require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/aantekeningen_2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b5316ce7993012ac5cceb5667d4b169', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('aantekeningprojectleider').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/aantekeningen_2023/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('AANTEKENINGEN DOSSIER  ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/d9bf204fc0f2ac457fe9699af16d6bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('aantekeningen').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/aantekeningen_2023/components/5ecc5ca9100b7ee189c776ecddea8e9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#89b087';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/19bfb0d80cbc61cf8e036ba2374cdc98/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/aantekeningen_2023/components/89efc196401e5c994d4813a164a97b83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/a14c80814751fb55fed93cd24c9ff12a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'aantekeningprojectleider')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/44d62bac8b48b7c17e8632ad73f5fda9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'nieuweaantekening')) == null) {
    (function (message) { alert(message) })('Aantekeningen moet ingevuld worden.');
  } else {
    await Backendless.Data.of('aantekeningen').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'datuminvoeraantekening': (new Date()),'aantekeningen': (getObjectProperty(___arguments.context.pageData, 'nieuweaantekening')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    ___arguments.context.pageData['nieuweaantekening'] = '';
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/a19afdb71d918411e8e300c3896a9fd2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'aantekeningprojectleider')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/287c331443d67e4292916bf81abe814b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e047e3a58e9fa5c07bb103b438e50b7')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/1a4cd66eea08b55a0b4658cdbb67ac99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/f86ce658657a9444f787e36a15ea21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('aantekeningen').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e047e3a58e9fa5c07bb103b438e50b7'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/dd0390c3fce3b37fd83f9b2b5fefe73b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0eaaa477a99cf89cbe7aed7978bd2d0a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/f1ec4fe137a9e4682899399a5f1113da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/c8a3179bc79363438a07a7e82b5722d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/8bb2924ab13a697f301cae689c0307f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#89b087';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/aantekeningen_2023/components/1dff28ef2369b62289dd54f6fa7500ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e047e3a58e9fa5c07bb103b438e50b7')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/0e9feb881bd67fad78f9a17d9e5e592f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('aantekeningen').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e047e3a58e9fa5c07bb103b438e50b7'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/aantekeningen_2023/components/de56d8dc288fc09947928044dfdd7e4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('61f8c6996a54862824944ec8e4618338')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'evaluatie')) == null) {
    (function (message) { alert(message) })('Evaluatie moet ingevuld worden');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten' }) );
    await Backendless.Data.of('dossiersafgesloten').save( ({ [`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`status`]: 'Afgesloten',[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`financieringvws`]: (getObjectProperty(___arguments.context.appData, 'financieringvws')),[`evaluatie`]: (getObjectProperty(___arguments.context.pageData, 'evaluatie')) }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
      await Backendless.Messaging.sendEmailFromTemplate('dossiergesloten', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(email, 'value')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief') {
    text = String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  } else {
    text = String('Openen dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('482c28c650f57004b735f34a21d59bda', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'status', 'activiteit', 'questioscholingofmoreel']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/afsluitendossier/components/6bac877fe01c60ea331240d7657abb7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/a4d1d9f1d78986670a179fa983bb4752/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'delenaantalgv')) > 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/b8c301deb158b1a71b07db1f24a50df9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalgv'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalgv'));
  ___arguments.context.pageData['status'] = (getObjectProperty(___arguments.context.dataModel, 'status'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.pageData['questioscholingofmoreel'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingofmoreel'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/d767cc4e696e1bc1663cfa33e2150272/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Actief',[`afrondingabc`]: null,[`afrondingdoorverwijzing`]: null,[`afrondingreden`]: null }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
    await Backendless.Messaging.sendEmailFromTemplate('dossierheropend', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(email, 'value')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/94634cf58581f0660e9301f8815dcaed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/119d08a5f71d5488e5c5bf8f0ee3c395/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/e88859c67af6642c9db131f480fcf70c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten/ activiteiten wat op het dossier stond. Indien u meer minuten of activiteiten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  } else {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten wat op het dossier stond. Indien u meer minuten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/ddc84bf8f2c85ca4e804a418203831bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/61f8c6996a54862824944ec8e4618338/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('270ca375708f95fd785b4e4d044f15e2')), 'display')) == true) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10dc48148323bb0354bebc3a11521039')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questiodeelnemers')) == null) {
      (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
    } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9b2e60920926e646b837f871ac52d37')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioevaluatie')) == null) {
      (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
    } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad967b5342aaa0b3be7cc23fa127fe23')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioevaluatiecijfer')) == null) {
      (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten',[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'registratiesgewerkteminuten')) }) );
      } else {
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten' }) );
      }
      await Backendless.Data.of('dossiersafgesloten').save( ({ [`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`status`]: 'Afgesloten',[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`questiodeelnemers`]: (getObjectProperty(___arguments.context.pageData, 'questiodeelnemers')),[`questioevaluatie`]: (getObjectProperty(___arguments.context.pageData, 'questioevaluatie')),[`questioevaluatiecijfer`]: (getObjectProperty(___arguments.context.pageData, 'questioevaluatiecijfer')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')) }) );
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
        if ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Scholing') {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
          } else {
            await Backendless.Messaging.sendEmailFromTemplate('afsluitendossierquestio', Backendless.EmailEnvelope.create({ addresses: 'e.bron@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
          }
        } else if ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Groepsconsult' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
          } else {
            await Backendless.Messaging.sendEmailFromTemplate('afsluitendossierquestio', Backendless.EmailEnvelope.create({ addresses: 'e.bron@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
          }
        }
      }
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten',[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'registratiesgewerkteminuten')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten' }) );
    }
    await Backendless.Data.of('dossiersafgesloten').save( ({ [`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`status`]: 'Afgesloten',[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`questiodeelnemers`]: (getObjectProperty(___arguments.context.pageData, 'questiodeelnemers')),[`questioevaluatie`]: (getObjectProperty(___arguments.context.pageData, 'questioevaluatie')),[`questioevaluatiecijfer`]: (getObjectProperty(___arguments.context.pageData, 'questioevaluatiecijfer')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')) }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      if ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Scholing') {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('afsluitendossierquestio', Backendless.EmailEnvelope.create({ addresses: 'e.bron@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      } else if ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Groepsconsult' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('afsluitendossierquestio', Backendless.EmailEnvelope.create({ addresses: 'e.bron@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief') {
    text = String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  } else {
    text = String('Openen dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('482c28c650f57004b735f34a21d59bda', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'status', 'activiteit', 'questioscholingofmoreel', 'financieringvws', 'registratiesgewerkteminuten']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/6bac877fe01c60ea331240d7657abb7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/a4d1d9f1d78986670a179fa983bb4752/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'delenaantalgv')) > 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/b8c301deb158b1a71b07db1f24a50df9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalgv'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalgv'));
  ___arguments.context.pageData['status'] = (getObjectProperty(___arguments.context.dataModel, 'status'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.pageData['questioscholingofmoreel'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingofmoreel'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['registratiesgewerkteminuten'] = (getObjectProperty(___arguments.context.dataModel, 'registratiesgewerkteminuten'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/d767cc4e696e1bc1663cfa33e2150272/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'status': 'Actief','afrondingabc': null,'afrondingdoorverwijzing': null,'afrondingreden': null }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/94634cf58581f0660e9301f8815dcaed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/270ca375708f95fd785b4e4d044f15e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult' && (getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult' && (getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz' && (getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/c9b2e60920926e646b837f871ac52d37/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['questioevaluatiecijfer'] = null;

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Is de evaluatie uitgevoerd?' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/2d6fd97bfa2d163d47daec4acc7ce9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'questioevaluatie')) == 'Ja' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/ad967b5342aaa0b3be7cc23fa127fe23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'questioevaluatie')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Wat is het gemiddelde cijfer van de evaluatie? cijfers invullen' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/119d08a5f71d5488e5c5bf8f0ee3c395/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/635854f62c3c305cb6459f0fe4cb7fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/b04642edf8dfa5f5980cceb294d51544/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/5d96a56235ea993e27154def9066c19e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier-questio/components/cab8a69529287538688891c8443a35fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio') {
    if (___arguments.value == 'Doorverwijzing') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77344c4f796cdfefa20c7266f943f32d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', true);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77344c4f796cdfefa20c7266f943f32d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', false);
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
    }
    if (___arguments.value == 'Anders') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', true);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
    }
    if (___arguments.value == 'Verkeerd dossier aangemaakt') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', true);
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
    }
    if (___arguments.value == 'Er hebben geen gesprekken plaatsgevonden') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', true);
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
    }
  } else {
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
  if (___arguments.value != null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b7fdb076f3bbb30d917715b65c6374c2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
    if (___arguments.value == 'Doorverwijzing') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77344c4f796cdfefa20c7266f943f32d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', true);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77344c4f796cdfefa20c7266f943f32d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', false);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
    }
    if (___arguments.value == 'Verkeerd dossier aangemaakt') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', true);
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
    }
    if (___arguments.value == 'Er hebben geen gesprekken plaatsgevonden') {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', true);
    } else {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd71fe31860a23fb027e1e72eabce2dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74b19c3b43ac4677d3c891a67aec31d1', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingreden').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingreden']),'label': (item['afrondingreden']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/5fd3c0cde9187c3d6cc768c5b89919b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingdoorverwijzing').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setSortBy('afrondingdoorverwijzing').setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingdoorverwijzing']),'label': (item['afrondingdoorverwijzing']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief') {
    text = String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  } else {
    text = String('Openen dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1446aa5bce58444383fdfdd310b7b7d5', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'status', 'registratiesgewerkteminuten', 'regio']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/aa627e5d527a29b453dc455c923cde7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/c16248b3c91db7267a53b02a6b7f77df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value == 'Ja') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c2a258263c2173d849bc55de86e734c', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7171d28442cd02a279b19ff612aca54', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c2a258263c2173d849bc55de86e734c', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7171d28442cd02a279b19ff612aca54', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/6155250a7f7c23e6ffcf558214997958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/6c2422f85244a3b80c588e834127c8c4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalgv'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalgv'));
  ___arguments.context.pageData['status'] = (getObjectProperty(___arguments.context.dataModel, 'status'));
  ___arguments.context.pageData['registratiesgewerkteminuten'] = (getObjectProperty(___arguments.context.dataModel, 'registratiesgewerkteminuten'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/4021855b9598c66357f73cc7b6169e65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['delenaantalgv']) != 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/8d66f256a2ead959e39a629ddb6f24ab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'wasersprakevan')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).splice((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'wasersprakevan')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var toelichting, dossier;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f75555170ae6dad50ddd25a23bf90a61')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).length) {
    (function (message) { alert(message) })('\'Was er sprake van\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == null) {
    (function (message) { alert(message) })('\'Reden van afronding\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fd3c0cde9187c3d6cc768c5b89919b2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')) == null) {
    (function (message) { alert(message) })('Doorverwijzing\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fdb076f3bbb30d917715b65c6374c2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafrondingquestio')) == null) {
    (function (message) { alert(message) })('\'Toelichting op reden van afronding\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74b19c3b43ac4677d3c891a67aec31d1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) == null) {
    (function (message) { alert(message) })('\'Toelichting op reden van afronding\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c16248b3c91db7267a53b02a6b7f77df')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')) == null) {
    (function (message) { alert(message) })('\'Zijn er vervolgafspraken\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7171d28442cd02a279b19ff612aca54')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')) == null) {
    (function (message) { alert(message) })('\'Welke vervolgafspraken zijn gemaakt?\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e9c2bd3402c37c46f4c8173887a2755')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')) == null) {
    (function (message) { alert(message) })('\'Achtergrond - levensbeschouwing\' moet ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`afrondingabc`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`status`]: 'Afgesloten',[`rotterdamvervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')),[`rotterdamwelkevervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')),[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'registratiesgewerkteminuten')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`afrondingabc`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`status`]: 'Afgesloten',[`rotterdamvervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')),[`rotterdamwelkevervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')),[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) }) );
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      toelichting = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafrondingquestio'));
    } else {
      toelichting = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      dossier = null;
    } else {
      dossier = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
    }
    await Backendless.Data.of('dossiersafgesloten').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`dossier`]: dossier,[`afrondingabc`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`status`]: 'Afgesloten',[`rotterdamvervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')),[`rotterdamwelkevervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')),[`toelichtingopredenafronding`]: toelichting,[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultthemas`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`financieringvws`]: (getObjectProperty(___arguments.context.appData, 'financieringvws')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/9e9c2bd3402c37c46f4c8173887a2755/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['listwasersprakevan'] = [];
  ___arguments.context.dataModel['listcat'] = [];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/d1326f8b33bcf10c3f12e2ae7545d83d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/01e49eb8c696ee81d1daba095fcf23cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Actief',[`afrondingabc`]: null,[`afrondingdoorverwijzing`]: null,[`afrondingreden`]: null }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
    await Backendless.Messaging.sendEmailFromTemplate('dossierheropend', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(email, 'value')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/5f76cb3ae6fba647a13df96611a5c69c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')).splice((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/f7a5804e8274b7297d69fe5d26f63759/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == null ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Verkeerd dossier aangemaakt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Er hebben geen gesprekken plaatsgevonden' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/d4bf50b5971383a1667e8ab4c8984153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten/ activiteiten wat op het dossier stond. Indien u meer minuten of activiteiten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  } else {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten wat op het dossier stond. Indien u meer minuten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/f75555170ae6dad50ddd25a23bf90a61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == null ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Verkeerd dossier aangemaakt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Er hebben geen gesprekken plaatsgevonden' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/bb34f0317a427aa82bbf768bcce72e36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/b7fdb076f3bbb30d917715b65c6374c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/ab42f36d123f7c35459b9f0fdab65eaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/10466c846504422f55282eadfd619f62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossierconsultinwpro/components/ada4398870f82eb65e5f2f3ce638bdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['listwasersprakevan'] = [];
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultinwthemasachtergrond'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['rotterdamvervolgafspraken'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['rotterdamwelkevervolgafspraken'] = null;
  if (___arguments.value == 'Doorverwijzing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f75555170ae6dad50ddd25a23bf90a61', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  } else if (___arguments.value == 'Anders') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f75555170ae6dad50ddd25a23bf90a61', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  } else if (___arguments.value == 'Verkeerd dossier aangemaakt') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f75555170ae6dad50ddd25a23bf90a61', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7a5804e8274b7297d69fe5d26f63759', false);
  } else if (___arguments.value == 'Er hebben geen gesprekken plaatsgevonden') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f75555170ae6dad50ddd25a23bf90a61', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7a5804e8274b7297d69fe5d26f63759', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f75555170ae6dad50ddd25a23bf90a61', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingreden').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingreden']),'label': (item['afrondingreden']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/5fd3c0cde9187c3d6cc768c5b89919b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingdoorverwijzing').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setSortBy('afrondingdoorverwijzing').setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingdoorverwijzing']),'label': (item['afrondingdoorverwijzing']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief') {
    text = String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  } else {
    text = String('Openen dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1446aa5bce58444383fdfdd310b7b7d5', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'status', 'regio']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/aa627e5d527a29b453dc455c923cde7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/c16248b3c91db7267a53b02a6b7f77df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Op verzoek van de zorgvrager') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Op voorstel van geestelijk verzorger') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Verkeerd dossier aangemaakt') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'De zorgvrager is overleden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value == 'Ja') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c2a258263c2173d849bc55de86e734c', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7171d28442cd02a279b19ff612aca54', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c2a258263c2173d849bc55de86e734c', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7171d28442cd02a279b19ff612aca54', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/6155250a7f7c23e6ffcf558214997958/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Op verzoek van de zorgvrager') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Op voorstel van geestelijk verzorger') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Verkeerd dossier aangemaakt') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'De zorgvrager is overleden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/6c2422f85244a3b80c588e834127c8c4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalgv'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalgv'));
  ___arguments.context.pageData['status'] = (getObjectProperty(___arguments.context.dataModel, 'status'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/4021855b9598c66357f73cc7b6169e65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['delenaantalgv']) != 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/8d66f256a2ead959e39a629ddb6f24ab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'wasersprakevan')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).splice((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f381e821ad95999e084d89207b3e0c1'), 'wasersprakevan')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f75555170ae6dad50ddd25a23bf90a61')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')).length) {
    (function (message) { alert(message) })('\'Was er sprake van\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == null) {
    (function (message) { alert(message) })('\'Reden van afronding\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fd3c0cde9187c3d6cc768c5b89919b2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')) == null) {
    (function (message) { alert(message) })('Doorverwijzing\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74b19c3b43ac4677d3c891a67aec31d1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) == null) {
    (function (message) { alert(message) })('\'Toelichting op reden van afronding\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c16248b3c91db7267a53b02a6b7f77df')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')) == null) {
    (function (message) { alert(message) })('\'Zijn er vervolgafspraken\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7171d28442cd02a279b19ff612aca54')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')) == null) {
    (function (message) { alert(message) })('\'Welke vervolgafspraken zijn gemaakt?\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e9c2bd3402c37c46f4c8173887a2755')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')) == null) {
    (function (message) { alert(message) })('\'Achtergrond - levensbeschouwing\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7a5804e8274b7297d69fe5d26f63759')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')).length) {
    (function (message) { alert(message) })('\'Belangrijkste thema\'s\' moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7a5804e8274b7297d69fe5d26f63759')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')) == null) {
    (function (message) { alert(message) })('Evaluatie moet ingevuld worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48b88f68786894a8c3dd1bc88a570f88')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwezennaar')) == null) {
    (function (message) { alert(message) })('Doorverwezen naar moet ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`afrondingabc`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`afrondingdoorverwezennaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwezennaar')),[`status`]: 'Afgesloten',[`rotterdamvervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')),[`rotterdamwelkevervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')),[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) }) );
    await Backendless.Data.of('dossiersafgesloten').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`afrondingabc`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`afrondingdoorverwezennaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwezennaar')),[`status`]: 'Afgesloten',[`rotterdamvervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamvervolgafspraken')),[`rotterdamwelkevervolgafspraken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwelkevervolgafspraken')),[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')),[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultthemas`]: String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`financieringvws`]: (getObjectProperty(___arguments.context.appData, 'financieringvws')),[`evaluatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')) }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
      await Backendless.Messaging.sendEmailFromTemplate('dossiergesloten', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(email, 'value')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')) }), undefined);
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/9e9c2bd3402c37c46f4c8173887a2755/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Actief' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['listwasersprakevan'] = [];
  ___arguments.context.dataModel['listcat'] = [];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/d1326f8b33bcf10c3f12e2ae7545d83d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'status')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/01e49eb8c696ee81d1daba095fcf23cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Actief',[`afrondingabc`]: null,[`afrondingdoorverwijzing`]: null,[`afrondingreden`]: null }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
    await Backendless.Messaging.sendEmailFromTemplate('dossierheropend', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(email, 'value')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/5f76cb3ae6fba647a13df96611a5c69c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')).splice((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ddba182116cdb6ee46477af630a13d4a'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/f7a5804e8274b7297d69fe5d26f63759/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e72e82e1e9fff0de59f8405aeab8928', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/d4bf50b5971383a1667e8ab4c8984153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten/ activiteiten wat op het dossier stond. Indien u meer minuten of activiteiten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  } else {
    text = 'Wanneer u het dossier weer opent dan ontvangt u het aantal resterende minuten wat op het dossier stond. Indien u meer minuten nodig heeft dan kunt u een verzoek tot verlenging indienen.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/f75555170ae6dad50ddd25a23bf90a61/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7e61b6ab38c330fb393b5c6b4642b51', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/77344c4f796cdfefa20c7266f943f32d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/bd71fe31860a23fb027e1e72eabce2dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/74b19c3b43ac4677d3c891a67aec31d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Anders' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/e86de9c8f2884106efe85c9629b88cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/d9f8ef08b3182b0a75fe2368dff537e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/85b7332b7938ad8819184648db9ea008/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossiernietquestio/components/48b88f68786894a8c3dd1bc88a570f88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == 'Doorverwijzing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', (await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)));
  ___arguments.context.pageData['naam'] = 'Hoofdmappen';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/bibliotheekquestio/components/4de7453825c8db6703b86328a23d7058/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'titel')) == null) {
    (function (message) { alert(message) })('Vul de titel in');
  } else if ((getObjectProperty(___arguments.context.pageData, 'map')) == null) {
    (function (message) { alert(message) })('Selecteer eerst een map');
  } else if ((getObjectProperty(___arguments.context.pageData, 'omschrijving')) == null) {
    (function (message) { alert(message) })('Vul de omschrijving in');
  } else {
    await Backendless.Data.of('bibliotheekquestio').save( ({ [`map`]: (getObjectProperty(___arguments.context.pageData, 'map')),[`submap`]: (getObjectProperty(___arguments.context.pageData, 'submap')),[`titel`]: (getObjectProperty(___arguments.context.pageData, 'titel')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'filename')),[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')) }) );
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4de7453825c8db6703b86328a23d7058');
    ___arguments.context.pageData['titel'] = null;
    ___arguments.context.pageData['map'] = null;
    ___arguments.context.pageData['submap'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc783028df183148178815860118bef8', (await Backendless.Data.of('bibliotheekquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4de7453825c8db6703b86328a23d7058');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = ['',(getObjectProperty(___arguments.context.pageData, 'map')),'/',(getObjectProperty(___arguments.context.pageData, 'submap')),'/'].join('');
}



  return 'bibliotheekquestio/'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension, mapensubmap;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  if ((getObjectProperty(___arguments.context.pageData, 'submap')) == null) {
    mapensubmap = String(getObjectProperty(___arguments.context.pageData, 'map')) + String('/');
  } else {
    mapensubmap = [(getObjectProperty(___arguments.context.pageData, 'map')),'/',(getObjectProperty(___arguments.context.pageData, 'submap')),'/'].join('');
  }
  ___arguments.context.pageData['filename'] = ([mapensubmap,(getObjectProperty(___arguments.context.pageData, 'titel')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),'_',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),extension].join(''));

  return ([mapensubmap,(getObjectProperty(___arguments.context.pageData, 'titel')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),'_',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'titel')) != null && (getObjectProperty(___arguments.context.pageData, 'map')) != null && (getObjectProperty(___arguments.context.pageData, 'omschrijving')) != null) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/1ca815cb9f887d8845aff6a441e8c49e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/bibliotheekquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('323e71465ad6a268b738428f75b8c9d7'), 'file'))].join('')), true, undefined);
  await Backendless.Data.of('historielog').save( ({ [`actie`]: String('Document verwijderd: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('323e71465ad6a268b738428f75b8c9d7'), 'file')),[`pagina`]: ['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/8f98fb1227587db880f8f5f8473b1108/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4eec306281204bd2cb8f261c598b528', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == 'PL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == '*PL')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/b4f2134e94f85eb8a9a88283266897b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('bibliotheekquestio').bulkDelete( (['file=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('323e71465ad6a268b738428f75b8c9d7'), 'file')),'\''].join('')) );
  await Backendless.Files.remove(encodePath((String('bibliotheekquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('323e71465ad6a268b738428f75b8c9d7'), 'file')))));
  await Backendless.Data.of('historielog').save( ({ [`actie`]: String('Document verwijderd: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('323e71465ad6a268b738428f75b8c9d7'), 'file')),[`pagina`]: ['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4eec306281204bd2cb8f261c598b528', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc783028df183148178815860118bef8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/a06ac12885981a78668cf5aa6678c428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4eec306281204bd2cb8f261c598b528', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/6871913feeb839ffa599b4d8fc48f998/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == 'PL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == '*PL')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/3cb141e4a8a503cf29b8081832e81c22/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  item = (await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0));
  list = (await Promise.all((await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });})));
}



  return (await Promise.all((await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/4b9a4218e763aa58574fbf5813ba0288/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, listfilter, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  list = (await Backendless.Files.listing(encodePath((String('bibliotheekquestio/') + String(getObjectProperty(___arguments.context.pageData, 'map')))), '', false, 100, 0));
  listfilter = (await asyncListFilter(list, async (item) => {
     if ((getObjectProperty(item, 'name')).indexOf('.') !== -1) {
      return false;
    }


   return item;
  }));

  return (await Promise.all(listfilter.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/98ac1e29313879b7a948746202541d8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, listfilter, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', false);
  ___arguments.context.pageData['filterhoofdmap'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbc8a12827a29c58d43926141b184ed5'), 'name'));
  ___arguments.context.pageData['naam'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbc8a12827a29c58d43926141b184ed5'), 'name')).replace('_', ' '));
  list = (await Backendless.Files.listing(encodePath((String('bibliotheekquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbc8a12827a29c58d43926141b184ed5'), 'name')))), '', false, 100, 0));
  listfilter = (await asyncListFilter(list, async (item) => {
     if ((getObjectProperty(item, 'name')).indexOf('.') !== -1) {
      return false;
    }


   return item;
  }));
  if (!listfilter.length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc783028df183148178815860118bef8', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc783028df183148178815860118bef8', (await Backendless.Data.of('bibliotheekquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e7816ca1908a36867288818940819c8', (await Promise.all(listfilter.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace((new RegExp(' ', 'g')), '_')) });}))));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbc8a12827a29c58d43926141b184ed5'), 'name')).replace((new RegExp('_', 'g')), ' '))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/d6caa768dcd602f7ea2f56588f98870c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0988d9c8c623937883c8cbf803f8574a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0988d9c8c623937883c8cbf803f8574a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0988d9c8c623937883c8cbf803f8574a', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == 'PL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == '*PL')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/d7fa2888212b288e1ea7a5e8b3a5eee6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, list, listfilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  if (listfilter == null) {
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e7816ca1908a36867288818940819c8', (await Promise.all(listfilter.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: (getObjectProperty(item, 'name')) });}))));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', false);
  ___arguments.context.pageData['filtersubmap'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f88b2ec43787ce89638ebc880bd40f8'), 'value'));
  ___arguments.context.pageData['naam'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f88b2ec43787ce89638ebc880bd40f8'), 'value')).replace((new RegExp('_', 'g')), ' '));
  list = (await Backendless.Files.listing(encodePath((['bibliotheekquestio/',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'/',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'/'].join(''))), '', false, 100, 0));
  listfilter = (await asyncListFilter(list, async (item) => {
     if ((getObjectProperty(item, 'name')).indexOf('.') !== -1) {
      return false;
    }


   return item;
  }));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc783028df183148178815860118bef8', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc783028df183148178815860118bef8', (await Backendless.Data.of('bibliotheekquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var a;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  a = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f88b2ec43787ce89638ebc880bd40f8'), 'value')).replace('\'/_/g\'', ' '));
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f88b2ec43787ce89638ebc880bd40f8'), 'value')).replace((new RegExp('_', 'g')), ' '))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/ce345e033458b4b8422f07e8d999d33f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var listfilter, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e7816ca1908a36867288818940819c8')), 'display')) == true) {
    ___arguments.context.pageData['naam'] = ((getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')).replace('_', ' '));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', true);
    ___arguments.context.pageData['naam'] = 'Hoofdmappen';
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc783028df183148178815860118bef8')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc783028df183148178815860118bef8', false);
    list = (await Backendless.Files.listing(encodePath((String('bibliotheekquestio/') + String(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')))), '', false, 100, 0));
    listfilter = (await asyncListFilter(list, async (item) => {
       if ((getObjectProperty(item, 'name')).indexOf('.') !== -1) {
        return false;
      }


     return item;
    }));
    if (!listfilter.length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', true);
      ___arguments.context.pageData['naam'] = 'Hoofdmappen';
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', true);
      ___arguments.context.pageData['naam'] = ((getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')).replace('_', ' '));
    }
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('33e82bd9d0f85b6f36e98c74f5298706')), 'display')) == true) {
    ___arguments.context.pageData['naam'] = 'Hoofdmappen';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/eb727fe2a05c11b88c587bf86cf88c58/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/07b837ffd639b6b9f34607abdab747aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e89d5a76e0066349fba18c01d06ebac8')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e89d5a76e0066349fba18c01d06ebac8', false);
  } else {
    ___arguments.context.pageData['newmap'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e89d5a76e0066349fba18c01d06ebac8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/4c9879b844486c1ab98843f69b7817f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0509333a3d28c6449fcd5de8bfebe15a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0509333a3d28c6449fcd5de8bfebe15a', false);
  } else {
    ___arguments.context.pageData['mapremove'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0509333a3d28c6449fcd5de8bfebe15a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/f64856db9b271ff8ffa87048c708c464/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7488e7c89948c6a87d9823d8a7987ca9')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7488e7c89948c6a87d9823d8a7987ca9', false);
  } else {
    ___arguments.context.pageData['hoofdmap'] = null;
    ___arguments.context.pageData['newsubmap'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7488e7c89948c6a87d9823d8a7987ca9', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/8de2c57860dfe94aa77e665893383c57/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('affbc5ece1b808e84cde4c7efc28668d')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('affbc5ece1b808e84cde4c7efc28668d', false);
  } else {
    ___arguments.context.pageData['hoofdmap'] = null;
    ___arguments.context.pageData['submapremove'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('affbc5ece1b808e84cde4c7efc28668d', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/f6e6d743019229c3005848a837280278/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'newmap')) == null) {
    (function (message) { alert(message) })('Vul svp de naam in van de nieuwe map');
  } else {
    await Backendless.Files.createDirectory(encodePath((String('bibliotheekquestio/') + String((getObjectProperty(___arguments.context.pageData, 'newmap')).replace((new RegExp(' ', 'g')), '_')))));
    (function (message) { alert(message) })((['De map ',(getObjectProperty(___arguments.context.pageData, 'newmap')),' is aangemaakt'].join('')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e89d5a76e0066349fba18c01d06ebac8', false);
    ___arguments.context.pageData['map'] = null;
    ___arguments.context.pageData['newmap'] = null;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', (await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/927b5a88aa5596d815bcc638af733a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/79490f6d1f389f99001e10940d78de08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f8f25799854dbe809683b680ea814c8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/29b857087f59795886d8a52b853a107a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var listfilter, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'mapremove')) == null) {
    (function (message) { alert(message) })('Selecteer de naam van de map die verwijderd moet worden');
  } else {
    await Backendless.Files.removeDirectory(encodePath((String('bibliotheekquestio/') + String((getObjectProperty(___arguments.context.pageData, 'mapremove')).replace((new RegExp(' ', 'g')), '_')))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0509333a3d28c6449fcd5de8bfebe15a', false);
    (function (message) { alert(message) })((['De map ',(getObjectProperty(___arguments.context.pageData, 'mapremove')),' is verwijderd'].join('')));
    await Backendless.Data.of('bibliotheekquestio').bulkDelete( (['map=\'',((getObjectProperty(___arguments.context.pageData, 'mapremove')).replace((new RegExp(' ', 'g')), '_')),'\''].join('')) );
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc783028df183148178815860118bef8', (await Backendless.Data.of('bibliotheekquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
    ___arguments.context.pageData['mapremove'] = null;
    ___arguments.context.pageData['map'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', (await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)));
    ___arguments.context.pageData['naam'] = 'Hoofdmappen';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/a41cc2b23518aa785bd7c054e038fe48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['mapremove'] = null;
  ___arguments.context.pageData['map'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0509333a3d28c6449fcd5de8bfebe15a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f8f25799854dbe809683b680ea814c8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/bcfd16e42aa5e2488015f89cb496176e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'hoofdmap')) == null) {
    (function (message) { alert(message) })('Selecteer de hoofdmap waarin de nieuwe submap moet komen');
  } else if ((getObjectProperty(___arguments.context.pageData, 'newsubmap')) == null) {
    (function (message) { alert(message) })('Vul svp de naam in van de nieuwe submap');
  } else {
    await Backendless.Files.createDirectory(encodePath((['bibliotheekquestio/',((getObjectProperty(___arguments.context.pageData, 'hoofdmap')).replace((new RegExp(' ', 'g')), '_')),'/',((getObjectProperty(___arguments.context.pageData, 'newsubmap')).replace((new RegExp(' ', 'g')), '_'))].join(''))));
    (function (message) { alert(message) })((['De submap ',(getObjectProperty(___arguments.context.pageData, 'newsubmap')),' is aangemaakt'].join('')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7488e7c89948c6a87d9823d8a7987ca9', false);
    ___arguments.context.pageData['hoofdmap'] = null;
    ___arguments.context.pageData['newsubmap'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/0c1c48086301f68887a727e1e3f8f657/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6983c938e18db9bee0893cb6cb82128', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/24dce49883562dd32d9847c5b5911cb8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/c908d892fbf8d5280fe8c1a8dab8afa8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, listfilter, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  list = (await Backendless.Files.listing(encodePath((String('bibliotheekquestio/') + String(getObjectProperty(___arguments.context.pageData, 'hoofdmap')))), '', false, 100, 0));
  listfilter = (await asyncListFilter(list, async (item) => {
     if ((getObjectProperty(item, 'name')).indexOf('.') !== -1) {
      return false;
    }


   return item;
  }));

  return (await Promise.all(listfilter.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'name')),[`label`]: ((getObjectProperty(item, 'name')).replace('_', ' ')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/bibliotheekquestio/components/659838887ef8acd8f1e5af3864e7f818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['map'] = null;
  ___arguments.context.pageData['submapremove'] = null;
  ___arguments.context.pageData['hoofdmap'] = null;
  ___arguments.context.pageData['submap'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('affbc5ece1b808e84cde4c7efc28668d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6983c938e18db9bee0893cb6cb82128', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/c4085b385f2ab1b8c686b438d04880a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'hoofdmap')) == null) {
    (function (message) { alert(message) })('Selecteer de hoofdmap waarin de submap staat die verwijderd moet worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'submapremove')) == null) {
    (function (message) { alert(message) })('Selecteer de naam van de submap die verwijderd moet worden');
  } else {
    await Backendless.Files.removeDirectory(encodePath((['bibliotheekquestio/',((getObjectProperty(___arguments.context.pageData, 'hoofdmap')).replace((new RegExp(' ', 'g')), '_')),'/',((getObjectProperty(___arguments.context.pageData, 'submapremove')).replace((new RegExp(' ', 'g')), '_'))].join(''))));
    (function (message) { alert(message) })((['De submap ',(getObjectProperty(___arguments.context.pageData, 'submapremove')),' is verwijderd'].join('')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6983c938e18db9bee0893cb6cb82128', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('affbc5ece1b808e84cde4c7efc28668d', false);
    await Backendless.Data.of('bibliotheekquestio').bulkDelete( (['map=\'',((getObjectProperty(___arguments.context.pageData, 'hoofdmap')).replace((new RegExp(' ', 'g')), '_')),'\' AND submap=\'',((getObjectProperty(___arguments.context.pageData, 'submapremove')).replace((new RegExp(' ', 'g')), '_')),'\''].join('')) );
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc783028df183148178815860118bef8', (await Backendless.Data.of('bibliotheekquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['map=\'',(getObjectProperty(___arguments.context.pageData, 'filterhoofdmap')),'\' AND submap=\'',(getObjectProperty(___arguments.context.pageData, 'filtersubmap')),'\''].join(''))).setSortBy('created DESC').setPageSize(100))));
    ___arguments.context.pageData['hoofdmap'] = null;
    ___arguments.context.pageData['submapremove'] = null;
    ___arguments.context.pageData['map'] = null;
    ___arguments.context.pageData['submap'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7816ca1908a36867288818940819c8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e82bd9d0f85b6f36e98c74f5298706', true);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('33e82bd9d0f85b6f36e98c74f5298706', (await Backendless.Files.listing(encodePath('bibliotheekquestio'), '', false, 100, 0)));
    ___arguments.context.pageData['naam'] = 'Hoofdmappen';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/bibliotheekquestio/components/1c097e1896d89e22598a56d8c718f108/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Files.removeDirectory(encodePath('bibliotheekquestio/Scholingen/Hoop%2C_hopeloosheid_en_wanhoop'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var emailgv, userobjectId, organisatie, regiogv, vw, gv, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, pakketminutenakkoord, pakketminuten, akkoord, naam, user, financieringstroom, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52b3b9e12e83ab7d873f5865fcf6c74c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == null) {
    (function (message) { alert(message) })('De vraag of het een lopend of nieuw dossier betreft is nog niet ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd644f7567cb138e5315bf1cb81a601a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')) == null) {
    (function (message) { alert(message) })('Er is nog geen toelichting gegeven m.b.t. het al bestaande dossier');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2add94aaaa6ad0c6c347db6965aa7fb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Het postcodeveld is niet correct ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2834c5d47a1e8ebe86a2db936d3b83d3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) == null) {
    (function (message) { alert(message) })('Het geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc734ea7fb13a99ccc98a2d7ff28244a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == null) {
    (function (message) { alert(message) })('Gender dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('De doelgroep dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94b509e5c3bd37bbe7ff853524cea631')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')) == null) {
    (function (message) { alert(message) })('De vraag over WLZ indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('522ca1f750fab0549de4e8a2643105e2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')) == null) {
    (function (message) { alert(message) })('Welk soort WLZ-indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('De hulpvraag dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else {
      financieringvws = '';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = 5 - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = 5;
        }
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
        }
      } else {
        pakketminutenakkoord = null;
        userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
      financieringstroom = 'fonds buiten VWS';
    } else {
      financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroom'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`lopenddossier`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossier')),[`lopenddossiertoelichting`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')),[`wlzindicatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')),[`wlzindicatiesoort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')),[`wlzpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzpostcode')),[`geboortedatumdag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),[`geboortedatummaand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),[`geboortedatumjaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')),[`geboortedatum`]: (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar'))].join('')))),[`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`leeftijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`doelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`activiteit`]: 'Consult zorgvrager',[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`pakketminuten`]: pakketminuten,[`pakketminutenakkoord`]: pakketminutenakkoord,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId,[`verwijzercontactgegevens`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzercontactgegevens')),[`spoed`]: (getObjectProperty(___arguments.context.pageData, 'spoed')) }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvlieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiopllieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvjm') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult zorgvrager',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult zorgvrager',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/d2add94aaaa6ad0c6c347db6965aa7fb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));
}

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL vul de postcode opnieuw in');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }
  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/2834c5d47a1e8ebe86a2db936d3b83d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgeboortejaar']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var return2, item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')) == 'true' || (getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')) == 'true') {
    status2 = '%';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
    status2 = '%';
  } else {
    status2 = '0';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == false) {
    return2 = (addItemToList((await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });}))), ({ [`value`]: '50+ en palliatieve patiënt',[`label`]: '50+ en palliatieve patiënt' })));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestiokot').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'','0','\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  }

  return return2

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/494621285353f752130877ff70fedd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/0178daaffd383e1716c52f9dc0fb86ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/bc734ea7fb13a99ccc98a2d7ff28244a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/d6e4b1f72294b047859f005ed47853f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/94b509e5c3bd37bbe7ff853524cea631/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', false);
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94b509e5c3bd37bbe7ff853524cea631', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', true);
    ___arguments.context.pageData['wlzindicatiesoort'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/522ca1f750fab0549de4e8a2643105e2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('wlzindicatie').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'indicatiewlz')),'label': (getObjectProperty(item, 'indicatiewlz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/52b3b9e12e83ab7d873f5865fcf6c74c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['lopenddossiertoelichting'] = '';

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/05dfd94f3682fb4e8bda0ea69d24ee08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/53bfb28b468fabd1455f58b5f7e17c44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierconsultinw/components/cd644f7567cb138e5315bf1cb81a601a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == 'Lopend dossier')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, financieringstroom, financieringvws, minutenpergepland;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94c2530a7f9ed0a60581116226e2ef82')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdaf608b6dc10fea493e06d7ed41e36f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7b57e692d768af2f572300b46e38b8c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == null) {
    (function (message) { alert(message) })('Doel groepconsult dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1acf70f5af8ceb88f8fcf9884ce249c5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvinggroepsconsult')) == null) {
    (function (message) { alert(message) })('Omschrijving groepsconsult dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('275e70a5310c26867ba1dbb91bb5efda')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Aantal gepland dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Minuten per groepsconsult dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('720557294658ed61ebbc81ba4b8b7111')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('720557294658ed61ebbc81ba4b8b7111')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8b758d78325d40562c2390fceecec34')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c7ff96e4273bfe6f468677866c173611')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6965ee57f02d08ecb0870da5ec1296fc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2aa9474cfeddf57e85e324ea9c816a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultperiodebijeenkomsten')) == null) {
    (function (message) { alert(message) })('Periode bijeenkomsten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d84d98733776c93e94647a3c8410191')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultlocatiebijeenkomsten')) == null) {
    (function (message) { alert(message) })('Locatie bijeenkomsten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff9f3e7cb6c74db795f945470cf6b65')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwervingdeelnemers')) == null) {
    (function (message) { alert(message) })('Werving dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a1634452d5e01e817eb881cb1944806')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultleeftijddeelnemers')) == null) {
    (function (message) { alert(message) })('Leeftijd deelnemers dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f408857535167d48d1ce089a2ebc1e81')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdeelnemersperbijeenkomst')) == null) {
    (function (message) { alert(message) })('Verwachte deelnemers per bijeenkomst dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b0b7b73eda3e024db5db87c49a81d3b5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwelkecompetenties')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47823244e62687968fa4843f436c2697')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db71735f4c279be90064009398fa3683')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultthema')) == null) {
    (function (message) { alert(message) })('Thema dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e81f8dcee0be0ed9a886b1120a687416')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdoel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb5b2f9ee80d0876ad163a3872148ff4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsulthomogeniteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09f31b081506f14cc935d4498298fcb8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultmeerwaarde')) == null) {
    (function (message) { alert(message) })('Meerwaarde van het groepsconsult dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('707d7b7a75e68d0a91fce0fd3ce85288')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultprogrammabijeenkomst')) == null) {
    (function (message) { alert(message) })('Programma per bijeenkomst dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('317e895395096c095baf65fd2e75470a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      minutenpergepland = 1;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee') {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdgroepsconsult'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`doelgroepsconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')),[`omschrijvinggroepsconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvinggroepsconsult')),[`activiteit`]: 'Groepsconsult',[`betrokkenorganisaties`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'betrokkenorganisaties')),[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questiogroepsconsultperiodebijeenkomsten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultperiodebijeenkomsten')),[`questiogroepsconsultlocatiebijeenkomsten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultlocatiebijeenkomsten')),[`questiogroepsconsultwervingdeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwervingdeelnemers')),[`questiogroepsconsultleeftijddeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultleeftijddeelnemers')),[`questiogroepsconsultdeelnemersperbijeenkomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdeelnemersperbijeenkomst')),[`questiogroepsconsultwelkecompetenties`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwelkecompetenties')),[`questiogroepsconsultbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultbijdrage')),[`questiogroepsconsultthema`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultthema')),[`questiogroepsconsultdoel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdoel')),[`questiogroepsconsulthomogeniteit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsulthomogeniteit')),[`questiogroepsconsultmeerwaarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultmeerwaarde')),[`questiogroepsconsultprogrammabijeenkomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultprogrammabijeenkomst')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`overlegaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Groepsconsult',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Groepsconsult',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/cdaf608b6dc10fea493e06d7ed41e36f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemminggroeps, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemminggroeps = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemminggroeps').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemminggroeps')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemminggroeps'] = (getObjectProperty(toestemminggroeps, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/94c2530a7f9ed0a60581116226e2ef82/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'email': (getObjectProperty(item, 'email')),'btwplichtig': (getObjectProperty(item, 'btwplichtig')),'btwinclcoaching': (getObjectProperty(item, 'btwinclcoaching')),'btwinclconsulten': (getObjectProperty(item, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(item, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(item, 'btwinclscholing')),'btwinclmdopatz': (getObjectProperty(item, 'btwinclmdopatz')),'regiogv': (getObjectProperty(item, 'regiogv')),'organisatie': (getObjectProperty(item, 'organisatie')),'objectId': (getObjectProperty(item, 'objectId')),'gv': (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'objectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/3f2b76fe03cc77e69b9777918bbeb279/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/e2da7da2e2696c29dd93be945ec39e0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/b7b57e692d768af2f572300b46e38b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemminggroeps, item, email, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemminggroeps'] = (getObjectProperty(toestemminggroeps, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/275e70a5310c26867ba1dbb91bb5efda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
    (function (message) { alert(message) })((['Voor groepsconsulten kunnen maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult')))),' minuten per groepsconsult gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/720557294658ed61ebbc81ba4b8b7111/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/cf22bb7e50d7e94f64d2208d6b9f3b53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/98d87531234fb25415d7b30a78c74e05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/6629fc96bba5be66d118a59236f53b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/4954de8fa5855903fcbd9f5952e30628/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/c7ff96e4273bfe6f468677866c173611/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/f2ce5dea64d83c6ad3290a2d82796cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/e8b758d78325d40562c2390fceecec34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/e91fefe79236880225965ea56d9b56ed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/6965ee57f02d08ecb0870da5ec1296fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/8973d427d3381de5ebc222f5cd8cce75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/b2aa9474cfeddf57e85e324ea9c816a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/0d84d98733776c93e94647a3c8410191/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/0ff9f3e7cb6c74db795f945470cf6b65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/2a1634452d5e01e817eb881cb1944806/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/f408857535167d48d1ce089a2ebc1e81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/ff22bbf471e74f03da9ad205a10bed6d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/b0b7b73eda3e024db5db87c49a81d3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/db71735f4c279be90064009398fa3683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/c161e905571b0454bc83f4ce03db2f93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/e81f8dcee0be0ed9a886b1120a687416/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/eb5b2f9ee80d0876ad163a3872148ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/09f31b081506f14cc935d4498298fcb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/707d7b7a75e68d0a91fce0fd3ce85288/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/c4e4d25cc13a695ab336101fcd037032/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/47823244e62687968fa4843f436c2697/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/01c4bd0eb7155ef8763b0063f8534f67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/d13fddffe1892e9ef5c1953b60f4b0b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/317e895395096c095baf65fd2e75470a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/eec29cfbdce31d91ae338f01a934c1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/237980795b934eddb89a27d7987e18ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/9f5aa643d18997f3c75ac3316af44491/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossiergroepsconsult/components/9fbdcc487a36a5f23308ac3b072f4c41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bff68209a7721ce1cc716ea834b82ab2')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('350e4f4937c32a25422718c52985473a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73e573d71bb6696d8182e5b129e42cb4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'soortoverlegpatzmdo')) == null) {
    (function (message) { alert(message) })('Soort overleg dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naampatzmdo')) == null) {
    (function (message) { alert(message) })('Naam PaTz MDO  dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('41f85eae4f0322a49935639ca19277f9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdostandaardbetrokken')) == null) {
    (function (message) { alert(message) })('Standaard disciplines dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff18483415f683e1d898ed3acce44435')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdoincidenteelbetrokken')) == null) {
    (function (message) { alert(message) })('Incidentele disciplines dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Aantal MDO PaTZ dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Minuten per overleg dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da577a091d18868ee0c2e13e62c7dda3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff0b5d41bb2192cd8b0b89b3333da4df')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
    } else {
      financieringvws = '';
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = 1;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
      } else {
        pakketminutenakkoord = null;
      }
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`financieringvws`]: financieringvws,[`soortoverlegpatzmdo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'soortoverlegpatzmdo')),[`naampatzmdo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naampatzmdo')),[`questiomdostandaardbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdostandaardbetrokken')),[`questiomdoincidentieelbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdoincidenteelbetrokken')),[`activiteit`]: 'MDO/PaTz',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefmdopatz')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`overlegaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')),[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'MDO/PaTz',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'MDO/PaTz',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/350e4f4937c32a25422718c52985473a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingmdopatz, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingmdopatz = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingmdopatz').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingmdopatz')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingmdopatz'] = (getObjectProperty(toestemmingmdopatz, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/bff68209a7721ce1cc716ea834b82ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'email': (getObjectProperty(item, 'email')),'btwplichtig': (getObjectProperty(item, 'btwplichtig')),'btwinclcoaching': (getObjectProperty(item, 'btwinclcoaching')),'btwinclconsulten': (getObjectProperty(item, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(item, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(item, 'btwinclscholing')),'btwinclmdopatz': (getObjectProperty(item, 'btwinclmdopatz')),'regiogv': (getObjectProperty(item, 'regiogv')),'organisatie': (getObjectProperty(item, 'organisatie')),'objectId': (getObjectProperty(item, 'objectId')),'gv': (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'objectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/6bb591767d6a761259df83212b6baabb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/bb5f8366e44c0eeb1bc2fdd2ed1f5ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/2028f63328628d13d1b810d3e679127b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/73e573d71bb6696d8182e5b129e42cb4/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingmdopatz, item, email, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingmdopatz'] = (getObjectProperty(toestemmingmdopatz, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/3cbf5ae86e83983dd22878cc8b023761/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/da577a091d18868ee0c2e13e62c7dda3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/390c238f0d7775e585b222876bc3fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/29738dbe6ede2a8475dc1ffac47bc91f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/b22e9c260f372a8b8ba913c7c0482314/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
    (function (message) { alert(message) })((['Voor PatZ/MDO kan maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz')))),' minuten per overleg gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/41f85eae4f0322a49935639ca19277f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/ff18483415f683e1d898ed3acce44435/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/32ba06261adbb6f365c5ff3946acb1bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/ff0b5d41bb2192cd8b0b89b3333da4df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/9e865de3a05fa70d38ab89e6a72e1d66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/efc593a48c5fddffc05d220e7bce30f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/b363fb77180417e927b9b1d6b77a4135/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierpatzmdo/components/cb3ebcd2016e641bea58d9acd029def5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2b677748bd6af42766267f53a4ed09ea')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Scholing of moreel beraad dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Naam van de scholing dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0decc7a92ecf24eb4c077b186eb62197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Omschrijving scholing dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Leerdoelen dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Doelgroep van de scholing ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Organisatie waarvoor de scholing wordt georganiseerd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Locatie scholing dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Aantal scholingen gepland dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Gemiddeld aantal minuten per scholing dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Verwacht aantal deelnemers dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ff9871a3c3aa9de187f50916119ad37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')) == null) {
    (function (message) { alert(message) })('Scholing geaccrediteerd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Wijze van scholing dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('246bea85b93b54fac7821a4e7ed7d355')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) == null) {
    (function (message) { alert(message) })('Geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Verwijzer ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c207a8f15a41531589887b1a7b4c55f1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')) == null) {
    (function (message) { alert(message) })('Geslacht client dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e8212f90fd1babb2171be19701aad75')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')) == null) {
    (function (message) { alert(message) })('Thuiswonend dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Hulpvraag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c4b69fbd9bbaec9cfdd54f4549352ec')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: 'Ja',[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'email': (getObjectProperty(item, 'email')),'btwplichtig': (getObjectProperty(item, 'btwplichtig')),'btwinclcoaching': (getObjectProperty(item, 'btwinclcoaching')),'btwinclconsulten': (getObjectProperty(item, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(item, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(item, 'btwinclscholing')),'btwinclmdopatz': (getObjectProperty(item, 'btwinclmdopatz')),'regiogv': (getObjectProperty(item, 'regiogv')),'organisatie': (getObjectProperty(item, 'organisatie')),'objectId': (getObjectProperty(item, 'objectId')),'gv': (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'objectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
    (function (message) { alert(message) })((['Voor scholing kan maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing')))),' minuten per scholing gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/246bea85b93b54fac7821a4e7ed7d355/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) <= 1894) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) >= 2024) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/c207a8f15a41531589887b1a7b4c55f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/2e8212f90fd1babb2171be19701aad75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/7ff9871a3c3aa9de187f50916119ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/0decc7a92ecf24eb4c077b186eb62197/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/2b677748bd6af42766267f53a4ed09ea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemminggroeps').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/afcb6d03ffdd65a62c57e31ee9ddb271/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/blcreatedossierscholing-zhn/components/fd754358fa16c26fa39db7a6edac807b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/chartverlengingbrabant/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/chartverlengingbrabant/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/chartverlengingbrabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiercoaching/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiercoaching/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userobjectId, vw, gv, pakketminutenakkoord, naam, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = 1;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1136ab890757fbba6172a9278895e6c5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('De geestelijk verzorgere dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c06bd6685ac5d369c562f8fcb4e0f04')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('De gemeente/woonplaats dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4429da2003aa3a3d99711ef63ab6568')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naamorgpro')) == null) {
    (function (message) { alert(message) })('Naam organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'functiepro')) == null) {
    (function (message) { alert(message) })('Functie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('Hulpvraag dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Aantal gepland dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0e7cc23b1e056cbcdc8adde7c331d262')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Postcode van de coaching dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      }
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingcoaching')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      pakketminutenakkoord = null;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`naamorgpro`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naamorgpro')),[`functiepro`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'functiepro')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`activiteit`]: 'Coaching on the job',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingcoaching')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoaching')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`pakketminutenakkoord`]: pakketminutenakkoord,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`userobjectId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingcoaching')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Coaching on the job',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('functiepro').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (item['functiepro']),'label': (item['functiepro']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/7c06bd6685ac5d369c562f8fcb4e0f04/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingcoaching, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingcoaching = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingcoaching').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingcoaching')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingcoaching'] = (getObjectProperty(toestemmingcoaching, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/0b598eba5ccf696359ba5e3fc559c02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiercoaching/components/1975b6791a91e4fb11d51d39416e23cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiercoaching/components/1136ab890757fbba6172a9278895e6c5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiercoaching/components/44a38aa18bac5a01e145c494b3ea95dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/7e02eb9b2d243d9c711ccd150d584c0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/4b4a6fdefdbd20ab6618c29a045fbfc7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/d4429da2003aa3a3d99711ef63ab6568/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async onBlur(___arguments) {
    var list;


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND gemeentewoonplaats =\'',(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon']),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    ;await ( async function (message){ alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
    var email, item, regio, toestemmingcoaching;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingcoaching = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingcoaching').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingcoaching')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingcoaching'] = (getObjectProperty(toestemmingcoaching, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/52f300fbea1db3e37d6d4a06071c8c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Voer de vier cijfers van de postcode in van de activiteit';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/0e7cc23b1e056cbcdc8adde7c331d262/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiercoaching/components/2348257b1059bb5c30ab406c1583ab99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/aafc576c36ef4cce73853f645366031e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/ddcd1da7a00a9f43dbed4db88391126e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    (function (message) { alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiercoaching/components/076735ab68da6814d285f178b459c023/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingcoaching'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiercoaching/components/640b1206ac9331453e33ec920e518bd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiercoaching/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/cc7ce235ed5debd2122fcddbae5310b6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/23b518453e5f984e6f38b83e2e181297/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/d93601dee857f766df97448a39c8a2db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/d4a83c2d79fd4ba75ae82dbb05f86df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/6c150d5c553e45650a381cbda3ae4dab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/b126a87a88eded853709ed2f487e3c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoaching/components/1bdec867a67ca1be11edf7da74eaa4bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierconsultinw/components/561bec1c2dcb96d10a8bd4dbdeecd0a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')),[`email2`]: (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var emailgv, userobjectId, organisatie, regiogv, vw, gv, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, pakketminutenakkoord, pakketminuten, akkoord, naam, user, financieringstroom, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89f985738a7181eed7ad32134a7b7d6d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Het veld \'welke geestelijk verzorger pakt dit dossier op\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52b3b9e12e83ab7d873f5865fcf6c74c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == null) {
    (function (message) { alert(message) })('De vraag of het een lopend of nieuw dossier betreft is nog niet ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79f319b9623b026a0d5bd32c0f1ded27')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')) == null) {
    (function (message) { alert(message) })('Er is nog geen toelichting gegeven m.b.t. het al bestaande dossier');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f0f01b64e41a601ec814f57f93879c1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Datum aanvraag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aed95b1356832b947c34d152863b36cb')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')) == null) {
    (function (message) { alert(message) })('Het veld \'aangenomen door\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c0d6dc5e33a1e9182a43ac7aebbbf0e9')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'spoed')) == null) {
    (function (message) { alert(message) })('Het veld \'spoed\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d91a24ec5d85aca565dc7019d87f4c6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == null) {
    (function (message) { alert(message) })('Het veld \'subsidieregeling\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48020848e8bfd091f426a7dfc01b395b')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Het veld \'financieringstroom\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94b509e5c3bd37bbe7ff853524cea631')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')) == null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN') {
    (function (message) { alert(message) })('De vraag over WLZ indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('522ca1f750fab0549de4e8a2643105e2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')) == null) {
    (function (message) { alert(message) })('Welk soort WLZ-indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47fdafa2c8b51049807e7ff803b24be6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzpostcode')) == null) {
    (function (message) { alert(message) })('De postcode van de cliënt dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')) == null) {
    (function (message) { alert(message) })('De geboortedag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')) == null) {
    (function (message) { alert(message) })('De geboortemaand dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) == null) {
    (function (message) { alert(message) })('Het geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('561bec1c2dcb96d10a8bd4dbdeecd0a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('De plaats van de zorgvrager dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2add94aaaa6ad0c6c347db6965aa7fb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Het postcodeveld is niet correct ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) == null) {
    (function (message) { alert(message) })('De leeftijd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2834c5d47a1e8ebe86a2db936d3b83d3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) == null) {
    (function (message) { alert(message) })('Het geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d5ffdd4b83a70fb619bb293c9582f44a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == null) {
    (function (message) { alert(message) })('Gender dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('De doelgroep dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('De hulpvraag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b94d19bfc63f83c8271459ac51d0dff')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('De postcode aankomst dient ingevuld te worden');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == null) {
    (function (message) { alert(message) })('Relatienummer dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
      } else {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
      } else {
        if ((getObjectProperty(___arguments.context.pageData, 'financieringstroom')) == 'Zelfbetalende cliënt') {
          pakketminuten = 240;
        } else {
          pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
        }
      }
    } else {
      financieringvws = '';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = 5 - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = 5;
        }
      } else {
        pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
      }
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = 5 - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = 5;
        }
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
        }
      } else {
        pakketminutenakkoord = null;
        userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
      financieringstroom = 'fonds buiten VWS';
    } else {
      financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroom'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`questioconsultenreedsgedaan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')),[`userobjectId`]: userobjectId,[`consultinwgendertoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'consultinwgendertoelichting')),[`lopenddossier`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossier')),[`lopenddossiertoelichting`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')),[`wlzindicatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')),[`wlzindicatiesoort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')),[`wlzpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzpostcode')),[`geboortedatumdag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),[`geboortedatummaand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),[`geboortedatumjaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')),[`geboortedatum`]: (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar'))].join('')))),[`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`leeftijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`doelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`activiteit`]: 'Consult zorgvrager',[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`pakketminuten`]: pakketminuten,[`pakketminutenakkoord`]: pakketminutenakkoord,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId,[`verwijzercontactgegevens`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzercontactgegevens')),[`spoed`]: (getObjectProperty(___arguments.context.pageData, 'spoed')) }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvlieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiopllieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvjm') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult cliënt',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult zorgvrager',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinw/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinw/components/168573c620e9bd9a54c5063f14a5605f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinw/components/89f985738a7181eed7ad32134a7b7d6d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username', 'organisatie']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/1c894979f8694397d8d94b1e96fc72f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/3d9357cf3a5208c9bdb947349eac4fb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/c12365339a01da21efbe5789410c92b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode van de zorgvrager in (alleen de postcode-cijfers)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Selecteer gemeente';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/d2add94aaaa6ad0c6c347db6965aa7fb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/2834c5d47a1e8ebe86a2db936d3b83d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgeboortejaar']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/890811d777445414c146705efbb7c2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    text = 'Geboortejaar zorgvrager';
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    text = 'Geboortedatum cliënt';
  } else {
    text = 'Leeftijd zorgvrager';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) < 5) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = '';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) > 120) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/a9e6feb1de6157fc119895de8a99249e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Geslacht cliënt';
  } else {
    text = 'Gender';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/d5ffdd4b83a70fb619bb293c9582f44a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var return2, item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')) == 'true' || (getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')) == 'true') {
    status2 = '%';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    status2 = '%';
  } else {
    status2 = '0';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == false) {
    return2 = (addItemToList((await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });}))), ({ [`value`]: '50+ en palliatieve patiënt',[`label`]: '50+ en palliatieve patiënt' })));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
    return2 = (addItemToList((await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });}))), ({ [`value`]: '50-',[`label`]: '50-' })));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestiokot').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'','0','\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepsichtpunt').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  }

  return return2

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/5b94d19bfc63f83c8271459ac51d0dff/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/494621285353f752130877ff70fedd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/4d9f97ca0b592a04b28442c160f3d2da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1) {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk'))) > 3) {
      (function (message) { alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '00') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '00000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '000000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0000000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/b5773f35a756a0b7bf444ee2dcd23caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Relatienummer (nummer verkregen bij de aanmelding)' : 'CvL-kenmerk')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/7f0f01b64e41a601ec814f57f93879c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/7d9ffbdf29d13ca1e264210561f514bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/8d2e607c4f73eec6b028fdc129fc4732/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Achtergrond informatie (maximaal 100 tekens)' : 'Achtergrond informatie')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/28bcdf33d5690bece26116837cad4856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Aangenomen door:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    text = 'Aangenomen door:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Aangemeld door:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/aed95b1356832b947c34d152863b36cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/79ad9008522164e2147ed3a492e9764b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/214d722315a7fbcadc5d30fbbdd581c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie'))) > 100) {
      (function (message) { alert(message) })('Dit veld mag maximaal 100 tekens bevatten');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioconsultinwachtergrondinformatie'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie')).slice(0, 100));
    }
  }
}

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/0178daaffd383e1716c52f9dc0fb86ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/f36f43f717b76ebfa801c4252359ed9f/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/e067193ad28b770b6677053915039814/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/bc734ea7fb13a99ccc98a2d7ff28244a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/343d8f6c5764833e9dddf5ace3bb402d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Hoeveel minuten zijn er al besteed op dit dossier?' : 'Hoeveel consulten zijn er reeds gedaan?')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/cac2db85e4aa94598f84cff41fa9e86f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/94b509e5c3bd37bbe7ff853524cea631/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', true);
    ___arguments.context.pageData['wlzindicatiesoort'] = '';
    ___arguments.context.pageData['wlzpostcode'] = null;
  } else if (___arguments.value == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    ___arguments.context.pageData['wlzindicatiesoort'] = '';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/47fdafa2c8b51049807e7ff803b24be6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'wlzpostcode')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.pageData['wlzpostcode'] = ((getObjectProperty(___arguments.context.pageData, 'wlzpostcode')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/522ca1f750fab0549de4e8a2643105e2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('wlzindicatie').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'indicatiewlz')),'label': (getObjectProperty(item, 'indicatiewlz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/2a264c66a40b599ae86fc337176f2126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Hulpvraag of situatieschets (korte omschrijving, maximaal 100 tekens)' : 'Hulpvraag of situatieschets (korte omschrijving)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/2faa8f19ed61c7c7b40c76cce8d725fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    text = 'Wie is de verwijzer? (vul hieronder de naam, organisatie,telefoonnummer en/of emailadres in). Let op: u heeft hiervoor toestemming nodig van de verwijzer.';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    text = 'Wie is de verwijzer + telefoonummer? Let op: u heeft hiervoor toestemming nodig van de verwijzer.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/b52b33d9b8622c08679b6fc2846f698f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/9baf298a8055b561187fe98e785a2451/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/3d91a24ec5d85aca565dc7019d87f4c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = 0;

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = null;
  ___arguments.context.pageData['wlzindicatie'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinw/components/48020848e8bfd091f426a7dfc01b395b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt';

  return ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    return2 = (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'=\'1\' AND financieringsstroom=\'','Zelfbetalende cliënt','\''].join(''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'financieringsstroom')),[`label`]: (getObjectProperty(item, 'financieringsstroom')) });})));
  } else {
    return2 = (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\' '))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'financieringsstroom')),[`label`]: (getObjectProperty(item, 'financieringsstroom')) });})));
  }

  return return2

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/6c8827894d4e1d7c824f0fbf36c16849/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt';

  return ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/8172c58410fc201a937a4e26190a81c1/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag'))) > 100) {
      (function (message) { alert(message) })('Dit veld mag maximaal 100 tekens bevatten');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['hulpvraag'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')).slice(0, 100));
    }
  }
}

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinw/components/c50163177f18d5c8837b33bd2efb98e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/52b3b9e12e83ab7d873f5865fcf6c74c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['lopenddossiertoelichting'] = '';

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/854518ddb0c9c8a6c9d3155cef3551a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/3de3fd51197cc689feb28325ca2c9bd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == 'Lopend dossier')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/79f319b9623b026a0d5bd32c0f1ded27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == 'Lopend dossier')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/05dfd94f3682fb4e8bda0ea69d24ee08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinw/components/53bfb28b468fabd1455f58b5f7e17c44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinw/components/cf427cc9865c2d9af052fc132e3fff51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/c0d6dc5e33a1e9182a43ac7aebbbf0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/4feecc0f5acff053f01915ebcf28c3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/c1d7b8630797554841bc52cc6b4d3a6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Vul hieronder in hoeveel minuten u al heeft gedeclareerd bij het Centrum voor Levensvragen. Dit aantal zal dan in mindering worden gebracht op het totaal aantal minuten die standaard worden toegekend. Mocht  dit een nieuwe zorgvrager betreffen en heeft u nog geen consulten uitgevoerd, dan kunt u deze vraag overslaan. ' : 'Vul hieronder in hoeveel consulten u al heeft gedeclareerd bij het Centrum voor Levensvragen. Dit aantal zal dan in mindering worden gebracht op de 5 consulten die standaard worden toegekend. Mocht  dit een nieuwe zorgvrager betreffen en heeft u nog geen consulten uitgevoerd, dan kunt u deze vraag overslaan. ')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/1b1ba3af1d946afd3d9614bf21fecabe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['wlzindicatie'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/977211defc122e3be9660cc64e4253c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/3e23c02c20fa0774e44b1f597653e9f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/6588c2ced6018b7c2338e0882158000b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/355a9f490bce564ac5abfecf24d6cdd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/091593c720d2f25604f6b9b7e7937ba4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/ae5464e3c0ecb96131668a4423867065/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinw/components/48a146cb91d33b8c166ad0c62a0efeb7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/561bec1c2dcb96d10a8bd4dbdeecd0a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')),[`email2`]: (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var emailgv, userobjectId, organisatie, regiogv, vw, gv, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, pakketminutenakkoord, pakketminuten, akkoord, naam, user, financieringstroom, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89f985738a7181eed7ad32134a7b7d6d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Het veld \'welke geestelijk verzorger pakt dit dossier op\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52b3b9e12e83ab7d873f5865fcf6c74c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == null) {
    (function (message) { alert(message) })('De vraag of het een lopend of nieuw dossier betreft is nog niet ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79f319b9623b026a0d5bd32c0f1ded27')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')) == null) {
    (function (message) { alert(message) })('Er is nog geen toelichting gegeven m.b.t. het al bestaande dossier');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f0f01b64e41a601ec814f57f93879c1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Datum aanvraag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aed95b1356832b947c34d152863b36cb')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')) == null) {
    (function (message) { alert(message) })('Het veld \'aangenomen door\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c0d6dc5e33a1e9182a43ac7aebbbf0e9')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'spoed')) == null) {
    (function (message) { alert(message) })('Het veld \'spoed\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d91a24ec5d85aca565dc7019d87f4c6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == null) {
    (function (message) { alert(message) })('Het veld \'subsidieregeling\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48020848e8bfd091f426a7dfc01b395b')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Het veld \'financieringstroom\' dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94b509e5c3bd37bbe7ff853524cea631')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')) == null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN') {
    (function (message) { alert(message) })('De vraag over WLZ indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('522ca1f750fab0549de4e8a2643105e2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')) == null) {
    (function (message) { alert(message) })('Welk soort WLZ-indicatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47fdafa2c8b51049807e7ff803b24be6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzpostcode')) == null) {
    (function (message) { alert(message) })('De postcode van de cliënt dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')) == null) {
    (function (message) { alert(message) })('De geboortedag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')) == null) {
    (function (message) { alert(message) })('De geboortemaand dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e067193ad28b770b6677053915039814')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) == null) {
    (function (message) { alert(message) })('Het geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('561bec1c2dcb96d10a8bd4dbdeecd0a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('De plaats van de zorgvrager dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2add94aaaa6ad0c6c347db6965aa7fb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Het postcodeveld is niet correct ingevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) == null) {
    (function (message) { alert(message) })('De leeftijd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2834c5d47a1e8ebe86a2db936d3b83d3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) == null) {
    (function (message) { alert(message) })('Het geboortejaar dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d5ffdd4b83a70fb619bb293c9582f44a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == null) {
    (function (message) { alert(message) })('Gender dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('De doelgroep dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('De hulpvraag dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b94d19bfc63f83c8271459ac51d0dff')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('De postcode aankomst dient ingevuld te worden');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == null) {
    (function (message) { alert(message) })('Relatienummer dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 1;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvws'));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
      } else {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
      } else {
        pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
      }
    } else {
      financieringvws = '';
      pakketminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = 5 - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = 5;
        }
      } else {
        pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
      }
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = 5 - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = 5;
        }
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')) != null) {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan'));
        } else {
          pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
        }
      } else {
        pakketminutenakkoord = null;
        userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
      financieringstroom = 'fonds buiten VWS';
    } else {
      financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroom'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`questioconsultenreedsgedaan`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultenreedsgedaan')),[`userobjectId`]: userobjectId,[`consultinwgendertoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'consultinwgendertoelichting')),[`lopenddossier`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossier')),[`lopenddossiertoelichting`]: (getObjectProperty(___arguments.context.pageData, 'lopenddossiertoelichting')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')),[`wlzindicatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatie')),[`wlzindicatiesoort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzindicatiesoort')),[`wlzpostcode`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'wlzpostcode')),[`geboortedatumdag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),[`geboortedatummaand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),[`geboortedatumjaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')),[`geboortedatum`]: (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar'))].join('')))),[`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`leeftijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`doelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`activiteit`]: 'Consult zorgvrager',[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`pakketminuten`]: pakketminuten,[`pakketminutenakkoord`]: pakketminutenakkoord,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId,[`verwijzercontactgegevens`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzercontactgegevens')),[`spoed`]: (getObjectProperty(___arguments.context.pageData, 'spoed')) }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvlieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiopllieke' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvjm') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult cliënt',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult zorgvrager',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/168573c620e9bd9a54c5063f14a5605f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/89f985738a7181eed7ad32134a7b7d6d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username', 'organisatie']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/1c894979f8694397d8d94b1e96fc72f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/3d9357cf3a5208c9bdb947349eac4fb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/c12365339a01da21efbe5789410c92b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode van de zorgvrager in (alleen de postcode-cijfers)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Selecteer gemeente';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/d2add94aaaa6ad0c6c347db6965aa7fb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingconsultinwpro, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/2834c5d47a1e8ebe86a2db936d3b83d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgeboortejaar']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/890811d777445414c146705efbb7c2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    text = 'Geboortejaar zorgvrager';
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    text = 'Geboortedatum cliënt';
  } else {
    text = 'Leeftijd zorgvrager';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) < 5) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = '';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) > 120) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/a9e6feb1de6157fc119895de8a99249e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Geslacht cliënt';
  } else {
    text = 'Gender';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/d5ffdd4b83a70fb619bb293c9582f44a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var return2, item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')) == 'true' || (getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')) == 'true') {
    status2 = '%';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    status2 = '%';
  } else {
    status2 = '0';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == false) {
    return2 = (addItemToList((await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });}))), ({ [`value`]: '50+ en palliatieve patiënt',[`label`]: '50+ en palliatieve patiënt' })));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
    return2 = (addItemToList((await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });}))), ({ [`value`]: '50-',[`label`]: '50-' })));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepquestiokot').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'','0','\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepsichtpunt').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  }

  return return2

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/5b94d19bfc63f83c8271459ac51d0dff/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/494621285353f752130877ff70fedd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/4d9f97ca0b592a04b28442c160f3d2da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1) {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk'))) > 3) {
      (function (message) { alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '00') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '00000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '000000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')) == '0000000') {
      (function (message) { alert(message) })('Er moet een juiste CVL-kenmerk ingevuld worden, er mag geen 0 ingevuld worden');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/b5773f35a756a0b7bf444ee2dcd23caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Relatienummer (nummer verkregen bij de aanmelding)' : 'CvL-kenmerk')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/7f0f01b64e41a601ec814f57f93879c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/7d9ffbdf29d13ca1e264210561f514bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/8d2e607c4f73eec6b028fdc129fc4732/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Achtergrond informatie (maximaal 100 tekens)' : 'Achtergrond informatie')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/28bcdf33d5690bece26116837cad4856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Aangenomen door:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    text = 'Aangenomen door:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Aangemeld door:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/aed95b1356832b947c34d152863b36cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/79ad9008522164e2147ed3a492e9764b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/214d722315a7fbcadc5d30fbbdd581c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie'))) > 100) {
      (function (message) { alert(message) })('Dit veld mag maximaal 100 tekens bevatten');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioconsultinwachtergrondinformatie'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwachtergrondinformatie')).slice(0, 100));
    }
  }
}

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/0178daaffd383e1716c52f9dc0fb86ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/f36f43f717b76ebfa801c4252359ed9f/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/e067193ad28b770b6677053915039814/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/bc734ea7fb13a99ccc98a2d7ff28244a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/343d8f6c5764833e9dddf5ace3bb402d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Hoeveel minuten zijn er al besteed op dit dossier?' : 'Hoeveel consulten zijn er reeds gedaan?')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/cac2db85e4aa94598f84cff41fa9e86f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/94b509e5c3bd37bbe7ff853524cea631/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', true);
    ___arguments.context.pageData['wlzindicatiesoort'] = '';
    ___arguments.context.pageData['wlzpostcode'] = null;
  } else if (___arguments.value == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    ___arguments.context.pageData['wlzindicatiesoort'] = '';
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/47fdafa2c8b51049807e7ff803b24be6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'wlzpostcode')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.pageData['wlzpostcode'] = ((getObjectProperty(___arguments.context.pageData, 'wlzpostcode')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/522ca1f750fab0549de4e8a2643105e2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('wlzindicatie').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'indicatiewlz')),'label': (getObjectProperty(item, 'indicatiewlz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/2a264c66a40b599ae86fc337176f2126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Hulpvraag of situatieschets (korte omschrijving, maximaal 100 tekens)' : 'Hulpvraag of situatieschets (korte omschrijving)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/2faa8f19ed61c7c7b40c76cce8d725fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    text = 'Wie is de verwijzer? (vul hieronder de naam, organisatie,telefoonnummer en/of emailadres in). Let op: u heeft hiervoor toestemming nodig van de verwijzer.';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    text = 'Wie is de verwijzer + telefoonummer? Let op: u heeft hiervoor toestemming nodig van de verwijzer.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/b52b33d9b8622c08679b6fc2846f698f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/9baf298a8055b561187fe98e785a2451/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/3d91a24ec5d85aca565dc7019d87f4c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = 0;

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = null;
  ___arguments.context.pageData['wlzindicatie'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/48020848e8bfd091f426a7dfc01b395b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt';

  return ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'financieringsstroom')),[`label`]: (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/6c8827894d4e1d7c824f0fbf36c16849/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt';

  return ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/8172c58410fc201a937a4e26190a81c1/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag'))) > 100) {
      (function (message) { alert(message) })('Dit veld mag maximaal 100 tekens bevatten');
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['hulpvraag'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')).slice(0, 100));
    }
  }
}

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/c50163177f18d5c8837b33bd2efb98e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/52b3b9e12e83ab7d873f5865fcf6c74c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['lopenddossiertoelichting'] = '';

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/854518ddb0c9c8a6c9d3155cef3551a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/3de3fd51197cc689feb28325ca2c9bd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == 'Lopend dossier')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/79f319b9623b026a0d5bd32c0f1ded27/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'lopenddossier')) == 'Lopend dossier')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/05dfd94f3682fb4e8bda0ea69d24ee08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/53bfb28b468fabd1455f58b5f7e17c44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/cf427cc9865c2d9af052fc132e3fff51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/c0d6dc5e33a1e9182a43ac7aebbbf0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/4feecc0f5acff053f01915ebcf28c3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/c1d7b8630797554841bc52cc6b4d3a6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Vul hieronder in hoeveel minuten u al heeft gedeclareerd bij het Centrum voor Levensvragen. Dit aantal zal dan in mindering worden gebracht op het totaal aantal minuten die standaard worden toegekend. Mocht  dit een nieuwe zorgvrager betreffen en heeft u nog geen consulten uitgevoerd, dan kunt u deze vraag overslaan. ' : 'Vul hieronder in hoeveel consulten u al heeft gedeclareerd bij het Centrum voor Levensvragen. Dit aantal zal dan in mindering worden gebracht op de 5 consulten die standaard worden toegekend. Mocht  dit een nieuwe zorgvrager betreffen en heeft u nog geen consulten uitgevoerd, dan kunt u deze vraag overslaan. ')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/1b1ba3af1d946afd3d9614bf21fecabe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['wlzindicatie'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1b3a51985bec594a31645b864f4b66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('522ca1f750fab0549de4e8a2643105e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c73d1669277a51e7b31be025a6eaa932', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47fdafa2c8b51049807e7ff803b24be6', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/977211defc122e3be9660cc64e4253c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/3e23c02c20fa0774e44b1f597653e9f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/6588c2ced6018b7c2338e0882158000b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/355a9f490bce564ac5abfecf24d6cdd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/091593c720d2f25604f6b9b7e7937ba4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/ae5464e3c0ecb96131668a4423867065/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultinwbackup/components/48a146cb91d33b8c166ad0c62a0efeb7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userobjectId, vw, gv, pakketminutenakkoord, naam, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d403ef77162e63f25605c752e8fd58c9')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b39e08c6a75bbff23391bfc6324877a8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4727ea031ff7fa4af1c88663be5a8ac9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naamorgpro')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'functiepro')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d2274710e4eaed54a9e7c12b10a62cf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else {
      pakketminutenakkoord = null;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`naamorgpro`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naamorgpro')),[`functiepro`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'functiepro')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`activiteit`]: 'Consult professional',[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`pakketminuten`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))),[`pakketminutenakkoord`]: pakketminutenakkoord,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingconsultinwpro')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult professional',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('functiepro').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (item['functiepro']),'label': (item['functiepro']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/b39e08c6a75bbff23391bfc6324877a8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join('')) })).map(async item => {; return ({ 'value': (item['gemeentewoonplaats']),'label': (item['gemeentewoonplaats']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    
  },  
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var email, item, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/debb4e9cfc4745bbf7f610660c348aab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultpro/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierconsultpro/components/83e85872928536568817da8a85fb3402/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultpro/components/d403ef77162e63f25605c752e8fd58c9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierconsultpro/components/7045cf33935f0a1a064b181e85088264/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/e149baadbea31dd5e33611ba055ecfe7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/7d9afad6bf5dbd02b4d94fe70f3155c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/4727ea031ff7fa4af1c88663be5a8ac9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var email, item, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingconsultinwpro'] = (getObjectProperty(toestemmingconsultinwpro, 'value'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async onBlur(___arguments) {
    var list;


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND gemeentewoonplaats =\'',(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon']),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    ;await ( async function (message){ alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/7a2e343945831c4fe56abe4ad353596a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Voer de vier cijfers van de postcode van de professional in';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/0d2274710e4eaed54a9e7c12b10a62cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierconsultpro/components/df771e0be72ee854f8ceccc5ed9223ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierconsultpro/components/21b3d4b66b1c77c7a4936a065775fea9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var naam, regio, user, userobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c58b2549ba3d9de7dbf187d77365b33')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regio')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0db7e3125ae8d59883cbe8fb072a4e14')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      user = (getObjectProperty(___arguments.context.dataModel, 'username'));
      naam = (getObjectProperty(___arguments.context.dataModel, 'naam'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      regio = (getObjectProperty(___arguments.context.pageData, 'regio'));
    } else {
      regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`coordinatiekortetoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting')),[`activiteit`]: 'Coördinatietaken',[`akkoord`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'toestemmingcoordinatie')))),[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`centra`]: (getObjectProperty(___arguments.context.dataModel, 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoordinatie')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: regio,[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/030f40d678b7c6fc02f127edae6ece1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/0db7e3125ae8d59883cbe8fb072a4e14/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/c7db1bac472103da300f0f08a5d90fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/e3d67b2835be99e31e1e8958642e3804/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/2afb5297b44ef464ee7a1173e165ae83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiercoordinatietaken/components/8c58b2549ba3d9de7dbf187d77365b33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, financieringstroom, financieringvws, minutenpergepland;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94c2530a7f9ed0a60581116226e2ef82')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdaf608b6dc10fea493e06d7ed41e36f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7b57e692d768af2f572300b46e38b8c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb55e51ff61edaf92e2ae39b04f50969')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1acf70f5af8ceb88f8fcf9884ce249c5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvinggroepsconsult')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('275e70a5310c26867ba1dbb91bb5efda')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a5183a6378f4926ddbfc3568356f767')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('720557294658ed61ebbc81ba4b8b7111')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('720557294658ed61ebbc81ba4b8b7111')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8b758d78325d40562c2390fceecec34')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c7ff96e4273bfe6f468677866c173611')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6965ee57f02d08ecb0870da5ec1296fc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2aa9474cfeddf57e85e324ea9c816a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultperiodebijeenkomsten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d84d98733776c93e94647a3c8410191')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultlocatiebijeenkomsten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff9f3e7cb6c74db795f945470cf6b65')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwervingdeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a1634452d5e01e817eb881cb1944806')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultleeftijddeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f408857535167d48d1ce089a2ebc1e81')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdeelnemersperbijeenkomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b0b7b73eda3e024db5db87c49a81d3b5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwelkecompetenties')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47823244e62687968fa4843f436c2697')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db71735f4c279be90064009398fa3683')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultthema')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e81f8dcee0be0ed9a886b1120a687416')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdoel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb5b2f9ee80d0876ad163a3872148ff4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsulthomogeniteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09f31b081506f14cc935d4498298fcb8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultmeerwaarde')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('707d7b7a75e68d0a91fce0fd3ce85288')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultprogrammabijeenkomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('317e895395096c095baf65fd2e75470a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('80f84201975ee01696fb4c8f8ffd2d87')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'groepsconsultstarteind')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d48d78e598b4ab156599d4c14bfdaa81')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'groepsconsultorganisatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      minutenpergepland = 1;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee') {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdgroepsconsult'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`doelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')),[`userobjectId`]: userobjectId,[`groepsconsultstarteind`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'groepsconsultstarteind')),[`groepsconsultorganisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'groepsconsultorganisatie')),[`doelgroepsconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')),[`omschrijvinggroepsconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvinggroepsconsult')),[`activiteit`]: 'Groepsconsult',[`betrokkenorganisaties`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'betrokkenorganisaties')),[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questiogroepsconsultperiodebijeenkomsten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultperiodebijeenkomsten')),[`questiogroepsconsultlocatiebijeenkomsten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultlocatiebijeenkomsten')),[`questiogroepsconsultwervingdeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwervingdeelnemers')),[`questiogroepsconsultleeftijddeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultleeftijddeelnemers')),[`questiogroepsconsultdeelnemersperbijeenkomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdeelnemersperbijeenkomst')),[`questiogroepsconsultwelkecompetenties`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultwelkecompetenties')),[`questiogroepsconsultbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultbijdrage')),[`questiogroepsconsultthema`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultthema')),[`questiogroepsconsultdoel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdoel')),[`questiogroepsconsulthomogeniteit`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsulthomogeniteit')),[`questiogroepsconsultmeerwaarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultmeerwaarde')),[`questiogroepsconsultprogrammabijeenkomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultprogrammabijeenkomst')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`overlegaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemminggroeps')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Groepsconsult',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Groepsconsult',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/cdaf608b6dc10fea493e06d7ed41e36f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemminggroeps, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemminggroeps = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemminggroeps').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemminggroeps')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemminggroeps'] = (getObjectProperty(toestemminggroeps, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/8f5bd17d17dd1ccbde2f0b2209a8155f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/0f65f4a4258b4362e9e98fc69a4703da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/94c2530a7f9ed0a60581116226e2ef82/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/3f2b76fe03cc77e69b9777918bbeb279/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/e2da7da2e2696c29dd93be945ec39e0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/b7b57e692d768af2f572300b46e38b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemminggroeps, item, email, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemminggroeps'] = (getObjectProperty(toestemminggroeps, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/c1dd7822c94aa9d9728491860feccb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Vanuit welke organisatie is de aanvraag voor een groepsconsult gedaan?';
  } else {
    text = 'Zijn er andere organisaties betrokken bij het groepsconsult, zo ja welke?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/2f7b7531dd71c8a2287eb9d44ff997c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Hoeveel groepsconsulten staan er in dit jaar gepland of hoeveel groepsconsulten verwacht je te geven in dit jaar? (cijfer ingeven)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Hoeveel groepsconsulten staan er gepland of hoeveel groepsconsulten verwacht je te geven? (cijfer ingeven, maximaal 5)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Aantal bijeenkomsten (cijfers invullen)';
  } else {
    text = 'Hoeveel groepsconsulten staan er gepland of hoeveel groepsconsulten verwacht je te geven? (cijfer ingeven)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/275e70a5310c26867ba1dbb91bb5efda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/a7af3f845e810ff28c72dadb9a56cc8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Hoeveel minuten verwacht je gemiddeld per groepsconsult te besteden? (maximaal 120 minuten)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    text = 'Hoeveel minuten verwacht je gemiddeld per groepsconsult te besteden? (cijfers ingeven, max 120 minuten per activiteit) ';
  } else {
    text = 'Hoeveel minuten verwacht je gemiddeld per groepsconsult te besteden?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
    (function (message) { alert(message) })((['Voor groepsconsulten kunnen maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult')))),' minuten per groepsconsult gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/720557294658ed61ebbc81ba4b8b7111/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/cf22bb7e50d7e94f64d2208d6b9f3b53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/98d87531234fb25415d7b30a78c74e05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/6629fc96bba5be66d118a59236f53b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/4954de8fa5855903fcbd9f5952e30628/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/c7ff96e4273bfe6f468677866c173611/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/f2ce5dea64d83c6ad3290a2d82796cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/e8b758d78325d40562c2390fceecec34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/e91fefe79236880225965ea56d9b56ed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/6965ee57f02d08ecb0870da5ec1296fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/fb55e51ff61edaf92e2ae39b04f50969/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Wat voor soort groepsconsult is het?' : 'Wat is het beoogde doel of resultaat van het groepsconsult?')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/8973d427d3381de5ebc222f5cd8cce75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/ca18810cbd580a9327779a7b24a8120e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/b2aa9474cfeddf57e85e324ea9c816a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/347d13935ae8c28e7b9398b852e98ab1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/0d84d98733776c93e94647a3c8410191/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/63812c96dc3f4eff948c73967629aa16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/0ff9f3e7cb6c74db795f945470cf6b65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/0b7a3647a5b18cd4722db23d6da6600f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/2a1634452d5e01e817eb881cb1944806/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultleeftijddeelnemers')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiogroepsconsultleeftijddeelnemers'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/8c39a7f66dcd75180e44d7de42449b96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/f408857535167d48d1ce089a2ebc1e81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiogroepsconsultdeelnemersperbijeenkomst')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiogroepsconsultdeelnemersperbijeenkomst'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/ff22bbf471e74f03da9ad205a10bed6d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/b0b7b73eda3e024db5db87c49a81d3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/4a662dd442173fbd6c41a17d6c5ea1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/db71735f4c279be90064009398fa3683/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/c161e905571b0454bc83f4ce03db2f93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/e81f8dcee0be0ed9a886b1120a687416/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/d59378050821a88fc47b5c8234b582fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/eb5b2f9ee80d0876ad163a3872148ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/bdc727e59a5fab42470cdb9fe3b815d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/09f31b081506f14cc935d4498298fcb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/8e8186efd5c25a0d7ff219f30503cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/707d7b7a75e68d0a91fce0fd3ce85288/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/254f3fb93949fe78d2194a2741b909a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode in van waar het groepsconsult plaatsvindt';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Selecteer gemeente';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/c4e4d25cc13a695ab336101fcd037032/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/47823244e62687968fa4843f436c2697/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/01c4bd0eb7155ef8763b0063f8534f67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/d13fddffe1892e9ef5c1953b60f4b0b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/317e895395096c095baf65fd2e75470a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/eec29cfbdce31d91ae338f01a934c1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/237980795b934eddb89a27d7987e18ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/9f5aa643d18997f3c75ac3316af44491/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/9fbdcc487a36a5f23308ac3b072f4c41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/627d474860e81ffdfc07b808441de2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/4279b997e3bc2028ba4ffac4e9fcc358/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Rouwgroep ')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/80f84201975ee01696fb4c8f8ffd2d87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Rouwgroep ')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/54ef19f6bbcee6840381571f3c242d3d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Rouwgroep ' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Lotgenotengroep')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/d48d78e598b4ab156599d4c14bfdaa81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Rouwgroep ' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroepsconsult')) == 'Lotgenotengroep')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/4d5a2997ac957f1820c6db928523672e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/02fb8d222e4748a8295da507be511169/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/af6410d80b2ab2ccfdf36afc60e91ad4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/812ee02e837bfae6aed2704f9b2256ed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/5381197e3dafaa8592737389a4f3ca46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/9a5183a6378f4926ddbfc3568356f767/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant')

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepgroepsconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'','0','\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossiergroepsconsult/components/6fec77050b15df3438935422fbee86b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiernpzf/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userobjectId, organisatie, regio, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, emailgv, naam, user, pakketminutenakkoord, akkoord, gv, vw, regiogv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d16cbd1f4edf04dbf30f4989fd0d046f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afccef94823ad814942131d4eb3736a5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      pakketminutenakkoord = (getObjectProperty(___arguments.context.pageData, 'aantalgepland')) * (getObjectProperty(___arguments.context.pageData, 'minutenpergepland'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = null;
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      pakketminutenakkoord = null;
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    regio = (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats'));
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`financieringvws`]: 'Ja',[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')),[`activiteit`]: 'Netwerkbijeenkomst NPZF',[`aantalgepland`]: (getObjectProperty(___arguments.context.pageData, 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.pageData, 'minutenpergepland')),[`akkoord`]: akkoord,[`pakketminutenakkoord`]: pakketminutenakkoord,[`kenmerk`]: (getObjectProperty(___arguments.context.pageData, 'kenmerk')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`regio`]: regio,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`userorganisatie`]: organisatie }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Netwerkbijeenkomst NPZF',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiernpzf/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiernpzf/components/afccef94823ad814942131d4eb3736a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiernpzf/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/848dcd7e9e75634e63d89acaaa124a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/76158158398bf715046d0574c924075d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/d16cbd1f4edf04dbf30f4989fd0d046f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingnetwerkbijeenkomstnpzf, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  toestemmingnetwerkbijeenkomstnpzf = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingnetwerkbijeenkomstnpzf').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingnetwerkbijeenkomstnpzf')) });})))[0];
  ___arguments.context.pageData['toestemmingnetwerkbijeenkomstnpzf'] = (getObjectProperty(toestemmingnetwerkbijeenkomstnpzf, 'value'));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossiernpzf/components/2cd258cb7f81c3fb85fa1047b816a60d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiernpzf/components/f88a6403eb361c7944144ee7087d8bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdnetwerkbijeenkomstnpzf'))))) {
    (function (message) { alert(message) })((['Voor Netwerkbijeenkomst NPZF kan maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdnetwerkbijeenkomstnpzf')))),' minuten per overleg gepland worden.'].join('')));
    ___arguments.context.pageData['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdnetwerkbijeenkomstnpzf'))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossiernpzf/components/b5177426354c2c0ade9b5152ac7c4878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.pageData['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regio, naam, user, pakketminutenakkoord, akkoord, aantalgepland;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d16cbd1f4edf04dbf30f4989fd0d046f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afccef94823ad814942131d4eb3736a5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e426715b6cfca3c45c88a5e8decf764f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'opbouwinfrastadofdorpenorganisatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      regio = (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      regio = (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats'));
    } else {
      regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.pageData, 'toestemmingopbouwinfra')) == 1) {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.pageData, 'aantalgepland')) * (getObjectProperty(___arguments.context.pageData, 'minutenpergepland'));
      } else {
        pakketminutenakkoord = null;
      }
    } else {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.pageData, 'aantalgepland')) * (getObjectProperty(___arguments.context.pageData, 'minutenpergepland'));
      } else {
        pakketminutenakkoord = null;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      akkoord = (getObjectProperty(___arguments.context.pageData, 'toestemmingopbouwinfra'));
    } else {
      akkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      aantalgepland = 1;
    } else {
      aantalgepland = (getObjectProperty(___arguments.context.pageData, 'aantalgepland'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`opbouwinfrastadofdorpenorganisatie`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrastadofdorpenorganisatie')),[`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')),[`activiteit`]: 'Opbouw infrastructuur',[`aantalgepland`]: aantalgepland,[`minutenpergepland`]: (getObjectProperty(___arguments.context.pageData, 'minutenpergepland')),[`akkoord`]: akkoord,[`pakketminutenakkoord`]: pakketminutenakkoord,[`kenmerk`]: (getObjectProperty(___arguments.context.pageData, 'kenmerk')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefopbouwinfra')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: regio,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.pageData, 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.pageData, 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'geestelijkeverzorgingrotterdam@gmail.com', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'info@zinzicht.org', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/afccef94823ad814942131d4eb3736a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/848dcd7e9e75634e63d89acaaa124a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/76158158398bf715046d0574c924075d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/5f89d16f9af8c30289975a5ce6bfd36d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/d16cbd1f4edf04dbf30f4989fd0d046f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.pageData['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/2cd258cb7f81c3fb85fa1047b816a60d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/f88a6403eb361c7944144ee7087d8bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/b5177426354c2c0ade9b5152ac7c4878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.pageData['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/55435e76e8fab1722cf9f0bad27ef259/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/e426715b6cfca3c45c88a5e8decf764f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/f6a865b75fc4fba7bf5b0f68fce80938/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropbouwinfra/components/fbc167e9d91563cc7312c76e478b6c3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Hoeveel minuten verwacht je aan deze activiteit te besteden? (max. 60 minuten)';
  } else {
    text = 'Hoeveel minuten verwacht je gemiddeld per activiteit te besteden?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossieropjeplek/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var naam, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afccef94823ad814942131d4eb3736a5')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ae758d861c991d6df6634f59e6dcf81d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9bbadf657ae3927d2fd1564b0edd3db7')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'projectnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('428d9d6d3a61e19a441ba2892169b3c6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('26b7fd6cf866dd6a18fd32b5531d228b')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'aanvrager')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e880616385f26cc4e3ee6818e55e1ad')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bd0813d3dbd41a82e31cc7c94c5e7524')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'hulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`ojpaanvrager`]: (getObjectProperty(___arguments.context.pageData, 'aanvrager')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'projectnaam')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`aantalgepland`]: (getObjectProperty(___arguments.context.pageData, 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.pageData, 'minutenpergepland')),[`akkoord`]: 1,[`pakketminutenakkoord`]: null,[`kenmerk`]: (getObjectProperty(___arguments.context.pageData, 'kenmerk')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefopjeplek')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`financieringvws`]: 'Nee',[`financieringstroom`]: 'Op je plek Aalten' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      if ((getObjectProperty(___arguments.context.pageData, 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'coordinator@cvl-mob.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Werkgroep',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossieropjeplek/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossieropjeplek/components/afccef94823ad814942131d4eb3736a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropjeplek/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/848dcd7e9e75634e63d89acaaa124a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/76158158398bf715046d0574c924075d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/26b7fd6cf866dd6a18fd32b5531d228b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/d235bc79e33de7629d55fcfb6a57c1df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/8e880616385f26cc4e3ee6818e55e1ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'geboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.dataModel['geboortejaar'] = '';
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'geboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.dataModel['geboortejaar'] = '';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossieropjeplek/components/428d9d6d3a61e19a441ba2892169b3c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var email, item, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')),[`email2`]: (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.pageData['email2'] = (getObjectProperty(email, 'email2'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropjeplek/components/ae758d861c991d6df6634f59e6dcf81d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Consult 1') {
    ___arguments.context.pageData['activiteit'] = 'Consult 1';
  } else if (___arguments.value == 'Netwerkactiviteiten') {
    ___arguments.context.pageData['activiteit'] = 'Netwerkactiviteiten';
  } else if (___arguments.value == 'Ontwikkeluren') {
    ___arguments.context.pageData['activiteit'] = 'Ontwikkeluren';
  } else if (___arguments.value == 'Groepsgesprekken') {
    ___arguments.context.pageData['activiteit'] = 'Groepsgesprekken';
  } else if (___arguments.value == 'Presentieactiviteiten') {
    ___arguments.context.pageData['activiteit'] = 'Presentieactiviteiten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossieropjeplek/components/9f38c87b8dc61794f8740ae3656e9ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossieropjeplek/components/e038cec53cf639cf90aa7e0ccb99944b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'keuzeactiviteit')) == 'Consult 1') {
    content2 = 'Hulpvraag';
  } else {
    content2 = 'Toelichting';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bff68209a7721ce1cc716ea834b82ab2')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('350e4f4937c32a25422718c52985473a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73e573d71bb6696d8182e5b129e42cb4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'soortoverlegpatzmdo')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naampatzmdo')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('41f85eae4f0322a49935639ca19277f9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdostandaardbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff18483415f683e1d898ed3acce44435')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdoincidenteelbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da577a091d18868ee0c2e13e62c7dda3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff0b5d41bb2192cd8b0b89b3333da4df')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e19d24c3b1486674d338c25a4df586ff')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'mdoclienten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c55cb79656d3a24e1e55e05fd454b408')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvingpatzmdo')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      financieringvws = 'Ja';
    } else {
      financieringvws = '';
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = 1;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
        pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
      } else {
        pakketminutenakkoord = null;
      }
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`omschrijvingpatzmdo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschrijvingpatzmdo')),[`financieringvws`]: financieringvws,[`soortoverlegpatzmdo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'soortoverlegpatzmdo')),[`naampatzmdo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'naampatzmdo')),[`questiomdostandaardbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdostandaardbetrokken')),[`questiomdoincidentieelbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomdoincidenteelbetrokken')),[`activiteit`]: 'MDO/PaTz',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefmdopatz')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`overlegaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')),[`ownerId`]: userobjectId,[`mdoclienten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'mdoclienten')) }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingmdopatz')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'MDO/PaTz',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Consult zorgvrager',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/350e4f4937c32a25422718c52985473a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvgemwoon']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingmdopatz, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingmdopatz = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingmdopatz').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingmdopatz')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingmdopatz'] = (getObjectProperty(toestemmingmdopatz, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/6533800a7c79c624aca266f738ebc149/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/b1f977ffb39a66d17c1ece537caa3149/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/bff68209a7721ce1cc716ea834b82ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/6bb591767d6a761259df83212b6baabb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/bb5f8366e44c0eeb1bc2fdd2ed1f5ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/2028f63328628d13d1b810d3e679127b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/73e573d71bb6696d8182e5b129e42cb4/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingmdopatz, item, email, regio, toestemmingconsultinwpro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  } else {
    toestemmingconsultinwpro = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingconsultinwpro').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingconsultinwpro')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingmdopatz'] = (getObjectProperty(toestemmingmdopatz, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/2e6a9ba488aab9b969c2b7a1061e1c11/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode in van waar de activiteit plaats vindt';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Selecteer gemeente';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/c4eeca7a9b33d1d6a0d46edf4ecc61e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Hoeveel minuten verwacht je gemiddeld per overleg te besteden? ';
  } else {
    text = 'Hoeveel minuten verwacht je gemiddeld per overleg te besteden? (excl. reistijd)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/3cbf5ae86e83983dd22878cc8b023761/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/da577a091d18868ee0c2e13e62c7dda3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/390c238f0d7775e585b222876bc3fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/29738dbe6ede2a8475dc1ffac47bc91f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/b22e9c260f372a8b8ba913c7c0482314/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
    (function (message) { alert(message) })((['Voor PatZ/MDO kan maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz')))),' minuten per overleg gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/504411c10bdffd9ea5c916913c8471d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? 'Welke disciplines zijn bij dit overleg betrokken?' : 'Welke disciplines zijn  bij dit overleg betrokken?')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/41f85eae4f0322a49935639ca19277f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/569d17bdf5a1168eaf78292b3e84d1c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/ff18483415f683e1d898ed3acce44435/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/32ba06261adbb6f365c5ff3946acb1bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/ff0b5d41bb2192cd8b0b89b3333da4df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/9e865de3a05fa70d38ab89e6a72e1d66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/efc593a48c5fddffc05d220e7bce30f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/18b564a4ec3b5bbde2051ed50c5da8b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Naam PaTz of MDO (welke praktijk, welke organisatie?)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Personen (functie/ organisatie) betrokkenen';
  } else {
    text = 'Naam PaTz of MDO';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/b363fb77180417e927b9b1d6b77a4135/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/cb3ebcd2016e641bea58d9acd029def5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/e66a4356b01990561a12e4ec1352612c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Aantal geplande PaTz bijeenkomsten (vul een cijfer in)';
  } else {
    text = 'Hoeveel MDO/ PaTz staan er gepland of bij hoeveel overleggen verwacht je aanwezig te zijn? (vul een cijfer in)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/d9889ddc87a33cef5e638cdfb4ea4425/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/e19d24c3b1486674d338c25a4df586ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/1f1cc92a860db0ff96beea7181c226c3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && ___arguments.value == 'MDO') {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b22e9c260f372a8b8ba913c7c0482314', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e66a4356b01990561a12e4ec1352612c', false);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && ___arguments.value == 'PaTz groep') {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b22e9c260f372a8b8ba913c7c0482314', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e66a4356b01990561a12e4ec1352612c', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/a3cff992a4eb1a87ed8e7af3af5eb605/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/7f358c7b34d1a93d50c93874d5b39f92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/cdc663d3b4591fd74aa7a037f18fe771/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/662f7f8e94d774f4249b46e954f78f05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/7049ac6afbe449b7a5051cd98adcf724/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierpatzmdo/components/c55cb79656d3a24e1e55e05fd454b408/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regio, naam, user, pakketminutenakkoord, akkoord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d16cbd1f4edf04dbf30f4989fd0d046f')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afccef94823ad814942131d4eb3736a5')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cd258cb7f81c3fb85fa1047b816a60d')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f88a6403eb361c7944144ee7087d8bc6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
    } else {
      user = (getObjectProperty(___arguments.context.dataModel, 'username'));
      naam = (getObjectProperty(___arguments.context.dataModel, 'naam'));
    }
    regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    if ((getObjectProperty(___arguments.context.appData, 'toestemmingraadvanadvies')) == 'true') {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')) * (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland'));
    } else {
      pakketminutenakkoord = null;
    }
    akkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'toestemmingraadvanadvies'))));
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting')),[`activiteit`]: 'Raad van Advies',[`aantalgepland`]: (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland')),[`akkoord`]: akkoord,[`pakketminutenakkoord`]: pakketminutenakkoord,[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`centra`]: (getObjectProperty(___arguments.context.dataModel, 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefraadvanadvies')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: regio,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      if ((getObjectProperty(___arguments.context.dataModel, 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Raad van Advies',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/afccef94823ad814942131d4eb3736a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/848dcd7e9e75634e63d89acaaa124a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/76158158398bf715046d0574c924075d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/5f89d16f9af8c30289975a5ce6bfd36d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/d16cbd1f4edf04dbf30f4989fd0d046f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.dataModel['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.dataModel['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/2cd258cb7f81c3fb85fa1047b816a60d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierraadvanadvies/components/f88a6403eb361c7944144ee7087d8bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bdce4478fd2ee57fd4f9e966e8955a82', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, emailgv, naam, user, userobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7ede205f703fc5bdda6f672130fe0c6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('891a0a05090fb7ec3a345697bad3e1e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Postcode veld is niet correct gevuld');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'orgscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'teamscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'orgscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'teamscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eeed1c26ca272846d85d6fb58a46922')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'scholingdoelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b68c15a1c9871e69ef5cf145a943101e')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c620e5605346d2c391e5074babdda29')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      pakketminutenakkoord = null;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`orgscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'orgscholing')),[`teamscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'teamscholing')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`scholingorganisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'orgscholing')),[`scholingteam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'teamscholing')),[`scholingdoelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'scholingdoelgroep')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`extrainfo`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'extrainfo')),[`akkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')),[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'organisatie')))),[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`overlegaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'overlegaanvraag')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/a7ede205f703fc5bdda6f672130fe0c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    options = (addItemToList((await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });}))), ({ [`value`]: 'Zinvol',[`label`]: 'Zinvol' })));
  } else {
    options = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });})));
  }

  return options

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgemwoon')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == 'Zinvol') {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = 'Zinvol';
  } else {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  }
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`gv`]: (getObjectProperty(item, 'GV')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/884839ce0b7be60566d654ccde19c375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/891a0a05090fb7ec3a345697bad3e1e4/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/c21176fc9bea5c9da3a2ecb63d884d71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode in van waar de activiteit plaats vindt';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/7eeed1c26ca272846d85d6fb58a46922/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('scholingdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroepscholing')),'label': (getObjectProperty(item, 'doelgroepscholing')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('51ba2e21a219f6846a61bc0921a183d8'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('51ba2e21a219f6846a61bc0921a183d8'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('51ba2e21a219f6846a61bc0921a183d8'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('51ba2e21a219f6846a61bc0921a183d8'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/5a5afd3e28437fdbd2489226b5a14aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/d08e4561caa4e772d1bae282cb11fb5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/f7e991348042204bb2de348a4585f6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Hoeveel minuten verwacht je gemiddeld per scholing te besteden? (incl. voorbereidingstijd)';
  } else {
    text = 'Hoeveel minuten verwacht je gemiddeld per scholing te besteden? (incl. voorbereidingstijd, excl. reistijd)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/6c620e5605346d2c391e5074babdda29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierscholing/components/b79acb772add472188cae91c765732c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/8bf274019aec5c02ff0691180248a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')).slice(0, 3));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierscholing/components/15417b878e31adf3ee8266513935050e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing/components/d8148143fc6d507d299a7182fff44aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/b68c15a1c9871e69ef5cf145a943101e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Korte omschrijving van de scholing (wat is het doel van de scholing, voor welke organisatie, welke groep ontvangt de scholing, wat is het adres?)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    text = 'Korte omschrijving van de scholing (wat is het doel van de scholing, voor welke organisatie, welke groep ontvangt de scholing)';
  } else {
    text = 'Korte omschrijving van de scholing';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/30a239e172c26d9e9f376327f1ea3de2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/469cfcfbfe55c7f258b2a2dc6ea8ef74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/a1efdc86e3099435f19ebc25557fa4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/e772ced5f92b063d5da4f24cf3acffaf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/b833577f667fa03f458126a28a7e7177/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/c3e1e1c642454f272037dd770f936e97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing/components/c19fa8372f3bd59c453a56aa9fc53412/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, minutenpergepland, aantalpergepland, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7ede205f703fc5bdda6f672130fe0c6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46f7707111dd3559d3fa58f5acd75fc1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fcefdd1f052274bd0eb1557b48091f05')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f8da7a75403ba4d8af6cd24b8919a38b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('653ecf838ac9bc46d19a91d224fdafeb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4959228433c8abc64bd6b54144f1c06')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ff9871a3c3aa9de187f50916119ad37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c8e54c16651ae33180d2c62d75b0462')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b21b71d0c1d116f5cabc0664f218639')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8da3c41e12025fdbaf6975b1335460cb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = 'Ja';
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      minutenpergepland = 60;
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren'));
      financieringvws = 'Ja';
    } else {
      minutenpergepland = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) * 60) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: financieringvws,[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`leeftijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: aantalpergepland,[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/a7ede205f703fc5bdda6f672130fe0c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgemwoon')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/f7e991348042204bb2de348a4585f6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8bf274019aec5c02ff0691180248a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/fcefdd1f052274bd0eb1557b48091f05/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/4237a535e20430fea44585e6a189977e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/46f7707111dd3559d3fa58f5acd75fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/9f09e3572ac1e9f3e77e47abec681f08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/676894f947262771de9b579fe729fcbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/15417b878e31adf3ee8266513935050e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/a6f70165db456545a7d4a353652749a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/45c48085867e6ec7d741fadb9f57c60c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/3c4b69fbd9bbaec9cfdd54f4549352ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/9364efb6095255e8184b18f72ba15f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/f8da7a75403ba4d8af6cd24b8919a38b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/653ecf838ac9bc46d19a91d224fdafeb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/2b5657ed29249ddedc5d5ec8d8f46b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/aa7959fdbe6df529ba090ba8aba6dc1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/7ff9871a3c3aa9de187f50916119ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/24af6fddf44f294461db690e9c8b6028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/bc8a8948d902f12335e4a15245a7ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8b21b71d0c1d116f5cabc0664f218639/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/1c8e54c16651ae33180d2c62d75b0462/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbedrag'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/7f18f10ac0aa32a5d49ac2fee85277b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8fead476f858274c1145e6af37e97e2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/710e19251a37eb9c40798319f2311a56/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/d5684d459dd63e6563dc0e4a27fe6355/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/3cf9aa99e1678133fd237cedaaee759c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/bd6c3ac7a8ed1665e09138cc0a014e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/8da3c41e12025fdbaf6975b1335460cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-brabant/components/b4959228433c8abc64bd6b54144f1c06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, minutenpergepland, aantalpergepland, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7ede205f703fc5bdda6f672130fe0c6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46f7707111dd3559d3fa58f5acd75fc1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fcefdd1f052274bd0eb1557b48091f05')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f8da7a75403ba4d8af6cd24b8919a38b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('653ecf838ac9bc46d19a91d224fdafeb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0decc7a92ecf24eb4c077b186eb62197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ff9871a3c3aa9de187f50916119ad37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c8e54c16651ae33180d2c62d75b0462')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b21b71d0c1d116f5cabc0664f218639')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('246bea85b93b54fac7821a4e7ed7d355')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c207a8f15a41531589887b1a7b4c55f1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e8212f90fd1babb2171be19701aad75')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c4b69fbd9bbaec9cfdd54f4549352ec')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8da3c41e12025fdbaf6975b1335460cb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      minutenpergepland = 60;
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren'));
      financieringvws = 'Ja';
    } else {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
      financieringvws = 'Ja';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: financieringvws,[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: aantalpergepland,[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/a7ede205f703fc5bdda6f672130fe0c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgemwoon')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/fcefdd1f052274bd0eb1557b48091f05/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/4237a535e20430fea44585e6a189977e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/46f7707111dd3559d3fa58f5acd75fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/9f09e3572ac1e9f3e77e47abec681f08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/676894f947262771de9b579fe729fcbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/15417b878e31adf3ee8266513935050e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/246bea85b93b54fac7821a4e7ed7d355/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/9c74734904af611dbabee20c7c537233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/97b2d984b4ea83645cd5eda7e13976e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/c207a8f15a41531589887b1a7b4c55f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/fcb26d51814e7e856b3be5935cc6071d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/2e8212f90fd1babb2171be19701aad75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/a6f70165db456545a7d4a353652749a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/45c48085867e6ec7d741fadb9f57c60c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/3c4b69fbd9bbaec9cfdd54f4549352ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/bd6c3ac7a8ed1665e09138cc0a014e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/8da3c41e12025fdbaf6975b1335460cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/9364efb6095255e8184b18f72ba15f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/f8da7a75403ba4d8af6cd24b8919a38b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/653ecf838ac9bc46d19a91d224fdafeb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/2b5657ed29249ddedc5d5ec8d8f46b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/aa7959fdbe6df529ba090ba8aba6dc1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/7ff9871a3c3aa9de187f50916119ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/24af6fddf44f294461db690e9c8b6028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/bc8a8948d902f12335e4a15245a7ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/8b21b71d0c1d116f5cabc0664f218639/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/1d0df66d3f786edc9d076664be0156df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/1c8e54c16651ae33180d2c62d75b0462/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbedrag'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/7f18f10ac0aa32a5d49ac2fee85277b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-haaglanden/components/0decc7a92ecf24eb4c077b186eb62197/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, tariefperminuut, akkoord, naam, user, minutenpergepland, aantalpergepland, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7ede205f703fc5bdda6f672130fe0c6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46f7707111dd3559d3fa58f5acd75fc1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fcefdd1f052274bd0eb1557b48091f05')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f8da7a75403ba4d8af6cd24b8919a38b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('653ecf838ac9bc46d19a91d224fdafeb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0decc7a92ecf24eb4c077b186eb62197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ff9871a3c3aa9de187f50916119ad37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c8e54c16651ae33180d2c62d75b0462')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b21b71d0c1d116f5cabc0664f218639')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('246bea85b93b54fac7821a4e7ed7d355')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c207a8f15a41531589887b1a7b4c55f1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e8212f90fd1babb2171be19701aad75')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c4b69fbd9bbaec9cfdd54f4549352ec')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8da3c41e12025fdbaf6975b1335460cb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      minutenpergepland = 60;
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren'));
      financieringvws = 'Ja';
    } else {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == 'Bestaande scholing ') {
      tariefperminuut = 22500;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == 'Nieuw te ontwikkelen scholing') {
      tariefperminuut = 22500;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      tariefperminuut = 22500;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')),[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: aantalpergepland,[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: tariefperminuut,[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/a7ede205f703fc5bdda6f672130fe0c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgemwoon')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/f7e991348042204bb2de348a4585f6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8bf274019aec5c02ff0691180248a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/fcefdd1f052274bd0eb1557b48091f05/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/4237a535e20430fea44585e6a189977e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/46f7707111dd3559d3fa58f5acd75fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/9f09e3572ac1e9f3e77e47abec681f08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/676894f947262771de9b579fe729fcbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/15417b878e31adf3ee8266513935050e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/246bea85b93b54fac7821a4e7ed7d355/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/9c74734904af611dbabee20c7c537233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/97b2d984b4ea83645cd5eda7e13976e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/c207a8f15a41531589887b1a7b4c55f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/fcb26d51814e7e856b3be5935cc6071d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/2e8212f90fd1babb2171be19701aad75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/a6f70165db456545a7d4a353652749a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/45c48085867e6ec7d741fadb9f57c60c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/3c4b69fbd9bbaec9cfdd54f4549352ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/bd6c3ac7a8ed1665e09138cc0a014e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8da3c41e12025fdbaf6975b1335460cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/9364efb6095255e8184b18f72ba15f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/f8da7a75403ba4d8af6cd24b8919a38b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/653ecf838ac9bc46d19a91d224fdafeb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/2b5657ed29249ddedc5d5ec8d8f46b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/aa7959fdbe6df529ba090ba8aba6dc1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/7ff9871a3c3aa9de187f50916119ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/24af6fddf44f294461db690e9c8b6028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/bc8a8948d902f12335e4a15245a7ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8b21b71d0c1d116f5cabc0664f218639/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/1d0df66d3f786edc9d076664be0156df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/1c8e54c16651ae33180d2c62d75b0462/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbedrag'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/7f18f10ac0aa32a5d49ac2fee85277b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/8fead476f858274c1145e6af37e97e2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/710e19251a37eb9c40798319f2311a56/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/d5684d459dd63e6563dc0e4a27fe6355/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/3cf9aa99e1678133fd237cedaaee759c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-questio/components/0decc7a92ecf24eb4c077b186eb62197/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user, minutenpergepland, aantalpergepland, financieringvws;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('518f993e1c1e576382c30db96e7b1fef')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'moreelberaadaanvrager')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7ede205f703fc5bdda6f672130fe0c6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2ac246555c2cf6d37bd1c26228ff8358')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'scholingdoelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7867ef46a6cb64f1de86ce38501e3aaa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46f7707111dd3559d3fa58f5acd75fc1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fcefdd1f052274bd0eb1557b48091f05')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f8da7a75403ba4d8af6cd24b8919a38b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('653ecf838ac9bc46d19a91d224fdafeb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0decc7a92ecf24eb4c077b186eb62197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c8e54c16651ae33180d2c62d75b0462')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b21b71d0c1d116f5cabc0664f218639')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('246bea85b93b54fac7821a4e7ed7d355')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c207a8f15a41531589887b1a7b4c55f1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e8212f90fd1babb2171be19701aad75')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c4b69fbd9bbaec9cfdd54f4549352ec')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8da3c41e12025fdbaf6975b1335460cb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      minutenpergepland = 60;
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren'));
      financieringvws = 'Ja';
    } else {
      minutenpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
      aantalpergepland = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland'));
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      pakketminutenakkoord = aantalpergepland * minutenpergepland;
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == null) {
      financieringvws = 'Ja';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`scholingdoelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'scholingdoelgroep')),[`userobjectId`]: userobjectId,[`moreelberaadaanvrager`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'moreelberaadaanvrager')),[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: financieringvws,[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: aantalpergepland,[`minutenpergepland`]: minutenpergepland,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: recipient, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/a7ede205f703fc5bdda6f672130fe0c6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgemwoon')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')),'email2': (getObjectProperty(item, 'email2')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email2'] = (getObjectProperty(email, 'email2'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemmingscholing').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/fcefdd1f052274bd0eb1557b48091f05/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/4237a535e20430fea44585e6a189977e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/46f7707111dd3559d3fa58f5acd75fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/9f09e3572ac1e9f3e77e47abec681f08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/676894f947262771de9b579fe729fcbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/15417b878e31adf3ee8266513935050e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/246bea85b93b54fac7821a4e7ed7d355/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/a6f70165db456545a7d4a353652749a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/bd6c3ac7a8ed1665e09138cc0a014e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8da3c41e12025fdbaf6975b1335460cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/9364efb6095255e8184b18f72ba15f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/f8da7a75403ba4d8af6cd24b8919a38b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/653ecf838ac9bc46d19a91d224fdafeb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/24af6fddf44f294461db690e9c8b6028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/bc8a8948d902f12335e4a15245a7ae6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8b21b71d0c1d116f5cabc0664f218639/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/1c8e54c16651ae33180d2c62d75b0462/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbedrag'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/7f18f10ac0aa32a5d49ac2fee85277b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/0decc7a92ecf24eb4c077b186eb62197/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/a641fdefd366b899ffa57c24bba80b0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/7867ef46a6cb64f1de86ce38501e3aaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/f7e991348042204bb2de348a4585f6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/8bf274019aec5c02ff0691180248a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/e3424aa7ff211da9c8dfc42e793bc961/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/518f993e1c1e576382c30db96e7b1fef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/a1c69ee8a432c9a94c9ced12aaf89c5e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-sichtpunt/components/2ac246555c2cf6d37bd1c26228ff8358/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var recipient, emailgv, userobjectId, organisatie, regiogv, vw, gv, pakketminutenakkoord, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, akkoord, naam, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d5de54dffc213d1285110daedd60a5c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2b677748bd6af42766267f53a4ed09ea')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef68d3630ef25c3352da12ccf8b1054d')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04177319dcd31e8b59c1d20c729c8c8e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('710e19251a37eb9c40798319f2311a56')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3cf9aa99e1678133fd237cedaaee759c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9da274f800ca389ffad769dce6e0df8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0decc7a92ecf24eb4c077b186eb62197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1ab9fe1e400fe865c486cfce7b58668d')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b808334d096c279ae93b4b9c8b010493')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ffa4e74617e9e1ceb7b71453697f9caf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15417b878e31adf3ee8266513935050e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e5f34c5e018206f9e70d28e4bc1d63f8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bf788e89b44db8f494598092f6070756')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ff9871a3c3aa9de187f50916119ad37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1df67ed59e940a3ff95cd9b79716fc02')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('246bea85b93b54fac7821a4e7ed7d355')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45eb6c7d340da4f47692f1540c7911fa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c207a8f15a41531589887b1a7b4c55f1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e8212f90fd1babb2171be19701aad75')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89440c4d446e1e8c532e49d85462fa77')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c4b69fbd9bbaec9cfdd54f4549352ec')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && ((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      pakketminutenakkoord = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland'));
    } else {
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioconsultinwaangenomendoor')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbestaandnieuw')),[`financieringvws`]: 'Ja',[`financieringstroom`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'financieringstroomwelke')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingnaam')),[`omschscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'omschscholing')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingverwachtaantaldeelnemers')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingwijze')),[`questioscholingbijdrage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbijdrage')),[`factuurcontactpersoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurcontactpersoon')),[`factuurmailadres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'factuurmailadres')),[`questioscholingbedrag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questioscholingbedrag')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeslacht')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadaantaluren')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadachtergrondinformatie')),[`scholingspecifiekedoelgroepteam`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')),[`activiteit`]: 'Scholing',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: user,[`naam`]: naam,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: akkoord,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`pakketminutenakkoord`]: pakketminutenakkoord,[`organisatie`]: organisatie,[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`regiogv`]: regiogv,[`postcodeaankomst`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'postcodeaankomst')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'cvlkenmerk')),[`userorganisatie`]: organisatie,[`ownerId`]: userobjectId }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingscholing')) == 1) {
      } else {
        if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
          await Backendless.Messaging.sendEmailFromTemplate('dossierprojectleider', Backendless.EmailEnvelope.create({ addresses: emailgv, ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`gemwoon`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) }), undefined);
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email2'));
          } else {
            recipient = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email'));
          }
          await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Scholing',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
        }
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/8e92d3147b6b7668dd7d1873c8afed8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/8d5de54dffc213d1285110daedd60a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND GV LIKE \'GV%\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/7d2ab0aa3e4710eedeba5eaff4ae1d61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/5dce2c0f4ad603317ffd167db2af1b48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2babec65481b3e6a2902749d4c646f7f'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/f7e991348042204bb2de348a4585f6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/8bf274019aec5c02ff0691180248a1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/e5f34c5e018206f9e70d28e4bc1d63f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'minutenpergepland')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
    (function (message) { alert(message) })((['Voor scholing kan maximaal ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing')))),' minuten per scholing gepland worden.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/04177319dcd31e8b59c1d20c729c8c8e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('74ce45f53742eaad076346d6cc133de4', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=1'))).setSortBy('nr').setPageSize(100))));
    ___arguments.context.pageData['listdoelgroepteam'] = [];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeslacht'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadthuiswonend'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadhulpvraag'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadachtergrondinformatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadaantaluren'] = null;
  } else {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingbestaandnieuw'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroom'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringstroomwelke'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['financieringvws'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingnaam'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['omschscholinginput'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingleerdoelen'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingwaarvoorgeorganiseerd'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholinglocatie'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['aantalgepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['minutenpergepland'] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')[''] = null;
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questioscholingverwachtaantaldeelnemers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/9f09e3572ac1e9f3e77e47abec681f08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/c9da274f800ca389ffad769dce6e0df8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/b9262fb2cf21b0bdd94f4f9d4fd12fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/1ab9fe1e400fe865c486cfce7b58668d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/fb09b61b282decc4a4ba564f32cc5c5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/b808334d096c279ae93b4b9c8b010493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/a94b49cba115af9c7fd5f4b33e24c0f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/ffa4e74617e9e1ceb7b71453697f9caf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/676894f947262771de9b579fe729fcbb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewscholing')) == true) {
    text = 'Hoeveel scholingen staan er gepland? (cijfers invullen)';
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad')) == true) {
    text = 'Aantal geplande moreel beraden? (cijfers invullen)';
  } else {
    text = 'Hoeveel scholingen staan er gepland? (cijfers invullen)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/bf788e89b44db8f494598092f6070756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/246bea85b93b54fac7821a4e7ed7d355/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) <= 1894) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'questiomoreelberaadgeboortejaar')) >= 2024) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['questiomoreelberaadgeboortejaar'] = null;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/9c74734904af611dbabee20c7c537233/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/97b2d984b4ea83645cd5eda7e13976e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/c207a8f15a41531589887b1a7b4c55f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/fcb26d51814e7e856b3be5935cc6071d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/2e8212f90fd1babb2171be19701aad75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/a6f70165db456545a7d4a353652749a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/89440c4d446e1e8c532e49d85462fa77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/46b4074d6f2386d9ff7e6cb4b118347c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/45eb6c7d340da4f47692f1540c7911fa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/2b5657ed29249ddedc5d5ec8d8f46b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/aa7959fdbe6df529ba090ba8aba6dc1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/7ff9871a3c3aa9de187f50916119ad37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/24af6fddf44f294461db690e9c8b6028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/1df67ed59e940a3ff95cd9b79716fc02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/0decc7a92ecf24eb4c077b186eb62197/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewscholing'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/506432fbd7170886426811da870afb81/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'viewscholing')) == true) {
    text = 'Gemiddeld aantal minuten per scholing (cijfers invullen)? Reken de voorbereidingstijd mee. De voorbereidingstijd is maximaal 50% van de scholingsduur.';
  } else if ((getObjectProperty(___arguments.context.pageData, 'viewmoreelberaad')) == true) {
    text = 'Gemiddeld aantal minuten per moreel beraad? (cijfers invullen)';
  } else {
    text = 'Gemiddeld aantal minuten per scholing (cijfers invullen)? Reken de voorbereidingstijd mee. De voorbereidingstijd is maximaal 50% van de scholingsduur.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/2b677748bd6af42766267f53a4ed09ea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingscholing, item, email, regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','ZHN','\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  } else {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  }
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingscholing = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),'\''].join(''))).setProperties('toestemminggroeps').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingscholing')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingscholing'] = (getObjectProperty(toestemmingscholing, 'value'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/afcb6d03ffdd65a62c57e31ee9ddb271/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierscholing-zhn/components/fd754358fa16c26fa39db7a6edac807b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiertriage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiertriage/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regio, naam, user, userobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c58b2549ba3d9de7dbf187d77365b33')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regio')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0db7e3125ae8d59883cbe8fb072a4e14')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
    } else {
      user = (getObjectProperty(___arguments.context.dataModel, 'username'));
      naam = (getObjectProperty(___arguments.context.dataModel, 'naam'));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      regio = (getObjectProperty(___arguments.context.pageData, 'regio'));
    } else {
      regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`coordinatiekortetoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting')),[`activiteit`]: 'Triage/intake',[`akkoord`]: false,[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`centra`]: (getObjectProperty(___arguments.context.dataModel, 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: regio,[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiertriage/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiertriage/components/030f40d678b7c6fc02f127edae6ece1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiertriage/components/0db7e3125ae8d59883cbe8fb072a4e14/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossiertriage/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiertriage/components/c7db1bac472103da300f0f08a5d90fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiertriage/components/e3d67b2835be99e31e1e8958642e3804/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiertriage/components/2afb5297b44ef464ee7a1173e165ae83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossiertriage/components/8c58b2549ba3d9de7dbf187d77365b33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userobjectId, organisatie, regio, btwinclmdopatz, btwinclscholing, btwinclgroepsconsulten, btwinclconsulten, btwinclcoaching, btwplichtig, emailgv, naam, user, pakketminutenakkoord, akkoord, gv, vw, regiogv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d16cbd1f4edf04dbf30f4989fd0d046f')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afccef94823ad814942131d4eb3736a5')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'selectgv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cd258cb7f81c3fb85fa1047b816a60d')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f88a6403eb361c7944144ee7087d8bc6')), 'display')) == true && (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ae758d861c991d6df6634f59e6dcf81d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      user = (getObjectProperty(___arguments.context.pageData, 'selectgv'));
      naam = (getObjectProperty(___arguments.context.pageData, 'selectnaam'));
      emailgv = (getObjectProperty(___arguments.context.pageData, 'email'));
      btwplichtig = (getObjectProperty(___arguments.context.pageData, 'btwplichtig'));
      btwinclcoaching = (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty(___arguments.context.pageData, 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz'));
      regiogv = (getObjectProperty(___arguments.context.pageData, 'regiogv'));
      organisatie = (getObjectProperty(___arguments.context.pageData, 'organisatie'));
      akkoord = true;
      userobjectId = (getObjectProperty(___arguments.context.pageData, 'userobjectId'));
      pakketminutenakkoord = (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')) * (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland'));
      if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    } else {
      user = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
      naam = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'));
      emailgv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
      btwplichtig = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig'));
      btwinclcoaching = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching'));
      btwinclconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten'));
      btwinclgroepsconsulten = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten'));
      btwinclscholing = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
      btwinclmdopatz = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz'));
      regiogv = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv'));
      organisatie = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'));
      akkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'toestemmingwerkgroep'))));
      userobjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
      pakketminutenakkoord = null;
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
        gv = 1;
        vw = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
        vw = 1;
        gv = 0;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
        vw = 0;
        gv = 0;
      }
    }
    regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: userobjectId,[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting')),[`activiteit`]: 'Werkgroep',[`aantalgepland`]: (getObjectProperty(___arguments.context.dataModel, 'aantalgepland')),[`minutenpergepland`]: (getObjectProperty(___arguments.context.dataModel, 'minutenpergepland')),[`akkoord`]: akkoord,[`pakketminutenakkoord`]: pakketminutenakkoord,[`kenmerk`]: (getObjectProperty(___arguments.context.dataModel, 'kenmerk')),[`centra`]: (getObjectProperty(___arguments.context.dataModel, 'centraname')),[`username`]: user,[`naam`]: naam,[`emailgv`]: emailgv,[`status`]: 'Actief',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningprojectleider')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`btwplichtig`]: btwplichtig,[`btwinclcoaching`]: btwinclcoaching,[`btwinclconsulten`]: btwinclconsulten,[`btwinclgroepsconsulten`]: btwinclgroepsconsulten,[`btwinclscholing`]: btwinclscholing,[`btwinclmdopatz`]: btwinclmdopatz,[`regio`]: regio,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats')),[`userorganisatie`]: organisatie,[`werkgroep`]: (getObjectProperty(___arguments.context.pageData, 'werkgroep')) }) ));
    await Backendless.Data.of('Users').addRelation(userobjectId, 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      if ((getObjectProperty(___arguments.context.dataModel, 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'coordinator@cvl-mob.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Werkgroep',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'geestelijkeverzorgingrotterdam@gmail.com', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Werkgroep',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'coordinator@centrum-levensvragen.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Werkgroep',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  } else {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/afccef94823ad814942131d4eb3736a5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND userStatus=\'ENABLED\''].join(''))).setProperties(['naam', 'username']).setSortBy('username ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`email`]: (getObjectProperty(item, 'email')),[`btwplichtig`]: (getObjectProperty(item, 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty(item, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(item, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(item, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(item, 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty(item, 'btwinclmdopatz')),[`regiogv`]: (getObjectProperty(item, 'regiogv')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`gv`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['selectnaam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['email'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(naam, 'btwplichtig'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(naam, 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(naam, 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(naam, 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(naam, 'btwinclscholing'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(naam, 'btwinclmdopatz'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(naam, 'regiogv'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(naam, 'organisatie'));
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/8ba5a2437db3870cd913051e26a1a4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/848dcd7e9e75634e63d89acaaa124a7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/76158158398bf715046d0574c924075d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Projectleider')) ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/5f89d16f9af8c30289975a5ce6bfd36d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/d16cbd1f4edf04dbf30f4989fd0d046f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.dataModel['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.dataModel['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/2cd258cb7f81c3fb85fa1047b816a60d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierwerkgroep/components/f88a6403eb361c7944144ee7087d8bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dashboard2023plbestuur/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard2023plbestuur/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/1a24c16b-9291-4c4c-a5c8-b366806c12fc/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ba745149-65b1-4e27-a064-4e5fd9178f08/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/187082b3-997e-4517-b3c3-398b9a396ea5/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9a9e6d93-58ad-4e87-9959-b43a479d5855/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d1dd7b5d-0e59-4428-b629-2d2b89bd5b43/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3af6a11b-6b72-4090-a6e1-122783226eed/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e8498715-ecf8-4eec-85d6-4bc656973184/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2acbf22f-d816-43d0-a710-ab05c8a8a4af/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/07dcfae2-94a5-43e9-bf3e-6321a18edd61/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/07cf442e-6d99-46ea-b888-d503658558a4/page/HdAuB';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard2023plbestuur/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard2024plbestuur/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard2024plbestuur/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/717aab50-8534-4c07-91ba-0ab49dfe6ff2/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a9ab088d-475a-4923-9b57-29f3e6b454ec/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e18dedfa-12d1-492a-ba3d-1f50bf218d2a/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/91cc7aec-5390-4fe3-8d44-ecd809501470/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c55e5295-164f-4ff3-8d86-c3bfdbb744b4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/40a09d66-3d3b-42a2-883e-67bf5c5416e3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/50c8caa5-98d9-4fec-9652-4dcb92361f29/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/64ac870b-3fe9-4218-9fbe-da6a52bf35cb/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ad5dbbdc-04c4-4469-83dc-177a7866e4e4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/d06c21e1-96c5-4d82-a74c-5a7840e9febb/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/e209c56d-37c3-4d33-aa28-9680b1a68fd5/page/HdAuB';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard2024plbestuur/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard2025bestuur/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard2025bestuur/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0cc08e0a-e3d5-4b0c-8718-a233acd6d9f5/page/HdAuB';
  } else if ((getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9b97e9cb-77f4-4287-9344-5888d1ec077d/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboard2025bestuur/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardbestuur2026/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardbestuur2026/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f389769b-acd0-47d1-a544-1f7a553772ab/page/HdAuB';
  } else if ((getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7d2e4328-74c9-4749-a002-2c3b0f6f4dcd/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardbestuur2026/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardgv2023/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2023/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2023/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ba745149-65b1-4e27-a064-4e5fd9178f08/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/62afacbc-ce98-4716-9bdc-4dae9d1d8357/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6878d438-38c1-4859-a81e-25b63ab2fbd3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2acbf22f-d816-43d0-a710-ab05c8a8a4af/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3ac15b7e-221d-4627-9661-b9449ab84ddc/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9d408b3d-44b9-4244-9db1-7030dece0b55/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/bad17c37-ea61-4e5d-a0cd-7bec9f81f9e7/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f0ff7218-e963-4a81-8a7c-de39a34ac760/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    if ((getObjectProperty(___arguments.context.appData, 'teamcoordinator')) == true) {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/8dbe9877-9115-451f-8632-c0491af88055/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/9673fd9b-e6b4-4e80-91b3-c621dc05f029/page/HdAuB';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardgv2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardgv2024/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2024/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2024/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a3d0a161-0dd0-4c6c-a7c7-7a376fc16be9/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/1af79353-bfc5-4cf9-9534-be48c0d8802b/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e18dedfa-12d1-492a-ba3d-1f50bf218d2a/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/be2097cd-87b6-47ab-bbaa-a90cdd38e6c3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d75b2ba8-2fd6-4d2a-be96-3ce911084280/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/005d82a7-056e-41fb-ac18-3130c61681ed/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/b29de4a7-97e3-4b85-9a6b-02d1bd6757a6/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn18mbs') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/1ab35516-72d8-4271-b5ae-12fc1bf2ec01/page/HdAuB';
    } else if ((getObjectProperty(___arguments.context.appData, 'teamcoordinator')) == true) {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/1ab35516-72d8-4271-b5ae-12fc1bf2ec01/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/1e9d5f66-db6f-42a8-bc50-bceb5dbf4a9e/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ad5dbbdc-04c4-4469-83dc-177a7866e4e4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/98e31eaa-4625-4143-b6ae-7254ce6dade4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = '';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = '';
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardgv2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardgv2024/components/f641639e0aa32a1e469b68a5c451f0e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboardgv2024/components/bbb33fb658cb00d8974788f757c98d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboardgv2024/components/c02c4b4539bfa3cd2407d2fd351597bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2024/components/0f77fe37c99602f54e1b85b67628dd12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2025/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2025/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2025/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e550d749-c793-4b83-87d9-916da42cc133/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/b4087616-0171-43f5-b617-33323817df24/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/016217eb-d203-437b-983e-3c1a65410f04/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/46e6aa3d-cca1-4aae-82c6-85f102573470/page/wmP8B';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a12ee7e9-1c73-4613-b218-5cfc71da31fc/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d83063d5-c8cb-4cfd-8610-3bfbdb5f3b93/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/011a2642-d2c7-4de8-9290-87c05d1ab1b3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn18mbs') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/14be2bbe-0a42-483b-b7ba-32daadb0e5f7/page/HdAuB';
    } else if ((getObjectProperty(___arguments.context.appData, 'teamcoordinator')) == true) {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/14be2bbe-0a42-483b-b7ba-32daadb0e5f7/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/1e7eda81-6800-4a86-9b28-ed51cb790ca5/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0cc08e0a-e3d5-4b0c-8718-a233acd6d9f5/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6cdd2f45-47c1-4ddd-b005-a8da956cfa70/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = '';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/cda7018b-a16f-4496-9413-7d4c83d09147/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz15mpr' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz17mpt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz12jmp') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/210d888e-dada-4fe2-96d2-3c51d23b9d6c/page/HdAuB';
    } else {
      URL2 = '';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardgv2025/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardgv2025/components/f641639e0aa32a1e469b68a5c451f0e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboardgv2025/components/bbb33fb658cb00d8974788f757c98d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboardgv2025/components/c02c4b4539bfa3cd2407d2fd351597bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2025/components/0f77fe37c99602f54e1b85b67628dd12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2026/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2026/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2026/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/5f787ba9-9a13-4cda-ae58-02caf38fd151/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = '';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/98062709-7652-4e4c-ba37-fff650f79dd0/page/wmP8B';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/fd93c761-c607-4dfb-a7af-fb3d9692b85d/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ef66781e-8005-4bb1-b810-df8d72f86d67/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6f2c8e3e-ebfb-4df6-8974-2411b5c2fe3c/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/98541121-aecf-45dd-9793-aaec26fc4d63/page/wmP8B';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a60a2243-638b-4895-9898-6c1341ca0667/page/wmP8B';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Mn18mbs' || (getObjectProperty(___arguments.context.appData, 'teamcoordinator')) == true) {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/4f4d7a8a-f59c-4ea2-990d-ec03a97797aa/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/bf7b6418-ac26-4ee9-a2fc-8779c3892ead/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f389769b-acd0-47d1-a544-1f7a553772ab/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/1e135a01-1b7a-42e5-acbd-c8adf18b530e/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = '';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6f2d2518-01bb-4e89-816f-976883fae6e3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz15mpr' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz17mpt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz12jmp') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/77003d10-9e8d-4906-b15c-0e929b8aa087/page/HdAuB';
    } else {
      URL2 = '';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/77003d10-9e8d-4906-b15c-0e929b8aa087/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardgv2026/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardgv2026/components/f641639e0aa32a1e469b68a5c451f0e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboardgv2026/components/c02c4b4539bfa3cd2407d2fd351597bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardgv2026/components/0f77fe37c99602f54e1b85b67628dd12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardlandelijk2025/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardlandelijk2025/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardlandelijk2025/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;


  URL2 = 'https://lookerstudio.google.com/embed/reporting/8bd2ed86-2850-42fb-93bb-21f6a3b23d59/page/p_l3gk5vw3td';

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardlandelijk2025/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ge04bat' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Wi01bat' || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpl2022/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2022/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2022/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d23f1242-bb10-4c2b-a3eb-5ea8d4546e86/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/227859df-ead8-4de4-b673-0b588e6af4d0/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/73b32f87-05ba-4cfc-a86f-61e5f6c49498/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7de1277c-0d63-4561-bf66-5686197ce9c3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = '';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a51f0644-e407-4607-aa7f-3457949c491d/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/8a93f35c-6837-4c7d-a3f2-4a82788616aa/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/bc1d8273-ec2f-4cad-9bd0-610143dde6e7/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/cce3c8ec-89da-44f4-8181-ede6d13a00fc/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/84daf255-8372-457a-88dd-2af2da9b7e31/page/HdAuB';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpl2022/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpl2023/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2023/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2023/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/1a24c16b-9291-4c4c-a5c8-b366806c12fc/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ba745149-65b1-4e27-a064-4e5fd9178f08/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/187082b3-997e-4517-b3c3-398b9a396ea5/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9a9e6d93-58ad-4e87-9959-b43a479d5855/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d1dd7b5d-0e59-4428-b629-2d2b89bd5b43/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3af6a11b-6b72-4090-a6e1-122783226eed/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e8498715-ecf8-4eec-85d6-4bc656973184/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2acbf22f-d816-43d0-a710-ab05c8a8a4af/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/07dcfae2-94a5-43e9-bf3e-6321a18edd61/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/07cf442e-6d99-46ea-b888-d503658558a4/page/HdAuB';
    }
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpl2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpl2024/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2024/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2024/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/717aab50-8534-4c07-91ba-0ab49dfe6ff2/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/8a951945-c191-43ef-b82f-8e358da35654/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a9ab088d-475a-4923-9b57-29f3e6b454ec/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e18dedfa-12d1-492a-ba3d-1f50bf218d2a/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/91cc7aec-5390-4fe3-8d44-ecd809501470/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c55e5295-164f-4ff3-8d86-c3bfdbb744b4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/40a09d66-3d3b-42a2-883e-67bf5c5416e3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/50c8caa5-98d9-4fec-9652-4dcb92361f29/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/64ac870b-3fe9-4218-9fbe-da6a52bf35cb/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ad5dbbdc-04c4-4469-83dc-177a7866e4e4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/d06c21e1-96c5-4d82-a74c-5a7840e9febb/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/e209c56d-37c3-4d33-aa28-9680b1a68fd5/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ed3d4f2f-ea61-4c1f-9a72-b8da670bc3e5/page/p_71g62loncd';
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpl2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpl2025/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2025/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2025/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/4497fe28-ba83-40b8-a587-e5e3179f8230/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/cda7018b-a16f-4496-9413-7d4c83d09147/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0ab5a9e5-cbbe-4f9c-b07f-1af98f29c3ac/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/210d888e-dada-4fe2-96d2-3c51d23b9d6c/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ca012afd-e26f-434e-9dc6-6becddb87808/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/016217eb-d203-437b-983e-3c1a65410f04/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/614bacc6-9c4b-44cc-8b97-879896ef7f52/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/23ed7ec2-30d6-4efe-9b0b-668436c322a4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/b4803d1d-20d3-4524-a9d5-b6353843e252/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9b97e9cb-77f4-4287-9344-5888d1ec077d/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/8fd03339-b27c-45f3-9187-bdc33a1408da/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/0cc08e0a-e3d5-4b0c-8718-a233acd6d9f5/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/97b9ce14-b0c5-4d5c-a0f0-f541cd8c2352/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/409b23ad-677e-4611-91bb-0e855812a470/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e57ad6d2-8b26-41f9-915c-cde1f569161f/page/HdAuB';
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpl2025/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpl2026/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2026/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpl2026/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c4a7e545-7fb2-4475-bc71-7404ef5371bd/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6f2d2518-01bb-4e89-816f-976883fae6e3/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c85a6d10-f0ff-4f61-a391-0989faf521a6/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/77003d10-9e8d-4906-b15c-0e929b8aa087/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/68c184cf-04e8-4c89-8f05-40e826bc533c/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/fd93c761-c607-4dfb-a7af-fb3d9692b85d/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ef66781e-8005-4bb1-b810-df8d72f86d67/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f61f0906-a2d6-4efc-bd93-d8b8fdd19ee2/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7e167d10-a723-4ba0-84e1-5721172d4ded/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/7d2e4328-74c9-4749-a002-2c3b0f6f4dcd/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d9238531-8cfe-4179-b080-ecd8abeb6ff9/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f389769b-acd0-47d1-a544-1f7a553772ab/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/a6e9f51b-5b0f-4b5f-a337-ca0fcc6f5330/page/HdAuB';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/00debd05-99f9-4710-8e1b-683b8f76ff84/page/HdAuB';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/897bb443-5ed3-4d55-8258-5ba60520adc2/page/HdAuB';
  } else {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22/page/HdAuB';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpl2026/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpmzwnl2023/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;


  URL2 = 'https://lookerstudio.google.com/embed/reporting/f8988d5b-6c5a-4455-b06d-efa47ecff71f/page/HdAuB';

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpmzwnl2023/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpmzwnl2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardtest/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardtest/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardtest/components/46fd706be85c360dba93a7bd58abf674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    await Backendless.Messaging.sendEmail((String('Helpdesk vraag van ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Helpdesk vraag van:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'<body><br>','Gebruikersnaam:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'<body><br>','Email:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'<body><br>','Centra:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'<body><br>','User role:  ',(await Backendless.UserService.getUserRoles()),'<body><br><br>','Vraag:  ',(getObjectProperty(___arguments.context.pageData, 'email'))].join('')) }), ensureArray('g.mulder@stichtingquestio.nl'), undefined);
  } else {
    await Backendless.Messaging.sendEmail((String('Helpdesk vraag van ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Helpdesk vraag van:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'<body><br>','Gebruikersnaam:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'<body><br>','Email:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'<body><br>','Centra:  ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'<body><br>','User role:  ',(await Backendless.UserService.getUserRoles()),'<body><br><br>','Vraag:  ',(getObjectProperty(___arguments.context.pageData, 'email'))].join('')) }), ensureArray('info@lorio.nl'), undefined);
  }
  await Backendless.Data.of('historiehelpdeskvragen').save( ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'gebruiker': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'helpdeskvraag': (getObjectProperty(___arguments.context.pageData, 'email')) }) );
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardtest/components/ae92877f8dbf6b1158d3f38a354c6c72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Hier kunt u uw vraag stellen, uw naam wordt automatisch meegestuurd met de mail.';
  } else {
    text = 'Hier kunt u uw vraag stellen aan Lorio, uw naam wordt automatisch meegestuurd met de mail.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboardtest/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardvw2023/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardvw2023/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardvw2023/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ba745149-65b1-4e27-a064-4e5fd9178f08/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/61c50c67-0c17-4a38-bd2b-40702053eedb/page/HdAuB';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardvw2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardvw2024/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardvw2024/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardvw2024/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e18dedfa-12d1-492a-ba3d-1f50bf218d2a/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ad5dbbdc-04c4-4469-83dc-177a7866e4e4/page/HdAuB';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ec354681-535d-46e1-a758-be64b7ac2dcc/page/p_8eay2e4qqc';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardvw2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailscoaching/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailscoaching/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailscoaching/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailscoaching/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var E, item, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailscoaching/components/2bc1dd4d90a495b84eb3d23c3378d8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailscoachingnietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailscoachingnietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailscoachingnietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailscoachingnietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailscoachingnietdecl/components/2bc1dd4d90a495b84eb3d23c3378d8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailscoordinatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailscoordinatie/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailscoordinatie/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailscoordinatie/components/1f86d568474452cb5ae726013f990472/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/b1fe72c5f0086956c4d5f89d8403504c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, E, D, C, B, A, K, J, I, H, F;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
  } else {
    A = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    H = 'Korte omschrijving';
    I = 'Doelgroep';
    J = 'Was er sprake van';
    K = 'Quote';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Brabant' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Sichtpunt' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' ? true : false) : false) : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/f043f102f815e4561201b35bac96b17c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/6552ccce4538af9edd4332a3bedc235c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/a0925eba3d84f055a8cd85732e066c74/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/ccb8177234c7ed6e8c4f16f4c079d316/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsult/components/9fdf14d6c69f1e3c2a32a7dec83f15ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsultnietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsgroepsconsultnietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsultnietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsgroepsconsultnietdecl/components/b1fe72c5f0086956c4d5f89d8403504c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsgroepsconsultnietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, E, D, C, B, A, H, F;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsmdopatz/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsmdopatz/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, F, E, D, C, B, A, K, J, I, H;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    F = 'Aantal besproken cliënten';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    H = 'Vervolg nav MDO\\PaTz';
    I = 'Quote';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Brabant' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Sichtpunt' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' ? true : false) : false) : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/15dbc838fc59df037ef233ecd7393238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsmdopatz/components/b146e00674ce45abde71d3cd996545f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/1b4e4be421991ba2307b52f620bba427/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/e62f8cd8d88e3a48360fb19a280c5f9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsmdopatz/components/dc411a74e1a917fe53757a2277c8eb93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsmdopatz/components/2bc182cb826ecf515d1f9519ebb3316f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsmdopatz/components/337cc049d0be47737c87a54718c7aab3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsmdopatznietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsmdopatznietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsmdopatznietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsmdopatznietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsmdopatznietdecl/components/15dbc838fc59df037ef233ecd7393238/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsopbouwinfra/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsopbouwinfra/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsopbouwinfra/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsopbouwinfra/components/da1a24341f6f092949e7d462bb87c389/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsopbouwinfra/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var E, item, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragernietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragernietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragernietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragernietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, H;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragernietdecl/components/45710f181f8b4cc42e8c4ed2575e9ae1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4e2c549e94192faf618d9b2b4688184f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Details registratie ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, F, E, D, C, B, A, K, J, I, H;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    H = 'Actief betrokkenen';
    I = 'Aantal betrokkenen';
    J = 'Besproken thema\'s';
    K = 'Quote';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Sichtpunt' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Brabant' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' ? true : false) : false) : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/45710f181f8b4cc42e8c4ed2575e9ae1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/6c5cdffe8c4769a279bbf3b8ab4ecb4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('changeregistratieconsultinw', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/1a97a8b88dba950c7258193c684ae7ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb2be4196c739a5bccbecff181dd139c'), 'maandakkoord'));

  return (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb2be4196c739a5bccbecff181dd139c'), 'maandakkoord'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/1b52584f78f6916435641044e6cb6be9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/3a72b6e9598ab64fc40399fb03e8258a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/248410e5f63a72e8796ed1bce94a7ade/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/984c18afa277711acb25749f07d5b57d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/4b48c603441add4b44e6066de57df485/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultzorgvragerprofessional/components/55ed3065816547332731920730c1d648/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsregistratieprofessional/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieprofessional/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieprofessional/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieprofessional/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsregistratieprofessional/components/45710f181f8b4cc42e8c4ed2575e9ae1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieprofessionalnietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieprofessionalnietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieprofessionalnietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieprofessionalnietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, E, D, C, B, A, H, F;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsregistratieprofessionalnietdecl/components/45710f181f8b4cc42e8c4ed2575e9ae1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsscholing/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholing/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsscholing/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A, L, K, J, I, M;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
    D = 'Korte omschrijving';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
    G = 'Omschrijving scholing';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    M = 'Organisatie die scholing afneemt';
    I = 'Team/locatie waaraan de scholing wordt gegeven';
    J = 'Doelgroep';
    K = 'Scholingwijze';
    L = 'Quote';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    H = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Brabant' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Sichtpunt' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' ? true : false) : false) : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsscholing/components/82c6c84fd12eaf9fab4bb0f7fec274ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholing/components/a54d2ce1d3c1d1d7a2b570067a57bffd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsscholing/components/84572b8df558db1cff8b0a721d7cb6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsscholing/components/a1f8161b02a5920251fb865f44690416/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholing/components/a79c008e4fece4983dd9989fcfb40ee1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholing/components/e0d4bcb9aae4e69aaa15dfeba52dac8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsscholing/components/f0cbec35aa7a58a1d9f23e445ef15781/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/detailsscholingnietdecl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsscholingnietdecl/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsscholingnietdecl/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsscholingnietdecl/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/detailsscholingnietdecl/components/82c6c84fd12eaf9fab4bb0f7fec274ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailswerkgroep/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailswerkgroep/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailswerkgroep/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailswerkgroep/components/82c6c84fd12eaf9fab4bb0f7fec274ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/detailswerkgroep/components/84572b8df558db1cff8b0a721d7cb6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/2f154579192182af405271bb20bd0886/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Dossier ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),' delen'].join('').toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/5a63aaacb926920c3a6e33bdf2ab4dde/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/bc0daadb215a4b3f99e1fc17adb97635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/9295b93e4a8f9c7be64f72515e6464e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/c60a0aae3d19219375ba4af20a68468d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vrijwilligerstatus, status2, delenaantalvw, delenaantalgv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv')) + 1;
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw'));
    status2 = 'Actief';
  } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv'));
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw')) + 1;
    vrijwilligerstatus = 'Actief';
  }
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  await Backendless.Data.of('Dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`delenaantalgv`]: delenaantalgv,[`delenaantalvw`]: delenaantalvw,[`status`]: status2,[`vrijwilligerstatus`]: vrijwilligerstatus }) );
  await Backendless.Data.of('Dossiers').bulkUpdate( (['objectId=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))),'\''].join('')), ({ [`username`]: [(getObjectProperty(___arguments.context.appData, 'dossierusername')),';',(getObjectProperty(___arguments.context.pageData, 'username'))].join('') }) );
  ___arguments.context.pageData['createddossierdelen'] = (await Backendless.Data.of('dossierdelen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'delenaannaam')),[`gedeelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gedeelddoorusername`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) ));
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossierdelen',[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'createddossierdelen')), 'objectId')) }));
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), ({ [`___class`]: 'dossierdelen',[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'createddossierdelen')), 'objectId')) }));
  await Backendless.Data.of('Users').addRelation((getObjectProperty(___arguments.context.pageData, 'userObjectId')), 'userdossiers', [(getObjectProperty(___arguments.context.appData, 'objectId'))]);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86529b7c523fc8d981d96108da2f5b39', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  await Backendless.Messaging.sendEmailFromTemplate('dossierdelen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naamverzender`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailtext`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')) }), undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/f0b72dbd58f5b117bdc478d11e24d9fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Dossier ',(JSON.parse((___arguments.context.appData['dossier']))),' is nu gedeeld met ',(___arguments.context.pageData['delenaannaam'])].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/eb96d605a02d09ecd5ce7073a3d9c7c9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setProperties(['naam', 'userobjectId', 'organisatie']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'userobjectId')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item, emailgv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  emailgv = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
}


  naam = (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties(['naam', 'GV', 'organisatie', 'userobjectId', 'email', 'username']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`gv`]: (getObjectProperty(item, 'GV')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`email`]: (getObjectProperty(item, 'email')),[`username`]: (getObjectProperty(item, 'username')) });})))[0];
  ___arguments.context.pageData['delenaannaam'] = ([(getObjectProperty(naam, 'value')),' - ',(getObjectProperty(naam, 'organisatie'))].join(''));
  ___arguments.context.pageData['userObjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['username'] = (getObjectProperty(naam, 'username'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d381f77d6a2add84176f93b74cb116f5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2403146da45302b37ff8244677fb94d6', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dossierdelen/components/0941101bb3f45c9d22cb54f9067b5481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['dossierobjectid']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86529b7c523fc8d981d96108da2f5b39', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59bf913e9266044bc34c00b645d9ef51', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'delenaantalvw']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dossierdelen/components/951177b40e874aa13821cacae9712777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['delenaannaam']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/7fde76ba8272c4cbe067a862b3a72059/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'delenaantalgv')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/c511a55405772ad852c757b4b1c31b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalgv'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalgv'));
  ___arguments.context.pageData['delenaantalvw'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalvw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dossierdelen/components/8e47097cb9b5926b8feaf76a4687aa3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/5441b0889d06e6a4ce4b792794d785bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/2f154579192182af405271bb20bd0886/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Dossier ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),' delen'].join('').toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/5a63aaacb926920c3a6e33bdf2ab4dde/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/bc0daadb215a4b3f99e1fc17adb97635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/9295b93e4a8f9c7be64f72515e6464e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/c60a0aae3d19219375ba4af20a68468d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vrijwilligerstatus, status2, delenaantalvw, delenaantalgv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('GV') !== -1) {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv')) + 1;
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw'));
    status2 = 'Actief';
  } else if ((getObjectProperty(___arguments.context.pageData, 'gv')).indexOf('VW') !== -1) {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv'));
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw')) + 1;
    vrijwilligerstatus = 'Actief';
  }
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  await Backendless.Data.of('Dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`delenaantalgv`]: delenaantalgv,[`delenaantalvw`]: delenaantalvw,[`status`]: status2,[`vrijwilligerstatus`]: vrijwilligerstatus,[`username`]: [(getObjectProperty(___arguments.context.appData, 'dossierusername')),';',(getObjectProperty(___arguments.context.pageData, 'username'))].join('') }) );
  ___arguments.context.pageData['createddossierdelen'] = (await Backendless.Data.of('dossierdelen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'delenaannaam')),[`gedeelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gedeelddoorusername`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) ));
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossierdelen',[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'createddossierdelen')), 'objectId')) }));
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), ({ [`___class`]: 'dossierdelen',[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'createddossierdelen')), 'objectId')) }));
  await Backendless.Data.of('Users').addRelation((getObjectProperty(___arguments.context.pageData, 'userObjectId')), 'userdossiers', [(getObjectProperty(___arguments.context.appData, 'objectId'))]);
  if ((getObjectProperty(___arguments.context.pageData, 'delenoverdragen')) == 'overdragen') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      await Backendless.Data.of('Dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`emailgv`]: (getObjectProperty(___arguments.context.pageData, 'emailgv')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }) );
    } else {
      await Backendless.Data.of('Dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`emailgv`]: (getObjectProperty(___arguments.context.pageData, 'emailgv')) }) );
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86529b7c523fc8d981d96108da2f5b39', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  await Backendless.Messaging.sendEmailFromTemplate('dossierdelen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naamverzender`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailtext`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')) }), undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/f0b72dbd58f5b117bdc478d11e24d9fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Dossier ',(JSON.parse((___arguments.context.appData['dossier']))),' is nu gedeeld met ',(___arguments.context.pageData['delenaannaam'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/eb96d605a02d09ecd5ce7073a3d9c7c9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setProperties(['naam', 'organisatie', 'userobjectId']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'userobjectId')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties(['naam', 'GV', 'organisatie', 'userobjectId', 'email', 'username']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`gv`]: (getObjectProperty(item, 'GV')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`email`]: (getObjectProperty(item, 'email')),[`username`]: (getObjectProperty(item, 'username')) });})))[0];
  ___arguments.context.pageData['delenaannaam'] = ([(getObjectProperty(naam, 'value')),' - ',(getObjectProperty(naam, 'organisatie'))].join(''));
  ___arguments.context.pageData['gv'] = (getObjectProperty(naam, 'gv'));
  ___arguments.context.pageData['naam'] = (getObjectProperty(naam, 'value'));
  ___arguments.context.pageData['userObjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['username'] = (getObjectProperty(naam, 'username'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d381f77d6a2add84176f93b74cb116f5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2403146da45302b37ff8244677fb94d6', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/0941101bb3f45c9d22cb54f9067b5481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['dossierobjectid']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86529b7c523fc8d981d96108da2f5b39', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59bf913e9266044bc34c00b645d9ef51', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'delenaantalvw']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/951177b40e874aa13821cacae9712777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['delenaannaam']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/54f2db625c8f662d7dd8cfe6df2cb80d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/8452d738da1d3c153d8d9c42c21e683b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c60a0aae3d19219375ba4af20a68468d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c60a0aae3d19219375ba4af20a68468d', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/86529b7c523fc8d981d96108da2f5b39/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData[''] = (({})['']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/7fde76ba8272c4cbe067a862b3a72059/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['delenaantalgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/c511a55405772ad852c757b4b1c31b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['delenaantalgv'] = (___arguments.context.dataModel['delenaantalgv']);
  ___arguments.context.pageData['delenaantalvw'] = (___arguments.context.dataModel['delenaantalvw']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/42e3bdad749263f444bd6f3a64b60c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelenzorgvrager/components/9acf9c26904600654615bede62697ca5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9793711caa9f3806c50a804a6f6e6cc1', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setRelated(['centra']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dossierstoevoegen/components/d26cf9146e9e4fa102651a6d286a6505/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'consultinw')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('blcreatedossierconsultinw', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierconsultinw', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Consult cliënt';
  } else {
    text = 'Consult aan zorgvrager';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dossierstoevoegen/components/b83f55a40c8461dc1d85eb848c96286c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'consultpro')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierconsultpro', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/6c2cc1688272d7992d4b82aa79fcab4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'groepsconsult')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('blcreatedossiergroepsconsult', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiergroepsconsult', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/c102f23bb88db74943f5e366942b83f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'mdopatz')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('blcreatedossierpatzmdo', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierpatzmdo', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/2f14c3c244f93ab36a9f8819599333b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'scholing')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing-questio', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing-haaglanden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing-brabant', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('blcreatedossierscholing-zhn', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing-zhn', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing-sichtpunt', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierscholing', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/39a403fd2295f36df7a3bf540a23793e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'coaching')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiercoaching', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/90c283c72a16e41b0d3d0f44167f6b92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'coordinatietaken')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiercoordinatietaken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/b71c16e3150fbfed31f74be13782d2f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'opbouwinfra')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossieropbouwinfra', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/d30500f10958b598627755af63285c0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierstoevoegen/components/17d91652c2bb7398bd3f4f0605931b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierstoevoegen/components/61d193e9426d2261906e843fc356174a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'werkgroep')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierwerkgroep', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/8a8a0477f004d5ab11264c1523936abe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'raadvanadvies')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierraadvanadvies', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/7d05b09eab8ef41fa8f7fcf81b8de502/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'setopjeplek')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossieropjeplek', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/c24580de8a992f95ea9edd5cf0de7eb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/f1bc6f849cb15f1f51cbfabb1bc56ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/f3ea4d21caebf2d63e942b8d5e5e4c81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gebiedsverantwoordelijke')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatorschap', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierstoevoegen/components/3551b6b16d9e065fadbf1e22e8251f19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiernpzf', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dossierstoevoegen/components/bbb1f374abf2cc5a30ef8042718ee94a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiertriage', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'triage')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b726eab8078816d8f848b24a473497a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var count, j, item, userlistfactuurnummers, userslist, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function factuurnummers_aanmaken_per_maand() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummersnew','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslistfactuurnummers: ') + String(userlistfactuurnummers));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringvws = \'Ja\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringsubsidie = \'fonds buiten VWS\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringsubsidie = \'Vrijwilliger\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  console.log(String('userslist: ') + String(userslist));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      count = (await Backendless.Data.of('factuurnummersnew').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join('')))));
      if (count == 0) {
        await Backendless.Data.of('factuurnummersnew').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: j,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: 1 }) );
      } else {
        count = (await asyncListSort((await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',j,'\''].join(''))).setProperties('nummer').setSortBy('nummer DESC').setPageSize(10))), -1, async (item) => {


         return (getObjectProperty(item, 'nummer'));
        }))[0];
        await Backendless.Data.of('factuurnummersnew').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: j,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`nummer`]: (getObjectProperty(count, 'nummer')) + 1 }) );
      }
    }
  }
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  await factuurnummers_aanmaken_per_maand();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'factuurafdrukken', 'organisatie', 'gebruiker']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b726eab8078816d8f848b24a473497a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'factuurafdrukken', 'organisatie', 'gebruiker']).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await userstoevoegenfactuurnummers();
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'Brabant\' OR ','centraname=\'Gelderland\' OR ','centraname=\'Willem\' OR ','centraname=\'ZHN\' OR ','centraname=\'Rotterdam\' OR','centraname=\'Utrecht\' OR','centraname=\'Overijssel\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}

/**
 * Describe this function...
 */
async function do_something2() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'groupBy': 'maand,username','properties': ['maand', 'username'] })));
  (function (message) { alert(message) })('Klaar voor gebruik');
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['factdatum'] = (getObjectProperty(___arguments.context.appData, 'factdatum'));
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'factuurafdrukken', 'organisatie', 'gebruiker']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukken/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',name2,' is akkoord bevonden om te factureren\'.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b726eab8078816d8f848b24a473497a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b726eab8078816d8f848b24a473497a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b726eab8078816d8f848b24a473497a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('algemeen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else {
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.appData['factgebruiker'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'gebruiker'));
    await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ [`factuurafdrukken`]: 1 }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Brabant') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenbrabant', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Gelderland') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Willem') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Lorio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Sichtpunt') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkensichtpunt', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenzhn', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Rotterdam') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenrotterdam', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Utrecht') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenutrecht', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Overijssel') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenoverijssel', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'factuurafdrukken')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/0e64daba1d0d27217adf2e671dac16bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ [`factuurafdrukken`]: 0 }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'factuurafdrukken', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_48, my_47, my_46, my_45, my_44, my_43, my_42, my_41, my_40, my_39, my_38, my_37, my_36, my_35, my_34, my_33, my_32, my_31, my_30, my_29, my_28, my_27, my_26, my_25, my_24, my_23, my_22, my_21, my_20, my_19, my_18, my_17, my_16, my_15, my_14, my_13, my_12, my_11, my_10, my_9, my_8, my_7, my_6, my_5, my_4, my_3, my_2, my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2022') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2022') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2022') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2022') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2022') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2022') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2022') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2022') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2022') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2022') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2022') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2022') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2023') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2023') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2023') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2023') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2023') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2023') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2023') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2023') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2023') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2023') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2023') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2023') {
    my_24 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2024') {
    my_25 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2024') {
    my_26 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2024') {
    my_27 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2024') {
    my_28 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2024') {
    my_29 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2024') {
    my_30 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2024') {
    my_31 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2024') {
    my_32 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2024') {
    my_33 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2024') {
    my_34 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2024') {
    my_35 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2024') {
    my_36 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2025') {
    my_37 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2025') {
    my_38 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2025') {
    my_39 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2025') {
    my_40 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2025') {
    my_41 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2025') {
    my_42 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2025') {
    my_43 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2025') {
    my_44 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2025') {
    my_45 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2025') {
    my_46 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2025') {
    my_47 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2025') {
    my_48 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ [`F202201`]: my_1,[`F202202`]: my_2,[`F202203`]: my_3,[`F202204`]: my_4,[`F202205`]: my_5,[`F202206`]: my_6,[`F202207`]: my_7,[`F202208`]: my_8,[`F202209`]: my_9,[`F202210`]: my_10,[`F202211`]: my_11,[`F202212`]: my_12,[`F202301`]: my_13,[`F202302`]: my_14,[`F202303`]: my_15,[`F202304`]: my_16,[`F202305`]: my_17,[`F202306`]: my_18,[`F202307`]: my_19,[`F202308`]: my_20,[`F202309`]: my_21,[`F202310`]: my_22,[`F202311`]: my_23,[`F202312`]: my_24,[`F202401`]: my_25,[`F202402`]: my_26,[`F202403`]: my_27,[`F202404`]: my_28,[`F202405`]: my_29,[`F202406`]: my_30,[`F202407`]: my_31,[`F202408`]: my_32,[`F202409`]: my_33,[`F202410`]: my_34,[`F202411`]: my_35,[`F202412`]: my_36,[`F202501`]: my_37,[`F202502`]: my_38,[`F202503`]: my_39,[`F202504`]: my_40,[`F202505`]: my_41,[`F202506`]: my_42,[`F202507`]: my_43,[`F202508`]: my_44,[`F202509`]: my_45,[`F202510`]: my_46,[`F202511`]: my_47,[`F202512`]: my_48 }) );
}

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukken/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;
  ___arguments.context.pageData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/60081e887478d278366872189d59fa68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['INVOICE'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('955e4a7a685b65ff32b4a7771f66c1d9', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  await new Promise(r => setTimeout(r, 3000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause('centra=\'Brabant\' ').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['inclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e9e78f43490c3e43773e924c6b2595be'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12c650072da1350d8705307803356d3e', false);
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('955e4a7a685b65ff32b4a7771f66c1d9', false);
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabant/components/99f8db95841e88b1cd34cb4d67ff7df7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202501'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202502'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202503'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202504'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202505'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202506'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202507'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202508'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202509'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202510'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202511'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202512'));
  }
  ___arguments.context.pageData['result'] = result;
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'','Brabant','\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await userstoevoegenfactuurnummers();
  ___arguments.context.pageData['factdatum'] = (getObjectProperty(___arguments.context.appData, 'factdatum'));
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'','Brabant','\''].join('')),'groupBy': 'maand,username','properties': ['maand', 'username'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',name2,' is akkoord bevonden om te factureren\'.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Brabant','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('algemeen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else if (false) {
  } else {
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenbrabant', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/0e64daba1d0d27217adf2e671dac16bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 0 }) );
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_1, my_10, my_11, my_12, my_13, my_14, my_15, my_16, my_17, my_18, my_19, my_2, my_20, my_21, my_22, my_23, my_24, my_25, my_26, my_27, my_28, my_29, my_3, my_30, my_31, my_32, my_33, my_34, my_35, my_36, my_4, my_5, my_6, my_7, my_8, my_9;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2022') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2022') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2022') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2022') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2022') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2022') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2022') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2022') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2022') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2022') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2022') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2022') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2023') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2023') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2023') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2023') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2023') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2023') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2023') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2023') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2023') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2023') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2023') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2023') {
    my_24 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2024') {
    my_25 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2024') {
    my_26 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2024') {
    my_27 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2024') {
    my_28 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2024') {
    my_29 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2024') {
    my_30 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2024') {
    my_31 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2024') {
    my_32 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2024') {
    my_33 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2024') {
    my_34 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2024') {
    my_35 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2024') {
    my_36 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ [`F202201`]: my_1,[`F202202`]: my_2,[`F202203`]: my_3,[`F202204`]: my_4,[`F202205`]: my_5,[`F202206`]: my_6,[`F202207`]: my_7,[`F202208`]: my_8,[`F202209`]: my_9,[`F202210`]: my_10,[`F202211`]: my_11,[`F202212`]: my_12,[`F202301`]: my_13,[`F202302`]: my_14,[`F202303`]: my_15,[`F202304`]: my_16,[`F202305`]: my_17,[`F202306`]: my_18,[`F202307`]: my_19,[`F202308`]: my_20,[`F202309`]: my_21,[`F202310`]: my_22,[`F202311`]: my_23,[`F202312`]: my_24,[`F202401`]: my_25,[`F202402`]: my_26,[`F202403`]: my_27,[`F202404`]: my_28,[`F202405`]: my_29,[`F202406`]: my_30,[`F202407`]: my_31,[`F202408`]: my_32,[`F202409`]: my_33,[`F202410`]: my_34,[`F202411`]: my_35,[`F202412`]: my_36 }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenbrabantstart/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b1680c389959949ab0740f5e3c981cd9', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('78240a86a431a7c375794c97ee58cbdc', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b6de4b95fed457df64ec3cba4774057', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7bd57e13fc5666a6c4ff5f665dd3e63', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND vrijwilligervergoedingov >0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(vrijwilligervergoedingov) as gewminutenexbtw', 'maand']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ef0da80458abe1976495de9ec19e41', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND vrijwilligervergoedingov >0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(vrijwilligervergoedingov) as gewminutenexbtw', 'maand']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'vrijwilligervergoedingexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'postcode')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl.lorio.nl/api/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['inclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e9e78f43490c3e43773e924c6b2595be'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/1b146b8cdb382a8ca4ff8acd87f9add7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202301'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202302'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202303'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202304'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202305'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202306'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202307'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202308'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202309'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202310'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202311'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202312'));
  }
  ___arguments.context.pageData['result'] = result;

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/43cd2f532abe62f470a47e121592fc0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/49ed9f1cc29cedfcec31d91a98ed21f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'extra')) == false ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/e3432bc4c2dfc4a5ce4d306ef7ea590e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie')) == null) {
    ___arguments.context.pageData['extra'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49ed9f1cc29cedfcec31d91a98ed21f2', false);
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie'));
    ___arguments.context.pageData['extra'] = true;
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text, display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    display = true;
  } else {
    display = false;
  }
  ___arguments.context.pageData['display'] = display;

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/4035a5a714bea6feb32f4eef070eb2e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b5bf3505937dbcad94080a41b1115ec3'), 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/0b6de4b95fed457df64ec3cba4774057/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'display'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/5cb8a4dfbdad68c3437aefb3f214a7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15b56b5439adc28bffdea7e4e758ece5'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/d7bd57e13fc5666a6c4ff5f665dd3e63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d7bd57e13fc5666a6c4ff5f665dd3e63')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/15b56b5439adc28bffdea7e4e758ece5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/1a8b936f285c4c7fe8bc807b5cf70929/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['vrijwilligervergoedingexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b6de4b95fed457df64ec3cba4774057', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b1680c389959949ab0740f5e3c981cd9', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('78240a86a431a7c375794c97ee58cbdc', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b6de4b95fed457df64ec3cba4774057', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7bd57e13fc5666a6c4ff5f665dd3e63', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND vrijwilligervergoedingov >0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(vrijwilligervergoedingov) as gewminutenexbtw', 'maand']).setPageSize(100))));
  if ((getObjectProperty(___arguments.context.appData, 'factgebruiker')) == 'vrijwilliger') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0 AND activiteit=\'Scholing\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw<>0 AND activiteit=\'Scholing\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw) as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw) as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ef0da80458abe1976495de9ec19e41', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND vrijwilligervergoedingov >0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(vrijwilligervergoedingov) as gewminutenexbtw', 'maand']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 4000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`factuurnummer`]: null }) );
}

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'vrijwilligervergoedingexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'postcode')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl.lorio.nl/api/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['inclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e9e78f43490c3e43773e924c6b2595be'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/1b146b8cdb382a8ca4ff8acd87f9add7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202501'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202502'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202503'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202504'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202505'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202506'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202507'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202508'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202509'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202510'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202511'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202512'));
  }
  ___arguments.context.pageData['result'] = result;
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/43cd2f532abe62f470a47e121592fc0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/49ed9f1cc29cedfcec31d91a98ed21f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'extra')) == false ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/e3432bc4c2dfc4a5ce4d306ef7ea590e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie')) == null) {
    ___arguments.context.pageData['extra'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49ed9f1cc29cedfcec31d91a98ed21f2', false);
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie'));
    ___arguments.context.pageData['extra'] = true;
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    display = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Kwitantie') {
    display = false;
  }
  ___arguments.context.pageData['display'] = display;

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/4035a5a714bea6feb32f4eef070eb2e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b5bf3505937dbcad94080a41b1115ec3'), 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/5cb8a4dfbdad68c3437aefb3f214a7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15b56b5439adc28bffdea7e4e758ece5'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/d7bd57e13fc5666a6c4ff5f665dd3e63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d7bd57e13fc5666a6c4ff5f665dd3e63')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/15b56b5439adc28bffdea7e4e758ece5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/1a8b936f285c4c7fe8bc807b5cf70929/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['vrijwilligervergoedingexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/e687afe602ef056a13211b0aca64d191/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkengelderland2024/components/0b6de4b95fed457df64ec3cba4774057/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'display'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('centra').setSortBy('centra ASC').setGroupBy('centra').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centra')),[`label`]: (getObjectProperty(item, 'centra')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'','Questio','\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await userstoevoegenfactuurnummers();
  ___arguments.context.appData['factuurnummer'] = null;
  ___arguments.context.appData['factdatum'] = null;
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'','Questio','\''].join('')),'groupBy': 'maand,username','properties': ['maand', 'username'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',name2,' is akkoord bevonden om te factureren\'.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('algemeen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else if ((getObjectProperty(___arguments.context.appData, 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Vul eerst het factuurnummer in.');
  } else {
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
    if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenquestio', undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Brabant') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenbrabant', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Gelderland') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Willem') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Lorio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkengelderland2024', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Sichtpunt') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkensichtpunt', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/0e64daba1d0d27217adf2e671dac16bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 0 }) );
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_1, my_10, my_11, my_12, my_13, my_14, my_15, my_16, my_17, my_18, my_19, my_2, my_20, my_21, my_22, my_23, my_24, my_3, my_4, my_5, my_6, my_7, my_8, my_9;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2022') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2022') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2022') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2022') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2022') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2022') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2022') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2022') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2022') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2022') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2022') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2022') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2023') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2023') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2023') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2023') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2023') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2023') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2023') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2023') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2023') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2023') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2023') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2023') {
    my_24 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ 'F202201': my_1,'F202202': my_2,'F202203': my_3,'F202204': my_4,'F202205': my_5,'F202206': my_6,'F202207': my_7,'F202208': my_8,'F202209': my_9,'F202210': my_10,'F202211': my_11,'F202212': my_12,'F202301': my_13,'F202302': my_14,'F202303': my_15,'F202304': my_16,'F202305': my_17,'F202306': my_18,'F202307': my_19,'F202308': my_20,'F202309': my_21,'F202310': my_22,'F202311': my_23,'F202312': my_24 }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/6024b3958925f986ba2d34af4d03d3e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factuurnummer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenlorio/components/b99df8ace718dcb694ce445c3545b255/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b1680c389959949ab0740f5e3c981cd9', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('78240a86a431a7c375794c97ee58cbdc', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0b6de4b95fed457df64ec3cba4774057', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclwerkenvoorminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw) as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclwerkenvoorminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw) as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\' AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.appData, 'filterfinanciering')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkennietdeclarabelstart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty(___arguments.context.appData, 'factcentra')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('18c832e4baccdbdbaa14163e57bdc77a'), 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'postcode')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl.lorio.nl/api/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['inclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e9e78f43490c3e43773e924c6b2595be'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/1b146b8cdb382a8ca4ff8acd87f9add7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202301'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202302'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202303'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202304'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202305'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202306'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202307'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202308'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202309'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202310'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202311'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2023') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202312'));
  }
  ___arguments.context.pageData['result'] = result;

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('17b820e59b5a1498f9bddf1b10c59baf'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/43cd2f532abe62f470a47e121592fc0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/49ed9f1cc29cedfcec31d91a98ed21f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'extra')) == false ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/e3432bc4c2dfc4a5ce4d306ef7ea590e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie')) == null) {
    ___arguments.context.pageData['extra'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49ed9f1cc29cedfcec31d91a98ed21f2', false);
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('49ed9f1cc29cedfcec31d91a98ed21f2'), 'extrainformatie'));
    ___arguments.context.pageData['extra'] = true;
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text, display;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    display = true;
  } else {
    display = false;
  }
  ___arguments.context.pageData['display'] = display;

  return (getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/4035a5a714bea6feb32f4eef070eb2e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b5bf3505937dbcad94080a41b1115ec3'), 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/0b6de4b95fed457df64ec3cba4774057/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'display'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/5cb8a4dfbdad68c3437aefb3f214a7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15b56b5439adc28bffdea7e4e758ece5'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/d7bd57e13fc5666a6c4ff5f665dd3e63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d7bd57e13fc5666a6c4ff5f665dd3e63')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/15b56b5439adc28bffdea7e4e758ece5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/1a8b936f285c4c7fe8bc807b5cf70929/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['vrijwilligervergoedingexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewminutenexbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabel/components/d2e78f6230d2d50cb9a638bd4cf18f4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'filterfinanciering'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await userstoevoegenfactuurnummers();
  ___arguments.context.pageData['factdatum'] = (getObjectProperty(___arguments.context.appData, 'factdatum'));
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['filterfinanciering'] = (getObjectProperty(___arguments.context.appData, 'filterfinanciering'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'groupBy': 'maand,username','properties': ['maand', 'username'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'filterfinanciering')) == null) {
    (function (message) { alert(message) })('Vul eerst de financiering in.');
  } else {
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.appData['filterfinanciering'] = (getObjectProperty(___arguments.context.pageData, 'filterfinanciering'));
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkennietdeclarabel', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 0 }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_24, my_23, my_22, my_21, my_20, my_19, my_18, my_17, my_16, my_15, my_14, my_13, my_12, my_11, my_10, my_9, my_8, my_7, my_6, my_5, my_4, my_3, my_2, my_1, my_36, my_35, my_34, my_33, my_32, my_31, my_30, my_29, my_28, my_27, my_26, my_25;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2022') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2022') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2022') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2022') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2022') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2022') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2022') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2022') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2022') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2022') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2022') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2022') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2023') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2023') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2023') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2023') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2023') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2023') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2023') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2023') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2023') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2023') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2023') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2023') {
    my_24 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2024') {
    my_25 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2024') {
    my_26 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2024') {
    my_27 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2024') {
    my_28 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2024') {
    my_29 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2024') {
    my_30 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2024') {
    my_31 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2024') {
    my_32 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2024') {
    my_33 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2024') {
    my_34 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2024') {
    my_35 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2024') {
    my_36 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ [`F202201`]: my_1,[`F202202`]: my_2,[`F202203`]: my_3,[`F202204`]: my_4,[`F202205`]: my_5,[`F202206`]: my_6,[`F202207`]: my_7,[`F202208`]: my_8,[`F202209`]: my_9,[`F202210`]: my_10,[`F202211`]: my_11,[`F202212`]: my_12,[`F202301`]: my_13,[`F202302`]: my_14,[`F202303`]: my_15,[`F202304`]: my_16,[`F202305`]: my_17,[`F202306`]: my_18,[`F202307`]: my_19,[`F202308`]: my_20,[`F202309`]: my_21,[`F202310`]: my_22,[`F202311`]: my_23,[`F202312`]: my_24,[`F202401`]: my_25,[`F202402`]: my_26,[`F202403`]: my_27,[`F202404`]: my_28,[`F202405`]: my_29,[`F202406`]: my_30,[`F202407`]: my_31,[`F202408`]: my_32,[`F202409`]: my_33,[`F202410`]: my_34,[`F202411`]: my_35,[`F202412`]: my_36 }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;
  ___arguments.context.pageData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkennietdeclarabelstart/components/3cf5c48a1d867ff53a7b924243c40779/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('financieringstroom').setSortBy('financieringstroom ASC').setGroupBy('financieringstroom').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'financieringstroom')),[`label`]: (getObjectProperty(item, 'financieringstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND financieringstroom=\'',(getObjectProperty(___arguments.context.pageData, 'filterfinanciering')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var copy, factuurnummer, item, factuurkwitantie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function factuurkwitantie2() {
  factuurkwitantie = (await Promise.all((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('factuurkwitantie').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'factuurkwitantie')) });})))[0];
  ___arguments.context.pageData['factuurkwitantie'] = (getObjectProperty(factuurkwitantie, 'value'));
  factuurnummer = (await Promise.all((await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'factuurnummer')) });})))[0];
  ___arguments.context.pageData['factuurnummer'] = (getObjectProperty(factuurnummer, 'value'));
  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'factuurnummer'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'true';
  ___arguments.context.pageData['maandselectie'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['VIEW'] = 'true';
  await factuurkwitantie2();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19f56ebe1df7204b9ebfa357c5b8d50b', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fd4bd8f97574ef1644f16db86ebbdcb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw) as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 2000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f14f8f2f8b9175332287b88fcd6df2fa')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['exclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/04aad222b0dfd884950345cde4229a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy, factuurkwitantie, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/fd4bd8f97574ef1644f16db86ebbdcb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/095200e6fd1535ef2d0814fb392433f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/1b6e497830ccbe74e7d729ced87e88e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/9297f9c5fa6f1c7ba93f411d75498bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/e8eee9e75e6a99790e51277c966abeef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/a32b24d873b8e9b860b8bd48fb020068/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/df869ff32605f5a8e41a57189a2b1a51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy, factuurkwitantie, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['factuurnummer'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));
  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurkwitantie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/f9ff1b481f32e5cdb7382358faacb158/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenoverijssel/components/439804fe01f87c0859ffc6581d38ff2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
    await format();
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['INVOICE'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringsubsidie=\'','VWS','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'filterusername')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenquestiostart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/0f6f5d12a49dcee86098c5b309eab404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1iHIBKgnHvpIUXq9BjhO9rtF1W1T8I7xT/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/d56d9182ba1e1f2893a6f32a3277f921/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = 'Consult cliënt';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var btwplichtig, item, list, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwplichtig = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwplichtig').setPageSize(10))).map(async btwplichtig => {; return ({ 'btwplichtig': (getObjectProperty(btwplichtig, 'btwplichtig')) });})))[0];
  if ((getObjectProperty(btwplichtig, 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text, btwplichtig;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwplichtig = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwplichtig').setPageSize(10))).map(async btwplichtig => {; return ({ 'btwplichtig': (getObjectProperty(btwplichtig, 'btwplichtig')) });})))[0];
  if ((getObjectProperty(btwplichtig, 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var btwinclscholing, btwplichtig, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwplichtig = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwplichtig').setPageSize(10))).map(async btwplichtig => {; return ({ 'btwplichtig': (getObjectProperty(btwplichtig, 'btwplichtig')) });})))[0];
  btwinclscholing = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwinclscholing').setPageSize(10))).map(async btwinclscholing => {; return ({ 'btwplichtig': (getObjectProperty(btwinclscholing, 'btwinclscholing')) });})))[0];
  if ((getObjectProperty(btwplichtig, 'btwplichtig')) == true && (getObjectProperty(btwinclscholing, 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text, btwinclscholing, btwplichtig;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  btwplichtig = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwplichtig').setPageSize(10)));
  btwinclscholing = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('btwinclscholing').setPageSize(10)));
  if (btwplichtig == true && btwinclscholing == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestio/components/1b146b8cdb382a8ca4ff8acd87f9add7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'','Questio','\''].join('')),'groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await userstoevoegenfactuurnummers();
  ___arguments.context.appData['factuurnummer'] = null;
  ___arguments.context.appData['factdatum'] = null;
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'','Questio','\''].join('')),'groupBy': 'maand,username','properties': ['maand', 'username'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',name2,' is akkoord bevonden om te factureren\'.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'','Questio','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('algemeen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
    (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
  } else if ((getObjectProperty(___arguments.context.appData, 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Vul eerst het factuurnummer in.');
  } else {
    ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
    ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.appData['factcentra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenquestio', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/0e64daba1d0d27217adf2e671dac16bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 0 }) );
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_1, my_10, my_11, my_12, my_13, my_14, my_15, my_16, my_17, my_18, my_19, my_2, my_20, my_21, my_22, my_23, my_24, my_3, my_4, my_5, my_6, my_7, my_8, my_9;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2022') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2022') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2022') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2022') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2022') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2022') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2022') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2022') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2022') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2022') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2022') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2022') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '1-2023') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '2-2023') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '3-2023') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '4-2023') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '5-2023') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '6-2023') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '7-2023') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '8-2023') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '9-2023') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '10-2023') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '11-2023') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maand')) == '12-2023') {
    my_24 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ 'F202201': my_1,'F202202': my_2,'F202203': my_3,'F202204': my_4,'F202205': my_5,'F202206': my_6,'F202207': my_7,'F202208': my_8,'F202209': my_9,'F202210': my_10,'F202211': my_11,'F202212': my_12,'F202301': my_13,'F202302': my_14,'F202303': my_15,'F202304': my_16,'F202305': my_17,'F202306': my_18,'F202307': my_19,'F202308': my_20,'F202309': my_21,'F202310': my_22,'F202311': my_23,'F202312': my_24 }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenquestiostart/components/6024b3958925f986ba2d34af4d03d3e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.appData['factuurnummer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('180e83cdeb3cd7c5c14b0b5d462804b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fda7052fe1d1f8b2236fda9c7b01de97', true);
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['INVOICE'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['maandselectie'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('484793826f8c07d194efef09905bc219', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be15fdb6b73c905a1f3bf006a23d5c97', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut', 'financieringsubsidie']).setSortBy('activiteit').setGroupBy('activiteit, financieringsubsidie').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0303a567855b9ae6678e79418ce5458e', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5cf7b86f419849c30fc112ce9b596fa6', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('777912f371e2e0421302f306ce78cb89', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b765eb6f0122d899a5b5cc54dfc1acbf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a7afa58d1b7d798de78a6d2013fb2d7', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Ja\'','OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c394869d5ff3e7c278e20686c4f648c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'gewerkteminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('71c950e80329614b1a08b835af5ce26d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\' AND mdopatzsoortoverleg=\'PaTz groep\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('acef241494a91a63d523820c7955de2c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\' AND mdopatzsoortoverleg=\'MDO\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fbc69b7d949306365bcabed8ce05c319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\'','OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f11dff78bb94658555cda631b48ee96', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fdffe5223e9abeae0b17217a9584e73d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('284b366eb8b312dd89c2887935817fb6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a349402bfd6237db389129954ab1a9c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' '].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('615f8805a5749e5f2a5d8e93a845e0a3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('622c994a7c58345f82f69ac66cb39a53', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('245bd7a4191728768474579a4c1e1a9c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('619d951fd09bc4793c4c3781249aa3e4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('204c448c0256f419e016d44d22b77a9d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\' OR ','username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0c06d7cd18ad9e67f3cd42242bd9930e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41ff3b7eb7814efcaa213ee25cc3e0a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04b64dc468ea8e19de7a5d02e73a2d26', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('204c448c0256f419e016d44d22b77a9d', true);
  await new Promise(r => setTimeout(r, 4000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`factuurnummer`]: null }) );
}

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/2a3744db2d39a0f38f84e47f709197e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/558ccb4b347138b388b8b2dfc6356695/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/c6e9635c891c6e3a70ea9085f57a7eea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/750930777078a42df5085041102b681e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/32ace18c06537d180831f9d3f41d9011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/53bb7d1ffd09e90de2cf3305621eaba9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/c24371ee5c657c7d9e6c0b06d451506d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/0c9ba9c76382ef54dc295ea49e26dd79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/ad6ba834d83f6cba2da6b15d7fc2ab74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/281f88b92af464964dfadfa9162cb1ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f5d565a585ef73d58e1fb2291cdef67f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8f5db1aa67fcf5373083509802720339/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/19fb3f1f2737ba682c7f2ae77c1e024a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/7dde52a604e4a2d1f599d2e7123887a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/a95c06fb4598e88ee499e44267094449/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/0644c44f03fceebabf8f8b72ade2d59f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/687456a8575fe93e48030c5ebcc92d12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/3983c66d42ec4ad9f1983c5785fd7dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/e246f231300ee74bc938be16aa483186/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/531cde561f3da025bd595e751c27d602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/520359e4c7f80e16756716b22c9cabd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8ebe1325253434d76d134261271f94fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/ff8cc9c670c162bbeb4dbea1b1f644c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length && !((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c394869d5ff3e7c278e20686c4f648c4')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length && !((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c394869d5ff3e7c278e20686c4f648c4')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/9224658f241147fae6d81af813a47afd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/0c06d7cd18ad9e67f3cd42242bd9930e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6c2b3cc697da3b7aed1e0ae5dcdc47bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8f11dff78bb94658555cda631b48ee96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/210a4446cc8dd5f7c0c6dc8516aff91a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/41ff3b7eb7814efcaa213ee25cc3e0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/71c950e80329614b1a08b835af5ce26d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/fdffe5223e9abeae0b17217a9584e73d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f6fe3b1944e975553fb1fbb9863b1d24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/04b64dc468ea8e19de7a5d02e73a2d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/fbc69b7d949306365bcabed8ce05c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/284b366eb8b312dd89c2887935817fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/521b455fb2640a8fe6e4359106c3eead/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/a349402bfd6237db389129954ab1a9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/aa289e34a6c3e6a1925fb57fbee1f563/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/d739b42d4073b8177a76efbebb7ba67b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/b7d5973296be117105521ddd0001fb54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f761aa41091454bf728bcc1312699991/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  oud = [(Backendless.appPath),'/files/logos/',(getObjectProperty(___arguments.context.appData, 'factusername')),'.jpg'].join('');
}

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/cb789b94fd7e4c3217e86ba9f8dc2df6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/e32b522d24f79d2c7f56687f01dff468/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/16498df1282374434642494414e4cada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('470e746de35b7249acc433d69f6f8ea3'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/d01c35d25ae6a39568984d6157c553a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7ee3bdf64ee3171075c6467c56571af'), 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6ab891ed58f47a7a5531f06288ae1c26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/41f537e9747b0577bdee2abc25b6c635/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/615f8805a5749e5f2a5d8e93a845e0a3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('615f8805a5749e5f2a5d8e93a845e0a3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
}

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/a72bdcacd71e91daa1e1243fa0c1285f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f42b3be9ce887083b81e7712d641ecc'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/0df6a9a2373468971022f78f561637c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c6bb8d997636ba843ff17f10319aa68'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/ca2226b7963c5258aa68311661a893e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18b599ee2d786077920712e57597f1a3'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8ecaf544e2f34556c487683a5f9ddd5d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/72dbfe0bd02da9fe25324d8da3fd5439/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/395efac6a9320919644299ef79f253ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/5c4c6d02601e586571913a63643f8721/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/965edb0c0c5456bdaba28cbc73d9be71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/28f4266b7c0fb07a2c779e9f8511ed0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/c20795538be3991ac1223d9bb0249b09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/204c448c0256f419e016d44d22b77a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('204c448c0256f419e016d44d22b77a9d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
}

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/e3089d6c4e2393cdf9e5e868b1c47abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/60ba84733abcbc2a857f13b68cc1f8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/f7db815535632651395b977afb7c5f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/478366811545b5a987097c16d0d17abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'activiteit')) + String(' (fonds buiten VWS)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/ba1cbf9aa95b116b55ad2f1c0f19521e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/338ca7f65319001d56120b6e901c3208/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/c2b14d751e4e1343e53ba033a2dfd07b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/b3bfc9d65652b6155dad62e62a35cb2b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/5571a42fac7ba4acdaeca4a2fc119547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'activiteit')) + String(' (fonds buiten VWS)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/a70a134cfbd71d33cf64df1eceea2bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/36d56e995383437dc31d21085cd85991/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/cb667cb61f25fc8538a8bee9e6494f98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/5cf7b86f419849c30fc112ce9b596fa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/52a90a68a2e7159c2456ef7d018abf64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/46cb912615c4978418d669e9c62f2aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/8b0bf121471ffe59c6c435a750bf82cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/41be301c7d1f76d6532346c3744e64fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/6d47c9c85e980ba528288038f5de29e6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202501'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202502'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202503'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202504'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202505'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202506'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202507'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202508'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202509'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202510'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202511'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202512'));
  }
  ___arguments.context.pageData['result'] = result;
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/0b5840b194cad1280a5db9b8058b7a68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/2c98751fbd0835783e03b6c45a78fe8e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2c98751fbd0835783e03b6c45a78fe8e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND extrainformatie is not null'].join(''))))) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenrotterdam/components/644a27f8f874c808c2a8c7c866a7a2db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND totaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND created> \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/92aaccb79c1f35081c53a0a64f8ca4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/e0018c759e4e72b5481ab4f219b89b19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1hcvKLF7EBy9f-_K2iGSHK_Ol_zwDdAoG/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/ec03c4d9109502bf844fed64d7aeaea5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkensichtpunt/components/b5482ac8dbcbb3a95867a7c6c9bed426/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factusername'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var copy, factuurnummer, item, factuurkwitantie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function factuurkwitantie2() {
  factuurkwitantie = (await Promise.all((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setProperties('factuurkwitantie').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'factuurkwitantie')) });})))[0];
  ___arguments.context.pageData['factuurkwitantie'] = (getObjectProperty(factuurkwitantie, 'value'));
  factuurnummer = (await Promise.all((await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'factuurnummer')) });})))[0];
  ___arguments.context.pageData['factuurnummer'] = (getObjectProperty(factuurnummer, 'value'));
  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'factuurnummer'))].join('');
  } else {
    copy = ['Kwitantie ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['INVOICE'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
  ___arguments.context.pageData['maandselectie'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  ___arguments.context.pageData['VIEW'] = 'true';
  await factuurkwitantie2();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b8488828007898f8ff084854a73872ed', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4ca26abcfafe7674c0b871a41f5e1236', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e903aa8b144d3403f2b66c68f005028f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca859ee97f3aef1a25bc397f60bfb51a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c9c6698e4e433219949d06668891fb66', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('82be34524fd2f216490eafd22e8fa6d9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e13c93811b1afd450c5803a723e64b1d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d82202582be52335bf5742975df110ce', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5eab13b3e05c73b687aa70a394b256d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('996f0daaf56e482640b4f3c73a9f5be4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('96affb6754fbd3692af50c5b222a44d3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('501dedb70fa1b26f3f19ca4e25328472', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31b33654aae3112db1d8d5326a5ac571', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ce722455663ab75aa9a81eed3c3ed85', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('132d54612ebe10b3a12985e66923fde7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddbc115796bdf0d9859c529d7ec38696', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11633fede17bb80b6e2622ac157b9bb9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c5c6c846ab7db55c098ed67efc68d84d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2ea687d52b0c7fc638992a98c692b787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('26d3db2487dd14b2d8d569c2bb0f4837', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 2000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f329285a6c5f9b17cd26a38cfabbd09c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a519e519fdac0038e6e7a6051af808c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe2d81d8b588959792e536bf5bbac835', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68610e87996e08eb4069b8926e5b9449', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9cd3acc36abf15e6be38c169b9d7a45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b6a418c5ddbaf36a10167f48467c107', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efb07a26849937d5c5e0a31b2be75cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a278bf9851ed39d7f7392ffc4bd86cf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4caf7b21f3621bef4a84729ffaa68c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('167398eb5217c71350bbef3ad2179244', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51855a06ccb9d241ded789898e2af82c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dba812d37c6f2deb4cef49258e1c9bf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f188db4dfbf9bc42864c0e5ee06acd11', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e903aa8b144d3403f2b66c68f005028f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9c6698e4e433219949d06668891fb66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e13c93811b1afd450c5803a723e64b1d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('996f0daaf56e482640b4f3c73a9f5be4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ce722455663ab75aa9a81eed3c3ed85', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5c6c846ab7db55c098ed67efc68d84d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca859ee97f3aef1a25bc397f60bfb51a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cdfa16b8e45f03debba2896c54b37575', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c4ff071fac6e9f2b48fd75e89c81c6c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96affb6754fbd3692af50c5b222a44d3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('132d54612ebe10b3a12985e66923fde7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea687d52b0c7fc638992a98c692b787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3f03940750e8692bd397aec8f56ee147', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82be34524fd2f216490eafd22e8fa6d9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d82202582be52335bf5742975df110ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('501dedb70fa1b26f3f19ca4e25328472', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddbc115796bdf0d9859c529d7ec38696', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26d3db2487dd14b2d8d569c2bb0f4837', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f329285a6c5f9b17cd26a38cfabbd09c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a519e519fdac0038e6e7a6051af808c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2a278bf9851ed39d7f7392ffc4bd86cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e903aa8b144d3403f2b66c68f005028f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ca859ee97f3aef1a25bc397f60bfb51a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true' && (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ca859ee97f3aef1a25bc397f60bfb51a'))['reistijdminutenspeciaal']) != 0) {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/fe2d81d8b588959792e536bf5bbac835/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f4caf7b21f3621bef4a84729ffaa68c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c9c6698e4e433219949d06668891fb66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/82be34524fd2f216490eafd22e8fa6d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/68610e87996e08eb4069b8926e5b9449/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/167398eb5217c71350bbef3ad2179244/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e13c93811b1afd450c5803a723e64b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d82202582be52335bf5742975df110ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a9cd3acc36abf15e6be38c169b9d7a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/51855a06ccb9d241ded789898e2af82c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/996f0daaf56e482640b4f3c73a9f5be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/96affb6754fbd3692af50c5b222a44d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/501dedb70fa1b26f3f19ca4e25328472/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/7b6a418c5ddbaf36a10167f48467c107/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/dba812d37c6f2deb4cef49258e1c9bf6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0ce722455663ab75aa9a81eed3c3ed85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/132d54612ebe10b3a12985e66923fde7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ddbc115796bdf0d9859c529d7ec38696/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6efb07a26849937d5c5e0a31b2be75cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f188db4dfbf9bc42864c0e5ee06acd11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c5c6c846ab7db55c098ed67efc68d84d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2ea687d52b0c7fc638992a98c692b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/26d3db2487dd14b2d8d569c2bb0f4837/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9b4603d130741334d2ed2b8830169b3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3e18c667d26484adc9580669ad73e613/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/65c64bb69b5ff7fea7997928ee32d931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2e5c240b35c773dd93eb20cff9d4d0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3c035ba75883a838535b01b882fef483/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a52f124d9c141c07bf512f0cfbadcb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/1c8e5112dd8685aa82149f370b0485d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/25e9bae62bea998e734fe8b792556da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9f1d6f5a6834a7994622ae7d1be323df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5548a0edceaf8f42cb9c69c2675afa02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ac7d29a256f991a290a8e3b93b2a4f82/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/144da5569cd95e5eb5ddfa94251f375d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/957a55a90af9f4077ced6035e15bab7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/94dd724811fe1b0234c8d3e60b458b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/beab1f97950bc1ce4a69dec583a4437d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/26713369fa44ce474fc9101c8f061923/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d17a599febeb88c725c4c0160a541a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/13d4ed3b6c6f5edad16c5c372cb85f28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e0c757a6a823f3ae02d33d7ea74a6904/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/91c32792c1f4db24988c442e8b5255fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/78f1f78742c665ae5cd2bd93fe0f4e32/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2a7e9f466f6b18830998a8f40516091b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cef1a6fb06d27c7659c6a8bae371b111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/dcb4386ff1cb75015c42b6fe360af5e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/aca7f995e5dedb6b275a0bd7609cf5d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/b886794b684355a2effdb8829a125a91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f53f98954ea95501f3771103b7fc85a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4b23f6dc9c382ceb59acefe5e36935fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/17fb835ebd443ddafcb849bb76c71df3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d503aa038fd506bf8af33f61066b3c79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/be7a89a976a51817d0e9b9e2e68188af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/1d98e22219b749756c255cf4e474e518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c17a5feebdb145ff9cbad6f56e9e754f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0195aaaf9e2231575e41b1ef2fb74682/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0c564489372f96f3088f6c0d574fce64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4dc20a6ecf148ff3dac47c2433b56c34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/081fd7efd4e9c0ed193146caf1f69124/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4f9bda37199a5b55620397b91f6d74d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f60238a1a9971adb892fb16bdaad3afa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f92c6985597e6a7c00131df5fe7abf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/871d3162f234ab9784eb98b57ad4583a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ff9f6e4ce7a4e4240779b687efffbd97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ef537a1362b9f9a75d86f84c8c91b8a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a4c12559a08c0a6c81754b55918ab10d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4d69af7c50a271e860d3d50159af351e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d8b4830a5252ae46260614f3533cada8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e8dde48dadfe77de123f38e854c1ec75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3ca3b2ea045b0f9a22ddaa2aae1277a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ac7fa8db03f4d5d9900d836e7d544b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9c67592b131c0c56df06f53afdcd1697/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f6a7cba71f95a05d6e534195166432a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3f0c059830dd98588623f6aa131e7af2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/561dc5788c94ebdfdbe61c0b6c5e6477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d057a152858e47730ed2aa97261fdcb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8e15d01f788508d2a75e75d3ea818692/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5ce171bd1f0362f16eebe6e1b957ff9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/fcb82cb579e8f7ef6b8ca1e826def4cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/684fa9b94f0aaa18b726ab06f35e0829/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d645fdde004c109e2de60ce376fbe71f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3bb17105818c7599f0a6dfba60b89ee1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/84720fa9d13c76a5adc85b4ef4d91808/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/b4d6bf4e17212c66f4416249b7b4727b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4a11f4c275a2843549732abad72cf6bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/49036b6637d8c28ba25c7db9efcbbe28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6785856e6a760d222de9ba2bc8dd5ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/aa0454ec5f091e44d4ce87de15846785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/7cd968d58d4f89bddc8ceab95cc65277/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/1f64747c2779cfeb81b170180872afb8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/989444e28659721dd4aa1eccc8263625/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/da0f04f2f142c1dd0e8c1944419bf6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2d6af192a86eb14ca2cae27af767b518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c172f6acbc0d78ecd4a373553d49b182/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a4db25bd4b4337594efa1371d9c51e07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/eb87497d9aeeea75caee67ddfafa8665/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/756fa1390b839f5c024f0597e378d621/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cd45eb285732615b117847699e181ab4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/b262e212c2155dada3f6e95455bf4c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2432d3af8fbc42f28ae40de71f6faee6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0bd8406f8e4faaf5fceb4d818b85b686/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a77b5887c952877bd735878bb992b729/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f3fb2e23bf932b1906a384a7153dc205/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c845197f0fc35dbfeb8c6c98333ef1ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2984d513cd39409d1b54143aef68396d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ee4a8b1d7a353da74f58c3788dcddc39/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8fe524e5067dffe39b624b526f2537e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8844e49f73ead24d9847ae91dbbc3e46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/7bd63c7f1cf86359a731f09eae6d5d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/92725a4638d19ef3ccc35353a60e3b1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/647442a4c84933a36b8b2014ca6393c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/2d7fad35c89bab376d75273ff634eb84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c447c01cea2434132b062bd48b5a6f4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/4ca26abcfafe7674c0b871a41f5e1236/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/a5eab13b3e05c73b687aa70a394b256d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/31b33654aae3112db1d8d5326a5ac571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/11633fede17bb80b6e2622ac157b9bb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/533e623612af08f8e701be55658999ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/02f98e570e018fc3eec433dcc17c055b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/aa87e0ff7f899bd13e51daf13a79cf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5455648e4a32ebef60b83d4f76632bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/08f4b99cc45946991c1af374fde242fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/be9d99cb32cdb557ae79276626fad7f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/38428a9f27153a6d407f04f1943f1b83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/925c0eab36f9c4a1b2f11e8634444f88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8ea961b38952a49a4c04751d18f8ee1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6fc2aadcdb068f7b57482be1bdb43b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/176d636dad32bc54c11ff2671442cf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/ece242b6591d663f35587841822f0542/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/94a6c2499561cb7765bc14f67fe923cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/617f4ec45e7ecbf55e5c2a4eb9eb3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/e8aa74fb1af76ddfb926b70e23e93906/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c812df5549badbe57caf4f6df8baa284'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5151e632e8559142b5b63cabf4096c9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('669a1894ed2ad848c731e3a20d8a06fc'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c0de0145869c46bc1b4681032aea4d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function oude_format_09_02_2026_voor_een_correcte_afronding() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('618d1598a108cc4738d5f1bdb594e2ad'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6f1f3a15f38822e6885d32c247cb5916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c8e79d6b48425e220e2aadd303e8d8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8e79d6b48425e220e2aadd303e8d8c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/aef1860512aba914470657b98753f4ee/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aef1860512aba914470657b98753f4ee', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/90a6c1643fa86c2c0ac4e56124dacca9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('90a6c1643fa86c2c0ac4e56124dacca9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6316a176ced64b33fbe5043d4c74ad3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6316a176ced64b33fbe5043d4c74ad3e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/0baa2e3d13e3c7568f3e92ec80569c62/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0baa2e3d13e3c7568f3e92ec80569c62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c684b73d1c7297048c52c3c2636de2a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c684b73d1c7297048c52c3c2636de2a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/866690a969ad906c8fea3d636b3f0642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/c338053cf24fabfb59c18ae641e39da2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['VIEW']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/5dcae76e3fa859e24bd8ad68a385b35a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/33388734f86d9bd85a8871358d0d4dd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['factuurnummer'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/f08f234c6498e3c85c78369834e8c548/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuur uitgereikt door afnemer';
  } else {
    text = 'Kwitantie uitgereikt door afnemer';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/8f056838ab986278fee62ff890b6c927/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'factuurkwitantie')) == 'Factuur') {
    text = 'Factuurnummer:';
  } else {
    text = 'Kwitantienummer:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenutrecht/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause('centra=\'Utrecht\' ').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['PRINT'] = true;
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('594b4a1ed0d2bbd7a6e2bf47e4028434', (await Backendless.Data.of('factuurnummersnew').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setGroupBy('').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND maand= \'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 4000 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join('')), ({ [`factuurnummer`]: null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty(___arguments.context.appData, 'factnaam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'factcentra')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e9e78f43490c3e43773e924c6b2595be'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
    ___arguments.context.pageData['viewextrainformatie'] = false;
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
    ___arguments.context.pageData['viewextrainformatie'] = true;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'viewextrainformatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/09fa172f176292726eb81accb3840cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/7c83e5a513c8615e1b22923b68ba7785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukkenzhn/components/1b146b8cdb382a8ca4ff8acd87f9add7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202412'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202501'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202502'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202503'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202504'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202505'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202506'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202507'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202508'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202509'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202510'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202511'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2025') {
    result = (getObjectProperty(___arguments.context.dataModel, 'FNR202512'));
  }
  ___arguments.context.pageData['result'] = result;
}


  ___arguments.context.pageData['result'] = (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'));

  return (getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var regiogvpl2, regiogvpl1, my_1, j, regiogvpllist;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  my_1 = ['\' AND regio IN (\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiopl')),'\')'].join('');
  my_1 = ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join('');
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something2() {
  regiogvpllist = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  for (var j_index in regiogvpllist) {
    j = regiogvpllist[j_index];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'DATA')), (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',j,'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }
  (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'DATA')));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (getObjectProperty(___arguments.context.pageData, 'DATA')));
  for (var j_index2 in regiogvpllist) {
    j = regiogvpllist[j_index2];
    addItemToList((getObjectProperty(___arguments.context.pageData, 'regiogvpl')), j);
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gvtoestemmingen/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/2a07c8910267501fa1bd76cf01986c99/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.pageData, 'akkoord'));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  ___arguments.context.pageData['questioscholingbedrag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingbedrag'));
  ___arguments.context.pageData['factuurcontactpersoon'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurcontactpersoon'));
  ___arguments.context.pageData['factuurmailadres'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurmailadres'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });}))), ({ [`value`]: '%',[`label`]: 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingpakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),'aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/gvtoestemmingen/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc, regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet verlengen. Stuur een mail naar de coordinator.');
  } else {
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
    }
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null,[`pakketminutenakkoord`]: null,[`status`]: 'Afgesloten',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'NIET AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0,[`pakketminutenakkoord`]: null,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'TE BEHANDELEN',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/7de3b5295b3b7842b7c72729efc7941c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/190739bfbd5238033e4f1d481d0e86bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Achtergrondinformatie';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
  } else {
    F = 'Status';
    G = 'Toelichting';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var regiogvpl2, regiogvpl1, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regiogvpl2, regiogvpl1;

/**
 * Describe this function...
 */
async function regiofilter() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = ___arguments.value.split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  await regiofilter();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Toegekend door ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;



  return 'Gemeente/ woonplaats'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    E = 'Aanvraag besproken?';
    F = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    C = 'Organisatie die de scholing afneemt';
    D = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/23e1c5223c82007889230b7891020864/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gvtoestemmingenverlenging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoordverzoekverlenging': 0 }) );
  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingstatusdossier': 'VERLENGING BEHANDELD','aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join('')),'sortBy': 'Dossier DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc, regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/30d86d04965ea9b4dbf5d7bf449225b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gvtoestemmingenaantekeningen', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-pagina alle notities bekeken'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'pagina alle notities bekeken',[`dossier`]: undefined,[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/gvtoestemmingen/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gvtoestemmingen/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/2a4f8f4f6666a285e5facfdfa6b4b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a4f8f4f6666a285e5facfdfa6b4b31f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/e3a50f7e5bd4485aad127b9c737467f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc613a630b217e93e626880a470508e7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/ebc92f328bfdb8fb9aa2f085026c2266/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questioscholingbedrag': (getObjectProperty(___arguments.context.pageData, 'questioscholingbedrag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De eigen bijdrage is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/a9c2f5452dfbe2b86e1f4733e8814297/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalender', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/aacd343f68c4bb05dd63282a3be96317/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5d1a6122cb0e48cd84f19df551bd7d3d')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/57bf086975d2bbd27452000ba0ca0d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d1a6122cb0e48cd84f19df551bd7d3d'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Programma is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/0f516cdc7a87a6ea4bf70da987e3dfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0f516cdc7a87a6ea4bf70da987e3dfbd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questiogroepsconsultprogrammabijeenkomst').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gvtoestemmingen/components/9da46e0784b6c92e46fa5f31c65d6f52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbe190c3259a97366ce030fefddbe01')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d53211de5906121a606260195aad8ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79abb5a3590c2b9ff8ce5939cc430832')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/6255fd828bcfa9d403ef015d4008f8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.pageData, 'wlzindicatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz is aangepast');
  ___arguments.context.pageData['wlzindicatie'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/928520092141ae4e2c8634bba421e66a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.pageData, 'wlzindicatiesoort')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz indicatie is aangepast');
  ___arguments.context.pageData['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d1ff33dff6da76fdc4e107e65544c786/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cbf77d19f4fa2292df687b656f521de')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d06bb12b3dc6fcf25c18762379a7e1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d99043cb0e2beb14692b289ca3f3a56')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/f3e33b580a8a6528ea34f2d393596f23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurcontactpersoon': (getObjectProperty(___arguments.context.pageData, 'factuurcontactpersoon')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De contactpersoon voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/458800d42e473d4a95c7bc165d45fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurmailadres': (getObjectProperty(___arguments.context.pageData, 'factuurmailadres')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Het emailadres voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/341f4ca6cebbded4944b69746ecc11ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/503b31d353cfd70f674baddc726ca10d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/f77f4042ef5bc25c5ea8cf7d4ea64945/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;



  return 'Resterende minuten op dossier'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/98e4a0146d34b776c2aeffeb29ea81fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/32e73059454f19165d0147ca564a76ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/d0949bf9f98b6f35b12427fc37a6f8bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/fefbe76de87b4fa35153a6e37dd7f8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('chartverlengingbrabant', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/3dec7a07010c45a3396dea41a0bbdb12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/1e191665dc4e26d95b2e1b74c861967e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/88e23952ed55134c3a77d72960e3122f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/82186e3b732d07b322bc5dd6e6d7ffcd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/33a6cea49fff954dca096566d2b90c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8553db664a7b49b4869ab7f3c06ff17f')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/4503288cc2c85e84af1ae5357c5b1b78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwachtergrondinformatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Achtergrondinformatie is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingen/components/8553db664a7b49b4869ab7f3c06ff17f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8553db664a7b49b4869ab7f3c06ff17f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questioconsultinwachtergrondinformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gvtoestemmingen/components/a7bbca3209812702649e08f59bdf152b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7bbca3209812702649e08f59bdf152b', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))).setProperties('naam').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gvtoestemmingen/components/b25db17d25541ed4ad434ee940f48692/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('dossierdelen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))))) == 0) {
    result = false;
  } else {
    result = true;
  }

  return result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingen/components/0d19b4d27ce9ec1f5c75d87901dad0c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1oYABu41OMPCl4WSafRzUbvhcO5KxXpUn/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'1\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')',' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });}))), ({ [`value`]: '%',[`label`]: 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gvtoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, D, item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    C = 'Organisatie die de scholing afneemt';
    D = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord')),' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord')),' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenaantekeningen/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var verlengingemail, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  verlengingemail = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlengingusername')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`email`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(verlengingemail, 'email'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a17dbd9b93d8a526687801fcdaa1196e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('476e6f7a6be44c614b8d19ab5f0778e5', true);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ [`startpakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'start')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingpakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['start'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc, regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': 1,'status': 'Actief','akkoorddoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'akkoorddatum': (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': 1 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingstatusdossier': 'AKKOORD','aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': null,'pakketminutenakkoord': null,'status': 'Afgesloten','akkoorddoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'akkoorddatum': (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': null }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingstatusdossier': 'NIET AKKOORD','aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': 0,'pakketminutenakkoord': null,'status': 'Actief','akkoorddoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'akkoorddatum': (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoord': 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingstatusdossier': 'TE BEHANDELEN','aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Toegekend door ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator'])));

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var E, item, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
  } else {
    D = 'Organisatie die de scholing afneemt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    E = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet verlengen. Stuur een mail naar de coordinator.');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'VERLENGING BEHANDELD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join('')),'sortBy': 'Dossier DESC' })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var verlengingemail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  verlengingemail = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlengingusername')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async verlengingemail => {; return ({ [`email`]: (getObjectProperty(verlengingemail, 'email')) });})))[0];
  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(verlengingemail, 'email'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc, regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleiderverlenging'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  await regiogvpl();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['opmerkingprojectleiderverlenging'] = undefined;
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/c5363ebf9fa24bb2cd7f2a652bde3dac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = 'Resterende activiteiten/ minuten op dossier';
  } else {
    return2 = 'Resterende minuten op dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/6d83ab843caf99486001011df50518c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gvtoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/a45f60ab83e3e21aa31d589f415728b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a17dbd9b93d8a526687801fcdaa1196e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('476e6f7a6be44c614b8d19ab5f0778e5', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/554b16920b87da79921e468445adc4d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND akkoordverzoekverlenging=\'',1,'\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\')'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/f9aebd7494c128789a35b3f4494a74a6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f9aebd7494c128789a35b3f4494a74a6')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/gvtoestemmingenverlenging/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/helpdesk/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/helpdesk/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/helpdesk/components/46fd706be85c360dba93a7bd58abf674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'a.pasterkamp@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`userrole`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`userrole`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  }
  await Backendless.Data.of('historiehelpdeskvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`helpdeskvraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }) );
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/ae92877f8dbf6b1158d3f38a354c6c72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Hier kunt u uw vraag stellen, uw naam wordt automatisch meegestuurd met de mail.';
  } else {
    text = 'Hier kunt u uw vraag stellen aan Lorio, uw naam wordt automatisch meegestuurd met de mail.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/helpdesk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/helpdesk/components/979216ad64451b674a629ce3a1ded715/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/18ea47610bde8c968764a4388b2da13f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/46fd706be85c360dba93a7bd58abf674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard2023plbestuur', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/a328fdbd41e8afc5acebd26eabc3dca7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard2024plbestuur', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/1038c9c810a8e8882bc871e834b88022/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Willem';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard2025bestuur', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/6cb88c815ef47d0d06787aaebb33c1b6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Rotterdam';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard2025bestuur', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/d7482128d672d5f654c8fbd89552521a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Willem';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/6098f5d808c828084d68d377c024f1e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Rotterdam';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/da2938183dcc07a8ad88cee83ae8bf3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Rotterdam';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025landelijk', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/c3adb8583f286ab8208e7598e3c84ad5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Willem';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2026', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/1a9854b3af5d72f800a2f085573ccaf9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Willem';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardbestuur2026', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginadashboard/components/fe8865d86455ec350aa8ce521d5126d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['dashboard'] = 'Rotterdam';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardbestuur2026', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await Backendless.Logging.setLogReportingPolicy(1, 0);
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ebd66eb2634d5292f113186f324c41fc', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setRelated(['centra']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5666f7325d8196b0c2cb9d946bd061a', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f5a9022a7c0122f7bf326301f2d2b2ad', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('96e87ae74d5559c4a8a29a1b2f3eba76', (await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c1fe8fdc12c3e109f58516e93982ddb2', (await Backendless.Data.of('settingsmaxtijden').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0fc296ba12346f5621a76a49c35fbb6d', (await Backendless.Data.of('settingspakketminuten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5a48a8f7575419bee5745a66557a079', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['email2', 'regio']).setGroupBy('regio').setPageSize(100))));
  ___arguments.context.appData['startpagemijndossiers'] = 'alleactiviteiten';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP2, TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old() {
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw09jhr') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpmzwnl2023', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    TEMP2 = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
    if (TEMP2 == 0) {
      await Backendless.Data.of('factuurnummers').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginagv/components/f068c95fd3abaca43ccde8de29d7e7c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/d8fb1569c4184c94efc2f1cfc6197a49/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'username'))));
  ___arguments.context.appData['centraname'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'centraname'))));
  ___arguments.context.appData['naam'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'naam'))));
  ___arguments.context.appData['objectid'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'objectId'))));
  ___arguments.context.appData['btwplichtig'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwplichtig'))));
  ___arguments.context.appData['btwinclcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwinclcoaching'))));
  ___arguments.context.appData['btwinclconsulten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwinclconsulten'))));
  ___arguments.context.appData['btwinclmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwinclmdopatz'))));
  ___arguments.context.appData['btwinclgroepsconsulten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwinclgroepsconsulten'))));
  ___arguments.context.appData['btwinclscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwinclscholing'))));
  ___arguments.context.appData['emailgv'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'email'))));
  ___arguments.context.appData['organisatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'organisatie'))));
  ___arguments.context.appData['kilometersdeclareren'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'kilometersdeclareren'))));
  ___arguments.context.appData['blind'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'blind'))));
  ___arguments.context.appData['gebiedsverantwoordelijke'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'gebiedsverantwoordelijke'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv/components/902746e53706a00682e4d76d4af433f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'centraname')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'naam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'objectid')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32'), 'btwplichtig'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/b8c934d32c3c838b403978446a46eeaa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['setcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'coaching'))));
  ___arguments.context.appData['setconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'consultinw'))));
  ___arguments.context.appData['setconsultpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'consultpro'))));
  ___arguments.context.appData['setcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'coordinatietaken'))));
  ___arguments.context.appData['setgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'groepsconsult'))));
  ___arguments.context.appData['setmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'mdopatz'))));
  ___arguments.context.appData['setopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'opbouwinfra'))));
  ___arguments.context.appData['setscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'scholing'))));
  ___arguments.context.appData['setwerkgroep'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'werkgroep'))));
  ___arguments.context.appData['setraadvanadvies'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'raadvanadvies'))));
  ___arguments.context.appData['setopjeplek'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'setopjeplek'))));
  ___arguments.context.appData['setreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdkm'))));
  ___arguments.context.appData['setreistijdminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdminuten'))));
  ___arguments.context.appData['setreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['setuitlegtijdconsultinw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdconsultinw'));
  ___arguments.context.appData['setuitlegtijdgroepsconsult'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdgroepsconsult'));
  ___arguments.context.appData['setuitlegtijdmdopatz'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdmdopatz'));
  ___arguments.context.appData['setuitlegtijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdscholing'));
  ___arguments.context.appData['setuitlegtijdcoaching'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdcoaching'));
  ___arguments.context.appData['uitlegreistijdconsultinw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegreistijdconsultinw'));
  ___arguments.context.appData['uitlegreistijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegreistijdscholing'));
  ___arguments.context.appData['toestemmingconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingconsultinwpro'))));
  ___arguments.context.appData['toestemminggroeps'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemminggroeps'))));
  ___arguments.context.appData['toestemmingmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingmdopatz'))));
  ___arguments.context.appData['toestemmingscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingscholing'))));
  ___arguments.context.appData['toestemmingcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingcoaching'))));
  ___arguments.context.appData['toestemmingopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingopbouwinfra'))));
  ___arguments.context.appData['toestemmingcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingcoordinatie'))));
  ___arguments.context.appData['toestemmingwerkgroep'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingwerkgroep'))));
  ___arguments.context.appData['toestemmingraadvanadvies'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingraadvanadvies'))));
  ___arguments.context.appData['gvdossiersinvoeren'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvdossiersinvoeren'))));
  ___arguments.context.appData['gvregistratiestop'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvregistratiestop'))));
  ___arguments.context.appData['gvpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvpostcode'))));
  ___arguments.context.appData['gvgeboortejaar'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgeboortejaar'))));
  ___arguments.context.appData['gvgender'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgender'))));
  ___arguments.context.appData['gvnietdeclarabel'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvnietdeclarabel'))));
  ___arguments.context.appData['gvregistrerenzonderakkoord'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvregistrerenzonderakkoord'))));
  ___arguments.context.appData['naamprojectleidercoordinator'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'naamprojectleidercoordinator'))));
  ___arguments.context.appData['gvreistijdwillem'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvreistijdwillem'))));
  ___arguments.context.appData['gvgemwoon'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgemwoon'))));
  ___arguments.context.appData['gvregistratievragenindossierscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvregistratievragenindossierscholing'))));
  ___arguments.context.appData['plemailinstellingenperregio'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'plemailinstellingenperregio'))));
  ___arguments.context.appData['gvreistijdpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvreistijdpostcode'))));
  ___arguments.context.appData['gvnietdeclarabelconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvnietdeclarabelconsultinw'))));
  ___arguments.context.appData['reistijdbtwupdate'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdbtwupdate'))));
  ___arguments.context.appData['selfbilling'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'selfbilling'))));
  ___arguments.context.appData['plmeldingdossiers'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'plmeldingdossiers'))));
  ___arguments.context.appData['registratiesaanpassen'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'registratiesaanpassen'))));
  ___arguments.context.appData['gvgeboortedatum'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgeboortedatum'))));
  ___arguments.context.appData['aw2024'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'aw2024'))));
  ___arguments.context.appData['scholingmetofzonderbtw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'scholingmetofzonderbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv/components/01051102fa7b3944af6ad53c857ed9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtdrechtsteden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtoverijssel2024', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem2024', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtenlimburg', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtrotterdam2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtutrechtfactuur', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem2024', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtzwnl', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtquestio', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtbrabant', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtzhn', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichthaaglanden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtzinvol', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtsichtpunt', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/6289f2069828b99818aae56ab62147ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/s/i1mbWBvNXqU', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/0852f0a8-f5d5-44c3-b8ac-e4502650eedb', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/a982bb37-b369-45f0-a24b-001f36295b8e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/79607005-8eb3-470f-9938-8dd207812f31', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/9a6ce47a-a46b-43bc-a61e-70728f2d5556', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/10656fed-1af5-401b-91b4-c76f46cb069e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/35a43573-8469-4114-a824-f817a5733af6', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/928c9045-890c-46e2-9fc6-9cafcd6df80a', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  my_1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true;

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/07eeabe47f04884152ef377187355a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('numberinputfieldtest', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/63a2e9174a13ee996a361da1b91f09be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('relatiebestand', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/b914a56e87eba3526ff19dd98a65d174/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'gvjaaractiviteiten')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/fb2516d8ade181f538ae5e6633b9785b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/beeea8014043b42890e4ebbb49d30da8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['maxtijdconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdconsultinwpro'))));
  ___arguments.context.appData['maxtijdgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdgroepsconsult'))));
  ___arguments.context.appData['maxtijdmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdmdopatz'))));
  ___arguments.context.appData['maxtijdscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdscholing'))));
  ___arguments.context.appData['maxtijdcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdcoaching'))));
  ___arguments.context.appData['maxtijdcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdcoordinatie'))));
  ___arguments.context.appData['maxtijdopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdopbouwinfra'))));
  ___arguments.context.appData['maxtijdreistijdminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdreistijdminuten'))));
  ___arguments.context.appData['maxtijdreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdreistijdkm'))));
  ___arguments.context.appData['maxtijdreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdreistijdminutenspeciaal'))));
  ___arguments.context.appData['maxtijdwerkgroep'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdwerkgroep'))));
  ___arguments.context.appData['maxtijdraadvanadvies'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdraadvanadvies'))));
  ___arguments.context.appData['maxtijdnetwerkbijeenkomstnpzf'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7dcfe3436962ee6cb3760fd3dbf91a11'), 'maxtijdnetwerkbijeenkomstnpzf'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv/components/705da784c35dfb0a04e47c14797fbade/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossiertijdconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdconsultinwpro'))));
  ___arguments.context.appData['dossiertijdgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdgroepsconsult'))));
  ___arguments.context.appData['dossiertijdmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdmdopatz'))));
  ___arguments.context.appData['dossiertijdscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdscholing'))));
  ___arguments.context.appData['dossiertijdcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdcoaching'))));
  ___arguments.context.appData['dossiertijdcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdcoordinatietaken'))));
  ___arguments.context.appData['dossiertijdopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('82586af69495bfa424cf26136f211e32'), 'dossiertijdopbouwinfra'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv/components/759799181947ebf303fede319cca26bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevensgv', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-mijn gegevens geopend'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginagv',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'mijn gegevens geopend',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/112b8869e6ba83be228d391500c99ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'ZHN') {
    name2 = 'Zuid Holland Noord';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'Haaglanden') {
    name2 = 'Haagsche-Zin';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname')) == 'Lorio') {
    name2 = 'Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a'), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/7d75ac6235d2a782d0256d6a852120c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/46f61368bf96f34d3b19b5cc0f796287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1bwdk10Dsd0bX41H9CrHtiDZYA_nkNB19/edit#', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/4928fbb9071c21769425c1a1adce756a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await ( async function (url, isExternal, params) { const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/spreadsheets/d/1HkvsrTaiFGi7wz1xyOD-ux1KGv0pM61Jl7iq3AqgC-k/edit?usp=sharing', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/12b2d8735b093884730b8cf94472dc54/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1V4EBfJzitjJPnisMn6uppCdshRQL4bFd/view?usp=sharing', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1srbiCs0JxFlUhCBZeX7_4Aq9DKMolLBC/view?usp=drive_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1S5vUrJjLHGMli-X6b9LVkz4fDtVBupIO/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1FgT1D1kGy6XJP8yRogMPKgfCvZdsGy-b/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1DFrg6M4sp75OuEGYXR7zJfF2joF87lGI/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1BWUeN5Cr8H9ntSNmE9-aXaGVKcnRFgc6/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fReZRj_A7K7egxH3GZHrupUTjY5XL3uw/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1XwtcRGMY77tx9LKiL10AgpaSCyTU76rn/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1T61v7OkSAM4Szc9PWjXeadn_dJzQVHoV/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1GGuiHOmpgJNgvy8qJE98ZSjsupk2YbHy/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1u_09RLN922UsgnvXF8K1MdyqhLPlsTgw/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1zwV9cQFyi9Lb2mMwKAumzMmn7yDA99hF/view?usp=sharing', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1bgnUE1O9XzjRsIu6toTWFCEZWsVfcrH9/view?usp=sharing', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/17COWgIQ2yKVsXWkqDcYbb8AXNv1GD3hx/view?usp=drive_link', true, undefined);
  } else {
    visible = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/b851917a9a499a0a671c8f8ff34c121a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/ba82fc35-36ed-4aeb-9c85-30b59aa793ce', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3f9a1140-4734-4887-a827-2e362a18a2ac', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/1005b856-9141-465d-80a1-732c1908cb85', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3dc7a781-5bf4-403d-9668-4bedb823b5f8', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/07130ab6-5779-4ac4-9310-d897ff7444a7', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/b7892aa3-55e3-4104-914e-d474050cb17d', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/f41210ce-3d49-4528-970c-a7168a472165', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/49400658-ab0d-4a5e-8d1f-434480e30a9d', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/b3d16fb6-fdba-4e37-8cd8-3cb5491e6249', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginagv',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardgv2023', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Wi56jln' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/5be9931280bd6ba377d680f1117e75bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['dashboardnamen'] = false;
  list = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e0ce1ee2f811d042e22218fef6c912eb'), 'email2'))];
  ___arguments.context.pageData['regiolist'] = [];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e0ce1ee2f811d042e22218fef6c912eb'), 'email2'))) {
      ___arguments.context.pageData['dashboardnamen'] = true;
      ___arguments.context.appData['teamcoordinator'] = true;
      addItemToList((getObjectProperty(___arguments.context.pageData, 'regiolist')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e0ce1ee2f811d042e22218fef6c912eb'), 'regio')));
    }
  }
  ___arguments.context.appData['regiolist'] = ((getObjectProperty(___arguments.context.pageData, 'regiolist')).join('\',\''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv/components/88ccb53b1ad481981889dad551e989ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dashboardnamen'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plusersutrecht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/812bd41a9c9a200b53ff66615b51bc18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'regiolist')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/2ac486b744ae5c2f46d1ea925c25ac7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kmoverzicht', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kmoverzicht', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('kmoverzicht', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/923949832fc34de346044f349713514d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtnietdeclarabelzwnl', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtnietdeclarabel', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'centra')), 'plmaandcontrolenietdeclarabel')) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ro69lht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/8eed8b772ff1f2116f6f3aae3e0629c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Of32rsh') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Of08mfr') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriooverijsselgvjm') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtoverijssel', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/4db3d5a564894a8beb11262f120fd4bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtoverijssel2024', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem2024', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtzwnl2024', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/b73a09dff17d5ad9000f5a9a86d75766/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtoverijssel', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtzwnl', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/2f8f1ad224b421ae686217ae91c8cbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2024'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginagv',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2024',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardgv2024', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Wi56jln' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/f37ab2b7254f1bdcc9add1f818fa48c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtbrabant', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtdrechtsteden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichthaaglanden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtquestio', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtrotterdam', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtsichtpunt', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtutrecht', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtzhn', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtzinvol', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/4ee324d804b5fb9420ae89cc3d565388/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('overzichtgvusersquestio', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var originele_code;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  originele_code = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false;

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'overzichtgvusersquestio')) == true || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == '' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/3b796ee9f3b61eb8c1055ade59ee9cd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/73b6f03ef8398fb6bbb6cae668e83856/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1bwdk10Dsd0bX41H9CrHtiDZYA_nkNB19/edit#', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/021ba9f3e74a7acde70b9eb606d2e3fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1V4EBfJzitjJPnisMn6uppCdshRQL4bFd/view?usp=sharing', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1srbiCs0JxFlUhCBZeX7_4Aq9DKMolLBC/view?usp=drive_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1S5vUrJjLHGMli-X6b9LVkz4fDtVBupIO/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1FgT1D1kGy6XJP8yRogMPKgfCvZdsGy-b/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1DFrg6M4sp75OuEGYXR7zJfF2joF87lGI/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1BWUeN5Cr8H9ntSNmE9-aXaGVKcnRFgc6/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fReZRj_A7K7egxH3GZHrupUTjY5XL3uw/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1XwtcRGMY77tx9LKiL10AgpaSCyTU76rn/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1T61v7OkSAM4Szc9PWjXeadn_dJzQVHoV/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1GGuiHOmpgJNgvy8qJE98ZSjsupk2YbHy/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1u_09RLN922UsgnvXF8K1MdyqhLPlsTgw/view?usp=share_link', true, undefined);
  } else {
    visible = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/ae7c444c6ce9b70e781266ab457286dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/09c31b7afe45594995e984a4c7b608f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/31faccf525a82025703f504d08642c77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gebiedsverantwoordelijke')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gvtoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/556fb02c65bdbf624862c7e1669aca0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardgv2025', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz15mpr' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz17mpt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz12jmp') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == 'PLGV') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv/components/af48e4f635357a38de3a8978feb81c36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz15mpr' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz17mpt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz12jmp') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) == 'PLGV') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardgv2026', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/171888f6fb3887081c6ef801d1030328/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtzinvolzelfbetalend', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv/components/c84819b65804bffdf002fcd8e93c754a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('bibliotheekquestio', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'bibliotheek')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await Backendless.Logging.setLogReportingPolicy(1, 0);
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9eb35433ff1737b9cdb7b6699b4525e7', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setRelated(['centra']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('35f29fcd6b92d5c7ce7d36196c2386f4', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('83c6d5b351c456be1682c4b66f654f0c', (await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6eaead4250932e8d8d0d54910a094697', (await Backendless.Data.of('settingsmaxtijden').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('10320dfae2431ed246d58ef8651ebc6c', (await Backendless.Data.of('settingspakketminuten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('552c95f81d09c0069923c10632387b96', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['email2', 'regio']).setGroupBy('regio').setPageSize(100))));
  ___arguments.context.appData['startpagemijndossiers'] = 'alleactiviteiten';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP2, TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    TEMP2 = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
    if (TEMP2 == 0) {
      await Backendless.Data.of('factuurnummers').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Of32rsh') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Of08mfr') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtdrechtsteden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtenlimburg', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtoverijssel', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtrotterdam2022', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtutrechtfactuur', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtzwnl', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzichtquestio', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/df91c3c46783105892d3d05c473df381/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/s/i1mbWBvNXqU', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/0852f0a8-f5d5-44c3-b8ac-e4502650eedb', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/a982bb37-b369-45f0-a24b-001f36295b8e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/79607005-8eb3-470f-9938-8dd207812f31', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/9a6ce47a-a46b-43bc-a61e-70728f2d5556', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/10656fed-1af5-401b-91b4-c76f46cb069e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/35a43573-8469-4114-a824-f817a5733af6', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/928c9045-890c-46e2-9fc6-9cafcd6df80a', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/fd0ca608999bd675b40ec72d5956524b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevensgv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/294d5049f41f5ab9dbe5be4c7a8a9fee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/365d3c9f35a137ca3804ed1c1c2c413a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtdrechtsteden', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtoverijssel', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtrotterdam', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtutrecht', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtzwnl', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtwillem', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('jaaroverzichtquestio', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/7bfbb0077999fc06a6f60a2d44239b82/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'gvjaaractiviteiten')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/64d7774df6dae9a992efc626bedb37d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('relatiebestand', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/d9235d6b15efdbeb69e939e666ea81b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/ba82fc35-36ed-4aeb-9c85-30b59aa793ce', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3f9a1140-4734-4887-a827-2e362a18a2ac', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/1005b856-9141-465d-80a1-732c1908cb85', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3dc7a781-5bf4-403d-9668-4bedb823b5f8', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/07130ab6-5779-4ac4-9310-d897ff7444a7', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/b7892aa3-55e3-4104-914e-d474050cb17d', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/f41210ce-3d49-4528-970c-a7168a472165', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/49400658-ab0d-4a5e-8d1f-434480e30a9d', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/b3d16fb6-fdba-4e37-8cd8-3cb5491e6249', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'gvdashboard')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/574cd2731569b6041bc8a319aa7b4882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/3c78a0cb7eeef84e8205b879cb92439c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1S5vUrJjLHGMli-X6b9LVkz4fDtVBupIO/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1FgT1D1kGy6XJP8yRogMPKgfCvZdsGy-b/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1DFrg6M4sp75OuEGYXR7zJfF2joF87lGI/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1BWUeN5Cr8H9ntSNmE9-aXaGVKcnRFgc6/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fReZRj_A7K7egxH3GZHrupUTjY5XL3uw/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1XwtcRGMY77tx9LKiL10AgpaSCyTU76rn/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1T61v7OkSAM4Szc9PWjXeadn_dJzQVHoV/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1GGuiHOmpgJNgvy8qJE98ZSjsupk2YbHy/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1u_09RLN922UsgnvXF8K1MdyqhLPlsTgw/view?usp=share_link', true, undefined);
  } else {
    visible = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1bwdk10Dsd0bX41H9CrHtiDZYA_nkNB19/edit#', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/971283dbebdb649e2ad3fe6201892761/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plupdatesgv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/4cdda851f3eba41c7718fc51528ca757/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/63c882547302736303fff99c660e6212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plusersutrecht', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dashboardnamen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/4a2fe735e862bb09032aa384a2f81bd1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/spreadsheets/d/1HkvsrTaiFGi7wz1xyOD-ux1KGv0pM61Jl7iq3AqgC-k/edit?usp=sharing', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/68d52e75ecc46084b13c507fb2bcd3ab/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['setcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'coaching'))));
  ___arguments.context.appData['setconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'consultinw'))));
  ___arguments.context.appData['setconsultpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'consultpro'))));
  ___arguments.context.appData['setcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'coordinatietaken'))));
  ___arguments.context.appData['setgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'groepsconsult'))));
  ___arguments.context.appData['setmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'mdopatz'))));
  ___arguments.context.appData['setopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'opbouwinfra'))));
  ___arguments.context.appData['setscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'scholing'))));
  ___arguments.context.appData['setreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'reistijdkm'))));
  ___arguments.context.appData['setreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'reistijdkm'))));
  ___arguments.context.appData['setreistijdminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'reistijdminuten'))));
  ___arguments.context.appData['setreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['setuitlegtijdconsultinw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegtijdconsultinw'));
  ___arguments.context.appData['setuitlegtijdgroepsconsult'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegtijdgroepsconsult'));
  ___arguments.context.appData['setuitlegtijdmdopatz'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegtijdmdopatz'));
  ___arguments.context.appData['setuitlegtijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegtijdscholing'));
  ___arguments.context.appData['setuitlegtijdcoaching'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegtijdcoaching'));
  ___arguments.context.appData['uitlegreistijdconsultinw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegreistijdconsultinw'));
  ___arguments.context.appData['uitlegreistijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'uitlegreistijdscholing'));
  ___arguments.context.appData['toestemmingconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingconsultinwpro'))));
  ___arguments.context.appData['toestemminggroeps'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemminggroeps'))));
  ___arguments.context.appData['toestemmingmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingmdopatz'))));
  ___arguments.context.appData['toestemmingscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingscholing'))));
  ___arguments.context.appData['toestemmingcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingcoaching'))));
  ___arguments.context.appData['toestemmingopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingopbouwinfra'))));
  ___arguments.context.appData['toestemmingcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'toestemmingcoordinatie'))));
  ___arguments.context.appData['gvdossiersinvoeren'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvdossiersinvoeren'))));
  ___arguments.context.appData['gvregistratiestop'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvregistratiestop'))));
  ___arguments.context.appData['gvpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvpostcode'))));
  ___arguments.context.appData['gvgeboortejaar'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvgeboortejaar'))));
  ___arguments.context.appData['gvgender'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvgender'))));
  ___arguments.context.appData['gvnietdeclarabel'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvnietdeclarabel'))));
  ___arguments.context.appData['gvregistrerenzonderakkoord'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvregistrerenzonderakkoord'))));
  ___arguments.context.appData['naamprojectleidercoordinator'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'naamprojectleidercoordinator'))));
  ___arguments.context.appData['gvreistijdwillem'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvreistijdwillem'))));
  ___arguments.context.appData['gvgemwoon'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvgemwoon'))));
  ___arguments.context.appData['gvregistratievragenindossierscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvregistratievragenindossierscholing'))));
  ___arguments.context.appData['plemailinstellingenperregio'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'plemailinstellingenperregio'))));
  ___arguments.context.appData['gvreistijdpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvreistijdpostcode'))));
  ___arguments.context.appData['gvnietdeclarabelconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvnietdeclarabelconsultinw'))));
  ___arguments.context.appData['reistijdbtwupdate'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'reistijdbtwupdate'))));
  ___arguments.context.appData['selfbilling'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'selfbilling'))));
  ___arguments.context.appData['plmeldingdossiers'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'plmeldingdossiers'))));
  ___arguments.context.appData['registratiesaanpassen'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'registratiesaanpassen'))));
  ___arguments.context.appData['gvgeboortedatum'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bfbcd9af7ee7d164b1a236fb975ac6e3'), 'gvgeboortedatum'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/d3efa821937a855f728a9a57b0e9a50d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'username'))));
  ___arguments.context.appData['centraname'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'centraname'))));
  ___arguments.context.appData['naam'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'naam'))));
  ___arguments.context.appData['objectid'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'objectId'))));
  ___arguments.context.appData['btwplichtig'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwplichtig'))));
  ___arguments.context.appData['btwinclcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwinclcoaching'))));
  ___arguments.context.appData['btwinclconsulten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwinclconsulten'))));
  ___arguments.context.appData['btwinclmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwinclmdopatz'))));
  ___arguments.context.appData['btwinclgroepsconsulten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwinclgroepsconsulten'))));
  ___arguments.context.appData['btwinclscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'btwinclscholing'))));
  ___arguments.context.appData['emailgv'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'email'))));
  ___arguments.context.appData['organisatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'organisatie'))));
  ___arguments.context.appData['kilometersdeclareren'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('594a94b65df8c35f79b829dabca3a619'), 'kilometersdeclareren'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/456147cbc4cce95ff675679c5a62cc14/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['maxtijdconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdconsultinwpro'))));
  ___arguments.context.appData['maxtijdgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdgroepsconsult'))));
  ___arguments.context.appData['maxtijdmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdmdopatz'))));
  ___arguments.context.appData['maxtijdscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdscholing'))));
  ___arguments.context.appData['maxtijdcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdcoaching'))));
  ___arguments.context.appData['maxtijdcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdcoordinatie'))));
  ___arguments.context.appData['maxtijdopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdopbouwinfra'))));
  ___arguments.context.appData['maxtijdreistijdminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdreistijdminuten'))));
  ___arguments.context.appData['maxtijdreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdreistijdkm'))));
  ___arguments.context.appData['maxtijdreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0642bde634ac1101927157f2f1c58b98'), 'maxtijdreistijdminutenspeciaal'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/a08dd959b45c5287e156713a02038403/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63c882547302736303fff99c660e6212')), 'display')) == false && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4a2fe735e862bb09032aa384a2f81bd1')), 'display')) == false && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64d7774df6dae9a992efc626bedb37d6')), 'display')) == false && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7bfbb0077999fc06a6f60a2d44239b82')), 'display')) == false) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/430c8d9b70f3e22b892696347f1184fe/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossiertijdconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdconsultinwpro'))));
  ___arguments.context.appData['dossiertijdgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdgroepsconsult'))));
  ___arguments.context.appData['dossiertijdmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdmdopatz'))));
  ___arguments.context.appData['dossiertijdscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdscholing'))));
  ___arguments.context.appData['dossiertijdcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdcoaching'))));
  ___arguments.context.appData['dossiertijdcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdcoordinatietaken'))));
  ___arguments.context.appData['dossiertijdopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c91c2b42c463f65f10319fd9fec4c37f'), 'dossiertijdopbouwinfra'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagv1/components/86b1f43525f37c5a96caba5ff232584e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['dashboardnamen'] = false;
  list = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('30f48cda4f891a52610e0c17c6eb3456'), 'email2'))];
  ___arguments.context.pageData['regiolist'] = [];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30f48cda4f891a52610e0c17c6eb3456'), 'email2'))) {
      ___arguments.context.pageData['dashboardnamen'] = true;
      addItemToList((getObjectProperty(___arguments.context.pageData, 'regiolist')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('30f48cda4f891a52610e0c17c6eb3456'), 'regio')));
    }
  }
  ___arguments.context.appData['regiolist'] = ((getObjectProperty(___arguments.context.pageData, 'regiolist')).join('\',\''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7cd127ad5db8fab3b314a51047233b4', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setRelated(['centra']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9eb35433ff1737b9cdb7b6699b4525e7', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setRelated(['centra']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f23621726c4b1550569823edefdd471', (await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('839c1c9419140ca3cf99344452e6e00a', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0af508ba033c5adce4338cae920d4952', (await Backendless.Data.of('settingspakketminuten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50099a2b41a3e546b11e78dbdc729592', (await Backendless.Data.of('settingsbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b787f9cd956e20f76685cbf5efe97992', (await Backendless.Data.of('tarievenpercentra').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dfbc5557c26b14a45241eb413a91cf6d', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['email', 'regio']).setGroupBy('regio').setPageSize(100))));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebrabant', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreedrotterdam', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolequestio', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolelimburg', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreedzhn', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrole', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/fc0c3d198f7a7369cd67844a5735c3ca/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['setcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'coaching'))));
  ___arguments.context.appData['setconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'consultinw'))));
  ___arguments.context.appData['setconsultpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'consultpro'))));
  ___arguments.context.appData['setcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'coordinatietaken'))));
  ___arguments.context.appData['setgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'groepsconsult'))));
  ___arguments.context.appData['setmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'mdopatz'))));
  ___arguments.context.appData['setopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'opbouwinfra'))));
  ___arguments.context.appData['setscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'scholing'))));
  ___arguments.context.appData['setreistijdkm'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'reistijdkm'));
  ___arguments.context.appData['setreistijdminuten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'reistijdminuten'));
  ___arguments.context.appData['setreistijdminutenspeciaal'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'reistijdminutenspeciaal'));
  ___arguments.context.appData['setuitlegtijdconsultinwpro'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'uitlegtijdconsultinwpro'));
  ___arguments.context.appData['setuitlegtijdgroepsconsult'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'uitlegtijdgroepsconsult'));
  ___arguments.context.appData['setuitlegtijdmdopatz'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'uitlegtijdmdopatz'));
  ___arguments.context.appData['setuitlegtijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'uitlegtijdscholing'));
  ___arguments.context.appData['setuitlegtijdcoaching'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'uitlegtijdcoaching'));
  ___arguments.context.appData['toestemmingconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingconsultinwpro'))));
  ___arguments.context.appData['toestemminggroeps'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemminggroeps'))));
  ___arguments.context.appData['toestemmingmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingmdopatz'))));
  ___arguments.context.appData['toestemmingscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingscholing'))));
  ___arguments.context.appData['toestemmingcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingcoaching'))));
  ___arguments.context.appData['toestemmingopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingopbouwinfra'))));
  ___arguments.context.appData['toestemmingcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'toestemmingcoordinatie'))));
  ___arguments.context.appData['plemailakkoord'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plemailakkoord'))));
  ___arguments.context.appData['plmaandcontroledossieraanmaker'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plmaandcontroledossieraanmaker'));
  ___arguments.context.appData['gvregistratiestop'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvregistratiestop'))));
  ___arguments.context.appData['gvpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvpostcode'))));
  ___arguments.context.appData['gvgeboortejaar'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvgeboortejaar'))));
  ___arguments.context.appData['gvgender'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvgender'))));
  ___arguments.context.appData['gvnietdeclarabel'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvnietdeclarabel'))));
  ___arguments.context.appData['gvnietdeclarabelconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvnietdeclarabelconsultinw'))));
  ___arguments.context.appData['plbudgetdetails'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plbudgetdetails'))));
  ___arguments.context.appData['naamprojectleidercoordinator'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'naamprojectleidercoordinator'))));
  ___arguments.context.appData['plmaandcontrolestatusdossier'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plmaandcontrolestatusdossier'))));
  ___arguments.context.appData['plmaandcontrolevrijwilligers'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plmaandcontrolevrijwilligers'))));
  ___arguments.context.appData['vrijwilligervergoedingreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'vrijwilligervergoedingreistijdkm'))));
  ___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'vrijwilligervergoedingreistijdminutenspeciaal'))));
  ___arguments.context.appData['vrijwilligervergoedingwerkminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'vrijwilligervergoedingwerkminuten'))));
  ___arguments.context.appData['plprojectkosten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plprojectkosten'))));
  ___arguments.context.appData['plakkoordvoorfacturatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plakkoordvoorfacturatie'))));
  ___arguments.context.appData['plakkoordvoorfacturatielorio'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plakkoordvoorfacturatielorio'))));
  ___arguments.context.appData['plemailinstellingenperregio'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plemailinstellingenperregio'))));
  ___arguments.context.appData['vrijwilligervergoedingov'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'vrijwilligervergoedingov'))));
  ___arguments.context.appData['gvreistijdpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvreistijdpostcode'))));
  ___arguments.context.appData['plcvlkenmerk'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plcvlkenmerk'))));
  ___arguments.context.appData['plmeldingdossiers'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'plmeldingdossiers'))));
  ___arguments.context.appData['gvgeboortedatum'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvgeboortedatum'))));
  ___arguments.context.appData['gvgemwoon'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'gvgemwoon'))));
  ___arguments.context.appData['aw2024'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'aw2024'))));
  ___arguments.context.appData['scholingvoorbereiding'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'scholingvoorbereiding'))));
  ___arguments.context.appData['activiteiten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69ad24e3a638ac8e70574e6110343989'), 'activiteiten'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/a0564e52e9e6239ef324f956fd72bfe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandakkoord', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plakkoordvoorfacturatielorio')) == '1' && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriolimburgpllieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriolimburgpljm')) {
    visible = true;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plakkoordvoorfacturatie')) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/df91c3c46783105892d3d05c473df381/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/s/i1mbWBvNXqU', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/a982bb37-b369-45f0-a24b-001f36295b8e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/4a2cb333-bde9-4351-844c-034bbebb1153', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/34e04f5a-d402-4ef9-a5aa-a86af96c1114', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/0ceee5a1-79b1-4162-b8dd-e5fd2644dd5f', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/57927e83-7651-441b-b84d-9d5313c7ad53', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/d303ac23-0411-435c-8782-fe241e35b283', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/9051f437-f1b5-43b2-874a-212186ffcd05', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpl2022', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2022'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'hoofdpaginaprojectleider',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2022',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/53da65d1b85bce3ed96b7bca198a38e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce219d3a081ebc7befa75f4cc9c927a7'), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce219d3a081ebc7befa75f4cc9c927a7'), 'centraname'));
  ___arguments.context.appData['naam'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce219d3a081ebc7befa75f4cc9c927a7'), 'naam'))));
  ___arguments.context.appData['objectid'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce219d3a081ebc7befa75f4cc9c927a7'), 'objectId'));
  ___arguments.context.appData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ce219d3a081ebc7befa75f4cc9c927a7'), 'btwplichtig'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/fd0ca608999bd675b40ec72d5956524b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgegevenspenvoerder', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/d5d2a4130019297e3c3117ae752d3016/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('relatiebestand', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/7fd4e164c7112717bc531845ab02aed5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossiertijdconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdconsultinwpro'))));
  ___arguments.context.appData['dossiertijdgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdgroepsconsult'))));
  ___arguments.context.appData['dossiertijdmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdmdopatz'))));
  ___arguments.context.appData['dossiertijdscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdscholing'))));
  ___arguments.context.appData['dossiertijdcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdcoaching'))));
  ___arguments.context.appData['dossiertijdcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdcoordinatietaken'))));
  ___arguments.context.appData['dossiertijdopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c22784157b36de1196caba5c4934bf5d'), 'dossiertijdopbouwinfra'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/22b2b23d5831c049a0094e5f4fc3ab55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).indexOf('lorio') !== -1) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/74f37f4333ff1bd4657e744c9af3baed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.appData['budgettotaal'] = (___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['totaal']);
  ___arguments.context.appData['budgetconsultinwpro'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['consultinwpro'])));
  ___arguments.context.appData['budgetgroepsconsult'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['groepsconsult'])));
  ___arguments.context.appData['budgetmdopatz'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['mdopatz'])));
  ___arguments.context.appData['budgetscholing'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['scholing'])));
  ___arguments.context.appData['budgetcoaching'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['coaching'])));
  ___arguments.context.appData['budgetcoordinatietaken'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['coordinatietaken'])));
  ___arguments.context.appData['budgetopbouwinfra'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('50552b4591d9c5ef5e0f833a20337c55')['opbouwinfra'])));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/25d6ef6fd16ebb710124f3447012a6ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['tariefconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'consultinwpro'))));
  ___arguments.context.appData['tariefgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'groepsconsult'))));
  ___arguments.context.appData['tariefmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'mdopatz'))));
  ___arguments.context.appData['tariefscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'scholing'))));
  ___arguments.context.appData['tariefcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'coaching'))));
  ___arguments.context.appData['tariefcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'coordinatietaken'))));
  ___arguments.context.appData['tariefopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'opbouwinfra'))));
  ___arguments.context.appData['tariefcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'coordinatietaken'))));
  ___arguments.context.appData['tariefreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'reistijdkm'))));
  ___arguments.context.appData['tariefreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['coachinginclbtw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'coachinginclbtw'))));
  ___arguments.context.appData['scholinginclbtw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'scholinginclbtw'))));
  ___arguments.context.appData['tariefcoordinatorschap'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a11d0eb8f3eab33fe2a41d75aa635ffe'), 'coordinatorschap'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/294d5049f41f5ab9dbe5be4c7a8a9fee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    name2 = 'Zuid Holland Noord';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    name2 = 'Nederland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/365d3c9f35a137ca3804ed1c1c2c413a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plmaandcontrolevrijwilligers')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolevrijwilligers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/4bf49442f42df5de0d15403bf5cca978/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkostenzwnl', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkosten', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkosten', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plprojectkosten')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/8a534b0143d8218952c593d135f2ebbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plemailprojectleider', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plemailinstellingenperregio')) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/bb342a6da5d47bb96f79e23e7eda3448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plbudget', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/7bfbb0077999fc06a6f60a2d44239b82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await ( async function (url, isExternal, params) { const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/spreadsheets/d/1Ife8rMudhmEV6Q0bCJEuPztS-kGuQzJfCadqTVruNs4/edit?usp=sharing', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/64d7774df6dae9a992efc626bedb37d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await ( async function (url, isExternal, params) { const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/spreadsheets/d/1HkvsrTaiFGi7wz1xyOD-ux1KGv0pM61Jl7iq3AqgC-k/edit?usp=sharing', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/1178e385b7fe862678569db3cfcdc9ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, alldatafromreglist, item, alldatafromreg, j, registratiedatalist, registratiedata, my_180_dagen, my_60_dagen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_60_dagen = '5184000';
  my_180_dagen = '15552000';
}


  registratiedata = (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum IS NULL OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum = \'\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum >=\'',((new Date((new Date()).getTime() - (5184000 * 1000))).toISOString()),'\''].join('')) }));
  registratiedatalist = (await Promise.all(registratiedata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')) });})));
  for (var j_index in registratiedatalist) {
    j = registratiedatalist[j_index];
    alldatafromreg = (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')) }));
    alldatafromreglist = (await Promise.all(alldatafromreg.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`gewerkteminuten`]: (getObjectProperty(item, 'gewerkteminuten')),[`voorbereidingminuten`]: (getObjectProperty(item, 'voorbereidingminuten')),[`reistijdkm`]: (getObjectProperty(item, 'reistijdkm')),[`reistijdminuten`]: (getObjectProperty(item, 'reistijdminuten')),[`reistijdminutenspeciaal`]: (getObjectProperty(item, 'reistijdminutenspeciaal')),[`aantalconsulten`]: (getObjectProperty(item, 'aantalconsulten')),[`totaalbedrag`]: (getObjectProperty(item, 'totaalbedrag')),[`reistijdoverijsselnr`]: (getObjectProperty(item, 'reistijdoverijsselnr')) });})));
    for (var k_index in alldatafromreglist) {
      k = alldatafromreglist[k_index];
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(k, 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(k, 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(k, 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(k, 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(k, 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(k, 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(k, 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(k, 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(k, 'reistijdoverijsselnr')) }) );
    }
  }
  (function (message) { alert(message) })('De dossiers zijn geupdate met de registratiedata');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/d9235d6b15efdbeb69e939e666ea81b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/ba82fc35-36ed-4aeb-9c85-30b59aa793ce', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/3dc7a781-5bf4-403d-9668-4bedb823b5f8', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/7bfc2352-c4ae-4912-b1c4-87bf60e3c550', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/89fd27dc-6383-45c5-ad61-3ee29fa8531e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/d02df328-1653-4ca9-8d0e-e01026223517', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/255eb36f-1856-4fd2-8e9d-9a6d057eb902', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/f8c2b970-ddaa-4c91-8ea2-f4cf53544b2d', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/1756253b-ad4e-4cbc-a858-01bc934a9b6e', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw76nbe') {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/cb63347d-caad-42b8-9279-b940b1416b37', true, undefined);
    } else {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/938343a8-bc38-486c-bdbf-98515bf6b4bc', true, undefined);
    }
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://datastudio.google.com/reporting/103e58b3-05d5-4e6a-a2e7-a23602f16f22', true, undefined);
  }
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpl2023', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2023'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'hoofdpaginaprojectleider',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2023',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/574cd2731569b6041bc8a319aa7b4882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'pldossiersaanmaken')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/0a028cffe4fbb1c15c5ba7e5d19321b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltarievenrotterdamlimburg', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltarieven', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/b4e4904f4fd316cd0e51444ba7695cc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/4d179e1e7c1d2e72f8813dbde516f908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekenquestio', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/0acc9fec77cc4814f41c9961157b3193/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossieroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/3c78a0cb7eeef84e8205b879cb92439c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1xCeEIAAW_PY9bJcqvMFUpK12DBsImvJL/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1hfNq4M_SAVknuJmVymJoI_K6t51o0Xp0/view?usp=sharing', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/100_mSdMFkIAvcRo4ac9Bp4F9BKgtKDv0/view?usp=share_link', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1WOeRBvjfyzPuQKSK7YK8UoqGKa_gSjes/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/971283dbebdb649e2ad3fe6201892761/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plupdates', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/ad1d6b081abc19dcf18f0eb66204ec0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).indexOf('lorio') !== -1) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmailsversturen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/2974acfc2a79c37e20febb3d6ecf52c1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('956e0735db536a026461c9c89788f618'), 'email'))];
  ___arguments.context.pageData['regiolist'] = [];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('956e0735db536a026461c9c89788f618'), 'email'))) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'regiolist')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('956e0735db536a026461c9c89788f618'), 'regio')));
    }
  }
  ___arguments.context.appData['regiolist'] = ((getObjectProperty(___arguments.context.pageData, 'regiolist')).join('\',\''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/63c882547302736303fff99c660e6212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/19c960914a5c35fd1c791d8e92ef7494/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, registratiedatalist, item, registratiedata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  registratiedata = (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (String('created after ') + String((new Date((new Date()).getTime() - (3024000 * 1000))).valueOf())) }));
  registratiedatalist = (await Promise.all(registratiedata.map(async item => {; return ({ 'dossier': (getObjectProperty(item, 'dossier')),'gewerkteminuten': (getObjectProperty(item, 'gewerkteminuten')),'voorbereidingminuten': (getObjectProperty(item, 'voorbereidingminuten')),'reistijdkm': (getObjectProperty(item, 'reistijdkm')),'reistijdminuten': (getObjectProperty(item, 'reistijdminuten')),'reistijdminutenspeciaal': (getObjectProperty(item, 'reistijdminutenspeciaal')),'aantalconsulten': (getObjectProperty(item, 'aantalconsulten')),'totaalbedrag': (getObjectProperty(item, 'totaalbedrag')),'reistijdoverijsselnr': (getObjectProperty(item, 'reistijdoverijsselnr')) });})));
  for (var j_index in registratiedatalist) {
    j = registratiedatalist[j_index];
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ 'registratiesgewerkteminuten': (getObjectProperty(j, 'gewerkteminuten')),'registratiesvoorbereidingminuten': (getObjectProperty(j, 'voorbereidingminuten')),'registratiesreistijdkm': (getObjectProperty(j, 'reistijdkm')),'registratiesreistijdminuten': (getObjectProperty(j, 'reistijdminuten')),'registratiesreistijdminutenspeciaal': (getObjectProperty(j, 'reistijdminutenspeciaal')),'registratiesaantalconsulten': (getObjectProperty(j, 'aantalconsulten')),'registratiestotaalbedrag': (getObjectProperty(j, 'totaalbedrag')),'registratiesreistijdoverijsselnr': (getObjectProperty(j, 'reistijdoverijsselnr')) }) );
  }
  (function (message) { alert(message) })('De dossiers zijn geupdate met de registratiedata');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/1fccb10ca9dcb9f2737b10d10d0d3339/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('relatiesdossiersregistraties', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/80814a72ff1cb9693ce94ba1768eab58/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;



  return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('relatiesusersdossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/383dc3cee396cf1f5c9e4534d3a1b43d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/2d1e8bbbd17d017d929ff895c8fd1774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/0419235228a2f88752ae062b46c88abc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, alldatafromreglist, item, alldatafromreg, j, registratiedatalist, registratiedata, my_180_dagen, my_60_dagen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_60_dagen = '5184000';
  my_180_dagen = '15552000';
}


  registratiedata = (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum IS NULL OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum = \'\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND controledatum >=\'',((new Date((new Date()).getTime() - (5184000 * 1000))).toISOString()),'\''].join('')) }));
  registratiedatalist = (await Promise.all(registratiedata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')) });})));
  for (var j_index in registratiedatalist) {
    j = registratiedatalist[j_index];
    alldatafromreg = (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')) }));
    alldatafromreglist = (await Promise.all(alldatafromreg.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`aantalconsulten`]: (getObjectProperty(item, 'aantalconsulten')),[`gewerkteminuten`]: (getObjectProperty(item, 'gewerkteminuten')),[`voorbereidingminuten`]: (getObjectProperty(item, 'voorbereidingminuten')) });})));
    for (var k_index in alldatafromreglist) {
      k = alldatafromreglist[k_index];
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(k, 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(k, 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(k, 'gewerkteminuten')) + (getObjectProperty(k, 'voorbereidingminuten')) }) );
    }
  }
  (function (message) { alert(message) })('De registraties zijn geupdate met de dossiergegevens');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/c37cd962318b428292ca23fe924115dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, registratiedatalist, item, registratiedata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  registratiedata = (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (String('created after ') + String((new Date((new Date()).getTime() - (3024000 * 1000))).valueOf())) }));
  registratiedatalist = (await Promise.all(registratiedata.map(async item => {; return ({ 'dossier': (getObjectProperty(item, 'dossier')),'aantalconsulten': (getObjectProperty(item, 'aantalconsulten')),'gewerkteminuten': (getObjectProperty(item, 'gewerkteminuten')),'voorbereidingminuten': (getObjectProperty(item, 'voorbereidingminuten')) });})));
  for (var j_index in registratiedatalist) {
    j = registratiedatalist[j_index];
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(j, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(j, 'gewerkteminuten')) + (getObjectProperty(j, 'voorbereidingminuten')) }) );
  }
  (function (message) { alert(message) })('De registraties zijn geupdate met de dossiergegevens');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/5675f3130efe09095117030a6381d488/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/b50b511e6f48cfdf8f71a8784f18250f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plexports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/a09690511f6564e7eb8638e85db84263/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plmaandcontrolenietdeclarabel')) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolenietdeclarabel', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/397bba3c1f02862212d6c4e2398e6add/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nietdeclarabeldatalist, item, nietdeclarabeldata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  nietdeclarabeldata = (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) }));
  nietdeclarabeldatalist = (await Promise.all(nietdeclarabeldata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`aantalconsulten`]: (getObjectProperty(item, 'aantalconsulten')),[`gewerkteminuten`]: (getObjectProperty(item, 'gewerkteminuten')),[`voorbereidingminuten`]: (getObjectProperty(item, 'voorbereidingminuten')) });})));
  for (var j_index in nietdeclarabeldatalist) {
    j = nietdeclarabeldatalist[j_index];
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(j, 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(j, 'gewerkteminuten')) + (getObjectProperty(j, 'voorbereidingminuten')) }) );
  }
  (function (message) { alert(message) })('De nietdeclarabel registraties zijn geupdate met de dossiergegevens');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/bda386957b381b4a5bff926ff23c2733/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('68ea93f9154de03951e39ddd2e595cba'), 'centra')), 'plmaandcontrolenietdeclarabel')) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandakkoordnietdeclarabel', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/a1a744fcd1a6a17ffcbf2987bc31e9fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenquestiostart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/37a309ed9f15209a7efbd69b051210d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('logbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/9b84f388faed75f7134310d52dab6088/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenbrabantstart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/f113ee0a93cd9d59f2d47071af9795ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('loriomaster')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plpermissions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/eef13c6134a4425d348f292a84470367/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2024'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'hoofdpaginaprojectleider',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2024',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpl2024', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/b4753a7aab3e0fb7b91b7a5d40d14b5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, dossierdatalist, item, dossierdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dossierdata = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) }));
  dossierdatalist = (await Promise.all(dossierdata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`cvlkenmerk`]: (getObjectProperty(item, 'cvlkenmerk')) });})));
  for (var j_index in dossierdatalist) {
    j = dossierdatalist[j_index];
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ [`cvlkenmerk`]: (getObjectProperty(j, 'cvlkenmerk')) }) );
  }
  (function (message) { alert(message) })('Cvl kenmerk zijn toegevoegd aan de tabel registraties');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/953f40b114b728e9bf2e9e3d7ae55cfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkennietdeclarabelstart', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/7d6b12b6fd14d885fe7f6de7ce2dc806/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('overzichtgvquestio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/1e3e638adc64a4dd328414288dc525d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('overzichtgvinstellingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/6e528cedd63cb1fbc947f6f8f9c29496/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var originele_code;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'overzichtgv')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/ui-builder/containers/Ontwikkelomgeving/index.html?page=overzichtgvquestio')), true, undefined);
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('overzichtgvquestio', undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/ui-builder/containers/Lorio/index.html?page=overzichtgvquestio')), true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/ad7d27d9d4ced402f39feabe3b2fbb35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolegegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/533e50b9c74e4c526a3d4bae703c823f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukkenlorio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/a1fead1a97edd244050d271f2d533902/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2025'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'hoofdpaginaprojectleider',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2025',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpl2025', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/a18f7dc9ce48f466ace9f04ba6363e34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/9369ffeac5b28fca6d134e37330f83db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025landelijk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/beb903bbdeec681241393b8eaadc8fbe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/ui-builder/containers/Lorio/index.html?page=overzichtgvquestiobeperkt')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'overzichtgv')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/8b184f08015877b7aca9ce9536e83cf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('bibliotheekquestio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/c39cb1d86d28d4b889a2455815d873cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'bibliotheek')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('bibliotheekquestio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/d8729722dcc93a641d38c7c8fa61c048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2026'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'hoofdpaginaprojectleider',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2026',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpl2026', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/5dc3e148f8d84378479878f83a4210b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltarievennietdeclarabel', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var list, nietdeclarabelcentra, visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  nietdeclarabelcentra = (await Backendless.Data.of('nietdeclarabeltarieven').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')))));
  if (nietdeclarabelcentra == 0) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/c158c588dca867ffe00e0698418cd2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardlandelijk2025', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ge04bat' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Wi01bat' || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/9d78cfe8c1286d98e3911914bf38e851/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2026', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginaprojectleider/components/27d89f5eeeb89f6651124af87d684c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2026landelijk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5666f7325d8196b0c2cb9d946bd061a', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f5a9022a7c0122f7bf326301f2d2b2ad', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('96e87ae74d5559c4a8a29a1b2f3eba76', (await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('69a1f0d5cf9cbe7b1477f49822e49aef', (await Backendless.Data.of('settingspakketminuten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8dc3c1c6026f6e2b08cdf384e56f0fe', (await Backendless.Data.of('settingsmaxtijden').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.appData['startpagemijndossiers'] = 'consultzorgvrager';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP2, TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function old() {
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    TEMP2 = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
    if (TEMP2 == 0) {
      await Backendless.Data.of('factuurnummers').save( ({ [`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/f068c95fd3abaca43ccde8de29d7e7c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/ebd66eb2634d5292f113186f324c41fc/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/d8fb1569c4184c94efc2f1cfc6197a49/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.appData['user'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['username'])));
  ___arguments.context.appData['centraname'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['centraname'])));
  ___arguments.context.appData['naam'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['naam'])));
  ___arguments.context.appData['objectid'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['objectId'])));
  ___arguments.context.appData['btwplichtig'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['btwplichtig'])));
  ___arguments.context.appData['btwinclconsulten'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['btwinclconsulten'])));
  ___arguments.context.appData['organisatie'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['organisatie'])));
  ___arguments.context.appData['emailgv'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['email'])));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/902746e53706a00682e4d76d4af433f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })([(___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['username']), (___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['centraname']), (___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['naam']), (___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['objectid']), (___arguments.context.getComponentDataStoreByUid('4fd906c6f0450cb1b0c820240f58bc32')['btwplichtig'])]);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/b8c934d32c3c838b403978446a46eeaa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['setcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'coaching'))));
  ___arguments.context.appData['setconsultinw'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'consultinw'))));
  ___arguments.context.appData['setconsultpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'consultpro'))));
  ___arguments.context.appData['setcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'coordinatietaken'))));
  ___arguments.context.appData['setgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'groepsconsult'))));
  ___arguments.context.appData['setmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'mdopatz'))));
  ___arguments.context.appData['setopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'opbouwinfra'))));
  ___arguments.context.appData['setscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'scholing'))));
  ___arguments.context.appData['setreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdkm'))));
  ___arguments.context.appData['setreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdkm'))));
  ___arguments.context.appData['setreistijdminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdminuten'))));
  ___arguments.context.appData['setreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['setuitlegtijdconsultinw'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdconsultinw'));
  ___arguments.context.appData['setuitlegtijdgroepsconsult'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdgroepsconsult'));
  ___arguments.context.appData['setuitlegtijdmdopatz'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdmdopatz'));
  ___arguments.context.appData['setuitlegtijdscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdscholing'));
  ___arguments.context.appData['setuitlegtijdcoaching'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegtijdcoaching'));
  ___arguments.context.appData['toestemmingconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingconsultinwpro'))));
  ___arguments.context.appData['toestemminggroeps'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemminggroeps'))));
  ___arguments.context.appData['toestemmingmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingmdopatz'))));
  ___arguments.context.appData['toestemmingscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingscholing'))));
  ___arguments.context.appData['toestemmingcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingcoaching'))));
  ___arguments.context.appData['toestemmingopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingopbouwinfra'))));
  ___arguments.context.appData['toestemmingcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'toestemmingcoordinatie'))));
  ___arguments.context.appData['gvpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvpostcode'))));
  ___arguments.context.appData['gvgender'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgender'))));
  ___arguments.context.appData['gvgeboortejaar'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvgeboortejaar'))));
  ___arguments.context.appData['naamprojectleidercoordinator'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'naamprojectleidercoordinator'))));
  ___arguments.context.appData['vrijwilligervergoedingreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'vrijwilligervergoedingreistijdkm'))));
  ___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'vrijwilligervergoedingreistijdminutenspeciaal'))));
  ___arguments.context.appData['vrijwilligervergoedingwerkminuten'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'vrijwilligervergoedingwerkminuten'))));
  ___arguments.context.appData['vrijwilligervergoedingov'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'vrijwilligervergoedingov'))));
  ___arguments.context.appData['gvreistijdpostcode'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'gvreistijdpostcode'))));
  ___arguments.context.appData['uitlegreiskostenvergoeding'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'uitlegreiskostenvergoeding'));
  ___arguments.context.appData['selfbilling'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'selfbilling'))));
  ___arguments.context.appData['plmeldingdossiers'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'plmeldingdossiers'))));
  ___arguments.context.appData['reistijdbtwupdate'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('99c85a470cf2b086bef56a3a7c9ceb1c'), 'reistijdbtwupdate'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/01051102fa7b3944af6ad53c857ed9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermaandoverzichtkwitantie', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/07eeabe47f04884152ef377187355a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['setreistijdkm']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/a87f6cec431ebe934c48a972edd28cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/833552a5a82aa32f1a7b8c03dec897b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijngegevens', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-mijn gegevens geopend'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginavrijwilliger',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'mijn gegevens geopend',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/112b8869e6ba83be228d391500c99ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a')['centraname']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a')['centraname']) == 'Lorio') {
    name2 = 'Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('531dcba306a9952862d7b076f5b5251a')['centraname']);
  }

  return name2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/bb39a855d802ef4b974cb925c75228bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/de9eb36ffd99adb6118e9132788fad98/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.appData['dossiertijdconsultinwpro'] = (JSON.stringify((___arguments.context.getComponentDataStoreByUid('f1f277714abbfd36e8435fcab38dcdcb')['dossiertijdconsultinwpro'])));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/ed4c8be2e73880a7d75b141c74f21a3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/document/d/1tykemopl_3aZCxFpnTpuRUnBJAR33dUr/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/5d283148ec27d14303e8c6d462c3f5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/ba82fc35-36ed-4aeb-9c85-30b59aa793ce', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/8f486422-c508-449b-89ad-f983f115abd1', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('', true, undefined);
  }
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2023'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginavrijwilliger',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2023',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardvw2023', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/8a52a9591f024b19f3ccfb710b04ef6a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.appData['maxtijdconsultinwpro'] = (JSON.parse((___arguments.context.getComponentDataStoreByUid('e2dd64f3f1a95a1452f335da752f6afb')['maxtijdconsultinwpro'])));
  ___arguments.context.appData['maxtijdreistijdkm'] = (JSON.parse((___arguments.context.getComponentDataStoreByUid('e2dd64f3f1a95a1452f335da752f6afb')['maxtijdreistijdkm'])));
  ___arguments.context.appData['maxtijdreistijdminutenspeciaal'] = (JSON.parse((___arguments.context.getComponentDataStoreByUid('e2dd64f3f1a95a1452f335da752f6afb')['maxtijdreistijdminutenspeciaal'])));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/d644effc400ff9d5951d3bffa3cecd89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerjaaroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginavrijwilliger/components/309f8cda54d40011978b7543fa075ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dashboard geopend 2024'].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'hoofdpaginavrijwilliger',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dashboard geopend 2024',[`dossier`]: undefined,[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardvw2024', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/impactmeting2025/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2025/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2025/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/8288fc6b-9a40-430d-b0bc-1713fec2e6e0/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/40041f96-d4bb-4d2e-9dcd-eb653411fc30/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/ab89b9d9-8279-4bc6-b440-925ccbab601d/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/d9ef3cc9-a86d-48c7-98fb-ad09020e9d47/page/p_lelo77uwpd';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/f5de73a8-3a75-4f62-9429-718baabe3c78/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/76587512-3a04-4b55-8dc9-2d0da4dc9e10/page/p_scwtlkswpd?cacheOverride=true';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/417403b7-0754-496c-813a-4e8bc59c9eac/page/p_lelo77uwpd';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/878515ad-05cf-4418-9ec7-54e23edcc3fe/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/642b080e-6ada-4b10-8791-db3f74901bb3/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/94f77492-d0ca-415f-ba8f-73f6467e9856/page/p_lelo77uwpd';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/515ca047-3019-47cd-a3c1-566110a94c44/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3c57f334-edbb-46a8-a2c6-d0e45b8241f6/page/p_scwtlkswpd';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/364c6835-750d-4867-aa3f-2738cc756163/page/p_lelo77uwpd';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e0871e1f-e297-4967-bedc-b98e9a9bdf69/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/3f218db0-dcd1-4ad1-a5a9-05ffdc0c0cd1/page/sSprE';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/impactmeting2025/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/impactmeting2025/components/56e74a8813cfb57533c456d13c87fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2025landelijk/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2025landelijk/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2025landelijk/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9b03dbe0-6379-4523-9fe2-2df53fa27335/page/sSprE';
  } else {
    URL2 = '';
  }

  return 'https://lookerstudio.google.com/embed/reporting/9b03dbe0-6379-4523-9fe2-2df53fa27335/page/sSprE'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/impactmeting2025landelijk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/impactmeting2025landelijk/components/56e74a8813cfb57533c456d13c87fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/6d004524-e758-41f3-b054-1608c725d0e3/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/b25dcd07-6d41-4810-831e-a38b775d861c/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2c20998b-6b39-4a5a-b17a-c562b802a70f/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/06b99155-2ff8-4963-b748-edf6d645a5ef/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/fc2791d3-ac17-4dbe-92dc-6c7994d623e1/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/819d1d4c-a6c5-410d-ae8a-5e7cfd1a5926/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/a19f63cb-c7a9-4d18-9b03-f0371906b24a/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/48d501b0-92a5-4d70-b5cc-a1bb860e8473/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/29cbfd0f-8ebe-4903-a031-67f6258e0260/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/c425e8e8-d557-46c4-83f8-16b9d7b26faa/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/253ec6bb-5873-4571-a389-97ffa213e4df/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/2077f97d-f953-423b-a9f3-8e6744fe21e2/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/e1f7c636-54c5-41a3-a552-465cd8ddbbfa/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/501f0b0e-2454-4ed7-aea2-f91f6eec4f28/page/sSprE';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/9af3d2cf-8703-468a-9a08-f8f600134404/page/sSprE';
  } else {
    URL2 = '';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/impactmeting2026/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/impactmeting2026/components/56e74a8813cfb57533c456d13c87fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026landelijk/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026landelijk/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/impactmeting2026landelijk/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Willem' || (getObjectProperty(___arguments.context.appData, 'dashboard')) == 'Rotterdam') {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/5cc957cb-81ae-46ec-8225-3c4953295cbc/page/sSprE';
  } else {
    URL2 = '';
  }

  return 'https://lookerstudio.google.com/embed/reporting/5cc957cb-81ae-46ec-8225-3c4953295cbc/page/sSprE'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/impactmeting2026landelijk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')) || ((await Backendless.UserService.getUserRoles()).includes('Dashboard')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/impactmeting2026landelijk/components/56e74a8813cfb57533c456d13c87fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12c454e2886534edcf4393894d22219', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a69240f4cce6798bf5d2c918c74c2f4', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ce3e81b02364eaa3c0c11e2f895e801')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7dfd192d040ea3656b0b8c42084ff3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/9b250b5ac5ef73d362b40c5ef967bc42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#89b087';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/8abb41ce996c4b251fb9cfd598ae3f9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await Backendless.UserService.logout();
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), true);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'XXX') {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkostenaccountant', undefined);
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve') {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
        }
      } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
      }
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0ea61c9bfc8fb45df3185d0f605189d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/00c12203fb5fb62c8d517401c5968862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/77d4cd5b03ce4fa924a3a199f5ada20a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(Backendless.appPath),'/users/restorepassword/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))].join('')))).setEncoding('utf8').send();
  (function (message) { alert(message) })('Er is een mail verstuurd met een link om het wachtwoord te resetten.');
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
    ___arguments.context.pageData['disablesave'] = false;
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/4f2245f981527212512785617151e579/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1xl0oNrQeA1VH4N_7Umts60cdCS9d6tiD/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/95d19f3d8665986da435aebb07a71f37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/831d9fccba2fc33e270757b870a4372c/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).close() })('831d9fccba2fc33e270757b870a4372c');

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inlogpagina/components/6b02c88374f5e98b8da10f973529ab8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/6ae5ef2342a35bbf050ab6ce019b8bec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/Gebruikersvoorwaarden Lorio v1.0.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtbrabant/components/2d250e94ca2b8adb232615dfb234d9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e342686d623c17947bf28c8b0ff3896', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'  AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'jaar')),'label': (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'jaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
      return (['https://cvl.lorio.nl/api/files/logos/',((await Backendless.UserService.getCurrentUser(false))['username']),'.jpg'].join(''))

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/eecfe8d6f4886bf2623a02d4fc5eab06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/79f2db1319d87741c7cd74270e82be6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/04aad222b0dfd884950345cde4229a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/39441101bc1a21f55fee816eeb47f5c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/5c9a55730b67c0452efd9dec676d36f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/50a7cfdf4c1a9f69f63c258b9fe73c6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1e342686d623c17947bf28c8b0ff3896/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/2d157c257869bcf7e933b58483aef312/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtdrechtsteden/components/1c34141fed07828ba03a7fc340a20ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash > \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichthaaglanden/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult zorgvrager\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult professional\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31e94fd517fad2960fd76a72ea73de09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c885cfe2a662eb88815fc40d608cc0c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('249a94090452464ed76ed4efd5b7f69f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult zorgvrager\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult professional\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9126596225392b68fedacb850871413b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be8d1a0a0eb384e8341478c5781b824a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('271a7ec626f8e67956ff291ad95e072b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Scholing\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('672ea4df0deb3147fc327bba22b91fb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'MDO/PaTz\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Scholing\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setGroupBy('jaar').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash < \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31e94fd517fad2960fd76a72ea73de09', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9126596225392b68fedacb850871413b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('672ea4df0deb3147fc327bba22b91fb1', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31e94fd517fad2960fd76a72ea73de09', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9126596225392b68fedacb850871413b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('672ea4df0deb3147fc327bba22b91fb1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
    C = 'Korte omschrijving';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
    G = 'Omschrijving scholing';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    H = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
  } else {
    C = 'Gender';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B && (item['title']) != C;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'organisatie'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/876ec113e94ff3b6525dcd897d43af18/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a86ad95e4d5b0352def5a19829944ea5'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/f12534bff813000e0e926ccc45b784de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7d46b9951e3216aa7c4353796c242ca'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/9e672b07a34f0152f76757f6eb5f0f21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminuten')) != 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/08c84519e1a7610915eb906a758e692b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a86ad95e4d5b0352def5a19829944ea5'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/935ed56957b70c31f338eda57f09a9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('977d79c6080484fe44b7b3699e92adce'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/a4736e0b415a66dc658e851fcb0bf235/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b33830854a63176f796cdaef02437711'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/25e1dda81062376de35ec6cd584e6115/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('977d79c6080484fe44b7b3699e92adce'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/d4c3187b27f60e48fb573746dd48f67e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a87b5228534bd46786291c525068d017'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/ebf2381bc409ed6eb8ee440c57375547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b33830854a63176f796cdaef02437711'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/d2841996084111887a39978afd230c09/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66e6deaef41df539c1cffdf148859bc'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/31e94fd517fad2960fd76a72ea73de09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;



  return (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31e94fd517fad2960fd76a72ea73de09')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/c885cfe2a662eb88815fc40d608cc0c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c885cfe2a662eb88815fc40d608cc0c3')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/249a94090452464ed76ed4efd5b7f69f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('249a94090452464ed76ed4efd5b7f69f')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/a7d46b9951e3216aa7c4353796c242ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/a87b5228534bd46786291c525068d017/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel/components/a66e6deaef41df539c1cffdf148859bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fd4bd8f97574ef1644f16db86ebbdcb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw) as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash > \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f14f8f2f8b9175332287b88fcd6df2fa')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['exclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/fd4bd8f97574ef1644f16db86ebbdcb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/095200e6fd1535ef2d0814fb392433f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/1b6e497830ccbe74e7d729ced87e88e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/9297f9c5fa6f1c7ba93f411d75498bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/e8eee9e75e6a99790e51277c966abeef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtoverijssel2024/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaarselectie')) == null) {
    content2 = 'Jaaroverzicht ';
  } else {
    content2 = String('Jaaroverzicht ') + String(getObjectProperty(___arguments.context.pageData, 'jaarselectie'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','VWS','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('350300a482e1fe88fa1864189c87b3bb', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Financiering gemeente Amsterdam','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
    await format();
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/d56d9182ba1e1f2893a6f32a3277f921/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = 'Consult cliënt';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/350300a482e1fe88fa1864189c87b3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('350300a482e1fe88fa1864189c87b3bb')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/b8831a0ba359899c2875dc765c9a2f45/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = 'Consult cliënt';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit'));
  }

  return (String(return2) + String(' KOT affaire'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/8016ae17a79af987bb555598d326d32f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminuten'));
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/fb7c037e9302d71298ae974b3f564c93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'tariefperminuut')) * 60;
    await format();
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/e7e106d34bf1592da00c8043df2fe919/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtquestio/components/a71124a25959433ce35a1c9e4f88b5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws<>\'Nee\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1f4d2aab5d7cde0dd0d927c76cdd1eb5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('71c950e80329614b1a08b835af5ce26d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fbc69b7d949306365bcabed8ce05c319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'Consult zorgvrager\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f11dff78bb94658555cda631b48ee96', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fdffe5223e9abeae0b17217a9584e73d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('284b366eb8b312dd89c2887935817fb6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a349402bfd6237db389129954ab1a9c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' '].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0c06d7cd18ad9e67f3cd42242bd9930e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41ff3b7eb7814efcaa213ee25cc3e0a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04b64dc468ea8e19de7a5d02e73a2d26', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fda7052fe1d1f8b2236fda9c7b01de97', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aab997318a09409b831c17d42d0a4649', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('180e83cdeb3cd7c5c14b0b5d462804b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc95a09c6a4115e2196e44acc17dee1', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'jaar')),'label': (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'jaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/2a3744db2d39a0f38f84e47f709197e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/558ccb4b347138b388b8b2dfc6356695/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c6e9635c891c6e3a70ea9085f57a7eea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/750930777078a42df5085041102b681e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/32ace18c06537d180831f9d3f41d9011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/53bb7d1ffd09e90de2cf3305621eaba9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c24371ee5c657c7d9e6c0b06d451506d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0c9ba9c76382ef54dc295ea49e26dd79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/ad6ba834d83f6cba2da6b15d7fc2ab74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/281f88b92af464964dfadfa9162cb1ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f5d565a585ef73d58e1fb2291cdef67f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8f5db1aa67fcf5373083509802720339/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/19fb3f1f2737ba682c7f2ae77c1e024a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/7dde52a604e4a2d1f599d2e7123887a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a95c06fb4598e88ee499e44267094449/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0644c44f03fceebabf8f8b72ade2d59f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/687456a8575fe93e48030c5ebcc92d12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/3983c66d42ec4ad9f1983c5785fd7dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/e246f231300ee74bc938be16aa483186/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/531cde561f3da025bd595e751c27d602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/520359e4c7f80e16756716b22c9cabd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8ebe1325253434d76d134261271f94fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/ff8cc9c670c162bbeb4dbea1b1f644c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/9224658f241147fae6d81af813a47afd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0c06d7cd18ad9e67f3cd42242bd9930e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6c2b3cc697da3b7aed1e0ae5dcdc47bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8f11dff78bb94658555cda631b48ee96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/210a4446cc8dd5f7c0c6dc8516aff91a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/41ff3b7eb7814efcaa213ee25cc3e0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/71c950e80329614b1a08b835af5ce26d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/fdffe5223e9abeae0b17217a9584e73d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f6fe3b1944e975553fb1fbb9863b1d24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/04b64dc468ea8e19de7a5d02e73a2d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/fbc69b7d949306365bcabed8ce05c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/284b366eb8b312dd89c2887935817fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/521b455fb2640a8fe6e4359106c3eead/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a349402bfd6237db389129954ab1a9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/aa289e34a6c3e6a1925fb57fbee1f563/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/d739b42d4073b8177a76efbebb7ba67b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/b7d5973296be117105521ddd0001fb54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f761aa41091454bf728bcc1312699991/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/cb789b94fd7e4c3217e86ba9f8dc2df6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/e32b522d24f79d2c7f56687f01dff468/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/16498df1282374434642494414e4cada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a7ee3bdf64ee3171075c6467c56571af/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7ee3bdf64ee3171075c6467c56571af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/d01c35d25ae6a39568984d6157c553a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6ab891ed58f47a7a5531f06288ae1c26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/41f537e9747b0577bdee2abc25b6c635/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/619d951fd09bc4793c4c3781249aa3e4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('619d951fd09bc4793c4c3781249aa3e4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/615f8805a5749e5f2a5d8e93a845e0a3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('615f8805a5749e5f2a5d8e93a845e0a3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a72bdcacd71e91daa1e1243fa0c1285f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f42b3be9ce887083b81e7712d641ecc'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0df6a9a2373468971022f78f561637c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c6bb8d997636ba843ff17f10319aa68'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/ca2226b7963c5258aa68311661a893e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18b599ee2d786077920712e57597f1a3'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/622c994a7c58345f82f69ac66cb39a53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('622c994a7c58345f82f69ac66cb39a53', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/245bd7a4191728768474579a4c1e1a9c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('245bd7a4191728768474579a4c1e1a9c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8ecaf544e2f34556c487683a5f9ddd5d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/72dbfe0bd02da9fe25324d8da3fd5439/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/395efac6a9320919644299ef79f253ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/5c4c6d02601e586571913a63643f8721/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/965edb0c0c5456bdaba28cbc73d9be71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/28f4266b7c0fb07a2c779e9f8511ed0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/6a36f1acc94d84f2d8f525729b068097/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/4908b91e4b824b319a9e06d982acb3df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4908b91e4b824b319a9e06d982acb3df', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f5ef5669df27ecb4a7f84b9f49ff8102/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/783ccd87c10238e52547e319f9c42196/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/809248d2c76e9a5d8d3103df80d1a035/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/132dc05fa9facce6542b5adb562d8e24/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/87e76f5cb99d5b25530bec34e8d15378/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/e96179628c3b44e6cc9f8551b957967d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/dbe95b43ac5af80b474f07556a088a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/484540e5dabdc37318ef1a05df8acae5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/080729f791fee87f1065442affbc9cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/df2cd44542371254347e6453639ea089/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/94bc865961a1662e0f0cfa2862496c1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c391da74d72e9391b7813122fa37401c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/1209dcab0383fea6c9d4e1bde47c47a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1209dcab0383fea6c9d4e1bde47c47a5', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0313aa339fc39c341d4da0722017616f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/04e5958dcafd67997f3add2fe065298a/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/1067219e319f3c37cbeedef87a980acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0313aa339fc39c341d4da0722017616f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbe95b43ac5af80b474f07556a088a0d')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('484540e5dabdc37318ef1a05df8acae5')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/c20795538be3991ac1223d9bb0249b09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/b765eb6f0122d899a5b5cc54dfc1acbf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b765eb6f0122d899a5b5cc54dfc1acbf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/777912f371e2e0421302f306ce78cb89/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('777912f371e2e0421302f306ce78cb89', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/0303a567855b9ae6678e79418ce5458e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0303a567855b9ae6678e79418ce5458e', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/484793826f8c07d194efef09905bc219/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('484793826f8c07d194efef09905bc219', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/204c448c0256f419e016d44d22b77a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('204c448c0256f419e016d44d22b77a9d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/e3089d6c4e2393cdf9e5e868b1c47abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/60ba84733abcbc2a857f13b68cc1f8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/f7db815535632651395b977afb7c5f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/a3de41b9fc790b44908df7b252fa3bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/067dd82481efb99de78c5588076a0c31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/9abfbf11965396eeb1596a2789d59e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/8f860ece470e9c6c7b87c05830c566a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('361277e739cc3d0fe712886302aab4d1'), 'activiteit')) + String(' (fonds buiten VWS)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/d93cc20a122a13c2d6645a3a62630477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('361277e739cc3d0fe712886302aab4d1'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/bb961ab145f414bfd2bdbb9d6d95c50e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('361277e739cc3d0fe712886302aab4d1'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/490d705e88b2e02a5df4e9120bb651ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('361277e739cc3d0fe712886302aab4d1'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtrotterdam/components/20df7e92c4fcb12e1871e9ca8ec68f55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('361277e739cc3d0fe712886302aab4d1'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND totaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/92aaccb79c1f35081c53a0a64f8ca4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/ec03c4d9109502bf844fed64d7aeaea5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtsichtpunt/components/b5482ac8dbcbb3a95867a7c6c9bed426/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4ca26abcfafe7674c0b871a41f5e1236', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e903aa8b144d3403f2b66c68f005028f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca859ee97f3aef1a25bc397f60bfb51a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c9c6698e4e433219949d06668891fb66', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('82be34524fd2f216490eafd22e8fa6d9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e13c93811b1afd450c5803a723e64b1d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d82202582be52335bf5742975df110ce', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5eab13b3e05c73b687aa70a394b256d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('996f0daaf56e482640b4f3c73a9f5be4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('96affb6754fbd3692af50c5b222a44d3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('501dedb70fa1b26f3f19ca4e25328472', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31b33654aae3112db1d8d5326a5ac571', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ce722455663ab75aa9a81eed3c3ed85', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('132d54612ebe10b3a12985e66923fde7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddbc115796bdf0d9859c529d7ec38696', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11633fede17bb80b6e2622ac157b9bb9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c5c6c846ab7db55c098ed67efc68d84d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2ea687d52b0c7fc638992a98c692b787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('26d3db2487dd14b2d8d569c2bb0f4837', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'jaar')),'label': (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f329285a6c5f9b17cd26a38cfabbd09c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a519e519fdac0038e6e7a6051af808c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe2d81d8b588959792e536bf5bbac835', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68610e87996e08eb4069b8926e5b9449', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9cd3acc36abf15e6be38c169b9d7a45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b6a418c5ddbaf36a10167f48467c107', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efb07a26849937d5c5e0a31b2be75cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a278bf9851ed39d7f7392ffc4bd86cf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4caf7b21f3621bef4a84729ffaa68c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('167398eb5217c71350bbef3ad2179244', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51855a06ccb9d241ded789898e2af82c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dba812d37c6f2deb4cef49258e1c9bf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f188db4dfbf9bc42864c0e5ee06acd11', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e903aa8b144d3403f2b66c68f005028f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9c6698e4e433219949d06668891fb66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e13c93811b1afd450c5803a723e64b1d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('996f0daaf56e482640b4f3c73a9f5be4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ce722455663ab75aa9a81eed3c3ed85', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5c6c846ab7db55c098ed67efc68d84d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca859ee97f3aef1a25bc397f60bfb51a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cdfa16b8e45f03debba2896c54b37575', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c4ff071fac6e9f2b48fd75e89c81c6c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96affb6754fbd3692af50c5b222a44d3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('132d54612ebe10b3a12985e66923fde7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea687d52b0c7fc638992a98c692b787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3f03940750e8692bd397aec8f56ee147', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82be34524fd2f216490eafd22e8fa6d9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d82202582be52335bf5742975df110ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('501dedb70fa1b26f3f19ca4e25328472', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddbc115796bdf0d9859c529d7ec38696', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26d3db2487dd14b2d8d569c2bb0f4837', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'jaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f329285a6c5f9b17cd26a38cfabbd09c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a519e519fdac0038e6e7a6051af808c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2a278bf9851ed39d7f7392ffc4bd86cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e903aa8b144d3403f2b66c68f005028f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ca859ee97f3aef1a25bc397f60bfb51a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true' && (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ca859ee97f3aef1a25bc397f60bfb51a'))['reistijdminutenspeciaal']) != 0) {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/fe2d81d8b588959792e536bf5bbac835/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f4caf7b21f3621bef4a84729ffaa68c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c9c6698e4e433219949d06668891fb66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/82be34524fd2f216490eafd22e8fa6d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/68610e87996e08eb4069b8926e5b9449/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/167398eb5217c71350bbef3ad2179244/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e13c93811b1afd450c5803a723e64b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d82202582be52335bf5742975df110ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a9cd3acc36abf15e6be38c169b9d7a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/51855a06ccb9d241ded789898e2af82c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/996f0daaf56e482640b4f3c73a9f5be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/96affb6754fbd3692af50c5b222a44d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/501dedb70fa1b26f3f19ca4e25328472/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/7b6a418c5ddbaf36a10167f48467c107/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dba812d37c6f2deb4cef49258e1c9bf6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0ce722455663ab75aa9a81eed3c3ed85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/132d54612ebe10b3a12985e66923fde7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ddbc115796bdf0d9859c529d7ec38696/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6efb07a26849937d5c5e0a31b2be75cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f188db4dfbf9bc42864c0e5ee06acd11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c5c6c846ab7db55c098ed67efc68d84d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2ea687d52b0c7fc638992a98c692b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/26d3db2487dd14b2d8d569c2bb0f4837/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9b4603d130741334d2ed2b8830169b3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3e18c667d26484adc9580669ad73e613/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/65c64bb69b5ff7fea7997928ee32d931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2e5c240b35c773dd93eb20cff9d4d0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3c035ba75883a838535b01b882fef483/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a52f124d9c141c07bf512f0cfbadcb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1c8e5112dd8685aa82149f370b0485d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/25e9bae62bea998e734fe8b792556da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9f1d6f5a6834a7994622ae7d1be323df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5548a0edceaf8f42cb9c69c2675afa02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ac7d29a256f991a290a8e3b93b2a4f82/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/144da5569cd95e5eb5ddfa94251f375d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/957a55a90af9f4077ced6035e15bab7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/94dd724811fe1b0234c8d3e60b458b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/beab1f97950bc1ce4a69dec583a4437d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/26713369fa44ce474fc9101c8f061923/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d17a599febeb88c725c4c0160a541a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/13d4ed3b6c6f5edad16c5c372cb85f28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e0c757a6a823f3ae02d33d7ea74a6904/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/91c32792c1f4db24988c442e8b5255fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/78f1f78742c665ae5cd2bd93fe0f4e32/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2a7e9f466f6b18830998a8f40516091b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cef1a6fb06d27c7659c6a8bae371b111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dcb4386ff1cb75015c42b6fe360af5e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/aca7f995e5dedb6b275a0bd7609cf5d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b886794b684355a2effdb8829a125a91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f53f98954ea95501f3771103b7fc85a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4b23f6dc9c382ceb59acefe5e36935fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/17fb835ebd443ddafcb849bb76c71df3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d503aa038fd506bf8af33f61066b3c79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/be7a89a976a51817d0e9b9e2e68188af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1d98e22219b749756c255cf4e474e518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c17a5feebdb145ff9cbad6f56e9e754f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0195aaaf9e2231575e41b1ef2fb74682/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0c564489372f96f3088f6c0d574fce64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4dc20a6ecf148ff3dac47c2433b56c34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/081fd7efd4e9c0ed193146caf1f69124/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4f9bda37199a5b55620397b91f6d74d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f60238a1a9971adb892fb16bdaad3afa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f92c6985597e6a7c00131df5fe7abf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/871d3162f234ab9784eb98b57ad4583a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ff9f6e4ce7a4e4240779b687efffbd97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ef537a1362b9f9a75d86f84c8c91b8a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a4c12559a08c0a6c81754b55918ab10d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4d69af7c50a271e860d3d50159af351e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d8b4830a5252ae46260614f3533cada8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e8dde48dadfe77de123f38e854c1ec75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3ca3b2ea045b0f9a22ddaa2aae1277a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ac7fa8db03f4d5d9900d836e7d544b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9c67592b131c0c56df06f53afdcd1697/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f6a7cba71f95a05d6e534195166432a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3f0c059830dd98588623f6aa131e7af2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/561dc5788c94ebdfdbe61c0b6c5e6477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d057a152858e47730ed2aa97261fdcb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8e15d01f788508d2a75e75d3ea818692/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5ce171bd1f0362f16eebe6e1b957ff9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/fcb82cb579e8f7ef6b8ca1e826def4cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/684fa9b94f0aaa18b726ab06f35e0829/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d645fdde004c109e2de60ce376fbe71f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3bb17105818c7599f0a6dfba60b89ee1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/84720fa9d13c76a5adc85b4ef4d91808/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b4d6bf4e17212c66f4416249b7b4727b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4a11f4c275a2843549732abad72cf6bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/49036b6637d8c28ba25c7db9efcbbe28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6785856e6a760d222de9ba2bc8dd5ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/aa0454ec5f091e44d4ce87de15846785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/7cd968d58d4f89bddc8ceab95cc65277/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1f64747c2779cfeb81b170180872afb8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/989444e28659721dd4aa1eccc8263625/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/da0f04f2f142c1dd0e8c1944419bf6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2d6af192a86eb14ca2cae27af767b518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c172f6acbc0d78ecd4a373553d49b182/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a4db25bd4b4337594efa1371d9c51e07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/eb87497d9aeeea75caee67ddfafa8665/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/756fa1390b839f5c024f0597e378d621/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cd45eb285732615b117847699e181ab4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b262e212c2155dada3f6e95455bf4c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2432d3af8fbc42f28ae40de71f6faee6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0bd8406f8e4faaf5fceb4d818b85b686/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a77b5887c952877bd735878bb992b729/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f3fb2e23bf932b1906a384a7153dc205/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c845197f0fc35dbfeb8c6c98333ef1ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2984d513cd39409d1b54143aef68396d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ee4a8b1d7a353da74f58c3788dcddc39/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8fe524e5067dffe39b624b526f2537e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8844e49f73ead24d9847ae91dbbc3e46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/7bd63c7f1cf86359a731f09eae6d5d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/92725a4638d19ef3ccc35353a60e3b1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/647442a4c84933a36b8b2014ca6393c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2d7fad35c89bab376d75273ff634eb84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c447c01cea2434132b062bd48b5a6f4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4ca26abcfafe7674c0b871a41f5e1236/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a5eab13b3e05c73b687aa70a394b256d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/31b33654aae3112db1d8d5326a5ac571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/11633fede17bb80b6e2622ac157b9bb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/533e623612af08f8e701be55658999ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/02f98e570e018fc3eec433dcc17c055b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/aa87e0ff7f899bd13e51daf13a79cf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5455648e4a32ebef60b83d4f76632bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/08f4b99cc45946991c1af374fde242fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/be9d99cb32cdb557ae79276626fad7f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/38428a9f27153a6d407f04f1943f1b83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/925c0eab36f9c4a1b2f11e8634444f88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/8ea961b38952a49a4c04751d18f8ee1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6fc2aadcdb068f7b57482be1bdb43b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/176d636dad32bc54c11ff2671442cf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/ece242b6591d663f35587841822f0542/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/94a6c2499561cb7765bc14f67fe923cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/617f4ec45e7ecbf55e5c2a4eb9eb3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/e8aa74fb1af76ddfb926b70e23e93906/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c812df5549badbe57caf4f6df8baa284')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5151e632e8559142b5b63cabf4096c9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('669a1894ed2ad848c731e3a20d8a06fc')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c0de0145869c46bc1b4681032aea4d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('618d1598a108cc4738d5f1bdb594e2ad')['totaalbedrag']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1500 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur') {
    name2 = 'Factuur opmaken';
  } else {
    name2 = 'Kwitantie opmaken';
  }

  return name2

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6f1f3a15f38822e6885d32c247cb5916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c8e79d6b48425e220e2aadd303e8d8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8e79d6b48425e220e2aadd303e8d8c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/aef1860512aba914470657b98753f4ee/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aef1860512aba914470657b98753f4ee', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/90a6c1643fa86c2c0ac4e56124dacca9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('90a6c1643fa86c2c0ac4e56124dacca9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6316a176ced64b33fbe5043d4c74ad3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6316a176ced64b33fbe5043d4c74ad3e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/0baa2e3d13e3c7568f3e92ec80569c62/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0baa2e3d13e3c7568f3e92ec80569c62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/c684b73d1c7297048c52c3c2636de2a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c684b73d1c7297048c52c3c2636de2a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/866690a969ad906c8fea3d636b3f0642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/a06ad44747effd1d679e85910d8ca6e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/344722532556d88dd1545cbc7b869c69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtutrecht/components/dff3a3182cb5fb4a522946123a3f5bad/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdb48cb7b722b473d8e30cfe484e59e5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash < \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'jaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordgv')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden door de geestelijk verzorger..');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/2fff1586bef1c782cf9924c883e7d2d7/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (String('Vink het vak hier aan indien u akkoord bent met het maandoverzicht, indien u niet akkoord bent neem dan contact op met de ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'maandakkoordgv': 1 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 1;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'maandakkoordgv': 0 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 0;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d419bf1a39243bbb719fa87cc53dcf94/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandakkoordgv'] = (getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cdb48cb7b722b473d8e30cfe484e59e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'true' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/a14be1b519cb307d449fce45f60440e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash > \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtwillem2024/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaarselectie')) == null) {
    content2 = 'Jaaroverzicht ';
  } else {
    content2 = String('Jaaroverzicht ') + String(getObjectProperty(___arguments.context.pageData, 'jaarselectie'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
}

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/2d250e94ca2b8adb232615dfb234d9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/694d4e98c6bb630ebbad504b89faaec7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/337af00d82184f168087c25e2381c0ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/28c7b7521b21a9176593d853821d52db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/7ea10e9b23a4cf3225be7963eaf635f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/83d334cd8557fee8a5883da47c36cfca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83d334cd8557fee8a5883da47c36cfca', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/b41c38494112003136bdcb0efd16a71a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b41c38494112003136bdcb0efd16a71a', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzhn/components/ce49ea287066af5ce07d85d4742e2a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('89e83c2438291ba89ae8dd489698cdb8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d24672180fd88f04ba38228e55e318b8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
}

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/2d250e94ca2b8adb232615dfb234d9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/694d4e98c6bb630ebbad504b89faaec7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/337af00d82184f168087c25e2381c0ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/28c7b7521b21a9176593d853821d52db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/7ea10e9b23a4cf3225be7963eaf635f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/83d334cd8557fee8a5883da47c36cfca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83d334cd8557fee8a5883da47c36cfca', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b41c38494112003136bdcb0efd16a71a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b41c38494112003136bdcb0efd16a71a', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/ce49ea287066af5ce07d85d4742e2a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaarselectie')) == null) {
    content2 = 'Jaaroverzicht ';
  } else {
    content2 = String('Jaaroverzicht ') + String(getObjectProperty(___arguments.context.pageData, 'jaarselectie'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/4be148f68c189b384d7819d80d234e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54d2f3f849a8bb254e98fc6536989db8'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/a9c40338db6306a1f7088172e408f2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7df214ee318ab4eb8fa992c2dc31088'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/894ddda880b4499835ec65bd0bd87d5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54d2f3f849a8bb254e98fc6536989db8'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54d2f3f849a8bb254e98fc6536989db8'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/1ec3e4087154c9e962a83dc6bc796e0f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7df214ee318ab4eb8fa992c2dc31088'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7df214ee318ab4eb8fa992c2dc31088'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/98780aedc32494180c0ba4d85958a6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54d2f3f849a8bb254e98fc6536989db8'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvol/components/c9b3c898e533a326b318da2f94884efc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7df214ee318ab4eb8fa992c2dc31088'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
}

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/2d250e94ca2b8adb232615dfb234d9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/694d4e98c6bb630ebbad504b89faaec7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/337af00d82184f168087c25e2381c0ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/28c7b7521b21a9176593d853821d52db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/7ea10e9b23a4cf3225be7963eaf635f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/83d334cd8557fee8a5883da47c36cfca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83d334cd8557fee8a5883da47c36cfca', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b41c38494112003136bdcb0efd16a71a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7ea10e9b23a4cf3225be7963eaf635f2', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b41c38494112003136bdcb0efd16a71a', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/ce49ea287066af5ce07d85d4742e2a9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzinvolbackup/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaarselectie')) == null) {
    content2 = 'Jaaroverzicht ';
  } else {
    content2 = String('Jaaroverzicht ') + String(getObjectProperty(___arguments.context.pageData, 'jaarselectie'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dc752a9cfccfe424bd3c295c71ca7aa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a452a2313cf9da84975f129d875d6657', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('abda89071b1ae8d4056646d86474e809', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6685c69631b23ffa2ba44b7846f344a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a1020cf99491e01d669a05c9370e8f62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81b85319aad158479a3176c684c545e7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ec3c02502b158785c517d465c3eca3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('076afe8a9ce3ed8ba2482a621ed90414', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9e67cbefecdf0a671de89e8f6fc76df1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81e9d7ed281fb148b2365574cf0886dc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b5a12b140bddea8b06eb464bca3db3a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('407c6331b21887412b5f264675c30dd3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8b82f752b67c5634fa40c31c09e5b6b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dd9dce125eea425b03258c1198dce7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13e4826d82034bc9e4247d21d37aa978', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d5c3feae8f33f272f0ee446d26a473a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a2a1635fd64a205b329fcf244b3fe7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c03643ab0730496f0ec146fbf673f1f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('34bb1337b28c2d954352839117a20bbe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa28702f23efabb158315bba195a8eea', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcc485a69b0237917be73bb7c892a46e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('796e4014856c76a63adb9b8cb38d197a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash < \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW1'] = false;
  ___arguments.context.pageData['VIEW2'] = false;
  ___arguments.context.pageData['VIEW3'] = false;
  ___arguments.context.pageData['VIEW4'] = false;
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'jaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    await ( async function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    await ( async function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    await ( async function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    await ( async function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    await ( async function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    await ( async function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    await ( async function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    await ( async function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    await ( async function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    await ( async function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
      await new Promise(r => setTimeout(r, 1000 || 0));
      await (async function() {
      	window.print()
      })();
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      await new Promise(r => setTimeout(r, 1000 || 0));
      await (async function() {
      	window.print()
      })();
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['file'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/312add2812dfe17b78f7b302c45e9059/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7b99fc997a8f4cb31f0afe9b2aba4e3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a70418ca86828dfc27df7e5e20058446/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/fa6fde96e573561527f4c7058ace30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/653d92711bffde05540e64fdf05b661b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/443c6a642218240c4749609aa327ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/36ea339cac3eacfc470790de84c9ea06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/48a3e37975e432924a4b87ba62826a37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/2c2707b4307d6201822e796275884508/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a452a2313cf9da84975f129d875d6657/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a452a2313cf9da84975f129d875d6657')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/81b85319aad158479a3176c684c545e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('81b85319aad158479a3176c684c545e7')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/34bb1337b28c2d954352839117a20bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('34bb1337b28c2d954352839117a20bbe')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7dc752a9cfccfe424bd3c295c71ca7aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7dc752a9cfccfe424bd3c295c71ca7aa')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/abda89071b1ae8d4056646d86474e809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('abda89071b1ae8d4056646d86474e809')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/11ec3c02502b158785c517d465c3eca3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11ec3c02502b158785c517d465c3eca3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/aa28702f23efabb158315bba195a8eea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aa28702f23efabb158315bba195a8eea')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6685c69631b23ffa2ba44b7846f344a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6685c69631b23ffa2ba44b7846f344a5')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/076afe8a9ce3ed8ba2482a621ed90414/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('076afe8a9ce3ed8ba2482a621ed90414')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/dcc485a69b0237917be73bb7c892a46e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('dcc485a69b0237917be73bb7c892a46e')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a1020cf99491e01d669a05c9370e8f62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a1020cf99491e01d669a05c9370e8f62')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9e67cbefecdf0a671de89e8f6fc76df1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9e67cbefecdf0a671de89e8f6fc76df1')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/796e4014856c76a63adb9b8cb38d197a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('796e4014856c76a63adb9b8cb38d197a')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f7a9ecc117b643a150c51e857c9c4e56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/590d3008f53318fc05b98bf4829868df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/071b427b1eb4f6a196eb414cc12a1573/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/859c8fcc4f9c8cd2d3cda09eb58950ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8a79a88bc503b1bf0424b18545e386c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5538429343523a697f34c8817d564533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e1d430f48ddf15b8e1befe036bcf0fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/eec49f8b2aee792432c7888dfa26b4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/bcd79968c97a343d7e6d34973dabba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f42ee7bdf989b59248034508f4c40996/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/648b0a6778b2b5f11f59c87c04674372/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4518dfcfa766a9caee4a41fd405ace1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b08f83ef72360015d1e460e8f5aa9358/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/2223646c3793c68fd45b0181f6845c69/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cc583438c387dd8d2f3a524d8e18231d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d1c6fed523e676d1f588e741a66640c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e562576afbca1decb9b1fc3b1566a3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/0a9452f50ba74bc88db484f986821724/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b2977c780ac21b99499e1fa1ca74255f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/56c35752782b4d7bcd3b9d3255c4cf6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/051d19bc9277554844d40534d399be5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/bd97b931fcbd85391cd8e566f20e832f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5811694bd03c64dce1019f0440f9f6a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/538c74dafbe6c73f41e96d29a56c2eca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9ccc2e349dd8cb7bdd7aac85c60275e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/0c3982a94f0dbd43a27c43f4e25dff5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/557917afb53bc122a1d996495037d6f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f349e6784f1a93d153eb1ae9252da201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/0d25b96ae8bff27d3865723c656a78fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a9af21650257d813b1038474a9320df5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a3e27ff971056c61ac3a3c9f08a2f153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cee564d45661dc2d1a62f90bcb22ca03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9299951da81ff8ebed57492d7dff2f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7dd9dce125eea425b03258c1198dce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5fe7f9ceb53b968c6c86d5ebc37420f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a03fb9e2b05df8efe3e95d06bb2d06af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5906d4762ed9b411e6bed347abffc71d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7c112cf6114e802258967966a4fb565d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'START')) == false) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/ca933cb7d3c90dbeeb6d5ed940453389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d6f65ac6cb3a711ea16a701db221c8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/51d63bc5e8ce88f63b3f68492594d255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8c913b77f7df8d36dcbbc765e8f312cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8e9afed82806dcfbc7eaa4268f21b947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7ba78e0845a96c66ee2ed77263fda1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/57a4e1edddb50da4592d3b71fed2659c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5d0ade29fe3a85955b0b2a9722e423d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f80b691361d569d97df9c2c5854b537d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/38bc9e4fc786fcc36e04d136e5ed2c04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/493131ad499e5c15496636746912f5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/987402ad2de3352e3224d7ab96316f86/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/64ba3bed2ebea56b9112c878fcd6de55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/177654ba7ace4e789c67e2e454df01d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e02a34fb9bfdc8ac20e72d04e5f3b118/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/cc21e3582de70b4551ccf53973e3b784/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/67091fb6510814aaa3e9c00fa9336008/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/04219b5eb03ba8f4407e236a5baedde7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/bad4db33177b074e613504723b830365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/02e65db5bdde359934d29c83131e4154/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/397fc0df33f3b4efbc45ca645f25eb49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/3129b24f3a1d5d9a138c74b204634acc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/55f117fbeb35fffaf25340aadc084f07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c5d6961480c6c21f7313457355499192/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/81e9d7ed281fb148b2365574cf0886dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c4297219ae9c8d948ad25ab4cc76663b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a0270e6598b9c11dff44f3061613ab54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/407c6331b21887412b5f264675c30dd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/7a32f1dae0d74fe93808a7291f7a958d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/579d49945e2fae5bfc4347c88dece931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/f273eee26972969b6111d908c4a79b95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/dc5ace4a7a6fadff15ccea07ef62c97a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c773d9d3e8357a5f40a1e628c1633ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1125ea4a2dd9c523568317d9bd4a1f11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/13e4826d82034bc9e4247d21d37aa978/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/2a2a1635fd64a205b329fcf244b3fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/0fdfabf1e7c81689bf8c22d41b788fda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4d4dff51210990a5a5b3b89d35fb062e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5f27e9e60f24d27125336dc9a563da7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1332e17b3d8909ce093225e80576dfc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/168a958dcc682723c11d8a5bd21c666b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/fff7517f93962816c01acfb45e491213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/6b5a12b140bddea8b06eb464bca3db3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e8b82f752b67c5634fa40c31c09e5b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/8d5c3feae8f33f272f0ee446d26a473a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/4c03643ab0730496f0ec146fbf673f1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a71f7745e15eebc8e11102ab68aa7eab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/19bd630731024763009ceed7bf28af45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/dd2f5d971f51e5bd3f8c15aed895be07/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/ab5e049cfaf261dd6d9cbe388df8f00b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a60e072e790e64cdf25be63dc574a1c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/e40bfa1cdad637111b4e4f87ceb8ef5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/af0ba216d8875658efdad9361cf72592/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/5d967d048b3c0bb740a9512c6e09c479/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1712661fcc8d4a75c33a3a051093fcbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/33b2e376f3d48547aa9fb3688291c227/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/aa76f8acc4854fc877d2e8ecc638e8af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/14ba4956f04be3e9df54602a4dffd645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/90232421addac742871a476242edf713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/1d8fd598bab5424a184634cf83cd7e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/a6e45a59b30e18cc8ebbff5b0a2f9d73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/75e6264b6a06970df052fcebcfb7c62f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl/components/c8db3c54e94e7ac4df159bb3cd520c89/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dc752a9cfccfe424bd3c295c71ca7aa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a452a2313cf9da84975f129d875d6657', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('abda89071b1ae8d4056646d86474e809', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6685c69631b23ffa2ba44b7846f344a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a1020cf99491e01d669a05c9370e8f62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81b85319aad158479a3176c684c545e7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ec3c02502b158785c517d465c3eca3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('076afe8a9ce3ed8ba2482a621ed90414', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9e67cbefecdf0a671de89e8f6fc76df1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81e9d7ed281fb148b2365574cf0886dc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b5a12b140bddea8b06eb464bca3db3a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('407c6331b21887412b5f264675c30dd3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8b82f752b67c5634fa40c31c09e5b6b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dd9dce125eea425b03258c1198dce7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13e4826d82034bc9e4247d21d37aa978', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d5c3feae8f33f272f0ee446d26a473a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a2a1635fd64a205b329fcf244b3fe7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c03643ab0730496f0ec146fbf673f1f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'jaar', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('34bb1337b28c2d954352839117a20bbe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa28702f23efabb158315bba195a8eea', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcc485a69b0237917be73bb7c892a46e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('796e4014856c76a63adb9b8cb38d197a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash > \'12/31/2023\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW1'] = false;
  ___arguments.context.pageData['VIEW2'] = false;
  ___arguments.context.pageData['VIEW3'] = false;
  ___arguments.context.pageData['VIEW4'] = false;
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
      await new Promise(r => setTimeout(r, 1000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      await new Promise(r => setTimeout(r, 1000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['file'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/312add2812dfe17b78f7b302c45e9059/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7b99fc997a8f4cb31f0afe9b2aba4e3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a70418ca86828dfc27df7e5e20058446/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/fa6fde96e573561527f4c7058ace30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/653d92711bffde05540e64fdf05b661b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/443c6a642218240c4749609aa327ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/36ea339cac3eacfc470790de84c9ea06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/48a3e37975e432924a4b87ba62826a37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2c2707b4307d6201822e796275884508/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a452a2313cf9da84975f129d875d6657/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a452a2313cf9da84975f129d875d6657')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/81b85319aad158479a3176c684c545e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('81b85319aad158479a3176c684c545e7')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/34bb1337b28c2d954352839117a20bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('34bb1337b28c2d954352839117a20bbe')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7dc752a9cfccfe424bd3c295c71ca7aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7dc752a9cfccfe424bd3c295c71ca7aa')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/abda89071b1ae8d4056646d86474e809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('abda89071b1ae8d4056646d86474e809')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/11ec3c02502b158785c517d465c3eca3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11ec3c02502b158785c517d465c3eca3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/aa28702f23efabb158315bba195a8eea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aa28702f23efabb158315bba195a8eea')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6685c69631b23ffa2ba44b7846f344a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6685c69631b23ffa2ba44b7846f344a5')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/076afe8a9ce3ed8ba2482a621ed90414/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('076afe8a9ce3ed8ba2482a621ed90414')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/dcc485a69b0237917be73bb7c892a46e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('dcc485a69b0237917be73bb7c892a46e')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a1020cf99491e01d669a05c9370e8f62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a1020cf99491e01d669a05c9370e8f62')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9e67cbefecdf0a671de89e8f6fc76df1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9e67cbefecdf0a671de89e8f6fc76df1')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/796e4014856c76a63adb9b8cb38d197a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('796e4014856c76a63adb9b8cb38d197a')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f7a9ecc117b643a150c51e857c9c4e56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/590d3008f53318fc05b98bf4829868df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/071b427b1eb4f6a196eb414cc12a1573/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/859c8fcc4f9c8cd2d3cda09eb58950ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8a79a88bc503b1bf0424b18545e386c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5538429343523a697f34c8817d564533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e1d430f48ddf15b8e1befe036bcf0fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/eec49f8b2aee792432c7888dfa26b4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/bcd79968c97a343d7e6d34973dabba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f42ee7bdf989b59248034508f4c40996/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/648b0a6778b2b5f11f59c87c04674372/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4518dfcfa766a9caee4a41fd405ace1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b08f83ef72360015d1e460e8f5aa9358/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2223646c3793c68fd45b0181f6845c69/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cc583438c387dd8d2f3a524d8e18231d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d1c6fed523e676d1f588e741a66640c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e562576afbca1decb9b1fc3b1566a3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/0a9452f50ba74bc88db484f986821724/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b2977c780ac21b99499e1fa1ca74255f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/56c35752782b4d7bcd3b9d3255c4cf6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/051d19bc9277554844d40534d399be5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/bd97b931fcbd85391cd8e566f20e832f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5811694bd03c64dce1019f0440f9f6a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/538c74dafbe6c73f41e96d29a56c2eca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9ccc2e349dd8cb7bdd7aac85c60275e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/0c3982a94f0dbd43a27c43f4e25dff5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/557917afb53bc122a1d996495037d6f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f349e6784f1a93d153eb1ae9252da201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/0d25b96ae8bff27d3865723c656a78fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a9af21650257d813b1038474a9320df5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a3e27ff971056c61ac3a3c9f08a2f153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cee564d45661dc2d1a62f90bcb22ca03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9299951da81ff8ebed57492d7dff2f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7dd9dce125eea425b03258c1198dce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5fe7f9ceb53b968c6c86d5ebc37420f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a03fb9e2b05df8efe3e95d06bb2d06af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5906d4762ed9b411e6bed347abffc71d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7c112cf6114e802258967966a4fb565d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'START')) == false) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/ca933cb7d3c90dbeeb6d5ed940453389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d6f65ac6cb3a711ea16a701db221c8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/51d63bc5e8ce88f63b3f68492594d255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8c913b77f7df8d36dcbbc765e8f312cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8e9afed82806dcfbc7eaa4268f21b947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7ba78e0845a96c66ee2ed77263fda1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/57a4e1edddb50da4592d3b71fed2659c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5d0ade29fe3a85955b0b2a9722e423d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f80b691361d569d97df9c2c5854b537d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/38bc9e4fc786fcc36e04d136e5ed2c04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/493131ad499e5c15496636746912f5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/987402ad2de3352e3224d7ab96316f86/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/64ba3bed2ebea56b9112c878fcd6de55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/177654ba7ace4e789c67e2e454df01d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e02a34fb9bfdc8ac20e72d04e5f3b118/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cc21e3582de70b4551ccf53973e3b784/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/67091fb6510814aaa3e9c00fa9336008/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/04219b5eb03ba8f4407e236a5baedde7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/bad4db33177b074e613504723b830365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/02e65db5bdde359934d29c83131e4154/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/397fc0df33f3b4efbc45ca645f25eb49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/3129b24f3a1d5d9a138c74b204634acc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/55f117fbeb35fffaf25340aadc084f07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c5d6961480c6c21f7313457355499192/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/81e9d7ed281fb148b2365574cf0886dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c4297219ae9c8d948ad25ab4cc76663b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a0270e6598b9c11dff44f3061613ab54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/407c6331b21887412b5f264675c30dd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/7a32f1dae0d74fe93808a7291f7a958d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/579d49945e2fae5bfc4347c88dece931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/f273eee26972969b6111d908c4a79b95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/dc5ace4a7a6fadff15ccea07ef62c97a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c773d9d3e8357a5f40a1e628c1633ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1125ea4a2dd9c523568317d9bd4a1f11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/13e4826d82034bc9e4247d21d37aa978/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2a2a1635fd64a205b329fcf244b3fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/0fdfabf1e7c81689bf8c22d41b788fda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4d4dff51210990a5a5b3b89d35fb062e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5f27e9e60f24d27125336dc9a563da7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1332e17b3d8909ce093225e80576dfc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/168a958dcc682723c11d8a5bd21c666b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/fff7517f93962816c01acfb45e491213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/6b5a12b140bddea8b06eb464bca3db3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e8b82f752b67c5634fa40c31c09e5b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/8d5c3feae8f33f272f0ee446d26a473a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/4c03643ab0730496f0ec146fbf673f1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a71f7745e15eebc8e11102ab68aa7eab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/19bd630731024763009ceed7bf28af45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/dd2f5d971f51e5bd3f8c15aed895be07/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/ab5e049cfaf261dd6d9cbe388df8f00b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a60e072e790e64cdf25be63dc574a1c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e40bfa1cdad637111b4e4f87ceb8ef5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/af0ba216d8875658efdad9361cf72592/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/5d967d048b3c0bb740a9512c6e09c479/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1712661fcc8d4a75c33a3a051093fcbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/33b2e376f3d48547aa9fb3688291c227/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/aa76f8acc4854fc877d2e8ecc638e8af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/14ba4956f04be3e9df54602a4dffd645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/90232421addac742871a476242edf713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/1d8fd598bab5424a184634cf83cd7e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/a6e45a59b30e18cc8ebbff5b0a2f9d73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/75e6264b6a06970df052fcebcfb7c62f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/c8db3c54e94e7ac4df159bb3cd520c89/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/2a498d29f06a3c5f36c83fd55ff4a7e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/e0a63f773da915cdd23d62e1efc34c66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/070296ef3d1b908f5c1ea4c1926b1857/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/jaaroverzichtzwnl2024/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaarselectie')) == null) {
    content2 = 'Jaaroverzicht ';
  } else {
    content2 = String('Jaaroverzicht ') + String(getObjectProperty(___arguments.context.pageData, 'jaarselectie'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/kmoverzicht/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kmoverzicht/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/kmoverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/kmoverzicht/components/2c0b77c8cc1e1b7c611ec294e8972fc6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2c0b77c8cc1e1b7c611ec294e8972fc6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties(['maand', 'sum (reistijdkm) as reistijdkm ']).setSortBy('created').setGroupBy('maand').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/kmoverzicht/components/8a76a7a418676a341a6dfa642febf29f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8a76a7a418676a341a6dfa642febf29f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties(['jaar', 'sum (reistijdkm) as reistijdkm ']).setSortBy('created').setGroupBy('jaar').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/logbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/logbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/logbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/logging/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/logging/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/logging/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandoverzicht2022/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fd4bd8f97574ef1644f16db86ebbdcb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw) as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash < \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/maandoverzicht2022/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f14f8f2f8b9175332287b88fcd6df2fa')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['START'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzicht2022/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/maandoverzicht2022/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht2022/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['exclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht2022/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/eecfe8d6f4886bf2623a02d4fc5eab06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/79f2db1319d87741c7cd74270e82be6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/04aad222b0dfd884950345cde4229a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/fd4bd8f97574ef1644f16db86ebbdcb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/095200e6fd1535ef2d0814fb392433f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/1b6e497830ccbe74e7d729ced87e88e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/9297f9c5fa6f1c7ba93f411d75498bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/e8eee9e75e6a99790e51277c966abeef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht2022/components/cc0195aa184fb09f28e136cdf01db535/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/maandoverzicht2022/components/3a85dc3679e8eb5e960ac4e8c2ecc651/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht2022/components/791d7e15058891ed0443ffe6df0e91ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Triage/intake') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/d69362155b4b8f52a4f1ea153bd8c7b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtbrabant/components/43c8cd197e0cb33f54469ed3a9863ca3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e342686d623c17947bf28c8b0ff3896', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'  AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['START'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = '550px';
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/eecfe8d6f4886bf2623a02d4fc5eab06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/79f2db1319d87741c7cd74270e82be6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/04aad222b0dfd884950345cde4229a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/39441101bc1a21f55fee816eeb47f5c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/5c9a55730b67c0452efd9dec676d36f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/50a7cfdf4c1a9f69f63c258b9fe73c6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d157c257869bcf7e933b58483aef312'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1e342686d623c17947bf28c8b0ff3896/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/2d157c257869bcf7e933b58483aef312/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/e8a206d8823407c59959057ea8441e89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/17ZoX3_9GE2p-i1H1ElafF4diQ_VmQD1o/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/1c34141fed07828ba03a7fc340a20ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/f181e16890742fadcb9703c3c166f06c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtdrechtsteden/components/4e68eda188a7aa6ef1a7421653b57f57/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'De declaratie is verzonden naar de budgethouder.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
    C = 'Korte omschrijving';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
    G = 'Omschrijving scholing';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.print()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtenlimburg/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND totaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND created> \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/92aaccb79c1f35081c53a0a64f8ca4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichthaaglanden/components/e0018c759e4e72b5481ab4f219b89b19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1hcvKLF7EBy9f-_K2iGSHK_Ol_zwDdAoG/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var financieringlist, item, financiering;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = '%';
  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\'  AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  if (false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdb48cb7b722b473d8e30cfe484e59e5', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));
  }
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  financiering = (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties('financieringstroom').setSortBy('financieringstroom').setGroupBy('financieringstroom').setPageSize(100)));
  financieringlist = (await Promise.all(financiering.map(async item => {; return (getObjectProperty(item, 'financieringstroom'));})));
  ___arguments.context.pageData['financiering'] = (String('Financiering: ') + String(financieringlist));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND created> \'03/31/2024\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['financieringstroom'] = '%';

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c4d2f4b68c29f3f2e9eac7de04c2744')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordgv')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden door de geestelijk verzorger..');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '550px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/0f6f5d12a49dcee86098c5b309eab404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1DEt2emJykOIjC7oJlckw93lThjsOP1ZF/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1Vn9rAkEn9YzUCKi7LhjuYRSL3eEvNh8u/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cdb48cb7b722b473d8e30cfe484e59e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'true' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/a14be1b519cb307d449fce45f60440e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/f5b558f94d86f6af0b3e4dc90b5e4123/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('financieringstroom').setSortBy('financieringstroom ASC').setGroupBy('financieringstroom').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'financieringstroom')),[`label`]: (getObjectProperty(item, 'financieringstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var financieringlist, item, financiering;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\'  AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  if (false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdb48cb7b722b473d8e30cfe484e59e5', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));
  }
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  financiering = (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties('financieringstroom').setSortBy('financieringstroom').setGroupBy('financieringstroom').setPageSize(100)));
  financieringlist = (await Promise.all(financiering.map(async item => {; return (getObjectProperty(item, 'financieringstroom'));})));
  ___arguments.context.pageData['financiering'] = (String('Financiering: ') + String(financieringlist));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/b69a0a21272d7e86154b49fc8e7af3f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroom')) == '%') {
    item = 'MAANDOVERZICHT - ANDERE FINANCIERINGSSTROOM';
  } else {
    item = String('MAANDOVERZICHT - ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));
  }

  return item

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/e60b545e9ee11b114ef5d66db2f6e3fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = '%';
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdkm) as reistijdkm', 'Sum(financieringnietdeclreistijdkmexbtw)as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw) as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclwerkenvoorminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\' AND financieringnietdeclreistijdkmbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdkmexbtw) as reistijdkmexbtw', 'Sum(financieringnietdeclreistijdkmbtw)as reistijdkmbtw', 'Sum(financieringnietdeclreistijdkmtotaal) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  if (false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdb48cb7b722b473d8e30cfe484e59e5', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));
  }
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringstroom LIKE\'',(getObjectProperty(___arguments.context.pageData, 'financieringstroom')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/1293a0c9955e546ede7645147fc444b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financiering'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabel/components/d271fb33ac2340d25ff5685cffe177c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    text = 'Aantal registraties';
  } else {
    text = 'Aantal activiteiten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function was_code_voor_reistijdminuten___niet_gebruikt() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminuten', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminuten', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dd9dce125eea425b03258c1198dce7c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminuten', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\''].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminuten', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dc752a9cfccfe424bd3c295c71ca7aa', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a452a2313cf9da84975f129d875d6657', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('abda89071b1ae8d4056646d86474e809', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6685c69631b23ffa2ba44b7846f344a5', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a1020cf99491e01d669a05c9370e8f62', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81b85319aad158479a3176c684c545e7', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ec3c02502b158785c517d465c3eca3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('076afe8a9ce3ed8ba2482a621ed90414', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9e67cbefecdf0a671de89e8f6fc76df1', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81e9d7ed281fb148b2365574cf0886dc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b5a12b140bddea8b06eb464bca3db3a', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('407c6331b21887412b5f264675c30dd3', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8b82f752b67c5634fa40c31c09e5b6b', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13e4826d82034bc9e4247d21d37aa978', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d5c3feae8f33f272f0ee446d26a473a', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a2a1635fd64a205b329fcf244b3fe7c', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c03643ab0730496f0ec146fbf673f1f', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminuten) as reistijdminutenspeciaal', 'Sum(financieringnietdeclreistijdminutenexbtw)as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw) as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('34bb1337b28c2d954352839117a20bbe', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa28702f23efabb158315bba195a8eea', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcc485a69b0237917be73bb7c892a46e', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('796e4014856c76a63adb9b8cb38d197a', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7a8f888152816d8a3b8dc676f282d08', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Coördinatietaken\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eaf1ece286784dcdc04649c4ff6b5c36', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Coördinatietaken\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(financieringnietdeclwerkenvoorminuten) as gewminuten', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND financieringnietdeclwerkenvoorminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND financieringnietdeclwerkenvoorminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclwerkenvoorminutenexbtw) as gewerkteminutenexbtw', 'Sum(financieringnietdeclwerkenvoorminutenbtw)as gewerkteminutenbtw', 'Sum(financieringnietdeclwerkenvoorminutentotaal) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND financieringnietdeclreistijdminutenbtw<>0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND financieringnietdeclreistijdminutenbtw=0'].join(''))).setProperties(['Sum(financieringnietdeclreistijdminutenexbtw) as reistijdminutenspeciaalexbtw', 'Sum(financieringnietdeclreistijdminutenbtw)as reistijdminutenspeciaalbtw', 'Sum(financieringnietdeclreistijdminutentotaal) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  tav = (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' '].join(''))).setProperties('regio').setSortBy('regio').setGroupBy('regio').setPageSize(100)));
  tavlist = (await Promise.all(tav.map(async item => {; return (getObjectProperty(item, 'regio'));})));
  ___arguments.context.pageData['tav'] = (String('t.a.v. ') + String(tavlist));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW1'] = false;
  ___arguments.context.pageData['VIEW2'] = false;
  ___arguments.context.pageData['VIEW3'] = false;
  ___arguments.context.pageData['VIEW4'] = false;
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ___arguments.context.pageData['START'] = false;
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['VIEW1'] = 'false';
    ___arguments.context.pageData['VIEW2'] = 'false';
    ___arguments.context.pageData['VIEW3'] = 'false';
    ___arguments.context.pageData['VIEW4'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
      await new Promise(r => setTimeout(r, 3000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      await new Promise(r => setTimeout(r, 3000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['file'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/312add2812dfe17b78f7b302c45e9059/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7b99fc997a8f4cb31f0afe9b2aba4e3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a70418ca86828dfc27df7e5e20058446/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/fa6fde96e573561527f4c7058ace30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/653d92711bffde05540e64fdf05b661b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/443c6a642218240c4749609aa327ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/36ea339cac3eacfc470790de84c9ea06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/48a3e37975e432924a4b87ba62826a37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2c2707b4307d6201822e796275884508/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a452a2313cf9da84975f129d875d6657/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a452a2313cf9da84975f129d875d6657')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/81b85319aad158479a3176c684c545e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('81b85319aad158479a3176c684c545e7')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/34bb1337b28c2d954352839117a20bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('34bb1337b28c2d954352839117a20bbe')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7dc752a9cfccfe424bd3c295c71ca7aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7dc752a9cfccfe424bd3c295c71ca7aa')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/abda89071b1ae8d4056646d86474e809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('abda89071b1ae8d4056646d86474e809')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/11ec3c02502b158785c517d465c3eca3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11ec3c02502b158785c517d465c3eca3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/aa28702f23efabb158315bba195a8eea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aa28702f23efabb158315bba195a8eea')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6685c69631b23ffa2ba44b7846f344a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6685c69631b23ffa2ba44b7846f344a5')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/076afe8a9ce3ed8ba2482a621ed90414/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('076afe8a9ce3ed8ba2482a621ed90414')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/dcc485a69b0237917be73bb7c892a46e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('dcc485a69b0237917be73bb7c892a46e')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a1020cf99491e01d669a05c9370e8f62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a1020cf99491e01d669a05c9370e8f62')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9e67cbefecdf0a671de89e8f6fc76df1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9e67cbefecdf0a671de89e8f6fc76df1')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/796e4014856c76a63adb9b8cb38d197a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('796e4014856c76a63adb9b8cb38d197a')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f7a9ecc117b643a150c51e857c9c4e56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/590d3008f53318fc05b98bf4829868df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/071b427b1eb4f6a196eb414cc12a1573/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/859c8fcc4f9c8cd2d3cda09eb58950ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8a79a88bc503b1bf0424b18545e386c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5538429343523a697f34c8817d564533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e1d430f48ddf15b8e1befe036bcf0fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/eec49f8b2aee792432c7888dfa26b4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/bcd79968c97a343d7e6d34973dabba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f42ee7bdf989b59248034508f4c40996/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/648b0a6778b2b5f11f59c87c04674372/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4518dfcfa766a9caee4a41fd405ace1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b08f83ef72360015d1e460e8f5aa9358/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2223646c3793c68fd45b0181f6845c69/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cc583438c387dd8d2f3a524d8e18231d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d1c6fed523e676d1f588e741a66640c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e562576afbca1decb9b1fc3b1566a3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0a9452f50ba74bc88db484f986821724/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b2977c780ac21b99499e1fa1ca74255f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/56c35752782b4d7bcd3b9d3255c4cf6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/051d19bc9277554844d40534d399be5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/bd97b931fcbd85391cd8e566f20e832f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5811694bd03c64dce1019f0440f9f6a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/538c74dafbe6c73f41e96d29a56c2eca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9ccc2e349dd8cb7bdd7aac85c60275e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0c3982a94f0dbd43a27c43f4e25dff5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/557917afb53bc122a1d996495037d6f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f349e6784f1a93d153eb1ae9252da201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0d25b96ae8bff27d3865723c656a78fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a9af21650257d813b1038474a9320df5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a3e27ff971056c61ac3a3c9f08a2f153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cee564d45661dc2d1a62f90bcb22ca03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9299951da81ff8ebed57492d7dff2f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7dd9dce125eea425b03258c1198dce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0e8365e34ad9992acec64e21cd72a02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/document/d/1RLjkhuFEQrLKCoUS8dRrl2HsFl5eb0ls/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5fe7f9ceb53b968c6c86d5ebc37420f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a03fb9e2b05df8efe3e95d06bb2d06af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5906d4762ed9b411e6bed347abffc71d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7c112cf6114e802258967966a4fb565d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'START')) == false) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/ca933cb7d3c90dbeeb6d5ed940453389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d6f65ac6cb3a711ea16a701db221c8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/51d63bc5e8ce88f63b3f68492594d255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8c913b77f7df8d36dcbbc765e8f312cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8e9afed82806dcfbc7eaa4268f21b947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7ba78e0845a96c66ee2ed77263fda1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/57a4e1edddb50da4592d3b71fed2659c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5d0ade29fe3a85955b0b2a9722e423d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f80b691361d569d97df9c2c5854b537d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/38bc9e4fc786fcc36e04d136e5ed2c04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/493131ad499e5c15496636746912f5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/987402ad2de3352e3224d7ab96316f86/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/64ba3bed2ebea56b9112c878fcd6de55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/177654ba7ace4e789c67e2e454df01d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e02a34fb9bfdc8ac20e72d04e5f3b118/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cc21e3582de70b4551ccf53973e3b784/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/67091fb6510814aaa3e9c00fa9336008/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/04219b5eb03ba8f4407e236a5baedde7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/bad4db33177b074e613504723b830365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/02e65db5bdde359934d29c83131e4154/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/397fc0df33f3b4efbc45ca645f25eb49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/3129b24f3a1d5d9a138c74b204634acc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/55f117fbeb35fffaf25340aadc084f07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c5d6961480c6c21f7313457355499192/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/81e9d7ed281fb148b2365574cf0886dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c4297219ae9c8d948ad25ab4cc76663b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a0270e6598b9c11dff44f3061613ab54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/407c6331b21887412b5f264675c30dd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/7a32f1dae0d74fe93808a7291f7a958d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/579d49945e2fae5bfc4347c88dece931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/f273eee26972969b6111d908c4a79b95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/dc5ace4a7a6fadff15ccea07ef62c97a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c773d9d3e8357a5f40a1e628c1633ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1125ea4a2dd9c523568317d9bd4a1f11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/13e4826d82034bc9e4247d21d37aa978/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2a2a1635fd64a205b329fcf244b3fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/0fdfabf1e7c81689bf8c22d41b788fda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4d4dff51210990a5a5b3b89d35fb062e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5f27e9e60f24d27125336dc9a563da7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1332e17b3d8909ce093225e80576dfc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/168a958dcc682723c11d8a5bd21c666b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/fff7517f93962816c01acfb45e491213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/6b5a12b140bddea8b06eb464bca3db3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e8b82f752b67c5634fa40c31c09e5b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/8d5c3feae8f33f272f0ee446d26a473a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/4c03643ab0730496f0ec146fbf673f1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a71f7745e15eebc8e11102ab68aa7eab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/19bd630731024763009ceed7bf28af45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/dd2f5d971f51e5bd3f8c15aed895be07/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/ab5e049cfaf261dd6d9cbe388df8f00b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a60e072e790e64cdf25be63dc574a1c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e40bfa1cdad637111b4e4f87ceb8ef5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/af0ba216d8875658efdad9361cf72592/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5d967d048b3c0bb740a9512c6e09c479/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1712661fcc8d4a75c33a3a051093fcbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/33b2e376f3d48547aa9fb3688291c227/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/aa76f8acc4854fc877d2e8ecc638e8af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/14ba4956f04be3e9df54602a4dffd645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/90232421addac742871a476242edf713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1d8fd598bab5424a184634cf83cd7e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/a6e45a59b30e18cc8ebbff5b0a2f9d73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/75e6264b6a06970df052fcebcfb7c62f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c8db3c54e94e7ac4df159bb3cd520c89/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2a498d29f06a3c5f36c83fd55ff4a7e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/e0a63f773da915cdd23d62e1efc34c66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/070296ef3d1b908f5c1ea4c1926b1857/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/96d2f14dcd9b9f528cdbaa93bd4e2c88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/bcc290d98e3a4f4fa3a49867b2142924/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/5aeea6b268c97c420aa3b4ce0f65bf4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/72125c5ba0bc7519bfd3ba2e0ea1ce6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/58c45fd846be0ec33e0fed11501951ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/b85e226d7be883b3fdd9e923e4d6fc1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/eaf1ece286784dcdc04649c4ff6b5c36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('eaf1ece286784dcdc04649c4ff6b5c36')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/ff78c0984bf8b098d8d8c5e8ce2b89f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/c3be8d3e6169f1235628c2afd9022ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/1bc5bea892f82d4e8cea4ce9d1888128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/2f171c2a9fc8de28b639b4288cf87f58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtnietdeclarabelzwnl/components/d7a8f888152816d8a3b8dc676f282d08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d7a8f888152816d8a3b8dc676f282d08')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult zorgvrager\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31e94fd517fad2960fd76a72ea73de09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c885cfe2a662eb88815fc40d608cc0c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('249a94090452464ed76ed4efd5b7f69f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult zorgvrager\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9126596225392b68fedacb850871413b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be8d1a0a0eb384e8341478c5781b824a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('271a7ec626f8e67956ff291ad95e072b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('672ea4df0deb3147fc327bba22b91fb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'MDO/PaTz\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setGroupBy('maand').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'  AND createddash < \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31e94fd517fad2960fd76a72ea73de09', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9126596225392b68fedacb850871413b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('672ea4df0deb3147fc327bba22b91fb1', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31e94fd517fad2960fd76a72ea73de09', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9126596225392b68fedacb850871413b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('672ea4df0deb3147fc327bba22b91fb1', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
    C = 'Korte omschrijving';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
    G = 'Omschrijving scholing';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    H = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
  } else {
    C = 'Gender';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B && (item['title']) != C;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'organisatie'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/876ec113e94ff3b6525dcd897d43af18/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a86ad95e4d5b0352def5a19829944ea5'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/f12534bff813000e0e926ccc45b784de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a7d46b9951e3216aa7c4353796c242ca'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/9e672b07a34f0152f76757f6eb5f0f21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminuten')) != 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/08c84519e1a7610915eb906a758e692b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a86ad95e4d5b0352def5a19829944ea5'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/935ed56957b70c31f338eda57f09a9a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('977d79c6080484fe44b7b3699e92adce'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/a4736e0b415a66dc658e851fcb0bf235/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b33830854a63176f796cdaef02437711'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/25e1dda81062376de35ec6cd584e6115/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('977d79c6080484fe44b7b3699e92adce'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/d4c3187b27f60e48fb573746dd48f67e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a87b5228534bd46786291c525068d017'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/ebf2381bc409ed6eb8ee440c57375547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b33830854a63176f796cdaef02437711'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/d2841996084111887a39978afd230c09/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a66e6deaef41df539c1cffdf148859bc'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/31e94fd517fad2960fd76a72ea73de09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;



  return (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31e94fd517fad2960fd76a72ea73de09')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/c885cfe2a662eb88815fc40d608cc0c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c885cfe2a662eb88815fc40d608cc0c3')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/249a94090452464ed76ed4efd5b7f69f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('249a94090452464ed76ed4efd5b7f69f')).length ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/a7d46b9951e3216aa7c4353796c242ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/a87b5228534bd46786291c525068d017/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel/components/a66e6deaef41df539c1cffdf148859bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fd4bd8f97574ef1644f16db86ebbdcb1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw) as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c76960884e9871b07e98cf6a572df4c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND createddash > \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'true';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['MAANDOVERZICHT'] = 'false';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f14f8f2f8b9175332287b88fcd6df2fa')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdkmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['exclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['START'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['height'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['minHeight'] = 'auto';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b22638f1673e580c4cab39726d544ed7'))['maxHeight'] = 'auto';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['exclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/f03ecd9a39da8fd27bbcb377431a5fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d1d5797df431ce4990f750863c49448'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/5c76960884e9871b07e98cf6a572df4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/eecfe8d6f4886bf2623a02d4fc5eab06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/79f2db1319d87741c7cd74270e82be6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/04aad222b0dfd884950345cde4229a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/fd4bd8f97574ef1644f16db86ebbdcb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/095200e6fd1535ef2d0814fb392433f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/1b6e497830ccbe74e7d729ced87e88e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/9297f9c5fa6f1c7ba93f411d75498bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/e8eee9e75e6a99790e51277c966abeef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('095200e6fd1535ef2d0814fb392433f8'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cc0195aa184fb09f28e136cdf01db535/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/98a27bb1c9ed135b05ebfbf8e566f1bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtoverijssel2024/components/cd470f920e73132d66392e22cf8c5787/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','VWS','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('350300a482e1fe88fa1864189c87b3bb', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Financiering gemeente Amsterdam','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
    await format();
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/0f6f5d12a49dcee86098c5b309eab404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1iHIBKgnHvpIUXq9BjhO9rtF1W1T8I7xT/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d56d9182ba1e1f2893a6f32a3277f921/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = 'Consult cliënt';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/2a675e316ea8943a378a2828ba225d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/350300a482e1fe88fa1864189c87b3bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('350300a482e1fe88fa1864189c87b3bb')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/b8831a0ba359899c2875dc765c9a2f45/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Consult zorgvrager') {
    return2 = 'Consult cliënt';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit'));
  }

  return (String(return2) + String(' KOT affaire'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/8016ae17a79af987bb555598d326d32f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Scholing') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminuten'));
  } else {
    return2 = null;
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/fb7c037e9302d71298ae974b3f564c93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'activiteit')) == 'Scholing') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'tariefperminuut')) * 60;
    await format();
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/e7e106d34bf1592da00c8043df2fe919/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/a71124a25959433ce35a1c9e4f88b5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9fe3a38ee45c026e0cfaa09e034a1d08'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtquestio/components/a5a599fe7fcffbd940998371392895c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Ja\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c394869d5ff3e7c278e20686c4f648c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'financieringsubsidie']).setSortBy('activiteit').setGroupBy('activiteit, financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'gewerkteminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('71c950e80329614b1a08b835af5ce26d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\' AND mdopatzsoortoverleg=\'PaTz groep\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('acef241494a91a63d523820c7955de2c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\' AND mdopatzsoortoverleg=\'MDO\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fbc69b7d949306365bcabed8ce05c319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f11dff78bb94658555cda631b48ee96', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fdffe5223e9abeae0b17217a9584e73d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('284b366eb8b312dd89c2887935817fb6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a349402bfd6237db389129954ab1a9c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' '].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0c06d7cd18ad9e67f3cd42242bd9930e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41ff3b7eb7814efcaa213ee25cc3e0a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04b64dc468ea8e19de7a5d02e73a2d26', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fda7052fe1d1f8b2236fda9c7b01de97', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aab997318a09409b831c17d42d0a4649', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('180e83cdeb3cd7c5c14b0b5d462804b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc95a09c6a4115e2196e44acc17dee1', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/2a3744db2d39a0f38f84e47f709197e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/558ccb4b347138b388b8b2dfc6356695/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c6e9635c891c6e3a70ea9085f57a7eea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/750930777078a42df5085041102b681e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/32ace18c06537d180831f9d3f41d9011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/53bb7d1ffd09e90de2cf3305621eaba9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c24371ee5c657c7d9e6c0b06d451506d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0c9ba9c76382ef54dc295ea49e26dd79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/ad6ba834d83f6cba2da6b15d7fc2ab74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/281f88b92af464964dfadfa9162cb1ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f5d565a585ef73d58e1fb2291cdef67f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8f5db1aa67fcf5373083509802720339/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/19fb3f1f2737ba682c7f2ae77c1e024a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/7dde52a604e4a2d1f599d2e7123887a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a95c06fb4598e88ee499e44267094449/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0644c44f03fceebabf8f8b72ade2d59f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/687456a8575fe93e48030c5ebcc92d12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/3983c66d42ec4ad9f1983c5785fd7dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/e246f231300ee74bc938be16aa483186/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/531cde561f3da025bd595e751c27d602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/520359e4c7f80e16756716b22c9cabd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8ebe1325253434d76d134261271f94fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/ff8cc9c670c162bbeb4dbea1b1f644c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length && !((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c394869d5ff3e7c278e20686c4f648c4')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length && !((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c394869d5ff3e7c278e20686c4f648c4')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/9224658f241147fae6d81af813a47afd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0c06d7cd18ad9e67f3cd42242bd9930e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6c2b3cc697da3b7aed1e0ae5dcdc47bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8f11dff78bb94658555cda631b48ee96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/210a4446cc8dd5f7c0c6dc8516aff91a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/41ff3b7eb7814efcaa213ee25cc3e0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/71c950e80329614b1a08b835af5ce26d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/fdffe5223e9abeae0b17217a9584e73d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f6fe3b1944e975553fb1fbb9863b1d24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/04b64dc468ea8e19de7a5d02e73a2d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/fbc69b7d949306365bcabed8ce05c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/284b366eb8b312dd89c2887935817fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/521b455fb2640a8fe6e4359106c3eead/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a349402bfd6237db389129954ab1a9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/aa289e34a6c3e6a1925fb57fbee1f563/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/d739b42d4073b8177a76efbebb7ba67b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/b7d5973296be117105521ddd0001fb54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f761aa41091454bf728bcc1312699991/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cb789b94fd7e4c3217e86ba9f8dc2df6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/e32b522d24f79d2c7f56687f01dff468/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/16498df1282374434642494414e4cada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a7ee3bdf64ee3171075c6467c56571af/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7ee3bdf64ee3171075c6467c56571af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/d01c35d25ae6a39568984d6157c553a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6ab891ed58f47a7a5531f06288ae1c26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/41f537e9747b0577bdee2abc25b6c635/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/619d951fd09bc4793c4c3781249aa3e4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('619d951fd09bc4793c4c3781249aa3e4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/615f8805a5749e5f2a5d8e93a845e0a3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('615f8805a5749e5f2a5d8e93a845e0a3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a72bdcacd71e91daa1e1243fa0c1285f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f42b3be9ce887083b81e7712d641ecc'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0df6a9a2373468971022f78f561637c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c6bb8d997636ba843ff17f10319aa68'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/ca2226b7963c5258aa68311661a893e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18b599ee2d786077920712e57597f1a3'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/622c994a7c58345f82f69ac66cb39a53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('622c994a7c58345f82f69ac66cb39a53', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/245bd7a4191728768474579a4c1e1a9c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('245bd7a4191728768474579a4c1e1a9c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8ecaf544e2f34556c487683a5f9ddd5d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/72dbfe0bd02da9fe25324d8da3fd5439/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/395efac6a9320919644299ef79f253ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/5c4c6d02601e586571913a63643f8721/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/965edb0c0c5456bdaba28cbc73d9be71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/28f4266b7c0fb07a2c779e9f8511ed0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/6a36f1acc94d84f2d8f525729b068097/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/4908b91e4b824b319a9e06d982acb3df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4908b91e4b824b319a9e06d982acb3df', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f5ef5669df27ecb4a7f84b9f49ff8102/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/783ccd87c10238e52547e319f9c42196/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/809248d2c76e9a5d8d3103df80d1a035/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/132dc05fa9facce6542b5adb562d8e24/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/87e76f5cb99d5b25530bec34e8d15378/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/e96179628c3b44e6cc9f8551b957967d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/dbe95b43ac5af80b474f07556a088a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/484540e5dabdc37318ef1a05df8acae5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/080729f791fee87f1065442affbc9cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/df2cd44542371254347e6453639ea089/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/94bc865961a1662e0f0cfa2862496c1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c391da74d72e9391b7813122fa37401c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/468dcf71802d7b6c8e78e6579ccd3873/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['START'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1209dcab0383fea6c9d4e1bde47c47a5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/1209dcab0383fea6c9d4e1bde47c47a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1209dcab0383fea6c9d4e1bde47c47a5', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0313aa339fc39c341d4da0722017616f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/04e5958dcafd67997f3add2fe065298a/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/1067219e319f3c37cbeedef87a980acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0313aa339fc39c341d4da0722017616f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbe95b43ac5af80b474f07556a088a0d')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('484540e5dabdc37318ef1a05df8acae5')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c20795538be3991ac1223d9bb0249b09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/b765eb6f0122d899a5b5cc54dfc1acbf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b765eb6f0122d899a5b5cc54dfc1acbf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/777912f371e2e0421302f306ce78cb89/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('777912f371e2e0421302f306ce78cb89', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/0303a567855b9ae6678e79418ce5458e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0303a567855b9ae6678e79418ce5458e', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/484793826f8c07d194efef09905bc219/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('484793826f8c07d194efef09905bc219', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/204c448c0256f419e016d44d22b77a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('204c448c0256f419e016d44d22b77a9d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/e3089d6c4e2393cdf9e5e868b1c47abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/60ba84733abcbc2a857f13b68cc1f8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/f7db815535632651395b977afb7c5f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a3de41b9fc790b44908df7b252fa3bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/067dd82481efb99de78c5588076a0c31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/2a9a973bb1a8e809211d09b95eebef63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/document/d/1YegezYy8wS7ywkeB_8_E9DXawv-142LO/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/9abfbf11965396eeb1596a2789d59e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/d472e12c349893525cb97babad2bb64f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/478366811545b5a987097c16d0d17abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'activiteit')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'financieringsubsidie'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/ba1cbf9aa95b116b55ad2f1c0f19521e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'tariefperminuut')) * 60;
  await format2();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/338ca7f65319001d56120b6e901c3208/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/c2b14d751e4e1343e53ba033a2dfd07b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/b3bfc9d65652b6155dad62e62a35cb2b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/5571a42fac7ba4acdaeca4a2fc119547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'activiteit')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'financieringsubsidie'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/a70a134cfbd71d33cf64df1eceea2bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/36d56e995383437dc31d21085cd85991/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/cb667cb61f25fc8538a8bee9e6494f98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/be15fdb6b73c905a1f3bf006a23d5c97/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be15fdb6b73c905a1f3bf006a23d5c97', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut', 'financieringsubsidie']).setSortBy('activiteit').setGroupBy('activiteit, financieringsubsidie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/3c4acfdae42a3b4ef30d4543906ca138/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/5cf7b86f419849c30fc112ce9b596fa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/52a90a68a2e7159c2456ef7d018abf64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/46cb912615c4978418d669e9c62f2aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/8b0bf121471ffe59c6c435a750bf82cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtrotterdam2022/components/41be301c7d1f76d6532346c3744e64fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e97d36880aec2b9216d68189d3a29766'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND totaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0 AND reistijdtotaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setGroupBy('tariefreistijdminutenspeciaal').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND created> \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/92aaccb79c1f35081c53a0a64f8ca4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/e0018c759e4e72b5481ab4f219b89b19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1p0Kgb-XxXOQr4sNGA_12lxGmdQpwdtEy/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/ec03c4d9109502bf844fed64d7aeaea5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtsichtpunt/components/b5482ac8dbcbb3a95867a7c6c9bed426/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'aantal'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL1 Noordwest Veluwe','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4ca26abcfafe7674c0b871a41f5e1236', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e903aa8b144d3403f2b66c68f005028f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ca859ee97f3aef1a25bc397f60bfb51a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL2 Eemland','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c9c6698e4e433219949d06668891fb66', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('82be34524fd2f216490eafd22e8fa6d9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL3 Rivierengebied','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e13c93811b1afd450c5803a723e64b1d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d82202582be52335bf5742975df110ce', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL4 Noordwest Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5eab13b3e05c73b687aa70a394b256d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('996f0daaf56e482640b4f3c73a9f5be4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('96affb6754fbd3692af50c5b222a44d3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('501dedb70fa1b26f3f19ca4e25328472', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL5 Lekstroom (Utrecht Zuid)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31b33654aae3112db1d8d5326a5ac571', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ce722455663ab75aa9a81eed3c3ed85', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('132d54612ebe10b3a12985e66923fde7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ddbc115796bdf0d9859c529d7ec38696', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL6 Zuidoost Utrecht','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11633fede17bb80b6e2622ac157b9bb9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c5c6c846ab7db55c098ed67efc68d84d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2ea687d52b0c7fc638992a98c692b787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('26d3db2487dd14b2d8d569c2bb0f4837', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL7 Zin in Utrecht (Gemeente Utrecht)','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.dataModel['maandakkoord']) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (___arguments.context.pageData['maandakkoord'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f329285a6c5f9b17cd26a38cfabbd09c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a519e519fdac0038e6e7a6051af808c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe2d81d8b588959792e536bf5bbac835', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68610e87996e08eb4069b8926e5b9449', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9cd3acc36abf15e6be38c169b9d7a45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b6a418c5ddbaf36a10167f48467c107', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6efb07a26849937d5c5e0a31b2be75cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a278bf9851ed39d7f7392ffc4bd86cf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4caf7b21f3621bef4a84729ffaa68c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('167398eb5217c71350bbef3ad2179244', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51855a06ccb9d241ded789898e2af82c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dba812d37c6f2deb4cef49258e1c9bf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f188db4dfbf9bc42864c0e5ee06acd11', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e903aa8b144d3403f2b66c68f005028f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9c6698e4e433219949d06668891fb66', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e13c93811b1afd450c5803a723e64b1d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('996f0daaf56e482640b4f3c73a9f5be4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ce722455663ab75aa9a81eed3c3ed85', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5c6c846ab7db55c098ed67efc68d84d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca859ee97f3aef1a25bc397f60bfb51a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cdfa16b8e45f03debba2896c54b37575', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c4ff071fac6e9f2b48fd75e89c81c6c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96affb6754fbd3692af50c5b222a44d3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('132d54612ebe10b3a12985e66923fde7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ea687d52b0c7fc638992a98c692b787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3f03940750e8692bd397aec8f56ee147', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('82be34524fd2f216490eafd22e8fa6d9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d82202582be52335bf5742975df110ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('501dedb70fa1b26f3f19ca4e25328472', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddbc115796bdf0d9859c529d7ec38696', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('26d3db2487dd14b2d8d569c2bb0f4837', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f329285a6c5f9b17cd26a38cfabbd09c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a519e519fdac0038e6e7a6051af808c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2a278bf9851ed39d7f7392ffc4bd86cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e903aa8b144d3403f2b66c68f005028f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ca859ee97f3aef1a25bc397f60bfb51a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true' && (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ca859ee97f3aef1a25bc397f60bfb51a'))['reistijdminutenspeciaal']) != 0) {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/fe2d81d8b588959792e536bf5bbac835/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f4caf7b21f3621bef4a84729ffaa68c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c9c6698e4e433219949d06668891fb66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/82be34524fd2f216490eafd22e8fa6d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/68610e87996e08eb4069b8926e5b9449/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/167398eb5217c71350bbef3ad2179244/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e13c93811b1afd450c5803a723e64b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d82202582be52335bf5742975df110ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a9cd3acc36abf15e6be38c169b9d7a45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/51855a06ccb9d241ded789898e2af82c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/996f0daaf56e482640b4f3c73a9f5be4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/96affb6754fbd3692af50c5b222a44d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/501dedb70fa1b26f3f19ca4e25328472/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/7b6a418c5ddbaf36a10167f48467c107/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dba812d37c6f2deb4cef49258e1c9bf6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0ce722455663ab75aa9a81eed3c3ed85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/132d54612ebe10b3a12985e66923fde7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ddbc115796bdf0d9859c529d7ec38696/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6efb07a26849937d5c5e0a31b2be75cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f188db4dfbf9bc42864c0e5ee06acd11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c5c6c846ab7db55c098ed67efc68d84d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2ea687d52b0c7fc638992a98c692b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/26d3db2487dd14b2d8d569c2bb0f4837/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9b4603d130741334d2ed2b8830169b3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3e18c667d26484adc9580669ad73e613/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/65c64bb69b5ff7fea7997928ee32d931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2e5c240b35c773dd93eb20cff9d4d0b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('11a286273abaa7f3f3bc130babdd47de')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3c035ba75883a838535b01b882fef483/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a52f124d9c141c07bf512f0cfbadcb4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1c8e5112dd8685aa82149f370b0485d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/25e9bae62bea998e734fe8b792556da6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('a77b5887c952877bd735878bb992b729')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9f1d6f5a6834a7994622ae7d1be323df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5548a0edceaf8f42cb9c69c2675afa02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ac7d29a256f991a290a8e3b93b2a4f82/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/144da5569cd95e5eb5ddfa94251f375d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8844e49f73ead24d9847ae91dbbc3e46')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/957a55a90af9f4077ced6035e15bab7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/94dd724811fe1b0234c8d3e60b458b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/beab1f97950bc1ce4a69dec583a4437d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/26713369fa44ce474fc9101c8f061923/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d17a599febeb88c725c4c0160a541a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/13d4ed3b6c6f5edad16c5c372cb85f28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e0c757a6a823f3ae02d33d7ea74a6904/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f3fb2e23bf932b1906a384a7153dc205')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/91c32792c1f4db24988c442e8b5255fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/78f1f78742c665ae5cd2bd93fe0f4e32/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2a7e9f466f6b18830998a8f40516091b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cef1a6fb06d27c7659c6a8bae371b111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dcb4386ff1cb75015c42b6fe360af5e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('71a9cc86a70239dd10e182feac5d4c5d'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/aca7f995e5dedb6b275a0bd7609cf5d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b886794b684355a2effdb8829a125a91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f53f98954ea95501f3771103b7fc85a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4b23f6dc9c382ceb59acefe5e36935fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/17fb835ebd443ddafcb849bb76c71df3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c845197f0fc35dbfeb8c6c98333ef1ad')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d503aa038fd506bf8af33f61066b3c79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/be7a89a976a51817d0e9b9e2e68188af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1d98e22219b749756c255cf4e474e518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c17a5feebdb145ff9cbad6f56e9e754f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0195aaaf9e2231575e41b1ef2fb74682/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dabc82e47fdb512dda872215dba8e376'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0c564489372f96f3088f6c0d574fce64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4dc20a6ecf148ff3dac47c2433b56c34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/081fd7efd4e9c0ed193146caf1f69124/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4f9bda37199a5b55620397b91f6d74d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f60238a1a9971adb892fb16bdaad3afa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f92c6985597e6a7c00131df5fe7abf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/871d3162f234ab9784eb98b57ad4583a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ff9f6e4ce7a4e4240779b687efffbd97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ef537a1362b9f9a75d86f84c8c91b8a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a4c12559a08c0a6c81754b55918ab10d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ef566aff2fc8187b3329e1bf8eb161bd')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4d69af7c50a271e860d3d50159af351e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('15c146740eeac65f5ef320dcfd3a59e6')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d8b4830a5252ae46260614f3533cada8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8b179d4ff6c3d5eac366c96ea8a75bed')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e8dde48dadfe77de123f38e854c1ec75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3ca3b2ea045b0f9a22ddaa2aae1277a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ac7fa8db03f4d5d9900d836e7d544b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9c67592b131c0c56df06f53afdcd1697/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f6a7cba71f95a05d6e534195166432a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3f0c059830dd98588623f6aa131e7af2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/561dc5788c94ebdfdbe61c0b6c5e6477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d057a152858e47730ed2aa97261fdcb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8e15d01f788508d2a75e75d3ea818692/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5ce171bd1f0362f16eebe6e1b957ff9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2984d513cd39409d1b54143aef68396d')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/fcb82cb579e8f7ef6b8ca1e826def4cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ee4a8b1d7a353da74f58c3788dcddc39')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/684fa9b94f0aaa18b726ab06f35e0829/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('8fe524e5067dffe39b624b526f2537e2')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d645fdde004c109e2de60ce376fbe71f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3bb17105818c7599f0a6dfba60b89ee1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/84720fa9d13c76a5adc85b4ef4d91808/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b4d6bf4e17212c66f4416249b7b4727b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4a11f4c275a2843549732abad72cf6bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/49036b6637d8c28ba25c7db9efcbbe28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6785856e6a760d222de9ba2bc8dd5ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/aa0454ec5f091e44d4ce87de15846785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/7cd968d58d4f89bddc8ceab95cc65277/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1f64747c2779cfeb81b170180872afb8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('7bd63c7f1cf86359a731f09eae6d5d26')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/989444e28659721dd4aa1eccc8263625/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('92725a4638d19ef3ccc35353a60e3b1a')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/da0f04f2f142c1dd0e8c1944419bf6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('647442a4c84933a36b8b2014ca6393c9')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2d6af192a86eb14ca2cae27af767b518/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c172f6acbc0d78ecd4a373553d49b182/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a4db25bd4b4337594efa1371d9c51e07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/eb87497d9aeeea75caee67ddfafa8665/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/756fa1390b839f5c024f0597e378d621/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cd45eb285732615b117847699e181ab4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b262e212c2155dada3f6e95455bf4c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e80a4b1cd0e5f266dd8dee411bda3d0e'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2432d3af8fbc42f28ae40de71f6faee6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('341ead2c66f2bd3fdf651633322a5a97'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0bd8406f8e4faaf5fceb4d818b85b686/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3a7939e2ea160863fd76cb7b8c4fd17a'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a77b5887c952877bd735878bb992b729/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f3fb2e23bf932b1906a384a7153dc205/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c845197f0fc35dbfeb8c6c98333ef1ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2984d513cd39409d1b54143aef68396d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ee4a8b1d7a353da74f58c3788dcddc39/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8fe524e5067dffe39b624b526f2537e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8844e49f73ead24d9847ae91dbbc3e46/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/7bd63c7f1cf86359a731f09eae6d5d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/92725a4638d19ef3ccc35353a60e3b1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/647442a4c84933a36b8b2014ca6393c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2d7fad35c89bab376d75273ff634eb84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c447c01cea2434132b062bd48b5a6f4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/44d6160d6ed6ba95ed0eb837e7c6ff93/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4ca26abcfafe7674c0b871a41f5e1236/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4ca26abcfafe7674c0b871a41f5e1236')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a5eab13b3e05c73b687aa70a394b256d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a5eab13b3e05c73b687aa70a394b256d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/31b33654aae3112db1d8d5326a5ac571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('31b33654aae3112db1d8d5326a5ac571')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/11633fede17bb80b6e2622ac157b9bb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11633fede17bb80b6e2622ac157b9bb9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/533e623612af08f8e701be55658999ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/02f98e570e018fc3eec433dcc17c055b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutentotaalbedrag']) + (___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    ;await ( async function (message){ alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/aa87e0ff7f899bd13e51daf13a79cf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5455648e4a32ebef60b83d4f76632bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/08f4b99cc45946991c1af374fde242fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['tariefreistijdminutenspeciaal']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/be9d99cb32cdb557ae79276626fad7f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/38428a9f27153a6d407f04f1943f1b83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/925c0eab36f9c4a1b2f11e8634444f88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/8ea961b38952a49a4c04751d18f8ee1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6fc2aadcdb068f7b57482be1bdb43b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/176d636dad32bc54c11ff2671442cf25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/ece242b6591d663f35587841822f0542/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/94a6c2499561cb7765bc14f67fe923cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/617f4ec45e7ecbf55e5c2a4eb9eb3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/e8aa74fb1af76ddfb926b70e23e93906/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c812df5549badbe57caf4f6df8baa284')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5151e632e8559142b5b63cabf4096c9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('669a1894ed2ad848c731e3a20d8a06fc')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c0de0145869c46bc1b4681032aea4d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(euro / 100);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('618d1598a108cc4738d5f1bdb594e2ad'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c338053cf24fabfb59c18ae641e39da2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur') {
    name2 = 'Factuur opmaken';
  } else {
    name2 = 'Kwitantie opmaken';
  }

  return name2

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6f1f3a15f38822e6885d32c247cb5916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c8e79d6b48425e220e2aadd303e8d8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8e79d6b48425e220e2aadd303e8d8c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/aef1860512aba914470657b98753f4ee/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aef1860512aba914470657b98753f4ee', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/90a6c1643fa86c2c0ac4e56124dacca9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('90a6c1643fa86c2c0ac4e56124dacca9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6316a176ced64b33fbe5043d4c74ad3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6316a176ced64b33fbe5043d4c74ad3e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0baa2e3d13e3c7568f3e92ec80569c62/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0baa2e3d13e3c7568f3e92ec80569c62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c684b73d1c7297048c52c3c2636de2a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c684b73d1c7297048c52c3c2636de2a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/866690a969ad906c8fea3d636b3f0642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['reistijdminutenspeciaal']) == 0 ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/c338053cf24fabfb59c18ae641e39da2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['VIEW']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a12e6f46694bfb6659c894726c719aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1yKoG1QX075Zjj6w65aepF9meKJ1jOaLC/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/a06ad44747effd1d679e85910d8ca6e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/344722532556d88dd1545cbc7b869c69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97092f3e54d635f1bdcfff9799dd7f8c'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/dff3a3182cb5fb4a522946123a3f5bad/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/0e6989f881d7ed984944f0ae61c3e431/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtutrechtfactuur/components/cae339653cab065e5691d3b7e46baa1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdb48cb7b722b473d8e30cfe484e59e5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c4d2f4b68c29f3f2e9eac7de04c2744')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/2fff1586bef1c782cf9924c883e7d2d7/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return (String('Vink het vak hier aan indien u akkoord bent met het maandoverzicht, indien u niet akkoord bent neem dan contact op met de ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'maandakkoordgv': 1 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 1;
    await Backendless.Data.of('historiemaandakkoordgv').save( ({ 'datum': (new Date()),'status': (getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'maandakkoordgv': 0 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 0;
    await Backendless.Data.of('historiemaandakkoordgv').save( ({ 'datum': (new Date()),'status': (getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d419bf1a39243bbb719fa87cc53dcf94/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandakkoordgv'] = (getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/0f6f5d12a49dcee86098c5b309eab404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1DEt2emJykOIjC7oJlckw93lThjsOP1ZF/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1Vn9rAkEn9YzUCKi7LhjuYRSL3eEvNh8u/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cdb48cb7b722b473d8e30cfe484e59e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'true' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/a14be1b519cb307d449fce45f60440e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/468e21b3a11328420c498b6f16534ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem/components/7a4467d1c098680aa3b56685923f7986/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND totaalbedrag<>0'].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0 AND reistijdkmexbtw>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND totaalbedrag<>0'].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND created> \'12/31/2023\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '700px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 90;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 60;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten')) * 150;
  } else {
    return2 = null;
  }
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));
    await round();
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Raad van Advies' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Coaching on the job') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Consult professional') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 90;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'MDO/PaTz') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 60;
    await format();
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'activiteit')) == 'Groepsconsult') {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) / 150;
    await format();
  } else {
    euro = null;
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/2e9f7548b7d7c5ff9d14ae9c8cffb1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtwillem2024/components/614475892296156c310df843cb9adc83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminuten'));
  await round();

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '550px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['PRINT'] = false;
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['PRINT'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = [(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join('');
}


  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/a80dcfb395da0d1d59af3884b49ba616/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/09fa172f176292726eb81accb3840cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/7c83e5a513c8615e1b22923b68ba7785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/685cc9d617c7061ab6474d617aa48369/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1z9yw78DpIalM1SMFEyn0W1U3vPV3XuX3/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b6462106f538010c65963dcea9894af2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/1894080119aca86caac71f748908f316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/a3735e0c761c41dfd854f54895f9bc6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/d2a52a95c198e344da86483fe55b526b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/b7a1f2e846ab15e9f97f30d32316c95c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzhn/components/cd4abd364af28e4bdbaad45e37d1165c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function zelfbetalende_client_eruit_gehaald_15_05_2025() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee1dcdf8a8cb8e6897b75cd8f90f4478', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('344853187618746f7d78cf6887989288', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '550px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['PRINT'] = false;
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['PRINT'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = [(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join('');
}


  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Zelfbetalende cliënt)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/a80dcfb395da0d1d59af3884b49ba616/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/09fa172f176292726eb81accb3840cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/7c83e5a513c8615e1b22923b68ba7785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/685cc9d617c7061ab6474d617aa48369/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1z9yw78DpIalM1SMFEyn0W1U3vPV3XuX3/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b6462106f538010c65963dcea9894af2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/1894080119aca86caac71f748908f316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/a3735e0c761c41dfd854f54895f9bc6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d2a52a95c198e344da86483fe55b526b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/b7a1f2e846ab15e9f97f30d32316c95c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/cd4abd364af28e4bdbaad45e37d1165c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/dcf81216c6e8c93847a8a188dbe80fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/5688d8d56c48d45bc2d8fbb8f5f89018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/f33c7478ddf3eed2705831d871cc4a77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/6088dbe890c8578a71d83bc8725886b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/0851a7959d880278171c695340fd4c6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/23d83fad931c9708b55f1504232cf858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/70c820b488a829585758a8f8b8d80015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/a91ef27d8a58895671dbf49a0b555426/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvol/components/d6f86a48e81ec6dcdbd1f0f89d68ee18/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Fonds inloophuis','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c240ec6ef3bf5ee022f1d9dfed178a8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('213f4f6250c36142f7da63f62deecb09', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '550px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['PRINT'] = false;
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['PRINT'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = [(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join('');
}


  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9adef46c33d400bda64a7467e9270045/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Fonds inloophuis)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/a80dcfb395da0d1d59af3884b49ba616/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/09fa172f176292726eb81accb3840cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/7c83e5a513c8615e1b22923b68ba7785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/685cc9d617c7061ab6474d617aa48369/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/17jN9KWK6z9XB7IGY1m2MCjKT8akMDlOi/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b6462106f538010c65963dcea9894af2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/1894080119aca86caac71f748908f316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/a3735e0c761c41dfd854f54895f9bc6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/d2a52a95c198e344da86483fe55b526b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/b7a1f2e846ab15e9f97f30d32316c95c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolbackup/components/cd4abd364af28e4bdbaad45e37d1165c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0655ef6412eb200dd09f3e4bef1b0081', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee1dcdf8a8cb8e6897b75cd8f90f4478', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('344853187618746f7d78cf6887989288', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('853ba052e9560a6b49ef7e9da458b289', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e149c004573f5e3255219952b3b2e199', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'','Zelfbetalende cliënt','\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d12e730520f671f690ed4f5dd19dc4bd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND reistijdkmbtw=0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('925dbce8bcef4f64665cc1f23d1c2201', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\'',' AND reistijdkmbtw<>0'].join(''))).setProperties(['Sum(reistijdkmexbtw) as reistijdkmexbtw', 'Sum(reistijdkmbtw)as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND financieringsubsidie=\'Zelfbetalende cliënt\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;
  ___arguments.context.pageData['PRINT'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden door het CvL.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'false';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = 'Auto';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = 'Auto';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89b5be342fb7dc08ad668adacc36b106', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* handler:onSearchingAssignment */
  ['onSearchingAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PRINT'))

  },
  /* handler:onSearchingAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, A, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenexbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalexbtw']) + (___arguments.context.pageData['inclreistijdkmexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['inclgewerkteminutenbtw']) + (___arguments.context.pageData['inclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['inclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdminutenspeciaalexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclreistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']) + (___arguments.context.pageData['exclreistijdkmbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (___arguments.context.dataModel['gewerkteminutenexbtw']);
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (___arguments.context.dataModel['gewerkteminutenbtw']);
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (___arguments.context.dataModel['gewerkteminutentotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['height'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['minHeight'] = '550px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bbb722a98ea20107d52c4c956c673bd5'))['maxHeight'] = '550px';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['PRINT'] = false;
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    ___arguments.context.pageData['PRINT'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  my_1 = [(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join('');
}


  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/925dbce8bcef4f64665cc1f23d1c2201/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/324eecf7c2981afe68e71dfa75fa8b51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['inclreistijdkmexbtw'] = (___arguments.context.dataModel['reistijdkmexbtw']);
  ___arguments.context.pageData['inclreistijdkmbtw'] = (___arguments.context.dataModel['reistijdkmbtw']);
  ___arguments.context.pageData['inclreistijdkmtotaalbedrag'] = (___arguments.context.dataModel['reistijdkmtotaalbedrag']);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b2a2007c1c2506e1140182695eec1217/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclreistijdkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw'));
  ___arguments.context.pageData['exclreistijdkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmbtw'));
  ___arguments.context.pageData['exclreistijdkmtotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdkmtotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6bc8098e2047488648f554223eb7e456/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/0b111ec8fcb493cc5c377df87918c3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = null;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/c3375fbca977b9d7a328b16b58626fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/01f87b186c4810de8a0e6b21d6b78369/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/295896c75446a81cb7fe498151e78947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/f1ef23d6945572cee0d7989972b42488/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('94219fc5f4bb47abec33936c408a8319'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/f04f9badec06267bfa06a153a30da612/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77955cf3ad1918f87538e69907c927af'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/789436c1e18e46d55bf2c79eca37c9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd7f0b78f0a225b5f0f4dab2b157fc1b'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/9c240ec6ef3bf5ee022f1d9dfed178a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9c240ec6ef3bf5ee022f1d9dfed178a8')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/213f4f6250c36142f7da63f62deecb09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('213f4f6250c36142f7da63f62deecb09')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/853ba052e9560a6b49ef7e9da458b289/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/e149c004573f5e3255219952b3b2e199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/5da75e5c18d86b52535b914f3086c688/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('4419bc6a64f94b668e282f5548feb787')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('bfd475169d91218427fa0df7bb2199b3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/dd7f0b78f0a225b5f0f4dab2b157fc1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d2bd5e22bba69e441f33175ab35a3581/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/09f2710110f4e33fb7ee8c0744812fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/12c650072da1350d8705307803356d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('12c650072da1350d8705307803356d3e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8e7c0404d74da9c18a8b9b8760240ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/58ca1f15d0db976f2fa21f4d0bd5610b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminuten'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6c22af8dbd0382e4e0e13e5909df4d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financieringsubsidie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/34d47f12bc69d1d4de435a05b6bb0197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/e4225d31a90125f74f0d4adb740c55ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    return2 = 'Factuur';
  } else {
    return2 = 'Kwitantie';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6746621aa7c69a121b32a84527870451/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6ac85085196df7f6887d650a20848295/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/a704a10136bfe1a1ca4d183fb7c52dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/7dc74787c02d201b39c8a74638e882d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'activiteit')) + String(' (Zelfbetalende cliënt)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/0655ef6412eb200dd09f3e4bef1b0081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('0655ef6412eb200dd09f3e4bef1b0081')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/470ca55fd3027a0f56a5a235b8e89f27/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/8f639b12bb6fca35ec526238d048c1bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = null;
  } else {
    text = 'Vrijgesteld van btw';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true) {
    text = false;
  } else {
    text = true;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/4a7f3ec88d539907f5bbc3f185a1fbe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = 'Vrijgesteld van btw voor scholingsactiviteiten';
  } else {
    text = null;
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')) == false) {
    text = true;
  } else {
    text = false;
  }

  return text

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/0d0202ba5af4e0ffd85fb23cab420b1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  return2 = return2 * 100;
  return2 = Math.round(return2);
  return2 = return2 / 100;
}


  return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'aantal'));

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6464ea55d95f32fdccfcb36305df9fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/a80dcfb395da0d1d59af3884b49ba616/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/09fa172f176292726eb81accb3840cf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/7c83e5a513c8615e1b22923b68ba7785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2bd5e22bba69e441f33175ab35a3581'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/685cc9d617c7061ab6474d617aa48369/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1z9yw78DpIalM1SMFEyn0W1U3vPV3XuX3/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b6462106f538010c65963dcea9894af2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/1894080119aca86caac71f748908f316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/a3735e0c761c41dfd854f54895f9bc6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a3735e0c761c41dfd854f54895f9bc6b', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33dca6ad66975bff3698d0f3fbb4be5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('336561a84b078989342102df581c53ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d2a52a95c198e344da86483fe55b526b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1894080119aca86caac71f748908f316', true);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2a52a95c198e344da86483fe55b526b', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/b7a1f2e846ab15e9f97f30d32316c95c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/cd4abd364af28e4bdbaad45e37d1165c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    ___arguments.context.pageData['PRINT'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    ___arguments.context.pageData['PRINT'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/dcf81216c6e8c93847a8a188dbe80fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6723508de691f1d4d66f8631015b6a92'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/5688d8d56c48d45bc2d8fbb8f5f89018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/f33c7478ddf3eed2705831d871cc4a77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'tariefreistijdkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/6088dbe890c8578a71d83bc8725886b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/0851a7959d880278171c695340fd4c6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/23d83fad931c9708b55f1504232cf858/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a91ef27d8a58895671dbf49a0b555426'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/70c820b488a829585758a8f8b8d80015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6f86a48e81ec6dcdbd1f0f89d68ee18'), 'reistijdkmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/a91ef27d8a58895671dbf49a0b555426/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/d6f86a48e81ec6dcdbd1f0f89d68ee18/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdkmexbtw')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/ee1dcdf8a8cb8e6897b75cd8f90f4478/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ee1dcdf8a8cb8e6897b75cd8f90f4478')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzinvolzelfbetalend/components/344853187618746f7d78cf6887989288/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('344853187618746f7d78cf6887989288')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','West-Brabant',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dc752a9cfccfe424bd3c295c71ca7aa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zinvol/Stadsgewest Breda',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7e88418c3c1b8afacc91ea44aeab73f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','Zeeland',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a54200b23e5816b15ba779695587c5dd', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult zorgvrager\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Consult professional\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND regio=\'','CvL Zuid-Hollandse Eilanden',' \'AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a452a2313cf9da84975f129d875d6657', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('abda89071b1ae8d4056646d86474e809', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6685c69631b23ffa2ba44b7846f344a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a1020cf99491e01d669a05c9370e8f62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'MDO/PaTz\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81b85319aad158479a3176c684c545e7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('11ec3c02502b158785c517d465c3eca3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('076afe8a9ce3ed8ba2482a621ed90414', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9e67cbefecdf0a671de89e8f6fc76df1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Scholing\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Coaching on the job\' '].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut', 'btwinclscholing']).setSortBy('activiteit').setGroupBy(['activiteit', 'tariefperminuut', 'btwinclscholing']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81e9d7ed281fb148b2365574cf0886dc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b5a12b140bddea8b06eb464bca3db3a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cdfa16b8e45f03debba2896c54b37575', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('407c6331b21887412b5f264675c30dd3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8b82f752b67c5634fa40c31c09e5b6b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7dd9dce125eea425b03258c1198dce7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13e4826d82034bc9e4247d21d37aa978', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d5c3feae8f33f272f0ee446d26a473a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c4ff071fac6e9f2b48fd75e89c81c6c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\''].join(''))).setProperties(['Sum(reistijdminuten) as reistijdminuten', 'Sum(reistijdminutenexbtw)as reistijdminutenexbtw', 'Sum(reistijdminutenbtw) as reistijdminutenbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a2a1635fd64a205b329fcf244b3fe7c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4c03643ab0730496f0ec146fbf673f1f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdtotaalbedrag) as reistijdtotaalbedrag', 'maand', 'tariefperminuut']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('34bb1337b28c2d954352839117a20bbe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa28702f23efabb158315bba195a8eea', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zinvol/Stadsgewest Breda','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcc485a69b0237917be73bb7c892a46e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('796e4014856c76a63adb9b8cb38d197a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','CvL Zuid-Hollandse Eilanden','\'',' AND activiteit=\'Opbouw infrastructuur\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7a8f888152816d8a3b8dc676f282d08', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','West-Brabant','\'',' AND activiteit=\'Coördinatietaken\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eaf1ece286784dcdc04649c4ff6b5c36', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND regio=\'','Zeeland','\'',' AND activiteit=\'Coördinatietaken\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingminuten) as gewminuten', 'Sum(gewerktvoorbereidingbtw)as gewminutenbtw', 'Sum(gewerktvoorbereidingexbtw) as gewminutenexbtw', 'Sum(gewerktvoorbereidingtotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3f03940750e8692bd397aec8f56ee147', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('074ecc081e43c1ca4da4f41a186f630a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9886a73d83dacb7938026495a22a02ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('50da6d3ac82852e9918c35219648d681', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ef5b8e949d8b9fddf5eb591d1213ed24', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw<>0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ce298c49f9842f4a4aaea77e09342d2e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND reistijdminutenspeciaalbtw=0'].join(''))).setProperties(['Sum(reistijdminutenspeciaalexbtw) as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw)as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  tav = (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' '].join(''))).setProperties('regio').setSortBy('regio').setGroupBy('regio').setPageSize(100)));
  tavlist = (await Promise.all(tav.map(async item => {; return (getObjectProperty(item, 'regio'));})));
  ___arguments.context.pageData['tav'] = (String('t.a.v. ') + String(tavlist));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW1'] = false;
  ___arguments.context.pageData['VIEW2'] = false;
  ___arguments.context.pageData['VIEW3'] = false;
  ___arguments.context.pageData['VIEW4'] = false;
  ___arguments.context.pageData['VIEW'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/80f719fcaad7afb9cdf491d12f42e856/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('523672a38fecc9e63b21f6811d68ff43'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/428b005af85a1dc9f60d1e34afdf648b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/932c070e2877faafe4ef70f8fc1ebbca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3135b87e6a2b1035bd19a8a1094b8656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0e5f3f2bee8252d1b54e4fdffc58f71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4e19c139d5271bae40371c3101dba539/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e7d880717247a67199831fb2e21cce06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d175f72c3dc8a1c6978c35b5285230ae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/79e860592506df3fb1b5bf7ece4e967a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/62e60c23d7360cdaffd62771c501edbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/746df37da8dd562db5ed8a926baeded4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1ec2f021085cc2acc9e3df75e3f58a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/074ecc081e43c1ca4da4f41a186f630a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6ab398a7fa7abe3148f99847b488bf3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('286f1328f168c46dd721d57bcc32f2f4')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f7e88418c3c1b8afacc91ea44aeab73f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f7e88418c3c1b8afacc91ea44aeab73f')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a54200b23e5816b15ba779695587c5dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a54200b23e5816b15ba779695587c5dd')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/533a0ab1c02155551fc9807994ccd895/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/bd191bf3b20f6f3c737a527f9133f119/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d407b33ccc84f73290ea94ebdadf1f35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenexbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8f49aeee1c08e5ec455439eed2dca4e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['exclgewerkteminutenbtw']) + (___arguments.context.pageData['exclreistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/22cff4bcdb1cfd288dabbd661bfd696d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/72a94ef621cedf773223cc095a274586/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cd120de667962516396a4341a7b75b33/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclreistijdminutenspeciaalexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalexbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaalbtw'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaalbtw'));
  ___arguments.context.pageData['inclreistijdminutenspeciaaltotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaaltotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/82e87938b5fc932323f6da037fcb4889/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['exclreistijdminutenspeciaalexbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalexbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaalbtw'] = (___arguments.context.dataModel['reistijdminutenspeciaalbtw']);
  ___arguments.context.pageData['exclreistijdminutenspeciaaltotaalbedrag'] = (___arguments.context.dataModel['reistijdminutenspeciaaltotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1dc84a23c3d16bea43d903b6fc729123/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7f5bcebb0fef75fde8aa6d0c342a503c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/accd136d6683bc73d4f677d35f76a367/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ___arguments.context.pageData['START'] = false;
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['VIEW1'] = 'false';
    ___arguments.context.pageData['VIEW2'] = 'false';
    ___arguments.context.pageData['VIEW3'] = 'false';
    ___arguments.context.pageData['VIEW4'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2710d7ef46ad19503eb08884b290c39')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De bedrijfsnaam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e69353cb1eb5639caefdb9da335acaf')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c6f62e4f48a333af3c202a6b63ed72a')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    if ((getObjectProperty(___arguments.context.pageData, 'START')) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
      await new Promise(r => setTimeout(r, 3000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
      await new Promise(r => setTimeout(r, 3000 || 0));
      await (async function() {
      	window.print()
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var tavlist, item, tav;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4e69353cb1eb5639caefdb9da335acaf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6c6f62e4f48a333af3c202a6b63ed72a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315')['file'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );
  ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['START'] = true;
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['VIEW1'] = 'true';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['VIEW3'] = 'true';
  ___arguments.context.pageData['VIEW4'] = 'true';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/312add2812dfe17b78f7b302c45e9059/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7b99fc997a8f4cb31f0afe9b2aba4e3f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a70418ca86828dfc27df7e5e20058446/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/fa6fde96e573561527f4c7058ace30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/653d92711bffde05540e64fdf05b661b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/443c6a642218240c4749609aa327ae72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/36ea339cac3eacfc470790de84c9ea06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/48a3e37975e432924a4b87ba62826a37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2c2707b4307d6201822e796275884508/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a452a2313cf9da84975f129d875d6657/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a452a2313cf9da84975f129d875d6657')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/81b85319aad158479a3176c684c545e7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('81b85319aad158479a3176c684c545e7')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/34bb1337b28c2d954352839117a20bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('34bb1337b28c2d954352839117a20bbe')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7dc752a9cfccfe424bd3c295c71ca7aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7dc752a9cfccfe424bd3c295c71ca7aa')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/abda89071b1ae8d4056646d86474e809/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('abda89071b1ae8d4056646d86474e809')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/11ec3c02502b158785c517d465c3eca3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('11ec3c02502b158785c517d465c3eca3')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/aa28702f23efabb158315bba195a8eea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aa28702f23efabb158315bba195a8eea')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6685c69631b23ffa2ba44b7846f344a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6685c69631b23ffa2ba44b7846f344a5')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/076afe8a9ce3ed8ba2482a621ed90414/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('076afe8a9ce3ed8ba2482a621ed90414')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/dcc485a69b0237917be73bb7c892a46e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('dcc485a69b0237917be73bb7c892a46e')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a1020cf99491e01d669a05c9370e8f62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a1020cf99491e01d669a05c9370e8f62')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9e67cbefecdf0a671de89e8f6fc76df1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9e67cbefecdf0a671de89e8f6fc76df1')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/796e4014856c76a63adb9b8cb38d197a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('796e4014856c76a63adb9b8cb38d197a')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f7a9ecc117b643a150c51e857c9c4e56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/590d3008f53318fc05b98bf4829868df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/071b427b1eb4f6a196eb414cc12a1573/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/859c8fcc4f9c8cd2d3cda09eb58950ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['tariefperminuut']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8a79a88bc503b1bf0424b18545e386c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5538429343523a697f34c8817d564533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e1d430f48ddf15b8e1befe036bcf0fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/eec49f8b2aee792432c7888dfa26b4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/bcd79968c97a343d7e6d34973dabba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f42ee7bdf989b59248034508f4c40996/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/648b0a6778b2b5f11f59c87c04674372/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4518dfcfa766a9caee4a41fd405ace1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b08f83ef72360015d1e460e8f5aa9358/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2223646c3793c68fd45b0181f6845c69/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cc583438c387dd8d2f3a524d8e18231d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d1c6fed523e676d1f588e741a66640c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e562576afbca1decb9b1fc3b1566a3a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0a9452f50ba74bc88db484f986821724/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28')['reistijdminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b2977c780ac21b99499e1fa1ca74255f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/56c35752782b4d7bcd3b9d3255c4cf6d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/051d19bc9277554844d40534d399be5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/bd97b931fcbd85391cd8e566f20e832f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5811694bd03c64dce1019f0440f9f6a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/538c74dafbe6c73f41e96d29a56c2eca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9ccc2e349dd8cb7bdd7aac85c60275e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0c3982a94f0dbd43a27c43f4e25dff5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/557917afb53bc122a1d996495037d6f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f349e6784f1a93d153eb1ae9252da201/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0d25b96ae8bff27d3865723c656a78fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b')['gewminutenexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a9af21650257d813b1038474a9320df5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a3e27ff971056c61ac3a3c9f08a2f153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cee564d45661dc2d1a62f90bcb22ca03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9299951da81ff8ebed57492d7dff2f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cdfa16b8e45f03debba2896c54b37575/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW2']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW1']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7dd9dce125eea425b03258c1198dce7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW3']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4c4ff071fac6e9f2b48fd75e89c81c6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == false) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW4']) == true) {
    visible = true;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0e8365e34ad9992acec64e21cd72a02f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/document/d/1RLjkhuFEQrLKCoUS8dRrl2HsFl5eb0ls/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5fe7f9ceb53b968c6c86d5ebc37420f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d2710d7ef46ad19503eb08884b290c39/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a03fb9e2b05df8efe3e95d06bb2d06af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclreistijdminutenspeciaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f35a85eae2fcee453a795686d8d68e4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5906d4762ed9b411e6bed347abffc71d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3f03940750e8692bd397aec8f56ee147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8dd98867bfe1dd4967df0b960c4180f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c3a6a646e3937a5f56bd649536c1e5d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/ccb6ac77010de42675c5adf99161b68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b1680c389959949ab0740f5e3c981cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7c112cf6114e802258967966a4fb565d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'START')) == false) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/ca933cb7d3c90dbeeb6d5ed940453389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/ee2d9b8afd82fe9bab5dad0238fe19a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d6f65ac6cb3a711ea16a701db221c8f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/51d63bc5e8ce88f63b3f68492594d255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d67fa12c7a7c2e73f63ebfb9584aa68'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8c913b77f7df8d36dcbbc765e8f312cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('451f4e556cc28c226569b78c62e49c41'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8e9afed82806dcfbc7eaa4268f21b947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7ba78e0845a96c66ee2ed77263fda1db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d20d492f841ffd96f5855bedcd14781c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/57a4e1edddb50da4592d3b71fed2659c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54bd31ac3eb7a614a492692ed79a397d'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5d0ade29fe3a85955b0b2a9722e423d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4fc2276f7f161e1fc95e70b2822339fe'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f80b691361d569d97df9c2c5854b537d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('605b4b0800642a65a544245e398ae0d8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/38bc9e4fc786fcc36e04d136e5ed2c04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f35a85eae2fcee453a795686d8d68e4a'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/493131ad499e5c15496636746912f5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16aa3f332892b72b3929c9b593ab0138'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/987402ad2de3352e3224d7ab96316f86/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c0138043897a54bb88ad944adfe8ccf4'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/64ba3bed2ebea56b9112c878fcd6de55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af5e09c88bdf9bae31dc738142bb8e5c'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/177654ba7ace4e789c67e2e454df01d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5056376e56a8ab0729089e99485fcd49'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e02a34fb9bfdc8ac20e72d04e5f3b118/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9299951da81ff8ebed57492d7dff2f28'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cc21e3582de70b4551ccf53973e3b784/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c039542894d585527c6b1ac4d11c9ba'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/67091fb6510814aaa3e9c00fa9336008/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af6bffddf6320c9a805cd61e0f784045'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/04219b5eb03ba8f4407e236a5baedde7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6f36649ebaf6e3a363299ad20037f282'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/bad4db33177b074e613504723b830365/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4724564ba01106e77c4e0e02085d62a8'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/02e65db5bdde359934d29c83131e4154/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1ec2f021085cc2acc9e3df75e3f58a9d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/397fc0df33f3b4efbc45ca645f25eb49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c6d225e560d403bc5f99ca082d3cf37b'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9ce37da8ccc1f248763462d36f7afe99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d83424cee0efabf8361148f43d116582/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1cc221a1538fde7413cf51c3665b275d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/3129b24f3a1d5d9a138c74b204634acc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/55f117fbeb35fffaf25340aadc084f07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c5d6961480c6c21f7313457355499192/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/81e9d7ed281fb148b2365574cf0886dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c4297219ae9c8d948ad25ab4cc76663b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a0270e6598b9c11dff44f3061613ab54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c5d6961480c6c21f7313457355499192'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/407c6331b21887412b5f264675c30dd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/7a32f1dae0d74fe93808a7291f7a958d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/579d49945e2fae5bfc4347c88dece931/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/f273eee26972969b6111d908c4a79b95/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/dc5ace4a7a6fadff15ccea07ef62c97a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c773d9d3e8357a5f40a1e628c1633ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1125ea4a2dd9c523568317d9bd4a1f11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/13e4826d82034bc9e4247d21d37aa978/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2a2a1635fd64a205b329fcf244b3fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/0fdfabf1e7c81689bf8c22d41b788fda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4d4dff51210990a5a5b3b89d35fb062e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5f27e9e60f24d27125336dc9a563da7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1332e17b3d8909ce093225e80576dfc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7a32f1dae0d74fe93808a7291f7a958d'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/168a958dcc682723c11d8a5bd21c666b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c773d9d3e8357a5f40a1e628c1633ad6'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/fff7517f93962816c01acfb45e491213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1125ea4a2dd9c523568317d9bd4a1f11'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/6b5a12b140bddea8b06eb464bca3db3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e8b82f752b67c5634fa40c31c09e5b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/8d5c3feae8f33f272f0ee446d26a473a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/4c03643ab0730496f0ec146fbf673f1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == false) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW1')) == true) {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a71f7745e15eebc8e11102ab68aa7eab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/19bd630731024763009ceed7bf28af45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/dd2f5d971f51e5bd3f8c15aed895be07/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/ab5e049cfaf261dd6d9cbe388df8f00b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a60e072e790e64cdf25be63dc574a1c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e40bfa1cdad637111b4e4f87ceb8ef5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/af0ba216d8875658efdad9361cf72592/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5d967d048b3c0bb740a9512c6e09c479/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1712661fcc8d4a75c33a3a051093fcbf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/33b2e376f3d48547aa9fb3688291c227/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/aa76f8acc4854fc877d2e8ecc638e8af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/14ba4956f04be3e9df54602a4dffd645/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdminutenspeciaalbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/90232421addac742871a476242edf713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a71f7745e15eebc8e11102ab68aa7eab'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1d8fd598bab5424a184634cf83cd7e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19bd630731024763009ceed7bf28af45'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/a6e45a59b30e18cc8ebbff5b0a2f9d73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd2f5d971f51e5bd3f8c15aed895be07'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/75e6264b6a06970df052fcebcfb7c62f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab5e049cfaf261dd6d9cbe388df8f00b'), 'reistijdtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c8db3c54e94e7ac4df159bb3cd520c89/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/594b4a1ed0d2bbd7a6e2bf47e4028434/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2a498d29f06a3c5f36c83fd55ff4a7e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/cc56a36639a9dec98971dc7e017ef1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/605429c76cc97ce4e56e920e84bffba9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/e0a63f773da915cdd23d62e1efc34c66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/070296ef3d1b908f5c1ea4c1926b1857/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'tav'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/96d2f14dcd9b9f528cdbaa93bd4e2c88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/bcc290d98e3a4f4fa3a49867b2142924/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/5aeea6b268c97c420aa3b4ce0f65bf4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/72125c5ba0bc7519bfd3ba2e0ea1ce6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/58c45fd846be0ec33e0fed11501951ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b85e226d7be883b3fdd9e923e4d6fc1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f0de457a8a80d252629dec71b6b9731'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/eaf1ece286784dcdc04649c4ff6b5c36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('eaf1ece286784dcdc04649c4ff6b5c36')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/ff78c0984bf8b098d8d8c5e8ce2b89f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/c3be8d3e6169f1235628c2afd9022ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/1bc5bea892f82d4e8cea4ce9d1888128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/2f171c2a9fc8de28b639b4288cf87f58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('48dfd4e83d2564d8321830cb44f88de6'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/d7a8f888152816d8a3b8dc676f282d08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d7a8f888152816d8a3b8dc676f282d08')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/9f9d32f14a55ee0f19128ff8ac08cec8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = String('Extra informatie: ') + String(getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzichtzwnl/components/b834aa684e1171185458aa32bf3e8cdd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b834aa684e1171185458aa32bf3e8cdd', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijndossiers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f0c646a44d335ddb9f8403754115faac', (await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    ___arguments.context.pageData['brabant'] = true;
  }
  ___arguments.context.appData['startpagemijndossiers'] = 'alleactiviteiten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpagemijndossiers'));
  ___arguments.context.pageData['statusfilter'] = 'Actief';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eaa9f8755c3cff7dbd1b529a11621d76', (await Backendless.Data.of('tarievenpercentra').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2884cb6ff3a583da506de4289dde1eb6', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\''].join(''))).setSortBy('dossier DESC').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndossiers/components/ad1dda42ca6e610a84b4617b936eb2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/93a56b644eec20a89db4265f06054542/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/c92b6df66c75680c5fd1069a59d24d92/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['tariefconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'consultinwpro'))));
  ___arguments.context.appData['tariefgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'groepsconsult'))));
  ___arguments.context.appData['tariefmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'mdopatz'))));
  ___arguments.context.appData['tariefscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'scholing'))));
  ___arguments.context.appData['tariefcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coaching'))));
  ___arguments.context.appData['tariefcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coordinatietaken'))));
  ___arguments.context.appData['tariefopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'opbouwinfra'))));
  ___arguments.context.appData['tariefcoordinatie'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coordinatietaken'))));
  ___arguments.context.appData['tariefreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'reistijdkm'))));
  ___arguments.context.appData['tariefreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['tariefwerkgroep'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'werkgroep'))));
  ___arguments.context.appData['tariefraadvanadvies'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'raadvanadvies'))));
  ___arguments.context.appData['tariefopjeplek'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'opjeplek'))));
  ___arguments.context.appData['tariefopjeplek'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'opjeplek'))));
  ___arguments.context.appData['tariefcoordinatorschap'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coordinatorschap'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijndossiers/components/42e4711b2aace0850c0234abb0afa5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })([(JSON.stringify((___arguments.context.appData['tariefconsultinwpro']))), (JSON.stringify((___arguments.context.appData['tariefgroepsconsult']))), (JSON.stringify((___arguments.context.appData['tariefmdopatz']))), (JSON.stringify((___arguments.context.appData['tariefscholing']))), (JSON.stringify((___arguments.context.appData['tariefcoaching']))), (JSON.stringify((___arguments.context.appData['tariefopbouwinfra']))), (JSON.stringify((___arguments.context.appData['tariefreistijdkm']))), (JSON.stringify((___arguments.context.appData['tariefreistijdminutenspeciaal'])))]);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/8445c80c81cd6b6be17775cadf48b095/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'consultzorgvrager';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8445c80c81cd6b6be17775cadf48b095')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
  } else {
    B = 'Gender';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    C = 'Gemeente/woonplaats';
  } else {
    C = 'Postcode';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))) == 'projectleider') {
    D = 'Akkoord coördinator';
  } else {
    D = 'Akkoord projectleider';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Relatienummer';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/f402de9bd1e8a5d6ad0e80641523ba61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'consultzorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/331cd7a54ea853aaa8445becbc66b2cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'consultprofessional' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/7b5c5228545448ad3f78caad0e7fb916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'groepsconsult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'groepsconsult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'groepsconsult' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/6916cdae447817893948321b2da2a317/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patzmdo' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/04d41f9d57bbb992d5547f463d08bfb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/c2ce9af15396de05046e030c1f1b1488/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'coaching' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/b1ebaa5b07651fe78438beda88bda076/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'coordinatie' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/99deb756bdd3c962231610977ab305ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opbouwinfra' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/9ddb112af8db5cae71583fd6174df539/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setconsultinw')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  async ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Consult cliënt';
  } else {
    text = 'Consult zorgvrager';
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/ba61576df91825f7559a19b4c93bae15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setconsultpro')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/c9f1a085c1b7fe4f1975679fe8c4792b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setgroepsconsult')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/0913ad1f9ffd08e21539f0acc8e24ea9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setmdopatz']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/dda8f4e2898e0b14ef6c0694c38b54ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setscholing']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/e57afb8285161e99c37e40c176dececa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setcoaching')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/dad5ed4519448476d4de9361ad96078d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setcoordinatietaken')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/675e0e7cd83fd521c0e2e4699f0b4f6d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/26fbd3573286e38eaff852f28a3ad8f5/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'consultprofessional';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item, D, C, B;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('26fbd3573286e38eaff852f28a3ad8f5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult professional','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/180cbea46c343016a211e555dd520998/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'groepsconsult';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('180cbea46c343016a211e555dd520998')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Groepsconsult','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/e2497a3e29c174e2d407d4f756374df1/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'patzmdo';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2497a3e29c174e2d407d4f756374df1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','MDO/PaTz','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/ba32efc19d6692cc58085b39930b0f45/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item, D, C, B;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ba32efc19d6692cc58085b39930b0f45'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Scholing','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/f9a84b670396eafcb96aad0313fa7c84/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'coaching';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item, D, C, B;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f9a84b670396eafcb96aad0313fa7c84'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Coaching on the job','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/4507b1055ad30a823a19452f1d7d5343/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'coordinatie';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Coördinatietaken','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/dd0971b63ef3a84151d8c8aed6c5a258/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'opbouwinfra';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Opbouw infrastructuur','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/29a9a859dad9bc311997d99db4774832/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'alleactiviteiten';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('29a9a859dad9bc311997d99db4774832')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    C = 'Relatienummer/ CvL-kenmerk';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/f7cc1c0507f335de83445804b22e6632/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/f0c646a44d335ddb9f8403754115faac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/75cc8b462205b0e7be2d5332281e33eb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['conditionzorgvrager'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditionprofessional'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult professional','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditiongroepsconsult'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Groepsconsult','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditionpatzmdo'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','MDO/PaTz','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditionscholing'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Scholing','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditioncoaching'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Coaching on the job','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditioncoordinatie'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Coördinatietaken','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditionopbouwinfra'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Opbouw infrastructuur','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));
  ___arguments.context.pageData['conditionalleactiviteiten'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''));

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Klik op onderstaande filter om alle afgesloten dossiers in te zien' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/e38909a3608de8219b81ff33d192b4ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('f35998f11f855b16d579d33b84062a4c')['statusafgesloten']).indexOf(((await Backendless.UserService.getCurrentUser(false))['username'])) !== -1) {
    text = 'Afgesloten';
  } else {
    text = 'Actief';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/8c16d977679df42a87aa31a9546a0521/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10f4e0bef845760d1a6198339c4cb631')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/734844a4df58188c835ba0e8a51281dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'consultzorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/c85c7b384d1f8e59481e933d6341965d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'consultzorgvrager';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/mijndossiers/components/7f24199e73b85bfe70d84378abfbccc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'groepsconsult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'groepsconsult' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/2c07837d7bf296619af547a9c63307c6/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'groepsconsult';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Groepsconsult','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/eeff9a950b8cbe77c69cf9581355e9f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/71819e65213f4c43b7a755ace57ccbbc/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Scholing','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/7ceba078ce82d06420aecdac0a890d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17a38ab526025dedf6112fdaf18114f7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('799dbea9909f47271aaae9c8c7dd8b2c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0c646a44d335ddb9f8403754115faac', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4af364aa3124f48c51aca8f1e81c94c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44bcdd95510a9d827af91dbff5b62982', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('931936f3437182456c1fbc5d19984568', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5d5abe93276d13b411bb25e0ea16ac2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75cc8b462205b0e7be2d5332281e33eb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c16d977679df42a87aa31a9546a0521', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02c850efab8da1d2b9cc2de8e697f50a', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4af364aa3124f48c51aca8f1e81c94c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02c850efab8da1d2b9cc2de8e697f50a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44bcdd95510a9d827af91dbff5b62982', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('931936f3437182456c1fbc5d19984568', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5d5abe93276d13b411bb25e0ea16ac2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75cc8b462205b0e7be2d5332281e33eb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c16d977679df42a87aa31a9546a0521', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0c646a44d335ddb9f8403754115faac', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17a38ab526025dedf6112fdaf18114f7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('799dbea9909f47271aaae9c8c7dd8b2c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/c4af364aa3124f48c51aca8f1e81c94c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalendergv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/b8232e381ea97f9113c6b64d107a6915/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('b8232e381ea97f9113c6b64d107a6915', (!___arguments['isOpen']));

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('b8232e381ea97f9113c6b64d107a6915', ___arguments['isOpen']);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/mijndossiers/components/d48f7821598d2438284cc2c4cbfd4749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setwerkgroep')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/fb5dac9e36342e6c9322a3f6ca16e8de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/0442aad6913a0d8403dd022be03ff029/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Scholing','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/mijndossiers/components/5568c7ca5df30de923128cfa6d37b7cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'werkgroep' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/a673637368ca80cd40163c4a62df0d4e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Werkgroep','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/mijndossiers/components/1d8742df4cfa911eb88e562277f8ddc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/1a4e33074b252e03d3839a186a37d2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/bf7a78697ebc76e1b99636028909f3dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('bf7a78697ebc76e1b99636028909f3dc', (!___arguments['isOpen']));

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('bf7a78697ebc76e1b99636028909f3dc', ___arguments['isOpen']);

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/mijndossiers/components/108b93a7371bd0ae6c3fe6d6039a2f54/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setopjeplek')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/5f540f2316a90f2c7eae0766651f431a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'opjeplek' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/153996ab9a96fceff902c90a064c003a/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'','Consult 1','\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\' OR username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'','Netwerkactiviteiten','\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\' OR username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'','Ontwikkeluren','\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\' OR username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'Groepsgesprekken\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\' OR username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'Presentieactiviteiten\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/mijndossiers/components/02de293e0682fb3bf24215dd52c3f756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/d82518ea683db40112f8cf0567b683eb/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Scholing','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'scholing';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/mijndossiers/components/82b94b89bd4ac136b405223dac583023/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvjm')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('resterend', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/25d763dc4c9183c3e9cf80186c18cb89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/3cab98f9d9615a33337eb4edb7ab8c04/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/9214821ef76c5723ff1509368b96fce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierstoevoegen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/02c850efab8da1d2b9cc2de8e697f50a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/8dc811fcfb7fb9c3f1a40dc1aa31cb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patzmdo' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/fc05aae80fe3acdf39bbd91436fb72b6/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','MDO/PaTz','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'patzmdo';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2497a3e29c174e2d407d4f756374df1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))) == 'projectleider') {
    B = 'Akkoord coördinator';
  } else {
    B = 'Akkoord projectleider';
  }
  return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/4fe8b66fe76ad48e7709d641d4edcc4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/8566d42f82e75d9efe1f56a5481344dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'npzf' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/ea7ccb18aa3786c14ac38ff5ac01da79/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'opbouwinfra';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Netwerkbijeenkomst NPZF','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/68e6b60420c9111dea1cb67f5cfbc25c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/39661dcdd275a201fb849849a9c40ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'triage' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/11162cf109dd9416abbe7772eacc4f6e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'triage';
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'mijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Triage/intake','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossierskalender/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossierskalender/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossierskalender/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndossierskalendergv/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossierskalendergv/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossierskalendergv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijngegevensgv/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('189f5a0d8d51bab81cc41f96fd1293e3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties(['centraname', 'naam', 'username', 'email', 'organisatie', 'dashboardnaam', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclscholing']).setPageSize(10))));
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijngegevensgv/components/501fb8d6f63dc00cd7610922814ea438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    await Backendless.Data.of('historiehelpdeskvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`helpdeskvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')) }) );
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 6000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevensgv/components/ad9290ae160fb19c40781acdb445d9d7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );
  ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/3033cec633750c865d839d4676ff0764/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3033cec633750c865d839d4676ff0764', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevensgv/components/8d4b19d71b1f5fd6db5e793a3792ce61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/e80459def20f761364d89751ff2fb476/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/fb11de6a924286d7d9bd82119b75bdda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/9762fc8b74559eabbeccd1121711793f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/e05588c5b376a736cccd307686111917/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/11d32d5f405e0b3ea9b8922a61a6e70e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/01160c6c7cbc160ad88c882b81459025/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/b1dbd676c7493e7cc04e871931d8e354/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/3ab1d976b2159693507e569bacf45806/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/0e7c8a7565464e7e9a8ff5d5f51fb45f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/91b9268dce8ae0eaa1ced1d849b492f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'selfbilling')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/d00fda287b0547125311e2466a975117/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7d45302ccf19089fe89ef7202cd457d'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/35a13d92c6137db7363beee7219a8cdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7d45302ccf19089fe89ef7202cd457d'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/26699768ce28a38f8d8a3c3b2d8b57b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'akkoordfactuurgegevens')) == true) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`akkoordfactuurgegevens`]: 1,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('factuurgegevensakkoord', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'akkoordfactuurgegevens')) == false) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`akkoordfactuurgegevens`]: 0 }) );
    await Backendless.Messaging.sendEmailFromTemplate('factuurgegevensnietakkoord', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/a7a4d3c17bbb90ab598de2a4036fbc88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv/components/cae4e792870611f43daf227e1c62b214/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/c469e6768debcae901dc234b9fdfef89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/70ef9727964d1d178d883b2111fd94c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/6c9358ae678c0f34c01c84c460bef183/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/4a2dfdafc235fac9b37d708aa6a1bb58/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4a2dfdafc235fac9b37d708aa6a1bb58');

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4a2dfdafc235fac9b37d708aa6a1bb58');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/mijngegevensgv/components/cc81dbbfd592c4bc554f3b16a341f209/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/353be4677b07935d431874edf87e4ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/f67cc8ce5227192fb9589929b232029c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/979ba34a95fb564391962b77a2edbf4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/d9eed20fd6eaa24cb8d55e02e1368819/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/05dc506d4183befb2abe92f1a42ba8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var naam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'btwplichtig')) == 1) {
    naam = 'Ja';
  } else {
    naam = 'Nee';
  }

  return naam

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/e9c2fb69b414ca6b3b1dc91b9b1c3f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'btwinclconsulten')) == 1) {
    text = 'Ja';
  } else {
    text = 'Nee';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/ed831756120bc47cd7dc7ac717e34769/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'btwinclgroepsconsulten')) == 1) {
    text = 'Ja';
  } else {
    text = 'Nee';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/86d54802bec4b3594ce4e8a8192cf39c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var naam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'btwinclscholing')) == 1) {
    naam = 'Ja';
  } else {
    naam = 'Nee';
  }

  return naam

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/6337c985da3e3a08cf8944ffc69ce597/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/bca8507202befcf680887e62cca261b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/2b5aea4641e5699bfa8e7c17ee5e3cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'ZHN') {
    name2 = 'Zuid Holland Noord';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'Haaglanden') {
    name2 = 'Haagsche-Zin';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname')) == 'Lorio') {
    name2 = 'Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7533bf1ee0ba6efa855b164280310141'), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/434e5bdcdc442e681b8beaff6b6eac89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv/components/fd4e3731813ac3a63a7d0961c54a6e75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevensgv1/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevensgv1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('189f5a0d8d51bab81cc41f96fd1293e3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties(['centraname', 'naam', 'username', 'email', 'organisatie', 'dashboardnaam', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclscholing']).setPageSize(10))));
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijngegevensgv1/components/501fb8d6f63dc00cd7610922814ea438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    await Backendless.Data.of('historiehelpdeskvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`helpdeskvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')) }) );
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 6000 || 0));
    ___arguments.context.pageData['emailupdate'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevensgv1/components/d5b4a8eb6a95f14ef41cf931df381d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var naam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1) {
    naam = 'Ja';
  } else {
    naam = 'Nee';
  }

  return naam

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/407cd3477c6efd89ea38e681a639c77b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'centraname')) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/6a7b79951bbcbe5c167577927ae9a371/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var naam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwinclscholing')) == 1) {
    naam = 'Ja';
  } else {
    naam = 'Nee';
  }

  return naam

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/de6e645358461d95d0bf21ac655dbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/30c76619595e7da566c8dc03814674e1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/ce31651396c862d8f182057acd7b7062/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwinclconsulten')) == 1) {
    text = 'Ja';
  } else {
    text = 'Nee';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/7373fc52fb145a77a853e4096a2f86b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwinclgroepsconsulten')) == 1) {
    text = 'Ja';
  } else {
    text = 'Nee';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/214d8f4650a335774281c281969d457e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/bf741c09fde1be3aabd13aaa444fc454/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/1b45278d11d26c6e874cb72448183b4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/2b558c646b394abefd0d7253f5e9ed6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('04cce3548a385f42ee24873deba3165a'), 'btwplichtig')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/ad9290ae160fb19c40781acdb445d9d7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );
  ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881')['kvknummer'] = null;
  ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881')['btwnummer'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/3033cec633750c865d839d4676ff0764/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3033cec633750c865d839d4676ff0764', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevensgv1/components/8d4b19d71b1f5fd6db5e793a3792ce61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/e80459def20f761364d89751ff2fb476/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/fb11de6a924286d7d9bd82119b75bdda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/9762fc8b74559eabbeccd1121711793f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/e05588c5b376a736cccd307686111917/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/11d32d5f405e0b3ea9b8922a61a6e70e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/01160c6c7cbc160ad88c882b81459025/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/b1dbd676c7493e7cc04e871931d8e354/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/3ab1d976b2159693507e569bacf45806/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/0e7c8a7565464e7e9a8ff5d5f51fb45f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/91b9268dce8ae0eaa1ced1d849b492f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'selfbilling')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/d00fda287b0547125311e2466a975117/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7d45302ccf19089fe89ef7202cd457d'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/35a13d92c6137db7363beee7219a8cdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b7d45302ccf19089fe89ef7202cd457d'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/26699768ce28a38f8d8a3c3b2d8b57b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'akkoordfactuurgegevens')) == true) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'akkoordfactuurgegevens': 1,'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'GV': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
    await Backendless.Messaging.sendEmail((String('Facturatiegegevens akkoord gegeven door ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br><br>',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'heeft de facturatiegegevens akkoord gegeven'].join('')) }), ensureArray('info@lorio.nl'), undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881'), 'akkoordfactuurgegevens')) == false) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'akkoordfactuurgegevens': 0 }) );
    await Backendless.Messaging.sendEmail((String('Facturatiegegevens NIET akkoord gegeven door ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br><br>',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'heeft de facturatiegegevens NIET akkoord gegeven'].join('')) }), ensureArray('info@lorio.nl'), undefined);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/a7a4d3c17bbb90ab598de2a4036fbc88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevensgv1/components/cae4e792870611f43daf227e1c62b214/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/c469e6768debcae901dc234b9fdfef89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/70ef9727964d1d178d883b2111fd94c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/6c9358ae678c0f34c01c84c460bef183/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('207f3b76f29fb60e8736acbf73fb4881') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/4a2dfdafc235fac9b37d708aa6a1bb58/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4a2dfdafc235fac9b37d708aa6a1bb58');

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4a2dfdafc235fac9b37d708aa6a1bb58');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/mijngegevensgv1/components/cc81dbbfd592c4bc554f3b16a341f209/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/353be4677b07935d431874edf87e4ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/f67cc8ce5227192fb9589929b232029c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/979ba34a95fb564391962b77a2edbf4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevensgv1/components/d9eed20fd6eaa24cb8d55e02e1368819/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/a6fba3ea0973d1b7458556e103dcfd88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/ecbc1fa879b4fa34da3dea81a286469f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/eeeeda7dd7a3624a2aca33f55eb38544/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/59811a069deafe52ec66ac555b3cb781/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Dossier ') + String(JSON.parse((___arguments.context.appData['dossier']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/fc69bb91203a67f15a55b94d3b5f541a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'nieuwehulpvraag')) == null) {
    (function (message) { alert(message) })('Nieuwe hulpvraag moet ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('hulpvraagconsultinwpro').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'datuminvoerhulpvraag': (new Date()),'nieuwehulpvraag': (getObjectProperty(___arguments.context.pageData, 'nieuwehulpvraag')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/f55d64a71f25944aec513bb398ef38c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nieuwehulpvraag/components/0b272f280b0ef051dd817ee9d9f634cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'XXX') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkostenaccountant', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nugv/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nugv/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/nugv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/nugv/components/979216ad64451b674a629ce3a1ded715/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nugv/components/18ea47610bde8c968764a4388b2da13f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/nugv/components/65f87647c8c8509bda7c07db096896c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/nugv/components/14a5abf81ea87b58342838a718786136/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('centra:') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/f7c8f57aa3d7b5bdbe4a562bebeaa4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PL*\' AND userStatus=\'enabled\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var objectid, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  objectid = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectpl')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})))[0];
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(objectid, 'objectId'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/63baa7578bd5431ff8e2ead821598623/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Registraties').find(Backendless.DataQueryBuilder.create().setProperties('centra').setSortBy('centra ASC').setGroupBy('centra').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centra')),[`label`]: (getObjectProperty(item, 'centra')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/03ab6057cbde36042fc98317782a9c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nietdeclarabellist, item, records, recordslist;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Centra invoeren');
  } else if ((getObjectProperty(___arguments.context.pageData, 'file')) == null) {
    (function (message) { alert(message) })('Naam tabel invoeren');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Projectleider moet geselcteerd worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Actie moet ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      records = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': (getObjectProperty(___arguments.context.pageData, 'file')),'whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
      recordslist = (await Promise.all(records.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in recordslist) {
        j = recordslist[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })((String('Permissions zijn toegekend voor deze user in tabel ') + String(getObjectProperty(___arguments.context.pageData, 'file'))));
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      records = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': (getObjectProperty(___arguments.context.pageData, 'file')),'whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join('')),'properties': ['objectId'] }));
      recordslist = (await Promise.all(records.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index2];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
      }
      (function (message) { alert(message) })((String('Permission zijn verwijdert voor deze user in tabel ') + String(getObjectProperty(___arguments.context.pageData, 'file'))));
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/dba8ec77e619eb798ade1476cabef118/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/b5ec90346a2d225d8a83a8837ccd337e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, usernamesingle, projectleiderslist, item, projectleiders, username, recordslist, records;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Files.Permissions.READ.grantForUser('', '');
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
  await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`objectId`]: j }));
  username = (await Backendless.Data.of('users').findById(j, Backendless.DataQueryBuilder.create().setProperties('username')));
}


  records = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'users','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'GV\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'GV*\' AND userStatus=\'enabled\''].join('')),'properties': ['objectId'] }));
  recordslist = (await Promise.all(records.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index2 in recordslist) {
    j = recordslist[j_index2];
    username = (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',j,'\''].join(''))).setProperties('username').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')) });})))[0];
    usernamesingle = (getObjectProperty(username, 'value'));
    await Backendless.Files.createDirectory(encodePath((String('gvdocumentenquestio/') + String(usernamesingle))));
    await Backendless.Files.Permissions.READ.grantForUser(j, (String('gvdocumentenquestio/') + String(usernamesingle)));
    await Backendless.Files.Permissions.WRITE.grantForUser(j, (String('gvdocumentenquestio/') + String(usernamesingle)));
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PL*\' AND userStatus=\'enabled\''].join('')),'properties': ['objectId'] }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index in projectleiderslist) {
      j = projectleiderslist[j_index];
      await Backendless.Files.Permissions.READ.grantForUser(j, (String('gvdocumentenquestio/') + String(usernamesingle)));
      await Backendless.Files.Permissions.WRITE.grantForUser(j, (String('gvdocumentenquestio/') + String(usernamesingle)));
    }
  }
  (function (message) { alert(message) })('Mappen zijn aangemaakt voor de GV-ers + de users hebben toestemming om te lezen en te schrijven');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/0c73668387e723418f5cc02f517aae5b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Registraties').find(Backendless.DataQueryBuilder.create().setProperties('centra').setSortBy('centra ASC').setGroupBy('centra').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centra')),[`label`]: (getObjectProperty(item, 'centra')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/90190eebf67267261a5570da821c6933/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, recordslist, item, records, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'GV\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'GV*\' AND userStatus=\'enabled\''].join('')),'properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'username'));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    records = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['username=\'',j,'\''].join('')),'properties': ['objectId'] }));
    recordslist = (await Promise.all(records.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in recordslist) {
      k = recordslist[k_index];
      await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: k }));
      await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: k }));
    }
  }
  (function (message) { alert(message) })('Permissions zijn ingesteld, de users hebben nu toegang tot overzichtgvquestio');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvinstellingen/components/6467e2f464cbdbec2123ae33db58c881/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var URL2, userid;


  await (async function() {
  	var URL2, userid;


  	  URL2 ='https://cvl23.lorio.nl/api/files/gvdocumentenquestio/Qu37ejn';
  	  userid = '017598E6-1132-4E3F-AF56-B4CED4571918';

  	Backendless.Files.Permissions.READ.grantForUser( userid, URL2 );
  	Backendless.Files.Permissions.WRITE.grantForUser( userid, URL2 );

  })();
  if (false) {
    await Backendless.Files.Permissions.WRITE.grantForUser('017598E6-1132-4E3F-AF56-B4CED4571918', 'gvdocumentenquestio/Qu37ejn');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.close();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, list, newObject, j, txResult, myTx, orders, select;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    orders = (_uow.find('overzichtgvquestio', Backendless.DataQueryBuilder.create().setSortBy('Naam_GV ASC').setPageSize(100)).setOpResultId('getOrders'));

  })();

  txResult = (await myTx.execute());
  if (txResult.isSuccess()) {
    ___arguments.context.pageData['myOrders'] = (getObjectProperty((txResult.getResults()), 'getOrders.result'));
  }
  ___arguments.context.pageData['object'] = ({ [`field`]: 'Naam_GV',[`flex`]: 1 });
  newObject = 0;
  list = ['Naam_GV'];
  for (var j_index in list) {
    j = list[j_index];
    newObject[j] = (getObjectProperty(___arguments.context.pageData, j));
  }
  (function (message) { alert(message) })((JSON.stringify(newObject)));
  ___arguments.context.pageData['columnlogic'] = ['[', '{"field": "Naam_GV", "flex": 1}', '{"field": "Straat_en_huisnummer", "flex": 1}', ' {"field": "Postcode_en_woonplaats", "flex": 1}', '{"field": "Telefoonnummer_1", "flex": 1}', '{"field": "Telefoonnummer_2", "flex": 1}', ']'];
  list = ({  });
  addItemToList(list, (JSON.parse((['{"field": "Naam_GV", "flex": 1},','{"field": "Straat_en_huisnummer", "flex": 1},',' {"field": "Postcode_en_woonplaats", "flex": 1},','{"field": "Telefoonnummer_1", "flex": 1},','{"field": "Telefoonnummer_2", "flex": 1}'].join('')))));
  (function (message) { alert(message) })(list);
  ___arguments.context.pageData['columnlogic'] = list;
  ___arguments.context.pageData['columnwidth'] = (String((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth'))) + String('px'));
  item = 0;
  item = 0;
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['status'] = 'Actief';
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/overzichtgvquestio/components/cefd3283586ffdcbf1255a655763b0ac/bundle.js', [], () => ({
  /* content */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cefd3283586ffdcbf1255a655763b0ac', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fbad59dc00b0c29fda2b62869ce6556', true);
}


  console.log(___arguments['cellParams']);
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Overeenkomst') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Addendum') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'SKGV_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'CV') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'VOG_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  }
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Naam_GV') {
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    ___arguments.context.pageData['datagridview'] = false;
    ___arguments.context.pageData['objectId'] = (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'objectId'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
    ___arguments.context.pageData['updateview'] = true;
  }

  },
  /* handler:onCellClick */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    var test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'data'))

  },
  /* handler:rowsDataLogic */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'columndefinition'))

  },
  /* handler:columnDefsLogic */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'columnwidth')) < ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'))) {
    width = '100%';
  } else {
    width = String(getObjectProperty(___arguments.context.pageData, 'columnwidth')) + String('px');
  }

  return width

  },
  /* handler:widthLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  my_1 = (getObjectProperty(___arguments.context.pageData, 'datagridview'));

  },
  /* handler:onDisplayAssignment */
  /* handler:resizableLogic */
  ['resizableLogic'](___arguments) {
      return true

  },
  /* handler:resizableLogic */
  /* content */
}))

define('./pages/overzichtgvquestio/components/3466ab52b5bfa6b725b1709a7eb6d89a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['Persoonsgegevens beperkt'] = false;
  ___arguments.context.pageData['Persoonsgegevens uitgebreid'] = false;
  ___arguments.context.pageData['Achtergrond informatie'] = false;
  ___arguments.context.pageData['KVK/BTW'] = false;
  ___arguments.context.pageData['Bijzonderheden'] = false;
  ___arguments.context.pageData['Hoofdregio'] = false;
  ___arguments.context.pageData['Organisatie'] = false;
  ___arguments.context.pageData['Inzetbaarheid'] = false;
  ___arguments.context.pageData['Inzetbaarheid uren'] = false;
  ___arguments.context.pageData['Soort activiteit'] = false;
  ___arguments.context.pageData['Documenten'] = false;
  ___arguments.context.pageData['Status'] = false;
  ___arguments.context.pageData['selectionlist'] = [];
  addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Start');
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/ba8601687b93c3a3d9be627eb6eae2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Persoonsgegevens beperkt');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Persoonsgegevens beperkt') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f8331edf541450d771067b611f8c7185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Organisatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Organisatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/bc9efc981e4af0061eb48a0dd3ae4f6f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Bijzonderheden');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Bijzonderheden') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/6acf7be71f3dbc75d61f1f0f0a918549/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Hoofdregio');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Hoofdregio') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/28833e9f654b43b1c2f3a89ae1e88b72/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['filterview'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['updateview'] = true;
  (function (message) { alert(message) })((['listgemeentegebruiker: ',(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')),'listgemeentevolledig:',(getObjectProperty(___arguments.context.pageData, 'gemeentenhn'))].join('')));
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Inzetbaarheid');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Inzetbaarheid') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a6f6a096c8e7fd715cc5201a99528263/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Achtergrond informatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Achtergrond informatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/6162030d86e8b84dfd311ad877511d15/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Documenten');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Documenten') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/6478bb8fbac4003110392d5e42b98bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Soort activiteit');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Soort activiteit') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/27cc0c6eed09b20469fb1afd895f3c27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'KVK/BTW');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('KVK/BTW') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/0757cc27824290b7581b1e0688db2778/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Persoonsgegevens beperkt'] = true;
  ___arguments.context.pageData['Persoonsgegevens uitgebreid'] = true;
  ___arguments.context.pageData['Achtergrond informatie'] = true;
  ___arguments.context.pageData['KVK/BTW'] = true;
  ___arguments.context.pageData['Bijzonderheden'] = true;
  ___arguments.context.pageData['Hoofdregio'] = true;
  ___arguments.context.pageData['Organisatie'] = true;
  ___arguments.context.pageData['Inzetbaarheid'] = true;
  ___arguments.context.pageData['Inzetbaarheid uren'] = true;
  ___arguments.context.pageData['Soort activiteit'] = true;
  ___arguments.context.pageData['Documenten'] = true;
  ___arguments.context.pageData['Status'] = true;
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/07e171ddbfc6637f44fe101417467d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', true);
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f3c998f3e4ff1a83224b38dc156343c2')), 'display')) == true) {
    ___arguments.context.pageData['filterview'] = false;
  } else {
    ___arguments.context.pageData['filterview'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/113b7fb13b334eeef38c98041229df37/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Persoonsgegevens beperkt'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c004616fbe4d5108298b098cee449efc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Naam_GV',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Naam_GV')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/7fbad59dc00b0c29fda2b62869ce6556/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'updateview'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c0940d583fcc204693957992e7690fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selection, item, select;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fbad59dc00b0c29fda2b62869ce6556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cefd3283586ffdcbf1255a655763b0ac', true);
}

/**
 * Describe this function...
 */
async function old() {
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
}

/**
 * Describe this function...
 */
async function do_something2() {
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
}


  ___arguments.context.pageData['status'] = 'Actief';
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/042e5fc47c06abab7523cefc6d175f46/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Postcode_en_Woonplaats',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Postcode_en_Woonplaats')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/e0931c0d79c6021ec33131a81c059904/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Status');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Status') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c20aa48cd117174424c52fb764415853/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  ___arguments.context.pageData['gemeentenhn'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentenhn'));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/overzichtgvquestio/components/2d238c67941b31ba8a890fc1bd2aebbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Inzetbaarheid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/35ed27847326399b6ac1292cf7c1c2f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Achtergrond informatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/66ccbbbc58a949b8abbfcb3941bc9a71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'KVK/BTW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/04abb132e398aeee3d3c26d4e39de263/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Bijzonderheden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/fb065e89682723cd54aecd138cd632db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Hoofdregio'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/b85c92344dd4649fd9b60e3c775304b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Organisatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/783e31d7845569a44cca821615040f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Soort activiteit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/fc55061a494b5586ffe264a674e96784/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Documenten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d5080bd7f445873ee8fdff68cd1c6316/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Status'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/3abf85191a1afb48c731d9c57f175aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhz'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHZ')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhz')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a9ac60a12acadae2af512901482b6a07/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentegv'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_G&V')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentegv'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentegv')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a5698a8eb4b2f47701d554c1e521452e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentead'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_AD')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentead'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'ad')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a109f2f7fccb745d10b4a9d67c816266/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentemh'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_MH')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentemh'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentemh')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/91eff5bd7b87ca36855786e7136d1391/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b6f87c4bc77c9d56d5b945acadd9942', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhz IS NOT NULL').setProperties(['gemeentenhz']).setSortBy('gemeentenhz ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d20ae97de112f44bc9acfc95bd5443dd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ec197e4bc492e62a94514caa664b0a93', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentegv IS NOT NULL').setProperties(['gemeentegv']).setSortBy('gemeentegv ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/aecb2e027a2cbd51d99e5f9cab19f12d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a98ae31740fe4efaacdee222a7fbe49', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('ad IS NOT NULL').setProperties(['ad']).setSortBy('ad ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a6f5724fa59551a5a62f25f8522a52a4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39fd5cc91418eeffb878b0c82c87a87b', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentemh IS NOT NULL').setProperties(['gemeentemh']).setSortBy('gemeentemh ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/6323b79dff85c00febbe45b60ca7f67b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')) == null) {
    ___arguments.context.pageData['listgemeentenhn'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHN`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/ee7c16d1826df11e0701e965af560359/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')) == null) {
    ___arguments.context.pageData['listgemeentezw'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_ZW`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/2866ab1ce6a757eda485714e82f1df12/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')) == null) {
    ___arguments.context.pageData['listgemeentenhz'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHZ`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/45a707354e2631c4ca2f69db1a736b73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')) == null) {
    ___arguments.context.pageData['listgemeentegv'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_G&V`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f41fe279e3f92e77a0dc719434eaf901/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentead')) == null) {
    ___arguments.context.pageData['listgemeentead'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentead')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentead')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_AD`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d5d78d76c78ce2ff44a32d79a3d5e288/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')) == null) {
    ___arguments.context.pageData['listgemeentemh'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_MH`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d8bdb38a9315f3d6cc1a0ad18fa2ad94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/92029bcb4d93c3dba524bed943fcc915/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_1',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_1')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a108668db9063cda158ca847a993d9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_2',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_2')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/5a9c4056bf8f1744b7b2ac116195f764/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/0de3f1532364b546efd9b858bf9f6e14/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres_Questio',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres_Questio')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d309c33aa2bfb879b44f6c117d12d90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')) == null) {
    ___arguments.context.pageData['listlevensbeschouwing'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).splice((((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Levensbeschouwing`]: (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/1f95b0217cfac0e98bf70dbb6384500f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f04f990ae45e916b96338252c9048cc7', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentezw IS NOT NULL').setProperties(['gemeentezw']).setSortBy('gemeentezw ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/78521b5203933dd439d3a79e65386f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentezw'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_ZW')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentezw'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentezw')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/cf4f4b516477935375a608f4e79ef0bc/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f5c84b040b7909f863b2c42a33418148/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4fbd92436f1ef76af9e241052be3eae6', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhn IS NOT NULL').setProperties(['gemeentenhn']).setSortBy('gemeentenhn ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c26608a3fbde7fdbf9f6caed52a61fb1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54878c42354e57947714e9ff4407cc59', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('levensbeschouwing IS NOT NULL').setProperties(['levensbeschouwing']).setSortBy('levensbeschouwing ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/62732028215f8dc722f68db19029b9b3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listlevensbeschouwing'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Levensbeschouwing')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'levensbeschouwing')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/ece54c57287dfb6aadcd587407f2cb16/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a35c3fc6fda7419ed14e49dcae449e32', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('talen IS NOT NULL').setProperties(['talen']).setSortBy('talen ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/20965dfaa91aeef28c745f3f4348206a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listtalen'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Talen_naast_Nederlands')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listtalen'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'talen')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/fd6adb32666ec5ce5d64d5716a92f6a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listtalen')) == null) {
    ___arguments.context.pageData['listtalen'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listtalen')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listtalen')).splice((((getObjectProperty(___arguments.context.pageData, 'listtalen')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Talen_naast_Nederlands`]: (getObjectProperty(___arguments.context.pageData, 'listtalen')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/7a9f7bdd12b8e235a7bb8c1651116745/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(([(getObjectProperty(___arguments.context.pageData, 'maand')),'-',(getObjectProperty(___arguments.context.pageData, 'dag')),'-',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Geboorte_datum',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Geboorte_datum`]: (date.valueOf()) }) );
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/aeaf298f6fdca35bac04157fea1284c6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dag'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dag'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/eb9f3b4ceae50e2a4c12e47814947733/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['maand'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/e856043ff8452d116713581140893fcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['jaar'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'jaar'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a7e61f7264ee890e24bf7ec9fc467a75/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var age, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  age = (await Promise.all((await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setProperties('DateDiff(date(now()), Geboorte_datum) as age').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'age')) });})))[0];

  return (Math.floor((getObjectProperty(age, 'value')) / 365))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a27665661d5903880121d02a795f6cc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70e63c4da107090438045bfadb09388c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/366dfeed354db48d411131349a4a86fd/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')) != null ? (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))) : '')

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/923a55e2d544f0c1cd0d64ec91150ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Voorkeur_inzet',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Voorkeur_inzet')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/28c63d4a57a302ec8d2eb92fb1f96d55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'BTW_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'BTW_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c4b52caef10bdb22da8c5e87f9f187c7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'KVK',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'KVK')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/39eba82e29c62e836e382f52be224a61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Bijzonderheden',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Bijzonderheden')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/321883119dd590ae9cbe5ad550cf0e86/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Liever_niet_inzetten',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Liever_niet_inzetten')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c404ec9ced3767a40342c547632866ca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Beschikbare_uren_per_week',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Beschikbare_uren_per_week')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/236c5e3fb8c55c530106034db9017a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Individuele_consulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/70e7bfe2c34582355a54313280c1e0ac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Groepsconsulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/5aaff1cd35157169058c31d488d1d707/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/67cc1e46b55e325cec0ed64c80165d95/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'MDO_PATZ',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/82fd92cf7457a8835199d39646ed48f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Moreel_beraad',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c2136ecbdef94a53a57905aee1bee9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Kinderopvang_toeslagenaffaire',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/c752d8e482775986061e6d03f8888189/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGV_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/3c11540e2296fe55581be16885176d69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Status',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f77abcf4958137261371ff0329dbf503/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(___arguments.value));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Datumvertrek`]: (date.valueOf()) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/9c722b5b7745346730547f929bbbe7fa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item, newobjectid, j, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function grantpermissionpl() {
  projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND GV =\'PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND GV =\'PL*\' AND userStatus=\'enabled\''].join('')),'properties': ['objectId'] }));
  projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in projectleiderslist) {
    j = projectleiderslist[j_index];
    await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: (JSON.stringify((getObjectProperty(newobjectid, 'objectId')))) }));
    await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: (JSON.stringify((getObjectProperty(newobjectid, 'objectId')))) }));
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Vul svp de naam van de nieuwe gebruiker in en klik dan op de knop gebruiker toevoegen.');
  } else {
    newobjectid = (await Backendless.Data.of('overzichtgvquestio').save( ({ [`Naam_GV`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`Status`]: 'Actief' }) ));
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
    ___arguments.context.pageData['selectionlist'] = select;
    ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
    ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
    ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
    await Backendless.Messaging.sendEmail('Nieuwe user overzichtgvquestio', new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br>','Er is een nieuwe user aangemaakt in de overzichtgvquestio tabel','<body><br>','1. Stel de correcte username in voor deze persoon','<body><br>','2.Maak een map aan voor de aangemaakte username in de map gvdocumentenquestio en stel de permissions in voor de user. ','<body><br>','3.Ga naar Overzicht GV instellingen en klik op de knnp GV-ers toegang geven tot overzichtgvquestio','<body><br>','Lorio'].join('')) }), ensureArray('info@lorio.nl'), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/8f16c2f8b8ddc5e836b8edd595414878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13e3c2a1659e22126136f57fb975a176')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/5a069b7635ed1b4f484841913d0f7803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Hoofd_regio',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/b60f2a7aeeb925a7cfcc450bdf0e45c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGVgeldigtot',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGVgeldigtot')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/83ea2ccf864d2dc606655d93fa480696/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Datumvertrek',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Datumvertrek')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f6691b5eda549d1a435f5f8930bdaf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'username',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/60c603dd7c8b7317f439a2b427eba9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamecv'] = (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`CV`]: (getObjectProperty(___arguments.context.pageData, 'filenamecv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/overzichtgvquestio/components/6785cd23c96a061df928ef6d209bacf3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'CV'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/ae2ff675bf75aac803f56905dc7b8e84/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`VOG_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenamevog')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamevog'] = (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/3b8c5b6beb129025aefe34320d99c5c9/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SKGV_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenameskgv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameskgv'] = (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/4b32941a2bc593dc3f6d4a72bdc310f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'VOG_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/7a2e07d27a12c55407fdb07deda892e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/64efb16b60c97166bb3d7dc4fd267743/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Overeenkomst`]: (getObjectProperty(___arguments.context.pageData, 'filenameovereenkomst')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('64efb16b60c97166bb3d7dc4fd267743');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('64efb16b60c97166bb3d7dc4fd267743');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameovereenkomst'] = (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/0bc343b6f01650b978f6fddd527ffbac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Overeenkomst'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f3c998f3e4ff1a83224b38dc156343c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filterview'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/d67885f3634f58386a0764097025ba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Status_toelichting',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Status_toelichting')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/f6a25c075f0871a27654ccaf35710dca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Specialisatie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Specialisatie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/99553e4ec87cbd22a1ae18a2526996df/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Addendum`]: (getObjectProperty(___arguments.context.pageData, 'filenameaddendum')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('99553e4ec87cbd22a1ae18a2526996df');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('99553e4ec87cbd22a1ae18a2526996df');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameaddendum'] = (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/a515a8d187f7e774943b8853025d91b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Addendum'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/1d01d393e78690ff3012349e0bf8ac9d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Vakantie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Vakantie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/8cdacfe2a86f9fa80b35c61d1bbdbfca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Bedrijfsnaam',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Bedrijfsnaam')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/28a9d4c664fde8ecce74213d69eecd2f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Gekoppeld_aan',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Gekoppeld_aan')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/78886d7cf77d7f2faebcdabaf27aa02b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Werkzaam_(geweest)_bij',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Werkzaam_(geweest)_bij')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestio/components/fa428add43e79f499549b628ccbb39f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/bfccffda01131f396e4e5d1ae3187fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfccffda01131f396e4e5d1ae3187fb6', (await Backendless.Files.listing(encodePath((['gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/'].join(''))), '', false, 100, 0)));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestio/components/bd3a3edebadbde810d82c35b2de18aad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'name'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'publicUrl')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/b91bd627d9b17462bec97e029319b5cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfccffda01131f396e4e5d1ae3187fb6', (await Backendless.Files.listing(encodePath((['gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/'].join(''))), '', false, 100, 0)));
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bfccffda01131f396e4e5d1ae3187fb6')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/2e5ad6a73703667f8fec3696d623210b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/43ec872484fb403da4bf5b6c90344533/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5bd18817faf9b1870ba79601d329a957')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bd18817faf9b1870ba79601d329a957', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bd18817faf9b1870ba79601d329a957', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/50176914acbecbc400eeaf1e645c80fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','NHN','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen NHN zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/2fffb07548c4f18abd988fb70467419a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','ZW','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen ZW zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/dd16e0234ce36a0278a3fbc35bef2bae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','NHZ','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen NHZ zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/3864e16af1738ce264136609038f4779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','G&V','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen G&V zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/562562e9162b9c9f0f22f30f4db1a943/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','AD','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen AD zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/bd797edc1dceffa5558e6f3a7f1dc2ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','MH','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen MH zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestio/components/46e5e147806401cddca7ef0c743fbab3/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'columndefinition'))

  },
  /* handler:columnDefsLogic */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'data'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments['cellParams']);
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Overeenkomst') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Addendum') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'SKGV_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'CV') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'VOG_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  }
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Naam_GV') {
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    ___arguments.context.pageData['datagridview'] = false;
    ___arguments.context.pageData['objectId'] = (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'objectId'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
    ___arguments.context.pageData['updateview'] = true;
  }

  },
  /* handler:onCellClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'datagridview'))

  },
  /* handler:onDisplayAssignment */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'columnwidth')) < ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'))) {
    width = '100%';
  } else {
    width = String(getObjectProperty(___arguments.context.pageData, 'columnwidth')) + String('px');
  }

  },
  /* handler:widthLogic */
  /* content */
}))

define('./pages/overzichtgvquestio/components/39ddc06806a9870273fd1b1aea96270b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Persoonsgegevens uitgebreid');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Persoonsgegevens uitgebreid') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/47312e7b78b6fef5d89635c4e83d8fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Inzetbaarheid uren');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Inzetbaarheid uren') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/41815263445f494a8fdc7cbfd01f0601/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SKGV_geldig_tot`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/2bcc8473e1afc8e1add48afd7ee3a42b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`VOG_geldig_tot`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestio/components/16886f88cd48fbf8ad67d5f535f9da58/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SEPA`]: (getObjectProperty(___arguments.context.pageData, 'filenameSEPA')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('16886f88cd48fbf8ad67d5f535f9da58');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('16886f88cd48fbf8ad67d5f535f9da58');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameSEPA'] = (['SEPA_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['SEPA_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvquestio/components/be181ce85fa8f04ba9c8ad91391804f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SEPA'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	window.close();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, list, newObject, j, txResult, myTx, orders, select;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  myTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = myTx;

    orders = (_uow.find('overzichtgvquestio', Backendless.DataQueryBuilder.create().setSortBy('Naam_GV ASC').setPageSize(100)).setOpResultId('getOrders'));

  })();

  txResult = (await myTx.execute());
  if (txResult.isSuccess()) {
    ___arguments.context.pageData['myOrders'] = (getObjectProperty((txResult.getResults()), 'getOrders.result'));
  }
  ___arguments.context.pageData['object'] = ({ [`field`]: 'Naam_GV',[`flex`]: 1 });
  newObject = 0;
  list = ['Naam_GV'];
  for (var j_index in list) {
    j = list[j_index];
    newObject[j] = (getObjectProperty(___arguments.context.pageData, j));
  }
  (function (message) { alert(message) })((JSON.stringify(newObject)));
  ___arguments.context.pageData['columnlogic'] = ['[', '{"field": "Naam_GV", "flex": 1}', '{"field": "Straat_en_huisnummer", "flex": 1}', ' {"field": "Postcode_en_woonplaats", "flex": 1}', '{"field": "Telefoonnummer_1", "flex": 1}', '{"field": "Telefoonnummer_2", "flex": 1}', ']'];
  list = ({  });
  addItemToList(list, (JSON.parse((['{"field": "Naam_GV", "flex": 1},','{"field": "Straat_en_huisnummer", "flex": 1},',' {"field": "Postcode_en_woonplaats", "flex": 1},','{"field": "Telefoonnummer_1", "flex": 1},','{"field": "Telefoonnummer_2", "flex": 1}'].join('')))));
  (function (message) { alert(message) })(list);
  ___arguments.context.pageData['columnlogic'] = list;
  ___arguments.context.pageData['columnwidth'] = (String((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth'))) + String('px'));
  item = 0;
  item = 0;
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['status'] = 'Actief';
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/cefd3283586ffdcbf1255a655763b0ac/bundle.js', [], () => ({
  /* content */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cefd3283586ffdcbf1255a655763b0ac', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fbad59dc00b0c29fda2b62869ce6556', true);
}


  console.log(___arguments['cellParams']);
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Overeenkomst') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Addendum') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'SKGV_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'CV') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'VOG_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  }
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Naam_GV') {
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    ___arguments.context.pageData['datagridview'] = false;
    ___arguments.context.pageData['objectId'] = (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'objectId'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
    ___arguments.context.pageData['updateview'] = true;
  }

  },
  /* handler:onCellClick */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    var test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'data'))

  },
  /* handler:rowsDataLogic */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'columndefinition'))

  },
  /* handler:columnDefsLogic */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'columnwidth')) < ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'))) {
    width = '100%';
  } else {
    width = String(getObjectProperty(___arguments.context.pageData, 'columnwidth')) + String('px');
  }

  return width

  },
  /* handler:widthLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var my_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  my_1 = (getObjectProperty(___arguments.context.pageData, 'datagridview'));

  },
  /* handler:onDisplayAssignment */
  /* handler:resizableLogic */
  ['resizableLogic'](___arguments) {
      return true

  },
  /* handler:resizableLogic */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/3466ab52b5bfa6b725b1709a7eb6d89a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['Persoonsgegevens beperkt'] = false;
  ___arguments.context.pageData['Persoonsgegevens uitgebreid'] = false;
  ___arguments.context.pageData['Achtergrond informatie'] = false;
  ___arguments.context.pageData['KVK/BTW'] = false;
  ___arguments.context.pageData['Bijzonderheden'] = false;
  ___arguments.context.pageData['Hoofdregio'] = false;
  ___arguments.context.pageData['Organisatie'] = false;
  ___arguments.context.pageData['Inzetbaarheid'] = false;
  ___arguments.context.pageData['Inzetbaarheid uren'] = false;
  ___arguments.context.pageData['Soort activiteit'] = false;
  ___arguments.context.pageData['Documenten'] = false;
  ___arguments.context.pageData['Status'] = false;
  ___arguments.context.pageData['selectionlist'] = [];
  addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Start');
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/ba8601687b93c3a3d9be627eb6eae2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Persoonsgegevens beperkt');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Persoonsgegevens beperkt') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f8331edf541450d771067b611f8c7185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Organisatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Organisatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/bc9efc981e4af0061eb48a0dd3ae4f6f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Bijzonderheden');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Bijzonderheden') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/6acf7be71f3dbc75d61f1f0f0a918549/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Hoofdregio');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Hoofdregio') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/28833e9f654b43b1c2f3a89ae1e88b72/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['filterview'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['updateview'] = true;
  (function (message) { alert(message) })((['listgemeentegebruiker: ',(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')),'listgemeentevolledig:',(getObjectProperty(___arguments.context.pageData, 'gemeentenhn'))].join('')));
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Inzetbaarheid');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Inzetbaarheid') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a6f6a096c8e7fd715cc5201a99528263/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Achtergrond informatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Achtergrond informatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/6162030d86e8b84dfd311ad877511d15/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Documenten');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Documenten') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/6478bb8fbac4003110392d5e42b98bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Soort activiteit');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Soort activiteit') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/27cc0c6eed09b20469fb1afd895f3c27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'KVK/BTW');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('KVK/BTW') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/0757cc27824290b7581b1e0688db2778/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Persoonsgegevens beperkt'] = true;
  ___arguments.context.pageData['Persoonsgegevens uitgebreid'] = true;
  ___arguments.context.pageData['Achtergrond informatie'] = true;
  ___arguments.context.pageData['KVK/BTW'] = true;
  ___arguments.context.pageData['Bijzonderheden'] = true;
  ___arguments.context.pageData['Hoofdregio'] = true;
  ___arguments.context.pageData['Organisatie'] = true;
  ___arguments.context.pageData['Inzetbaarheid'] = true;
  ___arguments.context.pageData['Inzetbaarheid uren'] = true;
  ___arguments.context.pageData['Soort activiteit'] = true;
  ___arguments.context.pageData['Documenten'] = true;
  ___arguments.context.pageData['Status'] = true;
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/07e171ddbfc6637f44fe101417467d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('862f30eb448a8f22b2f54a1101f75edc', true);
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f3c998f3e4ff1a83224b38dc156343c2')), 'display')) == true) {
    ___arguments.context.pageData['filterview'] = false;
  } else {
    ___arguments.context.pageData['filterview'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/113b7fb13b334eeef38c98041229df37/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Persoonsgegevens beperkt'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c004616fbe4d5108298b098cee449efc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Naam_GV',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Naam_GV')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/7fbad59dc00b0c29fda2b62869ce6556/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'updateview'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c0940d583fcc204693957992e7690fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item, selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fbad59dc00b0c29fda2b62869ce6556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cefd3283586ffdcbf1255a655763b0ac', true);
}

/**
 * Describe this function...
 */
async function old() {
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
}

/**
 * Describe this function...
 */
async function do_something2() {
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
}


  ___arguments.context.pageData['status'] = 'Actief';
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['updateview'] = false;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestiobeperkt').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestiobeperkt').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/042e5fc47c06abab7523cefc6d175f46/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Postcode_en_Woonplaats',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Postcode_en_Woonplaats')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/e0931c0d79c6021ec33131a81c059904/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Status');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Status') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c20aa48cd117174424c52fb764415853/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  ___arguments.context.pageData['gemeentenhn'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentenhn'));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/2d238c67941b31ba8a890fc1bd2aebbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Inzetbaarheid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/35ed27847326399b6ac1292cf7c1c2f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Achtergrond informatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/66ccbbbc58a949b8abbfcb3941bc9a71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'KVK/BTW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/04abb132e398aeee3d3c26d4e39de263/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Bijzonderheden'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/fb065e89682723cd54aecd138cd632db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Hoofdregio'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/b85c92344dd4649fd9b60e3c775304b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Organisatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/783e31d7845569a44cca821615040f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Soort activiteit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/fc55061a494b5586ffe264a674e96784/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Documenten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d5080bd7f445873ee8fdff68cd1c6316/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Status'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/3abf85191a1afb48c731d9c57f175aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhz'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHZ')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhz')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a9ac60a12acadae2af512901482b6a07/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentegv'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_G&V')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentegv'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentegv')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a5698a8eb4b2f47701d554c1e521452e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentead'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_AD')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentead'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'ad')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a109f2f7fccb745d10b4a9d67c816266/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentemh'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_MH')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentemh'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentemh')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/91eff5bd7b87ca36855786e7136d1391/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b6f87c4bc77c9d56d5b945acadd9942', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhz IS NOT NULL').setProperties(['gemeentenhz']).setSortBy('gemeentenhz ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d20ae97de112f44bc9acfc95bd5443dd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ec197e4bc492e62a94514caa664b0a93', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentegv IS NOT NULL').setProperties(['gemeentegv']).setSortBy('gemeentegv ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/aecb2e027a2cbd51d99e5f9cab19f12d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a98ae31740fe4efaacdee222a7fbe49', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('ad IS NOT NULL').setProperties(['ad']).setSortBy('ad ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a6f5724fa59551a5a62f25f8522a52a4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39fd5cc91418eeffb878b0c82c87a87b', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentemh IS NOT NULL').setProperties(['gemeentemh']).setSortBy('gemeentemh ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/6323b79dff85c00febbe45b60ca7f67b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')) == null) {
    ___arguments.context.pageData['listgemeentenhn'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHN`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/ee7c16d1826df11e0701e965af560359/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')) == null) {
    ___arguments.context.pageData['listgemeentezw'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_ZW`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/2866ab1ce6a757eda485714e82f1df12/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')) == null) {
    ___arguments.context.pageData['listgemeentenhz'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHZ`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/45a707354e2631c4ca2f69db1a736b73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')) == null) {
    ___arguments.context.pageData['listgemeentegv'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_G&V`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f41fe279e3f92e77a0dc719434eaf901/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentead')) == null) {
    ___arguments.context.pageData['listgemeentead'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentead')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentead')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_AD`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d5d78d76c78ce2ff44a32d79a3d5e288/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')) == null) {
    ___arguments.context.pageData['listgemeentemh'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_MH`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d8bdb38a9315f3d6cc1a0ad18fa2ad94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/92029bcb4d93c3dba524bed943fcc915/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_1',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_1')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a108668db9063cda158ca847a993d9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_2',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_2')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/5a9c4056bf8f1744b7b2ac116195f764/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/0de3f1532364b546efd9b858bf9f6e14/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres_Questio',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres_Questio')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d309c33aa2bfb879b44f6c117d12d90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')) == null) {
    ___arguments.context.pageData['listlevensbeschouwing'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).splice((((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Levensbeschouwing`]: (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/1f95b0217cfac0e98bf70dbb6384500f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f04f990ae45e916b96338252c9048cc7', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentezw IS NOT NULL').setProperties(['gemeentezw']).setSortBy('gemeentezw ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/78521b5203933dd439d3a79e65386f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentezw'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_ZW')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentezw'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentezw')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/cf4f4b516477935375a608f4e79ef0bc/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f5c84b040b7909f863b2c42a33418148/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4fbd92436f1ef76af9e241052be3eae6', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhn IS NOT NULL').setProperties(['gemeentenhn']).setSortBy('gemeentenhn ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c26608a3fbde7fdbf9f6caed52a61fb1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54878c42354e57947714e9ff4407cc59', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('levensbeschouwing IS NOT NULL').setProperties(['levensbeschouwing']).setSortBy('levensbeschouwing ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/62732028215f8dc722f68db19029b9b3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listlevensbeschouwing'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Levensbeschouwing')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'levensbeschouwing')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/ece54c57287dfb6aadcd587407f2cb16/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a35c3fc6fda7419ed14e49dcae449e32', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('talen IS NOT NULL').setProperties(['talen']).setSortBy('talen ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/20965dfaa91aeef28c745f3f4348206a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listtalen'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Talen_naast_Nederlands')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listtalen'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'talen')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/fd6adb32666ec5ce5d64d5716a92f6a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listtalen')) == null) {
    ___arguments.context.pageData['listtalen'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listtalen')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listtalen')).splice((((getObjectProperty(___arguments.context.pageData, 'listtalen')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Talen_naast_Nederlands`]: (getObjectProperty(___arguments.context.pageData, 'listtalen')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/7a9f7bdd12b8e235a7bb8c1651116745/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(([(getObjectProperty(___arguments.context.pageData, 'maand')),'-',(getObjectProperty(___arguments.context.pageData, 'dag')),'-',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Geboorte_datum',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Geboorte_datum`]: (date.valueOf()) }) );
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/aeaf298f6fdca35bac04157fea1284c6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dag'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dag'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/eb9f3b4ceae50e2a4c12e47814947733/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['maand'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/e856043ff8452d116713581140893fcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['jaar'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'jaar'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a7e61f7264ee890e24bf7ec9fc467a75/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var age, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  age = (await Promise.all((await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setProperties('DateDiff(date(now()), Geboorte_datum) as age').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'age')) });})))[0];

  return (Math.floor((getObjectProperty(age, 'value')) / 365))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a27665661d5903880121d02a795f6cc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70e63c4da107090438045bfadb09388c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/366dfeed354db48d411131349a4a86fd/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')) != null ? (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))) : '')

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/923a55e2d544f0c1cd0d64ec91150ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Voorkeur_inzet',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Voorkeur_inzet')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/28c63d4a57a302ec8d2eb92fb1f96d55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'BTW_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'BTW_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c4b52caef10bdb22da8c5e87f9f187c7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'KVK',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'KVK')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/39eba82e29c62e836e382f52be224a61/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Bijzonderheden',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Bijzonderheden')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/321883119dd590ae9cbe5ad550cf0e86/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Liever_niet_inzetten',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Liever_niet_inzetten')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c404ec9ced3767a40342c547632866ca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Beschikbare_uren_per_week',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Beschikbare_uren_per_week')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/236c5e3fb8c55c530106034db9017a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Individuele_consulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/70e7bfe2c34582355a54313280c1e0ac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Groepsconsulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/5aaff1cd35157169058c31d488d1d707/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/67cc1e46b55e325cec0ed64c80165d95/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'MDO_PATZ',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/82fd92cf7457a8835199d39646ed48f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Moreel_beraad',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c2136ecbdef94a53a57905aee1bee9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Kinderopvang_toeslagenaffaire',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/c752d8e482775986061e6d03f8888189/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGV_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/be3e753d2005324ec1b7aafab21dba33/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(___arguments.value));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SKGVgeldigtot`]: (date.valueOf()) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/3c11540e2296fe55581be16885176d69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Status',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f77abcf4958137261371ff0329dbf503/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(___arguments.value));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Datumvertrek`]: (date.valueOf()) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/9c722b5b7745346730547f929bbbe7fa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item, newobjectid, j, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function grantpermissionpl() {
  projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND GV =\'PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND GV =\'PL*\' AND userStatus=\'enabled\''].join('')),'properties': ['objectId'] }));
  projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in projectleiderslist) {
    j = projectleiderslist[j_index];
    await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: (JSON.stringify((getObjectProperty(newobjectid, 'objectId')))) }));
    await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'overzichtgvquestio',[`objectId`]: (JSON.stringify((getObjectProperty(newobjectid, 'objectId')))) }));
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Vul svp de naam van de nieuwe gebruiker in en klik dan op de knop gebruiker toevoegen.');
  } else {
    newobjectid = (await Backendless.Data.of('overzichtgvquestio').save( ({ [`Naam_GV`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`Status`]: 'Actief' }) ));
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
    ___arguments.context.pageData['selectionlist'] = select;
    ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
    ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setProperties(['field', 'flex', 'selectable', 'width', 'minWidth', 'maxWidth']).setSortBy('nr ASC').setPageSize(100)));
    ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount()) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
    await Backendless.Messaging.sendEmail('Nieuwe user overzichtgvquestio', new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br>','Er is een nieuwe user aangemaakt in de overzichtgvquestio tabel','<body><br>','1. Stel de correcte username in voor deze persoon','<body><br>','2.Maak een map aan voor de aangemaakte username in de map gvdocumentenquestio en stel de permissions in voor de user. ','<body><br>','3.Ga naar Overzicht GV instellingen en klik op de knnp GV-ers toegang geven tot overzichtgvquestio','<body><br>','Lorio'].join('')) }), ensureArray('info@lorio.nl'), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/8f16c2f8b8ddc5e836b8edd595414878/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13e3c2a1659e22126136f57fb975a176')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e3c2a1659e22126136f57fb975a176', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/5a069b7635ed1b4f484841913d0f7803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Hoofd_regio',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/b60f2a7aeeb925a7cfcc450bdf0e45c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGVgeldigtot',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGVgeldigtot')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/83ea2ccf864d2dc606655d93fa480696/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Datumvertrek',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Datumvertrek')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f6691b5eda549d1a435f5f8930bdaf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'username',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/60c603dd7c8b7317f439a2b427eba9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamecv'] = (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`CV`]: (getObjectProperty(___arguments.context.pageData, 'filenamecv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/6785cd23c96a061df928ef6d209bacf3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'CV'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/ae2ff675bf75aac803f56905dc7b8e84/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`VOG_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenamevog')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamevog'] = (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/3b8c5b6beb129025aefe34320d99c5c9/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SKGV_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenameskgv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameskgv'] = (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/4b32941a2bc593dc3f6d4a72bdc310f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'VOG_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/7a2e07d27a12c55407fdb07deda892e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/64efb16b60c97166bb3d7dc4fd267743/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Overeenkomst`]: (getObjectProperty(___arguments.context.pageData, 'filenameovereenkomst')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('64efb16b60c97166bb3d7dc4fd267743');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('64efb16b60c97166bb3d7dc4fd267743');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameovereenkomst'] = (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/0bc343b6f01650b978f6fddd527ffbac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Overeenkomst'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f3c998f3e4ff1a83224b38dc156343c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filterview'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/d67885f3634f58386a0764097025ba2e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Status_toelichting',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Status_toelichting')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/f6a25c075f0871a27654ccaf35710dca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Specialisatie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Specialisatie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/99553e4ec87cbd22a1ae18a2526996df/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`Addendum`]: (getObjectProperty(___arguments.context.pageData, 'filenameaddendum')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('99553e4ec87cbd22a1ae18a2526996df');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('99553e4ec87cbd22a1ae18a2526996df');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameaddendum'] = (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/a515a8d187f7e774943b8853025d91b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Addendum'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/1d01d393e78690ff3012349e0bf8ac9d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Vakantie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Vakantie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/8cdacfe2a86f9fa80b35c61d1bbdbfca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Bedrijfsnaam',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Bedrijfsnaam')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/28a9d4c664fde8ecce74213d69eecd2f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Gekoppeld_aan',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Gekoppeld_aan')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/78886d7cf77d7f2faebcdabaf27aa02b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Werkzaam_(geweest)_bij',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Werkzaam_(geweest)_bij')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/fa428add43e79f499549b628ccbb39f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['status=\'',(getObjectProperty(___arguments.context.pageData, 'status')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/bfccffda01131f396e4e5d1ae3187fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfccffda01131f396e4e5d1ae3187fb6', (await Backendless.Files.listing(encodePath((['gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/'].join(''))), '', false, 100, 0)));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/bd3a3edebadbde810d82c35b2de18aad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'name'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.dataModel, 'publicUrl')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/b91bd627d9b17462bec97e029319b5cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfccffda01131f396e4e5d1ae3187fb6', (await Backendless.Files.listing(encodePath((['gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/'].join(''))), '', false, 100, 0)));
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bfccffda01131f396e4e5d1ae3187fb6')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfccffda01131f396e4e5d1ae3187fb6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/2e5ad6a73703667f8fec3696d623210b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/43ec872484fb403da4bf5b6c90344533/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5bd18817faf9b1870ba79601d329a957')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bd18817faf9b1870ba79601d329a957', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bd18817faf9b1870ba79601d329a957', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/50176914acbecbc400eeaf1e645c80fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','NHN','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen NHN zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/2fffb07548c4f18abd988fb70467419a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','ZW','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen ZW zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/dd16e0234ce36a0278a3fbc35bef2bae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','NHZ','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen NHZ zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/3864e16af1738ce264136609038f4779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','G&V','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen G&V zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/562562e9162b9c9f0f22f30f4db1a943/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','AD','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen AD zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/bd797edc1dceffa5558e6f3a7f1dc2ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var data, result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	navigator.clipboard.writeText("");

  })();
  data = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['Status=\'','Actief','\' AND Hoofd_regio=\'','MH','\''].join('')),'properties': ['email'] })).map(async item => {; return (getObjectProperty(item, 'email'));})));
  result = data.join(';');
  await (async function() {

  	  let selection = document.getSelection();
  	  selection = (result);
  	  console.log(selection);
  	//clipboardData.setData('text/plain', selection);
  	 navigator.clipboard.writeText(result)
  })();
  (function (message) { alert(message) })('Emailadressen MH zijn gekopieerd, deze kunnen nu in de mail geplakt worden (CTRL+V)');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/46e5e147806401cddca7ef0c743fbab3/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'columndefinition'))

  },
  /* handler:columnDefsLogic */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'data'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments['cellParams']);
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Overeenkomst') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Addendum') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'SKGV_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'CV') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  } else if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'VOG_certificaat') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'username')),'/',(getObjectProperty(___arguments['cellParams'], 'value'))].join('')), true, undefined);
  }
  if ((getObjectProperty(___arguments['cellParams'], 'type')) == 'cellClicked' && (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'column')), 'colId')) == 'Naam_GV') {
    ___arguments.context.pageData['filterview'] = true;
    ___arguments.context.pageData['filterview'] = false;
    ___arguments.context.pageData['datagridview'] = false;
    ___arguments.context.pageData['objectId'] = (getObjectProperty((getObjectProperty(___arguments['cellParams'], 'data')), 'objectId'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
    ___arguments.context.pageData['updateview'] = true;
  }

  },
  /* handler:onCellClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'datagridview'))

  },
  /* handler:onDisplayAssignment */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'columnwidth')) < ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'))) {
    width = '100%';
  } else {
    width = String(getObjectProperty(___arguments.context.pageData, 'columnwidth')) + String('px');
  }

  },
  /* handler:widthLogic */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/39ddc06806a9870273fd1b1aea96270b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Persoonsgegevens uitgebreid');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Persoonsgegevens uitgebreid') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/47312e7b78b6fef5d89635c4e83d8fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Inzetbaarheid uren');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Inzetbaarheid uren') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');
  ___arguments.context.pageData['columndefinition'] = (await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))).setProperties(['field', 'selectable', 'width', 'pinned', 'wrapText', 'autoHeight', 'minWidth', 'flex', 'maxWidth', 'cellStyle']).setSortBy('nr ASC').setPageSize(100)));
  ___arguments.context.pageData['columnwidth'] = ((await Backendless.Data.of('overzichtgvselectiequestio').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['groep IN (\'',selection,'\')'].join(''))))) * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvquestiobeperkt/components/ecc899397c28ef4845ecdbfe618aab2c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`VOG_geldig_tot`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var select, item, Hoofd_regio, countrowsdatagrid, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loaddatagriddata() {
  Hoofd_regio = (await Promise.all((await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('Hoofd_regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Hoofd_regio')) });})))[0];
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/overzichtgvgedeeldedata/overzichtgvgedeeldedata`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'user': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'tableName': 'overzichtgvquestio','whereClause': (['Hoofd_regio=\'',(getObjectProperty(Hoofd_regio, 'value')),'\' AND status=\'Actief\''].join('')) }));
  await countrows();
}

/**
 * Describe this function...
 */
async function countrows() {
  ___arguments.context.pageData['countrowsdatagrid'] = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    countrowsdatagrid = (getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid')) + 1;
    ___arguments.context.pageData['countrowsdatagrid'] = countrowsdatagrid;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid'));
  ___arguments.context.pageData['rowsdatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid')) * 60);
}

/**
 * Describe this function...
 */
async function old_on_page_enter_voor_columndefinition() {
  ___arguments.context.pageData['data'] = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'overzichtgvquestio','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')),'sortBy': 'Naam_GV ASC' }));
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await new Promise(r => setTimeout(r, 1200 || 0));
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['field<>\'Bijzonderheden\' ','AND field<>\'Werkzaam_of_werkzaam_geweest_bij\' ','AND groep<>\'Status\''].join(''))).setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['columnwidth'] = (17 * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
  await loaddatagriddata();
  ___arguments.context.pageData['Persoonsgegevens'] = true;
  ___arguments.context.pageData['Achtergrond informatie'] = true;
  ___arguments.context.pageData['KVK/BTW'] = true;
  ___arguments.context.pageData['Hoofdregio'] = true;
  ___arguments.context.pageData['Organisatie'] = true;
  ___arguments.context.pageData['Inzetbaarheid'] = true;
  ___arguments.context.pageData['Soort activiteit'] = true;
  ___arguments.context.pageData['Documenten'] = true;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/cefd3283586ffdcbf1255a655763b0ac/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'data'))

  },
  /* handler:rowsDataLogic */
  /* handler:widthLogic */
  ['widthLogic'](___arguments) {
    var width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'columnwidth')) < ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth'))) {
    width = '100%';
  } else {
    width = String(getObjectProperty(___arguments.context.pageData, 'columnwidth')) + String('px');
  }

  return width

  },
  /* handler:widthLogic */
  /* handler:heightLogic */
  ['heightLogic'](___arguments) {
    var height, width;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  height = String(getObjectProperty(___arguments.context.pageData, 'rowsdatagrid')) + String('px');

  return height

  },
  /* handler:heightLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'datagridview'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/3466ab52b5bfa6b725b1709a7eb6d89a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Persoonsgegevens'] = false;
  ___arguments.context.pageData['Achtergrond informatie'] = false;
  ___arguments.context.pageData['KVK/BTW'] = false;
  ___arguments.context.pageData['Hoofdregio'] = false;
  ___arguments.context.pageData['Organisatie'] = false;
  ___arguments.context.pageData['Inzetbaarheid'] = false;
  ___arguments.context.pageData['Soort activiteit'] = false;
  ___arguments.context.pageData['Documenten'] = false;
  ___arguments.context.pageData['selectionlist'] = [];
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ba8601687b93c3a3d9be627eb6eae2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Persoonsgegevens');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Persoonsgegevens') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/f8331edf541450d771067b611f8c7185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Organisatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Organisatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/6acf7be71f3dbc75d61f1f0f0a918549/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Hoofdregio');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Hoofdregio') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/28833e9f654b43b1c2f3a89ae1e88b72/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['filterview'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['updateview'] = true;
  (function (message) { alert(message) })((['listgemeentegebruiker: ',(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')),'listgemeentevolledig:',(getObjectProperty(___arguments.context.pageData, 'gemeentenhn'))].join('')));
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Inzetbaarheid');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Inzetbaarheid') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a6f6a096c8e7fd715cc5201a99528263/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Achtergrond informatie');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Achtergrond informatie') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/6162030d86e8b84dfd311ad877511d15/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Documenten');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Documenten') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/6478bb8fbac4003110392d5e42b98bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'Soort activiteit');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('Soort activiteit') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/27cc0c6eed09b20469fb1afd895f3c27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selection;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'selectionlist')), 'KVK/BTW');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'selectionlist')).splice((((getObjectProperty(___arguments.context.pageData, 'selectionlist')).indexOf('KVK/BTW') + 1) - 1), 1);
  }
  selection = (getObjectProperty(___arguments.context.pageData, 'selectionlist')).join('\',\'');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/0757cc27824290b7581b1e0688db2778/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Persoonsgegevens'] = true;
  ___arguments.context.pageData['Achtergrond informatie'] = true;
  ___arguments.context.pageData['KVK/BTW'] = true;
  ___arguments.context.pageData['Hoofdregio'] = true;
  ___arguments.context.pageData['Organisatie'] = true;
  ___arguments.context.pageData['Inzetbaarheid'] = true;
  ___arguments.context.pageData['Soort activiteit'] = true;
  ___arguments.context.pageData['Documenten'] = true;
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['field<>\'Bijzonderheden_vakantie\' ','AND field<>\'Werkzaam_of_werkzaam_geweest_bij\' ','AND groep<>\'Status\''].join(''))).setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/07e171ddbfc6637f44fe101417467d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterview')) == true) {
    ___arguments.context.pageData['filterview'] = false;
  } else {
    ___arguments.context.pageData['filterview'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/113b7fb13b334eeef38c98041229df37/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Persoonsgegevens'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c004616fbe4d5108298b098cee449efc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Naam_GV',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Naam_GV')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/7fbad59dc00b0c29fda2b62869ce6556/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/042e5fc47c06abab7523cefc6d175f46/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Postcode_en_Woonplaats',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Postcode_en_Woonplaats')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c20aa48cd117174424c52fb764415853/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  ___arguments.context.pageData['gemeentenhn'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentenhn'));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onVisibilityChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  console.log(String('listgemeentegebruiker: ') + String(getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')));
  console.log(String('listgemeentevolledig: ') + String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/2d238c67941b31ba8a890fc1bd2aebbf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Inzetbaarheid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/35ed27847326399b6ac1292cf7c1c2f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Achtergrond informatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/66ccbbbc58a949b8abbfcb3941bc9a71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'KVK/BTW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/fb065e89682723cd54aecd138cd632db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Hoofdregio'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/b85c92344dd4649fd9b60e3c775304b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Organisatie'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/783e31d7845569a44cca821615040f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Soort activiteit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/fc55061a494b5586ffe264a674e96784/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Documenten'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/3abf85191a1afb48c731d9c57f175aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhz'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHZ')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhz')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a9ac60a12acadae2af512901482b6a07/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentegv'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_G&V')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentegv'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentegv')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a5698a8eb4b2f47701d554c1e521452e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentead'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_AD')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentead'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'ad')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a109f2f7fccb745d10b4a9d67c816266/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentemh'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_MH')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentemh'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentemh')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/91eff5bd7b87ca36855786e7136d1391/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6b6f87c4bc77c9d56d5b945acadd9942', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhz IS NOT NULL').setProperties(['gemeentenhz']).setSortBy('gemeentenhz ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/d20ae97de112f44bc9acfc95bd5443dd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ec197e4bc492e62a94514caa664b0a93', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentegv IS NOT NULL').setProperties(['gemeentegv']).setSortBy('gemeentegv ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/aecb2e027a2cbd51d99e5f9cab19f12d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a98ae31740fe4efaacdee222a7fbe49', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('ad IS NOT NULL').setProperties(['ad']).setSortBy('ad ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a6f5724fa59551a5a62f25f8522a52a4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39fd5cc91418eeffb878b0c82c87a87b', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentemh IS NOT NULL').setProperties(['gemeentemh']).setSortBy('gemeentemh ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/6323b79dff85c00febbe45b60ca7f67b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var select, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')) == null) {
    ___arguments.context.pageData['listgemeentenhn'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cf4f4b516477935375a608f4e79ef0bc'), 'gemeentenhn')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHN`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ee7c16d1826df11e0701e965af560359/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')) == null) {
    ___arguments.context.pageData['listgemeentezw'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('78521b5203933dd439d3a79e65386f8a'), 'gemeentezw')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_ZW`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentezw')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/2866ab1ce6a757eda485714e82f1df12/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')) == null) {
    ___arguments.context.pageData['listgemeentenhz'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3abf85191a1afb48c731d9c57f175aa6'), 'gemeentenhz')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_NHZ`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentenhz')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/45a707354e2631c4ca2f69db1a736b73/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')) == null) {
    ___arguments.context.pageData['listgemeentegv'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9ac60a12acadae2af512901482b6a07'), 'gemeentegv')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_G&V`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentegv')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/f41fe279e3f92e77a0dc719434eaf901/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentead')) == null) {
    ___arguments.context.pageData['listgemeentead'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentead')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentead')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a5698a8eb4b2f47701d554c1e521452e'), 'ad')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_AD`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentead')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/d5d78d76c78ce2ff44a32d79a3d5e288/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')) == null) {
    ___arguments.context.pageData['listgemeentemh'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')), (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).splice((((getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).indexOf(String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a109f2f7fccb745d10b4a9d67c816266'), 'gemeentemh')) + String(' ')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Inzetbaar_in_gemeenten_MH`]: (getObjectProperty(___arguments.context.pageData, 'listgemeentemh')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/d8bdb38a9315f3d6cc1a0ad18fa2ad94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/92029bcb4d93c3dba524bed943fcc915/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_1',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_1')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a108668db9063cda158ca847a993d9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Telefoonnummer_2',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Telefoonnummer_2')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/5a9c4056bf8f1744b7b2ac116195f764/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/0de3f1532364b546efd9b858bf9f6e14/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'E_mailadres_Questio',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'E_mailadres_Questio')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/d309c33aa2bfb879b44f6c117d12d90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')) == null) {
    ___arguments.context.pageData['listlevensbeschouwing'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).splice((((getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('62732028215f8dc722f68db19029b9b3'), 'levensbeschouwing')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Levensbeschouwing`]: (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/1f95b0217cfac0e98bf70dbb6384500f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f04f990ae45e916b96338252c9048cc7', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentezw IS NOT NULL').setProperties(['gemeentezw']).setSortBy('gemeentezw ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/78521b5203933dd439d3a79e65386f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentezw'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_ZW')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentezw'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentezw')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/cf4f4b516477935375a608f4e79ef0bc/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listgemeentenhn'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Inzetbaar_in_gemeenten_NHN')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listgemeentenhn'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (String(getObjectProperty(___arguments.context.dataModel, 'gemeentenhn')) + String(' ') == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/f5c84b040b7909f863b2c42a33418148/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4fbd92436f1ef76af9e241052be3eae6', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('gemeentenhn IS NOT NULL').setProperties(['gemeentenhn']).setSortBy('gemeentenhn ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c26608a3fbde7fdbf9f6caed52a61fb1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54878c42354e57947714e9ff4407cc59', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('levensbeschouwing IS NOT NULL').setProperties(['levensbeschouwing']).setSortBy('levensbeschouwing ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/62732028215f8dc722f68db19029b9b3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listlevensbeschouwing'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Levensbeschouwing')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listlevensbeschouwing'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'levensbeschouwing')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ece54c57287dfb6aadcd587407f2cb16/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a35c3fc6fda7419ed14e49dcae449e32', (await Backendless.Data.of('overzichtgvgemeentequestio').find(Backendless.DataQueryBuilder.create().setWhereClause('talen IS NOT NULL').setProperties(['talen']).setSortBy('talen ASC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/20965dfaa91aeef28c745f3f4348206a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['listtalen'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Talen_naast_Nederlands')).split(','));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'listtalen'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'talen')) == j) {
      ___arguments.context.dataModel['selected'] = true;
    }
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/fd6adb32666ec5ce5d64d5716a92f6a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'listtalen')) == null) {
    ___arguments.context.pageData['listtalen'] = [];
  }
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listtalen')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listtalen')).splice((((getObjectProperty(___arguments.context.pageData, 'listtalen')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('20965dfaa91aeef28c745f3f4348206a'), 'talen')) + 1) - 1), 1);
  }
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Talen_naast_Nederlands`]: (getObjectProperty(___arguments.context.pageData, 'listtalen')).join(',') }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/7a9f7bdd12b8e235a7bb8c1651116745/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(([(getObjectProperty(___arguments.context.pageData, 'maand')),'-',(getObjectProperty(___arguments.context.pageData, 'dag')),'-',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Geboorte_datum',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Geboorte_datum`]: (date.valueOf()) }) );
  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/aeaf298f6fdca35bac04157fea1284c6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dag'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dag'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/eb9f3b4ceae50e2a4c12e47814947733/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['maand'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/e856043ff8452d116713581140893fcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['jaar'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'jaar'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a7e61f7264ee890e24bf7ec9fc467a75/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var age, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  age = (await Promise.all((await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('DateDiff(date(now()), Geboorte_datum) as age').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'age')) });})))[0];

  return (Math.floor((getObjectProperty(age, 'value')) / 365))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/a27665661d5903880121d02a795f6cc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70e63c4da107090438045bfadb09388c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70e63c4da107090438045bfadb09388c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/366dfeed354db48d411131349a4a86fd/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')) != null ? (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Geboorte_datum')))) : '')

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/923a55e2d544f0c1cd0d64ec91150ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Voorkeur_inzet',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Voorkeur_inzet')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/28c63d4a57a302ec8d2eb92fb1f96d55/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'BTW_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'BTW_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c4b52caef10bdb22da8c5e87f9f187c7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'KVK',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'KVK')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/438116f3a21b486a1a9b5c521c638f91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Gekoppeld_aan',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Gekoppeld_aan')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/321883119dd590ae9cbe5ad550cf0e86/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Liever_niet_inzetten',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Liever_niet_inzetten')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c404ec9ced3767a40342c547632866ca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Beschikbare_uren_per_week',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Beschikbare_uren_per_week')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/236c5e3fb8c55c530106034db9017a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Individuele_consulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/70e7bfe2c34582355a54313280c1e0ac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Groepsconsulten',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/5aaff1cd35157169058c31d488d1d707/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Straat_en_huisnummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Straat_en_huisnummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/67cc1e46b55e325cec0ed64c80165d95/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'MDO_PATZ',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/82fd92cf7457a8835199d39646ed48f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Moreel_beraad',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c2136ecbdef94a53a57905aee1bee9a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );
  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Kinderopvang_toeslagenaffaire',[`Oude waarde`]: ___arguments.prevValue,[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/c752d8e482775986061e6d03f8888189/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGV_nummer',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_nummer')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/be3e753d2005324ec1b7aafab21dba33/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date(___arguments.value));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`SKGVgeldigtot`]: (date.valueOf()) }) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/b60f2a7aeeb925a7cfcc450bdf0e45c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'SKGVgeldigtot',[`Oude waarde`]: (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGVgeldigtot')))),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/f6691b5eda549d1a435f5f8930bdaf7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'username',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/60c603dd7c8b7317f439a2b427eba9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamecv'] = (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['CV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`CV`]: (getObjectProperty(___arguments.context.pageData, 'filenamecv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('60c603dd7c8b7317f439a2b427eba9e5');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/6785cd23c96a061df928ef6d209bacf3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'CV'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'CV')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ae2ff675bf75aac803f56905dc7b8e84/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`VOG_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenamevog')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ae2ff675bf75aac803f56905dc7b8e84');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenamevog'] = (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['VOG_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/3b8c5b6beb129025aefe34320d99c5c9/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`SKGV_certificaat`]: (getObjectProperty(___arguments.context.pageData, 'filenameskgv')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3b8c5b6beb129025aefe34320d99c5c9');

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameskgv'] = (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['SKGV_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/4b32941a2bc593dc3f6d4a72bdc310f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'VOG_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'VOG_certificaat')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/7a2e07d27a12c55407fdb07deda892e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_certificaat'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SKGV_certificaat')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/1d96980f153990bcdadf8da275980fd3/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Overeenkomst`]: (getObjectProperty(___arguments.context.pageData, 'filenameovereenkomst')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1d96980f153990bcdadf8da275980fd3');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('1d96980f153990bcdadf8da275980fd3');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameovereenkomst'] = (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Overeenkomst_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/9e13152f74f4fa03e5b9dbf8a6f8f80b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Overeenkomst'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Overeenkomst')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ba36fac20f3bd2d615f2a5d45b28b84e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'filterview'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/e3a4cd9a74727e96897f40ee771e6706/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Specialisatie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Specialisatie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/0ae9136f7834e74b37ab1be3bf81a316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var select, item, Hoofd_regio, countrowsdatagrid, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loaddatagriddata() {
  Hoofd_regio = (await Promise.all((await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('Hoofd_regio').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Hoofd_regio')) });})))[0];
  ___arguments.context.pageData['data'] = (await Backendless.Request.get(`${Backendless.appPath}/services/overzichtgvgedeeldedata/overzichtgvgedeeldedata`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'user': JSON.stringify((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))),'tableName': JSON.stringify('overzichtgvquestio'),'whereClause': JSON.stringify((['Hoofd_regio=\'',(getObjectProperty(Hoofd_regio, 'value')),'\' AND status=\'Actief\''].join(''))) }).send());
  await countrows();
}

/**
 * Describe this function...
 */
async function countrows() {
  ___arguments.context.pageData['countrowsdatagrid'] = 0;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    countrowsdatagrid = (getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid')) + 1;
    ___arguments.context.pageData['countrowsdatagrid'] = countrowsdatagrid;
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid'));
  ___arguments.context.pageData['rowsdatagrid'] = ((getObjectProperty(___arguments.context.pageData, 'countrowsdatagrid')) * 60);
}


  ___arguments.context.pageData['filterview'] = true;
  ___arguments.context.pageData['filterview'] = false;
  ___arguments.context.pageData['datagridview'] = true;
  ___arguments.context.pageData['columncountwidth'] = 280;
  ___arguments.context.pageData['selectionlist'] = [];
  select = (await Promise.all((await Backendless.Data.of('overzichtgvselectiequestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['field<>\'Bijzonderheden_vakantie\' ','AND field<>\'Werkzaam_of_werkzaam_geweest_bij\' ','AND groep<>\'Status\''].join(''))).setProperties('groep').setGroupBy('groep').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'groep'));})));
  ___arguments.context.pageData['selectionlist'] = select;
  ___arguments.context.pageData['columnwidth'] = (17 * (getObjectProperty(___arguments.context.pageData, 'columncountwidth')));
  await loaddatagriddata();
  ___arguments.context.pageData['Persoonsgegevens'] = true;
  ___arguments.context.pageData['Achtergrond informatie'] = true;
  ___arguments.context.pageData['KVK/BTW'] = true;
  ___arguments.context.pageData['Hoofdregio'] = true;
  ___arguments.context.pageData['Organisatie'] = true;
  ___arguments.context.pageData['Inzetbaarheid'] = true;
  ___arguments.context.pageData['Soort activiteit'] = true;
  ___arguments.context.pageData['Documenten'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/e12f42c9aedf58f161634caea7f8920c/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`Addendum`]: (getObjectProperty(___arguments.context.pageData, 'filenameaddendum')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e12f42c9aedf58f161634caea7f8920c');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e12f42c9aedf58f161634caea7f8920c');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameaddendum'] = (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['Addendum_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/1f96eca41bc9fcc14b4de22a457db3d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Addendum'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Addendum')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/2647b2de287824ec9fba49c45325d946/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Vakantie',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Vakantie')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/e7d694f6b52b0f124b936692f6dbdcfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvlogquestio').save( ({ [`Veld`]: 'Bedrijfsnaam',[`Oude waarde`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'Bedrijfsnaam')),[`id`]: (getObjectProperty(___arguments.context.pageData, 'objectId')),[`Aangepast door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/37871a781de6037885381d8b0bb8e048/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('overzichtgvquestio').save( ___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/ad6abff4d8ff067807284bca48f8ebdb/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('overzichtgvquestio').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join('')), ({ [`SEPA`]: (getObjectProperty(___arguments.context.pageData, 'filenameSEPA')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7fbad59dc00b0c29fda2b62869ce6556', (await Backendless.Data.of('overzichtgvquestio').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10))));
  await new Promise(r => setTimeout(r, 4000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ad6abff4d8ff067807284bca48f8ebdb');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })('Upload is niet gelukt');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('ad6abff4d8ff067807284bca48f8ebdb');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('gvdocumentenquestio/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Documentnummer', 1);
  ___arguments.context.pageData['filenameSEPA'] = (['SEPA_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''));

  return (['SEPA_',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'_',(new Intl.DateTimeFormat('de', undefined).format((new Date()))),'_',(await Backendless.Counters.get('Documentnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/overzichtgvusersquestio/components/cbd4b6bd15a8212881e8cf28da185c98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/gvdocumentenquestio/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'username')),'/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9af89c5cd87ffdef65a354640df96eea'), 'SEPA'))].join('')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plbudget/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plbudget/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plbudget/components/2df20af935b715159721d0176e4ceb75/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['budgettotaal'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/325ac979b5c2831fec470ceee7fbd818/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('325ac979b5c2831fec470ceee7fbd818', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/13aff615c15dbdd274bbcd73cfbc0488/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13aff615c15dbdd274bbcd73cfbc0488', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/9299a2db99cd335598caa4653da18a6c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9299a2db99cd335598caa4653da18a6c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/be5631f6e008e69bfda436d12727efc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/c71aa311723de403bdc2226e09f837e6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/b6785ecd687847acfb2aec351572fb47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/704668e7629933755bc6635471c29f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaal')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaal'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/a95e774677e22059e31b56588a33e0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/7ef949ccf9b258d7bc1220f6beec51f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 764740000;
  await format();
  ___arguments.context.pageData['budgettotaalgelderland1'] = 764740000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/b36b629384e339de70d385c5431bd719/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b36b629384e339de70d385c5431bd719', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','D3rde Verdieping','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/1fe8deda708a622cc1ef54d9fc68b64b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1fe8deda708a622cc1ef54d9fc68b64b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','D3rde Verdieping','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/81a53a726e6b47018d8de35f2217d879/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81a53a726e6b47018d8de35f2217d879', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','D3rde Verdieping','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/24fad2c2f305b18477af37f67acba57f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalgelderland1'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/1a130f6a28c5e1461181dae4480291b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalgelderland1'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/ec68561b599ad31936efb4b24d644962/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/3b57bd2bd356fc185039be63a67fc4d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland1')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland1'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/0a393f1c8e4e366d215694626828bd55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland1')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalgelderland1'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland1')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/6a71737c98d648eeaf656931f8c2fe7f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 273540000;
  await format();
  ___arguments.context.pageData['budgettotaalgelderland2'] = 273540000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/412c1ee85161450f7272d20a3a6191c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalgelderland2'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/81d2e53dce2b3b02c95443d140f78675/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalgelderland2'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/178c8fe30ae22d4ceefb373c6bcee149/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland2')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalgelderland2'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland2')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/142f363ff1d495774a282c0abd7b72ff/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('142f363ff1d495774a282c0abd7b72ff', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Land van Cuijk en kop van Noord-Limburg','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/2976d42a2daa4729431a61a29bd80b7d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2976d42a2daa4729431a61a29bd80b7d', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Land van Cuijk en kop van Noord-Limburg','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/9c15df9c0d6638a4270d2ca7be6804d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c15df9c0d6638a4270d2ca7be6804d7', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Land van Cuijk en kop van Noord-Limburg','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/372c0c335286dce459c410a8596f2311/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/90eb2772ff68ccd2b61ff1fd04ed1de7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland2')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland2'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/f2663d8ecc2e794f45e3bfbc60a2cd99/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2663d8ecc2e794f45e3bfbc60a2cd99', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Levensvragen in de Vallei','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/cebd1a7c5ca5472ca2cc7ec5bcd2e273/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cebd1a7c5ca5472ca2cc7ec5bcd2e273', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Veluwe','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/2085bf846ec3b1bedb39fe4d225393f7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2085bf846ec3b1bedb39fe4d225393f7', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Zuid-Gelderland','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/5f834012b6ce71afbfbd4056f473286c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5f834012b6ce71afbfbd4056f473286c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Levensvragen in de Vallei','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/f69f811437a3f968a555a478009abda3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f69f811437a3f968a555a478009abda3', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Veluwe','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/2f7ce2c4f54fe7d72ab31854174d14a9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f7ce2c4f54fe7d72ab31854174d14a9', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Zuid-Gelderland','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/31ad073d701fd751b2887e329581e9b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('31ad073d701fd751b2887e329581e9b5', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Levensvragen in de Vallei','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/5a5c331da87e0e43bd1a896dda114d22/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a5c331da87e0e43bd1a896dda114d22', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Veluwe','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/28ca4547a5488042853c2ccc166d9eb1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('28ca4547a5488042853c2ccc166d9eb1', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Zuid-Gelderland','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/d3bbc95421aa65aa824aecd505e42d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 595190000;
  await format();
  ___arguments.context.pageData['budgettotaalgelderland3'] = 595190000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/68e724b9f75d0f5f2bc76c871ff9ac7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 446530000;
  await format();
  ___arguments.context.pageData['budgettotaalgelderland4'] = 446530000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/807f2acf9c4ac2bed2376d39c88b3bfa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 609360000;
  await format();
  ___arguments.context.pageData['budgettotaalgelderland5'] = 609360000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/5a2f6a639e6896ba7a9531127c8f42fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalgelderland3'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/7d55d37bd4637d6d00e436b47e83a22d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalgelderland4'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/2baf92da36016ea48c69699336fcb827/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalgelderland5'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/8bc103f5e0db90e7066cfdf4b57a5f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalgelderland3'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/2c349646f877946c7adee03e122e52eb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalgelderland4'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/26d31a2dafddee6403e78e242828191e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalgelderland5'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/0baf7bb9e55519b2c2cf281fbc8ed3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland3')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalgelderland3'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland3')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/8bfd28d51cc568a7d5d4d788e5e6e1bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland4')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalgelderland4'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland4')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/cafe88bc6dc198a7f784e8c3b52e39e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland5')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalgelderland5'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland5')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/fe520285d7a2f13da5a191f1429447ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland3')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland3'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/e427129f9c2aa7fd3ef8080dad59b20c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland4')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland4'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/9884347baa7a24e16dee26a793150db4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalgelderland5')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalgelderland5'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/69b18991a079cf2e511d581a04446813/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/10db19f4d5b353aba74234455e1ce5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/c191b29f5da49cd3c05a97d497ea2cbd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/ed8cab127584cc2ed1df01e95c352eb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/c8fdefcaa48c89592d24935b5914776a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/c5eb5d75cd694946cfbac34c6b3655fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 519960000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem1'] = 519960000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/7ff3492e73b90d21ff9a915a946d5b16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 318260000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem2'] = 318260000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/66f97c8f8f1f2b2d68df1ffe1478ca27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 442430000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem3'] = 442430000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/12e394d979829ecac3f7a5672d69b892/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 318280000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem4'] = 318280000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/df96d3e34658fb375308e159804871f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 302530000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem5'] = 302530000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/636625f7eff87131ff911f66b7a5ac04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 325340000;
  await format();
  ___arguments.context.pageData['budgettotaalwillem6'] = 325340000;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/6db251641394e3ac1697111e04e1e5b1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6db251641394e3ac1697111e04e1e5b1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Enschede Haaksbergen en Noordoost Twente','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/c05a84452e223cb6d1b1d7a8709b68a1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c05a84452e223cb6d1b1d7a8709b68a1', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Midden-Twente','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/651635794e57601bbb21fa45c5f12414/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('651635794e57601bbb21fa45c5f12414', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Noordwest Twente','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/59af0573b54b951699037dfb2e8ab38f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59af0573b54b951699037dfb2e8ab38f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Achterhoek','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/79f636b6222b07783384ef42ad6143c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('79f636b6222b07783384ef42ad6143c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Regio Zutphen','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/e6250d71f8f612ae7e06b02b06ccefb8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e6250d71f8f612ae7e06b02b06ccefb8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','West-Achterhoek','\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/099406cb523c358fe89d210f672ed5b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('099406cb523c358fe89d210f672ed5b4', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Enschede Haaksbergen en Noordoost Twente','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/7f219b3b7e1dee8107eb594992777ce7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f219b3b7e1dee8107eb594992777ce7', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Midden-Twente','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/bc2751a3b8514db3e0bb928338ffeb4d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc2751a3b8514db3e0bb928338ffeb4d', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Noordwest Twente','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/64af0f63419df6d732f2c8a474f4cffe/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('64af0f63419df6d732f2c8a474f4cffe', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Achterhoek','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/24ba9b33665e0c947f0bccea58514871/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('24ba9b33665e0c947f0bccea58514871', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Regio Zutphen','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/9dacebc5e29472811204a54dd7c72b9b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9dacebc5e29472811204a54dd7c72b9b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','West-Achterhoek','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/6932569ae5445f4c615336f172fbbd2b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6932569ae5445f4c615336f172fbbd2b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Enschede Haaksbergen en Noordoost Twente','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/1c8eccb1af04e3fda4a995fd8a7fb033/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1c8eccb1af04e3fda4a995fd8a7fb033', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Midden-Twente','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/6a083344824d75e696c74bba894549be/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a083344824d75e696c74bba894549be', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Noordwest Twente','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/6ef9524ffd5e582e414f10985a146ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6ef9524ffd5e582e414f10985a146ef4', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Oost-Achterhoek','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/d404a6db703a33614f2b04a93973f47f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d404a6db703a33614f2b04a93973f47f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','Regio Zutphen','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/54b3737c8231635191ee7fc3060ca32e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54b3737c8231635191ee7fc3060ca32e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'','West-Achterhoek','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plbudget/components/b5829fac94cba7299e380df8228f0c0e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem1'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/5783776bb239a77b21ad17356a8650fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem2'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/89561bc2e83ea4cb609149ec0f5a307a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem3'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/df640c87e33c0e5e6f01cad501077667/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem4'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/30389ba6e07b78e333c5306d0b1af45a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem5'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/5784ce563b2850f8b474644fa2ac1bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaalwillem6'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/328490a66bec56c23773b0e3ec0e0797/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem1'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/d20e5b05fd5847cb41da2038b6f873a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem2'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/bb32fcf9490821bb3d9297131d0553b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem3'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/bb6339c97116ac1d8c6fd6ec95bbfae5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem4'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/2676c791eadf64e3e512a0ce081715c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem5'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/7e9dc325c9c2510cf86d16e3d3cea9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaalwillem6'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/593b4dba41c9ff7457575e3d7e463d0d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem1')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem1'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem1')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/d6b6baece3b3f5ee3c66043ad1f8f7c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem2')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem2'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem2')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/c999223f9106de7fd499c25ce55f9247/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem3')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem3'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem3')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/6d65576721e62aad64b344537982dbd9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem4')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem4'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem4')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/b0cdebc905f2c3034cd859b213b72d7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem5')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem5'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem5')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/924745ef757cbc46d17b32987f010eca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem6')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaalwillem6'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem6')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/2eda617444b43cd14f9e1c513263d4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem1')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem1'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/3cc974127c1121566aec4e14f617a072/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem2')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem2'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/5413c877ea67d86ec6f8110124d9cba6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem3')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem3'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/6a8ec0e4a285f2ee02c4a791ab0ef62a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem4')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem4'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/6cb3c2dbc463ab65ac6e09141b6fe04a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem5')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem5'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/7b895419c9eea8667bcf9b1ddac788a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaalwillem6')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaalwillem6'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plbudget/components/a2e78ad65ecb77b4e3f99b771c556a65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/342a9ca6d45d6a41ee6f90f460ceac2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/da48f364693578474a9fe17200f75c86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/85177839f055608371aa20e995e23b84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/b628fcc7784c755d7c8aa3e5b401cd9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/63738c54e1fbc09e7a2d416e894f5688/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plbudget/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraag': (getObjectProperty(___arguments.context.pageData, 'emailvraag')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'opmerkingenprojectleider': [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekenquestio', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    E = 'Aanvraag besproken?';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    C = 'Organisatie die de scholing afneemt';
    D = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/2a4f8f4f6666a285e5facfdfa6b4b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a4f8f4f6666a285e5facfdfa6b4b31f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/e3a50f7e5bd4485aad127b9c737467f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc613a630b217e93e626880a470508e7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/ebc92f328bfdb8fb9aa2f085026c2266/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questioscholingbedrag': (getObjectProperty(___arguments.context.pageData, 'questioscholingbedrag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De eigen bijdrage is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/aacd343f68c4bb05dd63282a3be96317/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5d1a6122cb0e48cd84f19df551bd7d3d')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/57bf086975d2bbd27452000ba0ca0d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d1a6122cb0e48cd84f19df551bd7d3d'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Programma is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/0f516cdc7a87a6ea4bf70da987e3dfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0f516cdc7a87a6ea4bf70da987e3dfbd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('questiogroepsconsultprogrammabijeenkomst').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/9da46e0784b6c92e46fa5f31c65d6f52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbe190c3259a97366ce030fefddbe01')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/d53211de5906121a606260195aad8ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79abb5a3590c2b9ff8ce5939cc430832')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/6255fd828bcfa9d403ef015d4008f8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.pageData, 'wlzindicatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz is aangepast');
  ___arguments.context.pageData['wlzindicatie'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/928520092141ae4e2c8634bba421e66a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.pageData, 'wlzindicatiesoort')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz indicatie is aangepast');
  ___arguments.context.pageData['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/d1ff33dff6da76fdc4e107e65544c786/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cbf77d19f4fa2292df687b656f521de')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/d06bb12b3dc6fcf25c18762379a7e1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d99043cb0e2beb14692b289ca3f3a56')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/f3e33b580a8a6528ea34f2d393596f23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurcontactpersoon': (getObjectProperty(___arguments.context.pageData, 'factuurcontactpersoon')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De contactpersoon voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/458800d42e473d4a95c7bc165d45fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurmailadres': (getObjectProperty(___arguments.context.pageData, 'factuurmailadres')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Het emailadres voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/be8d899cba2e1b91dbd5eed49d5ef80d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/796ea58fd5daf3c29d13ba44d07d7d9d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == 'Groepsconsult')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/d168e33a12064424506c143745849a26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == 'MDO/PaTz')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/bdcb4a2287b5b0aab4edfaacfd338abd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'questioscholingofmoreel')) == 'Scholing')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/64ed27db0edcb01945d265947d45035d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'questioscholingofmoreel')) == 'Moreel beraad')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/fef7cb91659da8a6646f3872bf144bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == 'Consult zorgvrager')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/968fa5a253f2472fd8b2db2de35a2f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == 'Consult professional')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/9fe666b5fe970f153424c421446823a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == 'Consult professional')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/6fb58b012d87a383c2dde50eca092d9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Coördinatietaken')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierdetailsquestio/components/bf71eb57a628f7fd2e63b6d24ab52492/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Opbouw infrastructuur')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\''].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteraantalconsulten'] = '0';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'registratiesaantalconsulten';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatusakkoord'] = '%';
  ___arguments.context.pageData['filterstatusdossier'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'offset'))))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('28b8447172e29462c212d85b3352fb75', (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('e69290248fe46c4711ed2252e0cacccf', (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });}))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9cde6bfa3d366426e7c38adb8616cebd', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pldossieroverzicht/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratiestotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7af83651c8665586915c3eb2fec28fc7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b6f77278267ac66e5e7a22529256ff', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d9d919b76264da96832cb64ba542978', false);
  ___arguments.context.pageData['filterdossiers'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca7cf7791de5e8b5ee04dab876260a1e', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9769f6f930f3b56457380d3668c0413', true);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fedfb52ac5a8a23e095e4bcbfb83ab78', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('312330f1dd5db2e10b33fbda4c6d053e', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('842b194d1d5689db39ab26fbbfcbc08d', true);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('028a50b48d3d48d1f5acdfe44cb65aab', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bf85cfe3a9571ced7b3ad36791697ae', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0cbcc3f934c1e9f662d55334e5704cb', true);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('defa49d2fffc0b9ea41ba301e7b6daf7', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a392fbaddb4d16ff625391f461e1572', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecc146b2a5bce7bdc6dff0431b09b097', true);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75e54eb4b079126ddad17cb1672e38e1', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a76e22d60a3a848d6785e7949f393264', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('169a28afd9a61743486b6c075e7a365a', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pldossieroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    text = 'Overhead';
  } else {
    text = 'Totaal reistijd in minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/5aefd7c549181d1c60047edc0b527dd2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/7af83651c8665586915c3eb2fec28fc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_code_10_10_2026() {
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten'))].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'offset'))))));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7af83651c8665586915c3eb2fec28fc7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d9d919b76264da96832cb64ba542978', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9769f6f930f3b56457380d3668c0413', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca7cf7791de5e8b5ee04dab876260a1e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fedfb52ac5a8a23e095e4bcbfb83ab78', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('842b194d1d5689db39ab26fbbfcbc08d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('312330f1dd5db2e10b33fbda4c6d053e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0cbcc3f934c1e9f662d55334e5704cb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('028a50b48d3d48d1f5acdfe44cb65aab', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecc146b2a5bce7bdc6dff0431b09b097', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('defa49d2fffc0b9ea41ba301e7b6daf7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a392fbaddb4d16ff625391f461e1572', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75e54eb4b079126ddad17cb1672e38e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a76e22d60a3a848d6785e7949f393264', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('169a28afd9a61743486b6c075e7a365a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b6f77278267ac66e5e7a22529256ff', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/66dd9e5a5e24dfcf05a70882f501d747/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('66dd9e5a5e24dfcf05a70882f501d747'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('66dd9e5a5e24dfcf05a70882f501d747'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('66dd9e5a5e24dfcf05a70882f501d747'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/620215c29409c3197a7683cf80035ed4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/5358b3b534741be670e4a7bfcb585ad2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\''].join(''))).setSortBy('akkoordomschrijving ASC').setGroupBy('akkoordomschrijving').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'akkoordomschrijving')),'label': (getObjectProperty(item, 'akkoordomschrijving')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/2a617a9a56f2dc71470724db0118a709/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('status ASC').setGroupBy('status').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'status')),'label': (getObjectProperty(item, 'status')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/517cc7e3f9023c2bc31d370c4df213e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['totaalbudget'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/cc0e032675f9a34c3cbc86a6432a5c0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbesteed'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/dbbf02fa8cf591039ebdd9353cc1a4cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetconsultinwpro']);
  await format();
  ___arguments.context.pageData['budgetconsultinwpro'] = (___arguments.context.appData['budgetconsultinwpro']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a1090b03d1cf23646bcfa8e3d0beba15/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedconsultinwpro'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b2ae2802d60c5c7808aa6f989ac7c635/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandconsultinwpro'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/8d3106fc26d9ab5c48920cd4342b1c9f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.appData['tariefconsultinwpro'] = (JSON.stringify((___arguments.context.dataModel['consultinwpro'])));
  ___arguments.context.appData['tariefgroepsconsult'] = (JSON.stringify((___arguments.context.dataModel['groepsconsult'])));
  ___arguments.context.appData['tariefmdopatz'] = (JSON.stringify((___arguments.context.dataModel['mdopatz'])));
  ___arguments.context.appData['tariefscholing'] = (JSON.stringify((___arguments.context.dataModel['scholing'])));
  ___arguments.context.appData['tariefcoordinatie'] = (JSON.stringify((___arguments.context.dataModel['coordinatietaken'])));
  ___arguments.context.appData['tariefopbouwinfra'] = (JSON.stringify((___arguments.context.dataModel['opbouwinfra'])));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/36a42a2ebda15b789e17503965f99efe/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('36a42a2ebda15b789e17503965f99efe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' AND jaar=2023 OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/840b47246e3c5f6fb9de1a5f5898156c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('840b47246e3c5f6fb9de1a5f5898156c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3bcc790e5a7a48d2fc88d97ecccda353/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3bcc790e5a7a48d2fc88d97ecccda353', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/2e83623eef737819bccb187beda423ff/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2e83623eef737819bccb187beda423ff', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/36764d67b8461688bb7ea74ba674c865/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('36764d67b8461688bb7ea74ba674c865', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/98baf3efb53c69996516451b582ae6be/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98baf3efb53c69996516451b582ae6be', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/8782678a890de14e1b0293b7721cf527/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalopenstaand'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/e84f879e91c7561e59a45a4b00962d3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'totaalbesteed')) + (getObjectProperty(___arguments.context.pageData, 'totaalopenstaand'));
  euro = (getObjectProperty(___arguments.context.pageData, 'totaalbudget')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/98ff212b0c1f1b0bd2d192b87ab5867a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedconsultinwpro']) + (___arguments.context.pageData['openstaandconsultinwpro']);
  euro = (___arguments.context.pageData['budgetconsultinwpro']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a4ad358272ca734843179aee2e29ab17/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetgroepsconsult']);
  await format();
  ___arguments.context.pageData['budgetgroepsconsult'] = (___arguments.context.appData['budgetgroepsconsult']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3aa67395cf2d1351d02f8e6b923414e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetmdopatz']);
  await format();
  ___arguments.context.pageData['budgetmdopatz'] = (___arguments.context.appData['budgetmdopatz']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/934a36650efa5af7e368c365ee0443e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetscholing']);
  await format();
  ___arguments.context.pageData['budgetscholing'] = (___arguments.context.appData['budgetscholing']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3fd8602e88ab7c730257e4931ff26ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoaching']);
  await format();
  ___arguments.context.pageData['budgetcoaching'] = (___arguments.context.appData['budgetcoaching']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/c966951282030457f91b3838933e0444/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoordinatietaken']);
  await format();
  ___arguments.context.pageData['budgetcoordinatie'] = (___arguments.context.appData['budgetcoordinatietaken']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/abbade9fb9dc40f14dc48fcdb9c3c5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetopbouwinfra']);
  await format();
  ___arguments.context.pageData['budgetopbouwinfra'] = (___arguments.context.appData['budgetopbouwinfra']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b5f18f3c70e175a5339e9fc38a3f8e41/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b5f18f3c70e175a5339e9fc38a3f8e41', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Groepsconsult\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/cb5cb4bce1bb9f33b166fd343e599f27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedgroepsconsult'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/055df44c845bff0eace61db6d764ec56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedmdopatz'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d575c201a994a3344352777546eb17c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedscholing'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/67b25a043e5639bf317516e765155c58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoaching'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/ead7efa6dff801673035a1073c99dd03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoordinatie'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/61e356bed1111d1b47e48a8244bdf3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedopbouwinfra'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f141bc1a47e21cf426bcb92d84274ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f141bc1a47e21cf426bcb92d84274ec5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'MDO/PaTz\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/8c1b061226f834a5edab6bb76bfd4f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8c1b061226f834a5edab6bb76bfd4f4b', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Scholing\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1a5a0ebf13cadceab068679cc8020e8f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1a5a0ebf13cadceab068679cc8020e8f', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coaching on the job\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d63dfd86b1bfe46255c95318a04975c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d63dfd86b1bfe46255c95318a04975c8', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coördinatietaken\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0131f964973cdf2f422c62195fe5d882/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0131f964973cdf2f422c62195fe5d882', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Opbouw infrastructuur\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/64e3abc2942c208eeae9929dffbdb224/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('64e3abc2942c208eeae9929dffbdb224', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/6ba9cd0cb708c977151f1f1dfc77ad9d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6ba9cd0cb708c977151f1f1dfc77ad9d', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a7f6768fdc61055f64aef9bb832672e5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7f6768fdc61055f64aef9bb832672e5', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/55585361afae56ea5cf50cac18b7137e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('55585361afae56ea5cf50cac18b7137e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/88097a7999bc1d7373058f8fb02625db/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('88097a7999bc1d7373058f8fb02625db', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/c6a804756f264219637b9d4c3d348f51/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c6a804756f264219637b9d4c3d348f51', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0df1599b9f330ba9909ae327c3cd2b05/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0df1599b9f330ba9909ae327c3cd2b05', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/247468aa92a405b6edb2fd335db6d094/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('247468aa92a405b6edb2fd335db6d094', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/de78def4d47e103693a531195fcb1c04/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('de78def4d47e103693a531195fcb1c04', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0ebec2c9bfd3bf4e39de12c2751fde3b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ebec2c9bfd3bf4e39de12c2751fde3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/ad1971bd8b9b455c95d30d4891922518/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad1971bd8b9b455c95d30d4891922518', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/c1b2c72c0d2b6f6dbaefce32afd18739/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c1b2c72c0d2b6f6dbaefce32afd18739', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/96c4e7a2c5bda4e91d26a4073be6a48f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandgroepsconsult'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/66120d542c667775925a6168804ed376/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandmdopatz'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/31c5d4844b7610fa93c9b6badc2a5bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandscholing'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1bff262c3ee1bd45cd19f4d913767891/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoaching'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/74ebcae9ecd41807d6cd6513eea107a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoordinatie'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/fea865424b3fcda3e53d12184c596375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandopbouwinfra'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/605f33362e49fb86717afd5a77344eed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedgroepsconsult']) + (___arguments.context.pageData['openstaandgroepsconsult']);
  euro = (___arguments.context.pageData['budgetgroepsconsult']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/91a9d9fa8f1f07354f5bc42a80414f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedmdopatz']) + (___arguments.context.pageData['openstaandmdopatz']);
  euro = (___arguments.context.pageData['budgetmdopatz']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/25a80db3ccf41ee48f3bb1ed985747eb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedscholing']) + (___arguments.context.pageData['openstaandscholing']);
  euro = (___arguments.context.pageData['budgetscholing']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f518564a1ab5bcdd601fb7e3c832eefa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoaching']) + (___arguments.context.pageData['openstaandcoaching']);
  euro = (___arguments.context.pageData['budgetcoaching']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a1f9ce730879187ac0db1b8d2f99bf3d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoordinatie']) + (___arguments.context.pageData['openstaandcoordinatie']);
  euro = (___arguments.context.pageData['budgetcoordinatie']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a8868fa99ab41904414b47fa7f951647/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedopbouwinfra']) + (___arguments.context.pageData['openstaandopbouwinfra']);
  euro = (___arguments.context.pageData['budgetopbouwinfra']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/566cac82e89fb28d7965df23834454c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f43a9e345ba8e4d17bffa3df5cf1cf24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('566cac82e89fb28d7965df23834454c3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90f190952e27de0492d44352f5739267', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/90f190952e27de0492d44352f5739267/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f43a9e345ba8e4d17bffa3df5cf1cf24', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90f190952e27de0492d44352f5739267', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('566cac82e89fb28d7965df23834454c3', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/45b871795bdff8945e33b0e83c8b0f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetconsultinwpro']) - (___arguments.context.pageData['besteedconsultinwpro']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/4b44d10df4cc7c4e75a526fadd3ddd96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetgroepsconsult']) - (___arguments.context.pageData['besteedgroepsconsult']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d0d52f892f737fac1c02505e352b21c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetmdopatz']) - (___arguments.context.pageData['besteedmdopatz']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/38ea23c286891b36def9eefa373bd2d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetscholing']) - (___arguments.context.pageData['besteedscholing']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/03555ae45ea3dc9fbc0fb45dca7a6918/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoaching']) - (___arguments.context.pageData['besteedcoaching']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/7f490169361d280ca415fefb15750d05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoordinatie']) - (___arguments.context.pageData['besteedcoordinatie']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/084f8047ae039e525c4aadc205098701/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgetopbouwinfra')) - (getObjectProperty(___arguments.context.pageData, 'besteedopbouwinfra'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/07793cf14a3a823f764d9577eac5e489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'totaalbudget')) - (getObjectProperty(___arguments.context.pageData, 'totaalbesteed'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/55c67c3afcc46591068cc2a56217d493/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0236b6c79794cc24a3037fe16f848a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/73b61f2187dc26cb9c3b9cd3a8c40a15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/62ab0198f8d75411ccaab7e2b54fb1dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/179fd0a52cffaf2906ef524f308c1ef1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/899c37bdc5838a89449a1a6b22dad6fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/309c4b51c739a37a1c5c9ae5c187e0c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/2ef67a0d0e115a070555035e7d09b342/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/e8652e7f410cb489efb52f0b0eeb5e37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3b4fba540c93a59c25e960d67765610e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/ef07f3397afc0117b5731e8e6ffaf34c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/c6d372baf11339eacfdb76ffc61fed98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3faa70baeb6e2e8b099b34872341952d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterstatusakkoord'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/2fed107add39802154211f499c435422/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1b9ffcfb287d75022df3316f74d18855/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatusdossier'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b5ae0bf93b2322d94456413e1139b649/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b0079ad83084a69eda4920d3d35cdc1c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/6e8f28377843dcec2a12e1deb145899a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/52f966ca85687708d88759179ed8db14/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/47b7bad2ab3123de7472e09c06e3c911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/edafe901250dc26cf6a4f5bcdeb7302b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b3b187b7806c7a4ee4af8bb5016ec166/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteraantalconsulten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/69661cc8fbfca9cc4ca135e90b469de5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/6c3fbeba454e216baada7d66d299c98f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6c3fbeba454e216baada7d66d299c98f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/129ee9eeb5f50eb1d30d3dda9fe7bc16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setconsultinw']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/681f993b8561378ca17847cf2553db8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setgroepsconsult']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/896e85ccaa3b8b9ee26ba9aef58732a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setmdopatz']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b7796dc945c176dcb55e8a5870631d4b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setscholing']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0e6e95c5f3a957c32f256917cab7af4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoaching']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/28970f7901a5b773d7773c95a29b702c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoordinatietaken']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/029c0785f6aab1f692c5f80830e7686d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b4dcafea9f128aaf2df88064f86b3751/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/350d9337d00c58673699b7270c0befde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/51639ce3739824af11c5003ba40e7a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Toegekend door ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator'])));

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/188523630f269c99834a0c2d20a3e061/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/66da50eedef7500803652493453f45d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/4d9d919b76264da96832cb64ba542978/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4b43e26baa39c2e5d8366eb2ab43d445')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/e86aef6f8187cd95bfe3e4b1ed121c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/5e6b405cef06a925df5f83c6c9b881e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/ce17f7c39df7ad28bad4c62fc0710ced/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'update')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) }) );
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f1448f91cb8ce95a79839afe96eab2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/560ece7dbfa32cee811ea625008eb335/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3f86abc35d2e359d99ac454eff381358/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['update'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9cde6bfa3d366426e7c38adb8616cebd', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9cde6bfa3d366426e7c38adb8616cebd', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9cde6bfa3d366426e7c38adb8616cebd')), 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9cde6bfa3d366426e7c38adb8616cebd')), 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9cde6bfa3d366426e7c38adb8616cebd')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9cde6bfa3d366426e7c38adb8616cebd')), 'voorbereidingminuten')) }) );
  ___arguments.context.pageData['update'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/784b9aa9e4aae59de1165112431bb082/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    return2 = 'Totaal aantal activiteiten/ gewerkte minuten';
  } else {
    return2 = 'Totaal gewerkte minuten';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/982a348440022ec21215d66e0da55406/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1197530df5b50a5a864cc8e5347cf79f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/61356a4cbac26eebd34446359461d9a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true) {
    return2 = 'Resterende activiteiten/ minuten';
  } else {
    return2 = 'Resterende minuten';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/ca95d077b3f4c15303f78f45fc56cfbe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\''].join(''))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d3ee6aa74d29e638d071710359dd1929/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/37eba749d82cc2adacff16877829f4f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    return2 = 'activiteiten/ gewerkte minuten per dossier';
  } else {
    return2 = 'gewerkte minuten per dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f46eeb77fb6fd28867d81762ecb41464/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/d47debd34413d652bfc93ff6c56425df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/edb39bf38052fc6eb50e8f142a6842c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusakkoord')),'\'','AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatusdossier')),'\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\'','AND registratiesaantalconsulten>=',(getObjectProperty(___arguments.context.pageData, 'filteraantalconsulten')),'AND registratiesgewerkteminuten>=',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/332b11cd5bca22ee3efff594580269e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraag': (getObjectProperty(___arguments.context.pageData, 'emailvraag')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailvraag'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/3e9f84d41f840bfcc70e84ca3e8cd6f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1ed8e174777683878c612c660c89f04d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'financieringsubsidie')) == 'Financiering gemeente Amsterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'financieringsubsidie')) == 'UWV' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'scholingbetaald')) == true) {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'scholingbetaalddoor': [(new Intl.DateTimeFormat('de', undefined).format((new Date()))),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''),'scholingbetaald': true }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'scholingbetaald')) == false) {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'scholingbetaalddoor': null,'scholingbetaald': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pldossieroverzicht/components/fb17aa87b73ccbfca07b532c0bc46719/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb17aa87b73ccbfca07b532c0bc46719')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/f84b467204c3421c91db57eb79ee399b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a6649c2b393d901cc4a2ba0694e13079/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/6ce787bd7bc32e64b1fc97c53f8deaae/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/4e1eb33546b4b1530b816cee0f52c68e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/1fc7c32a17e37f041d0dd51609c5ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratiesgewerkteminuten'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/dd364746c4f83091e91f87cf392a462a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE\'','Scholing','\' AND status LIKE\'','Afgesloten','\' AND scholingbetaald is null AND akkoordomschrijving =\'Akkoord\'',' OR ','centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND financieringsubsidie LIKE\'','Financiering gemeente Amsterdam','\' AND status LIKE\'','Afgesloten','\' AND scholingbetaald is null',' AND akkoordomschrijving =\'Akkoord\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/7999ac55ad43aa342ef6f73f50638431/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'','Akkoord','\'','AND status LIKE\'','Afgesloten','\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND financieringsubsidie= \'Financiering gemeente Amsterdam\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b6376505d706b34f03b2c6c1d17a27cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/72cb99b1f5e29d3c47f449e6b16ca5ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE\'','Scholing','\' AND status LIKE\'','Actief','\' AND scholingbetaald is null AND akkoordomschrijving =\'Akkoord\'',' OR ','centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND financieringsubsidie LIKE\'','Financiering gemeente Amsterdam','\' AND status LIKE\'','Actief','\' AND scholingbetaald is null',' AND akkoordomschrijving =\'Akkoord\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0568fa82b8f2d1437349c5b3167488ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'','Akkoord','\'','AND status LIKE\'','Actief','\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND financieringsubsidie= \'Financiering gemeente Amsterdam\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/b7314518af188048a5c86b382c06db25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/5558b8e81f58b778008886ba24086568/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND financieringsubsidie LIKE\'','UWV','\' AND status LIKE\'','Afgesloten','\' AND scholingbetaald is null',' AND akkoordomschrijving =\'Akkoord\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/66e80758f7c727a8025e1ff4b168f5e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND financieringsubsidie LIKE\'','UWV','\' AND status LIKE\'','Actief','\' AND scholingbetaald is null',' AND akkoordomschrijving =\'Akkoord\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/bde4f428a5784a9f9208ae38124854c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'','Akkoord','\'','AND status LIKE\'','Afgesloten','\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND financieringsubsidie= \'UWV\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a1f91658f6ff56049194e2f295683b31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'','AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'','AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'','AND akkoordomschrijving LIKE\'','Akkoord','\'','AND status LIKE\'','Actief','\'','AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND financieringsubsidie= \'UWV\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/006896c80512c3d8389875cc3fd8dfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/2ef82e9cced83086ca2f42588e69efe8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2ef82e9cced83086ca2f42588e69efe8', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filterdossiers'))).setProperties(['financieringstroom', 'sum(datatotaalbedrag) as totaalbedrag']).setGroupBy('financieringstroom').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pldossieroverzicht/components/7d1820b864589f615cc892588f185728/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2aa61805065441610f08d71b580ba8'), 'financieringstroom'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a688cf38176fc518eef8188e422dead8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2aa61805065441610f08d71b580ba8'), 'totaalbedrag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/43e888d94b88365f60e8418cb3b846d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/e11a9d0807586ea8136f0e5e6d4e3f08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Leiden\', \'Oegstgeest\', \'Voorschoten\', \'Leiderdorp\')'].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/26baec2841b86d176158b808c4d5b5be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Noordwijk\', \'Teylingen\', \'Katwijk\', \'Lisse\', \'Hillegom\')'].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/a2a88db839a8754879a8065490f42b6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Alphen aan den Rijn\', \'Kaag en Braassem\', \'Zoeterwoude\',\'Nieuwkoop\')'].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossieroverzicht/components/23482147967830c863d85384bd285238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Leiden\', \'Oegstgeest\', \'Voorschoten\', \'Leiderdorp\')'].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/0aa85a18da982f88a2497db3473a2498/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Noordwijk\', \'Teylingen\', \'Katwijk\', \'Lisse\', \'Hillegom\')'].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossieroverzicht/components/813845783529e5cee2480928c97f5588/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND status = \'actief\' AND regio IN (\'Alphen aan den Rijn\', \'Kaag en Braassem\', \'Zoeterwoude\')'].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/fc66159ea071290ccbe600745ff891d3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Consult zorgvrager','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Consult zorgvrager')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierdetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/2c1eae7de09c413f95ee15c3340620d1/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Groepsconsult','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Groepsconsult')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierdetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/151d9d01254a9d84fc6b9ba4782dbc61/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Scholing','\' AND questioscholingofmoreel=\'','Scholing','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Scholing')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierdetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/1ae234f5e6d4b288d9c22c56169a3542/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Scholing','\' AND questioscholingofmoreel=\'','Moreel beraad','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Moreel beraad')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierdetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/80ece13c74286f98ba8362942cc24a05/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','MDO/PaTz','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'MDO/PaTz')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierdetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == null) {
  } else {
    ___arguments.context.pageData['filteractiviteit'] = (getObjectProperty(___arguments.context.appData, 'filteractiviteit'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filternaamgv')) == null) {
    ___arguments.context.pageData['filternaamgv'] = '%';
  } else {
    ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.appData, 'filternaamgv'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filterregio')) == null) {
    ___arguments.context.pageData['filterregio'] = '%';
  } else {
    ___arguments.context.pageData['filterregio'] = (getObjectProperty(___arguments.context.appData, 'filterregio'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filtergemeente')) == null) {
    ___arguments.context.pageData['filtergemeente'] = '%';
  } else {
    ___arguments.context.pageData['filtergemeente'] = (getObjectProperty(___arguments.context.appData, 'filtergemeente'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/61e4e8721be28f3fbe1c5078fde98944/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/123277a8b941f53a98ee395ce7d11e1b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('gemeentewoonplaats ASC').setGroupBy('gemeentewoonplaats').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/423335e1140e82bfb70b552a152e1d57/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/77e1e011af6f5801d85b4f5fa1d886e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filternaamgv'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/46c83938a527f112f2af122fbfbb1387/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filtergemeente'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/c599962bd5ef393925163e7d2dab4e49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filterregio'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/a25f96079c73e80d0cbf8fe7e0ec23ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/5ee7320b564295273e53a7f8f8918ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/60c6b28cff492dff5e675b54cd8872d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestio/components/03a4404c57e1d3ad14ec6765cfddabc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalender', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/fc66159ea071290ccbe600745ff891d3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Consult zorgvrager','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Consult zorgvrager')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekendetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/2c1eae7de09c413f95ee15c3340620d1/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Groepsconsult','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Groepsconsult')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekendetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/151d9d01254a9d84fc6b9ba4782dbc61/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Scholing','\' AND questioscholingofmoreel=\'','Scholing','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Scholing')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekendetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/1ae234f5e6d4b288d9c22c56169a3542/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','Scholing','\' AND questioscholingofmoreel=\'','Moreel beraad','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'Moreel beraad')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekendetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/80ece13c74286f98ba8362942cc24a05/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'','MDO/PaTz','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == 'MDO/PaTz')

  },
  /* handler:onDisplayAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['filteractiviteit'] = (getObjectProperty(___arguments.context.pageData, 'filteractiviteit'));
  ___arguments.context.appData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.appData['filterregio'] = (getObjectProperty(___arguments.context.pageData, 'filterregio'));
  ___arguments.context.appData['filtergemeente'] = (getObjectProperty(___arguments.context.pageData, 'filtergemeente'));
  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.selectedRecord, 'activiteit'));
  ___arguments.context.appData['questioscholingofmoreel'] = (getObjectProperty(___arguments.selectedRecord, 'questioscholingofmoreel'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossierzoekendetailsquestio', undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'filteractiviteit')) == null) {
  } else {
    ___arguments.context.pageData['filteractiviteit'] = (getObjectProperty(___arguments.context.appData, 'filteractiviteit'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filternaamgv')) == null) {
    ___arguments.context.pageData['filternaamgv'] = '%';
  } else {
    ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.appData, 'filternaamgv'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filterregio')) == null) {
    ___arguments.context.pageData['filterregio'] = '%';
  } else {
    ___arguments.context.pageData['filterregio'] = (getObjectProperty(___arguments.context.appData, 'filterregio'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'filtergemeente')) == null) {
    ___arguments.context.pageData['filtergemeente'] = '%';
  } else {
    ___arguments.context.pageData['filtergemeente'] = (getObjectProperty(___arguments.context.appData, 'filtergemeente'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/61e4e8721be28f3fbe1c5078fde98944/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/123277a8b941f53a98ee395ce7d11e1b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('gemeentewoonplaats ASC').setGroupBy('gemeentewoonplaats').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/423335e1140e82bfb70b552a152e1d57/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND gemeentewoonplaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtergemeente')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/77e1e011af6f5801d85b4f5fa1d886e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filternaamgv'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/46c83938a527f112f2af122fbfbb1387/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filtergemeente'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/c599962bd5ef393925163e7d2dab4e49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['filterregio'] = '%';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/a25f96079c73e80d0cbf8fe7e0ec23ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/5ee7320b564295273e53a7f8f8918ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pldossierzoekenquestiokalender/components/60c6b28cff492dff5e675b54cd8872d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filteractiviteit')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plemailprojectleider/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plemailprojectleider/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plemailprojectleider/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('41dc4c3344d617ff1c087dbac95b6d17', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setSortBy('regio ASC').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plemailprojectleider/components/8bdf3b7c339fad5e71be9ebe3efea71a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('emailprojectleider').save( ___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plemailprojectleider/components/4a3d715393a35bd76edfea8867f596a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Hier kan het emailadres worden ingesteld voor de emails die verzonden worden naar de ',(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))),'. De gegevens worden automatisch opgeslagen.'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plemailprojectleider/components/a00dbc6dcb4ae636178ea78840d9650a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht1') {
    name2 = 'CvL1 Noordwest Veluwe';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht2') {
    name2 = 'CvL2 Eemland';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht3') {
    name2 = 'CvL3 Rivierengebied';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht4') {
    name2 = 'CvL4 Noordwest Utrecht';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht5') {
    name2 = 'CvL5 Lekstroom (Utrecht Zuid)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht6') {
    name2 = 'CvL6 Zuidoost Utrecht';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio')) == 'Utrecht7') {
    name2 = 'CvL7 Zin in Utrecht (Gemeente Utrecht)';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302'), 'regio'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plemailprojectleider/components/1e0ef22fd851a7effd5bb37f2c923f59/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    text = 'Email teamcoördinator (verlengingsaanvragen)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Email Scholing, groepsconsulten en MDO/PaTz';
  } else {
    text = 'tekst 2e email veld';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plemailprojectleider/components/015fd014cc2befb355e90e24a2b1b8af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio')

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('emailprojectleider').save( ___arguments.context.getComponentDataStoreByUid('5b47ae58f783eb293aa3d20d29efe302') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plemailprojectleider/components/c938260ba424bcaaee64f612eb1ac71d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    return2 = 'Email Consult Cliënt';
  } else {
    return2 = 'Email coördinator';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plexports/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/b0cce717141446c20ca52a3fce9610af/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setProperties('centra').setSortBy('centra ASC').setGroupBy('centra').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'centra')),'label': (getObjectProperty(item, 'centra')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plexports/components/4bed4aaa4c3a9f43751b84eb1e6aa0bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvResterendeminutendossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvResterendeminutendossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/resterendeminutendossiers.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND status =\'Actief\''].join(''),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['activiteit', 'dossier', 'regio', 'naam', 'status', 'resterend', 'Sum(resterendtotaalbedrag)/10000 as resterendtotaalbedrag', 'pakketminutendossier', 'date(created) as created '],[`columnsMapping`]: ({ [`activiteit`]: 'Activiteit',[`regio`]: 'Regio',[`naam`]: 'Naam',[`dossier`]: 'Dossiernummer',[`status`]: 'Status',[`pakketminutendossier`]: 'Totaal minuten op het dossier',[`resterend`]: 'Resterende minuten op het dossier',[`resterendtotaalbedrag`]: 'Resterend totaalbedrag',[`created`]: 'Datum aanmaak dossier' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Activiteit', 'Regio', 'Naam', 'Dossiernummer', 'Status', 'Totaal minuten op het dossier', 'Resterende minuten op het dossier', 'Resterend totaalbedrag', 'Datum aanmaak dossier'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvResterendeminutendossiers)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export resterendeminutendossiers.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export resterendeminutendossiers.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8b8a5b9574c8dfa523f1cf57431206d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroledossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroledossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroledossiers2025.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: String('centra<>\'Lorio\'') + String(' AND aanmaakjaar <2026'),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['status', 'regio', 'resterend', 'resterendtotaalbedrag', 'pakketminutendossier', 'created as hulpvraag', 'created', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'activiteit', 'gemeentewoonplaats', 'leeftijd', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer', 'omschscholing', 'opbouwinfrakortetoelichting', 'betrokkenorganisaties', 'centra', 'xcreateddatum', 'dossier', 'vrijwilligerstatus', 'registratiesaantalconsulten', 'dashboardnaam', 'wlzindicatie', 'wlzindicatiesoort', 'wlzpostcode', 'akkoordomschrijving', 'dossieraanmakerquestio'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['status', 'regio', 'resterend', 'resterendtotaalbedrag', 'pakketminutendossier', 'hulpvraag', 'created', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'activiteit', 'gemeentewoonplaats', 'leeftijd', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer', 'omschscholing', 'opbouwinfrakortetoelichting', 'betrokkenorganisaties', 'centra', 'xcreateddatum', 'dossier', 'vrijwilligerstatus', 'registratiesaantalconsulten', 'dashboardnaam', 'wlzindicatie', 'wlzindicatiesoort', 'wlzpostcode', 'akkoordomschrijving', 'dossieraanmakerquestio'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroledossiers)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export csvmaandcontroledossiers'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export csvmaandcontroledossiers',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/d252fcebd774f6a6e5eac467227b0253/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroleusers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroleusers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroleusers.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'centra<>\'Lorio\' AND GV=\'GV\' AND userStatus=\'ENABLED\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['dashboardnaam', 'centraname', 'GV', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing'],[`columnsMapping`]: undefined,[`sortBy`]: 'dashboardnaam ASC' }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'centraname', 'GV', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroleusers)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export maandcontroleusers.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export maandcontroleusers.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/9de72ec4943648b91fec0ed73d2ea286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvuserstotaaloverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvuserstotaaloverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/userstotaaloverzichtlorio.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'centra<>\'Lorio\'',[`relations`]: undefined,[`groupBy`]: 'username',[`sortBy`]: 'dashboardnaam ASC',[`pageSize`]: undefined,[`properties`]: ['dashboardnaam', 'naam', 'organisatie', 'email'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'naam', 'organisatie', 'email'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvuserstotaaloverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export userstotaaloverzichtlorio.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export userstotaaloverzichtlorio.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/d72cc0f3d6a46cde213bbee177853472/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvbtwinstellingentotaaloverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvbtwinstellingentotaaloverzicht, false, undefined);
}


  csvbtwinstellingentotaaloverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/btwinstellingen',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'.csv'].join('')),'tableName': 'Users','tableOptions': ({ [`where`]: ['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND userStatus=\'ENABLED\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: 'centraname ASC',[`pageSize`]: undefined,[`properties`]: ['dashboardnaam', 'organisatie', 'naam', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'organisatie', 'naam', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvbtwinstellingentotaaloverzicht)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export btwinstellingenlorio.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export btwinstellingenlorio.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/f9d2e173396223b1a7ee6d73cbb529d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroledossiersafgesloten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroledossiersafgesloten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroledossiersafgesloten.csv','tableName': 'dossiersafgesloten','tableOptions': ({ [`where`]: 'centra<>\'Lorio\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'afrondingabc', 'afrondingdoorverwijzing', 'afrondingdoorverwijzinggv', 'afrondingreden', 'centra', 'consultinwthemasachtergrond', 'consultthemas', 'dossier', 'financieringvws', 'gebruiker', 'questiodeelnemers', 'questioevaluatie', 'questioevaluatiecijfer', 'rotterdamvervolgafspraken', 'rotterdamwelkevervolgafspraken', 'status', 'toelichtingopredenafronding', 'year(created) as created', 'afrondingdoorverwezennaar'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'afrondingabc', 'afrondingdoorverwijzing', 'afrondingdoorverwijzinggv', 'afrondingreden', 'centra', 'consultinwthemasachtergrond', 'consultthemas', 'dossier', 'financieringvws', 'gebruiker', 'questiodeelnemers', 'questioevaluatie', 'questioevaluatiecijfer', 'rotterdamvervolgafspraken', 'rotterdamwelkevervolgafspraken', 'status', 'toelichtingopredenafronding', 'created', 'afrondingdoorverwezennaar'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroledossiersafgesloten)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export csvmaandcontroledossiersafgesloten'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export csvmaandcontroledossiersafgesloten',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/80da81f5b631cce2123adfb1dd441b85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registraties.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra<>\'Lorio\' AND jaar=\'2023\' AND anderefinanciering=0',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registraties.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registraties.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/79adbed27d746b34ae4afc3455546296/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzicht2022.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Rotterdam','\' AND anderefinanciering <>TRUE AND jaar=2022 AND financieringsubsidie<>\'Vrijwillig\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzicht2022.csv Rotterdam'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzicht2022.csv Rotterdam',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8b6440f5ba85474aaad230dac0fca80e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzicht2022zwnl.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'jaar=2022 AND centra=\'ZWNL\' AND gebruiker is null',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'naam', 'reistijdminuten', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'consultinwdoelgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'naam', 'reistijdminuten', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag', 'consultinwdoelgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzicht2022zwnl.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzicht2022zwnl.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/5a3fe1ee1ea1acab072975d53d9e3881/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk1_2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Drechtsteden\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Gelderland\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Limburg\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Overijssel\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Rotterdam\' AND jaar=\'2023\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk1)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk1_2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk1_2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8acbdf37fd21f6b9c41ba93e70f74092/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk2 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk2_2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Utrecht\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Willem\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Questio\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'ZWNL\' AND jaar=\'2023\' AND anderefinanciering=0',' OR ','centra=\'Brabant\' AND jaar=\'2023\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk2)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk2_2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk2_2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/36bc45fbfd2b956257a5c57a2c9a0ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtRotterdam2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Rotterdam','\' AND anderefinanciering <>TRUE AND jaar=2023 AND financieringsubsidie<>\'Vrijwillig\''].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtRotterdam2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtRotterdam2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/27136d56adf260837e6d22bed3a82555/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtDrechtsteden2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','drechtsteden','\' AND jaar=2023'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtDrechtsteden2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtDrechtsteden2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/3687d50bbc4134f12f6d5ddd8c421ffc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtGelderland2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'gelderland\' AND jaar=2023 AND financieringvws=\'Ja\'',' OR ','centra=\'gelderland\' AND jaar=2023 AND financieringvws=\'Gedeeltelijk\'',' OR ','centra=\'gelderland\' and jaar=2023 and financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtGelderland2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtGelderland2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/56b8177e3c9b8c68fad9a28da4863ead/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtLimburg2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'limburg\' AND jaar=2023',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtLimburg2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtLimburg2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/976771458f424b8e9ca1bbb8c67f353b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtOverijssel2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'overijssel\' AND jaar=2023',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtOverijssel2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtOverijssel2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/e4a2d857399b6c77f7d97325e04ee43c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtQuestio2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Questio','\' AND jaar=2023'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtQuestio2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtQuestio2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/f6314a0c5a6ec70daf833ead53faec1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtUtrecht2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Utrecht','\' AND jaar=2023'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtUtrecht2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtUtrecht2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/418ec85cb71f923e725909c7be8a7e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtWillem2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'willem\' AND jaar=2023 AND financieringvws=\'Ja\'',' OR ','centra=\'willem\' AND jaar=2023 AND financieringvws=\'Gedeeltelijk\'',' OR ','centra=\'willem\' and jaar=2023 and financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtWillem2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtWillem2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/53ae77d1d09308949f7df84baca7cc7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtZWNL2023.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'ZWNL\' AND jaar=2023',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtZWNL2023.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtZWNL2023.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plexports/components/3537b8f89c91ee46dbeb6abdeffc47e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiesmaandcontrolejm22.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra<>\'Lorio\' AND anderefinanciering=0 AND jaar=\'2022\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiesmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiesmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/3558074d574d94f8b26217db226fb5ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/dossierssmaandcontrolejm.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: 'centra<>\'Lorio\'',[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'dossier', 'naam', 'centra', 'username', 'created', 'hulpvraag', 'gemeentewoonplaats', 'kenmerk', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'dossier', 'naam', 'centra', 'username', 'created', 'hulpvraag', 'gemeentewoonplaats', 'kenmerk', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export dossiersmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export dossiersmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/2afb057c590cdf48165a3dca8001abe1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk1_2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Drechtsteden\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Gelderland\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Limburg\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Overijssel\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Rotterdam\' AND jaar=\'2024\'',' OR ','centra=\'ZHN\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Haaglanden\' AND jaar=\'2024\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk1)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk1_2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk1_2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/4ad98853a49b9e4f423688717003761a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk2 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk2_2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Utrecht\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Willem\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Questio\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'ZWNL\' AND jaar=\'2024\' AND anderefinanciering=0',' OR ','centra=\'Brabant\' AND jaar=\'2024\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk2)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk2_2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk2_2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/efd219da513dfce443582946fdba8d2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvdossiersactief;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvdossiersactief = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/dossiersactief.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND status=\'Actief\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['centra', 'regio', 'dossier', 'activiteit', 'date(created) as aanmaakdatum', 'aanmaakmaand', 'aanmaakjaar', 'naam', 'emailgv', 'organisatie', 'pakketminutenakkoord', 'resterend'],[`columnsMapping`]: undefined,[`sortBy`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'regio', 'dossier', 'activiteit', 'aanmaakdatum', 'aanmaakmaand', 'aanmaakjaar', 'naam', 'emailgv', 'organisatie', 'pakketminutenakkoord', 'resterend'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvdossiersactief)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/ab9608080c3fe4d6988e3333967d2e78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiesdatum;


  csvregistratiesdatum = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiesdatum.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'Utrecht\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['jaar', 'dossier', 'gewerkteminuten', 'reistijdminutenspeciaal', 'date(created) as datum', 'gewerkteminutentotaalbedrag'],[`columnsMapping`]: undefined,[`sortBy`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['jaar', 'dossier', 'gewerkteminuten', 'reistijdminutenspeciaal', 'datum', 'gewerkteminutentotaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiesdatum)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/7415ca0942a875d55513ea2c494e1089/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiesmaandcontrolejm24.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra<>\'Lorio\' AND anderefinanciering=0 AND jaar=\'2024\' ',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiesmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiesmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/854344061478bd3370a65c0ea748046d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiesmaandcontrolejm23.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra<>\'Lorio\' AND anderefinanciering=0 AND jaar=\'2023\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiesmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiesmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/d17269ce2d9828cc8c4ea85abaeb5278/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtDrechtsteden2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','drechtsteden','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtDrechtsteden2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtDrechtsteden2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/46a7f0b6664dee59265c35e9c1649a66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtGelderland2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'gelderland\' AND jaar=2024 AND financieringvws=\'Ja\'',' OR ','centra=\'gelderland\' AND jaar=2024 AND financieringvws=\'Gedeeltelijk\'',' OR ','centra=\'gelderland\' and jaar=2024 and financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtGelderland2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtGelderland2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/a48ffab8e21b00d4dcd552d4ac1bad66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtLimburg2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'limburg\' AND jaar=2024',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtLimburg2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtLimburg2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/2e3261a641f5c1a4c201201215186b71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtOverijssel2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'overijssel\' AND jaar=2024',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtOverijssel2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtOverijssel2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/3e440d2180a49c0925a984d8e66be2d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtQuestio2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Questio','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'voorbereidingminuten', 'Sum(totaalexbtw)/10000 as totaalexbtw', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'voorbereidingminuten', 'totaalexbtw', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtQuestio2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtQuestio2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8cf3959995c2add49c7e5fb7f9d2a596/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtRotterdam2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Rotterdam','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'financieringsubsidie', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'financieringsubsidie', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtRotterdam2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtRotterdam2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/2ed116070a13247e7ed62691b27b9ccd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtUtrecht2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Utrecht','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtUtrecht2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtUtrecht2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/58ff55c34e1ef83a05b5638564a29675/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtWillem2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'willem\' AND jaar=2024 AND financieringvws=\'Ja\'',' OR ','centra=\'willem\' AND jaar=2024 AND financieringvws=\'Gedeeltelijk\'',' OR ','centra=\'willem\' and jaar=2024 and financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtWillem2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtWillem2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/3c271fd52d6e9dff8fcda4757f36f50c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtZWNL2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: 'centra=\'ZWNL\' AND jaar=2024',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtZWNL2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtZWNL2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/15ee37697e4343f2a35ed08ecb44eb7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtBrabant2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Brabant','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtBrabant2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtBrabant2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/786d399a5d59826bab0a6b276922d674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtZHN2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','ZHN','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtZHN2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtZHN2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/12b726c7958997d99d9434639e947ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiestijd;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiestijd = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiestijd.csv','tableName': 'registratiestijd','tableOptions': ({ [`where`]: 'dossier is not null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['registratienummer', 'dossier', 'gebruiker', 'gewerkteminuten', 'reistijdminuten', 'reistijdminutenspeciaal', 'voorbereidingminuten', 'reistijdkm', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['registratienummer', 'dossier', 'gebruiker', 'gewerkteminuten', 'reistijdminuten', 'reistijdminutenspeciaal', 'voorbereidingminuten', 'reistijdkm', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiestijd)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiestijd.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiestijd.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/f4f799924117d188b1378dfa0a9ae2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var dossiers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dossiers = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')),'properties': ['dossier'] })).map(async item => {; return (getObjectProperty(item, 'dossier'));})));
  ___arguments.context.pageData['dossierslist'] = (dossiers.join('\',\''));
  (function (message) { alert(message) })('Data is klaar om blauwe knoppen te gebruiken.');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plexports/components/023c86ccd923d2ecc737f473c718581c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroleregistraties.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['dossier IN(\'',(getObjectProperty(___arguments.context.pageData, 'dossierslist')),'\')'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'registratienummer', 'dossier', 'naam', 'totaalminuten', 'maand', 'centra', 'regio', 'consultdatum', 'totaalbedrag', 'username', 'created'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistraties)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiesmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiesmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/6cddaf98dda1d1b3b0ce75155cc78dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroledossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroledossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroledossiers.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['dossier IN(\'',(getObjectProperty(___arguments.context.pageData, 'dossierslist')),'\')'].join(''),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'dossier', 'naam', 'centra', 'username', 'created', 'gemeentewoonplaats', 'kenmerk', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'btwplichtig', 'dossier', 'naam', 'centra', 'username', 'created', 'gemeentewoonplaats', 'kenmerk', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroledossiers)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export dossiersmaandcontrolejm.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export dossiersmaandcontrolejm.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/4177f9119ccd02fb13a3512f235f8dbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroleregistratiestijd;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroleregistratiestijd = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroleregistratiestijd.csv','tableName': 'registratiestijd','tableOptions': ({ [`where`]: ['dossier IN(\'',(getObjectProperty(___arguments.context.pageData, 'dossierslist')),'\')'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['registratienummer', 'dossier', 'gebruiker', 'gewerkteminuten', 'reistijdminuten', 'reistijdminutenspeciaal', 'voorbereidingminuten', 'reistijdkm', 'created', 'updated'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['registratienummer', 'dossier', 'gebruiker', 'gewerkteminuten', 'reistijdminuten', 'reistijdminutenspeciaal', 'voorbereidingminuten', 'reistijdkm', 'created', 'updated'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroleregistratiestijd)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export maandcontroleregistratiestijd.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export maandcontroleregistratiestijd.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/6dcce3298dcf49e4685a413ce83fe0bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvDossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvDossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/dossiersZHN2024.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['centra=\'','ZHN','\''].join(''),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['naam', 'activiteit', 'dossier', 'lopenddossier', 'lopenddossiertoelichting', 'pakketminutenakkoord', 'resterend', 'status'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['naam', 'activiteit', 'dossier', 'lopenddossier', 'lopenddossiertoelichting', 'pakketminutenakkoord', 'resterend', 'status'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvDossiers)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/dossiersZHN2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/dossiersZHN2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/cddbb489006f2697fc669ea10265d847/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolegegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8b1b4bc945c46cfd688bd4583fedd3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtHaaglanden2024.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Haaglanden','\' AND jaar=2024'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtHaaglanden2024.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtHaaglanden2024.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/247685eefee9215e8c5d58be96b23ecb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk1_2025.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Drechtsteden\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Gelderland\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Limburg\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Overijssel\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Rotterdam\' AND jaar=\'2025\'',' OR ','centra=\'ZHN\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Haaglanden\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Zinvol\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Sichtpunt\' AND jaar=\'2025\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'maand as hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk1)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk1_2025.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk1_2025.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/fe7d12538f32636f17914478b38c3cca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk2 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk2_2025.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Utrecht\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Willem\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Questio\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'ZWNL\' AND jaar=\'2025\' AND anderefinanciering=0',' OR ','centra=\'Brabant\' AND jaar=\'2025\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'maand as hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk2)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk2_2025.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk2_2025.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/1c9e979b801cd7176abc5fa2be4f5f46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvlandelijkregistratiedata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvlandelijkregistratiedata = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvlandelijkregistratiedata.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra<>\'Lorio\' AND jaar =\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null '].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['jaar', 'activiteit', 'centra', 'dossier', 'totaalminuten', 'groepsaantaldeelnemers', 'scholingaantaldeelnemers', 'mdopatzaantalbesprokenclienten', 'registratienummer', 'financieringsubsidie', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['jaar', 'activiteit', 'centra', 'dossier', 'totaalminuten', 'groepsaantaldeelnemers', 'scholingaantaldeelnemers', 'mdopatzaantalbesprokenclienten', 'registratienummer', 'financieringsubsidie', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvlandelijkregistratiedata)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export landelijkemonitoring.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: '-export landelijkemonitoring.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/c0b162d823d15ae84ea8afe8b89d6e18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Zinvol',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Zinvol','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Zinvol',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Zinvol',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/a301da65bd29bb5558377ce8beb28e68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvlandelijkregistratiebedragen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvlandelijkregistratiebedragen = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvlandelijkregistratiedatabedragen.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra<>\'Lorio\' AND jaar =\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null '].join(''),[`relations`]: undefined,[`groupBy`]: 'maand',[`pageSize`]: undefined,[`properties`]: ['jaar', 'sum(totaalbedrag) as totaal', 'maand'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['jaar', 'totaal', 'maand'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvlandelijkregistratiebedragen)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export landelijkemonitoring.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: '-export landelijkemonitoring.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/8ba8a1a612f85e3dab58911897df1478/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var old, csvlandelijkverwijzers;

/**
 * Describe this function...
 */
async function do_something() {
  old = String('centra<>\'Lorio\' ') + String(' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null AND activiteit=\'Consult zorgvrager\' ');
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something2() {
  if (false) {
    csvlandelijkverwijzers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvlandelijkverwijzers.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra<>\'Lorio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null AND activiteit=\'Consult zorgvrager\' '].join(''),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['activiteit', 'dossier', 'registratienummer', 'consultinwverwijzer'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'dossier', 'registratienummer', 'consultinwverwijzer'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvlandelijkverwijzers)), false, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export landelijkemonitoring.csv'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: '-export landelijkemonitoring.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  }
}


  csvlandelijkverwijzers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvlandelijkverwijzers.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra<>\'Lorio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null AND activiteit=\'Consult zorgvrager\' '].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['consultinwverwijzer'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['consultinwverwijzer'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvlandelijkverwijzers)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export landelijkemonitoring.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: '-export landelijkemonitoring.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/c0188998248a57f86c28386801580b38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvlandelijkthemas;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvlandelijkthemas = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvlandelijkthemas.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra<>\'Lorio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null AND activiteit=\'Consult zorgvrager\' ',' OR ','centra<>\'Lorio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND anderefinanciering=0 AND financieringsubsidie=\'VWS\' AND gebruiker is null AND activiteit=\'Consult professional\' '].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'dossier', 'registratienummer', 'consultthemas'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'dossier', 'registratienummer', 'consultthemas'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvlandelijkthemas)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export landelijkemonitoring.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: '-export landelijkemonitoring.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/6a0357c7587828d8846b6db8e188e108/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Haaglanden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Haaglanden','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'gemeentewoonplaats', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'gemeentewoonplaats', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'totaalbedrag', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Haaglanden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Haaglanden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/4c4892385efab508561c9e78ca57c2b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvhistoriepltoestemmingen;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvhistoriepltoestemmingen = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/historiepltoestemmingen.csv','tableName': 'historiepltoestemmingen','tableOptions': ({ [`where`]: 'centra=\'Haaglanden\' AND aanpassingstatusdossier=\'VERLENGING BEHANDELD\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['centra', 'datumaanpassing', 'dossier', 'startpakketminutenakkoord', 'aanpassingpakketminutenakkoord'],[`columnsMapping`]: undefined,[`sortBy`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'datumaanpassing', 'dossier', 'startpakketminutenakkoord', 'aanpassingpakketminutenakkoord'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvhistoriepltoestemmingen)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export historiepltoestemmingen.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export historiepltoestemmingen.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/9538aff6803808abc838ef66641edee8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvfactuurnummersnew;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvfactuurnummersnew = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/factuurnummersnew.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND financieringvws = \'Ja\' OR ','centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND financieringsubsidie = \'fonds buiten VWS\' OR  ','centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND financieringsubsidie = \'Vrijwilliger\''].join(''),[`relations`]: undefined,[`groupBy`]: 'maand,username',[`pageSize`]: undefined,[`properties`]: ['centra', 'maand', 'username'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'maand', 'username'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfactuurnummersnew)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/factuurnummersnew.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/factuurnummersnew.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/4f68c77a3c27b0eb61b834f8875162b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centra, GVORG;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == null) {
    (function (message) { alert(message) })('Selecteer centra');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Drechtsteden') {
      centra = 'Dr';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Gelderland') {
      centra = 'Ge';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Limburg') {
      centra = 'Li';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Overijssel') {
      centra = 'Of';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Questio') {
      centra = 'Qu';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Rotterdam') {
      centra = 'Ro';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Utrecht') {
      centra = 'Mn';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Willem') {
      centra = 'Wi';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'ZWNL') {
      centra = 'Zw';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Brabant') {
      centra = 'Br';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'ZHN') {
      centra = 'Zh';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Haaglanden') {
      centra = 'Hz';
    } else if ((getObjectProperty(___arguments.context.pageData, 'filtercentra')) == 'Zinvol') {
      centra = 'Zv';
    }
    GVORG = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/GVORG.csv','tableName': 'factuurgegevens','tableOptions': ({ [`where`]: ['centra=\'',centra,'\' AND username NOT LIKE  \'lorio%\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['username', 'bedrijfsnaam', 'email'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['username', 'bedrijfsnaam', 'email'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(GVORG, true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/e5f841aa16a84a88e51bc158105dea58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk1 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk1_2026.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Drechtsteden\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Gelderland\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Limburg\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Overijssel\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Rotterdam\' AND jaar=\'2026\'',' OR ','centra=\'ZHN\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Haaglanden\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Zinvol\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Sichtpunt\' AND jaar=\'2026\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'maand as hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk1)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk1_2026.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk1_2026.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/c9c852580e29adc9b79899a781e4b4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvregistratiespernetwerk2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvregistratiespernetwerk2 = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/registratiespernetwerk2_2026.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'Utrecht\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Willem\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Questio\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'ZWNL\' AND jaar=\'2026\' AND anderefinanciering=0',' OR ','centra=\'Brabant\' AND jaar=\'2026\' AND anderefinanciering=0'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'maand as hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'date(createddash) as createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'Date(geboortedatum) as geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'questioconsultinwaangenomendoor', 'Date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['activiteit', 'btw', 'centra', 'coachingdeelnemers', 'coachingdoelgroep', 'coachingfunctiepro', 'coachingnaamorgpro', 'coachingonderdeelscholing', 'coachingorganisatielocatie', 'coachingspecifiekedoelgroepteam', 'consultaantbetrokken', 'consultbetrokken', 'consultdatum', 'consultinwdoelgroep', 'consultinwgeboortejaar', 'consultinwgender', 'consultinwleeftijd', 'consultinwverwijzer', 'consultprofunctie', 'consultpronaamorg', 'consultthemas', 'consultwijze', 'coordinatiekortetoelichting', 'coordinatiemaanduitgevoerdetaken', 'datumconsult', 'dossier', 'financieringconsultthemas', 'financieringnietdeclreistijdkm', 'financieringnietdeclreistijdminuten', 'financieringnietdeclvoorbereidingminuten', 'financieringnietdeclwerkminuten', 'financieringstroom', 'financieringvws', 'gebruiker', 'gemeentewoonplaats', 'gewerkteminuten', 'gewerkteminutenbtw', 'gewerkteminutenexbtw', 'gewerkteminutentotaalbedrag', 'gewerktvoorbereidingreistijdminuten', 'groepsaantaldeelnemers', 'groepsbeoogdedoelresultaat', 'groepsbetrokkenorganisaties', 'groepsdoelgroep', 'groepskorteomschrijving', 'groepsthemas', 'groepswasersprakevan', 'hulpvraag', 'maand', 'mdopatzaantalbesprokenclienten', 'mdopatznaam', 'mdopatzsoortoverleg', 'mdopatzvervolgnavmdopatz', 'opbouwinfrakorteomschrijving', 'opbouwinfrakortetoelichting', 'quote', 'regio', 'registratienummer', 'reistijdkm', 'reistijdkmbtw', 'reistijdkmexbtw', 'reistijdkmtotaalbedrag', 'reistijdminuten', 'reistijdminutenbtw', 'reistijdminutenexbtw', 'reistijdminutenspeciaal', 'reistijdminutenspeciaalbtw', 'reistijdminutenspeciaalexbtw', 'reistijdminutenspeciaaltotaalbedrag', 'reistijdminutentotaalbedrag', 'reistijdtotaalbedrag', 'rotterdamklachtenreglement', 'rotterdamleerpunten', 'rotterdamomschrijvingscholing', 'rotterdamwaarheid', 'scholingaantaldeelnemers', 'scholingdoelgroep', 'scholingomschrijving', 'scholingorganisatie', 'scholingspecifiekedoelgroepteam', 'scholingteam', 'scholingwijze', 'tariefperminuut', 'tariefreistijdkm', 'tariefreistijdminutenspeciaal', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'totaalminuten', 'dashboardnaam', 'voorbereidingbtw', 'voorbereidingexbtw', 'voorbereidingminuten', 'voorbereidingtotaalbedrag', 'vrijwilligervergoedingov', 'objectId', 'ownerId', 'createddash', 'consultinwthemasthematiek', 'consultinwthemasachtergrond', 'consultinwthemasproces', 'anderefinanciering', 'financieringsubsidie', 'geboortedatum', 'omschrijvinggroepsconsult', 'omschscholing', 'verwijzer', 'objectId', 'questioconsultinwdatumaanvraag', 'questiogroepsconsultbijdrage', 'questiogroepsconsultdeelnemersperbijeenkomst', 'questiogroepsconsultdoel', 'questiogroepsconsulthomogeniteit', 'questiogroepsconsultleeftijddeelnemers', 'questiogroepsconsultlocatiebijeenkomsten', 'questiogroepsconsultmeerwaarde', 'questiogroepsconsultperiodebijeenkomsten', 'questiogroepsconsultprogrammabijeenkomst', 'questiogroepsconsultthema', 'questiogroepsconsultwelkecompetenties', 'questiogroepsconsultwervingdeelnemers', 'questiomoreelberaadaantaluren', 'questiomoreelberaadachtergrondinformatie', 'questiomoreelberaadgeboortejaar', 'questiomoreelberaadgeslacht', 'questiomoreelberaadhulpvraag', 'questiomoreelberaadthuiswonend', 'questioscholingbestaandnieuw', 'questioscholinggeaccrediteerd', 'questioscholingleerdoelen', 'questioscholinglocatie', 'questioscholingnaam', 'questioscholingofmoreel', 'questioscholingverwachtaantaldeelnemers', 'questioscholingwaarvoorgeorganiseerd', 'questioscholingwijze', 'questiomdoincidentieelbetrokken', 'questiomdostandaardbetrokken', 'aantalcontactmomenten', 'werkgroep'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvregistratiespernetwerk2)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export registratiespernetwerk2_2026.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export registratiespernetwerk2_2026.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/64bb3a68d6fd22185f283da8549e0ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzichtDrechtsteden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','drechtsteden','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['- export/jaaroverzichtDrechtsteden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['- export/jaaroverzichtDrechtsteden',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/61086e1b56dec4ea22f20fe8ebf83aa8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzichtGelderland',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'gelderland\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND financieringvws=\'Ja\'',' OR ','centra=\'gelderland\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND financieringvws=\'Gedeeltelijk\'',' OR ','centra=\'gelderland\' and jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtGelderland.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtGelderland.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/e7b413d83e4a03fa4e78b788ecb83808/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzichtLimburg',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Limburg','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtLimburg.csv'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtLimburg.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/fce81578f328f5d8c1953c48a4887da6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','overijssel',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','overijssel','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','overijssel',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','overijssel',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/2e48cf942fa83f2e6874df98874fd578/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Questio',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Questio','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'voorbereidingminuten', 'Sum(totaalexbtw)/10000 as totaalexbtw', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'reistijdkm', 'voorbereidingminuten', 'totaalexbtw', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Questio',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Questio',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/f82cc2585d58915fe0088768d1820bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Rotterdam',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Rotterdam','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'financieringsubsidie', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'financieringsubsidie', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Rotterdam',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Rotterdam',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/d9182d671da82508060a3fe85dc8c988/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Utrecht',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Utrecht','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['dashboardnaam', 'regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Utrecht',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Utrecht',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/e735ae4329988dc8c058fb2c19280c8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Willem',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'willem\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND financieringvws=\'Ja\' OR ','centra=\'willem\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND financieringvws=\'Gedeeltelijk\' OR ','centra=\'willem\' and jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' and financieringvws is null'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'createddash as tijdstipregistratie', 'controledatum', 'controledoor'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdkm', 'reistijdminutenspeciaal', 'totaalbedrag', 'tijdstipregistratie', 'controledatum', 'controledoor'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Willem',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Willem',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/b8c8fec5c9487de1b0c8b1fb74a87f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','ZWNL',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','ZWNL','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['regio', 'maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdminutenspeciaal', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','ZWNL',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','ZWNL',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/64d85168efb8b0981d88b998b94d0ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Brabant',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Brabant','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Brabant',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Brabant',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/9e812f91d7112da6fd757108f3384bac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','ZHN',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','ZHN','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'financieringsubsidie', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gewerkteminuten', 'voorbereidingminuten', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','ZHN',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','ZHN',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/71f569f8a22500ca9cea9968033828f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/jaaroverzicht','Sichtpunt',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Sichtpunt','\' AND jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar'))].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'date(datumconsult) as consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'Sum(reistijdtotaalbedrag)/10000 as reistijdtotaalbedrag', 'Sum(totaalbedrag)/10000 as totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'consultdatum', 'organisatie', 'naam', 'gebruiker', 'gewerkteminuten', 'voorbereidingminuten', 'reistijdtotaalbedrag', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvJaaroverzicht)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),['export/jaaroverzicht','Sichtpunt',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: ['export/jaaroverzicht','Sichtpunt',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join(''),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/4e086e98f45892e64a2866f8dbd375e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandcontroledossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandcontroledossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandcontroledossiers2026.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: String('centra<>\'Lorio\'') + String(' AND aanmaakjaar >=2026'),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['status', 'regio', 'resterend', 'resterendtotaalbedrag', 'pakketminutendossier', 'created as hulpvraag', 'created', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'activiteit', 'gemeentewoonplaats', 'leeftijd', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer', 'omschscholing', 'opbouwinfrakortetoelichting', 'betrokkenorganisaties', 'centra', 'xcreateddatum', 'dossier', 'vrijwilligerstatus', 'registratiesaantalconsulten', 'dashboardnaam', 'wlzindicatie', 'wlzindicatiesoort', 'wlzpostcode', 'akkoordomschrijving', 'dossieraanmakerquestio'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['status', 'regio', 'resterend', 'resterendtotaalbedrag', 'pakketminutendossier', 'hulpvraag', 'created', 'btwplichtig', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'activiteit', 'gemeentewoonplaats', 'leeftijd', 'leeftijd', 'consultinwgeboortejaar', 'consultinwgender', 'verwijzer', 'omschscholing', 'opbouwinfrakortetoelichting', 'betrokkenorganisaties', 'centra', 'xcreateddatum', 'dossier', 'vrijwilligerstatus', 'registratiesaantalconsulten', 'dashboardnaam', 'wlzindicatie', 'wlzindicatiesoort', 'wlzpostcode', 'akkoordomschrijving', 'dossieraanmakerquestio'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandcontroledossiers)), false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export csvmaandcontroledossiers'].join('')));
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export csvmaandcontroledossiers',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/83e627d850f85cd8ba58495899050179/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvdataleeftijdscategorie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvdataleeftijdscategorie = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['export/dataleeftijdscategorie',(getObjectProperty(___arguments.context.pageData, 'jaar')),'.csv'].join('')),'tableName': 'registraties','tableOptions': ({ [`where`]: ['jaar=',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND activiteit=\'Consult zorgvrager\' AND financieringsubsidie=\'VWS\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['centra', 'dossier', 'activiteit', 'consultinwdoelgroep', 'consultinwleeftijd', 'consultinwgeboortejaar', 'jaar', 'date(geboortedatum) as geboortedatum', 'date(questioconsultinwdatumaanvraag) as questioconsultinwdatumaanvraag'],[`columnsMapping`]: undefined,[`sortBy`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'dossier', 'activiteit', 'consultinwdoelgroep', 'consultinwleeftijd', 'consultinwgeboortejaar', 'jaar', 'geboortedatum', 'questioconsultinwdatumaanvraag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvdataleeftijdscategorie)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/fd388c7c179885befa6ce87fe8587138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvverwijzercontactgegevens;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvverwijzercontactgegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verwijzercontactgegevens.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty(___arguments.context.pageData, 'filtercentra')),'\' AND verwijzercontactgegevens is not null'].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['centra', 'dossier', 'verwijzercontactgegevens', 'naam', 'emailgv', 'date(created) as aanmaakdatum', 'aanmaakmaand', 'aanmaakjaar'],[`columnsMapping`]: undefined,[`sortBy`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'dossier', 'verwijzercontactgegevens', 'naam', 'emailgv', 'aanmaakdatum', 'aanmaakmaand', 'aanmaakjaar'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvverwijzercontactgegevens)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/9148f8340534e178dfa810f848383388/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvOnderzoeksdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvOnderzoeksdata = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/onderzoeksdata.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['activiteit=\'consult zorgvrager\'',' AND consultinwdoelgroep =\'50+\'',' AND financieringvws=\'Ja\'',' AND created >= 1767222000000 AND created < 1790805600000'].join(''),[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['centra', 'activiteit', 'dossier', 'registratienummer', 'date(datumconsult) as consultdatum', 'date(created) as created', 'consultinwleeftijd', 'date(geboortedatum) as geboortedatum1', 'consultinwgeboortejaar', 'hulpvraag', 'consultthemas', 'quote'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['centra', 'activiteit', 'dossier', 'registratienummer', 'consultdatum', 'created', 'consultinwleeftijd', 'geboortedatum1', 'consultinwgeboortejaar', 'hulpvraag', 'consultthemas', 'quote'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvOnderzoeksdata)), true, undefined);
  await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/onderzoeksdata.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plexports/components/d598ff1d72880c48a9e82c4831e83758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierdatacreated, dossiers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dossiers = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['activiteit=\'consult zorgvrager\'',' AND consultinwdoelgroep =\'50+\'',' AND created >= 1767222000000 AND created < 1790805600000'].join('')),'properties': ['dossier'] })).map(async item => {; return (getObjectProperty(item, 'dossier'));})));
  ___arguments.context.pageData['dossierslist'] = (dossiers.join('\',\''));
  dossierdatacreated = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/dossierdatacreated.csv','tableName': 'dossiers','tableOptions': ({ [`where`]: ['dossier IN(\'',(getObjectProperty(___arguments.context.pageData, 'dossierslist')),'\')'].join(''),[`relations`]: undefined,[`groupBy`]: 'dossier',[`pageSize`]: undefined,[`properties`]: ['dossier', 'date(created) as created'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dossier', 'created'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(dossierdatacreated)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause(([' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'ENABLED\' AND',' GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else if (false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'GV\' AND',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'VW\' AND',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'PL\' AND',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'ENABLED\' AND',' GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }
  ___arguments.context.pageData['btwplichtig'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fea0adc46aae868d8b5f843c8aae9c2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/7836af74b96eaf0fc8f1b77d91fd4125/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dashboardnaam')),'label': (getObjectProperty(item, 'dashboardnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/38b45228c9ab1108f4319b04e5df558f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f24bb6b6ee8444046dfd4b245e7a6503')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/d0ab53412e941c4725f9135d79ebe1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) == null) {
    (function (message) { alert(message) })('Er is geen dashboardnaam geselecteerd.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dashboardnaamopvragen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dashboardnaam': (getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) }), undefined);
    (function (message) { alert(message) })('Het verzoek is verzonden. U ontvangt zo snel mogelijk bericht.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'GV')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0972e5824ad68dc30fb528fe7d2eb9a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regiogv')) == null) {
    (function (message) { alert(message) })('De regio dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'aanmaakdatum')) == null) {
    (function (message) { alert(message) })('De datum dient ingevuld te worden');
  } else {
    await Backendless.Data.of('newuserrequests').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmaakdatum`]: (getObjectProperty(___arguments.context.pageData, 'aanmaakdatum')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`GV`]: (getObjectProperty(___arguments.context.pageData, 'GV')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`regiogv`]: (getObjectProperty(___arguments.context.pageData, 'regiogv')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),[`btwinclcoaching`]: (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),[`btwinclmdopatz`]: (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')),[`drechtstedenorganisatietarief`]: (getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietarief')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aanmaakdatum`]: (getObjectProperty(___arguments.context.pageData, 'aanmaakdatum')) }), undefined);
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`gv`]: (getObjectProperty(___arguments.context.pageData, 'GV')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`regiogv`]: (getObjectProperty(___arguments.context.pageData, 'regiogv')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),[`btwinclcoaching`]: (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),[`btwinclmdopatz`]: (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')),[`drechtstedenorganisatietarief`]: (getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietarief')) }) );
    ___arguments.context.pageData['GV'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['regiogv'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    ___arguments.context.pageData['btwinclconsulten'] = false;
    ___arguments.context.pageData['btwinclconsultenselect'] = false;
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
    ___arguments.context.pageData['btwinclgroepsconsultenselect'] = false;
    ___arguments.context.pageData['btwinclmdopatz'] = false;
    ___arguments.context.pageData['btwinclmdopatzselect'] = false;
    ___arguments.context.pageData['btwinclscholing'] = false;
    ___arguments.context.pageData['btwinclscholingselect'] = false;
    ___arguments.context.pageData['btwinclcoaching'] = false;
    ___arguments.context.pageData['btwinclcoachingselect'] = false;
    ___arguments.context.pageData['drechtstedenorganisatietariefselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('32a636293b6874189222b14edd687938');
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/beb80b15f265c7764dc6ae77491c7109/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == true) {
    ___arguments.context.pageData['btwinclscholing'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == false) {
    ___arguments.context.pageData['btwinclscholing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/45f607e2ccd2bfa5f3f27eb7785cd294/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/cd95b1a4af05c934e2bda1e92be60f47/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/529a64226faf1bd297452bb48e4e1226/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == true) {
    ___arguments.context.pageData['btwinclcoaching'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == false) {
    ___arguments.context.pageData['btwinclcoaching'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/cc464e9ed7efa588fd3aa1014bc49261/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == true) {
    ___arguments.context.pageData['btwinclmdopatz'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == false) {
    ___arguments.context.pageData['btwinclmdopatz'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['btwplichtig'] = false;
  ___arguments.context.pageData['btwinclconsulten'] = false;
  ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
  ___arguments.context.pageData['btwinclmdopatz'] = false;
  ___arguments.context.pageData['btwinclscholing'] = false;
  ___arguments.context.pageData['btwinclcoaching'] = false;
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/e031c83c1f6df2a433fe0185674839c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgegevensgv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/726d8f6221befee38d376c1d9434d3be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/bdc9b7aea44c1baad0228c23722400b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/9b9d6494a40e5b2eba2828497fa6f7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/d54d70db830f71c83111b66fcc5219f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/64b7288d8b58a322ef3183993b045f47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/ad6412ecf6fda10770b858134724555a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/0d52797bcfe8ea42a0a3281353d9cdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['datum'] = (new Intl.DateTimeFormat('de', undefined).format((new Date((___arguments.value.valueOf())))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/f595dcdd6cd1f2cb7bf4a585988e8137/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdirectdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'organisatie')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'Aanvraag tot deactiveren',[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'organisatie')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')) }) );
  await Backendless.Request.post(`${Backendless.appPath}/services/deactivatiedatum/deactivatiedatum`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'username': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')),'datumaanvraagdeactivatie': (new Intl.DateTimeFormat('de', undefined).format((new Date()))) });
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
  }
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fea0adc46aae868d8b5f843c8aae9c2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/272a64f4964aa86ddc119c4a23e71ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('selecteer eerst de datum waarop de gebruiker gedeactiveerd moet worden.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'organisatie')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'Aanvraag tot deactiveren',[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'organisatie')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')) }) );
    await Backendless.Request.post(`${Backendless.appPath}/services/deactivatiedatum/deactivatiedatum`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'username': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'username')),'datumaanvraagdeactivatie': (new Intl.DateTimeFormat('de', undefined).format((new Date()))) });
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR ',' regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' OR regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),'%\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\' AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'GV\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'VW\' OR ','centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND GV=\'PL\''].join(''))).setProperties(['dashboardnaam', 'naam', 'organisatie', 'GV', 'username', 'userStatus', 'lastLogin', 'btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'datumaanvraagdeactivatie']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));
    }
    (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7fea0adc46aae868d8b5f843c8aae9c2'), 'naam')),' is verzonden. Wij zullen deze gebruiker op inactief zetten op de aangegeven datum. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7fea0adc46aae868d8b5f843c8aae9c2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/00e871e4ee7aa3d2624f59135b1c0f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['aanmaakdatum'] = (new Intl.DateTimeFormat('de', undefined).format((new Date((___arguments.value.valueOf())))));

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/df7afdcdca67b436fe2c1091891e4709/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/adf64fb727a5c7e1e85ddb190e4ea6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietariefselect')) == true) {
    ___arguments.context.pageData['drechtstedenorganisatietarief'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietariefselect')) == false) {
    ___arguments.context.pageData['drechtstedenorganisatietarief'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgebruikersbeheer/components/32a636293b6874189222b14edd687938/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['useraangemaakt = 0 AND centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/plgegevensgv/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgegevensgv/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgegevensgv/components/3bb1787db7d31e1cd32c5c97d6bda56d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var centra, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    centra = 'Ge';
    filter = ['centra=\'',centra,'\' AND regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND GV=\'','GV','\' OR centra=\'',centra,'\' AND regiogv LIKE \'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'%\' AND GV=\'','VW','\''].join('');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    centra = 'Wi';
    filter = ['centra=\'',centra,'\' AND GV=\'GV\' ',' OR centra=\'',centra,'\' AND GV=\'VW\''].join('');
  }

  return filter

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/plgegevensgv/components/54c652956d82b0e491715fe2cbad4c58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75111bc6ee571d611e4fcb2cb0393644', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54c652956d82b0e491715fe2cbad4c58', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75111bc6ee571d611e4fcb2cb0393644', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('54c652956d82b0e491715fe2cbad4c58', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plgegevensgv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('271f7c82664738d1802ac79e7d2f1e4c', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/c0218a7ef4e5c0863d6ae05a28b8c831/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/2791a0ca370dc7f88a3a3fa7d2c7e223/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/184a625c154e468ed743539657cd8648/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/dcc323eb2d81d61e063569190622e1cc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/5d7c0ca34a312b6cef9d264e9647edcd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/8ea9dba609abd5d8f9ec07b800098c92/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/1325293a5a9349a384ba2e6fbc2dec4e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plgegevenspenvoerder/components/edff71c9c834fb678f55ab57b4f534e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('gegevenspenvoerder').save( ___arguments.context.getComponentDataStoreByUid('a001d3748a9b3bd797db5877fc4e821a') );

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc9e24fd47986118ccb823a82018cbfe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92fe59515c1b4b944e99d90ef90ebf1e', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc9e24fd47986118ccb823a82018cbfe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 1,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 0,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')) }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 1 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 'Alles akkoord gegeven',[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: 0 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: 'Alles akkoord geven uitgevinkt',[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naamgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92fe59515c1b4b944e99d90ef90ebf1e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2),'\''].join(''))).setProperties(['username', 'objectId']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandakkoord/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordgelderland', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Rotterdam') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordrotterdam', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZHN') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordzhn', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordlimburg', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Questio') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordquestio', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordwillem', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordbrabant', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordzinvol', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordoverijssel', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordutrecht', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'maand')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`emailgv`]: (getObjectProperty(___arguments.context.pageData, 'emailgv')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  }
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Overijssel/Flevoland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Zuid West Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Lorio',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Midden Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Gelderland',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar D3rde Verdieping voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Willem',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar CvL Willem voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Limburg',' is akkoord bevonden door de coördinatoren. Dit maandoverzicht zal worden verzonden naar de budgethouder voor uitbetaling. '].join('');
  } else {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',(getObjectProperty(___arguments.context.pageData, 'centra')),' is akkoord bevonden om te factureren\'.'].join('');
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc9e24fd47986118ccb823a82018cbfe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc9e24fd47986118ccb823a82018cbfe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc9e24fd47986118ccb823a82018cbfe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/cb06360bb256741837e7033a108a29dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandfactuurontvangen')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND naam=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'\''].join('')), ({ 'maandfactuurontvangen': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandfactuurontvangen')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND naam=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'\''].join('')), ({ 'maandfactuurontvangen': 0 }) );
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoord/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/8432f0afc5f43f1c9b79b1fcad8c6f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/43a9c286ec2ef4a2fd880e7e12743e68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/a9edf8c4a184d21cc6ec3b7682f864a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/e485801bd41f2fbc7bf9c969640facbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvfilebrabant, csvFileGelderland, csvfileutrecht, csvfilewillem, csvfilezhn, csvmaandakkoordutrecht, csvoverijssel, csvrotterdam, letters, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function maandoverzichtutrecht() {
  csvmaandakkoordutrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandakkoordutrecht.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centraname=\'','Utrecht','\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['regiogv', 'maand', 'naam', 'organisatie', 'totaalbedrag', 'maandakkoord'],[`columnsMapping`]: ({ [`regiogv`]: 'Regio gv',[`maand`]: 'Maand',[`naam`]: 'Naam',[`organisatie`]: 'Organisatie',[`totaalbedrag`]: 'Totaalbedrag',[`maandakkoord`]: 'Maandoverzicht akkoord?' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Regio gv', 'Maand', 'Naam', 'Organisatie', 'Totaalbedrag', 'Maandoverzicht akkoord?'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandakkoordutrecht)), true, undefined);
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    letters = 'Of';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    letters = 'Mn';
  } else {
    letters = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2);
  }
  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',letters,'\' AND registraties.maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['tennamevaniban', 'ibannummer', 'Sum(registraties.totaalbedrag)/10000 as totaalbedrag', 'registraties.maand as maand', 'registraties.naam as naam', 'registraties.organisatie as organisatie', 'bic']).excludeProperties(['consultinwdoelgroep', 'maandfactuurontvangen', 'reistijdminutentotaalbedrag', 'organisatie']).setSortBy('registraties.naam').setGroupBy('registraties.username').setPageSize(100)));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    await Backendless.Data.of('verzamelbetalinggelderland').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalinggelderland').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileGelderland = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalinggelderland.csv','tableName': 'verzamelbetalinggelderland','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['ibannummer', 'bic', 'totaalbedrag', 'tennamevaniban', 'omschrijving'],[`columnsMapping`]: ({ [`ibannummer`]: 'IBAN begunstigde',[`bic`]: 'BIC code',[`totaalbedrag`]: 'Bedrag',[`tennamevaniban`]: 'Naam begunstigde',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['IBAN begunstigde', 'BIC code', 'Bedrag', 'Naam begunstigde', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFileGelderland)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Gelderland'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling Gelderland',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await Backendless.Data.of('verzamelbetalingwillem').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingwillem').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvfilewillem = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingwillem.csv','tableName': 'verzamelbetalingwillem','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfilewillem)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Willem'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling Willem',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    await Backendless.Data.of('verzamelbetalingutrecht').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingutrecht').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvfileutrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingutrechtt.csv','tableName': 'verzamelbetalingutrecht','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfileutrecht)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Utrecht'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling Utrecht',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    await Backendless.Data.of('verzamelbetalingzhn').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingzhn').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvfilezhn = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingzhn.csv','tableName': 'verzamelbetalingzhn','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfilezhn)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling ZHN'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling ZHN',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    await Backendless.Data.of('verzamelbetalingbrabant').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingbrabant').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvfilebrabant = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingbrabant.csv','tableName': 'verzamelbetalingbrabant','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfilebrabant)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Brabant'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling Brabant',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    await Backendless.Data.of('verzamelbetalingrotterdam').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingrotterdam').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvrotterdam = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingrotterdam.csv','tableName': 'verzamelbetalingrotterdam','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvrotterdam)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Rotterdam'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling Rotterdam',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    await Backendless.Data.of('verzamelbetalingoverijssel').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingoverijssel').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvoverijssel = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalingoverijssel.csv','tableName': 'verzamelbetalingoverijssel','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvoverijssel)), true, undefined);
    Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling Overijssel'].join('')));
    await Backendless.Data.of('historieloginternlorio').save( ({ [`pagina`]: 'plmaandakkoord',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export verzamelbetaling OVerijssel',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/9f1e1421e25f0c443946fbfae916a8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, list, registratiesobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud_11_03_2026() {
  await Backendless.Data.of('factuurgegevens').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registraties'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('factuurgegevens').setRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandakkoord/components/54dcc589b52e366cad6db3ac8e7e40b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = ((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND maandakkoord =1'].join(''))).setProperties('emailgv').setGroupBy('emailgv').setPageSize(100))).map(item => item['emailgv']));
  ___arguments.context.pageData['bcc'] = (list.join(','));
  ___arguments.context.pageData['massiveemailgvakkoord'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/b5d1d70aea3fec3d771865fe3b2d42ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Overijssel/Flevoland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Zuid West Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Lorio',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Midden Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Gelderland',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar D3rde Verdieping voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Willem',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar CvL Willem voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Limburg',' is akkoord bevonden door de coördinatoren. Dit maandoverzicht zal worden verzonden naar de budgethouder voor uitbetaling. '].join('');
  } else {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),' is akkoord bevonden om te factureren\'.'].join('');
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/430ce639c79bc455b3338747797f5559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordgelderland', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordquestio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordzhn', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordlimburg', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordwillem', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordbrabant', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordzinvol', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordrotterdam', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordoverijssel', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordutrecht', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ [`centra`]: name2,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgvakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  }
  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND maandakkoord =1'].join('')), ({ [`akkoordmaandoverzichtmail`]: 1 }) );
  ___arguments.context.pageData['massiveemailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  ___arguments.context.pageData['massiveemailgvakkoord'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/bc71d6760a6e2c9a59ae7ac2f83a1816/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandakkoordutrecht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandakkoordutrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'maandakkoordutrecht.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Utrecht','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'username',[`pageSize`]: undefined,[`properties`]: ['regiogv', 'maand', 'naam', 'organisatie', 'Sum(totaalbedrag)/10000 as totaal', 'maandakkoord'],[`columnsMapping`]: ({ [`regiogv`]: 'Regio gv',[`maand`]: 'Maand',[`naam`]: 'Naam',[`organisatie`]: 'Organisatie',[`totaal`]: 'Totaalbedrag',[`maandakkoord`]: 'Maandoverzicht akkoord?' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Regio gv', 'Maand', 'Naam', 'Organisatie', 'Totaalbedrag', 'Maandoverzicht akkoord?'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandakkoordutrecht)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/3d5b77d4cdba31082a5bbf9a2dcc316c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/c3ecc43a5d1538e9ddaff9b715017a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (((await Backendless.UserService.getUserRoles()).includes('Lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoord/components/452bbf5bdaaaee79f3a4d8d3be954f9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1SbmR5RIdy70n4XB7sBobEAZNae493TGIWReCLM4bbSw/edit?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoord/components/84e840467b580058a9441c317db8261e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND jaar >2023'].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 1,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 0,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')) }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 1 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 'Alles akkoord gegeven','naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naamgv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 0 }) );
    await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 'Alles akkoord geven uitgevinkt','naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naamgv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92fe59515c1b4b944e99d90ef90ebf1e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2),'\''].join(''))).setProperties(['username', 'objectId']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordgelderlandnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordwillemnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  }
  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',(getObjectProperty(___arguments.context.pageData, 'centra')),' is akkoord bevonden om te factureren\'.'].join('');
  if (false) {
    if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Overijssel/Flevoland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Zuid West Nederland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Lorio',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Midden Nederland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Gelderland',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar D3rde Verdieping voor uitbetaling. '].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Willem',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar CvL Willem voor uitbetaling. '].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Limburg',' is akkoord bevonden door de coördinatoren. Dit maandoverzicht zal worden verzonden naar de budgethouder voor uitbetaling. '].join('');
    } else {
    }
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/43a9c286ec2ef4a2fd880e7e12743e68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/a9edf8c4a184d21cc6ec3b7682f864a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/e485801bd41f2fbc7bf9c969640facbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandakkoordutrecht, csvfilewillem, list, csvFileGelderland;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2),'\' AND registraties.maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['tennamevaniban', 'ibannummer', 'Sum(registraties.totaalbedrag)/10000 as totaalbedrag', 'registraties.maand as maand', 'registraties.naam as naam', 'registraties.organisatie as organisatie']).setRelated(['registraties']).setSortBy('registraties.naam').setGroupBy('registraties.username').setPageSize(100)));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    await Backendless.Data.of('verzamelbetalinggelderland').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalinggelderland').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvFileGelderland = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetalinggelderland.csv','tableName': 'verzamelbetalinggelderland','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFileGelderland)), true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await Backendless.Data.of('verzamelbetalingwillem').bulkDelete( 'objectId is not null' );
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Backendless.Data.of('verzamelbetalingwillem').bulkCreate( list );
    await new Promise(r => setTimeout(r, 1000 || 0));
    csvfilewillem = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'verzamelbetalingwillem.csv','tableName': 'verzamelbetalingwillem','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvfilewillem)), true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    csvmaandakkoordutrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'maandakkoordutrecht.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centraname=\'','Utrecht','\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['regiogv', 'maand', 'naam', 'organisatie', 'totaalbedrag', 'maandakkoord'],[`columnsMapping`]: ({ [`regiogv`]: 'Regio gv',[`maand`]: 'Maand',[`naam`]: 'Naam',[`organisatie`]: 'Organisatie',[`totaalbedrag`]: 'Totaalbedrag',[`maandakkoord`]: 'Maandoverzicht akkoord?' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Regio gv', 'Maand', 'Naam', 'Organisatie', 'Totaalbedrag', 'Maandoverzicht akkoord?'] }) }));
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandakkoordutrecht)), true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/9f1e1421e25f0c443946fbfae916a8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var countusers, factuurgegevensobjectId, factuurgegevensusername, i, j, list, number, registratiesobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registraties'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('factuurgegevens').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/54dcc589b52e366cad6db3ac8e7e40b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = ((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND maandakkoord =1'].join(''))).setProperties('emailgv').setGroupBy('emailgv').setPageSize(100))).map(item => item['emailgv']));
  ___arguments.context.pageData['bcc'] = (list.join(','));
  ___arguments.context.pageData['massiveemailgvakkoord'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/b5d1d70aea3fec3d771865fe3b2d42ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),' is akkoord bevonden om te factureren\'.'].join('');
  if (false) {
    if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Overijssel/Flevoland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Zuid West Nederland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Lorio',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Midden Nederland',' is akkoord bevonden om te factureren\'.'].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Gelderland',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar D3rde Verdieping voor uitbetaling. '].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Willem',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar CvL Willem voor uitbetaling. '].join('');
    } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
      emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van CvL ','Limburg',' is akkoord bevonden door de coördinatoren. Dit maandoverzicht zal worden verzonden naar de budgethouder voor uitbetaling. '].join('');
    } else {
    }
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/430ce639c79bc455b3338747797f5559/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordgelderlandnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordwillemnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordnietdeclarabel', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: cc, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcc')), query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'massiveemailgvakkoord')) }), undefined);
  }
  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND maandakkoord =1'].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['massiveemailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a59966a9dc27bfce39f142af2d1b5ef', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  ___arguments.context.pageData['massiveemailgvakkoord'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/bc71d6760a6e2c9a59ae7ac2f83a1816/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvmaandakkoordutrecht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvmaandakkoordutrecht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/maandakkoordutrecht.csv','tableName': 'registraties','tableOptions': ({ [`where`]: ['centra=\'','Utrecht','\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: 'username',[`pageSize`]: undefined,[`properties`]: ['regiogv', 'maand', 'naam', 'organisatie', 'Sum(totaalbedrag)/10000 as totaal', 'maandakkoord'],[`columnsMapping`]: ({ [`regiogv`]: 'Regio gv',[`maand`]: 'Maand',[`naam`]: 'Naam',[`organisatie`]: 'Organisatie',[`totaal`]: 'Totaalbedrag',[`maandakkoord`]: 'Maandoverzicht akkoord?' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Regio gv', 'Maand', 'Naam', 'Organisatie', 'Totaalbedrag', 'Maandoverzicht akkoord?'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvmaandakkoordutrecht)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/c3ecc43a5d1538e9ddaff9b715017a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempl' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogelderlandpl' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordnietdeclarabel/components/452bbf5bdaaaee79f3a4d8d3be954f9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1SbmR5RIdy70n4XB7sBobEAZNae493TGIWReCLM4bbSw/edit?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6fb89da1763d241aeffe4156002eaf18', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92fe59515c1b4b944e99d90ef90ebf1e', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2),'\''].join(''))).setProperties(['username', 'objectId']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/062d7e44407dbea7ab5c0a2d3c430ffa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    ___arguments.context.pageData['emailgvakkoord'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', true);
    ___arguments.context.pageData['centra'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'centra'));
    ___arguments.context.pageData['maand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
    ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
  } else {
    (function (message) { alert(message) })('Een mail kan enkel verstuurd worden wanneer de facturatie akkoord is bevonden.');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'akkoordmaandoverzichtmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('062d7e44407dbea7ab5c0a2d3c430ffa'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/856c06addc66ff05c31fc17b9de4fff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, cc, emailreactie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else {
    name2 = (getObjectProperty(___arguments.context.pageData, 'centra'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordgelderland', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordlimburg', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordwillem', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'centra': name2,'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'emailgv': (getObjectProperty(___arguments.context.pageData, 'emailgv')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'emailgvakkoord': (getObjectProperty(___arguments.context.pageData, 'emailgvakkoord')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  }
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\' ',' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join('')), ({ 'akkoordmaandoverzichtmail': 1 }) );
  ___arguments.context.pageData['emailgvakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/c5d6dc631ab3f2b30066aba14eab593f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var emailtext, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Overijssel/Flevoland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Zuid West Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Lorio') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Lorio',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Midden Nederland',' is akkoord bevonden om te factureren\'.'].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Gelderland',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar D3rde Verdieping voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Willem',' is akkoord bevonden. De factuur zal binnenkort worden opgemaakt en de verzamelbetaling wordt verzonden naar CvL Willem voor uitbetaling. '].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ','Limburg',' is akkoord bevonden door de coördinatoren. Dit maandoverzicht zal worden verzonden naar de budgethouder voor uitbetaling. '].join('');
  } else {
    emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'maand')),' van CvL ',(getObjectProperty(___arguments.context.pageData, 'centra')),' is akkoord bevonden om te factureren\'.'].join('');
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/40ce3f780fcec1698f5558874e142b06/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND gebruiker <> \'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/f6b78c1722484bf1f259e6658a0bc4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail', 'organisatie', 'regiogv']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/1d6f17696155a42644f8f28ac465849a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/cb06360bb256741837e7033a108a29dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandfactuurontvangen')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND naam=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'\''].join('')), ({ 'maandfactuurontvangen': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandfactuurontvangen')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maand')),'\' AND naam=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam')),'\''].join('')), ({ 'maandfactuurontvangen': 0 }) );
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/9a3e33ea0eb52e5a0e85a56d855d92f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Willem' || ((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/5e820215092885fa83388558ebdc36c2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;


  if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'ZWNL') {
    name2 = 'Zuid West Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Lorio') {
    name2 = 'Nederland';
  } else if ((___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']) == 'Utrecht') {
    name2 = 'Midden Nederland';
  } else {
    name2 = (___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['centra']);
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/f7b9665bd70bd39915b7f2ae96cba695/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'emailgv'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.pageData, 'subject')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'replyall': 'Als u op deze mail reageert, gebruik dan reply all/ allen beantwoorden.','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'ondertekening': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/95b53c5514f5866ef35dbc06cf32ba4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/8432f0afc5f43f1c9b79b1fcad8c6f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/43a9c286ec2ef4a2fd880e7e12743e68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/a9edf8c4a184d21cc6ec3b7682f864a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/e485801bd41f2fbc7bf9c969640facbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')).slice(0, 2),'\' AND registraties.maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['registraties.maand', 'registraties.naam', 'registraties.maandakkoord', 'registraties.emailgv', 'Sum(registraties.totaalbedrag) as totaalbedrag', 'registraties.maandakkoordgv', 'registraties.maandfactuurontvangen', 'registraties.username', 'registraties.akkoordmaandoverzichtmail', 'registraties.organisatie', 'registraties.regiogv', 'ibannummer', 'tennamevaniban']).setRelated(['registraties']).setSortBy('registraties.naam').setGroupBy('registraties.username').setPageSize(100)));
  (function (message) { alert(message) })((JSON.stringify(list)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandakkoordtest/components/9f1e1421e25f0c443946fbfae916a8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var countusers, factuurgegevensobjectId, factuurgegevensusername, i, j, list, number, registratiesobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registraties'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('factuurgegevens').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrole/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrole/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5edb617417f60149c5c334cf391f4ad', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatorschap') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb6ad6a60c5b35dfc43bc90f28584559', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrole',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraagregistratie`]: (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  ___arguments.context.pageData['emailvraagregistratie'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5edb617417f60149c5c334cf391f4ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb6ad6a60c5b35dfc43bc90f28584559', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, D, E, F, G, H, I, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
  } else {
    J = 'Dossiernummers besproken cliënten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;



  return (await (async () => {
  async function callback (item) {
      if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


    return ((item['title']) != A && (item['title']) != B);
  }

  const list = await Promise.all((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903'))['columns']).map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
})())

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrole/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filteractiviteit'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filternaamgv'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminuten'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (item['regio']),'label': (item['regio']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterregio'] = '%';
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossier')),'label': (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrole/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterdossier'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/914138c4df9998e8ecf5775fe55e0397/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/c05b0f2bddb1f50c40b1c0db6aa94dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/982a348440022ec21215d66e0da55406/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/1197530df5b50a5a864cc8e5347cf79f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/1737d937bcfc2a72678cf687f9443e2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportdrechtsteden/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdkm`]: 'Aantal km',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Aantal km', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/e7bebb06558ec52f24374a2b5ebb5249/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/3a34a50f4b7b60775fb25529c7d8aacb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrole/components/93cb79ee716f4159521d8ed702cbcb05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round(100 * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossiergewerkteminuten'))) / 100)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrole/components/1fc7c32a17e37f041d0dd51609c5ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round(100 * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'gewerkteminuten'))) / 100)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('81ec31590cd591f14113e386cd2edd2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3e813fccc295c651fcdcc4961a2b191d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4c56e93267816eb3e12675ebd8a141f', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e97e183704d659389b1e6ef9ee9cc8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11e40b9f6e62202f874e96d99e76621', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Triage/intake') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cdc86af86a1267802ce1be4ba9b2e23', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b4e20854c966a2a48dbf47941db72be', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolequestio',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'wijziging': (getObjectProperty(___arguments.context.pageData, 'emaillorio')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2,'email2': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3e813fccc295c651fcdcc4961a2b191d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4c56e93267816eb3e12675ebd8a141f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('81ec31590cd591f14113e386cd2edd2d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13e97e183704d659389b1e6ef9ee9cc8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f11e40b9f6e62202f874e96d99e76621', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/eb6dc28ce7a83449c2d7c56c1f9a6454/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminuten'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (item['regio']),'label': (item['regio']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': ((await Backendless.UserService.getCurrentUser(false))['naam']) }) );
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossier')),'label': (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/577ee52372a7cb57b7c24f7aba464ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    return2 = 'Aantal activiteiten/ gewerkte minuten op dit dossier';
  } else {
    return2 = 'Aantal gewerkte minuten op dit dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/4d796f8d166b724777c90985c4b22062/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing') {
    return2 = 'Scholing';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    return2 = 'Moreel beraad';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/7053b1af41ec1dd52f4f01c232144c89/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'updatepakketminutenakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.dataModel, 'pakketminutenakkoord')) }) );
    ___arguments.context.pageData['updatepakketminutenakkoord'] = false;
    ___arguments.context.pageData['spinner'] = false;
  }
}

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/0b659686bec4e23f699a25d8d19a880b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/b5692edeb7c9c93ba091339566aa3844/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/3666e0becb1e967cf2faf624d3ed662f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3666e0becb1e967cf2faf624d3ed662f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/352659ce7466f3bc58b68451a2b8936f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bcc5e521ef997d87ff957574b0f952b4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc5e521ef997d87ff957574b0f952b4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc5e521ef997d87ff957574b0f952b4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/483ec01771a772bef9e9aa2d193b750c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebrabant/components/93cb79ee716f4159521d8ed702cbcb05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossiergewerkteminuten'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, registratienummerlijst;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  registratienummerlijst = (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) }));
  ___arguments.context.pageData['registratienummerlijst'] = (await Promise.all(registratienummerlijst.map(async item => {; return ({ [`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`dossier`]: (getObjectProperty(item, 'dossiernummer')) });})));
  console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'registratienummerlijst')), 'registratienummer'));
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var set, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    text = 'Reistijd in minuten 2022';
  } else {
    text = 'Reistijd in minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    await ( async function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    J = 'Dossiernummer cliënt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossier')),[`label`]: (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/914138c4df9998e8ecf5775fe55e0397/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/c05b0f2bddb1f50c40b1c0db6aa94dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/a4c73be67869969953793d378b3ac379/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/af9fb509c14ff5cd26aff07e7da4eb1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/746da5560802641db99c6b8a295adcef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/16142426c947bd0b58cdf2e78caf0f64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/90a968b440b1941618bc136716f5db5f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Relatie-nummer';
  } else {
    text = 'CvL-kenmerk';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/f8bfa5c15285017158d1bf05a265a2e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/60d50108cd5dbbd2ff0c08013ffe89dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/2323106886cb3c2e2968ee416e834e16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/ad1d7082da0cf9e854c2805f106bda0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/0105023a641b0f32edac24fab9c90bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/25e4916d588bb16c5b163fbaf894cf53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Roterdam') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/e494e355a02328b794c4f2bea68d868f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportoverijssel/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminuten) as reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminuten`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/feea699f1312819b606bf88dc921e882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportwillemgelderland/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdkm`]: 'Aantal km',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Aantal km', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/6b2a84a70d6ed5c786bcd3685f7cadf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportutrecht/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/a06d57c93ca7b01567f494a57afccaa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportrotterdam/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/adb5987db50a8e7453412caf71f4b5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/3847c7521da41681b8c5572c1167b65c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'organisatie')),'label': (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/bfd673b33e4ed60e122616c325ddd6e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND financieringws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/56c8d6b799d6b2237c4dabd3310d22a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierinformatie', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/784b9aa9e4aae59de1165112431bb082/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Gewerkte minuten / activiteiten' : 'Gewerkte minuten')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/982a348440022ec21215d66e0da55406/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/1197530df5b50a5a864cc8e5347cf79f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/577ee52372a7cb57b7c24f7aba464ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Aantal activiteiten / gewerkte minuten op dit dossier' : 'Aantal gewerkte minuten op dit dossier')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/28da36aa2e91b53cb1959a7d27d64878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/a9588c7d9ae2360e7499423821dcba49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/93cb79ee716f4159521d8ed702cbcb05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossiergewerkteminuten'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreed/components/e5c7d98a1d19061c7b8eadc100a6fbc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreedperregistratie', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandcontrolebreed', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    await ( async function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    J = 'Dossiernummer cliënt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filternaamgv'] = '%';
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  await datalijstophalen();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join('')), ({ [`controle`]: true,[`controledatum`]: (new Date()),[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join('')), ({ [`controle`]: false,[`controledatum`]: null,[`controledoor`]: null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossier')),[`label`]: (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterdossier'] = '%';
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/25e4916d588bb16c5b163fbaf894cf53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Roterdam') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/adb5987db50a8e7453412caf71f4b5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/3847c7521da41681b8c5572c1167b65c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'organisatie')),'label': (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/bfd673b33e4ed60e122616c325ddd6e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['spinner'] = true;
  await datalijstophalen();
  await tablellenzichtbaarmaken();
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/56c8d6b799d6b2237c4dabd3310d22a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierinformatie', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/b6d3a2268b922fd746d8b6c4336a2794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  if ((getObjectProperty(___arguments.context.pageData, 'list')) == (await Backendless.Data.of('registraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')))))) {
    (function (message) { alert(message) })('Dit is de laatste registratie in de lijst.');
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 1);
    await datalijstophalen();
    await tablellenzichtbaarmaken();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/2c3a69831d546fed3bcd89c3fe2c0d13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var registratienummerlijst, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function datalijstophalen() {
  registratienummerlijst = (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties(['dossier', 'registratienummer', 'emailgv', 'activiteit', 'controle', 'aantekeningenprojectleider']).setPageSize(1).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))).map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`registratienummer`]: (getObjectProperty(item, 'registratienummer')),[`emailgv`]: (getObjectProperty(item, 'emailgv')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`controle`]: (getObjectProperty(item, 'controle')),[`aantekeningenprojectleider`]: (getObjectProperty(item, 'aantekeningenprojectleider')) });})))[0];
  ___arguments.context.pageData['dossier'] = (getObjectProperty(registratienummerlijst, 'dossier'));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(registratienummerlijst, 'registratienummer'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(registratienummerlijst, 'emailgv'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(registratienummerlijst, 'activiteit'));
  ___arguments.context.pageData['controle'] = (getObjectProperty(registratienummerlijst, 'controle'));
  ___arguments.context.pageData['aantekeningenprojectleider'] = (getObjectProperty(registratienummerlijst, 'aantekeningenprojectleider'));
}

/**
 * Describe this function...
 */
async function tablellenzichtbaarmaken() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.pageData, 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.pageData, 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.pageData, 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.pageData, 'emailgv'));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
    (function (message) { alert(message) })('Dit is de eerste registratie');
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 1);
    await datalijstophalen();
    await tablellenzichtbaarmaken();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/1d4255379335b45183568fd6307e4163/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.pageData, 'registratienummer')),'\''].join('')), ({ [`aantekeningenprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`aantekening`]: (getObjectProperty(___arguments.context.pageData, 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/c3fa2b949379f2bd48b4aeed3d166cf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2463fce7d877732c352cca61d0799b5b')), 'display'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedperregistratie/components/9b780ee4adc482f7e7acbd58c1b61c27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
    return2 = 1;
  } else if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == null) {
    return2 = null;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 1;
  }
  ___arguments.context.pageData['list'] = return2;

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var set, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    text = 'Reistijd in minuten 2022';
  } else {
    text = 'Reistijd in minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    await ( async function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;


  if ((___arguments.context.pageData['emaillorio']) == null) {
    ;await ( async function (message){ alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = ((await Backendless.UserService.getCurrentUser(false))['centraname']);
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: ((await Backendless.UserService.getCurrentUser(false))['email']), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (___arguments.context.pageData['dossier']),'registratienummer': (___arguments.context.pageData['registratienummer']),'activiteit': (___arguments.context.pageData['activiteit']),'wijziging': (___arguments.context.pageData['emaillorio']),'naamprojectleider': ((await Backendless.UserService.getCurrentUser(false))['naam']),'centraname': name2,'email2': ((await Backendless.UserService.getCurrentUser(false))['email']) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossier')),[`label`]: (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/914138c4df9998e8ecf5775fe55e0397/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/c05b0f2bddb1f50c40b1c0db6aa94dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/a4c73be67869969953793d378b3ac379/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/af9fb509c14ff5cd26aff07e7da4eb1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/90a968b440b1941618bc136716f5db5f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Relatie-nummer';
  } else {
    text = 'CvL-kenmerk';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/f8bfa5c15285017158d1bf05a265a2e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/60d50108cd5dbbd2ff0c08013ffe89dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/2323106886cb3c2e2968ee416e834e16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/ad1d7082da0cf9e854c2805f106bda0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/0105023a641b0f32edac24fab9c90bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/25e4916d588bb16c5b163fbaf894cf53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Roterdam') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/e494e355a02328b794c4f2bea68d868f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportoverijssel/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminuten) as reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminuten`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/feea699f1312819b606bf88dc921e882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportwillemgelderland/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdkm`]: 'Aantal km',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Aantal km', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/6b2a84a70d6ed5c786bcd3685f7cadf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportutrecht/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/a06d57c93ca7b01567f494a57afccaa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportrotterdam/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/adb5987db50a8e7453412caf71f4b5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/3847c7521da41681b8c5572c1167b65c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'organisatie')),'label': (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/bfd673b33e4ed60e122616c325ddd6e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/56c8d6b799d6b2237c4dabd3310d22a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierinformatie', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/784b9aa9e4aae59de1165112431bb082/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Gewerkte minuten / activiteiten' : 'Gewerkte minuten')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/982a348440022ec21215d66e0da55406/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/1197530df5b50a5a864cc8e5347cf79f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/577ee52372a7cb57b7c24f7aba464ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Aantal activiteiten / gewerkte minuten op dit dossier' : 'Aantal gewerkte minuten op dit dossier')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/28da36aa2e91b53cb1959a7d27d64878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/a9588c7d9ae2360e7499423821dcba49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedrotterdam/components/93cb79ee716f4159521d8ed702cbcb05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossiergewerkteminuten'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filterorganisatie'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var set, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    text = 'Reistijd in minuten 2022';
  } else {
    text = 'Reistijd in minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.appData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.appData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolebreed',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    await ( async function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var name2;


  if ((___arguments.context.pageData['emaillorio']) == null) {
    ;await ( async function (message){ alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = ((await Backendless.UserService.getCurrentUser(false))['centraname']);
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: ((await Backendless.UserService.getCurrentUser(false))['email']), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (___arguments.context.pageData['dossier']),'registratienummer': (___arguments.context.pageData['registratienummer']),'activiteit': (___arguments.context.pageData['activiteit']),'wijziging': (___arguments.context.pageData['emaillorio']),'naamprojectleider': ((await Backendless.UserService.getCurrentUser(false))['naam']),'centraname': name2,'email2': ((await Backendless.UserService.getCurrentUser(false))['email']) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, item, return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossier')),[`label`]: (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/914138c4df9998e8ecf5775fe55e0397/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/c05b0f2bddb1f50c40b1c0db6aa94dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/a4c73be67869969953793d378b3ac379/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/af9fb509c14ff5cd26aff07e7da4eb1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/746da5560802641db99c6b8a295adcef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/16142426c947bd0b58cdf2e78caf0f64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/90a968b440b1941618bc136716f5db5f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Relatie-nummer';
  } else {
    text = 'CvL-kenmerk';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/f8bfa5c15285017158d1bf05a265a2e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/60d50108cd5dbbd2ff0c08013ffe89dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/2323106886cb3c2e2968ee416e834e16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'anderefinanciering')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'anderefinanciering': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/ad1d7082da0cf9e854c2805f106bda0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/0105023a641b0f32edac24fab9c90bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/25e4916d588bb16c5b163fbaf894cf53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Roterdam') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/e494e355a02328b794c4f2bea68d868f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportoverijssel/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminuten) as reistijdminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminuten`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/feea699f1312819b606bf88dc921e882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportwillemgelderland/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdkm`]: 'Aantal km',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Aantal km', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/6b2a84a70d6ed5c786bcd3685f7cadf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportutrecht/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdminutenspeciaal`]: 'Reistijd in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Reistijd in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/a06d57c93ca7b01567f494a57afccaa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportrotterdam/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: undefined,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFile)), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/adb5987db50a8e7453412caf71f4b5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/3847c7521da41681b8c5572c1167b65c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\''].join(''))).setSortBy('organisatie ASC').setGroupBy('organisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'organisatie')),'label': (getObjectProperty(item, 'organisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\'',' AND financieringvws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/bfd673b33e4ed60e122616c325ddd6e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterorganisatie'] = '%';
  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND organisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterorganisatie')),'\' AND financieringws<>\'Nee\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/56c8d6b799d6b2237c4dabd3310d22a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierinformatie', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/784b9aa9e4aae59de1165112431bb082/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Gewerkte minuten / activiteiten' : 'Gewerkte minuten')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/982a348440022ec21215d66e0da55406/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/1197530df5b50a5a864cc8e5347cf79f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'scholingvoorbereiding')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/577ee52372a7cb57b7c24f7aba464ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true ? 'Aantal activiteiten / gewerkte minuten op dit dossier' : 'Aantal gewerkte minuten op dit dossier')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/28da36aa2e91b53cb1959a7d27d64878/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/a9588c7d9ae2360e7499423821dcba49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolebreedzhn/components/93cb79ee716f4159521d8ed702cbcb05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossiergewerkteminuten'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filterjaar'] = '2026';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d7f47275e6c8ba6c2e1c948e5a86304', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra, financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59e9a0411df3d4ffd56d7d1e0e4fe102', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'Count (activiteit) as aantal', 'jaar', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra,jaar,financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7233cb8f70e055b6a9d4205cbbeb73c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['','centra=\'Drechtsteden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Gelderland\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Limburg\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Overijssel\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Rotterdam\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZHN\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Haaglanden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Zinvol\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Sichtpunt\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a88e298cb16a6fb461b0082a15b72c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'Utrecht\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Willem\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Questio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZWNL\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Brabant\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/c4a3617a3e3d1f1d382124335fa5774e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('71af42d346749886fdec88eb3feaa0ae', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra, financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9f0804357ca8bd888fc8111852e82396', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND centra=\'Limburg\''].join(''))).setProperties(['Sum (reistijdkm) as reistijdkm', 'Sum (totaalminuten) as totaalminuten']).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/f8b5f181cc2cde7d1d682f09b238be73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('registraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['','centra=\'Drechtsteden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Gelderland\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Limburg\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Overijssel\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Rotterdam\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZHN\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Haaglanden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Zinvol\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Sichtpunt\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/d7233cb8f70e055b6a9d4205cbbeb73c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7233cb8f70e055b6a9d4205cbbeb73c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['','centra=\'Drechtsteden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Gelderland\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Limburg\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Overijssel\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Rotterdam\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZHN\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Haaglanden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Zinvol\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Sichtpunt\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/447ac655d1f89c271b925746495f2093/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/f3f9ab0d266ebe5910abcf249ec9ab2a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('registraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'Utrecht\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Willem\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Questio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZWNL\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Brabant\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/6a88e298cb16a6fb461b0082a15b72c9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a88e298cb16a6fb461b0082a15b72c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'Utrecht\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Willem\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Questio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZWNL\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Brabant\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/fd236126d164ba258bc2a5a8319ccd39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/8c99ceb60887341c5e0560fd1c28f5db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a884214ccf96352efee974fbbadbf79e'), 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/d5914b5bfdc28c5d38b6b2ff44ba7ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('registraties').getObjectCount())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/43efa46f55176a5317f8cb76229f7401/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var csvmaandcontroledossiers;



  return (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('centra<>\'Lorio\'') + String(' AND aanmaakjaar <2026')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/fe46debe910eca432dc2de39ed8ad56a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fe46debe910eca432dc2de39ed8ad56a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/1344c326d87317951883eacf779d1d06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/a258780ec1bfc8cbadd332d4a3debc34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3be6515468874f96357a58f72e1b737a'), 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/9f0804357ca8bd888fc8111852e82396/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9f0804357ca8bd888fc8111852e82396', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND centra=\'Limburg\''].join(''))).setProperties(['Sum (reistijdkm) as reistijdkm', 'Sum (totaalminuten) as totaalminuten']).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/9ba8c7389a88f42897a8689785d82213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('20b4fa461752befa5c48a1da7a4ed5b8'), 'reistijdkm')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20b4fa461752befa5c48a1da7a4ed5b8'), 'totaalminuten')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/517867d8a598b993e00b510cabfab111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var stap2, stap1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stap1 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c7e9650808243278358df8c85ed8c648'), 'reistijdkm'));
  stap2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c7e9650808243278358df8c85ed8c648'), 'totaalminuten')) / 60;

  return (stap1 + stap2)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/4b8f48ae9008677a78f88469903b4916/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('dossiersafgesloten').getObjectCount())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/8d087f7a8b682f9b99e39e7bf648e748/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d7f47275e6c8ba6c2e1c948e5a86304', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra, financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59e9a0411df3d4ffd56d7d1e0e4fe102', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'Count (activiteit) as aantal', 'jaar', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra,jaar,financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7233cb8f70e055b6a9d4205cbbeb73c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['','centra=\'Drechtsteden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Gelderland\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Limburg\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Overijssel\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Rotterdam\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZHN\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Haaglanden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Zinvol\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Sichtpunt\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a88e298cb16a6fb461b0082a15b72c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'Utrecht\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Willem\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Questio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZWNL\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Brabant\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/33184938d0080e28013588e503c98448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a12c7d6d3a9825157948b7c1dd38440d'), 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/cb08a0180b88fc6839f8c9d859584e5b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6d7f47275e6c8ba6c2e1c948e5a86304', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra, financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59e9a0411df3d4ffd56d7d1e0e4fe102', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties(['Sum (datatotaalbedrag) as totaal', 'centra', 'Count (activiteit) as aantal', 'jaar', 'financieringsubsidie']).setSortBy('centra ASC').setGroupBy('centra,jaar,financieringsubsidie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7233cb8f70e055b6a9d4205cbbeb73c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['','centra=\'Drechtsteden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Gelderland\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Limburg\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Overijssel\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Rotterdam\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZHN\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Haaglanden\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Zinvol\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Sichtpunt\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a88e298cb16a6fb461b0082a15b72c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'Utrecht\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Willem\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Questio\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'ZWNL\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\' OR centra=\'Brabant\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'filterjaar')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolegegevens/components/4dd7484884e23908abe888c8b77819e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('centra<>\'Lorio\'') + String(' AND aanmaakjaar >=2026')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cb0e91f5f153dd31e11f244d7022d045', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolelimburg',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/839f823dd30d3967b98fb967612acf08/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'update')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')) }) );
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'emailvraagregistratie': (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (getObjectProperty(___arguments.context.pageData, 'dossier')),'registratienummer': (getObjectProperty(___arguments.context.pageData, 'registratienummer')),'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'wijziging': (getObjectProperty(___arguments.context.pageData, 'emaillorio')),'naamprojectleider': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'centraname': name2,'email2': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/eb6dc28ce7a83449c2d7c56c1f9a6454/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A, I, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H && (item['title']) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;



  return (await (async () => {
  async function callback (item) {
      if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


    return ((item['title']) != A && (item['title']) != B);
  }

  const list = await Promise.all((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903'))['columns']).map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
})())

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (item['dossieraanmaker']),'label': (item['dossieraanmaker']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filteractiviteit'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filternaamgv'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminuten'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1' && (JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
    A = 'Leeftijd';
    return2 = (item['title']) != A;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1' && (JSON.parse((___arguments.context.appData['gvgender']))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (item['title']) != A && (item['title']) != B;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '0' && (JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
    A = 'Geboortejaar';
    return2 = (item['title']) != A;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '0' && (JSON.parse((___arguments.context.appData['gvgender']))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (item['title']) != A && (item['title']) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (item['regio']),'label': (item['regio']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterregio'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossier')),'label': (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterdossier'] = '%';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/4fde0138cdb20dc57a14d72c4e25ddc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriolimburgpl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriooverijsselpl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodrechtstedenpl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'lorioutrechtpl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdampl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Loriozwnlpl' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriogelderlandpl' ? true : false))))))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['update'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cb0e91f5f153dd31e11f244d7022d045', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cb0e91f5f153dd31e11f244d7022d045', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cb0e91f5f153dd31e11f244d7022d045')), 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cb0e91f5f153dd31e11f244d7022d045')), 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cb0e91f5f153dd31e11f244d7022d045')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cb0e91f5f153dd31e11f244d7022d045')), 'voorbereidingminuten')) }) );
  ___arguments.context.pageData['update'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/f46ab2814b2e89a7ac746689e1be29b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFile;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvFile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportlimburg/maandcontrole.csv','tableName': 'registraties','tableOptions': ({ [`pageSize`]: 4000,[`where`]: ['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''),[`groupBy`]: 'registratienummer',[`properties`]: ['maand', 'dossier', 'registratienummer', 'activiteit', 'naam', 'consultdatum', 'Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(totaalbedrag)/10000 as totaalbedrag', 'controle', 'aantekeningenprojectleider'],[`columnsMapping`]: ({ [`maand`]: 'Maand',[`dossier`]: 'Dossier',[`registratienummer`]: 'Registratienummer',[`activiteit`]: 'Activiteit',[`naam`]: 'Naam',[`consultdatum`]: 'Datum activiteit',[`gewerkteminuten`]: 'Gewerkte minuten',[`voorbereidingminuten`]: 'Voorbereiding in minuten',[`reistijdkm`]: 'Aantal km',[`totaalbedrag`]: 'Bedrag',[`controle`]: 'Controle gedaan' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Maand', 'Dossier', 'Registratienummer', 'Activiteit', 'Naam', 'Datum activiteit', 'Gewerkte minuten', 'Voorbereiding in minuten', 'Aantal km', 'Bedrag', 'Controle gedaan'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvFile, true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/879746713db24cc514d9f90a87331bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolelimburg/components/ef232efe1eb240c616d83a6f08ffab94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, nietdeclarabeldatalist, item, nietdeclarabeldata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  nietdeclarabeldata = (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) }));
  nietdeclarabeldatalist = (await Promise.all(nietdeclarabeldata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`aantalconsulten`]: (getObjectProperty(item, 'aantalconsulten')),[`gewerkteminuten`]: (getObjectProperty(item, 'gewerkteminuten')),[`voorbereidingminuten`]: (getObjectProperty(item, 'voorbereidingminuten')) });})));
  for (var j_index in nietdeclarabeldatalist) {
    j = nietdeclarabeldatalist[j_index];
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(j, 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(j, 'gewerkteminuten')) + (getObjectProperty(j, 'voorbereidingminuten')) }) );
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten>=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten>=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['financieringnietdeclwerkminuten>=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND created> \'03/31/2024\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult 1') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkactiviteiten') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Ontwikkeluren') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsgesprekken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Presentieactiviteiten') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolenietdeclarabel',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraagregistratie`]: (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')).length == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ 'aantekening': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumaantekening': (new Date()),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1' && (JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
    A = 'Leeftijd';
    return2 = (item['title']) != A;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1' && (JSON.parse((___arguments.context.appData['gvgender']))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (item['title']) != A && (item['title']) != B;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '0' && (JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
    A = 'Geboortejaar';
    return2 = (item['title']) != A;
  } else if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '0' && (JSON.parse((___arguments.context.appData['gvgender']))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (item['title']) != A && (item['title']) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('nietdeclarabel').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == true) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'controle')) == false) {
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossier')),'label': (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/ad1d7082da0cf9e854c2805f106bda0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ [`controle`]: true,[`controledatum`]: (new Date()),[`controledoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten>=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/0105023a641b0f32edac24fab9c90bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepagingnietdeclarabel`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['financieringnietdeclwerkminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/25e4916d588bb16c5b163fbaf894cf53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Roterdam') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/b68276e11eb4ace2d90688ddb1b1beda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/fd48e8f7e29395e2d16c888ecfd8cf6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolenietdeclarabel/components/d6df891bb7f6061e71d45b74959e9159/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
    ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult 1') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkactiviteiten') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Ontwikkeluren') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsgesprekken') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Presentieactiviteiten') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', true);
    }
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f04410381f9b99f17e36f712c0f8fd88', false);

  },
  /* handler:onMouseOut */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var financieringstroom;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    financieringstroom = subsequenceFromStartLast((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'financieringstroom')), 7);
  } else {
    financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'financieringstroom'));
  }

  return financieringstroom

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, dossierdata, dossierlist, dossiers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updatepakketminutenakkoord() {
  dossiers = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'properties': ['dossier'] })).map(async item => {; return (getObjectProperty(item, 'dossier'));})));
  dossierlist = dossiers.join('\',\'');
  dossierdata = (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['dossier IN (\'',dossierlist,'\')'].join('')),'properties': ['dossier', 'pakketminutenakkoord'] }));
  for (var j_index in dossierdata) {
    j = dossierdata[j_index];
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(j, 'pakketminutenakkoord')) }) );
  }
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('81ec31590cd591f14113e386cd2edd2d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3e813fccc295c651fcdcc4961a2b191d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4c56e93267816eb3e12675ebd8a141f', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolequestio',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraagregistratie`]: (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3e813fccc295c651fcdcc4961a2b191d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4c56e93267816eb3e12675ebd8a141f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('81ec31590cd591f14113e386cd2edd2d', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var I, item, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    H = 'CvL';
    I = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider'))) == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ [`centra`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'centra')),[`maand`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'maand')),[`aantekening`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumaantekening`]: (new Date()),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker <> \'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminuten'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND regio LIKE\'',(___arguments.context.pageData['filterregio']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(___arguments.context.pageData['sorteer']) + String(___arguments.context.pageData['sorteerwijze'])),'having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\' AND dossiergewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminutenopdossier']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var return2, B, item, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Leeftijd';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) != '1') {
    A = 'Leeftijd';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '1') {
    A = 'Geboortejaar';
    return2 = (getObjectProperty(item, 'title')) != A;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgender')))) == '0') {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B;
  }


 return return2;
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'',' AND dossieraanmaker LIKE \'',(___arguments.context.pageData['dossiergemaaktdoor']),'\'',' AND dossier LIKE\'',(___arguments.context.pageData['filterdossier']),'\'',' AND gebruiker<>\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (item['regio']),'label': (item['regio']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmaandcontrolestatusdossier')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': ((await Backendless.UserService.getCurrentUser(false))['naam']) }) );
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossier')),[`label`]: (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/acfb1712451a99bd15cf311af42b1c8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/577ee52372a7cb57b7c24f7aba464ccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    return2 = 'Aantal activiteiten/ gewerkte minuten op dit dossier';
  } else {
    return2 = 'Aantal gewerkte minuten op dit dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/4d796f8d166b724777c90985c4b22062/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing') {
    return2 = 'Scholing';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    return2 = 'Moreel beraad';
  } else {
    return2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/7053b1af41ec1dd52f4f01c232144c89/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.pageData, 'updatepakketminutenakkoord')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.dataModel, 'pakketminutenakkoord')) }) );
    ___arguments.context.pageData['updatepakketminutenakkoord'] = false;
    ___arguments.context.pageData['spinner'] = false;
  }
}

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/0b659686bec4e23f699a25d8d19a880b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/b5692edeb7c9c93ba091339566aa3844/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/3666e0becb1e967cf2faf624d3ed662f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3666e0becb1e967cf2faf624d3ed662f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/352659ce7466f3bc58b68451a2b8936f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bcc5e521ef997d87ff957574b0f952b4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc5e521ef997d87ff957574b0f952b4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcc5e521ef997d87ff957574b0f952b4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolequestio/components/cd7e44eedf1a4eb858bb2fbaec0685ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, dossierdata, dossierlist, dossiers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updatepakketminutenakkoord() {
  dossiers = (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'properties': ['dossier'] })).map(async item => {; return (getObjectProperty(item, 'dossier'));})));
  dossierlist = dossiers.join('\',\'');
  dossierdata = (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['dossier IN (\'',dossierlist,'\')'].join('')),'properties': ['dossier', 'pakketminutenakkoord'] }));
  for (var j_index in dossierdata) {
    j = dossierdata[j_index];
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(j, 'pakketminutenakkoord')) }) );
  }
}


  ___arguments.context.pageData['spinner'] = true;
  await updatepakketminutenakkoord();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker<>\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/e69290248fe46c4711ed2252e0cacccf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'','AND gebruiker=\'vrijwilliger\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cb0e91f5f153dd31e11f244d7022d045', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker=\'vrijwilliger\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/3d681d866f17b465e6a8d5428017c9c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['totaalbedrag']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/83a1aac1d824265330de01f8643bbdbb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/fd3d10ec320950db98323951059301bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/f101d2b36c2b8f0e83c105736ae7ef79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['sorteer'] = 'datumconsult';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filteraantalconsulten'] = '1';
  ___arguments.context.pageData['filterwerkminuten'] = '0';
  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND gebruiker=\'vrijwilliger\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/770ffa0e99712cf3fd936e7958c8d76c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/8d652e122b8fda56025e8c560b792986/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/1a58fdfcc8de47078c431b25de095b94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/d65b6052649fdcaa84362fc223610081/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/ae6e27f160c47ea3e89e76185c6c0bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', false);
  ___arguments.context.pageData['registratiefiltertabel'] = (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join(''));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['registratienummer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.context.pageData, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.pageData, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'plmaandcontrolevrijwilligers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/cb0e91f5f153dd31e11f244d7022d045/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/839f823dd30d3967b98fb967612acf08/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/c172bcbc4dad27c969ff8a9c0d739e67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/cdf158ae6b65e13d839df94ceb398976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekregistraties', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraagregistratie`]: (getObjectProperty(___arguments.context.pageData, 'emailvraagregistratie')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2 }), undefined);
    ___arguments.context.pageData['emailvraagregistratie'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/3e59a70b22e6c32d69c848db69afbb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emaillorio')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      name2 = 'Overijssel/Flevoland';
    } else {
      name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    }
    await Backendless.Messaging.sendEmailFromTemplate('wijzigingenlorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.pageData, 'registratienummer')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`wijziging`]: (getObjectProperty(___arguments.context.pageData, 'emaillorio')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centraname`]: name2,[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emaillorio'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/7add732331040a089355e5857245dfad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['emailvraag'] = undefined;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND maand LIKE \'',(___arguments.context.pageData['filtermaand']),'\'','AND gebruiker <> \'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(___arguments.context.pageData['filterwerkminuten']),'\''].join('')) })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/4c3b42aac75c102c135ac7adf38cfd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c3b42aac75c102c135ac7adf38cfd8a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83ebf99b415c838ca4c1810cf2bc8fc9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d91958dc128066ac40ae99e70dcd464', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('219c6f8cbfada4697c0f49f9f75f1b38', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7add732331040a089355e5857245dfad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94ed207140eb43ccc3521581b4a4ea91', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06c11e1d974e1bfcdfc160716eda14a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed03c7d482f21efd2ca9a20656316201', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3161e51fd9110fee1dd30e4b38aab73d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('836daa862bdeb41c1c42a9e6e429892a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2d882e7df86291fee6a9fc26e57bbf4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3baca416872ee0ea33a435b73caa52c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f049498afe144edfe5de53797b1f9b89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f416c6c0d302d289b3621d19334577', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5e76cec257b701292d59a4d44ea31fdd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e7963e77ada35449a2bbf48fb59720a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a32dfdd126c8dfdb9f184b4cd70e70ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdc4ec9635940931f4edb7855c08af6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2044e6dc4c1de3bd906f02bd466373d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aebecbcff4bdf228cb133ad359ce74a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a6fc2bc0f924ac750a9f38b48bd6692', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': 'dossier,datumconsult ASC','having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/eb6dc28ce7a83449c2d7c56c1f9a6454/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/c727900be215682a434726248b5b377e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/064be9d206140f8fa9e665d2341cb17f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, F, E, D, C, B, A, G;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('064be9d206140f8fa9e665d2341cb17f'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1') {
  } else {
    H = 'OV-vergoeding';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/08f425db339da38e79c7118d15e8bee4/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, D, E, F, G, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08f425db339da38e79c7118d15e8bee4'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
  } else {
    G = 'Reistijd in minuten';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/cb496fb8245ca1c3dc8a24e306459393/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb496fb8245ca1c3dc8a24e306459393'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/598e4c7f4fc6b1bc936a33785d6cb647/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('598e4c7f4fc6b1bc936a33785d6cb647'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/9fcf06c1cd91c7cc4e94c4660cd2c187/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9fcf06c1cd91c7cc4e94c4660cd2c187'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/63e285ea87a593d5cdb91cd43153f903/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;



  return (await (async () => {
  async function callback (item) {
      if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }


    return ((item['title']) != A && (item['title']) != B);
  }

  const list = await Promise.all((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('63e285ea87a593d5cdb91cd43153f903'))['columns']).map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
})())

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/aee30f9c1a75a61574e6e835cf1b0261/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aee30f9c1a75a61574e6e835cf1b0261'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/e542a41d4311f64e4e82c6651db9acb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')),'\''].join('')), ({ 'aantekeningenprojectleider': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')).length == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ 'aantekening': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'aantekeningenprojectleider')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumaantekening': (new Date()),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/ae8b4bae38aea7eb105bb80db3a4086b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ae8b4bae38aea7eb105bb80db3a4086b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/7e04f31c7f8dc6b1328528b27e6dcc35/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == null) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#d3d3d3';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 1) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#8CC63F';
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord']) == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e04f31c7f8dc6b1328528b27e6dcc35'))['color'] = '#ff0000';
  }

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/f9c8e98c31ad11f4388954c3234cc5a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND gebruiker=\'vrijwilliger\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/06228b0ab5a848f82d583d14a24df7b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/86ec429d7eb1a032d2b334af0e247e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/7f2472ffd46e07f2824eeb47a90f3a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminuten'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/cf1a799e3f62a65169d7312d596bae64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterwerkminutenopdossier'] = '0';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/fdf9360a9f65c9df11210404952c9566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/bfc7caee6aedf4040733d965c3ac6041/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/cd497bfbda6e2c29f3712cdde5b85df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/64340e7e2e4a47273d6e34f41af7c215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/789fc1087ee7610ce79e3a9c38aac6c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment *//* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/ad916821a1352f9cb065a7829f7788b1/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ad916821a1352f9cb065a7829f7788b1'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
    return2 = (item['title']) != A;
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
    return2 = (item['title']) != A && (item['title']) != B;
  }


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/745c509672170b48ac7d6c7ef8a3a05f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/f57be4949cfcd2075128720b01bfe94d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/36ad11a91d974547af914e521d57001e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/ed197d451b33a0b82699388d12e1a91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['vrijwilligervergoedingov']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/83ebf99b415c838ca4c1810cf2bc8fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0a48283abb6e6721be014a44b04c1d3a')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/414a72ead27b49eda035e4b260fdbc9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/b425e74cba7fd519cf227a5454eb2a35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/e10451da7ab39113b2a3e574365c880b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['plmaandcontrolestatusdossier']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/c075e084249c33889f4793811ea426bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': ((await Backendless.UserService.getCurrentUser(false))['naam']) }) );
  } else if ((___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['controle']) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['registratienummer']),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/563fefa4248f3511e3535082d6dfb886/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/4ffbccb6de3e1d6d64928c529516a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/bb9167d86c26330d2a5deac45ad75243/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Limburg' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/494912af1c8eb9f4c5ecd32d587960de/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': 'dossier ASC','groupBy': 'dossier' })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossier')),'label': (getObjectProperty(item, 'dossier')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/f9eb2a1dd4853e3130b452bc32d52292/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdossier'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND maand LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossier')),'\'',' AND gebruiker=\'vrijwilliger\''].join('')),'sortBy': (String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))),'having': (['gewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminuten')),'\' AND dossiergewerkteminuten >=\'',(getObjectProperty(___arguments.context.pageData, 'filterwerkminutenopdossier')),'\''].join('')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/0c8e8ee605a37a2576717bdfd837fdff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmaandcontrolevrijwilligers/components/d065340a9506c01726ed0976979b28da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/46fd706be85c360dba93a7bd58abf674/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Drechtsteden') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserdrechtstedengv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Limburg') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserlimburggv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Questio') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserquestiogv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Rotterdam') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserrotterdamgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserutrechtgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserwillemgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Gelderland') {
    await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Willem') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserwillemvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Brabant') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserbrabantgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZHN') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzhngv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Haaglanden') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserhaaglandengv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Zinvol') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzinvolgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Zinvol') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzinvolvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centra')) == 'Sichtpunt') {
    await Backendless.Messaging.sendEmailFromTemplate('newusersichtpuntgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'PL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserpl', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  }
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/a5f2894760c25477d98149be945e217d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'centraname')),'label': (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/7671de5e224e3a37f7fc464d67c2a03d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND userStatus = \'ENABLED\''].join(''))).setProperties('username').setSortBy('username DESC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('428a94dc344d207d80f18564426c60cf', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plmailsversturen/components/99be46479d8a7ab7c4faeeebe38b3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailmnl', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccmnl')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Midden Nederland is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/7df41258017331085d290d69b2072f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Utrecht','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccmnl'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/3a89c581d609b849f2113ccb63766105/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailgelderland', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccgelderland')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Gelderland is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/2518b66e4d1f57d49a311c0f1053a072/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Gelderland','\' AND userStatus = \'ENABLED\' AND GV=\'GV\' OR',' centraname=\'','Gelderland','\' AND userStatus = \'ENABLED\' AND GV=\'VW\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccgelderland'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/25347c79cbd76f7bb44d3a8935a3f1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailzwnl', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcczwnl')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Zuid West Nederland is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/ec5aea44b2cf7adbf16e6b4a333ae615/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','ZWNL','\' AND userStatus = \'ENABLED\' AND GV=\'GV\'',' OR centraname=\'','ZWNL','\' AND userStatus = \'ENABLED\' AND GV=\'VW\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcczwnl'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/plmailsversturen/components/c8d46d87c3881df3ec79061f7fa25eba/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Brabant','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccbrabant'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/f35e0505833f61caee1ce0dde9411f59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailbrabant', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccbrabant')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor CvL Midden- & Oost-Brabant is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/70cc6439637fcbd824eadd6efdd64c3b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Drechtsteden','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccdrechtsteden'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/f5b21202a54a1c9722bd06ee72143a03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemaildrechtsteden', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccdrechtsteden')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Drechtsteden is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/713616383b1e457556b5cebe2ff192c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemaillimburg', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcclimburg')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Limburg is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/5eaa19af1852e49d288d72a329b40772/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailoverijssel', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccoverijssel')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Overijssel is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/20a3fe02bd3b8fee0ec56cea0a71e68e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailquestio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccquestio')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Questio is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/299878ada0c5cea4778bc4913e1250bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailrotterdam', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccrotterdam')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Rotterdam is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/5651bd74053bea1a60ce96ef05a79a67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailwillem', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bccwillem')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Willem is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plmailsversturen/components/90ccdaeb79810d4d6fd87d78a8ec9522/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Limburg','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcclimburg'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/437b323961ffef9c7263f678fce96671/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Overijssel','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccoverijssel'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/4e8ddcbf19465bc3685bbcfbe5e8a9fe/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Questio','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccquestio'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/129f99d6d83238bcd4be3c45b1af7a21/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Rotterdam','\' AND userStatus = \'ENABLED\' AND GV=\'GV\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccrotterdam'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/3d0d1ea4bffea2eb4d8b0e617f2589cf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Willem','\' AND userStatus = \'ENABLED\' AND GV=\'GV\' OR',' centraname=\'','Willem','\' AND userStatus = \'ENABLED\' AND GV=\'VW\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bccwillem'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plmailsversturen/components/f8196082b09aed37174eae35cf34bec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('maandelijksemailzinvol', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: (getObjectProperty(___arguments.context.pageData, 'bcczinvol')), query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De maandelijkse mail voor Zinvol is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plmailsversturen/components/f71bed0744eb053ed796e852960ef153/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Zinvol','\' AND userStatus = \'ENABLED\' AND GV=\'GV\'',' OR centraname=\'','Zinvol','\' AND userStatus = \'ENABLED\' AND GV=\'VW\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcczinvol'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plpermissions/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plpermissions/components/f7c8f57aa3d7b5bdbe4a562bebeaa4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'*PL\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV =\'PLGV\' AND userStatus=\'enabled\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var objectid, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  objectid = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectpl')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})))[0];
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(objectid, 'objectId'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/63baa7578bd5431ff8e2ead821598623/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centraname')),[`label`]: (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/03ab6057cbde36042fc98317782a9c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nietdeclarabellist, item, nietdeclarabel, registratieslist, registraties, dossierslist, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in dossierslist) {
        j = dossierslist[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in registratieslist) {
        j = registratieslist[j_index2];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index3 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index3];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index4 in dossierslist) {
        j = dossierslist[j_index4];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index5 in registratieslist) {
        j = registratieslist[j_index5];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index6 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index6];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel dossiers en registraties en nietdeclarabel');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plpermissions/components/5cae597d72458f2e293eeffdd5afd0db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, registratieslist, item, registraties, dossierslist, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND gebruiker=\'vrijwilliger\''].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in dossierslist) {
        j = dossierslist[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND gebruiker=\'vrijwilliger\''].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in registratieslist) {
        j = registratieslist[j_index2];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties');
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index3 in dossierslist) {
        j = dossierslist[j_index3];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index4 in registratieslist) {
        j = registratieslist[j_index4];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel dossiers en registraties');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/dba8ec77e619eb798ade1476cabef118/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/23d5455597ca78df3a132b1e9617a731/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'','Zinvol','\' AND GV =\'PLGV\' AND userStatus=\'enabled\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var objectid, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  objectid = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgvgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`regiogvpl`]: (getObjectProperty(item, 'regiogvpl')) });})))[0];
  ___arguments.context.pageData['userobjectIdgvgv'] = (getObjectProperty(objectid, 'objectId'));
  ___arguments.context.pageData['regiogvpl'] = (getObjectProperty(objectid, 'regiogvpl'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/a2af6f0deea681c421fb4a5c51cc8e14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, nietdeclarabellist, item, nietdeclarabel, j, l, registratieslist, registraties, k, dossierslist, dossiers, regiogvpllist;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectgvgv')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actiegvgv')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actiegvgv')) == 'addpermission') {
      regiogvpllist = (getObjectProperty(___arguments.context.pageData, 'regiogvpl')).split(',');
      for (var j_index in regiogvpllist) {
        j = regiogvpllist[j_index];
        dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var k_index in dossierslist) {
          k = dossierslist[k_index];
          await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
          await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
        }
        registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var l_index in registratieslist) {
          l = registratieslist[l_index];
          await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
          await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
        }
        nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var m_index in nietdeclarabellist) {
          m = nietdeclarabellist[m_index];
          await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
          await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
        }
      }
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
      ___arguments.context.pageData['disablesave'] = false;
    } else if ((getObjectProperty(___arguments.context.pageData, 'actiegvgv')) == 'removepermission') {
      regiogvpllist = (getObjectProperty(___arguments.context.pageData, 'regiogvpl')).split(',');
      for (var j_index2 in regiogvpllist) {
        j = regiogvpllist[j_index2];
        dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var k_index2 in dossierslist) {
          k = dossierslist[k_index2];
          await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
          await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
        }
        registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var l_index2 in registratieslist) {
          l = registratieslist[l_index2];
          await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
          await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
        }
        nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'Zinvol\' AND ','regio=\'',j,'\' '].join('')),'properties': ['objectId'] }));
        nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var m_index2 in nietdeclarabellist) {
          m = nietdeclarabellist[m_index2];
          await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
          await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectIdgvgv')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
        }
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel dossiers en registraties en nietdeclarabel');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/2faa92e168b998faa7a750f9cf7d8ea2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nietdeclarabellist, item, nietdeclarabel, registratieslist, registraties, dossierslist, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in dossierslist) {
        j = dossierslist[j_index];
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in registratieslist) {
        j = registratieslist[j_index2];
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index3 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index3];
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index4 in dossierslist) {
        j = dossierslist[j_index4];
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index5 in registratieslist) {
        j = registratieslist[j_index5];
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index6 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index6];
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel dossiers en registraties en nietdeclarabel');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/dee48627edd7990ed5683401b22be0b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, l, projectleiders2list, item, projectleiders2, userslist, users, j, projectleiderslist, projectleiders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centragv')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Data.of('projectleiders').bulkDelete( (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' '].join('')) );
    projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV=\'PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV=\'*PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV=\'PLGV\' '].join('')),'properties': ['objectId', 'centraname', 'GV', 'userStatus'] }));
    projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return item;})));
    for (var j_index in projectleiderslist) {
      j = projectleiderslist[j_index];
      await Backendless.Data.of('projectleiders').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`centraname`]: (getObjectProperty(j, 'centraname')),[`GV`]: (getObjectProperty(j, 'GV')),[`userStatus`]: (getObjectProperty(j, 'userStatus')) }) );
    }
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\''].join('')),'properties': ['objectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      projectleiders2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectleiders','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\''].join('')),'properties': ['objectId'] }));
      projectleiders2list = (await Promise.all(projectleiders2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index in projectleiders2list) {
        l = projectleiders2list[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectleiders',[`objectId`]: l }));
      }
    }
    ___arguments.context.pageData['disablesave'] = false;
    (function (message) { alert(message) })((String('Permission zijn toegekend voor de tabel projectleiders in centra ') + String(getObjectProperty(___arguments.context.pageData, 'centragv'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/844d3d4ede4753bcf4d7b258c42c1f44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, registratieslist, item, registraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in registratieslist) {
      k = registratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
    }
  }
  console.log('USERSDOSSIERS VOLLEDIG UITGEVOERD');
  (function (message) { alert(message) })('USERSDOSSIERS VOLLEDIG UITGEVOERD');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/10b4ec0d284ee1fd0385ae22b1b32869/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, registratieslist, item, registraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in registratieslist) {
      k = registratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'registraties',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'registraties',[`objectId`]: k }));
    }
  }
  console.log('USERSREGISTRATIES VOLLEDIG UITGEVOERD');
  (function (message) { alert(message) })('USERSREGISTRATIES VOLLEDIG UITGEVOERD');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/69cc5393bbd3be8c75a94fb94e217773/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, registratieslist, item, registraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in registratieslist) {
      k = registratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: k }));
    }
  }
  console.log('USERSNIETDECLARABEL VOLLEDIG UITGEVOERD');
  (function (message) { alert(message) })('USERSNIETDECLARABEL VOLLEDIG UITGEVOERD');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/9c6bc7ace7d8f2d8f2c3151e0b5fb589/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, registratieslist, item, registraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in registratieslist) {
      k = registratieslist[k_index];
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'registraties',[`objectId`]: k }));
    }
  }
  console.log('USERSREGISTRATIES REMOVE VOLLEDIG UITGEVOERD');
  (function (message) { alert(message) })('USERSREGISTRATIES REMOVE VOLLEDIG UITGEVOERD');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/329aaa74399dff14a67f1043bb82b7ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierdelen, dossierdelenlist, dossiers, dossierslist, item, j, k, l, m, username, usernamelist, usernames;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['statusgedeeld=\'','Gedeeld dossier','\''].join('')),'properties': ['objectId', 'dossier', 'username'] }));
  dossierslist = (await Promise.all(dossiers.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`dossier`]: (getObjectProperty(item, 'dossier')),[`username`]: (getObjectProperty(item, 'username')) });})));
  console.log(dossierslist);
  for (var j_index in dossierslist) {
    j = dossierslist[j_index];
    console.log((getObjectProperty(j, 'username')).split(';'));
    usernames = (getObjectProperty(j, 'username')).split(';');
    for (var k_index in usernames) {
      k = usernames[k_index];
      console.log(k);
      username = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',k,'\''].join('')),'properties': ['objectId'] }));
      usernamelist = (await Promise.all(username.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index in usernamelist) {
        l = usernamelist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(k, ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
      }
      dossierdelen = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelen','whereClause': (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')),'properties': ['objectId'] }));
      dossierdelenlist = (await Promise.all(dossierdelen.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      console.log(dossierdelenlist);
      for (var m_index in dossierdelenlist) {
        m = dossierdelenlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'dossierdelen',[`objectId`]: m }));
      }
    }
  }
  (function (message) { alert(message) })('Permission zijn toegekend voor de gedeelde dossiers in tabel dossiers en dossierdelen');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/b43eac866dd3a172667fca74d2e7d84b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var k, refuser, userslist, item, users, j, dossierdelenuserslist, dossierdelenusers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': 'userobjectId is not null','properties': ['userobjectId', 'centraname', 'naam', 'GV', 'organisatie', 'email'] }));
  dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return item;})));
  for (var j_index2 in dossierdelenuserslist) {
    j = dossierdelenuserslist[j_index2];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\' AND GV=\'GV\'','OR userStatus=\'','ENABLED','\' AND GV=\'VW\'','OR userStatus=\'','ENABLED','\' AND GV=\'PLGV\''].join('')),'properties': ['objectId', 'centraname', 'naam', 'GV', 'organisatie', 'email'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index2 in userslist) {
      k = userslist[k_index2];
      if ((getObjectProperty(k, 'objectId')) != (getObjectProperty(j, 'userobjectId'))) {
      }
    }
  }
  console.log('abc');
}

/**
 * Describe this function...
 */
async function do_something3() {
  dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
  dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index3 in dossierdelenuserslist) {
    j = dossierdelenuserslist[j_index3];
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['userobjectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var k_index3 in userslist) {
      k = userslist[k_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'dossierdelenusers',[`objectId`]: j }));
    }
  }
  (function (message) { alert(message) })('STAP 2  UITGEVOERD');
}

/**
 * Describe this function...
 */
async function do_something2() {
  dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId', 'userobjectId'] }));
  dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')) });})));
  for (var j_index4 in dossierdelenuserslist) {
    j = dossierdelenuserslist[j_index4];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'objectIdnew')), 'userobjectId')), ({ [`___class`]: 'dossierdelenusers',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
  }
  for (var k_index4 in dossierdelenuserslist) {
    k = dossierdelenuserslist[k_index4];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(k, 'userobjectId')), ({ [`___class`]: 'dossierdelenusers',[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'objectIdnew')), 'objectId')) }));
  }
  (function (message) { alert(message) })('STAP 2  UITGEVOERD');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centragv')) == null) {
    (function (message) { alert(message) })('Centra selecteren');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectgv')) == null) {
    (function (message) { alert(message) })('Gebruiker selecteren');
  } else {
    if ((await Backendless.Data.of('dossierdelenusers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))))) == 0) {
      ___arguments.context.pageData['objectIdnew'] = (await Backendless.Data.of('dossierdelenusers').save( ({ [`userobjectId`]: (getObjectProperty(___arguments.context.pageData, 'gvuserobjectId')),[`centraname`]: (getObjectProperty(___arguments.context.pageData, 'centraname')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`GV`]: (getObjectProperty(___arguments.context.pageData, 'GV')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }) ));
    }
    refuser = (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')) });})))[0];
    dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
    dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index in dossierdelenuserslist) {
      j = dossierdelenuserslist[j_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(refuser, 'userobjectId')), ({ [`___class`]: 'dossierdelenusers',[`objectId`]: j }));
    }
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['userobjectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var k_index in userslist) {
      k = userslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'dossierdelenusers',[`objectId`]: (getObjectProperty(refuser, 'objectId')) }));
    }
    (function (message) { alert(message) })('STAP 2  UITGEVOERD');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/c6f6b5aa334d7a764518e548911649af/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV =\'GV\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV =\'VW\' AND userStatus=\'enabled\' OR ','centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\' AND GV =\'PLGV\' AND userStatus=\'enabled\''].join(''))).setProperties(['naam', 'username']).setSortBy('naam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var objectid, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  objectid = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectgv')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`centraname`]: (getObjectProperty(item, 'centraname')),[`naam`]: (getObjectProperty(item, 'naam')),[`GV`]: (getObjectProperty(item, 'GV')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`email`]: (getObjectProperty(item, 'email')),[`username`]: (getObjectProperty(item, 'username')) });})))[0];
  ___arguments.context.pageData['gvuserobjectId'] = (getObjectProperty(objectid, 'objectId'));
  ___arguments.context.pageData['centraname'] = (getObjectProperty(objectid, 'centraname'));
  ___arguments.context.pageData['naam'] = (getObjectProperty(objectid, 'naam'));
  ___arguments.context.pageData['GV'] = (getObjectProperty(objectid, 'GV'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(objectid, 'organisatie'));
  ___arguments.context.pageData['email'] = (getObjectProperty(objectid, 'email'));
  ___arguments.context.pageData['username'] = (getObjectProperty(objectid, 'username'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/92f2106c597976c388dd7fc6ea31360f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centraname')),[`label`]: (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/88f693aa3b6cb94f71a6d52b05cd86d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, dossierdelenuserslist, item, dossierdelenusers, k, userslist2, users2, centranamelist, centraname, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function dossierdelenusers_tabel_maken() {
  await Backendless.Data.of('dossierdelenusers').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\' AND GV=\'GV\'','OR userStatus=\'','ENABLED','\' AND GV=\'VW\'','OR userStatus=\'','ENABLED','\' AND GV=\'PLGV\''].join('')),'properties': ['objectId', 'centraname', 'naam', 'GV', 'organisatie', 'email', 'username'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('dossierdelenusers').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`centraname`]: (getObjectProperty(j, 'centraname')),[`naam`]: (getObjectProperty(j, 'naam')),[`GV`]: (getObjectProperty(j, 'GV')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`email`]: (getObjectProperty(j, 'email')),[`username`]: (getObjectProperty(j, 'username')) }) );
    centraname = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\''].join('')),'groupBy': 'centraname','properties': ['centraname'] }));
    centranamelist = (await Promise.all(centraname.map(async item => {; return (getObjectProperty(item, 'centraname'));})));
    for (var k_index in centranamelist) {
      k = centranamelist[k_index];
      users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'','ENABLED','\' AND centraname=\'',k,'\''].join('')),'properties': ['objectId'] }));
      userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var l_index in userslist2) {
        l = userslist2[l_index];
        dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',k,'\''].join('')),'properties': ['objectId'] }));
        dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var m_index in dossierdelenuserslist) {
          m = dossierdelenuserslist[m_index];
          await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'dossierdelenusers',[`objectId`]: m }));
        }
      }
    }
  }
  console.log('dossiersdelenstap1 volledig uitgevoerd');
  await Backendless.Data.of('timers').save( ({ [`timer`]: 'dossiersdelenstap1 ',[`date finished`]: (new Date()) }) );
}


  await Backendless.Request.get(`${Backendless.appPath}/services/Permissions/dossierdelenusersstap1`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'centra': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'centragv'))) }).send();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/c7485fb2f6a605b4aab2cc346618cd34/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centra, factuurgegevens, factuurgegevenslist, item, j, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function nodig_() {
  await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: k }));
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Haaglanden') {
    centra = 'Hz';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Overijssel') {
    centra = 'Of';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Utrecht') {
    centra = 'Mn';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZHN') {
    centra = 'Zh';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'Zinvol') {
    centra = 'Zv';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centra')) == 'ZWNL') {
    centra = 'Zw';
  } else {
    centra = (getObjectProperty(___arguments.context.pageData, 'centra')).slice(0, 2);
  }
  factuurgegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['centra=\'',centra,'\''].join('')),'properties': ['objectId'] }));
  factuurgegevenslist = (await Promise.all(factuurgegevens.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index in factuurgegevenslist) {
    j = factuurgegevenslist[j_index];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: j }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/8e5a358ce994b05b8775ff99eb2a192f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, projectkostenlist, item, projectkosten, userslist2, users2, centranamelist, k, centraname;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  centraname = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': 'objectId is not null','groupBy': 'centra','properties': ['centra'] }));
  centranamelist = (await Promise.all(centraname.map(async item => {; return (getObjectProperty(item, 'centra'));})));
  for (var k_index in centranamelist) {
    k = centranamelist[k_index];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',k,'\' AND GV=\'PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',k,'\' AND GV=\'*PL\''].join('')),'properties': ['objectId'] }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in userslist2) {
      l = userslist2[l_index];
      projectkosten = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',k,'\''].join('')),'properties': ['objectId'] }));
      projectkostenlist = (await Promise.all(projectkosten.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index in projectkostenlist) {
        m = projectkostenlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'projectkosten',[`objectId`]: m }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'projectkosten',[`objectId`]: m }));
        await Backendless.Data.Permissions.REMOVE.grantForUser(l, ({ [`___class`]: 'projectkosten',[`objectId`]: m }));
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/112bda6e6e068754c5725d97ea6b2ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, verlengingsaanvragenlist, item, verlengingsaanvragen, k, userslist2, users2, centranamelist, centraname;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  centraname = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'verlengingsaanvragen','whereClause': 'objectId is not null','groupBy': 'centraname','properties': ['centraname'] }));
  centranamelist = (await Promise.all(centraname.map(async item => {; return (getObjectProperty(item, 'centraname'));})));
  for (var k_index in centranamelist) {
    k = centranamelist[k_index];
    users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',k,'\' AND GV=\'PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',k,'\' AND GV=\'*PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',k,'\' AND GV=\'PLGV\' '].join('')),'properties': ['objectId'] }));
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in userslist2) {
      l = userslist2[l_index];
      verlengingsaanvragen = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'verlengingsaanvragen','whereClause': (['centraname=\'',k,'\''].join('')),'properties': ['objectId'] }));
      verlengingsaanvragenlist = (await Promise.all(verlengingsaanvragen.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var m_index in verlengingsaanvragenlist) {
        m = verlengingsaanvragenlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'verlengingsaanvragen',[`objectId`]: m }));
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/52119a0fa8d2ebb3d45580f9bd5708e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Request.get(`${Backendless.appPath}/services/Permissions/dossiersdelenstap2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'centra': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'centragv'))) }).send();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/6733cd03436ad9865a0dee2863129136/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, userslist, item, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'aantekeningen','whereClause': 'objectId is not null','properties': ['ownerId', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: (getObjectProperty(item, 'ownerId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'ownerId')), ({ [`___class`]: 'aantekeningen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'ownerId')), ({ [`___class`]: 'aantekeningen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
    await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'ownerId')), ({ [`___class`]: 'aantekeningen',[`objectId`]: (getObjectProperty(j, 'objectId')) }));
  }
  console.log('PERMISSIONS AANTEKENINGEN UITGEVOERD');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/6d5c3ed72ade1bd5b3776c1e42dc8e64/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, nietdeclarabellist, item, nietdeclarabel, registratieslist, registraties, dossierslist, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in dossierslist) {
        j = dossierslist[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND jaar=2025'].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in registratieslist) {
        j = registratieslist[j_index2];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index3 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index3];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index4 in dossierslist) {
        j = dossierslist[j_index4];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
      }
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index5 in registratieslist) {
        j = registratieslist[j_index5];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
      }
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index6 in nietdeclarabellist) {
        j = nietdeclarabellist[j_index6];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
        await Backendless.Data.Permissions.UPDATE.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel dossiers en registraties en nietdeclarabel');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/891d353efcb31fb81a5c9d8ba4a8bf2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, nietdeclarabellist, item, nietdeclarabel, userslist, registratieslist, registraties, l, dossierslist, dossiers, dossiersuitregistratieslist, dossiersuitregistraties, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV=\'PL\'',' OR centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND GV=\'*PL\''].join('')),'properties': ['objectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index in userslist) {
      j = userslist[j_index];
      dossiersuitregistraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'properties': ['dossier'] }));
      dossiersuitregistratieslist = (await Promise.all(dossiersuitregistraties.map(async item => {; return (getObjectProperty(item, 'dossier'));})));
      for (var k_index in dossiersuitregistratieslist) {
        k = dossiersuitregistratieslist[k_index];
        dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['dossier=\'',k,'\' '].join('')),'properties': ['objectId'] }));
        dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
        for (var l_index in dossierslist) {
          l = dossierslist[l_index];
          await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'dossiers',[`objectId`]: l }));
          await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'dossiers',[`objectId`]: l }));
        }
      }
    }
    for (var j_index2 in userslist) {
      j = userslist[j_index2];
      registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'properties': ['objectId'] }));
      registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var k_index2 in registratieslist) {
        k = registratieslist[k_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'registraties',[`objectId`]: k }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'registraties',[`objectId`]: k }));
      }
    }
    for (var j_index3 in userslist) {
      j = userslist[j_index3];
      nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')),'properties': ['objectId'] }));
      nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var k_index3 in nietdeclarabellist) {
        k = nietdeclarabellist[k_index3];
        await Backendless.Data.Permissions.FIND.grantForUser(j, ({ [`___class`]: 'nietdeclarabel',[`objectId`]: k }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(j, ({ [`___class`]: 'nietdeclarabel',[`objectId`]: k }));
      }
    }
    ___arguments.context.pageData['disablesave'] = false;
    (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/678348f68586aa3f17dd03c5bbba89fc/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });}))), ({ [`value`]: '%',[`label`]: 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/e778b398fe0231a7d57818e7f7d8ee59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'XXX') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkostenaccountant', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Gr01gve') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('impactmeting2025', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Dashboard')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginadashboard', undefined);
  }
}

/**
 * Describe this function...
 */
async function do_something2() {
  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || ((await Backendless.UserService.getUserRoles()).includes('Projectleider')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
}

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/7e95aac870983ca88fcacd987588b158/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e95aac870983ca88fcacd987588b158', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setSortBy('created DESC').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plpermissions/components/3e687488da88fb18f2b88b266e39d8f9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('newuserrequests').save( ___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae') );
  ___arguments.context.pageData['centraname'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'centraname'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'GV')) == 'PL') {
    ___arguments.context.pageData['GV'] = 'PL';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'GV')) == 'GV') {
    ___arguments.context.pageData['GV'] = 'GV';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'GV')) == 'VW') {
    ___arguments.context.pageData['GV'] = 'VW';
  }
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'naam'));
  ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'email'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'organisatie'));
  ___arguments.context.pageData['regiogv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'regiogv'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwplichtig'));
  ___arguments.context.pageData['btwinclconsulten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwinclconsulten'));
  ___arguments.context.pageData['btwinclgroepsconsulten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwinclgroepsconsulten'));
  ___arguments.context.pageData['btwinclscholing'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwinclscholing'));
  ___arguments.context.pageData['btwinclcoaching'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwinclcoaching'));
  ___arguments.context.pageData['btwinclmdopatz'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'btwinclmdopatz'));
  ___arguments.context.pageData['drechtstedenorganisatietarief'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'drechtstedenorganisatietarief'));
  ___arguments.context.pageData['aanmaakdatum'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'aanmaakdatum'));
  ___arguments.context.pageData['aangemelddoor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'aangemelddoor'));
  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'aangemelddooremail'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/0b099d884de886a8af386f78f82d9328/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centraname')),[`label`]: (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/e0465eb327282ba8209842f87733f9fd/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/f2e844d529fc4945dd78853b767ffb38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var createduser, l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users, k, projectleiders2list, projectleiders2, projectleiderslist, projectleiders, nietdeclarabellist, nietdeclarabel, registratieslist, registraties, dossierslist, dossiers, refuser, dossierdelenuserslist, dossierdelenusers, factuurgegevensobjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function instellen_permissions() {
  await userobjectId();
  await Users();
  await gebruikersbeheer2();
  await projectleiders3();
  await dossierdelenusers1();
  await dossierdelenusers2();
  if ((getObjectProperty(___arguments.context.pageData, 'GV')) != 'PL') {
    await factuurgegevens();
  }
  if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'PL') {
    await dossiersenregistratiespermissionsprojectleider();
  }
}

/**
 * Describe this function...
 */
async function userobjectId() {
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
}

/**
 * Describe this function...
 */
async function gebruikersbeheer2() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['btwinclcoaching', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclmdopatz', 'btwinclscholing', 'centraname', 'dashboardnaam', 'email', 'GV', 'lastLogin', 'naam', 'organisatie', 'regiogv', 'username', 'objectId', 'userStatus'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`btwinclcoaching`]: (getObjectProperty(j, 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty(j, 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty(j, 'btwinclgroepsconsulten')),[`btwinclmdopatz`]: (getObjectProperty(j, 'btwinclmdopatz')),[`btwinclscholing`]: (getObjectProperty(j, 'btwinclscholing')),[`centraname`]: (getObjectProperty(j, 'centraname')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`email`]: (getObjectProperty(j, 'email')),[`GV`]: (getObjectProperty(j, 'GV')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`regiogv`]: (getObjectProperty(j, 'regiogv')),[`username`]: (getObjectProperty(j, 'username')),[`userobjectId`]: (getObjectProperty(j, 'objectId')),[`userStatus`]: (getObjectProperty(j, 'userStatus')) }) );
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'*PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'PLGV\' '].join('')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')) }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function projectleiders3() {
  await Backendless.Data.of('projectleiders').bulkDelete( (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' '].join('')) );
  projectleiders = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'*PL\' OR ','userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND GV=\'PLGV\' '].join('')),'properties': ['objectId', 'centraname', 'GV', 'userStatus'] }));
  projectleiderslist = (await Promise.all(projectleiders.map(async item => {; return item;})));
  for (var j_index2 in projectleiderslist) {
    j = projectleiderslist[j_index2];
    await Backendless.Data.of('projectleiders').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`centraname`]: (getObjectProperty(j, 'centraname')),[`GV`]: (getObjectProperty(j, 'GV')),[`userStatus`]: (getObjectProperty(j, 'userStatus')) }) );
  }
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus=\'ENABLED\'',' AND centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var k_index in userslist) {
    k = userslist[k_index];
    projectleiders2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectleiders','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
    projectleiders2list = (await Promise.all(projectleiders2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index2 in projectleiders2list) {
      l = projectleiders2list[l_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'projectleiders',[`objectId`]: l }));
    }
  }
  console.log(String('permissions zijn toegekend voor de tabel projectleiders in centra ') + String(getObjectProperty(___arguments.context.pageData, 'centraname')));
}

/**
 * Describe this function...
 */
async function dossierdelenusers1() {
  await Backendless.Request.get(`${Backendless.appPath}/services/Permissions/dossierdelenusersstap1`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'centra': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'centraname'))) }).send();
  console.log('permissions dossierdelenusers1 uitgevoerd');
}

/**
 * Describe this function...
 */
async function dossiersenregistratiespermissionsprojectleider() {
  dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
  dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index3 in dossierslist) {
    j = dossierslist[j_index3];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
    await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: j }));
  }
  registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
  registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index4 in registratieslist) {
    j = registratieslist[j_index4];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
    await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: j }));
  }
  nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
  nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index5 in nietdeclarabellist) {
    j = nietdeclarabellist[j_index5];
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
    await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: j }));
  }
  console.log('dossiersenregistratiespermissionsprojectleider uitgevoerd');
}

/**
 * Describe this function...
 */
async function dossierdelenusers2() {
  await Backendless.Request.get(`${Backendless.appPath}/services/Permissions/dossiersdelenstap2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'centra': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'centraname'))) }).send();
  console.log('permissions dossierdelenusers2 uitgevoerd');
}

/**
 * Describe this function...
 */
async function Users() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
}

/**
 * Describe this function...
 */
async function oude_code_dossierdelenusers() {
  if ((await Backendless.Data.of('dossierdelenusers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))))) == 0) {
    ___arguments.context.pageData['objectIdnew'] = (await Backendless.Data.of('dossierdelenusers').save( ({ [`userobjectId`]: (getObjectProperty(___arguments.context.pageData, 'userobjectId')),[`centraname`]: (getObjectProperty(___arguments.context.pageData, 'centraname')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`GV`]: (getObjectProperty(___arguments.context.pageData, 'GV')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }) ));
    refuser = (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')) });})))[0];
    dossierdelenusers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['objectId'] }));
    dossierdelenuserslist = (await Promise.all(dossierdelenusers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var j_index6 in dossierdelenuserslist) {
      j = dossierdelenuserslist[j_index6];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(refuser, 'userobjectId')), ({ [`___class`]: 'dossierdelenusers',[`objectId`]: j }));
    }
    users = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossierdelenusers','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'properties': ['userobjectId'] }));
    userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var k_index2 in userslist) {
      k = userslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(k, ({ [`___class`]: 'dossierdelenusers',[`objectId`]: (getObjectProperty(refuser, 'objectId')) }));
    }
    console.log('permissions dossierdelenusers uitgevoerd');
  }
}

/**
 * Describe this function...
 */
async function factuurgegevens() {
  await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`GV`]: (getObjectProperty(___arguments.context.pageData, 'GV')),[`regiogv`]: (getObjectProperty(___arguments.context.pageData, 'regiogv')) }) );
  factuurgegevensobjectId = (getObjectProperty(((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: factuurgegevensobjectId }));
  await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: factuurgegevensobjectId }));
  console.log('permissions factuurgegevens uitgevoerd');
}


  if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == null) {
    (function (message) { alert(message) })('Centra dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'username')) == null) {
    (function (message) { alert(message) })('De username dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0465eb327282ba8209842f87733f9fd')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regiogv')) == null) {
    (function (message) { alert(message) })('De regio dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['spinner'] = true;
    createduser = (await Backendless.UserService.register( new Backendless.User({ 'aanmaakdatum': (getObjectProperty(___arguments.context.pageData, 'aanmaakdatum')),'centraname': (getObjectProperty(___arguments.context.pageData, 'centraname')),'username': (getObjectProperty(___arguments.context.pageData, 'username')),'password': 'CVL2022isBegonnen!@!','GV': (getObjectProperty(___arguments.context.pageData, 'GV')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'regiogv': (getObjectProperty(___arguments.context.pageData, 'regiogv')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),'btwinclcoaching': (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),'btwinclmdopatz': (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')),'drechtstedenorganisatietarief': (getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietarief')) }) ));
    await instellen_permissions();
    await Backendless.Data.of('Users').addRelation(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'centra', [(await Backendless.Data.of('settings').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]]);
    await Backendless.Data.of('newuserrequests').bulkUpdate( (['naam=\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\''].join('')), ({ [`useraangemaakt`]: true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e95aac870983ca88fcacd987588b158', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));
    ___arguments.context.pageData['spinner'] = false;
    (function (message) { alert(message) })((['User is geregistreerd: \n',['Naam: ',(getObjectProperty(___arguments.context.pageData, 'naam')),' \n'].join(''),['Email: ',(getObjectProperty(___arguments.context.pageData, 'email')),' \n'].join(''),['Username:  ',(getObjectProperty(___arguments.context.pageData, 'username')),' \n'].join(''),['organisatie:  ',(getObjectProperty(___arguments.context.pageData, 'organisatie')),' \n'].join(''),['Centra:  ',(getObjectProperty(___arguments.context.pageData, 'centraname')),' \n'].join(''),['GV:  ',(getObjectProperty(___arguments.context.pageData, 'GV')),' \n'].join(''),['btwplichtig:  ',(getObjectProperty(___arguments.context.pageData, 'btwplichtig')),' \n'].join(''),['btwinclconsulten:  ',(getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),' \n'].join(''),['btwinclgroepsconsulten:  ',(getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),' \n'].join(''),['btwinclscholing:  ',(getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),' \n'].join(''),['btwinclcoaching:  ',(getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),' \n'].join(''),['btwinclmdopatz:  ',(getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')),' \n'].join(''),['drechtstedenorganisatietarief:  ',(getObjectProperty(___arguments.context.pageData, 'drechtstedenorganisatietarief')),' \n'].join(''),['regiogv:  ',(getObjectProperty(___arguments.context.pageData, 'regiogv')),' \n'].join('')].join('')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/99b7381e961866231c4877f56b76ac68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['aanmaakdatum', 'centraname', 'username', 'GV', 'naam', 'email', 'organisatie', 'regiogv', 'btwplichtig', 'btwinclconsulten', 'btwinclgroepsconsulten', 'btwinclscholing', 'btwinclcoaching', 'btwinclmdopatz', 'drechtstedenorganisatietarief'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/8208563b7cd8afb823e8b6a8f2e6d88a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\' AND dashboardnaam NOT LIKE \'lori%\''].join(''))).setProperties('dashboardnaam').setSortBy('created DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plpermissions/components/84a8b8c88ea80c153b88214242b86fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var centranaam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function centranaam2() {
  if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Overijssel') {
    centranaam = 'Overijssel/Flevoland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'ZWNL') {
    centranaam = 'Zuid West Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Utrecht') {
    centranaam = 'Midden Nederland';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'ZHN') {
    centranaam = 'Zuid Holland Noord';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Haaglanden') {
    centranaam = 'Haagsche-Zin';
  } else if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Lorio') {
    centranaam = 'Nederland';
  } else {
    centranaam = (getObjectProperty(___arguments.context.pageData, 'centraname'));
  }
}

/**
 * Describe this function...
 */
async function instellen_permissions() {
}


  await centranaam2();
  if ((getObjectProperty(___arguments.context.pageData, 'centraname')) == null) {
    (function (message) { alert(message) })('Het centra dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'username')) == null) {
    (function (message) { alert(message) })('De username dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == null) {
    (function (message) { alert(message) })('GV dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Drechtsteden') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserdrechtstedengv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Gelderland') {
      await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Limburg') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserlimburggv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Overijssel') {
      await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Questio') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserquestiogv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Rotterdam') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserrotterdamgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Utrecht') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserutrechtgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Willem') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserwillemgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'ZWNL') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Overijssel') {
      await Backendless.Messaging.sendEmailFromTemplate('newuseroverijsselvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Gelderland') {
      await Backendless.Messaging.sendEmailFromTemplate('newusergelderlandvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'ZWNL') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserzwnlvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Willem') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserwillemvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Brabant') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserbrabantgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'ZHN') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserzhngv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Haaglanden') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserhaaglandengv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Zinvol') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserzinvolgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'VW' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Zinvol') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserzinvolvw', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'GV' && (getObjectProperty(___arguments.context.pageData, 'centraname')) == 'Sichtpunt') {
      await Backendless.Messaging.sendEmailFromTemplate('newusersichtpuntgv', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    } else if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'PL') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserpl', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
    }
    await Backendless.Messaging.sendEmailFromTemplate('newuseraangemaakt', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`centranaam`]: centranaam }), undefined);
    (function (message) { alert(message) })('De inloggegevens zijn verzonden naar de nieuwe user en de aanvrager heeft bevestiging ontvangen via mail.');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/70284cb802881dcac2bd0e887cfa9ee8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setProperties('centraname').setSortBy('centraname ASC').setGroupBy('centraname').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'centraname')),[`label`]: (getObjectProperty(item, 'centraname')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plpermissions/components/05a84e7aae78aeff5408be2dfc2886a8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centraname')),'\''].join('')),'sortBy': 'username ASC','groupBy': 'username','properties': ['username'] })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var user, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  user = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`naam`]: (getObjectProperty(item, 'naam')),[`GV`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['naam'] = (getObjectProperty(user, 'naam'));
  ___arguments.context.pageData['GV'] = (getObjectProperty(user, 'GV'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/ce581d784046df2cdb6599540492ebac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['centraname', 'username', 'naam', 'GV'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e0faf08cd68a38ec4660cc8c8b47038', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a708aed8d927a8ead3a888c8f3a82918', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/3df3e6026e5ae9af02fd2dc8f61554d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var countregistraties, countdossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e0faf08cd68a38ec4660cc8c8b47038', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a708aed8d927a8ead3a888c8f3a82918', false);
  countdossiers = (await Backendless.Data.of('dossiers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')))));
  countregistraties = (await Backendless.Data.of('registraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')))));
  if (countdossiers == 0 && countregistraties == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a708aed8d927a8ead3a888c8f3a82918', true);
    (function (message) { alert(message) })(([['Aantal dossiers: ',countdossiers,' \n'].join(''),['Aantal registraties: ',countregistraties,' \n'].join(''),String('Deze user moet verwijdert worden')].join('')));
  }
  if (countdossiers != 0 && countregistraties == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e0faf08cd68a38ec4660cc8c8b47038', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a708aed8d927a8ead3a888c8f3a82918', true);
    (function (message) { alert(message) })(([['Aantal dossiers: ',countdossiers,' \n'].join(''),['Aantal registraties: ',countregistraties,' \n'].join(''),String('Kies of je de user wilt deactiveren of verwijderen')].join('')));
  }
  if (countdossiers != 0 && countregistraties != 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e0faf08cd68a38ec4660cc8c8b47038', true);
    (function (message) { alert(message) })(([['Aantal dossiers: ',countdossiers,' \n'].join(''),['Aantal registraties: ',countregistraties,' \n'].join(''),String('Deze user moet gedeactiveerd worden')].join('')));
  }
  if (countdossiers == 0 && countregistraties != 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e0faf08cd68a38ec4660cc8c8b47038', true);
    (function (message) { alert(message) })(([['Aantal dossiers: ',countdossiers,' \n'].join(''),['Aantal registraties: ',countregistraties,' \n'].join(''),String('Deze user moet gedeactiveerd worden')].join('')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/4e0faf08cd68a38ec4660cc8c8b47038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userobjectId() {
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
}

/**
 * Describe this function...
 */
async function factuurgegevens() {
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`adres`]: null,[`akkoordfactuurgegevens`]: null,[`bedrijfsnaam`]: null,[`bic`]: null,[`btwnummer`]: null,[`contactpersoonbestuur`]: null,[`contactpersoonbestuuremail`]: null,[`email`]: null,[`GV`]: null,[`ibannummer`]: null,[`kvknummer`]: null,[`naam`]: null,[`postcode`]: null,[`regiogv`]: null,[`skgvnummer`]: null,[`specialisaties`]: null,[`telefoon`]: null,[`telefoonnummer`]: null,[`tennamevaniban`]: null,[`woonplaats`]: null }) );
}

/**
 * Describe this function...
 */
async function dossierdelenusers() {
  await Backendless.Data.of('dossierdelenusers').bulkDelete( (['userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'userobjectId')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function projectleiders() {
  await Backendless.Data.of('projectleiders').bulkDelete( (['userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'userobjectId')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function do_something() {
  await Backendless.Data.of('Users').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null,[`userStatus`]: 'DISABLED' }) );
}

/**
 * Describe this function...
 */
async function Users() {
  await Backendless.Request.post(`${Backendless.appPath}/services/disableuser/disableuser`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'userobjectId'))));
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.denyForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.denyForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
}

/**
 * Describe this function...
 */
async function gebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null,[`userStatus`]: 'DISABLED' }) );
}

/**
 * Describe this function...
 */
async function dossiers() {
  await Backendless.Data.of('dossiers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null }) );
}

/**
 * Describe this function...
 */
async function registraties() {
  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null }) );
}


  await userobjectId();
  await Users();
  await factuurgegevens();
  await gebruikersbeheer();
  await dossiers();
  await registraties();
  await dossierdelenusers();
  if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'PL' || (getObjectProperty(___arguments.context.pageData, 'GV')) == 'PLGV') {
    await projectleiders();
  }
  await Backendless.Messaging.sendEmailFromTemplate('usergedeactiveerd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`usergedeactiveerd`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d9e15c8c056c521f7c8ee2831570788', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));
  (function (message) { alert(message) })('User is gedeactiveerd en de email is verzonden naar de aanvrager');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/a708aed8d927a8ead3a888c8f3a82918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userobjectId() {
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
}

/**
 * Describe this function...
 */
async function Users() {
  await Backendless.Data.of('Users').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function factuurgegevens() {
  await Backendless.Data.of('factuurgegevens').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function gebruikersbeheer() {
  await Backendless.Data.of('factuurgegevens').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function dossierdelenusers() {
  await Backendless.Data.of('dossierdelenusers').bulkDelete( (['userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'userobjectId')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function projectleiders() {
  await Backendless.Data.of('projectleiders').bulkDelete( (['userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'userobjectId')),'\''].join('')) );
}


  await userobjectId();
  await Users();
  await factuurgegevens();
  await gebruikersbeheer();
  await dossierdelenusers();
  if ((getObjectProperty(___arguments.context.pageData, 'GV')) == 'PL' || (getObjectProperty(___arguments.context.pageData, 'GV')) == 'PLGV') {
    await projectleiders();
  }
  await Backendless.Messaging.sendEmailFromTemplate('usergedeactiveerd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`usergedeactiveerd`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d9e15c8c056c521f7c8ee2831570788', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));
  (function (message) { alert(message) })('User is verwijderd en de email is verzonden naar de aanvrager');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/27d8f408bfb8c813b7311a0824e84418/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, nietdeclarabellist, item, nietdeclarabel, j, l, registratieslist, registraties, k, dossierslist, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'selectuser')) == null) {
    (function (message) { alert(message) })('Selecteer user');
  } else if ((getObjectProperty(___arguments.context.pageData, 'centragv')) == null) {
    (function (message) { alert(message) })('Selecteer centragv');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectuser')),'\' '].join('')),'properties': ['objectId'] }));
    dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index in dossierslist) {
      k = dossierslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: k }));
    }
    registraties = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectuser')),'\' '].join('')),'properties': ['objectId'] }));
    registratieslist = (await Promise.all(registraties.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var l_index in registratieslist) {
      l = registratieslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'registraties',[`objectId`]: l }));
    }
    nietdeclarabel = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'nietdeclarabel','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectuser')),'\' '].join('')),'properties': ['objectId'] }));
    nietdeclarabellist = (await Promise.all(nietdeclarabel.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in nietdeclarabellist) {
      m = nietdeclarabellist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'nietdeclarabel',[`objectId`]: m }));
    }
    ___arguments.context.pageData['disablesave'] = false;
    (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel dossiers en registraties en nietdeclarabel');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/08c89d682348a7615ac849a918cb2248/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centragv')),'\''].join(''))).setProperties(['naam', 'username', 'organisatie']).setSortBy('naam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'username')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var objectid, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  objectid = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'selectuser')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})))[0];
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(objectid, 'objectId'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/2d9e15c8c056c521f7c8ee2831570788/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2d9e15c8c056c521f7c8ee2831570788', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plpermissions/components/16f283e9fe286408228ff0fa5738d548/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var user, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function loaduser() {
  user = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`naam`]: (getObjectProperty(item, 'naam')),[`GV`]: (getObjectProperty(item, 'GV')) });})))[0];
  ___arguments.context.pageData['naam'] = (getObjectProperty(user, 'naam'));
  ___arguments.context.pageData['GV'] = (getObjectProperty(user, 'GV'));
}


  ___arguments.context.pageData['centraname'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fae3f984e618c128ad78da188e98b258'), 'centraname'));
  ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fae3f984e618c128ad78da188e98b258'), 'username'));
  await loaduser();
  ___arguments.context.pageData['aangemelddoor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fae3f984e618c128ad78da188e98b258'), 'aangemelddoor'));
  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fae3f984e618c128ad78da188e98b258'), 'aangemelddooremail'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plpermissions/components/06980e28e1487a025b384c78b82895a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('de', ({ [`dateStyle`]: 'medium',[`timeStyle`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e8a829888df82a6f36e82d689ce8e0ae'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plpermissions/components/c2c9d4253728102813887fe8aac83d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('de', ({ [`dateStyle`]: 'medium',[`timeStyle`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fae3f984e618c128ad78da188e98b258'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plpermissions/components/3968116f66a85ec85c781635f2a2d9f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, dossierslist, item, dossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'centra')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'selectpl')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == null) {
    (function (message) { alert(message) })('Alle velden moeten ingevuld worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'addpermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'verlengingsaanvragen','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index in dossierslist) {
        j = dossierslist[j_index];
        await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'verlengingsaanvragen',[`objectId`]: j }));
      }
      ___arguments.context.pageData['disablesave'] = false;
      (function (message) { alert(message) })('Permission zijn toegekend voor deze user in tabel verlengingsaanvragen');
    } else if ((getObjectProperty(___arguments.context.pageData, 'actie')) == 'removepermission') {
      dossiers = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'verlengingsaanvragen','whereClause': (['centraname=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' '].join('')),'properties': ['objectId'] }));
      dossierslist = (await Promise.all(dossiers.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
      for (var j_index2 in dossierslist) {
        j = dossierslist[j_index2];
        await Backendless.Data.Permissions.FIND.denyForUser((getObjectProperty(___arguments.context.pageData, 'userobjectId')), ({ [`___class`]: 'verlengingsaanvragen',[`objectId`]: j }));
      }
      (function (message) { alert(message) })('Permission zijn verwijdert voor deze user in tabel verlengingsaanvragen');
      ___arguments.context.pageData['disablesave'] = false;
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plpermissions/components/ef0d4b3faa043e18d72d61081d2a83e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.stringify((await Backendless.UserService.findByRole((getObjectProperty(___arguments.context.pageData, 'userrole')), true, Backendless.DataQueryBuilder.create().setProperties(['username', 'naam', 'organisatie', 'centraname']).setPageSize(10))))));
  console.log(JSON.stringify((await Backendless.UserService.findByRole((getObjectProperty(___arguments.context.pageData, 'userrole')), true, Backendless.DataQueryBuilder.create().setProperties(['username', 'naam', 'organisatie', 'centraname']).setPageSize(10)))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarieven/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarieven/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarieven/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3d79f1ddb52f107564d4328510458759', (await Backendless.Data.of('tarievenpercentra').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pltarieven/components/9ece76ae0aafd6a82947c1e10645c5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/68f5872a511a32f87e711a1f6b227c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/028cf35c5ee33c5bddfe08ef23a3886e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/9327113b66188d91d38ef401ce8790f2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/9116a76f46776be539d1a886b749cb92/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/e15bfcb7645f9ebd86ddefc69cf17685/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/3291bb6bd5f30461fbedf64f16b643d5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/9e9ecde32a99d5a83cbed56af98936c2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/eaeb9d0a667459e2bad3bb2a17b3f5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/04579688ce0a7cf364927f0d9265fff3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4ea57b4b0f2e3ae5b4cc07206d954b1'), 'reistijdkm'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/0e664bf6aa3575fcc90a22c2406e4502/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9959a45ac1b6c1cdb06ea354fc4dc2e3'), 'reistijdkmvrijwilliger'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/c3e8d187fcce28e84b9ef1b51b48e399/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/df829fd6d235c4587e6bb8d8ae4c5532/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/e65901d1a3682dccc1198376d8e3c03e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/8926414cf9081cfd351b9682432f214a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/af36a592162271deb4082b0591386b99/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/3e97a9c66ab944447bf6bfc470fa586a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/460c2a9423ca440528316768eb27f4ae/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/0892a9a2c6c7029396c3ab5b0e8cbb03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/15fba37facbbc9719ad12ed2dbf5e5d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/b364116f046a954d2451a938e6a6870d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/82fc2f099467d5b1f13bc112803188f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/c4ea57b4b0f2e3ae5b4cc07206d954b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/9959a45ac1b6c1cdb06ea354fc4dc2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/9121ae1f3a14aa672a5df97aa5949862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/97a36ef81afe172e44e12ae520aa6ddb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/2542ea890bd572123727519316276c5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/fa379ad618c2b36a737a6769c9d185e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/029ede3d1bda7204e3028e9bf85944cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/b4a22d386b9e21ea6bd9f1635d058d64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/b1ff907a7aad54ab4a5c412e0ae8037b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per minuut';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/6434ec1587ce6cdbcbd6c192e5e918bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per uur';
  } else {
    visible = 'per uur';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/554e660575d12bcb15bc0955dca2a33a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarieven/components/75f41be436778582cfc1007177d60ec1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/717de8053edd26bf80c454f1dd7dc7d3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23fdd4a34de5b5c60f7d053564bbd631'), 'werkgroep'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/23fdd4a34de5b5c60f7d053564bbd631/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/112c1203bab4d7a2211893d485f76d35/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23fdd4a34de5b5c60f7d053564bbd631'), 'werkgroep')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/8afadb0e2d084bcf8a9cd5161eb9078f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/d4fa74b40855d3ce0a770a4fd9683a72/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8afadb0e2d084bcf8a9cd5161eb9078f'), 'coordinatorschap'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/495fbb5962f299ab26d5851430a62407/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8afadb0e2d084bcf8a9cd5161eb9078f'), 'coordinatorschap')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/3bb12c7735e2311b4c2e0dbc46db4ef9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/93c6c62ce67af48bf50751a9905c1b57/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb12c7735e2311b4c2e0dbc46db4ef9'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/264c31886ad91a26ea434fa634d83bce/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb12c7735e2311b4c2e0dbc46db4ef9'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/1962ba59041af128b91836d4897b1715/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarieven/components/36bc3dc8e5b81c7c2df8c1885c77049f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1962ba59041af128b91836d4897b1715'), 'coordinatietaken'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/c5957cc481580122f44aece39f18a928/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1962ba59041af128b91836d4897b1715'), 'coordinatietaken')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarieven/components/e68f2341a0947d63737c2ef83024bb45/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    text = 'Individuele consulten en zelfbetalende cliënt';
  } else {
    text = 'Individuele consulten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3d79f1ddb52f107564d4328510458759', (await Backendless.Data.of('nietdeclarabeltarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND financieringstroom <>\'Zelfbetalende cliënt\''].join(''))).setGroupBy('financieringstroom').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/9ece76ae0aafd6a82947c1e10645c5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/68f5872a511a32f87e711a1f6b227c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/028cf35c5ee33c5bddfe08ef23a3886e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/9327113b66188d91d38ef401ce8790f2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/9116a76f46776be539d1a886b749cb92/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/e15bfcb7645f9ebd86ddefc69cf17685/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/3291bb6bd5f30461fbedf64f16b643d5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/9e9ecde32a99d5a83cbed56af98936c2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/eaeb9d0a667459e2bad3bb2a17b3f5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/04579688ce0a7cf364927f0d9265fff3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4ea57b4b0f2e3ae5b4cc07206d954b1'), 'reistijdkm'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/c3e8d187fcce28e84b9ef1b51b48e399/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/df829fd6d235c4587e6bb8d8ae4c5532/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/e65901d1a3682dccc1198376d8e3c03e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/8926414cf9081cfd351b9682432f214a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/af36a592162271deb4082b0591386b99/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/3e97a9c66ab944447bf6bfc470fa586a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/460c2a9423ca440528316768eb27f4ae/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/0892a9a2c6c7029396c3ab5b0e8cbb03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/15fba37facbbc9719ad12ed2dbf5e5d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/b364116f046a954d2451a938e6a6870d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/82fc2f099467d5b1f13bc112803188f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/c4ea57b4b0f2e3ae5b4cc07206d954b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/1962ba59041af128b91836d4897b1715/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/36bc3dc8e5b81c7c2df8c1885c77049f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1962ba59041af128b91836d4897b1715'), 'coordinatietaken'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievennietdeclarabel/components/c5957cc481580122f44aece39f18a928/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1962ba59041af128b91836d4897b1715'), 'coordinatietaken')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3d79f1ddb52f107564d4328510458759', (await Backendless.Data.of('tarievenpercentra').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/9ece76ae0aafd6a82947c1e10645c5ec/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/68f5872a511a32f87e711a1f6b227c8f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4bcb9df6c1c80c35b5dc97b4d520568'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/028cf35c5ee33c5bddfe08ef23a3886e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/9327113b66188d91d38ef401ce8790f2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/9116a76f46776be539d1a886b749cb92/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/e15bfcb7645f9ebd86ddefc69cf17685/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/3291bb6bd5f30461fbedf64f16b643d5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/9e9ecde32a99d5a83cbed56af98936c2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/eaeb9d0a667459e2bad3bb2a17b3f5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/04579688ce0a7cf364927f0d9265fff3/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4ea57b4b0f2e3ae5b4cc07206d954b1'), 'reistijdkm'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/0e664bf6aa3575fcc90a22c2406e4502/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9959a45ac1b6c1cdb06ea354fc4dc2e3'), 'reistijdkm'));
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/c3e8d187fcce28e84b9ef1b51b48e399/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('629f63bec883eeacd42ac29c9549cb48'), 'groepsconsult')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/df829fd6d235c4587e6bb8d8ae4c5532/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b31f27d85d9188781f67e5352882bc31'), 'scholing')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/e65901d1a3682dccc1198376d8e3c03e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8fa1fafab57b963591cc79a42c7e94f'), 'mdopatz')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/8926414cf9081cfd351b9682432f214a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0892a9a2c6c7029396c3ab5b0e8cbb03'), 'opbouwinfra')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/af36a592162271deb4082b0591386b99/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('15fba37facbbc9719ad12ed2dbf5e5d8'), 'coaching')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/3e97a9c66ab944447bf6bfc470fa586a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b364116f046a954d2451a938e6a6870d'), 'consultinwpro')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/460c2a9423ca440528316768eb27f4ae/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('82fc2f099467d5b1f13bc112803188f8'), 'reistijdminutenspeciaal')) * 60;
  await format();

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/0892a9a2c6c7029396c3ab5b0e8cbb03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/15fba37facbbc9719ad12ed2dbf5e5d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/b364116f046a954d2451a938e6a6870d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/82fc2f099467d5b1f13bc112803188f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/c4ea57b4b0f2e3ae5b4cc07206d954b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/9959a45ac1b6c1cdb06ea354fc4dc2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/fa379ad618c2b36a737a6769c9d185e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/029ede3d1bda7204e3028e9bf85944cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/b4a22d386b9e21ea6bd9f1635d058d64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per activiteit';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/b1ff907a7aad54ab4a5c412e0ae8037b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per minuut (bestaande scholing/ moreel beraad)';
  } else {
    visible = 'per minuut';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltarievenrotterdamlimburg/components/6434ec1587ce6cdbcbd6c192e5e918bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = 'per uur (bestaande scholing/ moreel beraad)';
  } else {
    visible = 'per uur';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['filteraanmaakmaand'] = '%';
  ___arguments.context.pageData['filteraanmaakjaar'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setRelated('registraties').setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/pltoestemmingen/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/2a07c8910267501fa1bd76cf01986c99/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.pageData, 'akkoord'));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  ___arguments.context.pageData['questioscholingbedrag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingbedrag'));
  ___arguments.context.pageData['factuurcontactpersoon'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurcontactpersoon'));
  ___arguments.context.pageData['factuurmailadres'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurmailadres'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', false);
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/pltoestemmingen/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });}))), ({ [`value`]: '%',[`label`]: 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingpakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),'aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pltoestemmingen/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablemail')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablemail'] = true;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet akkoord geven. Stuur een mail naar de coordinator.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
        ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
      } else {
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
      }
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null,[`pakketminutenakkoord`]: null,[`status`]: 'Afgesloten',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'NIET AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0,[`pakketminutenakkoord`]: null,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'TE BEHANDELEN',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
    }
  }
  ___arguments.context.pageData['disablemail'] = false;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/fb2254d1d9cba6b1c47e26b4a1d53b43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/50e3d8cf1d5b5021dca38b96f68fee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/4f5920c69d1b7abd2f822e09cb1d21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));
  await format();
  ___arguments.context.pageData['budgetconsultinwpro'] = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ac961463f293122c2af42bd2bc951f7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetgroepsconsult']);
  await format();
  ___arguments.context.pageData['budgetgroepsconsult'] = (___arguments.context.appData['budgetgroepsconsult']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/99659364a71ca96f178968d42f2fce56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetmdopatz']);
  await format();
  ___arguments.context.pageData['budgetmdopatz'] = (___arguments.context.appData['budgetmdopatz']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/dc5277eedcf30867919eb198931ae448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetscholing']);
  await format();
  ___arguments.context.pageData['budgetscholing'] = (___arguments.context.appData['budgetscholing']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/0e03786468acfe7cce88103d5573990f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoaching']);
  await format();
  ___arguments.context.pageData['budgetcoaching'] = (___arguments.context.appData['budgetcoaching']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/66df52ab599bc4d4605fdbab2ec9357d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoordinatietaken']);
  await format();
  ___arguments.context.pageData['budgetcoordinatie'] = (___arguments.context.appData['budgetcoordinatietaken']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ec7fc435caf722a5bb5290af93f9d143/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));
  await format();
  ___arguments.context.pageData['budgetopbouwinfra'] = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/1466292dbeb6de8e0e19693b06d629d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['budgettotaal'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/15b85667f8b2491efe59dc5be4b2dce5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('15b85667f8b2491efe59dc5be4b2dce5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' AND jaar=2024 OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/eb2d8062b33538fdda3e8e6e12ea2316/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eb2d8062b33538fdda3e8e6e12ea2316', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Groepsconsult\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/10f2698d26baf92b10fe422640d276de/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('10f2698d26baf92b10fe422640d276de', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'MDO/PaTz\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/b3d3479b95de2b9cccae603f34094285/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b3d3479b95de2b9cccae603f34094285', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Scholing\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/207573524be607a6c1c6826e874fea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('207573524be607a6c1c6826e874fea9a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coaching on the job\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/0074fe95f8fad94e8884fc0caf4e8ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0074fe95f8fad94e8884fc0caf4e8ab2', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coördinatietaken\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/633b88654084f4d12a89e55efadf2687/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('633b88654084f4d12a89e55efadf2687', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Opbouw infrastructuur\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/8d85f7f484ccf25b162e45969bf6a748/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2026 AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2026'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/50a28c68cde3fb4a8fb381542c0fe8ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a5313f4bf8347e339c4eade136811d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedgroepsconsult'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3c7a4013e296143d9d47d92be89333c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedmdopatz'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a368cbd17349f50400233d4a6487bf39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedscholing'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b512abf16d8e6da3e644f456cdac4f4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoaching'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a8ebfb35abae6b24ea78922c0074f4e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoordinatie'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/55baa318075a1bd8c1c404bf6a085b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedopbouwinfra'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/6fa78d485af6f6f6d1bba9be0dcdac3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/c843e2f80775b77b51a711e83afb299f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c843e2f80775b77b51a711e83afb299f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a6cc9fc7efa8bb333d4247c84d0fc52e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a6cc9fc7efa8bb333d4247c84d0fc52e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/73f8b93f28c2d826704db521e2414073/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('73f8b93f28c2d826704db521e2414073', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d8f75cb59af9b9e3ea54684acf7a4f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8f75cb59af9b9e3ea54684acf7a4f4b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e8533b6140414d11fca7aed5ddb4968c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8533b6140414d11fca7aed5ddb4968c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/c306ec81991e8fb999c760fd70e1e44c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c306ec81991e8fb999c760fd70e1e44c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/fc7744bc17dfe7fbf4bfbfa9649dcded/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc7744bc17dfe7fbf4bfbfa9649dcded', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/6cf3f1d8f9044cace1cf17b82ccb24e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6cf3f1d8f9044cace1cf17b82ccb24e8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e73c1d420478f1d947391cc31e73008c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e73c1d420478f1d947391cc31e73008c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/eab629dfbd7f4928c036dc22bfafbfcb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eab629dfbd7f4928c036dc22bfafbfcb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/47837b81b0b2c648f3b5bfe524397cdb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('47837b81b0b2c648f3b5bfe524397cdb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/13ff2e8816793b54bcdf9c5653239514/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ff2e8816793b54bcdf9c5653239514', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e99eb0486adebf5f819ae5e71c7339ed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e99eb0486adebf5f819ae5e71c7339ed', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/151d795c1845ee060f73320e0103ef4a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('151d795c1845ee060f73320e0103ef4a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/0c1901ca79832fe6a3882a9b866be294/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0c1901ca79832fe6a3882a9b866be294', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ad75e9465b8126566f99b3362a23b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3cfa4b18dde681a3c8df93d3e16e1708/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/503f431d5b5faf63e5afea1a84df2a8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandgroepsconsult'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/cd85d0d273c557fa4ba2d9a1f8168184/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandmdopatz'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/4fbd1a890f434f5e12e58719b56859bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandscholing'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/0b378e9d2267f529cb94e152a47de283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoaching'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/7ba49626e8b588f7bd7bbc2dd1fbfcc8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoordinatie'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d3a16f996d4e90bc920d0cb9665e3b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandopbouwinfra'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/bd938b46dafbf7ec3494e793c2f2b94d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/90361a85a3b8834c28a334d5bcce088e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro')) + (getObjectProperty(___arguments.context.pageData, 'openstaandconsultinwpro'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/8b81a556be61cfd1ceec1f0a745b4111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedgroepsconsult']) + (___arguments.context.pageData['openstaandgroepsconsult']);
  euro = (___arguments.context.pageData['budgetgroepsconsult']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3d27b3d26878cef28135293953071b52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedmdopatz']) + (___arguments.context.pageData['openstaandmdopatz']);
  euro = (___arguments.context.pageData['budgetmdopatz']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/54445c8dd2bc501296abc21dbe3bb3a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedscholing']) + (___arguments.context.pageData['openstaandscholing']);
  euro = (___arguments.context.pageData['budgetscholing']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/bbca5d3cc364099e452cc28645e416a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoaching']) + (___arguments.context.pageData['openstaandcoaching']);
  euro = (___arguments.context.pageData['budgetcoaching']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/2e176a5989a1306939badbb848fe65ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoordinatie']) + (___arguments.context.pageData['openstaandcoordinatie']);
  euro = (___arguments.context.pageData['budgetcoordinatie']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/db32b9a6675a648f8b82c303f21de791/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedopbouwinfra']) + (___arguments.context.pageData['openstaandopbouwinfra']);
  euro = (___arguments.context.pageData['budgetopbouwinfra']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/1e06fe39d44cadac049cd2a88a8cd907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaal')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaal'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/824b126c33eb3cd63dd8595ed3c68f8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setconsultinw')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/0a9783d95605c6f63152a93e58d592e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setgroepsconsult']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/4284d0cd9144569f671f70dcb5a3b92e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setmdopatz']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ae2c9885141c8c8f433b60c37b959c41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setscholing']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/68d5d27230b5acf1e6e62df87da7a4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoaching']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/6256ac564398545a470b969575661be7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setcoordinatietaken')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/26d57ba7dae535750ab5399e2865047b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/7de3b5295b3b7842b7c72729efc7941c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/34ed2b476992f0a6e4e4e8a4f1cefd28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/f39e324f9e48ec31c74213c26592708c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetgroepsconsult']) - (___arguments.context.pageData['besteedgroepsconsult']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e8aeb0930c95050cea025b4e124fe99e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetmdopatz']) - (___arguments.context.pageData['besteedmdopatz']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d8d77a0a9a4570e3323ab3e2d502ef1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetscholing']) - (___arguments.context.pageData['besteedscholing']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/bca1322ecb7cf2a5ce4fa958bd8254d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoaching']) - (___arguments.context.pageData['besteedcoaching']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/06c2fa7579f5a972bba8aa3a5371396d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoordinatie']) - (___arguments.context.pageData['besteedcoordinatie']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d881eb4f0158775dcffa76c990399861/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetopbouwinfra']) - (___arguments.context.pageData['besteedopbouwinfra']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/667f3c48e3956ffe73efe3824738a691/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b88a84df888397b4714e5a5370283c03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/fefd0e9ad2a7924e66310f53a0e47db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/47a1890b9aecb8879ec9a2b83bce9204/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d09b4c992fb2125f6c5f1df747457607/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d036100e7ed9acb83ad2fe8e93bbe3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/fbf31ec6fc86aa473cc58f7db268b73e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/5b9b9ecc780658a7ee9b52c2e579c181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/7fc70af8ec0456e18ff41fa6dc39ec1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/320167587f0601545ed86ff266a9a32d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/df77d477ecff3d38b334b8cbf6838ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/4a7a98ac5fdd7bdf65c6e6bfca3a7e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/190739bfbd5238033e4f1d481d0e86bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var N, item, M, L, K, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Achtergrondinformatie';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
  } else {
    F = 'Status';
    G = 'Toelichting';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    H = 'Leeftijd';
    I = 'Gender';
  } else {
    J = 'Aangenomen door';
    K = 'Geboortedatum';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    J = 'Aangenomen door';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
  } else {
    L = 'Verwijzer contactgegevens';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M && (getObjectProperty(item, 'title')) != N);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Toegekend door ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Doelgroep';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var K, item, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    E = 'Betrokken disciplines';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
  } else {
    F = 'Omschrijving';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J, K, L, M;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
  } else {
    E = 'Organisatie die de scholing afneemt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    F = 'Team dat geschoold wordt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    G = 'Bestaand of nieuw';
    H = 'Naam scholing';
    I = 'Leerdoelen';
    J = 'Doelgroep scholing';
    K = 'Organisatie van de scholing';
    L = 'Locatie scholing';
    M = 'Verwacht aantal deelnemers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/61dd0bccaa0aeec9fc1dfabce0dc7676/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3eae46f51f4143753db9f87af6a99ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/23e1c5223c82007889230b7891020864/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenverlenging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet akkoord geven. Stuur een mail naar de coordinator.');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'VERLENGING BEHANDELD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join('')),'sortBy': 'Dossier DESC' })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/5a86c2b9221cca5eb54c8b8605d6bad5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Openstaand bedrag';
  } else {
    text = 'Bedrag openstaande werkminuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/30d86d04965ea9b4dbf5d7bf449225b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenaantekeningen', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-pagina alle notities bekeken'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'pagina alle notities bekeken',[`dossier`]: undefined,[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pltoestemmingen/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/2a4f8f4f6666a285e5facfdfa6b4b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a4f8f4f6666a285e5facfdfa6b4b31f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/e3a50f7e5bd4485aad127b9c737467f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc613a630b217e93e626880a470508e7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/ebc92f328bfdb8fb9aa2f085026c2266/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questioscholingbedrag': (getObjectProperty(___arguments.context.pageData, 'questioscholingbedrag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De eigen bijdrage is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/a9c2f5452dfbe2b86e1f4733e8814297/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalender', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/aacd343f68c4bb05dd63282a3be96317/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5d1a6122cb0e48cd84f19df551bd7d3d')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/57bf086975d2bbd27452000ba0ca0d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d1a6122cb0e48cd84f19df551bd7d3d'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Programma is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/0f516cdc7a87a6ea4bf70da987e3dfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0f516cdc7a87a6ea4bf70da987e3dfbd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questiogroepsconsultprogrammabijeenkomst').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/9da46e0784b6c92e46fa5f31c65d6f52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbe190c3259a97366ce030fefddbe01')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/d53211de5906121a606260195aad8ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79abb5a3590c2b9ff8ce5939cc430832')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/6255fd828bcfa9d403ef015d4008f8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.pageData, 'wlzindicatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz is aangepast');
  ___arguments.context.pageData['wlzindicatie'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/928520092141ae4e2c8634bba421e66a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.pageData, 'wlzindicatiesoort')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz indicatie is aangepast');
  ___arguments.context.pageData['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/d1ff33dff6da76fdc4e107e65544c786/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cbf77d19f4fa2292df687b656f521de')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/d06bb12b3dc6fcf25c18762379a7e1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d99043cb0e2beb14692b289ca3f3a56')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/f3e33b580a8a6528ea34f2d393596f23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurcontactpersoon': (getObjectProperty(___arguments.context.pageData, 'factuurcontactpersoon')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De contactpersoon voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/458800d42e473d4a95c7bc165d45fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurmailadres': (getObjectProperty(___arguments.context.pageData, 'factuurmailadres')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Het emailadres voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/341f4ca6cebbded4944b69746ecc11ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/503b31d353cfd70f674baddc726ca10d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/f77f4042ef5bc25c5ea8cf7d4ea64945/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true) {
    return2 = 'Resterende activiteiten/ minuten op dossier';
  } else {
    return2 = 'Resterende minuten op dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/98e4a0146d34b776c2aeffeb29ea81fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/32e73059454f19165d0147ca564a76ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/d0949bf9f98b6f35b12427fc37a6f8bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/fefbe76de87b4fa35153a6e37dd7f8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('chartverlengingbrabant', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/3dec7a07010c45a3396dea41a0bbdb12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/1e191665dc4e26d95b2e1b74c861967e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/88e23952ed55134c3a77d72960e3122f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/82186e3b732d07b322bc5dd6e6d7ffcd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/33a6cea49fff954dca096566d2b90c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8553db664a7b49b4869ab7f3c06ff17f')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/4503288cc2c85e84af1ae5357c5b1b78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwachtergrondinformatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Achtergrondinformatie is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/8553db664a7b49b4869ab7f3c06ff17f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8553db664a7b49b4869ab7f3c06ff17f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questioconsultinwachtergrondinformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/a7bbca3209812702649e08f59bdf152b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7bbca3209812702649e08f59bdf152b', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))).setProperties('naam').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingen/components/b25db17d25541ed4ad434ee940f48692/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('dossierdelen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))))) == 0) {
    result = false;
  } else {
    result = true;
  }

  return result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/b6e964abb716dad44771ca67249679a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/7f98d6bd268de8850d18878aa702e1bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = '(incl. openstaand bedrag)';
  } else {
    text = '(incl. openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/c6ac4a32b1cfbbaa721786b9818d2863/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'budget 2024 min totaal besteed bedrag';
  } else {
    text = '(zonder openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/f0d800a8ec688e8d12d8b5f8a6260fb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempljm')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/279805982d082158f4c6b24c5c08c828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempljm')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/cbf8dc6823474a837846186851fdf37b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('aanmaakmaand ASC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/f6cc3797906875c83651ff28a338cc28/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('aanmaakjaar DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingen/components/2d66a56862c2faf82f58510d19fec1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteraanmaakmaand'] = '%';
  ___arguments.context.pageData['filteraanmaakjaar'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingen/components/18586ec60fc853be3e9832a86ee801e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/01a814f25e3f50e691fb3b497a0f70bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingen/components/484935bdd8b35be77e86611d121eb11c/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var N, item, M, L, K, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('484935bdd8b35be77e86611d121eb11c')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
  } else {
    A = 'Stad of dorp en organisatie';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M && (getObjectProperty(item, 'title')) != N);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['emailvraag'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'1\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))), ({ 'value': '%','label': 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, D, item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    C = 'Organisatie die de scholing afneemt';
    D = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/61dd0bccaa0aeec9fc1dfabce0dc7676/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/3eae46f51f4143753db9f87af6a99ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord')),' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord')),' AND aantalopmerkingenprojectleider >0'].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltoestemmingenaantekeningen/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['filteraanmaakmaand'] = '%';
  ___arguments.context.pageData['filteraanmaakjaar'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setRelated('registraties').setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`label`]: (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/2a07c8910267501fa1bd76cf01986c99/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.pageData, 'akkoord'));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  ___arguments.context.pageData['questioscholingbedrag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingbedrag'));
  ___arguments.context.pageData['factuurcontactpersoon'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurcontactpersoon'));
  ___arguments.context.pageData['factuurmailadres'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurmailadres'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'activiteit')),[`label`]: (getObjectProperty(item, 'activiteit')) });}))), ({ [`value`]: '%',[`label`]: 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingpakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),'aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablemail')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablemail'] = true;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet akkoord geven. Stuur een mail naar de coordinator.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
        ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
      } else {
        await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
      }
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null,[`pakketminutenakkoord`]: null,[`status`]: 'Afgesloten',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'NIET AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0,[`pakketminutenakkoord`]: null,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
      await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
      await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'TE BEHANDELEN',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
      await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
    }
  }
  ___arguments.context.pageData['disablemail'] = false;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/fb2254d1d9cba6b1c47e26b4a1d53b43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/50e3d8cf1d5b5021dca38b96f68fee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/4f5920c69d1b7abd2f822e09cb1d21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));
  await format();
  ___arguments.context.pageData['budgetconsultinwpro'] = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ac961463f293122c2af42bd2bc951f7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetgroepsconsult']);
  await format();
  ___arguments.context.pageData['budgetgroepsconsult'] = (___arguments.context.appData['budgetgroepsconsult']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/99659364a71ca96f178968d42f2fce56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetmdopatz']);
  await format();
  ___arguments.context.pageData['budgetmdopatz'] = (___arguments.context.appData['budgetmdopatz']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/dc5277eedcf30867919eb198931ae448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetscholing']);
  await format();
  ___arguments.context.pageData['budgetscholing'] = (___arguments.context.appData['budgetscholing']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0e03786468acfe7cce88103d5573990f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoaching']);
  await format();
  ___arguments.context.pageData['budgetcoaching'] = (___arguments.context.appData['budgetcoaching']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/66df52ab599bc4d4605fdbab2ec9357d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoordinatietaken']);
  await format();
  ___arguments.context.pageData['budgetcoordinatie'] = (___arguments.context.appData['budgetcoordinatietaken']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ec7fc435caf722a5bb5290af93f9d143/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));
  await format();
  ___arguments.context.pageData['budgetopbouwinfra'] = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/1466292dbeb6de8e0e19693b06d629d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['budgettotaal'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/15b85667f8b2491efe59dc5be4b2dce5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('15b85667f8b2491efe59dc5be4b2dce5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' AND jaar=2024 OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/eb2d8062b33538fdda3e8e6e12ea2316/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eb2d8062b33538fdda3e8e6e12ea2316', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Groepsconsult\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/10f2698d26baf92b10fe422640d276de/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('10f2698d26baf92b10fe422640d276de', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'MDO/PaTz\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b3d3479b95de2b9cccae603f34094285/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b3d3479b95de2b9cccae603f34094285', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Scholing\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/207573524be607a6c1c6826e874fea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('207573524be607a6c1c6826e874fea9a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coaching on the job\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0074fe95f8fad94e8884fc0caf4e8ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0074fe95f8fad94e8884fc0caf4e8ab2', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coördinatietaken\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/633b88654084f4d12a89e55efadf2687/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('633b88654084f4d12a89e55efadf2687', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Opbouw infrastructuur\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/8d85f7f484ccf25b162e45969bf6a748/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2025 AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2025'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/50a28c68cde3fb4a8fb381542c0fe8ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a5313f4bf8347e339c4eade136811d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedgroepsconsult'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3c7a4013e296143d9d47d92be89333c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedmdopatz'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a368cbd17349f50400233d4a6487bf39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedscholing'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b512abf16d8e6da3e644f456cdac4f4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoaching'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a8ebfb35abae6b24ea78922c0074f4e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoordinatie'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/55baa318075a1bd8c1c404bf6a085b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedopbouwinfra'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6fa78d485af6f6f6d1bba9be0dcdac3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c843e2f80775b77b51a711e83afb299f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c843e2f80775b77b51a711e83afb299f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a6cc9fc7efa8bb333d4247c84d0fc52e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a6cc9fc7efa8bb333d4247c84d0fc52e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/73f8b93f28c2d826704db521e2414073/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('73f8b93f28c2d826704db521e2414073', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d8f75cb59af9b9e3ea54684acf7a4f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8f75cb59af9b9e3ea54684acf7a4f4b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e8533b6140414d11fca7aed5ddb4968c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8533b6140414d11fca7aed5ddb4968c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c306ec81991e8fb999c760fd70e1e44c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c306ec81991e8fb999c760fd70e1e44c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/fc7744bc17dfe7fbf4bfbfa9649dcded/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc7744bc17dfe7fbf4bfbfa9649dcded', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6cf3f1d8f9044cace1cf17b82ccb24e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6cf3f1d8f9044cace1cf17b82ccb24e8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e73c1d420478f1d947391cc31e73008c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e73c1d420478f1d947391cc31e73008c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/eab629dfbd7f4928c036dc22bfafbfcb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eab629dfbd7f4928c036dc22bfafbfcb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/47837b81b0b2c648f3b5bfe524397cdb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('47837b81b0b2c648f3b5bfe524397cdb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/13ff2e8816793b54bcdf9c5653239514/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ff2e8816793b54bcdf9c5653239514', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e99eb0486adebf5f819ae5e71c7339ed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e99eb0486adebf5f819ae5e71c7339ed', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/151d795c1845ee060f73320e0103ef4a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('151d795c1845ee060f73320e0103ef4a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0c1901ca79832fe6a3882a9b866be294/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0c1901ca79832fe6a3882a9b866be294', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ad75e9465b8126566f99b3362a23b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3cfa4b18dde681a3c8df93d3e16e1708/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/503f431d5b5faf63e5afea1a84df2a8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandgroepsconsult'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/cd85d0d273c557fa4ba2d9a1f8168184/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandmdopatz'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/4fbd1a890f434f5e12e58719b56859bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandscholing'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0b378e9d2267f529cb94e152a47de283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoaching'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7ba49626e8b588f7bd7bbc2dd1fbfcc8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoordinatie'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d3a16f996d4e90bc920d0cb9665e3b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandopbouwinfra'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/bd938b46dafbf7ec3494e793c2f2b94d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/90361a85a3b8834c28a334d5bcce088e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro')) + (getObjectProperty(___arguments.context.pageData, 'openstaandconsultinwpro'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/8b81a556be61cfd1ceec1f0a745b4111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedgroepsconsult']) + (___arguments.context.pageData['openstaandgroepsconsult']);
  euro = (___arguments.context.pageData['budgetgroepsconsult']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3d27b3d26878cef28135293953071b52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedmdopatz']) + (___arguments.context.pageData['openstaandmdopatz']);
  euro = (___arguments.context.pageData['budgetmdopatz']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/54445c8dd2bc501296abc21dbe3bb3a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedscholing']) + (___arguments.context.pageData['openstaandscholing']);
  euro = (___arguments.context.pageData['budgetscholing']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/bbca5d3cc364099e452cc28645e416a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoaching']) + (___arguments.context.pageData['openstaandcoaching']);
  euro = (___arguments.context.pageData['budgetcoaching']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/2e176a5989a1306939badbb848fe65ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoordinatie']) + (___arguments.context.pageData['openstaandcoordinatie']);
  euro = (___arguments.context.pageData['budgetcoordinatie']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/db32b9a6675a648f8b82c303f21de791/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedopbouwinfra']) + (___arguments.context.pageData['openstaandopbouwinfra']);
  euro = (___arguments.context.pageData['budgetopbouwinfra']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/1e06fe39d44cadac049cd2a88a8cd907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaal')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaal'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/824b126c33eb3cd63dd8595ed3c68f8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setconsultinw')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0a9783d95605c6f63152a93e58d592e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setgroepsconsult']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/4284d0cd9144569f671f70dcb5a3b92e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setmdopatz']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ae2c9885141c8c8f433b60c37b959c41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setscholing']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/68d5d27230b5acf1e6e62df87da7a4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoaching']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6256ac564398545a470b969575661be7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoordinatietaken']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/26d57ba7dae535750ab5399e2865047b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7de3b5295b3b7842b7c72729efc7941c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/34ed2b476992f0a6e4e4e8a4f1cefd28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f39e324f9e48ec31c74213c26592708c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetgroepsconsult']) - (___arguments.context.pageData['besteedgroepsconsult']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e8aeb0930c95050cea025b4e124fe99e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetmdopatz']) - (___arguments.context.pageData['besteedmdopatz']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d8d77a0a9a4570e3323ab3e2d502ef1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetscholing']) - (___arguments.context.pageData['besteedscholing']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/bca1322ecb7cf2a5ce4fa958bd8254d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoaching']) - (___arguments.context.pageData['besteedcoaching']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/06c2fa7579f5a972bba8aa3a5371396d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoordinatie']) - (___arguments.context.pageData['besteedcoordinatie']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d881eb4f0158775dcffa76c990399861/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetopbouwinfra']) - (___arguments.context.pageData['besteedopbouwinfra']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/667f3c48e3956ffe73efe3824738a691/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b88a84df888397b4714e5a5370283c03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/fefd0e9ad2a7924e66310f53a0e47db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/47a1890b9aecb8879ec9a2b83bce9204/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d09b4c992fb2125f6c5f1df747457607/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d036100e7ed9acb83ad2fe8e93bbe3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/fbf31ec6fc86aa473cc58f7db268b73e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/5b9b9ecc780658a7ee9b52c2e579c181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7fc70af8ec0456e18ff41fa6dc39ec1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/320167587f0601545ed86ff266a9a32d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/df77d477ecff3d38b334b8cbf6838ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/4a7a98ac5fdd7bdf65c6e6bfca3a7e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'dossieraanmaker')),[`label`]: (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/190739bfbd5238033e4f1d481d0e86bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var N, item, M, L, K, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Achtergrondinformatie';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
  } else {
    F = 'Status';
    G = 'Toelichting';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    H = 'Leeftijd';
    I = 'Gender';
  } else {
    J = 'Aangenomen door';
    K = 'Geboortedatum';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    J = 'Aangenomen door';
  } else {
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
  } else {
    L = 'Verwijzer contactgegevens';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M && (getObjectProperty(item, 'title')) != N);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'regio')),[`label`]: (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Toegekend door ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Doelgroep';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var K, item, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    E = 'Betrokken disciplines';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
  } else {
    F = 'Omschrijving';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J, K, L, M;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
  } else {
    E = 'Organisatie die de scholing afneemt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    F = 'Team dat geschoold wordt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    G = 'Bestaand of nieuw';
    H = 'Naam scholing';
    I = 'Leerdoelen';
    J = 'Doelgroep scholing';
    K = 'Organisatie van de scholing';
    L = 'Locatie scholing';
    M = 'Verwacht aantal deelnemers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/61dd0bccaa0aeec9fc1dfabce0dc7676/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3eae46f51f4143753db9f87af6a99ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/23e1c5223c82007889230b7891020864/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenverlenging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet akkoord geven. Stuur een mail naar de coordinator.');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'VERLENGING BEHANDELD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join('')),'sortBy': 'Dossier DESC' })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/5a86c2b9221cca5eb54c8b8605d6bad5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Openstaand bedrag';
  } else {
    text = 'Bedrag openstaande werkminuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/30d86d04965ea9b4dbf5d7bf449225b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenaantekeningen', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-pagina alle notities bekeken'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'pagina alle notities bekeken',[`dossier`]: undefined,[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/2a4f8f4f6666a285e5facfdfa6b4b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a4f8f4f6666a285e5facfdfa6b4b31f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/e3a50f7e5bd4485aad127b9c737467f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc613a630b217e93e626880a470508e7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/ebc92f328bfdb8fb9aa2f085026c2266/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questioscholingbedrag': (getObjectProperty(___arguments.context.pageData, 'questioscholingbedrag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De eigen bijdrage is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a9c2f5452dfbe2b86e1f4733e8814297/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalender', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/aacd343f68c4bb05dd63282a3be96317/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5d1a6122cb0e48cd84f19df551bd7d3d')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/57bf086975d2bbd27452000ba0ca0d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d1a6122cb0e48cd84f19df551bd7d3d'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Programma is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/0f516cdc7a87a6ea4bf70da987e3dfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0f516cdc7a87a6ea4bf70da987e3dfbd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questiogroepsconsultprogrammabijeenkomst').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/9da46e0784b6c92e46fa5f31c65d6f52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbe190c3259a97366ce030fefddbe01')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d53211de5906121a606260195aad8ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79abb5a3590c2b9ff8ce5939cc430832')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/6255fd828bcfa9d403ef015d4008f8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.pageData, 'wlzindicatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz is aangepast');
  ___arguments.context.pageData['wlzindicatie'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/928520092141ae4e2c8634bba421e66a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.pageData, 'wlzindicatiesoort')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz indicatie is aangepast');
  ___arguments.context.pageData['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d1ff33dff6da76fdc4e107e65544c786/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cbf77d19f4fa2292df687b656f521de')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d06bb12b3dc6fcf25c18762379a7e1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d99043cb0e2beb14692b289ca3f3a56')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f3e33b580a8a6528ea34f2d393596f23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurcontactpersoon': (getObjectProperty(___arguments.context.pageData, 'factuurcontactpersoon')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De contactpersoon voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/458800d42e473d4a95c7bc165d45fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurmailadres': (getObjectProperty(___arguments.context.pageData, 'factuurmailadres')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Het emailadres voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/341f4ca6cebbded4944b69746ecc11ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/503b31d353cfd70f674baddc726ca10d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f77f4042ef5bc25c5ea8cf7d4ea64945/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true) {
    return2 = 'Resterende activiteiten/ minuten op dossier';
  } else {
    return2 = 'Resterende minuten op dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/98e4a0146d34b776c2aeffeb29ea81fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/32e73059454f19165d0147ca564a76ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/d0949bf9f98b6f35b12427fc37a6f8bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/fefbe76de87b4fa35153a6e37dd7f8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('chartverlengingbrabant', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/3dec7a07010c45a3396dea41a0bbdb12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/1e191665dc4e26d95b2e1b74c861967e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/88e23952ed55134c3a77d72960e3122f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/82186e3b732d07b322bc5dd6e6d7ffcd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/33a6cea49fff954dca096566d2b90c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8553db664a7b49b4869ab7f3c06ff17f')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/4503288cc2c85e84af1ae5357c5b1b78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwachtergrondinformatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Achtergrondinformatie is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/8553db664a7b49b4869ab7f3c06ff17f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8553db664a7b49b4869ab7f3c06ff17f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questioconsultinwachtergrondinformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/a7bbca3209812702649e08f59bdf152b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7bbca3209812702649e08f59bdf152b', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))).setProperties('naam').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b25db17d25541ed4ad434ee940f48692/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('dossierdelen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))))) == 0) {
    result = false;
  } else {
    result = true;
  }

  return result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/b6e964abb716dad44771ca67249679a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/7f98d6bd268de8850d18878aa702e1bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = '(incl. openstaand bedrag)';
  } else {
    text = '(incl. openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/c6ac4a32b1cfbbaa721786b9818d2863/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'budget 2024 min totaal besteed bedrag';
  } else {
    text = '(zonder openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f0d800a8ec688e8d12d8b5f8a6260fb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempljm')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/279805982d082158f4c6b24c5c08c828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriowillempljm')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/cbf8dc6823474a837846186851fdf37b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('aanmaakmaand ASC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/f6cc3797906875c83651ff28a338cc28/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('aanmaakjaar DESC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakjaar')),[`label`]: (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/2d66a56862c2faf82f58510d19fec1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteraanmaakmaand'] = '%';
  ___arguments.context.pageData['filteraanmaakjaar'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakmaand')),'\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteraanmaakjaar')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/18586ec60fc853be3e9832a86ee801e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenbackup/components/01a814f25e3f50e691fb3b497a0f70bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/2a07c8910267501fa1bd76cf01986c99/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.pageData, 'akkoord'));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var verlengingemail, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  verlengingemail = (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlengingusername')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`email`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(verlengingemail, 'email'));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a17dbd9b93d8a526687801fcdaa1196e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('476e6f7a6be44c614b8d19ab5f0778e5', true);
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d4ac8786d45b62142983dd898a80d98', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
    } else if (false) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
    } else if (false) {
    } else if (false) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  }
  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'))) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))), ({ 'value': '%','label': 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ [`startpakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'start')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingpakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['start'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablemail')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablemail'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null,[`pakketminutenakkoord`]: null,[`status`]: 'Afgesloten',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'NIET AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0,[`pakketminutenakkoord`]: null,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'TE BEHANDELEN',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  }
  ___arguments.context.pageData['disablemail'] = false;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/fb2254d1d9cba6b1c47e26b4a1d53b43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/50e3d8cf1d5b5021dca38b96f68fee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/4f5920c69d1b7abd2f822e09cb1d21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));
  await format();
  ___arguments.context.pageData['budgetconsultinwpro'] = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ac961463f293122c2af42bd2bc951f7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetgroepsconsult']);
  await format();
  ___arguments.context.pageData['budgetgroepsconsult'] = (___arguments.context.appData['budgetgroepsconsult']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/99659364a71ca96f178968d42f2fce56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetmdopatz']);
  await format();
  ___arguments.context.pageData['budgetmdopatz'] = (___arguments.context.appData['budgetmdopatz']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/dc5277eedcf30867919eb198931ae448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetscholing']);
  await format();
  ___arguments.context.pageData['budgetscholing'] = (___arguments.context.appData['budgetscholing']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0e03786468acfe7cce88103d5573990f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoaching']);
  await format();
  ___arguments.context.pageData['budgetcoaching'] = (___arguments.context.appData['budgetcoaching']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/66df52ab599bc4d4605fdbab2ec9357d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoordinatietaken']);
  await format();
  ___arguments.context.pageData['budgetcoordinatie'] = (___arguments.context.appData['budgetcoordinatietaken']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ec7fc435caf722a5bb5290af93f9d143/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));
  await format();
  ___arguments.context.pageData['budgetopbouwinfra'] = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/1466292dbeb6de8e0e19693b06d629d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['budgettotaal'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/15b85667f8b2491efe59dc5be4b2dce5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('15b85667f8b2491efe59dc5be4b2dce5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' AND jaar=2023 OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/eb2d8062b33538fdda3e8e6e12ea2316/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eb2d8062b33538fdda3e8e6e12ea2316', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Groepsconsult\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/10f2698d26baf92b10fe422640d276de/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('10f2698d26baf92b10fe422640d276de', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'MDO/PaTz\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b3d3479b95de2b9cccae603f34094285/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b3d3479b95de2b9cccae603f34094285', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Scholing\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/207573524be607a6c1c6826e874fea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('207573524be607a6c1c6826e874fea9a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coaching on the job\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0074fe95f8fad94e8884fc0caf4e8ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0074fe95f8fad94e8884fc0caf4e8ab2', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coördinatietaken\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/633b88654084f4d12a89e55efadf2687/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('633b88654084f4d12a89e55efadf2687', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Opbouw infrastructuur\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/8d85f7f484ccf25b162e45969bf6a748/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2023'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/50a28c68cde3fb4a8fb381542c0fe8ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a5313f4bf8347e339c4eade136811d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedgroepsconsult'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3c7a4013e296143d9d47d92be89333c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedmdopatz'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a368cbd17349f50400233d4a6487bf39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedscholing'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b512abf16d8e6da3e644f456cdac4f4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoaching'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a8ebfb35abae6b24ea78922c0074f4e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoordinatie'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/55baa318075a1bd8c1c404bf6a085b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedopbouwinfra'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6fa78d485af6f6f6d1bba9be0dcdac3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c843e2f80775b77b51a711e83afb299f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c843e2f80775b77b51a711e83afb299f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a6cc9fc7efa8bb333d4247c84d0fc52e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a6cc9fc7efa8bb333d4247c84d0fc52e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/73f8b93f28c2d826704db521e2414073/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('73f8b93f28c2d826704db521e2414073', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d8f75cb59af9b9e3ea54684acf7a4f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8f75cb59af9b9e3ea54684acf7a4f4b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e8533b6140414d11fca7aed5ddb4968c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8533b6140414d11fca7aed5ddb4968c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c306ec81991e8fb999c760fd70e1e44c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c306ec81991e8fb999c760fd70e1e44c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/fc7744bc17dfe7fbf4bfbfa9649dcded/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc7744bc17dfe7fbf4bfbfa9649dcded', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6cf3f1d8f9044cace1cf17b82ccb24e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6cf3f1d8f9044cace1cf17b82ccb24e8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e73c1d420478f1d947391cc31e73008c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e73c1d420478f1d947391cc31e73008c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/eab629dfbd7f4928c036dc22bfafbfcb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eab629dfbd7f4928c036dc22bfafbfcb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/47837b81b0b2c648f3b5bfe524397cdb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('47837b81b0b2c648f3b5bfe524397cdb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/13ff2e8816793b54bcdf9c5653239514/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ff2e8816793b54bcdf9c5653239514', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e99eb0486adebf5f819ae5e71c7339ed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e99eb0486adebf5f819ae5e71c7339ed', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/151d795c1845ee060f73320e0103ef4a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('151d795c1845ee060f73320e0103ef4a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0c1901ca79832fe6a3882a9b866be294/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0c1901ca79832fe6a3882a9b866be294', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ad75e9465b8126566f99b3362a23b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3cfa4b18dde681a3c8df93d3e16e1708/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/503f431d5b5faf63e5afea1a84df2a8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandgroepsconsult'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/cd85d0d273c557fa4ba2d9a1f8168184/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandmdopatz'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/4fbd1a890f434f5e12e58719b56859bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandscholing'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0b378e9d2267f529cb94e152a47de283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoaching'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7ba49626e8b588f7bd7bbc2dd1fbfcc8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoordinatie'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d3a16f996d4e90bc920d0cb9665e3b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandopbouwinfra'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/bd938b46dafbf7ec3494e793c2f2b94d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/90361a85a3b8834c28a334d5bcce088e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedconsultinwpro']) + (___arguments.context.pageData['openstaandconsultinwpro']);
  euro = (___arguments.context.pageData['budgetconsultinwpro']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/8b81a556be61cfd1ceec1f0a745b4111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedgroepsconsult']) + (___arguments.context.pageData['openstaandgroepsconsult']);
  euro = (___arguments.context.pageData['budgetgroepsconsult']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3d27b3d26878cef28135293953071b52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedmdopatz']) + (___arguments.context.pageData['openstaandmdopatz']);
  euro = (___arguments.context.pageData['budgetmdopatz']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/54445c8dd2bc501296abc21dbe3bb3a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedscholing']) + (___arguments.context.pageData['openstaandscholing']);
  euro = (___arguments.context.pageData['budgetscholing']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/bbca5d3cc364099e452cc28645e416a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoaching']) + (___arguments.context.pageData['openstaandcoaching']);
  euro = (___arguments.context.pageData['budgetcoaching']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/2e176a5989a1306939badbb848fe65ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoordinatie']) + (___arguments.context.pageData['openstaandcoordinatie']);
  euro = (___arguments.context.pageData['budgetcoordinatie']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/db32b9a6675a648f8b82c303f21de791/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedopbouwinfra']) + (___arguments.context.pageData['openstaandopbouwinfra']);
  euro = (___arguments.context.pageData['budgetopbouwinfra']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/1e06fe39d44cadac049cd2a88a8cd907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaal')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaal'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/824b126c33eb3cd63dd8595ed3c68f8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setconsultinw')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0a9783d95605c6f63152a93e58d592e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setgroepsconsult']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/4284d0cd9144569f671f70dcb5a3b92e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setmdopatz']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ae2c9885141c8c8f433b60c37b959c41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setscholing']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/68d5d27230b5acf1e6e62df87da7a4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoaching']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6256ac564398545a470b969575661be7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoordinatietaken']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/26d57ba7dae535750ab5399e2865047b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7de3b5295b3b7842b7c72729efc7941c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/34ed2b476992f0a6e4e4e8a4f1cefd28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetconsultinwpro']) - (___arguments.context.pageData['besteedconsultinwpro']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/f39e324f9e48ec31c74213c26592708c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetgroepsconsult']) - (___arguments.context.pageData['besteedgroepsconsult']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e8aeb0930c95050cea025b4e124fe99e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetmdopatz']) - (___arguments.context.pageData['besteedmdopatz']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d8d77a0a9a4570e3323ab3e2d502ef1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetscholing']) - (___arguments.context.pageData['besteedscholing']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/bca1322ecb7cf2a5ce4fa958bd8254d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoaching']) - (___arguments.context.pageData['besteedcoaching']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/06c2fa7579f5a972bba8aa3a5371396d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoordinatie']) - (___arguments.context.pageData['besteedcoordinatie']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d881eb4f0158775dcffa76c990399861/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetopbouwinfra']) - (___arguments.context.pageData['besteedopbouwinfra']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/667f3c48e3956ffe73efe3824738a691/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b88a84df888397b4714e5a5370283c03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/fefd0e9ad2a7924e66310f53a0e47db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/47a1890b9aecb8879ec9a2b83bce9204/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d09b4c992fb2125f6c5f1df747457607/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d036100e7ed9acb83ad2fe8e93bbe3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/fbf31ec6fc86aa473cc58f7db268b73e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/5b9b9ecc780658a7ee9b52c2e579c181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7fc70af8ec0456e18ff41fa6dc39ec1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/320167587f0601545ed86ff266a9a32d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/df77d477ecff3d38b334b8cbf6838ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/4a7a98ac5fdd7bdf65c6e6bfca3a7e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/190739bfbd5238033e4f1d481d0e86bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Toegekend door ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator'])));

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var E, item, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
  } else {
    D = 'Organisatie die de scholing afneemt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    E = 'Team dat geschoold wordt';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/61dd0bccaa0aeec9fc1dfabce0dc7676/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3eae46f51f4143753db9f87af6a99ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/23e1c5223c82007889230b7891020864/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e1c5223c82007889230b7891020864', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3d8063a20bee38e29b367076fc378f4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b69fefecb82e5d938d192f68ef26e2c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b7a589f8bab78c87e75a8b74d0f8ad3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7caca79d5c218e7834fa853ffb296a08', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('446132d56221b83dd909033daa0b5212', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ff495b82ccdb77bd4575f53d2296eab', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7de3b5295b3b7842b7c72729efc7941c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('190739bfbd5238033e4f1d481d0e86bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4f970b1bc4b6c249c342d4cd2a812b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47d8363150e6729dccb43627bc3631e9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6eb2d97b8051741c32feea6fdd374918', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af9884d7dfaf872183d4658b2731815e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'username'))) {
    (function (message) { alert(message) })('Dit dossier is uw eigen dossier, deze kunt u niet verlengen. Stuur een mail naar de coordinator.');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'VERLENGING BEHANDELD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join('')),'sortBy': 'Dossier DESC' })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var verlengingemail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  verlengingemail = (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlengingusername')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async verlengingemail => {; return ({ [`email`]: (getObjectProperty(verlengingemail, 'email')) });})))[0];
  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(verlengingemail, 'email'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleiderverlenging'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['opmerkingprojectleiderverlenging'] = undefined;
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/5a86c2b9221cca5eb54c8b8605d6bad5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Openstaand bedrag';
  } else {
    text = 'Bedrag openstaande werkminuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/30d86d04965ea9b4dbf5d7bf449225b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenaantekeningen', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-pagina alle notities bekeken'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'pagina alle notities bekeken',[`dossier`]: undefined,[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c5363ebf9fa24bb2cd7f2a652bde3dac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    return2 = 'Resterende activiteiten/ minuten op dossier';
  } else {
    return2 = 'Resterende minuten op dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/6d83ab843caf99486001011df50518c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e1c5223c82007889230b7891020864', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3d8063a20bee38e29b367076fc378f4', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b69fefecb82e5d938d192f68ef26e2c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b7a589f8bab78c87e75a8b74d0f8ad3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7caca79d5c218e7834fa853ffb296a08', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('446132d56221b83dd909033daa0b5212', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ff495b82ccdb77bd4575f53d2296eab', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7de3b5295b3b7842b7c72729efc7941c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('190739bfbd5238033e4f1d481d0e86bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4f970b1bc4b6c249c342d4cd2a812b8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('47d8363150e6729dccb43627bc3631e9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6eb2d97b8051741c32feea6fdd374918', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af9884d7dfaf872183d4658b2731815e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/a45f60ab83e3e21aa31d589f415728b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a17dbd9b93d8a526687801fcdaa1196e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('476e6f7a6be44c614b8d19ab5f0778e5', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/554b16920b87da79921e468445adc4d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d83ab843caf99486001011df50518c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('554b16920b87da79921e468445adc4d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a45f60ab83e3e21aa31d589f415728b5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/f9aebd7494c128789a35b3f4494a74a6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f9aebd7494c128789a35b3f4494a74a6')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/pltoestemmingenverlenging/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/plupdates/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plupdates/components/52095ae6b0681b0bd0081cdaa2a6dd38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltarieven', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/13c1ef17198bfba89bbc1e9b0b45097c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Februari 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/2234abbb27133ceacbff6afc2c6b9035/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Januari 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/9e692e7c164cd48fd1869a0e79fecf21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Maart 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/d754bb3f86261194b53ff1dd16a16297/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'April 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/5add3a8c6ce383452cd5d0bb192e2366/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'December 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/db494115ed0d726378fdb55c6b2c907d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'November 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/d0197056e433d3acd368cd51df7d36fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Oktober 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/9a11a91301be4b31e5ede6532a31a76b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'September 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/4dfae8c4d9ce351104bc51e7dbe89302/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Augustus 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/a24821de170cf5dcb5dc63492a541872/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Juli 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/7d7970e1efa94c5dd4921a228b45d783/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Juni 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/1b0ef55dcd361a8fd493f4a12a56ca8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Mei 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/599712cce7d4acf34cb12f4c6aa57d06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/63f454445e572807eee4a78c236453ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/6ee4d70bdc1b7ee6f5f9c2c1abd52c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4805eb06cc4cc144872d9446c7efbc5c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/2ed66d228cca697cbe040dffc4e79ab6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/19f17397bd0d97336c8566d726ba586a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/ad72056f4b0d8df72dd5aa0212838d77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/3c6660f74f1c4376017cb623e7c4b123/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/31098dd73554320f4543653210e676ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossieroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/5627fe8926135b7dc8d17069e87bca86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdates/components/9832baddd7bdb601db752836a3e22894/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plusers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdates/components/808c14d69c13f491763834cbbf3fd824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandakkoord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plupdatesgv/components/52095ae6b0681b0bd0081cdaa2a6dd38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltarieven', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/13c1ef17198bfba89bbc1e9b0b45097c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Februari 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/2234abbb27133ceacbff6afc2c6b9035/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Januari 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/9e692e7c164cd48fd1869a0e79fecf21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Maart 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/d754bb3f86261194b53ff1dd16a16297/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'April 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/5add3a8c6ce383452cd5d0bb192e2366/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'December 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/db494115ed0d726378fdb55c6b2c907d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'November 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/d0197056e433d3acd368cd51df7d36fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Oktober 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/9a11a91301be4b31e5ede6532a31a76b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'September 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/4dfae8c4d9ce351104bc51e7dbe89302/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Augustus 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/a24821de170cf5dcb5dc63492a541872/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Juli 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/7d7970e1efa94c5dd4921a228b45d783/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Juni 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/1b0ef55dcd361a8fd493f4a12a56ca8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'Mei 2023' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/599712cce7d4acf34cb12f4c6aa57d06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/63f454445e572807eee4a78c236453ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/6ee4d70bdc1b7ee6f5f9c2c1abd52c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4805eb06cc4cc144872d9446c7efbc5c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/2ed66d228cca697cbe040dffc4e79ab6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/19f17397bd0d97336c8566d726ba586a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/ad72056f4b0d8df72dd5aa0212838d77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/3c6660f74f1c4376017cb623e7c4b123/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/31098dd73554320f4543653210e676ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pldossieroverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/5627fe8926135b7dc8d17069e87bca86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plupdatesgv/components/9832baddd7bdb601db752836a3e22894/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plusers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plupdatesgv/components/808c14d69c13f491763834cbbf3fd824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plmaandakkoord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND',' GV=\'GV\' AND',' regiogv IN (\'',(getObjectProperty(___arguments.context.appData, 'regiolist')),'\')'].join(''))).setProperties(['dashboardnaam', 'regiogv', 'lastLogin', 'naam', 'organisatie', 'GV', 'username', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/plusersutrecht/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  await Backendless.Messaging.sendEmail((String('Verzoek om user te deactiveren van Applicatie Lorio -  ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))), new Backendless.Bodyparts({ htmlmessage: (['<body>','Verzoek van: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'Email: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'<br>Centra: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'<br><br>','Deze username moet gedeactiveerd worden:','<br>username: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')),'<br>naam: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),'<br>organisatie: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie'))].join('')) }), ensureArray('info@lorio.nl'), undefined);
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('87b21c497cf55673c52611530531b85e'))['label'] = 'Het verzoek tot deactivatie is verzonden.';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/7836af74b96eaf0fc8f1b77d91fd4125/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dashboardnaam')),'label': (getObjectProperty(item, 'dashboardnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/38b45228c9ab1108f4319b04e5df558f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f24bb6b6ee8444046dfd4b245e7a6503')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/d0ab53412e941c4725f9135d79ebe1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) == null) {
    (function (message) { alert(message) })('Er is geen dashboardnaam geselecteerd.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dashboardnaamopvragen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dashboardnaam': (getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) }), undefined);
    (function (message) { alert(message) })('Het verzoek is verzonden. U ontvangt zo snel mogelijk bericht.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/9aaf3981002da0488181a2b4ce275279/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/6b25fbc2-5563-4095-9099-09c255bc562e', true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/0195f4139b76266e6a18e1af444deab7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/6b25fbc2-5563-4095-9099-09c255bc562e', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/492e95763dea1c88086ae886a3f283f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://lookerstudio.google.com/reporting/6b25fbc2-5563-4095-9099-09c255bc562e', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/plusersutrecht/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5ef3787fffe97d846cd14461bbe8ba34')), 'display')) == true && ((getObjectProperty(___arguments.context.pageData, 'akkoordcoordinator')) == null) == null) {
    (function (message) { alert(message) })('Akkoord door de coördinator dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'gv')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0972e5824ad68dc30fb528fe7d2eb9a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regiogv')) == null) {
    (function (message) { alert(message) })('De regio dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    await Backendless.UserService.register( new Backendless.User({ 'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'username': String(new Date()),'password': 'CVL2022isBegonnen!','akkoordcoordinator': (getObjectProperty(___arguments.context.pageData, 'akkoordcoordinator')),'GV': (getObjectProperty(___arguments.context.pageData, 'gv')),'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'regiogv': (getObjectProperty(___arguments.context.pageData, 'regiogv')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclconsulten')),'btwinclgroepsconsulten': (getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsulten')),'btwinclscholing': (getObjectProperty(___arguments.context.pageData, 'btwinclscholing')),'btwinclcoaching': (getObjectProperty(___arguments.context.pageData, 'btwinclcoaching')),'btwinclmdopatz': (getObjectProperty(___arguments.context.pageData, 'btwinclmdopatz')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['gv'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['regiogv'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    ___arguments.context.pageData['btwinclconsulten'] = false;
    ___arguments.context.pageData['btwinclconsultenselect'] = false;
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
    ___arguments.context.pageData['btwinclgroepsconsultenselect'] = false;
    ___arguments.context.pageData['btwinclmdopatz'] = false;
    ___arguments.context.pageData['btwinclmdopatzselect'] = false;
    ___arguments.context.pageData['btwinclscholing'] = false;
    ___arguments.context.pageData['btwinclscholingselect'] = false;
    ___arguments.context.pageData['btwinclcoaching'] = false;
    ___arguments.context.pageData['btwinclcoachingselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/beb80b15f265c7764dc6ae77491c7109/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == true) {
    ___arguments.context.pageData['btwinclscholing'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclscholingselect')) == false) {
    ___arguments.context.pageData['btwinclscholing'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/45f607e2ccd2bfa5f3f27eb7785cd294/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/cd95b1a4af05c934e2bda1e92be60f47/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == true) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclgroepsconsultenselect')) == false) {
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/529a64226faf1bd297452bb48e4e1226/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == true) {
    ___arguments.context.pageData['btwinclcoaching'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclcoachingselect')) == false) {
    ___arguments.context.pageData['btwinclcoaching'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/cc464e9ed7efa588fd3aa1014bc49261/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == true) {
    ___arguments.context.pageData['btwinclmdopatz'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclmdopatzselect')) == false) {
    ___arguments.context.pageData['btwinclmdopatz'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['btwplichtig'] = false;
  ___arguments.context.pageData['btwinclconsulten'] = false;
  ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
  ___arguments.context.pageData['btwinclmdopatz'] = false;
  ___arguments.context.pageData['btwinclscholing'] = false;
  ___arguments.context.pageData['btwinclcoaching'] = false;
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/plusersutrecht/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/726d8f6221befee38d376c1d9434d3be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/bdc9b7aea44c1baad0228c23722400b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/9b9d6494a40e5b2eba2828497fa6f7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/d54d70db830f71c83111b66fcc5219f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/64b7288d8b58a322ef3183993b045f47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/plusersutrecht/components/8d0caf1b3768441e6c8dac7c89ca4cad/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND',' GV=\'GV\' AND',' regiogv IN (\'',(getObjectProperty(___arguments.context.appData, 'regiolist')),'\')'].join(''))).setProperties(['dashboardnaam', 'regiogv', 'lastLogin', 'naam', 'organisatie', 'GV', 'username', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/e2cc4f739d312076c0abcfe6d53bfb01/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND',' GV=\'GV\' AND',' regiogv IN (\'',(getObjectProperty(___arguments.context.appData, 'regiolist')),'\')'].join(''))).setProperties(['dashboardnaam', 'regiogv', 'lastLogin', 'naam', 'organisatie', 'GV', 'username', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/8f2f106b919ad96a90778edb904ff1ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND userStatus=\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND',' GV=\'GV\' AND',' regiogv IN (\'',(getObjectProperty(___arguments.context.appData, 'regiolist')),'\')'].join(''))).setProperties(['dashboardnaam', 'regiogv', 'lastLogin', 'naam', 'organisatie', 'GV', 'username', 'userStatus']).setSortBy(([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/plusersutrecht/components/6cd2b97e66cce053baae2e38eb275a0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/9536815792a757e6b413569d0eb14599/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var cent, dotnumber, euro, factor, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  euro = (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) + ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btw'));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '0') {
      factor = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '21') {
      factor = 1.21;
    }
    euro = (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) * factor;
    await format();
  }

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/projectkosten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['jaar'] = (new Date((new Date())).getFullYear());
  ___arguments.context.pageData['maand'] = '%';
  ___arguments.context.pageData['activiteit'] = '%';
  ___arguments.context.pageData['totaalbedrag'] = 0;
  await Backendless.Data.of('projectkosten').bulkUpdate( 'delete=\'1\'', ({ [`delete`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join('')),'sortBy': 'datum DESC' })));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectkosten/components/7c9b3e2d6f05b5d18891514a7d1a49aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['bedragexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/860dc125e37bb9d1462fac3e39175f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['btwbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/b0768fa389b476de8ba29539e3a70f9e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/f59bc5bde1af81fb32023e77d085b99c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'delete')) != true) {
    (function (message) { alert(message) })('Om te kunnen verwijderen moet deze regel eerst geselecteerd worden.');
  } else {
    await Backendless.Data.of('projectkosten').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref')) == null) {
    } else {
      await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref'))));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'sortBy': 'jaar DESC,maandnummer DESC' })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/97d3000c16f54fd2388b8c43efd9c874/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['delete']) == true) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['objectId']),'\''].join('')), ({ 'delete': true }) );
  } else if ((___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['delete']) == false) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['objectId']),'\''].join('')), ({ 'delete': false }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectkosten/components/db3b136b07323435ca1ad865a17dce3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09ca3fdf42811286b833e50bd10800a6'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/a423e2a366587f7708bbf9e7740aa99c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5a94d4868dbf34bc03d4fcd1ffe9ac1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/4ce1856c5d156fd3a58a744be401d1e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6d8cff8a1a31c1d8bf4f5f843c53eaa8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/bec113a68a27e526b90facf132298981/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/a59eaaa720e3d6cb2251ee02aeec4ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/bdc112055b6e713215b50008c291f9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']) - (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/6d8cff8a1a31c1d8bf4f5f843c53eaa8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/projectkosten/components/290ec30bb0783fe2692ff2e85b3d8054/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/3dd986f13b4a4ac3d70402a9ccf1844b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == '') {
    options = (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\' AND jaar>2023'].join(''))).setProperties('jaar').setSortBy('jaar DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})));
  } else {
    options = (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('jaar').setSortBy('jaar DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})));
  }

  return options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/6c5924341805e3349836e34f7302e142/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('maandnummer').setSortBy('maandnummer ASC').setGroupBy('maandnummer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maandnummer')),'label': (getObjectProperty(item, 'maandnummer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/59a6819f63c228279ebf346125cbbb25/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND jaar LIKE\'',(___arguments.context.pageData['jaar']),'\' AND maandnummer LIKE\'',(___arguments.context.pageData['maand']),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/215efca1285f8a7946fc3c84a587fe09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/c1bd02da13e7613b7b29503f9a9a6246/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/9914b302bc4a2d351146d1dc30f99c15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/1d98a116c8e261715fcb87ad1ab86688/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var maandnum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de5be9442e3b1f02d954cb5beb217dff')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'maand')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('290ec30bb0783fe2692ff2e85b3d8054')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f4ea0f45fca1be6863afca8e9b9c63b4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7846fb0cc361107310ecf2688258f5b6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    maandnum = (getObjectProperty(___arguments.context.pageData, 'maand')).slice(0, ((getObjectProperty(___arguments.context.pageData, 'maand')).indexOf('-') + 1) - 1);
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('projectkosten').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'maand')),[`maandnum`]: maandnum,[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`kostenplaats`]: (getObjectProperty(___arguments.context.pageData, 'kostenplaats')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')),[`btw`]: (getObjectProperty(___arguments.context.pageData, 'btw')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`file2`]: (getObjectProperty(___arguments.context.pageData, 'file2')),[`fileref2`]: (getObjectProperty(___arguments.context.pageData, 'file2')) }) ));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9cc4c8db2b288d5f8d94c9b9b43b5f0f');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join('')),'sortBy': 'datum desc' })));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['maand'] = null;
    ___arguments.context.pageData['activiteit'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['kostenplaats'] = null;
    ___arguments.context.pageData['bedragexbtw'] = null;
    ___arguments.context.pageData['btw'] = null;
    ___arguments.context.pageData['jaar'] = '%';
    ___arguments.context.pageData['maand'] = '%';
    ___arguments.context.pageData['activiteit'] = '%';
    ___arguments.context.pageData['file'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/9cc4c8db2b288d5f8d94c9b9b43b5f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (String('facturen/') + String((await Backendless.UserService.getCurrentUser(false))['centraname']))

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Factuurnummer', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/facturen/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/projectkosten/components/c7358b39e467a1ed297fb4e9626c6091/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'file')) == null ? '' : 'factuur 1')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/projectkosten/components/4045ebd622f215ac39de351c6c3c0e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/72f6b3e6e4962edb756d769edd31f90e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/917f67b480b130de3b4b70ed6d177da2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'','AND budgetjaar=\'',(getObjectProperty(___arguments.context.dataModel, 'jaar')),'\''].join('')), ({ [`besteed`]: (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectkosten/components/0405e4afa57ab39142fb7a6fe56134d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('13e8d9de715a9b7d478afae154e8b6b7')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/b22581ec09024e36326dea7fb5bdafb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) >= 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 500) {
    text = ['Het resterende budget voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' is kleiner dan 500 euro !'].join('');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 0) {
    text = ['Het budget is overschreden voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' !'].join('');
  } else {
    text = '';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/1a7e2434324968df318dce88f618e233/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/c21b9e8dba63a7a969194ff9d2270217/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/d113ffde2943582698079093eb315b71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/a4c6f22312ff0982460a4ecaff7af9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('91333f045884da87e22ef273f3369b92')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/1f3dcaa1cf927085666e6d9ed60a014f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('soortprojectkosten').save( ({ 'activiteit': (getObjectProperty(___arguments.context.pageData, 'toevoegensoort2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('290ec30bb0783fe2692ff2e85b3d8054', (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  ___arguments.context.pageData['toevoegensoort2'] = '';
  (function (message) { alert(message) })('De nieuwe soort is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/39c85522252d5b78d5f9e0229587e7dd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectkosten/components/601521fe8f12e41ccabe1ae8f58b918e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/72d17065c2b9a4cbfae1c5e5fa1f7af7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('def1456116bc14231627403479b1f339')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/7dad5b3f959146ae71e5cea937c81dcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenplaats').save( ({ 'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'toevoegenkostenplaats2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('601521fe8f12e41ccabe1ae8f58b918e', (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  ___arguments.context.pageData['toevoegenkostenplaats2'] = '';
  (function (message) { alert(message) })('De nieuwe kostenplaats is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/8a5a5d24e8a4d6ded2a3e4918723e768/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectkosten/components/9483957142240acd2271b126a95143da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvprojectkosten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvprojectkosten = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'exportdrechtsteden/projectkosten.csv','tableName': 'projectkosten','tableOptions': ({ [`where`]: ['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''),[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['jaar', 'maand', 'date(datum) as datum', 'activiteit', 'omschrijving', 'kostenplaats', 'bedragexbtw', 'btwbedrag', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['jaar', 'maand', 'datum', 'activiteit', 'omschrijving', 'kostenplaats', 'bedragexbtw', 'btwbedrag', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(([(Backendless.appPath),'/files/',csvprojectkosten].join('')), true, undefined);
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'projectkosten',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export projectkosten.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/de5be9442e3b1f02d954cb5beb217dff/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/9bab15478377383ca3eaf05b4965e8c7/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'file2')) == null ? '' : 'factuur 2')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/projectkosten/components/c7a63bd2a72e30c7658bc82e94d1cb96/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('facturen/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Factuurnummer', 1);
  ___arguments.context.pageData['file2'] = ([(Backendless.appPath),'/files/facturen/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/9536815792a757e6b413569d0eb14599/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent, factor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  euro = ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btw')) + (getObjectProperty(___arguments.context.pageData, 'bedragexbtw'));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '0') {
      factor = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '21') {
      factor = 1.21;
    }
    euro = (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) * factor;
    await format();
  }

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['jaar'] = (new Date((new Date())).getFullYear());
  ___arguments.context.pageData['maand'] = '%';
  ___arguments.context.pageData['activiteit'] = '%';
  ___arguments.context.pageData['totaalbedrag'] = 0;
  await Backendless.Data.of('projectkosten').bulkUpdate( 'delete=\'1\'', ({ [`delete`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join('')),'sortBy': 'datum DESC' })));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectkostenaccountant/components/7c9b3e2d6f05b5d18891514a7d1a49aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['bedragexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/860dc125e37bb9d1462fac3e39175f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['btwbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/b0768fa389b476de8ba29539e3a70f9e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/f59bc5bde1af81fb32023e77d085b99c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'delete')) != true) {
    (function (message) { alert(message) })('Om te kunnen verwijderen moet deze regel eerst geselecteerd worden.');
  } else {
    await Backendless.Data.of('projectkosten').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref')) == null) {
    } else {
      await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref'))));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/97d3000c16f54fd2388b8c43efd9c874/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['delete']) == true) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['objectId']),'\''].join('')), ({ 'delete': true }) );
  } else if ((___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['delete']) == false) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['objectId']),'\''].join('')), ({ 'delete': false }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectkostenaccountant/components/db3b136b07323435ca1ad865a17dce3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('09ca3fdf42811286b833e50bd10800a6')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/a423e2a366587f7708bbf9e7740aa99c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5a94d4868dbf34bc03d4fcd1ffe9ac1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/4ce1856c5d156fd3a58a744be401d1e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6d8cff8a1a31c1d8bf4f5f843c53eaa8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/bec113a68a27e526b90facf132298981/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/a59eaaa720e3d6cb2251ee02aeec4ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/bdc112055b6e713215b50008c291f9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']) - (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/6d8cff8a1a31c1d8bf4f5f843c53eaa8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/projectkostenaccountant/components/290ec30bb0783fe2692ff2e85b3d8054/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/3dd986f13b4a4ac3d70402a9ccf1844b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\' AND jaar>2023'].join(''))).setProperties('jaar').setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'jaar')),[`label`]: (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/6c5924341805e3349836e34f7302e142/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('maandnummer').setSortBy('maandnummer ASC').setGroupBy('maandnummer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maandnummer')),'label': (getObjectProperty(item, 'maandnummer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/59a6819f63c228279ebf346125cbbb25/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND jaar LIKE\'',(___arguments.context.pageData['jaar']),'\' AND maandnummer LIKE\'',(___arguments.context.pageData['maand']),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (item['activiteit']),'label': (item['activiteit']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/215efca1285f8a7946fc3c84a587fe09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/c1bd02da13e7613b7b29503f9a9a6246/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/9914b302bc4a2d351146d1dc30f99c15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'datum DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/1d98a116c8e261715fcb87ad1ab86688/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var maandnum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de5be9442e3b1f02d954cb5beb217dff')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'maand')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('290ec30bb0783fe2692ff2e85b3d8054')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f4ea0f45fca1be6863afca8e9b9c63b4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7846fb0cc361107310ecf2688258f5b6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    maandnum = (getObjectProperty(___arguments.context.pageData, 'maand')).slice(0, ((getObjectProperty(___arguments.context.pageData, 'maand')).indexOf('-') + 1) - 1);
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('projectkosten').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`maand`]: (getObjectProperty(___arguments.context.pageData, 'maand')),[`maandnum`]: maandnum,[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`kostenplaats`]: (getObjectProperty(___arguments.context.pageData, 'kostenplaats')),[`bedragexbtw`]: (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')),[`btw`]: (getObjectProperty(___arguments.context.pageData, 'btw')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')) }) ));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9cc4c8db2b288d5f8d94c9b9b43b5f0f');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join('')),'sortBy': 'datum desc' })));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['maand'] = null;
    ___arguments.context.pageData['activiteit'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['kostenplaats'] = null;
    ___arguments.context.pageData['bedragexbtw'] = null;
    ___arguments.context.pageData['btw'] = null;
    ___arguments.context.pageData['jaar'] = '%';
    ___arguments.context.pageData['maand'] = '%';
    ___arguments.context.pageData['activiteit'] = '%';
    ___arguments.context.pageData['file'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/9cc4c8db2b288d5f8d94c9b9b43b5f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (String('facturen/') + String((await Backendless.UserService.getCurrentUser(false))['centraname']))

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Factuurnummer', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/facturen/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/c7358b39e467a1ed297fb4e9626c6091/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'file')) == null ? '' : 'factuur')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/4045ebd622f215ac39de351c6c3c0e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND budgetjaar=\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/72f6b3e6e4962edb756d769edd31f90e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/917f67b480b130de3b4b70ed6d177da2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'','AND budgetjaar=\'',(getObjectProperty(___arguments.context.dataModel, 'jaar')),'\''].join('')), ({ [`besteed`]: (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectkostenaccountant/components/0405e4afa57ab39142fb7a6fe56134d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('13e8d9de715a9b7d478afae154e8b6b7')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/b22581ec09024e36326dea7fb5bdafb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) >= 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 500) {
    text = ['Het resterende budget voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' is kleiner dan 500 euro !'].join('');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 0) {
    text = ['Het budget is overschreden voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' !'].join('');
  } else {
    text = '';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/1a7e2434324968df318dce88f618e233/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/c21b9e8dba63a7a969194ff9d2270217/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/d113ffde2943582698079093eb315b71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/a4c6f22312ff0982460a4ecaff7af9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('91333f045884da87e22ef273f3369b92')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/1f3dcaa1cf927085666e6d9ed60a014f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('soortprojectkosten').save( ({ 'activiteit': (getObjectProperty(___arguments.context.pageData, 'toevoegensoort2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('290ec30bb0783fe2692ff2e85b3d8054', (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  ___arguments.context.pageData['toevoegensoort2'] = '';
  (function (message) { alert(message) })('De nieuwe soort is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/39c85522252d5b78d5f9e0229587e7dd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/projectkostenaccountant/components/601521fe8f12e41ccabe1ae8f58b918e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenaccountant/components/72d17065c2b9a4cbfae1c5e5fa1f7af7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('def1456116bc14231627403479b1f339')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenaccountant/components/7dad5b3f959146ae71e5cea937c81dcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenplaats').save( ({ 'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'toevoegenkostenplaats2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('601521fe8f12e41ccabe1ae8f58b918e', (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  ___arguments.context.pageData['toevoegenkostenplaats2'] = '';
  (function (message) { alert(message) })('De nieuwe kostenplaats is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/9536815792a757e6b413569d0eb14599/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent, factor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  euro = ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btw')) + (getObjectProperty(___arguments.context.pageData, 'bedragexbtw'));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '0') {
      factor = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == '21') {
      factor = 1.21;
    }
    euro = (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) * factor;
    await format();
  }

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('Projectleider')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['jaar'] = '%';
  ___arguments.context.pageData['maand'] = '%';
  ___arguments.context.pageData['naam'] = '%';
  ___arguments.context.pageData['activiteit'] = '%';
  ___arguments.context.pageData['totaalbedrag'] = 0;
  await Backendless.Data.of('projectkosten').bulkUpdate( 'delete=\'1\'', ({ [`delete`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
  ___arguments.context.pageData['INVOICE'] = 'false';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectkostenzwnl/components/7c9b3e2d6f05b5d18891514a7d1a49aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['bedragexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/860dc125e37bb9d1462fac3e39175f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['btwbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/b0768fa389b476de8ba29539e3a70f9e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/f59bc5bde1af81fb32023e77d085b99c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'delete')) != true) {
    (function (message) { alert(message) })('Om te kunnen verwijderen moet deze regel eerst geselecteerd worden.');
  } else {
    await Backendless.Data.of('projectkosten').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref')) == null) {
    } else {
      await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'fileref'))));
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/97d3000c16f54fd2388b8c43efd9c874/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'delete')) == true) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')), ({ 'delete': true }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'delete')) == false) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')), ({ 'delete': false }) );
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/db3b136b07323435ca1ad865a17dce3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09ca3fdf42811286b833e50bd10800a6'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/a423e2a366587f7708bbf9e7740aa99c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('e5a94d4868dbf34bc03d4fcd1ffe9ac1')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/4ce1856c5d156fd3a58a744be401d1e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('6d8cff8a1a31c1d8bf4f5f843c53eaa8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/bec113a68a27e526b90facf132298981/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/a59eaaa720e3d6cb2251ee02aeec4ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/bdc112055b6e713215b50008c291f9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['budget']) - (___arguments.context.getComponentDataStoreByUid('71eff1b6b17300f6e9e4915bfcbdcf1f')['besteed']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/6d8cff8a1a31c1d8bf4f5f843c53eaa8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'',' AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/projectkostenzwnl/components/290ec30bb0783fe2692ff2e85b3d8054/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/3dd986f13b4a4ac3d70402a9ccf1844b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('jaar').setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'jaar')),'label': (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/6c5924341805e3349836e34f7302e142/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('maandnummer').setSortBy('maandnummer ASC').setGroupBy('maandnummer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maandnummer')),'label': (getObjectProperty(item, 'maandnummer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/59a6819f63c228279ebf346125cbbb25/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/215efca1285f8a7946fc3c84a587fe09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/c1bd02da13e7613b7b29503f9a9a6246/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/9914b302bc4a2d351146d1dc30f99c15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/1d98a116c8e261715fcb87ad1ab86688/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var maandnum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de5be9442e3b1f02d954cb5beb217dff')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'maand')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('290ec30bb0783fe2692ff2e85b3d8054')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f4ea0f45fca1be6863afca8e9b9c63b4')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7846fb0cc361107310ecf2688258f5b6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    maandnum = (getObjectProperty(___arguments.context.pageData, 'maand')).slice(0, ((getObjectProperty(___arguments.context.pageData, 'maand')).indexOf('-') + 1) - 1);
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('projectkosten').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'maand': (getObjectProperty(___arguments.context.pageData, 'maand')),'maandnum': maandnum,'activiteit': (getObjectProperty(___arguments.context.pageData, 'activiteit')),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'omschrijving': (getObjectProperty(___arguments.context.pageData, 'omschrijving')),'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'kostenplaats')),'bedragexbtw': (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')),'btw': (getObjectProperty(___arguments.context.pageData, 'btw')),'file': (getObjectProperty(___arguments.context.pageData, 'file')),'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'aantal': (getObjectProperty(___arguments.context.pageData, 'aantal')) }) ));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9cc4c8db2b288d5f8d94c9b9b43b5f0f');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', null);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d85d18cd9b6c2b75809df29fcdd64311', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budget', 'budgetjaar', 'besteed']).setPageSize(100))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('251fd99e41e622a646745b7a1b6db623')), 'display')) == true) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a3acf1a285c2d38cd58d998397b4c98f', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['naam', 'maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit,naam').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ecbbfdf587a83acc974b9d01c65f79', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['naam', 'maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit,naam').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
      await new Promise(r => setTimeout(r, 2000 || 0));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['maand'] = null;
    ___arguments.context.pageData['activiteit'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['aantal'] = null;
    ___arguments.context.pageData['kostenplaats'] = null;
    ___arguments.context.pageData['bedragexbtw'] = null;
    ___arguments.context.pageData['btw'] = null;
    ___arguments.context.pageData['jaar'] = '%';
    ___arguments.context.pageData['maand'] = '%';
    ___arguments.context.pageData['activiteit'] = '%';
    ___arguments.context.pageData['file'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/9cc4c8db2b288d5f8d94c9b9b43b5f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (String('facturen/') + String((await Backendless.UserService.getCurrentUser(false))['centraname']))

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('Factuurnummer', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/facturen/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(await Backendless.Counters.get('Factuurnummer')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/c7358b39e467a1ed297fb4e9626c6091/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'file')) == null ? '' : 'factuur')

  },
  /* handler:onTextAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/4045ebd622f215ac39de351c6c3c0e4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('39e74c1bba5ec382052b30f698a5430a', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93871984ca5740ea16f51a1625d8d9e8', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a3acf1a285c2d38cd58d998397b4c98f', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['naam', 'maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC').setGroupBy('maand,activiteit,naam').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ecbbfdf587a83acc974b9d01c65f79', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['naam', 'maand', 'activiteit', 'sum(totaalbedrag) as totaalbedrag', 'maandnummer', 'jaar']).setSortBy('jaar ASC,maandnummer ASC. naam ASC').setGroupBy('maand,activiteit,naam').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1e83f46c617d85486a9bff5aeb45a073', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'activiteit', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC,activiteit ASC').setGroupBy('jaar,activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('092e76f16402f286191ce9a61514b3cb', (await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['jaar', 'sum(totaalbedrag) as totaalbedrag']).setSortBy('jaar ASC').setGroupBy('jaar').setPageSize(100))));
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('19310608ec0527242eb5c746d943f9bc', (await Backendless.Data.of('projectkostenbudget').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['budgetjaar', 'budget', 'besteed']).setSortBy('budgetjaar ASC').setGroupBy('budgetjaar').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/72f6b3e6e4962edb756d769edd31f90e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4045ebd622f215ac39de351c6c3c0e4c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72f6b3e6e4962edb756d769edd31f90e', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/917f67b480b130de3b4b70ed6d177da2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var besteed;


  await Backendless.Data.of('projectkostenbudget').bulkUpdate( (['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\'','AND budgetjaar=\'',(___arguments.context.dataModel['jaar']),'\''].join('')), ({ 'besteed': (___arguments.context.dataModel['totaalbedrag']) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectkostenzwnl/components/0405e4afa57ab39142fb7a6fe56134d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('13e8d9de715a9b7d478afae154e8b6b7')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/b22581ec09024e36326dea7fb5bdafb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) >= 0 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 500) {
    text = ['Het resterende budget voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' is kleiner dan 500 euro !'].join('');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budget')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'besteed')) < 0) {
    text = ['Het budget is overschreden voor ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b532d1043b5bd79c7a362a47658fb25e'), 'budgetjaar')),' !'].join('');
  } else {
    text = '';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/1a7e2434324968df318dce88f618e233/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/c21b9e8dba63a7a969194ff9d2270217/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/d113ffde2943582698079093eb315b71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f42f0e35866bcfa847add4491bce9b2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/a4c6f22312ff0982460a4ecaff7af9f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('91333f045884da87e22ef273f3369b92')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/1f3dcaa1cf927085666e6d9ed60a014f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('soortprojectkosten').save( ({ 'activiteit': (getObjectProperty(___arguments.context.pageData, 'toevoegensoort2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('290ec30bb0783fe2692ff2e85b3d8054', (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('activiteit').setSortBy('activiteit ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91333f045884da87e22ef273f3369b92', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3155ab942e269ca94dcbb9fd52853b2', false);
  ___arguments.context.pageData['toevoegensoort2'] = '';
  (function (message) { alert(message) })('De nieuwe soort is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/39c85522252d5b78d5f9e0229587e7dd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/601521fe8f12e41ccabe1ae8f58b918e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/72d17065c2b9a4cbfae1c5e5fa1f7af7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('def1456116bc14231627403479b1f339')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/7dad5b3f959146ae71e5cea937c81dcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenplaats').save( ({ 'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'toevoegenkostenplaats2')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('601521fe8f12e41ccabe1ae8f58b918e', (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def1456116bc14231627403479b1f339', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97226cbe9f0c3261c268313df8cf57fc', false);
  ___arguments.context.pageData['toevoegenkostenplaats2'] = '';
  (function (message) { alert(message) })('De nieuwe kostenplaats is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/96487218e113f5ca01bf76ca2016512f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkosten').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/db547fb4fb51b1c21a427e651b34141a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['naam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8477a244d6d5e306d21b4a62ddf70db2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'projectkosten','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naam')),'\' AND maandnummer LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'activiteit')),'\''].join('')),'sortBy': 'jaar ASC,maandnummer ASC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/43b62c0418888a947f45d962843e05c6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fb6106dd505132df02c68cf93d914022'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/cd128d37f46a3719497f0d4ddd051e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format2() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5e7bae3a9c19ddac96070835bfd82484'), 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/b384c144bcad1dfba24aa95e4dbcfa7c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'controle')) == true) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')), ({ 'controle': true,'controledatum': (new Date()),'controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('projectkostenakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'email')), ccAddresses: 'facturencvlzwnl@bravis.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'naam')),'datum': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'datumgoed')),'activiteit': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'activiteit')),'controledoor': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'controledoor')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'controle')) == false) {
    await Backendless.Data.of('projectkosten').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6dea6f26cc2cb6a6fbeb17062805f842'), 'objectId')),'\''].join('')), ({ 'controle': false,'controledatum': null,'controledoor': null }) );
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zw98klw' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio' ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/c97943a4c75d8f277414bc61fc021836/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['print'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('395c5d4d0f2b087e6737d8d6bf3c3a3c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a7e2434324968df318dce88f618e233', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cd56aa9704206c1ebd1dc5b78180b77', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4ba60ce4fa2bc95652a8e74332204fd', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('395c5d4d0f2b087e6737d8d6bf3c3a3c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a7e2434324968df318dce88f618e233', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f42f0e35866bcfa847add4491bce9b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cd56aa9704206c1ebd1dc5b78180b77', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('251fd99e41e622a646745b7a1b6db623', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4ba60ce4fa2bc95652a8e74332204fd', true);
  ___arguments.context.pageData['print'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkostenzwnl/components/b43ca3e2d47fa797f91ab6456348f542/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/a3c9eacfc8afcb2bf24d5a1dbbfc3994/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/7a5c87161c66c76fc929a01aa8c888bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/1aae082f97da9a2aa1c7631dbe2bc7e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projectkostenzwnl/components/be8d7a13beed4503741ee76d3c67c80d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'print')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var financieringstroom, financieringvws, timestamp, tariefreistijdkm, reistijdbereking;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0985fefe8c6d33f402280ab9bac8bfe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e06bab19254855280afeb3aff91a8b4f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45ed687869fbd75aa7988ce89d997b78')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa1d7ffcd0634443ddd826d464dd46f6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingorganisatielocatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7bc49f69f64ee1583fd5501d1de2ce6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingdeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58098b8252c73b715878d9a7b63a9908')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingdoelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d387fc0204d9bc73451dca436c538ad7')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingspecifiekedoelgroepteam')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7e8c16c3c49f4a4308a42993689a2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingonderdeelscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6fa582b551091e465ce8eda622af57be')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2ecd32a6ea15c96889628a8f3c864df3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cb74f724b912e8997e6f96c8eae5de2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      tariefreistijdkm = 0;
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 1;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 1;
      }
    } else {
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdbereking = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdbereking <= 0) {
        reistijdbereking = 0;
      }
    } else {
      reistijdbereking = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringtarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`coachingorganisatielocatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingorganisatielocatie')),[`coachingdeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingdeelnemers')),[`coachingdoelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingdoelgroep')),[`coachingspecifiekedoelgroepteam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingspecifiekedoelgroepteam')),[`coachingonderdeelscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coachingonderdeelscholing')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`voorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel1')),[`activiteit`]: 'Coaching on the job',[`reistijdminutenspeciaal`]: reistijdbereking,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoaching')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`coachingnaamorgpro`]: (getObjectProperty(___arguments.context.pageData, 'coachingnaamorgpro')),[`coachingfunctiepro`]: (getObjectProperty(___arguments.context.pageData, 'coachingfunctiepro')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclvoorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`postcodesvertrekenaankomstlocatie`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join(''),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoaching/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var visible, text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' ,vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdcoaching'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/d387fc0204d9bc73451dca436c538ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('coachingdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((___arguments.context.appData['centraname']))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (item['coachingspecifiekedoelgroep']),'label': (item['coachingspecifiekedoelgroep']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/aad9769e299f0a18e84dfe9f0047ba57/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoaching/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f04c8ab360db481db6d829be6c1d623', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiecoaching/components/c2ed4daaf2f69dd885629a1ae66162d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/d04ece040acf125b18e28a55ac4b7333/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/f542002fb02dcb655c65e7a33c0f9eed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['coachingnaamorgpro'] = (getObjectProperty(___arguments.context.dataModel, 'naamorgpro'));
  ___arguments.context.pageData['coachingfunctiepro'] = (getObjectProperty(___arguments.context.dataModel, 'functiepro'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiecoaching/components/f334c6ac7d3e0a21b4dd6ab4cecf758c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/e0985fefe8c6d33f402280ab9bac8bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('730ace95b7e8f593c691aa0c3df7d7c5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06bab19254855280afeb3aff91a8b4f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('930af3ddeec3e086f98acc42152698c8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0f87898e205e5888931d2831ff82ea6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45ed687869fbd75aa7988ce89d997b78', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclvoorbereidingminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('730ace95b7e8f593c691aa0c3df7d7c5', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('930af3ddeec3e086f98acc42152698c8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0f87898e205e5888931d2831ff82ea6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45ed687869fbd75aa7988ce89d997b78', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06bab19254855280afeb3aff91a8b4f', true);
    }
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('730ace95b7e8f593c691aa0c3df7d7c5', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('930af3ddeec3e086f98acc42152698c8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0f87898e205e5888931d2831ff82ea6', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('45ed687869fbd75aa7988ce89d997b78', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e06bab19254855280afeb3aff91a8b4f', true);
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/e06bab19254855280afeb3aff91a8b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/730ace95b7e8f593c691aa0c3df7d7c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/cc6df8c9a8293f089c56679fa128a143/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/e818b92496847353c89a2159800bcd9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    } else {
      (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e818b92496847353c89a2159800bcd9c')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange *//* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Aantal minuten voorbereiding (max. 50% van de coachingsduur)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Aantal minuten voorbereiding (max. 50% van de coachingsduur) - VWS subsidie';
  } else {
    text = 'Aantal minuten voorbereiding (max. 50% van de coachingsduur)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/b8be01989232e2a4491a0dde913d6bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal gewerkte minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/6fa582b551091e465ce8eda622af57be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiecoaching/components/1d99994874c978c57774bc0104a1ad3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal minuten voorbereiding - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/02797c684f9f7e9fe95344f5d04c6cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange *//* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclvoorbereidingminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiecoaching/components/af36701589234c5f26b8aa646b38f1f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Reistijd in minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/dd06cda7bec92fe4a5e2159419f43307/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiecoaching/components/802cb3fc133fd9d88f8a8c9a2c99182e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/263567e2e62a7de639d2145dbeeb7a3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiecoaching/components/b41c9e629db663780783a55fbcd57ba2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/dbb516486595d6b9d2572ddb7e171ebc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/17d2d76ce49e55232fc35af2cd46b50a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/2cb74f724b912e8997e6f96c8eae5de2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/41e73943589b776cf646e2232824d7a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/f1da011bde0986abbf9ef1eb31f8f02d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/2ecd32a6ea15c96889628a8f3c864df3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiecoaching/components/f6d6edc557ee60fadd04a472abf12c77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/f7bc49f69f64ee1583fd5501d1de2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {  
  	  if (document.activeElement.type === "number") {  
  	    document.activeElement.blur();  
  	  }  
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoaching/components/7d1e17a95c8986b40b6d64412b392787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/26e368d415a66a057174bb5b95754abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/9fbaff52df9a5704983790f2f09307c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/7b9ccac9775200d247934ae3f4134b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoaching/components/930af3ddeec3e086f98acc42152698c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')).toLowerCase());

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['listcat'] = [];
  ___arguments.context.pageData['listcat2'] = [];
  ___arguments.context.pageData['listthematiek'] = [];
  ___arguments.context.pageData['listproces'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieconsult1/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp, consultbetrokken, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  temp = ({ [`activiteit`]: 'Consult 1' });
}

/**
 * Describe this function...
 */
async function original() {
  temp = ({ [`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`consultinwthemasthematiek`]: String(getObjectProperty(___arguments.context.pageData, 'listthematiek')),[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultinwthemasproces`]: String(getObjectProperty(___arguments.context.pageData, 'listproces')),[`consultbetrokken`]: consultbetrokken,[`consultaantbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`activiteit`]: 'Consult 1',[`reistijdminutenspeciaal`]: undefined,[`tariefperminuut`]: undefined,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgender')),[`financieringvws`]: 'Nee',[`financieringstroom`]: 'Op je plek',[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroomwelke')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamklachtenreglement`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`postcodesvertrekenaankomstlocatie`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) });
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f670ff334eac3454adb81326d29f9be')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14a5476d80812a69b9dceccb0a6b7a98')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e265f19d1dac19cb7a4fb648ecacc9c8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46d3f809f42d5b9b9342d8166c24382f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a74eeb6fcddb5537bc77e611d78f125b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2cad7af959656445172f14a933b8647')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('25e7a36dac698025fafc874bf9d7f7fd')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a3f3d7879f6948cadb88611ddd86f737')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('763b44a3298d67fd583765af29fe7f0e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat2')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4a62c499ba34754b4520e7db1e89ec5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12f30128f8267911891fa7180601f301')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listthematiek')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98716d7b2791883365e76d9b8a89c7d2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbc339ff89b102dfac53d6628534942e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listproces')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef267332c79a59bf3d9b114239fca505')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4220fd4ff19a88f542c46fdfe7f9d95')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6afa781ec5b27462d6e87b69edf27016')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c34c3a3178badb3ca412986968d7bbc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08f25acf4c9e5c6808e7b15138ce4bfe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'ojpopjeplek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Nee') {
      consultbetrokken = 'Er waren geen anderen bij het gesprek betrokken';
    } else {
      consultbetrokken = String(getObjectProperty(___arguments.context.pageData, 'listcat2'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`consultinwthemasthematiek`]: String(getObjectProperty(___arguments.context.pageData, 'listthematiek')),[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultinwthemasproces`]: String(getObjectProperty(___arguments.context.pageData, 'listproces')),[`consultbetrokken`]: consultbetrokken,[`consultaantbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`activiteit`]: 'Consult 1',[`reistijdminutenspeciaal`]: undefined,[`tariefperminuut`]: 0,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgender')),[`financieringvws`]: 'Nee',[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroomwelke')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamklachtenreglement`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`postcodesvertrekenaankomstlocatie`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')),[`ojpverhaalbetrokkene`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'ojpverhaalbetrokkene')),[`ojpindrukgesprekspartners`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'ojpindrukgesprekspartners')),[`ojpopjeplek`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'ojpopjeplek')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsult1/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', false);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdconsultinw'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsult1/components/084b2b5cba0664db469c2aabe8c2e9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('084b2b5cba0664db469c2aabe8c2e9fb')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/a7f3f6cd1a6fe09bcf2d7fec8ee9b083/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De totale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = '';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/a35d9fcca7127fb886d3cc1a681415b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : false) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['dossieraanmaker'] = (getObjectProperty(___arguments.context.dataModel, 'dossieraanmaker'));
  ___arguments.context.pageData['consultinwgeboortejaar'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgeboortejaar'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['ojpprojectnaam'] = (getObjectProperty(___arguments.context.dataModel, 'ojpprojectnaam'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['resterend']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsult1/components/ef267332c79a59bf3d9b114239fca505/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('consultwijze').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((___arguments.context.appData['centraname']))) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['consultwijze']),'label': (item['consultwijze']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 2';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdoverijssel'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 1';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/c2cad7af959656445172f14a933b8647/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/a74eeb6fcddb5537bc77e611d78f125b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/94e6ff38a1e43def59530577d9df7fd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : false) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/25e7a36dac698025fafc874bf9d7f7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Gewerkte tijd -  ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/e0ff61469b8632ef312f197f7ec1e0b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Reistijd in minuten - ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/4f276d4efa77ec6ed47deb0d767d2dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/0e3e0791648fd5580c1dbc32684b4f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;



  return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/6579b8df258767b6daa3e7c1f1056e31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['financieringvws'] = 'Nee';
  ___arguments.context.dataModel['financieringstroom'] = 'Op je plek';
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/08b716ca9ab20c38a1950653acb8da3f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/1b2925de3cb7152dc617f1327c7d87b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/bf798f9c5f03fa251697d494cac47102/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/939f9ff4ec3a929dc7390bcee8af6f4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'uitlegreistijdconsultinw'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/501d2633873596c2b0853f728e98247f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/14a5476d80812a69b9dceccb0a6b7a98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/ce9eeb6ebdf980952665bc522b8b9738/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/a178be7411f77b2d187ecf7e1abe92d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/a4220fd4ff19a88f542c46fdfe7f9d95/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/6afa781ec5b27462d6e87b69edf27016/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/4d4282aab075cde3b8d377d677714242/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/762595d2cc94de18c70dae8ca973332d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/b8b88783f43efdb41d0f86cc9a37e68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/a3f3d7879f6948cadb88611ddd86f737/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsultopjeplek').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/116d4fde33c6658e1ebe8a0d88c31ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat2')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat2')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat2')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie eerste graad') {
    text = 'Familie eerste graad (partner, ouders, kinderen, schoonouders, schoonzoons, schoondochters)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie tweede graad') {
    text = 'Familie tweede graad (broers, zussen, kleinkinderen, opa\'s, oma\'s, schoonzussen, zwagers, stiefzussen, stiefbroers)';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken'));
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/763b44a3298d67fd583765af29fe7f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/e265f19d1dac19cb7a4fb648ecacc9c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/12f30128f8267911891fa7180601f301/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/98716d7b2791883365e76d9b8a89c7d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/cbc339ff89b102dfac53d6628534942e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/97c3b6aff9c794590a927d4837c5097f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listthematiek')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listthematiek')).splice((((getObjectProperty(___arguments.context.pageData, 'listthematiek')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/34aec09242f12a832be9f8478bfea838/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listproces')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listproces')).splice((((getObjectProperty(___arguments.context.pageData, 'listproces')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/ae49058c1b9bc3a521bc51c2764e3d5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/ada326fd8fbabe87e7ed224ba21ee578/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/d7218f4f771ba4fb1439e51e77be923d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7218f4f771ba4fb1439e51e77be923d', (await Backendless.Data.of('consultbetrokken').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/ba9cbc27ec9ac19ffbe17a24385c8f9b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba9cbc27ec9ac19ffbe17a24385c8f9b', (await Backendless.Data.of('consultthemasthematiek').find(Backendless.DataQueryBuilder.create().setProperties('thematiek').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/fe8d8b11f2529b6c19fea39ada49c6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fe8d8b11f2529b6c19fea39ada49c6ad', (await Backendless.Data.of('consultthemasproces').find(Backendless.DataQueryBuilder.create().setProperties('proces').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsult1/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/d51e60f69935a99e369d048e844cde44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/8c34c3a3178badb3ca412986968d7bbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/fc81ecebc43e2cb53fb94e26bd1ce2de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk. Het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/e5661131da1e4e21fdf89e791ee40fb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 15) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 15;
  } else if (___arguments.value == 30) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 30;
  } else if (___arguments.value == 45) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 45;
  } else if (___arguments.value == 60) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 60;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsult1/components/40292b093f8d6a511c284d4491d6bf38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsult1/components/34c5bf0e1d0baf51ee5fe349bdc2ee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsult1/components/85328a0f19afadc73f37012f93f8a299/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['listcat'] = [];
  ___arguments.context.pageData['listcat2'] = [];
  ___arguments.context.pageData['listthematiek'] = [];
  ___arguments.context.pageData['listproces'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/registratieconsultinw/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, tariefreistijdkm, tariefperminuut, reistijdberekening, gewerkteminuten, consultbetrokken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('863a12f4e6c9af17bf14cd893f41a717')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14a5476d80812a69b9dceccb0a6b7a98')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e265f19d1dac19cb7a4fb648ecacc9c8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46d3f809f42d5b9b9342d8166c24382f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a74eeb6fcddb5537bc77e611d78f125b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2cad7af959656445172f14a933b8647')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('915827dd75f3c8285b28590a4ca86658')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a3f3d7879f6948cadb88611ddd86f737')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('763b44a3298d67fd583765af29fe7f0e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat2')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4a62c499ba34754b4520e7db1e89ec5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12f30128f8267911891fa7180601f301')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listthematiek')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98716d7b2791883365e76d9b8a89c7d2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbc339ff89b102dfac53d6628534942e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listproces')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef267332c79a59bf3d9b114239fca505')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4220fd4ff19a88f542c46fdfe7f9d95')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6afa781ec5b27462d6e87b69edf27016')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('693d919ac4192166a69d8d3907c176c8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c34c3a3178badb3ca412986968d7bbc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro'))));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Nee') {
      consultbetrokken = 'Er waren geen anderen bij het gesprek betrokken';
    } else {
      consultbetrokken = String(getObjectProperty(___arguments.context.pageData, 'listcat2'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      tariefreistijdkm = 0;
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        gewerkteminuten = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      }
      tariefreistijdkm = 0;
    } else {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Lansingerland') {
        financieringvws = 'Nee';
        financieringstroom = 'Lansingerland';
      } else {
        financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
        financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt') {
      financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
      financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
      financieringvws = 'Nee';
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringtarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`consultinwthemasthematiek`]: String(getObjectProperty(___arguments.context.pageData, 'listthematiek')),[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultinwthemasproces`]: String(getObjectProperty(___arguments.context.pageData, 'listproces')),[`consultbetrokken`]: consultbetrokken,[`consultaantbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: gewerkteminuten,[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`activiteit`]: 'Consult zorgvrager',[`reistijdminutenspeciaal`]: reistijdberekening,[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgender')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroomwelke')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamklachtenreglement`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', false);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdconsultinw'])

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw/components/084b2b5cba0664db469c2aabe8c2e9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('084b2b5cba0664db469c2aabe8c2e9fb')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/a7f3f6cd1a6fe09bcf2d7fec8ee9b083/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt')) {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De totale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = '';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/a35d9fcca7127fb886d3cc1a681415b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30) {
    (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 30;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjm' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ro69lht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['consultinwleeftijd'] = (getObjectProperty(___arguments.context.dataModel, 'leeftijd'));
  ___arguments.context.pageData['consultinwverwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['consultinwdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroep'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['consultinwgeboortejaar'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgeboortejaar'));
  ___arguments.context.pageData['consultinwgender'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgender'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['financieringvwsrotterdam'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['financieringstroomrotterdam'] = (getObjectProperty(___arguments.context.dataModel, 'financieringstroom'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['resterend']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw/components/ef267332c79a59bf3d9b114239fca505/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('consultwijze').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((___arguments.context.appData['centraname']))) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['consultwijze']),'label': (item['consultwijze']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 2';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdoverijssel'] = null;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 1';
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/c2cad7af959656445172f14a933b8647/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/a74eeb6fcddb5537bc77e611d78f125b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a558356e6e58fb78c114dba869f8b8e8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e851d946e94ab81618654d2618b273', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('915827dd75f3c8285b28590a4ca86658', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a558356e6e58fb78c114dba869f8b8e8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e851d946e94ab81618654d2618b273', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('915827dd75f3c8285b28590a4ca86658', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
    }
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a558356e6e58fb78c114dba869f8b8e8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e851d946e94ab81618654d2618b273', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('915827dd75f3c8285b28590a4ca86658', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/94e6ff38a1e43def59530577d9df7fd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjm' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ro69lht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true))))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/25e7a36dac698025fafc874bf9d7f7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Aantal gewerkte minuten -  ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/46d3f809f42d5b9b9342d8166c24382f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) > 90) {
      (function (message) { alert(message) })((String('Voor individuele consulten kan maximaal 90 minuten werktijd per consult geregistreerd worden.') + String(' ,vul svp het juiste aantal minuten in.')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/e0ff61469b8632ef312f197f7ec1e0b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Reistijd in minuten - ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/85328a0f19afadc73f37012f93f8a299/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/4f276d4efa77ec6ed47deb0d767d2dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/34c5bf0e1d0baf51ee5fe349bdc2ee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Zelfbetalende cliënt') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' ,vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) > 100) {
      (function (message) { alert(message) })((String('Er mag maximaal 100 kilometer geregistreerd worden.') + String(' ,vul svp het juiste aantal kilometers in.')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/047a9d6148f754eee551916f9f56daf7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/0e3e0791648fd5580c1dbc32684b4f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;



  return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/6579b8df258767b6daa3e7c1f1056e31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/08b716ca9ab20c38a1950653acb8da3f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/1b2925de3cb7152dc617f1327c7d87b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/bf798f9c5f03fa251697d494cac47102/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/939f9ff4ec3a929dc7390bcee8af6f4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'uitlegreistijdconsultinw'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/07367f5ea54637bc3d77f56502b25058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/863a12f4e6c9af17bf14cd893f41a717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/501d2633873596c2b0853f728e98247f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/14a5476d80812a69b9dceccb0a6b7a98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/ce9eeb6ebdf980952665bc522b8b9738/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/a178be7411f77b2d187ecf7e1abe92d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/a4220fd4ff19a88f542c46fdfe7f9d95/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/6afa781ec5b27462d6e87b69edf27016/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/4d4282aab075cde3b8d377d677714242/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/762595d2cc94de18c70dae8ca973332d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/b8b88783f43efdb41d0f86cc9a37e68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/a3f3d7879f6948cadb88611ddd86f737/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult2026 ').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/116d4fde33c6658e1ebe8a0d88c31ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat2')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat2')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat2')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie eerste graad') {
    text = 'Familie eerste graad (partner, ouders, kinderen, schoonouders, schoonzoons, schoondochters)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie tweede graad') {
    text = 'Familie tweede graad (broers, zussen, kleinkinderen, opa\'s, oma\'s, schoonzussen, zwagers, stiefzussen, stiefbroers)';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken'));
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/763b44a3298d67fd583765af29fe7f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/e265f19d1dac19cb7a4fb648ecacc9c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/8107afe40116462312b95158257f6f24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam')) == 'Zelfbetalende cliënt' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/97c3b6aff9c794590a927d4837c5097f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listthematiek')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listthematiek')).splice((((getObjectProperty(___arguments.context.pageData, 'listthematiek')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/34aec09242f12a832be9f8478bfea838/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listproces')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listproces')).splice((((getObjectProperty(___arguments.context.pageData, 'listproces')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/ae49058c1b9bc3a521bc51c2764e3d5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/ada326fd8fbabe87e7ed224ba21ee578/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/d7218f4f771ba4fb1439e51e77be923d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7218f4f771ba4fb1439e51e77be923d', (await Backendless.Data.of('consultbetrokken').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/ba9cbc27ec9ac19ffbe17a24385c8f9b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba9cbc27ec9ac19ffbe17a24385c8f9b', (await Backendless.Data.of('consultthemasthematiek').find(Backendless.DataQueryBuilder.create().setProperties('thematiek').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/fe8d8b11f2529b6c19fea39ada49c6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fe8d8b11f2529b6c19fea39ada49c6ad', (await Backendless.Data.of('consultthemasproces').find(Backendless.DataQueryBuilder.create().setProperties('proces').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws'] = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
    ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringstroom'] = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
    ___arguments.context.pageData['financieringstroom'] = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/d51e60f69935a99e369d048e844cde44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/8c34c3a3178badb3ca412986968d7bbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/fc81ecebc43e2cb53fb94e26bd1ce2de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk. Het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/3f670ff334eac3454adb81326d29f9be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/2d3bad727356b80c70e720d1fd519fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/b972fbf1251f5c6fb8d16144f9323697/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/454c7e5cb35da4ef178a8d790f6afab5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/693d919ac4192166a69d8d3907c176c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/a4a62c499ba34754b4520e7db1e89ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw/components/20decd397e6e184baad3294e70634b25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')));
  (function (message) { alert(message) })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw/components/be172e41983317515b8ac4ab1439be91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Hoelang heeft het consult geduurd?';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Hoelang heeft het consult geduurd?';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Hoelang heeft het consult geduurd? - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Hoelang heeft het consult geduurd? - VWS subsidie';
  } else {
    text = 'Hoelang heeft het consult geduurd?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw/components/4b23bce3501698cc0d5b7bba81af3868/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30) {
    (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 30;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw/components/a558356e6e58fb78c114dba869f8b8e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')).toLowerCase());

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['listcat'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp, tariefreistijdminutenspeciaal, tariefperminuut, reistijdminutenspeciaal, reistijdkm, gewerkteminuten, datumconsult, financieringnietdeclreistijdkm, financieringnietdeclwerkminuten, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud_ZHN() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
    gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd') {
    gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
    gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
  }
}

/**
 * Describe this function...
 */
async function oud_haaglanden() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
    financieringnietdeclwerkminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
  }
  financieringnietdeclreistijdkm = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm'));
}


  if ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true') {
    date = (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'jaar'))].join(''))));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    datumconsult = (date.valueOf());
  } else {
    datumconsult = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'));
  }
  if (datumconsult == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb38a66c3def5eaa4f22163cbab59dc9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'dag')) == null) {
    (function (message) { alert(message) })('Vul de dag van het datum van het consult in.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb38a66c3def5eaa4f22163cbab59dc9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'maand')) == null) {
    (function (message) { alert(message) })('Vul de maand van het datum van het consult in.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb38a66c3def5eaa4f22163cbab59dc9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'jaar')) == null) {
    (function (message) { alert(message) })('Vul de jaar van het datum van het consult in.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0306cfa52b840bb9c003b5052e6d1ec5')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Selecteer de belangrijkste categorie.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f3a5fab969517b2890715f78ca2483a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06d5d3b4fd7bd287281241370f3870a6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8cd7ad848fa8d1de2bc6b458afe511c7')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      gewerkteminuten = 1;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
        gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
        gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      reistijdminutenspeciaal = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
      tariefreistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = 1;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
        reistijdkm = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm'));
      } else if ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
        financieringnietdeclwerkminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten'));
        gewerkteminuten = 0;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      if ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Ja') {
        gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      } else if ((getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
        gewerkteminuten = null;
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 12396.6666666667;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefreistijdminutenspeciaal = 12396.6666666667;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      tariefreistijdminutenspeciaal = (getObjectProperty(___arguments.context.pageData, 'tariefreistijdkm'));
    } else {
      tariefreistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      reistijdminutenspeciaal = 1;
    } else {
      reistijdminutenspeciaal = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee') {
      tariefreistijdminutenspeciaal = 0;
      reistijdminutenspeciaal = 0;
      gewerkteminuten = 0;
      reistijdkm = 0;
      financieringnietdeclwerkminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      financieringnietdeclreistijdkm = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm'));
    } else {
      reistijdkm = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringnietdeclwerkminuten`]: financieringnietdeclwerkminuten,[`financieringnietdeclreistijdkm`]: financieringnietdeclreistijdkm,[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')),[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'financieringstroom')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: datumconsult,[`gewerkteminuten`]: gewerkteminuten,[`reistijdminuten`]: undefined,[`reistijdkm`]: reistijdkm,[`activiteit`]: 'Consult zorgvrager',[`reistijdminutenspeciaal`]: reistijdminutenspeciaal,[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: tariefreistijdminutenspeciaal,[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`questioconsultinwaangenomendoor`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwaangenomendoor')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`geboortedatum`]: (getObjectProperty(___arguments.context.pageData, 'geboortedatum')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwgender`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgender')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')),[`consultwijze`]: (getObjectProperty(___arguments.context.pageData, 'consultwijze')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['financieringstroom'] = (getObjectProperty(___arguments.context.dataModel, 'financieringstroom'));
  ___arguments.context.pageData['questioconsultinwdatumaanvraag'] = (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwdatumaanvraag'));
  ___arguments.context.pageData['questioconsultinwaangenomendoor'] = (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwaangenomendoor'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['geboortedatum'] = (getObjectProperty(___arguments.context.dataModel, 'geboortedatum'));
  ___arguments.context.pageData['consultinwgender'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgender'));
  ___arguments.context.pageData['consultinwverwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['questioconsultinwachtergrondinformatie'] = (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwachtergrondinformatie'));
  ___arguments.context.pageData['consultinwdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroep'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['consultinwleeftijd'] = (getObjectProperty(___arguments.context.dataModel, 'leeftijd'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['consultinwgeboortejaar'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgeboortejaar'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    offset = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')))).getTime() - (259200 * 1000)));
  } else {
    offset = 0;
  }

  return offset

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f3a5fab969517b2890715f78ca2483a')), 'display')) == false) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 1';
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var max;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    max = (new Date((new Date()).getTime() + (0 * 1000)));
  } else {
    max = (new Date((new Date()).getTime() + (604800 * 1000)));
  }

  return max

  },
  /* handler:onMaxDateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/4b347d4eba82bf3c65b58808adb184d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true))) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/8cd7ad848fa8d1de2bc6b458afe511c7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    gewerkteminuten = 1;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = 1;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == '1') {
        ___arguments.context.pageData['antwoord3'] = '15 minuten';
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == '2') {
        ___arguments.context.pageData['antwoord3'] = '30 minuten';
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == '3') {
        ___arguments.context.pageData['antwoord3'] = '45 minuten';
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == '4') {
        ___arguments.context.pageData['antwoord3'] = '60 minuten';
      }
    }
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && gewerkteminuten > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })('U heeft momenteel te weinig minuten op het dossier om de geselecteerde werktijd te kunnen declareren. Kies voor minder minuten of indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8cd7ad848fa8d1de2bc6b458afe511c7')));
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Hoelang heeft het multimediale consult geduurd?' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/673c0b52b425698dbf2f074d0b8c6f49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/0f3a5fab969517b2890715f78ca2483a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Soort consult' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/048ecb6f128d04d6659280eb3c222ded/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/edb109099df57603944a17c943cb5c25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/06d5d3b4fd7bd287281241370f3870a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true;

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    gewerkteminuten = 1;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      gewerkteminuten = 1;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '1') {
      ___arguments.context.pageData['antwoord2'] = '15 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '2') {
      ___arguments.context.pageData['antwoord2'] = '30 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '3') {
      ___arguments.context.pageData['antwoord2'] = '45 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '4') {
      ___arguments.context.pageData['antwoord2'] = '60 minuten';
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '1') {
      ___arguments.context.pageData['antwoord2'] = '15 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '2') {
      ___arguments.context.pageData['antwoord2'] = '30 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '3') {
      ___arguments.context.pageData['antwoord2'] = '45 minuten';
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == '4') {
      ___arguments.context.pageData['antwoord2'] = '60 minuten';
    }
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && gewerkteminuten > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })('U heeft momenteel te weinig minuten op het dossier om de geselecteerde werktijd te kunnen declareren. Kies voor minder minuten of indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06d5d3b4fd7bd287281241370f3870a6')));
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Hoelang heeft het consult geduurd?' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/a1740d33c71fd47de9c6cf0aed680548/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Consult 1' || ___arguments.value == 'Consult 1 zonder reistijd') {
    ___arguments.context.pageData['consultwijze'] = 'Face-to-face';
  } else if (___arguments.value == 'Consult 2') {
    ___arguments.context.pageData['consultwijze'] = 'Multimediaal consult';
  }
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
  if (___arguments.value == 'Consult 1') {
    ___arguments.context.pageData['antwoord1'] = 'Face to face consult, fysiek met reistijd';
  } else if (___arguments.value == 'Consult 1 zonder reistijd') {
    ___arguments.context.pageData['antwoord1'] = 'Face to face consult,fysiek zonder reistijd';
  } else if (___arguments.value == 'Consult 2') {
    ___arguments.context.pageData['antwoord1'] = 'Multimediaal consult zoals telefonisch, chat, videobellen';
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Soort consult' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/ff37d96919b27a729b13d9a72eded314/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true) : false;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/15c3b05da635fcba3b0a25987515a9d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1';

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Reistijd, niet verplicht' : '')

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == '15') {
    ___arguments.context.pageData['antwoord4'] = '15 minuten';
  } else if (___arguments.value == '30') {
    ___arguments.context.pageData['antwoord4'] = '30 minuten';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? 'REGISTRATIE CONSULT ZORGVRAGER' : 'REGISTRATIE CONSULT CLIËNT')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/3a2d96fc84fcd10e40b66cbfb4415633/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/170882d13e07e8f8b124e929a7c7d51b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/eb38a66c3def5eaa4f22163cbab59dc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/0167dd5cab18fafc63266b16f9075e96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/e338d178255c60393a11b7bb44ce6756/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > 60) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',60,' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e338d178255c60393a11b7bb44ce6756')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e338d178255c60393a11b7bb44ce6756')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/1dcf6a6643051162d8d7be750dd1b819/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantekeningen, het is aan uzelf of u een aantekening wilt maken. Let op AVG, noteer geen persoonsgegevens' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/48ca4f93d5d73eb363490cbee9bd54b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('729b835d8d4675f53bb544dc4142af03'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('729b835d8d4675f53bb544dc4142af03'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('729b835d8d4675f53bb544dc4142af03'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('729b835d8d4675f53bb544dc4142af03'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/0306cfa52b840bb9c003b5052e6d1ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aa24e2da52cef04ff6e7920bb664e655', (await Backendless.Data.of('belangcatconsult2026 ').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/d342120fbc542203d9a310d6b68ac6a6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Het gegeven antwoord op Soort consult is ') + String(getObjectProperty(___arguments.context.pageData, 'antwoord1')))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/b6d23d743e893816cb26f06bc137ae71/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Haaglanden' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1 zonder reistijd' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false) : false;

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Het gegeven antwoord op hoelang het consult geduurt heeft is ') + String(getObjectProperty(___arguments.context.pageData, 'antwoord2')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/311d8c063f943a13818c2ff4434a3cf9/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Het gegeven antwoord is ') + String(getObjectProperty(___arguments.context.pageData, 'antwoord3')))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false) : false;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/aa5b9b2b52ff8de9e6d633aed1d4a542/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Het gegeven antwoord op reistijd is ') + String(getObjectProperty(___arguments.context.pageData, 'antwoord4')))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' && (getObjectProperty(___arguments.context.appData, 'blind')) == 'true';

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/f9d319a3b7cfa6f841d6835a7e5f44cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/1b7ba71af44374dd7e04b47e8e8f531f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var maxtijd;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.pageData['antwoord5'] = 0;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b7ba71af44374dd7e04b47e8e8f531f')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b7ba71af44374dd7e04b47e8e8f531f')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
      maxtijd = (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
      maxtijd = 60;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > maxtijd) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(maxtijd)));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = maxtijd;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b7ba71af44374dd7e04b47e8e8f531f')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
    ___arguments.context.pageData['antwoord5'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['antwoord5'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/15f2ce969da8530a9b622edfbbd6b895/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/c5c812e97e7a368a069d2152ef87686a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function kilometerbedrag() {
  if (___arguments.value < 20) {
    ___arguments.context.pageData['tariefreistijdkm'] = 0;
  } else if (___arguments.value >= 20 && ___arguments.value <= 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 235000;
  } else if (___arguments.value > 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 470000;
  }
}


  await kilometerbedrag();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/55057f8eb5ae05a609d4dda5b5647366/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Het gegeven antwoord op gewerkte minuten is ') + String(getObjectProperty(___arguments.context.pageData, 'antwoord5')))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/7029e4eb40b45ea691e461794ee268d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/30a9e5d4ae08b477f969e3fcae3c1d9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/18cbf8e18c9138afc4fb1e2d1ae33a78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinw-questio/components/491acc2d523762276499d956fa81a009/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['listcat'] = [];
  ___arguments.context.pageData['listcat2'] = [];
  ___arguments.context.pageData['listthematiek'] = [];
  ___arguments.context.pageData['listproces'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, tariefreistijdkm, tariefperminuut, reistijdberekening, gewerkteminuten, consultbetrokken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('863a12f4e6c9af17bf14cd893f41a717')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14a5476d80812a69b9dceccb0a6b7a98')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e265f19d1dac19cb7a4fb648ecacc9c8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('46d3f809f42d5b9b9342d8166c24382f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a74eeb6fcddb5537bc77e611d78f125b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2cad7af959656445172f14a933b8647')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a3f3d7879f6948cadb88611ddd86f737')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('763b44a3298d67fd583765af29fe7f0e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat2')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4a62c499ba34754b4520e7db1e89ec5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('12f30128f8267911891fa7180601f301')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listthematiek')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98716d7b2791883365e76d9b8a89c7d2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbc339ff89b102dfac53d6628534942e')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listproces')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ef267332c79a59bf3d9b114239fca505')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a4220fd4ff19a88f542c46fdfe7f9d95')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6afa781ec5b27462d6e87b69edf27016')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('693d919ac4192166a69d8d3907c176c8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c34c3a3178badb3ca412986968d7bbc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro'))));
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Nee') {
      consultbetrokken = 'Er waren geen anderen bij het gesprek betrokken';
    } else {
      consultbetrokken = String(getObjectProperty(___arguments.context.pageData, 'listcat2'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      tariefreistijdkm = 0;
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        gewerkteminuten = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      }
      tariefreistijdkm = 0;
    } else {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Lansingerland') {
        financieringvws = 'Nee';
        financieringstroom = 'Lansingerland';
      } else {
        financieringvws = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
        financieringstroom = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`consultinwthemasthematiek`]: String(getObjectProperty(___arguments.context.pageData, 'listthematiek')),[`consultinwthemasachtergrond`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultinwthemasachtergrond')),[`consultinwthemasproces`]: String(getObjectProperty(___arguments.context.pageData, 'listproces')),[`consultbetrokken`]: consultbetrokken,[`consultaantbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: gewerkteminuten,[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`activiteit`]: 'Consult zorgvrager',[`reistijdminutenspeciaal`]: reistijdberekening,[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgeboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.pageData, 'consultinwgender')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroomwelke')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamklachtenreglement`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamklachtenreglement')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4a62c499ba34754b4520e7db1e89ec5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', false);
    ___arguments.context.pageData['listcat2'] = [];
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten - VWS subsidie';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      text = 'Reistijd in minuten';
    } else {
      text = 'Reistijd in minuten (max. 30 min retour)';
    }
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdconsultinw'])

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d918c2e71e5f05911794a1d1badcffe'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/084b2b5cba0664db469c2aabe8c2e9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('084b2b5cba0664db469c2aabe8c2e9fb')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a7f3f6cd1a6fe09bcf2d7fec8ee9b083/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De totale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = '';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a35d9fcca7127fb886d3cc1a681415b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30) {
    (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 30;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjm' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ro69lht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['consultinwleeftijd'] = (getObjectProperty(___arguments.context.dataModel, 'leeftijd'));
  ___arguments.context.pageData['consultinwverwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['consultinwdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroep'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['consultinwgeboortejaar'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgeboortejaar'));
  ___arguments.context.pageData['consultinwgender'] = (getObjectProperty(___arguments.context.dataModel, 'consultinwgender'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['financieringvwsrotterdam'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['financieringstroomrotterdam'] = (getObjectProperty(___arguments.context.dataModel, 'financieringstroom'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['resterend']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ef267332c79a59bf3d9b114239fca505/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('consultwijze').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((___arguments.context.appData['centraname']))) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['consultwijze']),'label': (item['consultwijze']) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 2';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdoverijssel'] = null;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 1';
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/c2cad7af959656445172f14a933b8647/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a74eeb6fcddb5537bc77e611d78f125b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94e6ff38a1e43def59530577d9df7fd2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2cad7af959656445172f14a933b8647', true);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/94e6ff38a1e43def59530577d9df7fd2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjm' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Ro69lht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/25e7a36dac698025fafc874bf9d7f7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Aantal gewerkte minuten -  ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/46d3f809f42d5b9b9342d8166c24382f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) > 90) {
      (function (message) { alert(message) })((String('Voor individuele consulten kan maximaal 90 minuten werktijd per consult geregistreerd worden.') + String(' ,vul svp het juiste aantal minuten in.')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/e0ff61469b8632ef312f197f7ec1e0b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Reistijd in minuten - ') + String(getObjectProperty(___arguments.context.pageData, 'financieringstroom'));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/85328a0f19afadc73f37012f93f8a299/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/4f276d4efa77ec6ed47deb0d767d2dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/34c5bf0e1d0baf51ee5fe349bdc2ee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' ,vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) > 100) {
      (function (message) { alert(message) })((String('Er mag maximaal 100 kilometer geregistreerd worden.') + String(' ,vul svp het juiste aantal kilometers in.')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/047a9d6148f754eee551916f9f56daf7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriorotterdamgvjmtest' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/0e3e0791648fd5580c1dbc32684b4f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;



  return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/6579b8df258767b6daa3e7c1f1056e31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/08b716ca9ab20c38a1950653acb8da3f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/1b2925de3cb7152dc617f1327c7d87b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/bf798f9c5f03fa251697d494cac47102/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/939f9ff4ec3a929dc7390bcee8af6f4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'uitlegreistijdconsultinw'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/07367f5ea54637bc3d77f56502b25058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/863a12f4e6c9af17bf14cd893f41a717/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/501d2633873596c2b0853f728e98247f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/14a5476d80812a69b9dceccb0a6b7a98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ce9eeb6ebdf980952665bc522b8b9738/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a178be7411f77b2d187ecf7e1abe92d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a4220fd4ff19a88f542c46fdfe7f9d95/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/6afa781ec5b27462d6e87b69edf27016/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/4d4282aab075cde3b8d377d677714242/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/762595d2cc94de18c70dae8ca973332d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/b8b88783f43efdb41d0f86cc9a37e68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Zorgvrager niet aanwezig' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a3f3d7879f6948cadb88611ddd86f737/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3c1258ef2e1a9ea630f97925e1b6dd41', (await Backendless.Data.of('belangcatconsult2026 ').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/116d4fde33c6658e1ebe8a0d88c31ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat2')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat2')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat2')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie eerste graad') {
    text = 'Familie eerste graad (partner, ouders, kinderen, schoonouders, schoonzoons, schoondochters)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken')) == 'Familie tweede graad') {
    text = 'Familie tweede graad (broers, zussen, kleinkinderen, opa\'s, oma\'s, schoonzussen, zwagers, stiefzussen, stiefbroers)';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('195cf345444d6103a44e9199a254fa23'), 'betrokken'));
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/763b44a3298d67fd583765af29fe7f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/e265f19d1dac19cb7a4fb648ecacc9c8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/8107afe40116462312b95158257f6f24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/97c3b6aff9c794590a927d4837c5097f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listthematiek')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listthematiek')).splice((((getObjectProperty(___arguments.context.pageData, 'listthematiek')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c8d3ebee9978475801c61f678dc16b9e'), 'thematiek')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/34aec09242f12a832be9f8478bfea838/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listproces')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listproces')).splice((((getObjectProperty(___arguments.context.pageData, 'listproces')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('de81625153ec1424f0a12a1684eb4088'), 'proces')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ae49058c1b9bc3a521bc51c2764e3d5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ada326fd8fbabe87e7ed224ba21ee578/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == 'Andere financieringsstroom' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/d7218f4f771ba4fb1439e51e77be923d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d7218f4f771ba4fb1439e51e77be923d', (await Backendless.Data.of('consultbetrokken').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/ba9cbc27ec9ac19ffbe17a24385c8f9b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ba9cbc27ec9ac19ffbe17a24385c8f9b', (await Backendless.Data.of('consultthemasthematiek').find(Backendless.DataQueryBuilder.create().setProperties('thematiek').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/fe8d8b11f2529b6c19fea39ada49c6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fe8d8b11f2529b6c19fea39ada49c6ad', (await Backendless.Data.of('consultthemasproces').find(Backendless.DataQueryBuilder.create().setProperties('proces').setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws'] = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
    ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.pageData, 'financieringvwsrotterdam'));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringstroom'] = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
    ___arguments.context.pageData['financieringstroom'] = (getObjectProperty(___arguments.context.pageData, 'financieringstroomrotterdam'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/d51e60f69935a99e369d048e844cde44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/8c34c3a3178badb3ca412986968d7bbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/fc81ecebc43e2cb53fb94e26bd1ce2de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk. Het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/3f670ff334eac3454adb81326d29f9be/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/2d3bad727356b80c70e720d1fd519fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/b972fbf1251f5c6fb8d16144f9323697/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/454c7e5cb35da4ef178a8d790f6afab5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/693d919ac4192166a69d8d3907c176c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/a4a62c499ba34754b4520e7db1e89ec5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultaantalbetrokken'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/20decd397e6e184baad3294e70634b25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')));
  (function (message) { alert(message) })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/be172e41983317515b8ac4ab1439be91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Hoelang heeft het consult geduurd?';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Hoelang heeft het consult geduurd?';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Hoelang heeft het consult geduurd? - VWS subsidie';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Hoelang heeft het consult geduurd? - VWS subsidie';
  } else {
    text = 'Hoelang heeft het consult geduurd?';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultinwbackup/components/4b23bce3501698cc0d5b7bba81af3868/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > 30) {
    (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 30;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' ,vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3bfb219eaa873a1f486d15145b65c4a8', (await Backendless.Data.of('belangcatconsult2026').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  ___arguments.context.pageData['listcat'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d2b1e93d3413bac929b8882d954c349', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieconsultpro/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, tariefreistijdkm, reistijdberekening, gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('561bec1c2dcb96d10a8bd4dbdeecd0a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'undefined') {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c64e35b88fa15d510cad3cb6185484')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cb26c3a973c76b4cfa2c302314f1eeb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e5f035402e271d57f87818de65ff79b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bcb1466da4dc4ff9da1ee5230a228b67')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9413e95efd34c933eacb479862ce6294')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad81a71d376c7ab2cb2b1cae460bd268')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6193bb39098a26ca92518e23506c725')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c4f224e97356dc9c1b5fb7d5d6d5a4c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        gewerkteminuten = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2') {
          gewerkteminuten = (1 / 6) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consult2aantal'));
        }
      }
      tariefreistijdkm = 0;
    } else {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: gewerkteminuten,[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`activiteit`]: 'Consult professional',[`reistijdminutenspeciaal`]: reistijdberekening,[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`consultpronaamorg`]: (getObjectProperty(___arguments.context.pageData, 'consultpronaamorg')),[`consultprofunctie`]: (getObjectProperty(___arguments.context.pageData, 'consultprofunctie')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultpro/components/561bec1c2dcb96d10a8bd4dbdeecd0a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('consultwijze').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'consultwijze')),'label': (getObjectProperty(item, 'consultwijze')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 2';
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdoverijssel'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'Consult 1';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Totaal aantal kilometers- VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' ,vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'setuitlegtijdconsultinw'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Zorgvrager niet aanwezig' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a99b70eddd26290a9b39160fdc78a972'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a99b70eddd26290a9b39160fdc78a972'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a99b70eddd26290a9b39160fdc78a972'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a99b70eddd26290a9b39160fdc78a972'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultpro/components/084b2b5cba0664db469c2aabe8c2e9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('084b2b5cba0664db469c2aabe8c2e9fb')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/a7f3f6cd1a6fe09bcf2d7fec8ee9b083/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7f3f6cd1a6fe09bcf2d7fec8ee9b083')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/a35d9fcca7127fb886d3cc1a681415b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a35d9fcca7127fb886d3cc1a681415b5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/ca0bf5d9f09fa02af4e1545e526efed6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['consultpronaamorg'] = (getObjectProperty(___arguments.context.dataModel, 'naamorgpro'));
  ___arguments.context.pageData['consultprofunctie'] = (getObjectProperty(___arguments.context.dataModel, 'functiepro'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieconsultpro/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/d0c64e35b88fa15d510cad3cb6185484/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('507725665c86d44d60a2d9fc9d9adfa1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cb26c3a973c76b4cfa2c302314f1eeb', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('507725665c86d44d60a2d9fc9d9adfa1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cb26c3a973c76b4cfa2c302314f1eeb', true);
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('507725665c86d44d60a2d9fc9d9adfa1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7cb26c3a973c76b4cfa2c302314f1eeb', true);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult1aantal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consult2aantal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/507725665c86d44d60a2d9fc9d9adfa1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/7cb26c3a973c76b4cfa2c302314f1eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/36d3cbe8ff44fc5f37cd03ff2b92756a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/665104f465dd151d44dc0a1775f558c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/4b8b704d01a2fc393d1e8eeb6d7ec345/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal gewerkte minuten -  ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/57b52de176b4aa95283439473ebd44c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Reistijd in minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/9e5f035402e271d57f87818de65ff79b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) <= 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/2601aabc5326daa2df2766be37a6c0e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/a795b3b73a6ec98c62b8f4cac9516903/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/c428abd57625f4c5d60d84cd45560907/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/bef2b87abe395c736dca8e9945df6cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/a7d6b5b80e03001b7175b5e6f82a73e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/33ee9bdb7499b4f639cb7dff902718b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['uitlegreistijdconsultinw'])

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/bcb1466da4dc4ff9da1ee5230a228b67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/95cc0f1dd7cb5cc4f6dae1fb6c8cf3b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/70a4a7bfd3d675e5da677465e57f4772/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/9413e95efd34c933eacb479862ce6294/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/b68e3b2568ddc99b2742b22fe6c9aac1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/b6193bb39098a26ca92518e23506c725/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/ad81a71d376c7ab2cb2b1cae460bd268/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieconsultpro/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieconsultpro/components/d53184412177d35c5df7f657d0d4bc3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/1c4f224e97356dc9c1b5fb7d5d6d5a4c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 2' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/ab0aefe5c94821d45e9b487fdcbcf569/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/d68d3442f1434ada7949c683548cbc8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/9ad401fdf134dc6a93080d0e3c8e50fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/6ce2ded42cfefc253acc4503513782c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieconsultpro/components/0055c68831bedd75de6a1fe281f71df4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'Consult 1' ? ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabelconsultinw')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoordinatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a82aae9c4b3a5e87dab7e728aedb5cba', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiecoordinatie/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiecoordinatie/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var btw, regio, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dd857a5fc1d4a2bf2531da6fd2056a6c')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      btw = 0;
      regio = (getObjectProperty(___arguments.context.pageData, 'regio'));
    } else {
      regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`btw`]: btw,[`financieringvws`]: 'Ja',[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`coordinatiemaanduitgevoerdetaken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'coordinatiemaanduitgevoerdetaken')),[`activiteit`]: 'Coördinatietaken',[`reistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoordinatie')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`coordinatiekortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'coordinatiekortetoelichting')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: regio,[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiecoordinatie/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatie/components/75a817eb7e530f417c0c8276b19f3ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatie/components/b2a3320e02e319014067b262150104b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')));
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoordinatie/components/969bb2f196d7cb11f02f53bba81cf567/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['coordinatiekortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiecoordinatie/components/dd857a5fc1d4a2bf2531da6fd2056a6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoordinatie/components/38ffcda7a7aeee1f31ec87de2c8a738b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiecoordinatie/components/c402e577e5eff551b02c28934107f0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoordinatorschap/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await regiogvpl();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiecoordinatorschap/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'kwartaalfilter')) == null) {
    (function (message) { alert(message) })('Het kwartaal moet geselecteerd worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`coordinatorschap`]: [(getObjectProperty(___arguments.context.pageData, 'kwartaalfilter')),' ',(new Date((new Date(timestamp))).getFullYear()),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl'))].join(''),[`financieringvws`]: 'Ja',[`datumconsult`]: timestamp,[`activiteit`]: 'Coördinatorschap',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoordinatorschap')))),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: 1,[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`akkoord`]: true,[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`dossieraanmaker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`dossiergewerkteminuten`]: 0,[`dossier`]: '0000000' }) ));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiecoordinatorschap/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatorschap/components/b1f2a90e984d91859fc92cfd02ee2f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var regiogvpl2, regiogvpl1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function regiogvpl() {
  ___arguments.context.pageData['regiogvpl'] = [];
  regiogvpl1 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')).split(',');
  regiogvpl2 = regiogvpl1.join('\',\'');
  ___arguments.context.pageData['regiogvpl'] = regiogvpl2;
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await regiogvpl();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandfilter')) == null) {
    (function (message) { alert(message) })('De maand moet geselecteerd worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`coordinatorschap`]: [(getObjectProperty(___arguments.context.pageData, 'maandfilter')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl'))].join(''),[`financieringvws`]: 'Ja',[`datumconsult`]: timestamp,[`activiteit`]: 'Coördinatorschap',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefcoordinatorschap')))),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.pageData, 'gewerkteminuten')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`akkoord`]: true,[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`dossieraanmaker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`dossiergewerkteminuten`]: 0,[`dossier`]: '0000000' }) ));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/b1f2a90e984d91859fc92cfd02ee2f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/ee6576d8268ae89268cda07f876a1fd4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit =\'','Consult zorgvrager','\' AND consultwijze =\'','Face-to-face','\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND akkoord = \'1\'',' AND maandakkoord = \'1\''].join(''))).setSortBy('maand ASC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'maand')),[`label`]: (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e1e48137cdf2ef9b809c4452a9af1fbe', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit =\'','Consult zorgvrager','\' AND consultwijze =\'','Face-to-face','\' AND regio IN (\'',(getObjectProperty(___arguments.context.pageData, 'regiogvpl')),'\') AND akkoord = \'1\'',' AND maandakkoord = \'1\'',' AND maand =\'',(getObjectProperty(___arguments.context.pageData, 'maandfilter')),'\''].join(''))).setProperties(['sum(gewerkteminuten) as totaalminuten']).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/e3be6afea78f3e96192306cc191e957c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'totaalminuten')) / 60)

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/registratiecoordinatorschapoud/components/762ddd7e7d8b5cdeb48b4e41817fa4be/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gewerkteminuten'] = (((getObjectProperty(___arguments.context.dataModel, 'totaalminuten')) / 60) * 10);

  return (((getObjectProperty(___arguments.context.dataModel, 'totaalminuten')) / 60) * 10)

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('72f3cc6d43193e6c6ec3c50c99fd52ea', (await Backendless.Data.of('belangcatconsult2026').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0d0a206949f98ab1ab2c158e3d52553a', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setSortBy('wasersprakevan').setPageSize(100))));
  ___arguments.context.pageData['listcat'] = [];
  ___arguments.context.pageData['listwasersprakevan'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7754c2dcf311c5889c06e3eda988f46f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, tariefreistijdkm, tariefperminuut, reistijdberekening, gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d668ec8e999f24eb138cdb6b2ec4223')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')) == null) {
    (function (message) { alert(message) })('De vraag over de evaluatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa1d7ffcd0634443ddd826d464dd46f6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b4a2736bac7489863becf0d81636ff1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('da3bd8515408b31cdc4bc6927cba500f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ea6e5a20798dfa61091acb6e2bbb807')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d8d7788cd5f2f8a218d3684f28ac58')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a6841a4012e11593a328b069f0d3e47')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('846f8d4d0ef6695d26ce92330e2b3284')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73cb228ede26c0ba592e777498d89663')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b7df679b14dcd1f98127d5a110cb586')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        gewerkteminuten = 1;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        gewerkteminuten = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        gewerkteminuten = 1;
      }
      tariefreistijdkm = 0;
    } else {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringtarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')),[`evaluatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`groepsaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantaldeelnemers')),[`groepsdoelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'doelgroep')),[`groepsthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`groepswasersprakevan`]: String(getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: gewerkteminuten,[`voorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`activiteit`]: 'Groepsconsult',[`reistijdminutenspeciaal`]: reistijdberekening,[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`groepsbeoogdedoelresultaat`]: (getObjectProperty(___arguments.context.pageData, 'groepsbeoogdedoelresultaat')),[`groepsbetrokkenorganisaties`]: (getObjectProperty(___arguments.context.pageData, 'groepsbetrokkenorganisaties')),[`groepskorteomschrijving`]: (getObjectProperty(___arguments.context.pageData, 'groepskorteomschrijving')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringconsultthemas`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringconsultthemas')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Totaal aantal kilometers- VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZWNL') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) != '1') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Nee') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdgroepsconsult'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('240569271535f4c114cf9794515f7d67'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('240569271535f4c114cf9794515f7d67'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('240569271535f4c114cf9794515f7d67'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('240569271535f4c114cf9794515f7d67'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/d9a454d551a519d564e8131dea46b5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.dataModel, 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')), (getObjectProperty(___arguments.context.dataModel, 'wasersprakevan')));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).splice((((getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).indexOf(getObjectProperty(___arguments.context.dataModel, 'wasersprakevan')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/665a8469e2036394aec1c8b43ae2739e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/b41fb8a4fc5be0a97877b01fc2b6b9f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b41fb8a4fc5be0a97877b01fc2b6b9f1')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/8bdf8cfe3f5f6d821b0be2028369477f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) != '1') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Nee') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8bdf8cfe3f5f6d821b0be2028369477f')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/060c380792fe4c76f5f56a81414522ff/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/7373859586754c733a42c04a21dcbaf9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['groepsbeoogdedoelresultaat'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroepsconsult'));
  ___arguments.context.pageData['groepsbetrokkenorganisaties'] = (getObjectProperty(___arguments.context.dataModel, 'betrokkenorganisaties'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['groepskorteomschrijving'] = (getObjectProperty(___arguments.context.dataModel, 'omschrijvinggroepsconsult'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/4fe8f6a30f6c50742f29132dd948689c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/da3bd8515408b31cdc4bc6927cba500f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/cdf3788b0a16f6980d96dd94f8c96f29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' || (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/f149a786544ba4bdddd6e267eb24d86a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal gewerkte minuten -  ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/7ea6e5a20798dfa61091acb6e2bbb807/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
    status2 = '%';
  } else {
    status2 = '0';
  }

  return (await Promise.all((await Backendless.Data.of('doelgroepgroepsconsult').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/70eb50d8e10d072c83ae38df59dec1f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/6d7ec3dc5c6fbb3fa93394ffa25a005d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/d3fff6a6f4cef72d934714658c021f31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/846f8d4d0ef6695d26ce92330e2b3284/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/8c21d6b718530dd437c4d986eea20618/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/79d673abbf798b14862355ff39fbc699/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/848ac2d65799c821720bf6662b8f9782/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Reistijd in minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/b91d82bb87cd107a118acc477b79f7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/3b4a2736bac7489863becf0d81636ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fe8f6a30f6c50742f29132dd948689c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da3bd8515408b31cdc4bc6927cba500f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9b86008608893384e28e6d8602fcae8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6ad8b6c8776e6b8776a67e8c0383043', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2d8d7788cd5f2f8a218d3684f28ac58', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fe8f6a30f6c50742f29132dd948689c', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9b86008608893384e28e6d8602fcae8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6ad8b6c8776e6b8776a67e8c0383043', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2d8d7788cd5f2f8a218d3684f28ac58', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da3bd8515408b31cdc4bc6927cba500f', true);
    }
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fe8f6a30f6c50742f29132dd948689c', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9b86008608893384e28e6d8602fcae8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c6ad8b6c8776e6b8776a67e8c0383043', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2d8d7788cd5f2f8a218d3684f28ac58', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da3bd8515408b31cdc4bc6927cba500f', true);
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/73cb228ede26c0ba592e777498d89663/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/1b7df679b14dcd1f98127d5a110cb586/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/6a6841a4012e11593a328b069f0d3e47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/b3f718c49a2d92dc02bb4c1daab60ef8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/aa1d7ffcd0634443ddd826d464dd46f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantaldeelnemers')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['aantaldeelnemers'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/9944defcc59b3fb10dca9d3599c267ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/6f315115e2d16bff15dde8588d56265e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/26e368d415a66a057174bb5b95754abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/b2d35adb2e2f83a5f0cb42ba16facd39/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/4e1ef2534a9ca3157113d05489c48e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/416539d6792199c65e88d6880e482ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/0d668ec8e999f24eb138cdb6b2ec4223/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/c923fa52c73993f9db4cd55a84287565/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    content2 = 'Voorbereidingstijd in minuten (max. 60 minuten)';
  } else {
    content2 = 'Voorbereidingstijd in minuten';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/84639ee7d91eb6981cccbeec5b8d88a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('060c380792fe4c76f5f56a81414522ff')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult/components/a9b86008608893384e28e6d8602fcae8/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')).toLowerCase());

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7754c2dcf311c5889c06e3eda988f46f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('673a0b2f278f9144a67e9e26aead1f3c', (await Backendless.Data.of('belangcatconsult2026').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  ___arguments.context.pageData['listcat'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tariefreistijdminutenspeciaal, tariefperminuut, reistijdminutenspeciaal, gewerkteminuten, datumconsult, timestamp, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    date = (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'jaar'))].join(''))));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    datumconsult = (date.valueOf());
  } else {
    datumconsult = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'));
  }
  if (datumconsult == null) {
    (function (message) { alert(message) })('Datum consult dient ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Belangrijkste categorie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff1be6bd9dbb162c54c9295e1cdc0def')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Gewerkte minuten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b593871683d4e3856fde5da92aba269')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'groepsaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Aantal deelnemers dient ingevuld te worden');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
        tariefperminuut = 12396.6666666667;
      } else {
        tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
      }
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'financieringsubsidie')) == 'VWS') {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
      gewerkteminuten = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'financieringsubsidie')) == 'Financiering gemeente Amsterdam') {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
      gewerkteminuten = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'financieringsubsidie')) == 'Fonds inloophuis') {
      tariefperminuut = 26500;
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefgroepsconsult'))));
      gewerkteminuten = 1;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefreistijdminutenspeciaal = 12396.6666666667;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      tariefreistijdminutenspeciaal = (getObjectProperty(___arguments.context.pageData, 'tariefreistijdkm'));
    } else {
      tariefreistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      reistijdminutenspeciaal = 1;
    } else {
      reistijdminutenspeciaal = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`voorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),[`activiteit`]: 'Groepsconsult',[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date(timestamp).getFullYear())].join(''),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: datumconsult,[`groepsthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`gewerkteminuten`]: gewerkteminuten,[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdminutenspeciaal`]: reistijdminutenspeciaal,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: tariefreistijdminutenspeciaal,[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')),[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.pageData, 'financieringstroomwelke')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`questiogroepsconsultperiodebijeenkomsten`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultperiodebijeenkomsten')),[`questiogroepsconsultlocatiebijeenkomsten`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultlocatiebijeenkomsten')),[`questiogroepsconsultwervingdeelnemers`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultwervingdeelnemers')),[`questiogroepsconsultleeftijddeelnemers`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultleeftijddeelnemers')),[`questiogroepsconsultwelkecompetenties`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultwelkecompetenties')),[`questiogroepsconsultthema`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultthema')),[`questiogroepsconsultdoel`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultdoel')),[`questiogroepsconsulthomogeniteit`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsulthomogeniteit')),[`questiogroepsconsultmeerwaarde`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultmeerwaarde')),[`questiogroepsconsultprogrammabijeenkomst`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultprogrammabijeenkomst')),[`omschrijvinggroepsconsult`]: (getObjectProperty(___arguments.context.pageData, 'omschrijvinggroepsconsult')),[`questiogroepsconsultbijdrage`]: (getObjectProperty(___arguments.context.pageData, 'questiogroepsconsultbijdrage')),[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`groepsaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'groepsaantaldeelnemers')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b138ba0dfffe3d6cb33ffffc6fc60908'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b138ba0dfffe3d6cb33ffffc6fc60908'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b138ba0dfffe3d6cb33ffffc6fc60908'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b138ba0dfffe3d6cb33ffffc6fc60908'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/665a8469e2036394aec1c8b43ae2739e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/7373859586754c733a42c04a21dcbaf9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['financieringstroom'] = (getObjectProperty(___arguments.context.dataModel, 'financieringstroom'));
  ___arguments.context.pageData['financieringstroomwelke'] = (getObjectProperty(___arguments.context.dataModel, 'financieringsstroomwelke'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['questiogroepsconsultperiodebijeenkomsten'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultperiodebijeenkomsten'));
  ___arguments.context.pageData['questiogroepsconsultlocatiebijeenkomsten'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultlocatiebijeenkomsten'));
  ___arguments.context.pageData['questiogroepsconsultwervingdeelnemers'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultwervingdeelnemers'));
  ___arguments.context.pageData['questiogroepsconsultleeftijddeelnemers'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultleeftijddeelnemers'));
  ___arguments.context.pageData['questiogroepsconsultwelkecompetenties'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultwelkecompetenties'));
  ___arguments.context.pageData['questiogroepsconsultthema'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultthema'));
  ___arguments.context.pageData['questiogroepsconsultdoel'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultdoel'));
  ___arguments.context.pageData['questiogroepsconsulthomogeniteit'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsulthomogeniteit'));
  ___arguments.context.pageData['questiogroepsconsultmeerwaarde'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultmeerwaarde'));
  ___arguments.context.pageData['questiogroepsconsultprogrammabijeenkomst'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultprogrammabijeenkomst'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['omschrijvinggroepsconsult'] = (getObjectProperty(___arguments.context.dataModel, 'omschrijvinggroepsconsult'));
  ___arguments.context.pageData['questiogroepsconsultbijdrage'] = (getObjectProperty(___arguments.context.dataModel, 'questiogroepsconsultbijdrage'));
  ___arguments.context.pageData['financieringsubsidie'] = (getObjectProperty(___arguments.context.dataModel, 'financieringsubsidie'));
  ___arguments.context.pageData['questioconsultinwdatumaanvraag'] = (getObjectProperty(___arguments.context.dataModel, 'datumaanvraag'));
  ___arguments.context.pageData['consultinwdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroep'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/ff1be6bd9dbb162c54c9295e1cdc0def/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff1be6bd9dbb162c54c9295e1cdc0def')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff1be6bd9dbb162c54c9295e1cdc0def')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty(___arguments.context.pageData, 'financieringsubsidie')) == 'Fonds inloophuis' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/758e3e7f9a9ae28a6db72871acf9fe8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty(___arguments.context.pageData, 'financieringsubsidie')) == 'Fonds inloophuis' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    offset = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')))).getTime() - (259200 * 1000)));
  } else {
    offset = 0;
  }

  return offset

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var max;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    max = (new Date((new Date()).getTime() + (0 * 1000)));
  } else {
    max = (new Date((new Date()).getTime() + (604800 * 1000)));
  }

  return max

  },
  /* handler:onMaxDateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/8ab6111fb93e06583f3a972b59d6db47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/74c329aa830af96ef33a4fb144b5c504/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true) : false;

  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/5a3c7bf3828f48f51791e76459dd4aad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var old;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  old = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true) : false;

  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/4b593871683d4e3856fde5da92aba269/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantal deelnemers, cijfers invullen' : '')

  },
  /* handler:onLabelAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'groepsaantaldeelnemers')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['groepsaantaldeelnemers'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/c6cb86ce1aab0c480709bdd7acbe445e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/06714567ff2ebf6dd2629e8a980c947b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/f31679cfdfae0166d94187f2932b9a09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/845c18848891c28a12d9bcdfe41f9896/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > 60) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',60,' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('845c18848891c28a12d9bcdfe41f9896')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('845c18848891c28a12d9bcdfe41f9896')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/f3a6661f46880d8b4eff1aa96375e037/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/e58f1f5d70de39f23f7470af3943bfc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/4454140b6ea4bb2f70d681fede5f53da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/b8b88783f43efdb41d0f86cc9a37e68b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/af9befa1a6717db7345c1473d37a08cb/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantekeningen' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/cba6e63d69ddd728950580c81e05f83a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/88f730d1465401863d9b6eaa9fa57c87/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function kilometerbedrag() {
  if (___arguments.value < 20) {
    ___arguments.context.pageData['tariefreistijdkm'] = 0;
  } else if (___arguments.value >= 20 && ___arguments.value <= 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 235000;
  } else if (___arguments.value > 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 470000;
  }
}


  await kilometerbedrag();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsconsult-questio/components/fdeff487138242bb9f6638960688c045/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (message) { alert(message) })(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),'\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),'\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten'))].join('')));
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fdeff487138242bb9f6638960688c045')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > 30) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren voor voorbereiding is ',30,' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = 30;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) == null) {
    (function (message) { alert(message) })('Vul de korte toelichting in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringvws`]: 'Nee',[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Groepsgesprekken',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['kenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'kenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['ojpprojectnaam'] = (getObjectProperty(___arguments.context.dataModel, 'ojpprojectnaam'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiegroepsgesprekken/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c36931f55a743272647e6c44d9360bb2', (await Backendless.Data.of('mdopatzvervolg').find(Backendless.DataQueryBuilder.create().setSortBy('vervolgmdopatz').setPageSize(100))));
  ___arguments.context.pageData['listvervolgmdopatz'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('941746ea71493268250fe26a2acf3325', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiemdopatz/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, tariefreistijdkm, tariefperminuut, reistijdberekening, gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa1d7ffcd0634443ddd826d464dd46f6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listvervolgmdopatz')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1829d5a6f0b2d8aab58914b6f3471207')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7366a47c3c0c8acc21199bc43974e02a')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c497edb5b1f52b127cfd653fad3cebf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f131a6ef923e7a8fb088f5c8e0fed501')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d45871da241884380a344d38d13c4f49')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09e70fc603b1aede829510da8ea556dd')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4b8e73370411078e68540b422f245d9')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('38a694adb92629d6f33842580fd663ff')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6726e835b43838645512f9ceeada0632')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8c484bacb68873db097487fc707679e')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a2739c97a6cf7031d1b70e8908fb18bb')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8fa3531d3e065837d072fdcc3887569b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzdossiernummersbesprokenclienten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefmdopatz'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
        }
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
        gewerkteminuten = 0;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Gedeeltelijk') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo1aantal'));
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
          gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
        }
      }
      tariefreistijdkm = 0;
    } else {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
      tariefreistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '0') {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringtarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')),[`mdopatzvervolgnavmdopatz`]: String(getObjectProperty(___arguments.context.pageData, 'listvervolgmdopatz')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: gewerkteminuten,[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`activiteit`]: 'MDO/PaTz',[`reistijdminutenspeciaal`]: reistijdberekening,[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: tariefreistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`mdopatzsoortoverleg`]: (getObjectProperty(___arguments.context.pageData, 'mdopatzsoortoverleg')),[`mdopatznaam`]: (getObjectProperty(___arguments.context.pageData, 'mdopatznaam')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')),[`mdopatzdossiernummersbesprokenclienten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzdossiernummersbesprokenclienten')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdopatz/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdmdopatz'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/d9a454d551a519d564e8131dea46b5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19d88acffa3e5bad779dbb99a202a5d1'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listvervolgmdopatz')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('19d88acffa3e5bad779dbb99a202a5d1'), 'vervolgmdopatz')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('19d88acffa3e5bad779dbb99a202a5d1'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listvervolgmdopatz')).splice((((getObjectProperty(___arguments.context.pageData, 'listvervolgmdopatz')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('19d88acffa3e5bad779dbb99a202a5d1'), 'vervolgmdopatz')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/c3d2549eb3f47e4e7b631431857a7011/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdopatz/components/7cc915c7118e2484105298166486e40d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/04553094861dc7b206e86f7da27efe14/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/1829d5a6f0b2d8aab58914b6f3471207/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1829d5a6f0b2d8aab58914b6f3471207')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1829d5a6f0b2d8aab58914b6f3471207')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1829d5a6f0b2d8aab58914b6f3471207')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/bdf66036a23e16a703eb9775e83a82fd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['mdopatzsoortoverleg'] = (getObjectProperty(___arguments.context.dataModel, 'soortoverlegpatzmdo'));
  ___arguments.context.pageData['mdopatznaam'] = (getObjectProperty(___arguments.context.dataModel, 'naampatzmdo'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiemdopatz/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/7366a47c3c0c8acc21199bc43974e02a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9d5ba9bd1023c17e4f8dd053a4862d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c497edb5b1f52b127cfd653fad3cebf', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('861534266c1e39f805c96984eb2b7d83', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11988c92a66865f1b3cb7ea612ea9ad8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d45871da241884380a344d38d13c4f49', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9d5ba9bd1023c17e4f8dd053a4862d6', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('861534266c1e39f805c96984eb2b7d83', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11988c92a66865f1b3cb7ea612ea9ad8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d45871da241884380a344d38d13c4f49', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c497edb5b1f52b127cfd653fad3cebf', true);
    }
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9d5ba9bd1023c17e4f8dd053a4862d6', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('861534266c1e39f805c96984eb2b7d83', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11988c92a66865f1b3cb7ea612ea9ad8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d45871da241884380a344d38d13c4f49', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c497edb5b1f52b127cfd653fad3cebf', true);
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/c9d5ba9bd1023c17e4f8dd053a4862d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/3c497edb5b1f52b127cfd653fad3cebf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal gewerkte minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Aantal gewerkte minuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/747c2cb44159dc3276f63d8a0179c4c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal gewerkte minuten -  ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/f131a6ef923e7a8fb088f5c8e0fed501/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/9e55886aea6be398d3f3af949e1ba06e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Reistijd in minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/e45b0291de3b662c1b41bcf45dba7655/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/79ae1559a083dac599f62abf2c8b17bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/2474451cf3f8d7a1c8f87a9ae7e49997/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/8b82344dfd78ab2cceb37815f12e1ab4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/5766091846e3e9985aebf392668c393f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/c4b8e73370411078e68540b422f245d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/5e1d439a3275bbd702e58c8b2e113026/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/65693bcbaaaed49576edeb278bd52e73/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) != 'Limburg') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/aa1d7ffcd0634443ddd826d464dd46f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) != 'Limburg') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdopatzaantalbesprokenclienten'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/8bb174cb569c23c6649ae7767a9fc5f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/38a694adb92629d6f33842580fd663ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/04fc9ccd0019b1ba04cba4aba902cf9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/6726e835b43838645512f9ceeada0632/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/09e70fc603b1aede829510da8ea556dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz/components/b623b41c79b9dafbca7a6c66fc9d31c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/e96a7e5d531a4a1680c4bd2124dcb989/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/c8c484bacb68873db097487fc707679e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdo1aantal'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdo2aantal'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz/components/0ef6494ca967f6f889bfe065ee23cd9a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/a2739c97a6cf7031d1b70e8908fb18bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/9776fe01a1f5459cceb8554a00d3f255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk. Het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/26e368d415a66a057174bb5b95754abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/521911e2e8537483ffef0ac5a1ab89a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/b237a79cc778f3777095ce6f0fa33e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/cbec2d97baac6b46abdea91d7048af26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/14e3be9abf9b7ee6bca80ae62d5b6f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/1c697e57f5e392c5f9865b2bc9c955bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/8fa3531d3e065837d072fdcc3887569b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz/components/861534266c1e39f805c96984eb2b7d83/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')).toLowerCase());

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp, tariefreistijdminutenspeciaal, tariefperminuut, datumconsult, reistijdminutenspeciaal, gewerkteminuten, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud_ZHN() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
    gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
    gewerkteminuten = (60 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    date = (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'jaar'))].join(''))));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setSeconds(0);
    datumconsult = (date.valueOf());
  } else {
    datumconsult = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'));
  }
  if (datumconsult == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')) == null) {
    (function (message) { alert(message) })('Vul het aantal besproken cliënten in.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7e9dc6fef22a9489ba444014534f616')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Gewerkte minuten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bae53d8a98e1ab921607955ed85208b3')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == null) {
    (function (message) { alert(message) })('Soort consult dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4faf9449fdd9bed7b86ced084b73b5cc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      gewerkteminuten = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten'));
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
        gewerkteminuten = 1;
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
        gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
      }
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 12396.6666666667;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefmdopatz'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefreistijdminutenspeciaal = 12396.6666666667;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      tariefreistijdminutenspeciaal = (getObjectProperty(___arguments.context.pageData, 'tariefreistijdkm'));
    } else {
      tariefreistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      reistijdminutenspeciaal = 1;
    } else {
      reistijdminutenspeciaal = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`gewerkteminuten`]: gewerkteminuten,[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdminutenspeciaal`]: reistijdminutenspeciaal,[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: datumconsult,[`mdopatzaantalbesprokenclienten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')),[`activiteit`]: 'MDO/PaTz',[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: tariefreistijdminutenspeciaal,[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`mdopatzsoortoverleg`]: (getObjectProperty(___arguments.context.pageData, 'mdopatzsoortoverleg')),[`mdopatznaam`]: (getObjectProperty(___arguments.context.pageData, 'mdopatznaam')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')),[`questiomdoincidentieelbetrokken`]: (getObjectProperty(___arguments.context.pageData, 'questiomdoincidentieelbetrokken')),[`questiomdostandaardbetrokken`]: (getObjectProperty(___arguments.context.pageData, 'questiomdostandaardbetrokken')),[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')),[`soortconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')),[`mdopatzdossiernummerclient`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzdossiernummerclient')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['mdopatzsoortoverleg'] = (getObjectProperty(___arguments.context.dataModel, 'soortoverlegpatzmdo'));
  ___arguments.context.pageData['mdopatznaam'] = (getObjectProperty(___arguments.context.dataModel, 'naampatzmdo'));
  ___arguments.context.pageData['questiomdoincidentieelbetrokken'] = (getObjectProperty(___arguments.context.dataModel, 'questiomdoincidentieelbetrokken'));
  ___arguments.context.pageData['questiomdostandaardbetrokken'] = (getObjectProperty(___arguments.context.dataModel, 'questiomdostandaardbetrokken'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['questioconsultinwdatumaanvraag'] = (getObjectProperty(___arguments.context.dataModel, 'datumaanvraag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['resterend']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    offset = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')))).getTime() - (259200 * 1000)));
  } else {
    offset = 0;
  }

  return offset

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bae53d8a98e1ab921607955ed85208b3')), 'display')) == false) {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = 'MDO-1';
  }

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var max;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    max = (new Date((new Date()).getTime() + (0 * 1000)));
  } else {
    max = (new Date((new Date()).getTime() + (604800 * 1000)));
  }

  return max

  },
  /* handler:onMaxDateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/e4cb422fb17faf2a3e697cdcb8768e44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/bae53d8a98e1ab921607955ed85208b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
      gewerkteminuten = 1;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
      gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && gewerkteminuten > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })('U heeft momenteel te weinig minuten op het dossier om de geselecteerde werktijd te kunnen declareren. Kies voor minder minuten of indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.');
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['soortconsult'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bae53d8a98e1ab921607955ed85208b3')));
    }
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Soort overleg' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/9ce407fac7118e69667b0a5b031f8a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/cb0e2dd20c5c691b9fae3a55fdcb3877/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Reistijd, niet verplicht' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/125956c321e37de4bc8e96fe5a14790a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    text = 'Aantal besproken zorgvragers';
  } else {
    text = 'Aantal besproken cliënten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/18143fc9d80e3f5bc8846e12a86de085/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/de271c94e2d601ffcebbc7e8b61702a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/e154edddd8ae424bc8ba53850b49b0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > 60) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',60,' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e154edddd8ae424bc8ba53850b49b0fe')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e154edddd8ae424bc8ba53850b49b0fe')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' ,vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/9444ba97551716edc551d2927da49d0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/e9031e0f81a3fe977ce76c4f6ed801c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantal besproken zorgvragers' : '')

  },
  /* handler:onLabelAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')) < 0) {
    (function (message) { alert(message) })((['De invoer is negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')),' , vul svp het juiste aantal in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdopatzaantalbesprokenclienten'] = null;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdopatzaantalbesprokenclienten')) == 0) {
      (function (message) { alert(message) })('De invoer is mag niet 0 zijn.');
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdopatzaantalbesprokenclienten'] = null;
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/1699a1c4411422348fd88a95a945c1e6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantekeningen' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/28ad68d17aa72d6aeb1e52a3541bad76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/82e5588486871e88ac8c3f16aa252d52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/a7e9dc6fef22a9489ba444014534f616/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7e9dc6fef22a9489ba444014534f616')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7e9dc6fef22a9489ba444014534f616')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/54e74defd091a80aa97bfeb1c9da85ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function kilometerbedrag() {
  if (___arguments.value < 20) {
    ___arguments.context.pageData['tariefreistijdkm'] = 0;
  } else if (___arguments.value >= 20 && ___arguments.value <= 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 235000;
  } else if (___arguments.value > 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 470000;
  }
}


  await kilometerbedrag();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/cbcc846544d46ff6492142f9e84a605c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/5f67fa18d93f2b37f5e663e46064e167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/4faf9449fdd9bed7b86ced084b73b5cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var gewerkteminuten;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-1') {
    gewerkteminuten = 1;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2') {
    gewerkteminuten = (1 / 4) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'mdo2aantal'));
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && gewerkteminuten > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (message) { alert(message) })('U heeft momenteel te weinig minuten op het dossier om de geselecteerde werktijd te kunnen declareren. Kies voor minder minuten of indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (message) { alert(message) })('U heeft momenteel te weinig minuten op het dossier om de geselecteerde werktijd te kunnen declareren. Kies voor minder minuten of indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.');
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['mdo2aantal'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4faf9449fdd9bed7b86ced084b73b5cc')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdopatz-questio/components/750be58db435048fd6e98ac8cadd2502/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'soortconsult')) == 'MDO-2' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) == null) {
    (function (message) { alert(message) })('Vul de korte toelichting in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringvws`]: 'Nee',[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Netwerkactiviteiten',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['kenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'kenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['ojpprojectnaam'] = (getObjectProperty(___arguments.context.dataModel, 'ojpprojectnaam'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratienetwerkactiviteiten/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4cee651b32b076e79698b4ba0cfa81a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('26e368d415a66a057174bb5b95754abc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('006a17a5840648f1f43ac2e414645b88')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Postcode vertrek dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Postcode aankomst dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Ja',[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`activiteit`]: 'Netwerkbijeenkomst NPZF',[`opbouwinfrakorteomschrijving`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')),[`reistijdminutenspeciaal`]: 1,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`tariefreistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.pageData, 'tariefreistijdkm')),[`tariefreistijdkm`]: 0,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakortetoelichting')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/b1f2a90e984d91859fc92cfd02ee2f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/15bdb7fc3fb5706fe7e27569393ecbf5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdnetwerkbijeenkomstnpzf'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdnetwerkbijeenkomstnpzf'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')));
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/6563509e43a1bd582e0d78859f138bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opbouwinfrakortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/006a17a5840648f1f43ac2e414645b88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/dbb2318ebb649dc5d9c6422ad8136d06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/e9fb1bb3bc53e0f2926e30a551811e65/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function kilometerbedrag() {
  if (___arguments.value < 20) {
    ___arguments.context.pageData['tariefreistijdkm'] = 0;
  } else if (___arguments.value >= 20 && ___arguments.value <= 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 235000;
  } else if (___arguments.value > 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 470000;
  }
}


  await kilometerbedrag();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/91b573376595ba94845532cb8bf1c0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/d6b3a82b62476ad9ebcfb0176ae93f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/8d56d40db6efde783ded96caf4d7c98a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratienetwerkbijeenkomstnpzf/components/73437f8c286977b2d5cb75c6aa5e0b38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) == null) {
    (function (message) { alert(message) })('Vul de korte toelichting in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringvws`]: 'Nee',[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Ontwikkeluren',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['kenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'kenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['ojpprojectnaam'] = (getObjectProperty(___arguments.context.dataModel, 'ojpprojectnaam'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieontwikkeluren/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4cee651b32b076e79698b4ba0cfa81a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, regio, timestamp, tariefperminuut;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('26e368d415a66a057174bb5b95754abc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('006a17a5840648f1f43ac2e414645b88')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Postcode vertrek dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Postcode aankomst dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefopbouwinfra'))));
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefopbouwinfra'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      regio = (getObjectProperty(___arguments.context.pageData, 'regio'));
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else {
      regio = (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname'))));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Ja',[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`activiteit`]: 'Opbouw infrastructuur',[`opbouwinfrakorteomschrijving`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')),[`reistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: regio,[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/b1f2a90e984d91859fc92cfd02ee2f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/15bdb7fc3fb5706fe7e27569393ecbf5/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')));
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15bdb7fc3fb5706fe7e27569393ecbf5')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/6563509e43a1bd582e0d78859f138bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opbouwinfrakortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/006a17a5840648f1f43ac2e414645b88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/dbb2318ebb649dc5d9c6422ad8136d06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/0039e545cb3f10ef30e8043a12df5ceb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/e9fb1bb3bc53e0f2926e30a551811e65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9fb1bb3bc53e0f2926e30a551811e65')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/91b573376595ba94845532cb8bf1c0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/d6b3a82b62476ad9ebcfb0176ae93f1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/8d56d40db6efde783ded96caf4d7c98a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieopbouwinfra/components/73437f8c286977b2d5cb75c6aa5e0b38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))) > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) == null) {
    (function (message) { alert(message) })('Vul de korte toelichting in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`ojpprojectnaam`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringvws`]: 'Nee',[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'ojpprojectnaam')),[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Presentieactiviteiten',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['kenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'kenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['ojpprojectnaam'] = (getObjectProperty(___arguments.context.dataModel, 'ojpprojectnaam'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiepresentieactiviteiten/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Raad van Advies',[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Raad van Advies',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['mdopatzsoortoverleg'] = (getObjectProperty(___arguments.context.dataModel, 'soortoverlegpatzmdo'));
  ___arguments.context.pageData['mdopatznaam'] = (getObjectProperty(___arguments.context.dataModel, 'naampatzmdo'));
  ___arguments.context.pageData['questiomdoincidentieelbetrokken'] = (getObjectProperty(___arguments.context.dataModel, 'questiomdoincidentieelbetrokken'));
  ___arguments.context.pageData['questiomdostandaardbetrokken'] = (getObjectProperty(___arguments.context.dataModel, 'questiomdostandaardbetrokken'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['questioconsultinwdatumaanvraag'] = (getObjectProperty(___arguments.context.dataModel, 'datumaanvraag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['resterend']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('748712f72a4715b1d221b05c6e55958b')));
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('748712f72a4715b1d221b05c6e55958b')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratieraadvanadvies/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e716abbcf427fb246926c9743ce633c8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6e425ec2fe7de8cf440876b6ad6d043a', (await Backendless.Data.of('scholingspecifiekdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));
  ___arguments.context.pageData['listdoelgroepteam'] = [];
  ___arguments.context.pageData['financieringstroom'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiescholing/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiescholing/components/163f0f4fb42643188776c636be4d6ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel') {
    text = 'Reistijd in minuten';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Totaal aantal kilometers';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Totaal aantal kilometers - VWS subsidie';
  } else {
    text = 'Totaal aantal kilometers';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour)';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['gvreistijdwillem']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (vul hier de totale reistijd in) - VWS subsidie';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Reistijd in minuten (max. 30 min retour) - VWS subsidie';
  } else {
    text = 'Reistijd in minuten (max. 30 min retour)';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdscholing'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/d9a454d551a519d564e8131dea46b5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af8dab350201a0a24fbf89230863c79c'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('af8dab350201a0a24fbf89230863c79c'), 'specifiekdoelgroepteam')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('af8dab350201a0a24fbf89230863c79c'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('af8dab350201a0a24fbf89230863c79c'), 'specifiekdoelgroepteam')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/58098b8252c73b715878d9a7b63a9908/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('scholingdoelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((___arguments.context.appData['centraname']))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (item['doelgroepscholing']),'label': (item['doelgroepscholing']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/acc1e1fcf455b29a29f5f859a835ae61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiescholing/components/05a7a5d94594a4a6109fae1db791b58c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/f2e6e6b7c7470134e4fd2a429d772897/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee') {
    visible = false;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/b7388eb21b06be8a0558276d82f3fc06/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['scholingomschrijving'] = (getObjectProperty(___arguments.context.dataModel, 'omschscholing'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['scholingorganisatie'] = (getObjectProperty(___arguments.context.dataModel, 'scholingorganisatie'));
  ___arguments.context.pageData['scholingteam'] = (getObjectProperty(___arguments.context.dataModel, 'scholingteam'));
  ___arguments.context.pageData['scholingdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'scholingdoelgroep'));
  ___arguments.context.pageData['scholingspecifiekedoelgroepteam'] = (getObjectProperty(___arguments.context.dataModel, 'scholingspecifiekedoelgroepteam'));
  ___arguments.context.pageData['postcodeaankomst'] = (getObjectProperty(___arguments.context.dataModel, 'postcodeaankomst'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiescholing/components/2a197d4293bbadcd0135079b586eac42/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2) {
        (function (message) { alert(message) })((String('De maximale tijd die U kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2))));
        ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2));
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a197d4293bbadcd0135079b586eac42')));
      }
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6a736860997abc3c7f2d65ee02cdccf')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2 && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Gelderland' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Willem')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    } else {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/edb2a9ece0f46387b5eba5cd24185408/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Ja') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ccbb909d3b48a1b8a859ea3d1a12b23', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc45530f8c8abbe9cace527f8beac46b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7b85eef3dc89b39ce3f5028ca08e45e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f3a1ba82f688d4535af1d96496850a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8a8d2082817e872699fdd485b92a388', false);
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclvoorbereidingminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
  } else if (___arguments.value == 'Gedeeltelijk') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ccbb909d3b48a1b8a859ea3d1a12b23', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7b85eef3dc89b39ce3f5028ca08e45e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f3a1ba82f688d4535af1d96496850a8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8a8d2082817e872699fdd485b92a388', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc45530f8c8abbe9cace527f8beac46b', true);
    }
  } else if (___arguments.value == 'Nee') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ccbb909d3b48a1b8a859ea3d1a12b23', true);
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7b85eef3dc89b39ce3f5028ca08e45e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5f3a1ba82f688d4535af1d96496850a8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b8a8d2082817e872699fdd485b92a388', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc45530f8c8abbe9cace527f8beac46b', true);
    }
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/9ccbb909d3b48a1b8a859ea3d1a12b23/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Gedeeltelijk') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald naast de VWS subsidie?';
  }
  if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    text = 'Vanuit welke financieringsstroom wordt deze activiteit betaald?';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/cc45530f8c8abbe9cace527f8beac46b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('financieringsstroom').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'financieringsstroom')),'label': (getObjectProperty(item, 'financieringsstroom')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['financieringstroom'] = (___arguments.value.toLowerCase());

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Ja') {
    text = 'Scholingstijd - aantal gewerkte minuten';
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja') {
    text = 'Scholingstijd - aantal gewerkte minuten - VWS subsidie';
  } else {
    text = 'Scholingstijd - aantal gewerkte minuten';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/a6a736860997abc3c7f2d65ee02cdccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6a736860997abc3c7f2d65ee02cdccf')));
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
    } else {
      (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6a736860997abc3c7f2d65ee02cdccf')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/90b8a19e5bf964239a16fcf582cfd9e2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Scholingstijd aantal gewerkte minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/a5da535eeadecbd37f65c1c2d84aef2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclwerkminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/a185d7ee7548d613e44c085c84022062/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Nee' ? false : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == 'Ja') {
    text = 'Aantal minuten voorbereiding';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja') {
    text = 'Aantal minuten voorbereiding - VWS subsidie';
  } else {
    text = 'Aantal minuten voorbereiding (max. 50% van de scholingsduur)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/dff93b1582b79c67046b1397f4c77a3c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Aantal minuten voorbereiding - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/81811b45aad8f84897039fd764f7dfc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclvoorbereidingminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/e22b21f197ccd0887a86731ebf2603a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Reistijd in minuten - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/e26a39b787928461bba42004cc5c69bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/bb47a7b33a06c6a8b6d2bc260f8f9c24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) != 'Ja' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = String('Totaal aantal kilometers - ') + String(___arguments.context.pageData['financieringstroom']);

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/dd65e99544f15dd2a31ed5d98994ac7f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) != 'Ja' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/2ad7a0d99f150a237691d9a4924c6b23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'xxx' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/cf1f483537f98691de6b4c28eb710397/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'xxx' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/b7e8c16c3c49f4a4308a42993689a2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdkm'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringnietdeclreistijdminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdoverijssel'] = null;
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/9d72bf73cf8c10b67341f6315e58719f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['uitlegreistijdscholing'])

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((JSON.parse((___arguments.context.appData['gvnietdeclarabel']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['financieringvws']) == 'Nee') {
    visible = false;
  } else if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/3b369fa31b056b6c0b07086193754763/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/7ffa4c363e8956289261003cf952dcb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/a206469fd209201bcca144df3494c08e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/11ae03037989a47cc2fb49fa4e6c5d39/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/698b978215789cdb7f42e3a54e0d5bd6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/78c6b12dd2eabeccad353173adf8b456/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/9df8975812357eba689bf3f1e4d5ac94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pcva, financieringstroom, financieringvws, timestamp, scholingmetofzonderbtw, tariefperminuut, reistijdberekening, voorbereidingminutenwaarde, specifiekedoelgroep, doelgroep, team, organisatie;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ee24d89a0c58e032059ed030e38dcaa')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')) == null) {
    (function (message) { alert(message) })('De vraag over de evaluatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('78c6b12dd2eabeccad353173adf8b456')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamomschrijvingscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a42adda614dda438c33367ab7c89ed37')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'orgscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dc67e93d925ca58268d51f8a59b78c05')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'teamscholing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa1d7ffcd0634443ddd826d464dd46f6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('58098b8252c73b715878d9a7b63a9908')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingdoelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c01e020f4963266f1cda4bae25e5622a')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7e8c16c3c49f4a4308a42993689a2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a6a736860997abc3c7f2d65ee02cdccf')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('edb2a9ece0f46387b5eba5cd24185408')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc45530f8c8abbe9cace527f8beac46b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a5da535eeadecbd37f65c1c2d84aef2b')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8a8d2082817e872699fdd485b92a388')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b78b6e61f8f339c8bf76c70f83fe3dc8')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b369fa31b056b6c0b07086193754763')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('40039377f83a2a3d0eb2001b01bbb0ea')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bdadeb5970e4a9d87126639fa82f07fc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingmetofzonderbtw')) == 'Ja') {
        scholingmetofzonderbtw = true;
      } else {
        scholingmetofzonderbtw = false;
      }
    } else {
      scholingmetofzonderbtw = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) - 20;
      if (reistijdberekening <= 0) {
        reistijdberekening = 0;
      }
    } else {
      reistijdberekening = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 10000;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing'))));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1') {
      organisatie = (getObjectProperty(___arguments.context.pageData, 'scholingorganisatie'));
      team = (getObjectProperty(___arguments.context.pageData, 'scholingteam'));
      doelgroep = (getObjectProperty(___arguments.context.pageData, 'scholingdoelgroep'));
      specifiekedoelgroep = (getObjectProperty(___arguments.context.pageData, 'scholingspecifiekedoelgroepteam'));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      organisatie = (getObjectProperty(___arguments.context.pageData, 'scholingorganisatie'));
      team = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'teamscholing'));
      doelgroep = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingdoelgroep'));
      specifiekedoelgroep = String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam'));
    } else {
      organisatie = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'orgscholing'));
      team = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'teamscholing'));
      doelgroep = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingdoelgroep'));
      specifiekedoelgroep = String(getObjectProperty(___arguments.context.pageData, 'listdoelgroepteam'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('');
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      pcva = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')),' - ',(getObjectProperty(___arguments.context.pageData, 'postcodeaankomst'))].join('');
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) == null) {
      voorbereidingminutenwaarde = 0;
    } else {
      voorbereidingminutenwaarde = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten'));
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == 0) {
      financieringvws = 'Ja';
      financieringstroom = '';
    } else {
      financieringvws = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringvws'));
      financieringstroom = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringtarief`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringtarief')),[`evaluatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'evaluatie')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`scholingorganisatie`]: organisatie,[`scholingteam`]: team,[`scholingaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')),[`scholingdoelgroep`]: doelgroep,[`scholingspecifiekedoelgroepteam`]: specifiekedoelgroep,[`scholingwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`voorbereidingminuten`]: voorbereidingminutenwaarde,[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`activiteit`]: 'Scholing',[`reistijdminutenspeciaal`]: reistijdberekening,[`reistijdoverijssel`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdoverijssel')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: scholingmetofzonderbtw,[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`scholingomschrijving`]: (getObjectProperty(___arguments.context.pageData, 'scholingomschrijving')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: financieringvws,[`financieringstroom`]: financieringstroom,[`financieringnietdeclwerkminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclwerkminuten')),[`financieringnietdeclvoorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclvoorbereidingminuten')),[`financieringnietdeclreistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdminuten')),[`financieringnietdeclreistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringnietdeclreistijdkm')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamomschrijvingscholing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamomschrijvingscholing')),[`rotterdamleerpunten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamleerpunten')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')),[`postcodesvertrekenaankomstlocatie`]: pcva,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`cvlkenmerk`]: (getObjectProperty(___arguments.context.pageData, 'cvlkenmerk')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/4fd1a5d69f4b2af1aac48f0b362c3bf3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/a42adda614dda438c33367ab7c89ed37/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/7ffaaae5c5519b9fa5d8a4c6354f18dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/dc67e93d925ca58268d51f8a59b78c05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/65693bcbaaaed49576edeb278bd52e73/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/c01e020f4963266f1cda4bae25e5622a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvregistratievragenindossierscholing']))) == '1' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/304d5f632312488fb3b2ff3bfee6620c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/40039377f83a2a3d0eb2001b01bbb0ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/0c360b2857465e365a0ee86fb03220ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/bdadeb5970e4a9d87126639fa82f07fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/b78b6e61f8f339c8bf76c70f83fe3dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrek'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrek')).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/15cc3627a0ce433dc317fcfb02a8c4a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingwijze')) == 'Face-to-face') {
    visible = true;
  } else {
    visible = false;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/aa1d7ffcd0634443ddd826d464dd46f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingaantaldeelnemers'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/26e368d415a66a057174bb5b95754abc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/47df91cefd22c1c77c63c18717df1465/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/7228523449adc69ad8323fa13b1d6c96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/905c4b95363ec653b9fb4374ad876d29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/8ee24d89a0c58e032059ed030e38dcaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? false : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/d39b2884e2383c18591d1f55387e5b18/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/d833ec48736d4eb56068d5a8f3c8ad88/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing/components/a7b85eef3dc89b39ce3f5028ca08e45e/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['financieringstroom'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'financieringstroom')).toLowerCase());

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing-questio/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7754c2dcf311c5889c06e3eda988f46f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiescholing-questio/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var scholingmetofzonderbtw, tariefreistijdminutenspeciaal, tariefperminuut, reistijdminutenspeciaal, datumconsult, timestamp, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    date = (new Date(([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'maand')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'dag')),'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'jaar'))].join(''))));
    date.setHours(12);
    date.setMinutes(0);
    date.setSeconds(0);
    datumconsult = (date.valueOf());
  } else {
    datumconsult = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'));
  }
  if (datumconsult == null) {
    (function (message) { alert(message) })('Datum dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Gewerkte minuten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59a2616cec726f3a8ca13856998b5a49')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Gewerkte minuten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b88102c6e1356b725ba196751721c841')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')) == null) {
    (function (message) { alert(message) })('Aantal deelnemers dient ingevuld te worden');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefperminuut = 12396.6666666667;
    } else {
      tariefperminuut = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefscholing'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'drechtstedenorganisatietarief')) == true) {
      tariefreistijdminutenspeciaal = 12396.6666666667;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      tariefreistijdminutenspeciaal = (getObjectProperty(___arguments.context.pageData, 'tariefreistijdkm'));
    } else {
      tariefreistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      reistijdminutenspeciaal = 1;
    } else {
      reistijdminutenspeciaal = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal'));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingmetofzonderbtw')) == 'Ja') {
        scholingmetofzonderbtw = true;
      } else {
        scholingmetofzonderbtw = false;
      }
    } else {
      scholingmetofzonderbtw = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`scholingdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'scholingdoelgroep')),[`voorbereidingminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')),[`scholingaantaldeelnemers`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')),[`activiteit`]: 'Scholing',[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: datumconsult,[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`reistijdminutenspeciaal`]: reistijdminutenspeciaal,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`tariefperminuut`]: tariefperminuut,[`tariefreistijdminutenspeciaal`]: tariefreistijdminutenspeciaal,[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: scholingmetofzonderbtw,[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`financieringvws`]: (getObjectProperty(___arguments.context.pageData, 'financieringvws')),[`financieringstroom`]: (getObjectProperty(___arguments.context.pageData, 'financieringstroom')),[`financieringstroomwelke`]: (getObjectProperty(___arguments.context.pageData, 'financieringstroomwelke')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`questioscholingofmoreel`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')),[`questioscholingbestaandnieuw`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingbestaandnieuw')),[`questioscholingnaam`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingnaam')),[`scholingomschrijving`]: (getObjectProperty(___arguments.context.pageData, 'scholingomschrijving')),[`questioscholingleerdoelen`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingleerdoelen')),[`questioscholingwaarvoorgeorganiseerd`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingwaarvoorgeorganiseerd')),[`questioscholinglocatie`]: (getObjectProperty(___arguments.context.pageData, 'questioscholinglocatie')),[`questioscholingverwachtaantaldeelnemers`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingverwachtaantaldeelnemers')),[`questiomoreelberaadgeboortejaar`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadgeboortejaar')),[`questiomoreelberaadgeslacht`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadgeslacht')),[`questiomoreelberaadthuiswonend`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadthuiswonend')),[`questiomoreelberaadhulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadhulpvraag')),[`questiomoreelberaadachtergrondinformatie`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadachtergrondinformatie')),[`questiomoreelberaadaantaluren`]: (getObjectProperty(___arguments.context.pageData, 'questiomoreelberaadaantaluren')),[`scholingspecifiekedoelgroepteam`]: (getObjectProperty(___arguments.context.pageData, 'scholingspecifiekedoelgroepteam')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`questioscholinggeaccrediteerd`]: (getObjectProperty(___arguments.context.pageData, 'questioscholinggeaccrediteerd')),[`questioscholingwijze`]: (getObjectProperty(___arguments.context.pageData, 'questioscholingwijze')),[`questioconsultinwdatumaanvraag`]: (getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/665a8469e2036394aec1c8b43ae2739e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/7373859586754c733a42c04a21dcbaf9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['tariefperminuut'] = (getObjectProperty(___arguments.context.dataModel, 'tariefperminuut'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['financieringstroom'] = (getObjectProperty(___arguments.context.dataModel, 'financieringstroom'));
  ___arguments.context.pageData['financieringstroomwelke'] = (getObjectProperty(___arguments.context.dataModel, 'financieringsstroomwelke'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['questioscholingofmoreel'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingofmoreel'));
  ___arguments.context.pageData['questioscholingbestaandnieuw'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingbestaandnieuw'));
  ___arguments.context.pageData['questioscholingnaam'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingnaam'));
  ___arguments.context.pageData['scholingomschrijving'] = (getObjectProperty(___arguments.context.dataModel, 'omschscholing'));
  ___arguments.context.pageData['questioscholingleerdoelen'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingleerdoelen'));
  ___arguments.context.pageData['questioscholingwaarvoorgeorganiseerd'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingwaarvoorgeorganiseerd'));
  ___arguments.context.pageData['questioscholinglocatie'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholinglocatie'));
  ___arguments.context.pageData['questioscholingverwachtaantaldeelnemers'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingverwachtaantaldeelnemers'));
  ___arguments.context.pageData['questiomoreelberaadgeboortejaar'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadgeboortejaar'));
  ___arguments.context.pageData['questiomoreelberaadgeslacht'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadgeslacht'));
  ___arguments.context.pageData['questiomoreelberaadthuiswonend'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadthuiswonend'));
  ___arguments.context.pageData['questiomoreelberaadhulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadhulpvraag'));
  ___arguments.context.pageData['questiomoreelberaadachtergrondinformatie'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadachtergrondinformatie'));
  ___arguments.context.pageData['questiomoreelberaadaantaluren'] = (getObjectProperty(___arguments.context.dataModel, 'questiomoreelberaadaantaluren'));
  ___arguments.context.pageData['questioscholingbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingbedrag'));
  ___arguments.context.pageData['questioscholingbijdrage'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingbijdrage'));
  ___arguments.context.pageData['scholingspecifiekedoelgroepteam'] = (getObjectProperty(___arguments.context.dataModel, 'scholingspecifiekedoelgroepteam'));
  ___arguments.context.pageData['verwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['questioscholinggeaccrediteerd'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholinggeaccrediteerd'));
  ___arguments.context.pageData['questioscholingwijze'] = (getObjectProperty(___arguments.context.dataModel, 'questioscholingwijze'));
  ___arguments.context.pageData['questioconsultinwdatumaanvraag'] = (getObjectProperty(___arguments.context.dataModel, 'datumaanvraag'));
  ___arguments.context.pageData['scholingdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'scholingdoelgroep'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiescholing-questio/components/27ee30db0afec2d80478ed63b2dcf228/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
      (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
    }
  } else {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
      (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
    }
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/f3a6661f46880d8b4eff1aa96375e037/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Datum scholing';
  } else {
    text = 'Datum moreel beraad';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Registratie ') + String(getObjectProperty(___arguments.context.appData, 'questioscholingofmoreel')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    offset = (new Date((new Date((getObjectProperty(___arguments.context.pageData, 'questioconsultinwdatumaanvraag')))).getTime() - (259200 * 1000)));
  } else {
    offset = 0;
  }

  return offset

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var max;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    max = (new Date((new Date()).getTime() + (0 * 1000)));
  } else {
    max = (new Date((new Date()).getTime() + (604800 * 1000)));
  }

  return max

  },
  /* handler:onMaxDateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/c1c61047b01a65b809f1d9bf7876172b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/6b725e0da31ca41505f84d9d9b5c8682/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Aantal gewerkte minuten (LET OP: alleen de feitelijke scholingstijd mag ingevoerd worden. De voorbereidingstijd is inbegrepen in het tarief)';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    text = 'Werktijd';
  } else {
    text = 'Aantal gewerkte minuten ';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/59a2616cec726f3a8ca13856998b5a49/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59a2616cec726f3a8ca13856998b5a49')));
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Aantal gewerkte minuten LET OP reken ook de voorbereidingstijd, dit is maximaal 50% van de scholingsduur';
  } else {
    text = 'Aantal gewerkte minuten ';
  }

  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? text : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/6d118301813fedb81f537fbf76e7b34f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Moreel beraad' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingwijze')) == 'Face-to-face' ? true : false)) : false;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/140d6d7dde863bf39ed89ac11b11dd75/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var oud;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oud = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Moreel beraad' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingwijze')) == 'Face-to-face' ? true : false)) : false;

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Reistijd, niet verplicht' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/7e45cf0a7f0b2ee740c31ec2b258a641/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Aantal deelnemers (cijfers invullen)';
  } else {
    text = 'Aantal besproken clienten (cijfers invullen)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/b88102c6e1356b725ba196751721c841/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Aantal deelnemers, cijfers invullen';
  } else {
    text = 'Aantal besproken clienten, cijfers invullen';
  }

  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? text : '')

  },
  /* handler:onLabelAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')) < 0) {
    (function (message) { alert(message) })((['De invoer is negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'scholingaantaldeelnemers')),' , vul svp het juiste aantal deelnemers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['scholingaantaldeelnemers'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing-questio/components/d6477f3ec36527552f4bf15416d626d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiescholing-questio/components/443beac16b96a5eca53e0ae7502f09d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiescholing-questio/components/97e10929bcbdfecb7cd141c1d2cfd3e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/af8952e5121c6a38d905d2de87fd7eb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > 60) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',60,' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af8952e5121c6a38d905d2de87fd7eb6')));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'Hz14aoa' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af8952e5121c6a38d905d2de87fd7eb6')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde kilometers zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),' , vul svp het juiste aantal kilometers in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing-questio/components/5c33749b1d6573883d44d196824583f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/1bc3cf248736b33e5b544df91d133e13/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? 'Aantekeningen' : '')

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/b325b3f447e553991a71037d9c1df66f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/4e5b90246981d4066e47b73fc2c152d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    /**
 * Describe this function...
 */
async function kilometerbedrag() {
  if (___arguments.value < 20) {
    ___arguments.context.pageData['tariefreistijdkm'] = 0;
  } else if (___arguments.value >= 20 && ___arguments.value <= 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 235000;
  } else if (___arguments.value > 50) {
    ___arguments.context.pageData['tariefreistijdkm'] = 470000;
  }
}


  await kilometerbedrag();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiescholing-questio/components/9004cb5f4254235b1d63f5be79482cd7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/5274f781d13dee69baaeb68adfea4b61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('27ee30db0afec2d80478ed63b2dcf228')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren voor voorbereiding is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2,' minuten.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['voorbereidingminuten'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) / 2);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiescholing-questio/components/faa8a5280c6e21689ec8a3b84428f198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiescholing-questio/components/360a46588f3824f40658c9013318119b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')) == true && (getObjectProperty(___arguments.context.appData, 'scholingmetofzonderbtw')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratietriage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a82aae9c4b3a5e87dab7e728aedb5cba', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratietriage/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratietriage/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp, btw;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2eec325ff5dbf54ac124b3b226b336a6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`btw`]: btw,[`financieringvws`]: 'Ja',[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`activiteit`]: 'Triage/intake',[`reistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratietriage/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratietriage/components/75a817eb7e530f417c0c8276b19f3ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratietriage/components/b2a3320e02e319014067b262150104b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2a3320e02e319014067b262150104b6')));
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratietriage/components/969bb2f196d7cb11f02f53bba81cf567/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['coordinatiekortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'coordinatiekortetoelichting'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratietriage/components/c402e577e5eff551b02c28934107f0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiewerkgroep/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c3621d7a4bc31b4520fc90681e95a883', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiewerkgroep/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratiewerkgroep/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Vul de datum van het consult in.');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Vul het aantal gewerkte minuten in.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Werkgroep',[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`mdopatzaantalbesprokenclienten`]: undefined,[`activiteit`]: 'Werkgroep',[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefwerkgroep')))),[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.appData, 'akkoord')),[`regio`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')),[`werkgroep`]: (getObjectProperty(___arguments.context.pageData, 'werkgroep')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')) == null) {
    } else {
      await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiewerkgroep/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiewerkgroep/components/2d64dbeecb4cdfb1a9bd060572885fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiewerkgroep/components/8791a6df68f205a898ccc8d80a05eb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['cvlkenmerk'] = (getObjectProperty(___arguments.context.dataModel, 'cvlkenmerk'));
  ___arguments.context.pageData['financieringvws'] = (getObjectProperty(___arguments.context.dataModel, 'financieringvws'));
  ___arguments.context.pageData['opbouwinfrakortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting'));
  ___arguments.context.pageData['werkgroep'] = (getObjectProperty(___arguments.context.dataModel, 'werkgroep'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiewerkgroep/components/daecfedeaf6cfe4fe8f45ec89f144958/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiewerkgroep/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['financieringvws'] = null;
  ___arguments.context.dataModel['financieringstroom'] = null;
  ___arguments.context.dataModel['datum'] = null;
  ___arguments.context.dataModel['consultwijze'] = null;
  ___arguments.context.dataModel['consultbetrokken'] = null;
  ___arguments.context.dataModel['consultaantalbetrokken'] = null;
  ___arguments.context.dataModel['reistijdminuten'] = null;
  ___arguments.context.dataModel['reistijdkm'] = null;
  ___arguments.context.dataModel['reistijdminutenspeciaal'] = null;
  ___arguments.context.dataModel['financieringconsultthemas'] = null;
  ___arguments.context.dataModel['financieringnietdeclwerkminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdminuten'] = null;
  ___arguments.context.dataModel['financieringnietdeclreistijdkm'] = null;
  ___arguments.context.pageData['listcat'] = null;
  ___arguments.context.pageData['listcat2'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratiewerkgroep/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var offset, max;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    max = (new Date((new Date()).getTime() + (0 * 1000)));
  } else {
    max = (new Date((new Date()).getTime() + (2678400 * 1000)));
  }

  return max

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/registratiewerkgroep/components/748712f72a4715b1d221b05c6e55958b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))))) {
    (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('748712f72a4715b1d221b05c6e55958b')));
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
    (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = null;
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('748712f72a4715b1d221b05c6e55958b')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })((['De ingevoerde minuten zijn negatief en niet juist: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),' , vul svp het juiste aantal minuten in.'].join('')));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['gewerkteminuten'] = 0;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registratiewerkgroep/components/b6b8d1150b23758d4f6da13f36b43d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? 'Aantekeningen (het gaat hier om praktische aantekeningen, niet zorginhoudelijk)' : 'Aantekeningen (het is aan uzelf of u een aantekening wilt maken. Let op AVG: noteer geen persoonsgegevens)')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', null);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/6a6fc4ec5cdba2767288a88d488a6bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gemeente')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'relatieorganisatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naamrelatieorganisatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'toestemming')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bcdd6529b9af72c1dc5f2b150f425db2')), 'diplay')) == true && (getObjectProperty(___arguments.context.pageData, 'plaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1d224e227337a93d0c65d2ba36e957c')), 'diplay')) == true && (getObjectProperty(___arguments.context.pageData, 'naamrelatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('87d9155f45ee1cd9fed732ad852bebe7')), 'diplay')) == true && (getObjectProperty(___arguments.context.pageData, 'functierelatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('962b473968bc0c160d882b2a06d90d75')), 'diplay')) == true && (getObjectProperty(___arguments.context.pageData, 'telefoonnummerrelatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('539b503a8566e443d741cbe20b4c82ec')), 'diplay')) == true && (getObjectProperty(___arguments.context.pageData, 'mailrelatie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'omschrijving')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    await Backendless.Data.of('relatiebestand').save( ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'gemeente': (getObjectProperty(___arguments.context.pageData, 'gemeente')),'relatieorganisatie': (getObjectProperty(___arguments.context.pageData, 'relatieorganisatie')),'afdeling': (getObjectProperty(___arguments.context.pageData, 'afdeling')),'naamrelatieorganisatie': (getObjectProperty(___arguments.context.pageData, 'naamrelatieorganisatie')),'toestemming': (getObjectProperty(___arguments.context.pageData, 'toestemming')),'plaats': (getObjectProperty(___arguments.context.pageData, 'plaats')),'naamrelatie': (getObjectProperty(___arguments.context.pageData, 'naamrelatie')),'functierelatie': (getObjectProperty(___arguments.context.pageData, 'functierelatie')),'telefoonnummerrelatie': (getObjectProperty(___arguments.context.pageData, 'telefoonnummerrelatie')),'mailrelatie': (getObjectProperty(___arguments.context.pageData, 'mailrelatie')),'omschrijving': (getObjectProperty(___arguments.context.pageData, 'omschrijving')),'vervolgafspraken': (getObjectProperty(___arguments.context.pageData, 'vervolgafspraken')) }) );
    ___arguments.context.pageData['gemeente'] = null;
    ___arguments.context.pageData['relatieorganisatie'] = null;
    ___arguments.context.pageData['afdeling'] = null;
    ___arguments.context.pageData['naamrelatieorganisatie'] = null;
    ___arguments.context.pageData['toestemming'] = null;
    ___arguments.context.pageData['plaats'] = null;
    ___arguments.context.pageData['naamrelatie'] = null;
    ___arguments.context.pageData['functierelatie'] = null;
    ___arguments.context.pageData['telefoonnummerrelatie'] = null;
    ___arguments.context.pageData['mailrelatie'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['vervolgafspraken'] = null;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af81c5434c327dd5e00664370d1e7135', false);
    ___arguments.context.pageData['gemeentefilter'] = '%';
    ___arguments.context.pageData['relatieorganisatiefilter'] = '%';
    ___arguments.context.pageData['naamfilter'] = '%';
    ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\'','\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\''].join(''));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/c2411555e954b42d99a95c25f416ef0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af81c5434c327dd5e00664370d1e7135', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/5832e70cd0c3bdab88767fd341ed2b4e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('gemeente').setSortBy('gemeente ASC').setGroupBy('gemeente').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeente')),'label': (getObjectProperty(item, 'gemeente')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/443172a4bb5542370a5fcb8eec9e646b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('relatiebestandrelatieorganisatie').find(Backendless.DataQueryBuilder.create().setProperties('relatieorganisatie').setSortBy('relatieorganisatie ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'relatieorganisatie')),'label': (getObjectProperty(item, 'relatieorganisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/22e258e1f589656762074d9185c60a39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af81c5434c327dd5e00664370d1e7135', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/1d0c7fe1c6fd33af6a02fb84fa9c493d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af81c5434c327dd5e00664370d1e7135', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/632134d8362f454b82495bf86506b908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af81c5434c327dd5e00664370d1e7135', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/37ed90436b9b9e821a1e4c3d9c7d63aa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'toestemming')) == 'Ja, ik heb toestemming om persoonsgegevens te noteren') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e99476651c0c67a5fe86f61b6656e8', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d224e227337a93d0c65d2ba36e957c', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd8b6e4fee972fb34f917faf79bb427b', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcdd6529b9af72c1dc5f2b150f425db2', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ff61583adfdbcab1435633fadab492', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87d9155f45ee1cd9fed732ad852bebe7', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5903f98b301532c3f7746b3d7507c2be', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('962b473968bc0c160d882b2a06d90d75', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('689e9b5d346ece85959f335ada38478e', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('539b503a8566e443d741cbe20b4c82ec', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e99476651c0c67a5fe86f61b6656e8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1d224e227337a93d0c65d2ba36e957c', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd8b6e4fee972fb34f917faf79bb427b', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bcdd6529b9af72c1dc5f2b150f425db2', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ff61583adfdbcab1435633fadab492', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87d9155f45ee1cd9fed732ad852bebe7', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5903f98b301532c3f7746b3d7507c2be', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('962b473968bc0c160d882b2a06d90d75', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('689e9b5d346ece85959f335ada38478e', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('539b503a8566e443d741cbe20b4c82ec', false);
    ___arguments.context.pageData['naamrelatie'] = null;
    ___arguments.context.pageData['plaats'] = null;
    ___arguments.context.pageData['functierelatie'] = null;
    ___arguments.context.pageData['telefoonnummerrelatie'] = null;
    ___arguments.context.pageData['mailrelatie'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/relatiebestand/components/c1818d86bb7907fb7966b6e13857e692/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('relatiebestand').find(Backendless.DataQueryBuilder.create().setWhereClause((['plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''))).setProperties('gemeente').setSortBy('gemeente').setGroupBy('gemeente').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeente')),'label': (getObjectProperty(item, 'gemeente')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/a9479c8d0bbb0c71e777904b64e8852b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('relatiebestand').find(Backendless.DataQueryBuilder.create().setWhereClause((['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''))).setProperties('relatieorganisatie').setSortBy('relatieorganisatie').setGroupBy('relatieorganisatie').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'relatieorganisatie')),'label': (getObjectProperty(item, 'relatieorganisatie')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/relatiebestand/components/32f1257a064f7155302dfe265bbc6617/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('relatiebestand').find(Backendless.DataQueryBuilder.create().setWhereClause((['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\''].join(''))).setProperties('naam').setSortBy('naam').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/relatiebestand/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) || !((await Backendless.UserService.getUserRoles()).includes('Projectleider'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['gemeentefilter'] = '%';
  ___arguments.context.pageData['relatieorganisatiefilter'] = '%';
  ___arguments.context.pageData['naamfilter'] = '%';
  ___arguments.context.pageData['plaatsfilter'] = '%';
  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/relatiebestand/components/cc4da0bb9cbbc75e5d04c85cdaec4286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gemeentefilter'] = '%';
  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/166ff074d219d5626057c6359dd1a626/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['relatieorganisatiefilter'] = '%';
  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/994d7a165775797e2b112ad8b30a1356/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['naamfilter'] = '%';
  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiebestand/components/bcdd6529b9af72c1dc5f2b150f425db2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'','AND gemeente=\'',(getObjectProperty(___arguments.context.pageData, 'gemeente')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/1ed1d93c561e0c9bf7190c25ecfd77ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('relatiebestand').find(Backendless.DataQueryBuilder.create().setWhereClause((['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''))).setProperties('plaats').setSortBy('plaats').setGroupBy('plaats').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'plaats')),'label': (getObjectProperty(item, 'plaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/relatiebestand/components/6fee10cfd8e1eafd18036fd15392f97d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['plaatsfilter'] = '%';
  ___arguments.context.pageData['filter'] = (['gemeente LIKE\'',(getObjectProperty(___arguments.context.pageData, 'gemeentefilter')),'\' AND plaats LIKE\'',(getObjectProperty(___arguments.context.pageData, 'plaatsfilter')),'\' AND relatieorganisatie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'relatieorganisatiefilter')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'naamfilter')),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiesdossiersregistraties/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiesdossiersregistraties/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiesdossiersregistraties/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6a31c711cee53931db586f1616a9ae4', (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': 'registraties.objectId is null','properties': ['dossier', 'objectId'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/relatiesdossiersregistraties/components/bc0e3ceaf24ba35ef013930eb663a204/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var registratiesobjectId, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'dossier'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registraties'),'whereClause': JSON.stringify((['dossier=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('dossiers').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('dossiers'),'whereClause': JSON.stringify((['dossier=\'',j,'\''].join(''))),'groupBy': JSON.stringify('dossier') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/relatiesusersdossiers/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiesusersdossiers/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/relatiesusersdossiers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6a31c711cee53931db586f1616a9ae4', (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'Users[userdossiers].objectId is null','properties': ['username', 'objectId'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/relatiesusersdossiers/components/bc0e3ceaf24ba35ef013930eb663a204/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list, dossiersobjectId, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function createrelation() {
  for (var j_index in list) {
    j = list[j_index];
    dossiersobjectId = (await Backendless.Request.post(`${Backendless.appPath}/services/Paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Dossiers','whereClause': (['username=\'',j,'\''].join('')) }));
    await Backendless.Data.of('Users').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Paging/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'userdossiers', (dossiersobjectId.map(item => item['objectId'])));
  }
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  await createrelation();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/resterend/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/resterend/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('Projectleider')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/resterend/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/startconsult/components/ad1dda42ca6e610a84b4617b936eb2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ca11ef9e22d4db18616a3b46cf81159', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc49ccd3d5ae11b54385bcf5975c68fc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5bb7bb2dbc689c6497bd77199ae71b88', (await Backendless.Data.of('settingsjaarpakketorganisatie').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setProperties('organisatietotaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('04c2a6614184c0f28d4e32f21d57e3ba', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND jaar=\'',(new Date((new Date())).getFullYear()),'\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a86ec7eddf8acfadb7e897bd25dc085', (await Backendless.Data.of('settingsjaarpakket').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('calcmaxtotaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('56d243e2fb4e2828796696d237b26757', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c025722d2a621dd886eb0d521ecccdd2', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ea897d7b04497754b3c648ec125ba905', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86fc7142268f6fbcc19a8574fe7243bc', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b4e43a7975f95424328dae7a54472b9', (await Backendless.Data.of('hulpvraagconsultinwpro').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoerhulpvraag ASC').setPageSize(50))));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6deb646245ca010c41c8dae7284b0698', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['email', 'email2']).setGroupBy('email').setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6deb646245ca010c41c8dae7284b0698', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setGroupBy('email').setPageSize(10))));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten') {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        (function (message) { alert(message) })('Let op: dit is het één-na-laatste gesprek binnen dit traject. Bij het volgende gesprek dient u het traject af te ronden. Na afronding wordt het dossier door u gesloten. Alleen bij een nieuwe hulpvraag kan verlenging aangevraagd worden. Dit ter beoordeling door de coördinator. ');
      } else {
        (function (message) { alert(message) })((['Op dit dossier is nog ',(getObjectProperty(___arguments.context.appData, 'resterend')),' activiteit over, wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
          (function (message) { alert(message) })((['Alle beschikbare minuten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
            (function (message) { alert(message) })('Dit is het laatste consult, het dossier dient te worden gesloten');
          } else {
            (function (message) { alert(message) })((['Alle beschikbare activiteiten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
          }
        }
      } else {
        (function (message) { alert(message) })((['Alle beschikbare minuten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
      }
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.pageData, 'totaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'calcmaxtotaalbedrag'))) {
    (function (message) { alert(message) })((['U heeft het totaalbedrag aan registraties overschreden. Er kunnen geen registraties meer worden toegevoegd. Neem contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' om een verhoging van het budget voor het totaalbedrag voor dit jaar aan te vragen.'].join('')));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'registratiesorganisatietotaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'organisatietotaalbedrag'))) {
    (function (message) { alert(message) })((['Uw organisatie heeft het totaalbedrag aan registraties overschreden. Er kunnen geen registraties meer worden toegevoegd. Neem contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' om een verhoging van het budget voor uw organisatie aan te vragen.'].join('')));
    await Backendless.Messaging.sendEmail((['Organisatie ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),' budget overschreden'].join('')), new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br><br>','Organisatie ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),' heeft het jaar budget overschreden.','<body><br>','Deze organisatie kan vanaf nu geen registraties meer invoeren.','<body><br><br>','Met vriendelijke groet,','<body><br><br>','Lorio'].join('')) }), ensureArray('geestelijkeverzorgingrotterdam@gmail.com'), undefined);
  }
  ___arguments.context.pageData['filternietdeclarabel'] = (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f321800e4f0228994759e4216e87e0fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setProperties('financieringvws').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.get(`${Backendless.appPath}/services/dossieroverzichtpagingstartconsult/dossieroverzichtpagingstartconsult`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiestijd'),'whereClause': JSON.stringify((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))) }).send()));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.get(`${Backendless.appPath}/services/dossieroverzichtpagingstartconsult/dossieroverzichtpagingstartconsult`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiestijd'),'whereClause': JSON.stringify((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))) }).send()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/startconsult/components/c7fbacd5c7a570a46009ba087ca3b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/e618759de024b8c908d697decd9ab104/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/a251b96154f7907704cdcee2fd6b668b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/8455474a96f3f9d93f4cb676bd146aea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkbijeenkomstnpzf', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiewerkgroep', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Raad van Advies') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieraadvanadvies', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Triage/intake') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratietriage', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultpro', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult 1') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsult1', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkactiviteiten', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ontwikkeluren') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieontwikkeluren', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsgesprekken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsgesprekken', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Presentieactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiepresentieactiviteiten', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Qu69kvs' ? false : ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/8445c80c81cd6b6be17775cadf48b095/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'registratienummer'))));
    if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragerprofessional', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessional', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatz', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholing', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoaching', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    }
    await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      (function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8445c80c81cd6b6be17775cadf48b095')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'registratiesaanpassen')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join('');
  } else {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join('');
  }

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/startconsult/components/72423c480a48efc297c46db6161bcab8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  ___arguments.context.appData['financieringvws'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws'));
  ___arguments.context.appData['objectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'objectId'));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult zorgvrager' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/8ed9df97f8dcaaa23a3d1a236ffd6037/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Groepsconsult' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/d83d0e9ca08d634a6281249bb9519337/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/adff3329a7ec9f65a734a8518baabee4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/51ce3b71cab2ad45dd43e402c31a879f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult professional' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/83438a46c7ceb0f8171777eb09543983/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/ed3c554accf3b605e7a3fb18d43413e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'MDO/PaTz' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['dossierstatus'] = (___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['status']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/3863769ace655feb0a1c4e9eefb9b8dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    ___arguments.context.appData['questioscholingofmoreel'] = 'Scholing';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.appData['questioscholingofmoreel'] = 'Moreel beraad';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/c3fd85b124191dbb34afca818c44e24d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Coaching on the job' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/c7d1203aff62f4bac396c06c7594c785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/b9da9ad12389fb016b2ec7f14e3ae661/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/d706cee8adad334fd3ab74485b2eefb7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/8a165d9a227da25db24de3b338c39a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/693bca7d519a8965c4d9e36504c347bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/632359468ebe745a179807ebaa4509da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/fa2b6b0eb53a3faf102c7f8a03f18272/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossierusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'username'));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/799f82a31ce52d3b1887dd5469189f52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '0' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/13cc078f32be5deaa7a5fd7b9e26687c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '0' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/6c0a8895e8f23be1407f213cb501950d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/4c684fe47b1a15a1d1dd87632a5c8a99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/52039aba582d159d9c89e54210d8006e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/ac18185d6f512ed85929a6c35199b904/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Opbouw infrastructuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/b9e71c9d2ac8e61bb1b8ec1517bc2025/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Coördinatietaken' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/3fbd52bf24fde497b586f3be9e39c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/56d243e2fb4e2828796696d237b26757/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visibility = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.pageData, 'totaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'calcmaxtotaalbedrag'))) {
    visibility = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'registratiesorganisatietotaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'organisatietotaalbedrag'))) {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == '0') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == '0') {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
    visibility = false;
  } else {
    visibility = true;
  }

  return visibility

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/eb249244b2f869968021eefa5107d2c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/8c3ff7ee03b21df9cf14af9fbe9f0103/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult professional' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nieuwehulpvraag', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/13d4a4b729b230f275dceef495c68201/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelenzorgvrager', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/833d141a647d9e8d483b8062880b4d16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Coördinatietaken' ? false : ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossiernietquestio', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/f79d848d941c23f733eae65cc9cc4a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/29e6f4bc8158f38e9771bc0525f6b248/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/cd75c91b24eac9db8845bd0f5a7c55ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'a.pasterkamp@stichtingquestio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    } else {
      await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    }
    await Backendless.Data.of('historiedossieraanpassingsverzoeken').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanpassing`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }) );
    ___arguments.context.pageData['email'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/startconsult/components/81c3289858dcfab1de746996a3b23ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/c6efe5ce35e8452a389b54dc0564571e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/0f5d24d921631e67ac050353dae66881/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['gewerkteminuten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten'));
  ___arguments.context.appData['voorbereidingminuten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten'));
  ___arguments.context.appData['reistijdminutenspeciaal'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'reistijdminutenspeciaal'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/8d9e4339ca85ee8655878e77ee3b734d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var result, sum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    sum = (getObjectProperty(___arguments.context.appData, 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.appData, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.appData, 'reistijdminutenspeciaal'));
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
    ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  } else {
    sum = (getObjectProperty(___arguments.context.appData, 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.appData, 'gewerkteminuten'));
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
    ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/22735d2c0947bab7c295c27180d6a179/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));
  ___arguments.context.appData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'activiteit'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/44ddb4b847b981882b3c38be8d4db603/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND GV LIKE \'PL%\''].join(''))).setProperties(['email', 'naam']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var emailadres, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailadres = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND naam=\'',(getObjectProperty(___arguments.context.pageData, 'emailnaam')),'\'AND GV LIKE \'PL%\''].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['emailadres'] = (getObjectProperty(emailadres, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/003b63d93c283d0bce3614f8b641ae7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3527d4d75eebfe3b599e7ea425d60704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var minutenactiviteiten, cc, emailaddress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plemailinstellingenperregio')))) == '1') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' consulten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' bijeenkomsten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' groepsconsulten';
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      }
    } else {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' minuten';
    }
  } else {
    emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailadres'));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' bijeenkomsten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' minuten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' groepsconsulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      minutenactiviteiten = ' minuten';
    } else {
      minutenactiviteiten = ' minuten';
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    cc = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
  } else {
    cc = null;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    cc = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
  } else {
    cc = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'emailverlenging')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailminuten')) == null) {
    (function (message) { alert(message) })('Het aantal activiteiten of minuten verlenging is niet ingevuld.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4299d5c4c3bc15d3b1a3f563a91331f7')), 'display')) == ((getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) == null)) {
    (function (message) { alert(message) })('De vraag of de verlenging is besproken is niet ingevuld.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailverlenging')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('aanvraagverlengingutrecht', Backendless.EmailEnvelope.create({ addresses: emailaddress, ccAddresses: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), cc], bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`emailminuten`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten,[`overlegverlenging`]: (getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) }), undefined);
      }
    } else {
      if (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvjm') {
      } else {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('aanvraagverlenging', Backendless.EmailEnvelope.create({ addresses: emailaddress, ccAddresses: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), cc], bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`emailminuten`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten }), undefined);
        }
      }
    }
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 1,[`akkoordverzoekverlengingusername`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`aantal`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten,[`overlegverlenging`]: (getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) }) );
    ___arguments.context.pageData['emailverlenging'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);
  }
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Verstuur aanvraag verlenging naar ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/startconsult/components/c0d2b2b56de9d39d29f39c0f4e6df72d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/79dc760829dfd1f5b1eebec182e799a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/51c5539d4ac6444f06a3d2150977254f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/6f2e358cdb328a99a94ab6835aeeefaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/c708bec2b40ac4aebc495d1346fb6ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/8114b94eedb560249258709c9b06ef62/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Postcode:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/7de304217fe1dbd3bebab90883c7e58a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/61bc7bba80283a0cef1113687e588555/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/e9af06693359e8b3a6bd5b99d7e46c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/7c73dfd1bb75400a0b435253bc72d6c6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Postcode:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/423d37f5fde57fcf35b2f1085ed2819f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/49c48998dc1f649c8a5ab5daa18d0c3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = ['Selecteer de ',(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))),' aan wie u de verlenging wilt aanvragen.'].join('');

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/16f2a27626aee567f2abc5cf02fab8e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord')) == null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/7def8e6a257a021116e69099dbfac8a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == null ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/666d61c8344a3af96286da170de9176c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
      (function (message) { alert(message) })('Dit dossier is over het maximaal te besteden aantal minuten. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de projectleider via de knop \'vraag om verlenging\' op dit dossier.\'');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/startconsult/components/c808d09c0bc205ba29a65107bcbc16bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a27d511b65d86935cd359d6903d8ee7f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['calcmaxtotaalbedrag'] = (___arguments.context.dataModel['calcmaxtotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/aea3cc0707f51a74f01757148392c697/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['totaalbedrag'] = (___arguments.context.dataModel['totaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/d8173062d2d9798339a61699826abd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = (___arguments.context.pageData['calcmaxtotaalbedrag']) - (___arguments.context.pageData['totaalbedrag']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/5824d6b9ad042adda00ba4ff5e9da2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/2d12762ad49dbeafb4cca63a6c9c62bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/2ad13d2d82570db4e14b46336cd14745/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/edb3eb041b2fb4a2c1d6e37e308d9af6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['organisatietotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'organisatietotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/bafc7c2424ee498d053864181392739c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['registratiesorganisatietotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/9f8dfa5ca8cbb479af23fcab2c85c0b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = (___arguments.context.pageData['organisatietotaalbedrag']) - (___arguments.context.pageData['registratiesorganisatietotaalbedrag']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/d43c6ced28fed7199f958b18dd6aae5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plemailinstellingenperregio')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/9638aa0ecaeedee6c371a5e7f757b025/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailprojectleider'] = (getObjectProperty(___arguments.context.dataModel, 'email'));
  ___arguments.context.pageData['emailprojectleider2'] = (getObjectProperty(___arguments.context.dataModel, 'email2'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/1a2b3f430186c1e8d7a1249475976995/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/02e455861228350af0c751b4bf33b8d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e3ca2bf533e90aa177c3acb846ffb5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/6096d20b183c1505202222fb144fc19f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/cd2927aabd9f329309baf584fe1a6642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f133f4a3b64908969801b362e813d03c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/dc16b2b28ad50124f14e59aba88c99b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/ee26811c166b2671fd4b30396d3b9de9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e3d3549da5a9c99a77c7d7ca26a20b76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a4142bb3245d007cbe2f33d8396c4a34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/0ffecea995c506132f19adbcd29918b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e224cc6c3f19514a0664327e1b678f3c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f1d8d3197f96941815565a8c324e9774/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c'), 'cvlkenmerk')).slice(0, 3));
    await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsult/components/99e2e477526e1cd2a3d61ebe9df67749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/ed8f37cff0b47a06ecd5b132ed6b4ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'registratienummer'))));
    if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragernietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessionalnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsultnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatznietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholingnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoachingnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      await ( async function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'visible')) == true) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      visible = false;
    } else {
      visible = true;
    }
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed8f37cff0b47a06ecd5b132ed6b4ff2')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setopjeplek')))) == '1') {
      A = 'Reistijd minuten';
      B = 'Voorbereiding in minuten';
      C = 'Aantal kilometers';
    } else {
      A = 'Reistijd minuten';
      B = 'Reistijd in minuten';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    A = 'Reistijd minuten';
    B = 'Voorbereiding in minuten';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    A = 'Voorbereiding in minuten';
    B = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/startconsult/components/2afbd1b88c3c80f8488a90fd8f55534d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Ja') {
    ___arguments.context.pageData['visible'] = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Nee') {
    ___arguments.context.pageData['visible'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Gedeeltelijk') {
    ___arguments.context.pageData['visible'] = true;
  }

  return (getObjectProperty(___arguments.context.dataModel, 'financieringvws'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/95e735e2699a2c9c18eb71d17c9c064c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c555802a26f2bc2e4a3280fb198c7b5')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/1b4b5f7d140e13834db28825100e7cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) != true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: true }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b4b5f7d140e13834db28825100e7cc2', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty(___arguments.context.pageData, 'visible')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'controle')) == '1' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e71967d1c327c52bc748c52a401798d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing werkminuten',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
    await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
    await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > 30) {
      (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = 30;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 30 }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'));
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Werkgroep') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Raad van Advies') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  }

  },
  /* handler:onBlur */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'gewerkteminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'gewerkteminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/startconsult/components/4c1eae71097368c9ffb4682a435de1a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : false) : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : false) : true) : true) : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f4d1b9877fc28414b9fabf32e32fa2c4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'change': false }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/331b76b3b62b66f506f8e16777bfe73b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var result, sum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  result = result * 100;
  result = Math.round(result);
  result = result / 100;
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    sum = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'reistijdminutenspeciaal'));
    result = (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
  } else {
    sum = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten'));
    result = (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
  }
  await do_something();

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/1333f24438161b1cb617d4d99fbfbb83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/19ceeba44ecaa7293d38768c0236086e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b4b5f7d140e13834db28825100e7cc2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setSortBy('registratienummer DESC').setPageSize(50))));
  await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (message) { alert(message) })('Wijziging is opgeslagen');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/0bb318cfeb09cbf3731c24ffad791c22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : true) : true) : true)))) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/d758c36a29ff1b8880fffc7e56dbf872/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      visible = false;
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        visible = false;
      } else {
        visible = true;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      visible = false;
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
        visible = true;
      } else {
        visible = false;
      }
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/41be0c5de555cbc894aab63c1a8f77fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f4be3a896a76c9eac682935839d40a57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) != 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) != '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'questioscholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/7ca6c404b24af9ac0b87b35149e74bed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Ja') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Gedeeltelijk') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/3c57d7f2fec2a6ff82120bfa89fe1645/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e8bd652d38125d0ec5ed9d34b5fe49e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/5be6d03b513d3e2967a554485d5a78b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
        visible = false;
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
          visible = true;
        } else {
          visible = false;
        }
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/c7467fcad2181ac41ce607e232a2143a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Ja') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Gedeeltelijk') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/314c00a5072ccf610296f705ff5335a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing voorbereiding',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'voorbereidingminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'voorbereidingminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
          (function (message) { alert(message) })((String('De maximale tijd die U kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
          ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
          await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
          await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
          (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
        }
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2 && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Gelderland' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Willem')) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      } else {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
        await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
        await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) * 1 > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsult/components/56d28f7d91e7131f7e29c20c468fde84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdminuten',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsult/components/d69b8d49960b5b5354cc26ec2985771d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var reistijdbereking;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
    reistijdbereking = ___arguments.value - 20;
    if (reistijdbereking <= 0) {
      reistijdbereking = 0;
    }
  } else {
    reistijdbereking = ___arguments.value;
  }
  ___arguments.context.pageData['reistijdberekening'] = reistijdbereking;
  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminutenspeciaal`]: reistijdbereking }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminutenspeciaal`]: reistijdbereking }) );
  await new Promise(r => setTimeout(r, 750 || 0));
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = (getObjectProperty(___arguments.context.pageData, 'reistijdberekening'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdminutenspeciaal',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminutenspeciaal': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminutenspeciaal': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.pageData, 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.pageData, 'reistijdminutenspeciaal')) * 1 > (getObjectProperty(___arguments.context.appData, 'resterend'))) {
      if (false) {
        (function (message) { alert(message) })((['De totale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = '';
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsult/components/93ffb69bf6bac39e90dd710629a1fccd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdkm`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdkm',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdkm': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdkm': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsult/components/33850df7c3a2a302aab485ee06f5a379/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      visible = false;
    } else {
      visible = true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      visible = true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/c34279419038788a98a6009f85c39e85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })(([(getObjectProperty(___arguments.context.pageData, 'activiteit')),'-',(getObjectProperty(___arguments.context.dataModel, 'change')),'-',(getObjectProperty(___arguments.context.appData, 'resterend')),'-',(getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) * 1,'-',(getObjectProperty(___arguments.context.dataModel, 'controle'))].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3f285b566fd68b7a3236c9ccdaf376cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/d9134f5f43ab99abc115565bb15b8a52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'change'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/e50d16999358f0ba7eee5addb878dbbd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      visible = true;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/fd29c86e98b42712fe229d94f22955dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/045f640745f374090d067143b3b1f94b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/8eff0a4a5a243c1eff69fa357e58064d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer'))));
    Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie geopend','-dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer'))].join('')));
    await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragerprofessional', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessional', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholing', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailswerkgroep', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      (function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/b71ecfdb124f5f34684a9d1fe2e89d3c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'registratiesaanpassen')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/8638cafa0bffaf2116540035957b5b93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijdert',[`datum`]: (new Date(((new Date()).valueOf()))),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'dossier')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  await Backendless.Data.of('registraties').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),'\''].join('')) );
  await Backendless.Data.of('registratiestijd').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setSortBy('registratienummer DESC').setPageSize(50))));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/b89bda7bcec629afc5b74432b66769e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/aa7c406bc447c8dd77a1bd8ad765c153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/d67c7b7be29da7cf92b84c1c5d342401/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/9a74370a92b516ef2e0dca06da1de82f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.dataModel, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.dataModel, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/ce05c0e634d687d4c7ea5213352ef1e2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'registratiesgewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')),'registratiesvoorbereidingminuten': (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')),'registratiesreistijdkm': (getObjectProperty(___arguments.context.dataModel, 'reistijdkm')),'registratiesreistijdminuten': (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')),'registratiesreistijdminutenspeciaal': (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')),'registratiesaantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'registratiestotaalbedrag': (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/1b9f050c22955ece1567666e8283b77c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/9bb4108667b9402462352152cca32f93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/822eda1bf6b6b4e6adb96682411888e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/4e438f0e0e1a499912fbf2e6352bd9bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwdatumaanvraag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/a632352295ba52deaec7b62eecfacdd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Ja') {
    result = 'VWS';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) != 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) == 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroomwelke'));
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/3929c1413a5c68ff6c5e02989361390f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/598393eb5de28b6cd75e3d67ab06c386/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/9c3631d196f8a55b7418137fe41331bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/77d4d81111b382e577818e22c264b769/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwdatumaanvraag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/51e6a4ad3c416accd12811078e9fb352/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a2519b8c63194bbe3c739f278bb83075/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/24228601099f951b60cb7a6c95ebbb58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Ja') {
    result = 'VWS';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) != 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) == 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroomwelke'));
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/b967b4c9bc01f75d4494bb2457a7842c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/317534085809e628d56c2a3bf4372a32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/2f66b84356f914db5a0df80ae3579aba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/404a9d86dc0804a9802980e47588915a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/7e376eb574e697a3e01f9c78f47ca253/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/startconsult/components/c96a203632c17cd451c5706bb3a7ec3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/b9c13196381d536a4f938668ec1544a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/b2cdde63b5edf6a2243e8b12473b59fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/140308ce8be58f699c7dcb39fd8792ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Aantal geplande scholingen: ';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    text = 'Aantal geplande moreel beraden: ';
  } else {
    text = 'Aantal geplande scholingen: ';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/7a59a8b7bdd80353922138fbffcb7539/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/470e468e8286c52c451e2cb96238a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Coördinatietaken') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else {
    text = 'Aantal toegekende minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/677f4f02fa2d61260823edbec8464078/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Coördinatietaken') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else {
    text = 'Nog te besteden minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/6c450ccc689e1e755e24686fe3944bbb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemiddeld aantal minuten per scholing:';
  } else {
    text = 'Gemiddeld aantal minuten per scholing (incl. voorbereidingstijd, excl. reistijd):';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/2f4dbc98a80d9e45e809516bb0f1ae1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Consult cliënt';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/a5f248645d62ae9f71a8637f04f3e566/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Consult zorgvrager' ? false : true) : true) : true) : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/5416bc6892bc656d0b9d3964f1dfd2ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/50d16c0e8546b83e6671f35494238fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/b763dd3b599bce49eec6a2f4fa28f1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a7462e450507e8f4184d9634f62db774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/011fb349c28bcfe5ff8cb9974247e4fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/9bc57974ae4d6ef3d57ba9cfee24eb3d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/b56aeb3ec092bc630bc8fb67e60c50eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/c41f55df783c60a71aeae1d5eee48f15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/fa828d65cb27ba5d06023eba07bb083d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/07a324a600cb809380c1bc8a30d9cd45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aantekeningen_2023', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-aantekeningen geopend-','-dossier:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aantekeningen geopend',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/092c9087d26635f6c3240df168be02ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/d308f4b1af31e4919eeb26d5c245ed22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/6e85861324c53f78c165a0adbbb6135e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/0c428a2f677aad227c3ba7b8c7ff299e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier (reken hier de reistijd niet in mee).';
    } else {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier (reken hier de reistijd niet in mee).';
    }
  } else {
    text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/cc6829028999bf19c1e7c3723fadeba3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d2b8a463c0c02de112f88ae5b315158')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', false);
  }
  ___arguments.context.pageData['hulpvraagorigineel'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraag'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/00d8526e1ed31f5c1a516efc08452637/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }) );
  await Backendless.Messaging.sendEmailFromTemplate('hulpvraagaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'hulpvraagorigineel': (getObjectProperty(___arguments.context.pageData, 'hulpvraagorigineel')),'hulpvraaggewijzigd': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }), undefined);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', false);
  (function (message) { alert(message) })('De hulpvraag is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/6d773c83385128fab51fe595c90b5e22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/4299d5c4c3bc15d3b1a3f563a91331f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/6c67a0ea1b8bd069850824981ca4557b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14c116aeee1e70c6794525f78ca32767')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/0ce413051b1b9a795427ede66daf1383/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioscholingleerdoelen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingleerdoelen')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioscholingleerdoelen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingleerdoelen')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', false);
  (function (message) { alert(message) })('Het leerdoel is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/222b6047a62337873a53d94226b3343f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/67f49921a8e23618cdcbbba483725541/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('818e9b5f0096cc45518341dd6f92ffa9')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/1e1c491760320348eb5feed3d60476f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioconsultinwachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwachtergrondinformatie')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioconsultinwachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwachtergrondinformatie')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', false);
  (function (message) { alert(message) })('De achtergrondinformatie is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/9d8e5a96b7f44777d2e88cdc7473d22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('edc13506624dfe2882687b8d40476adc')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/368c3683682226b9f0e6465a2711be59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschscholing': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschscholing')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschscholing': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschscholing')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', false);
  (function (message) { alert(message) })('De omschrijving van de scholing is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/cbeb15974c5959a9c823c9f6d2198014/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aea93ab4064d88a8f8f82dd7b9ad6c82')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/721e3d5f43dedb4b351ec9ed02792c22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiomoreelberaadachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiomoreelberaadachtergrondinformatie')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiomoreelberaadachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiomoreelberaadachtergrondinformatie')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', false);
  (function (message) { alert(message) })('De achtergrondinformatie is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/b1c5ebe4d8a1eee95c9c23b3cfab5763/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a11a7552e0457a6cba73f1560bb3c4e')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/c7090d2be9c97cc33c09a8dab84863b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschrijvinggroepsconsult': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschrijvinggroepsconsult')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschrijvinggroepsconsult': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschrijvinggroepsconsult')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', false);
  (function (message) { alert(message) })('De omschrijving van het groepsconsult is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/fb226a55f5a47bc332fe0a45d69be78f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/d08966ccccffc52e11ce20a968baffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1025a2f8fdc23b2b9eae1ed1539d4811')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', false);
  }
  ___arguments.context.pageData['programmaorigineel'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/870ed0c7fd62826e65414701e9636e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', false);
  (function (message) { alert(message) })('De programma bijeenkomst tekst is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/13f5fc3165671a9bbca46037bf6ee606/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afa3ae9699cfe802b9057871b5953f9c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/e965416c5315bcdf809f43f85e72706b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/9524ed0b1e595292637c52cec3568afe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) == 'Nee') {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')),'wlzindicatiesoort': null }) );
    (function (message) { alert(message) })('De WLZ indicatie is aangepast');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) }) );
    (function (message) { alert(message) })('De WLZ indicatie is aangepast');
    (function (message) { alert(message) })('Controleer of de Soort WLZ indicatie ingevuld is, zo niet vul deze dan in!');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/bfb21e691a9d68fa96dfac4fe4e508b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7773764d95a794c63ff8b75e02de37a2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/284e32f9a24f12ca75bb9f5c1b526b69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatiesoort')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', true);
  (function (message) { alert(message) })('De soort WLZ indicatie is aangepast');

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('wlzindicatie').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'indicatiewlz')),'label': (getObjectProperty(item, 'indicatiewlz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/startconsult/components/7f8362ce3c412d566a388c8ec9323fb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/79a627029737569e6669024bb1490e6f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Werkgroep' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/e91a7513911a5bf8619fbf981d69a28a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Raad van Advies' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/7c3e8d9a588811ea9da5e92a5139138c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/aaeb08b7c3e61c36405e041f3316ffa3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/f32cb09785525b1ad6dfeb7a5c0e705b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/7cdde004cb3adaba9e8a4af607de2ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/977af1a237a5895ba2d89f0b86bdb57a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/28dddee5df2cb1b6cf12dacee1382ca9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'aantekeningprojectleider')) != null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f085e72bf0bdf3446eb623ae0ca8d831/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/ec295c1ef3c25d3e1ce901fb93b7fd1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/363bb46c27231ce541f9e40547e761d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/14fdf2245bac09586c95fc849bc98d62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/0603704608ae6bd2f1fc826bdb079cc7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a0e20ea2ed942ef177fab5d4324f00ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/e4842e0a21f1a06afad9934ea20ffb67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/6ce9b2a4cb92e8dddb06fcca64de41e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/6b9fe1ef1e12f8cc017c646fadf45d53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Netwerkactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/a0f5c237dde94665a1668a94ce936ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Ontwikkeluren' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/c266d3f5f74503fa73cbcd6348f57c49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/92be75553e9bd48a64836fa620f351f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/052cf06338f2b2ebdd8a7939cdd1cd3c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'emailminuten')) > 4) {
    (function (message) { alert(message) })('Het maximaal aantal activiteiten voor een verlenging voor consulten is 4 activiteiten.');
    ___arguments.context.pageData['emailminuten'] = 4;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['emailminuten'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/6d8aa8bbab795d9cdf9f6b6db4d7439f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/aeec0bc5d90b67a49eec98a2bc617022/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/7b3bd1073ca44d1a6d9e348f7315517f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/35f3bab7b62438032096fcd93844383b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afa3ae9699cfe802b9057871b5953f9c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/bf25182d3b146022cf2378c589090041/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiewerkgroep', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Raad van Advies') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieraadvanadvies', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultpro', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult 1') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsult1', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkactiviteiten', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ontwikkeluren') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieontwikkeluren', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/deb65a46e04444d6bc887a06dded5d5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/70ee133712585291e8af47627feacf38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/488e3943b4419334a6c356dcb6a62261/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult professional' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nieuwehulpvraag', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/1b9f62b7a5c10c915ccf1144e9754afb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/2d58f7f976d54b05285c3ba5c09d1d3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aantekeningen_2023', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-aantekeningen geopend-','-dossier:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aantekeningen geopend',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/5da3c4617f0e68a5917a18899e01edc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelenzorgvrager', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/12beae4e7e9e50dd3dcf6582b1856353/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3a811dec4547dcb58358149188067402/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Coördinatietaken' ? false : ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossiernietquestio', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/4785dde5cf837195768715f15b1fd094/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) != 'Scholing' ? false : ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/1bae19bd3c0da02d8ff34df5913b1e85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/96d76a4807ae8bbc3b3c4d390577baf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Personen (functie/ organisatie) betrokkenen:';
  } else {
    text = 'Naam PaTz of MDO:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/3c17d1c71ec5beadfbb2763eb39b26bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Netwerkbijeenkomst NPZF' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/8f9d2ecda7a7481b4323174e7e9f85a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/4dfd47831aa794d3704dccb20f1e428c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'consultinwgender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/1f57e176d149797518de08db6b6fdf14/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? 'Overhead' : 'Reistijd minuten')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/ce277b567da520ed72fd52a863daed5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    text = 'Overhead:';
  } else {
    text = 'Totaal reistijd in minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/1d492069c254bbd8d1dacfd8d5457c1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Triage/intake' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/1d79c1060f13d53391c56cc6f9a1f927/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/5faa1bc154366725a90d99f850ffbe7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/99826f741bd1c273343e13f76f529499/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/df35c84848783608a7d9fc1766e24218/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Groepsgesprekken' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/f2d972e38f681398fde848584618b883/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Presentieactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/44e222288de88fad5b280198ffd8b0a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/86d16bed3a47670686a8b8386b260b68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/800dfd2739443db8dd36bdc957e8f7a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3d088d98b9b882885ba868efe0d81adc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oude_code_01_10_2026() {
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND jaar >2025'].join('')), ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Rotterdamverzekering' }) );
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Rotterdamverzekering' }) );
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`pagina`]: 'startconsult',[`actie`]: ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' ','en alle registraties op dit dossier op subsidie Rotterdamverzekering gezet'].join('') }) );
  await Backendless.Messaging.sendEmailFromTemplate('rotterdamverzekering', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: 'financiencvl010@gmail.com', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', false);
  (function (message) { alert(message) })('Het dossier en de eventuele registraties op dit dossier zijn op de subsidie Rotterdamverzekering gezet.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/48a48bb899c8f841b7985f0a2b03fc48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/81e8d197a08374e6f9caa481952dc04a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/cd47c02ad281a1e83058f9fa94e17b01/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'nugv')) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nugv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/ad1dda42ca6e610a84b4617b936eb2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Geestelijk verzorger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ca11ef9e22d4db18616a3b46cf81159', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bc49ccd3d5ae11b54385bcf5975c68fc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5bb7bb2dbc689c6497bd77199ae71b88', (await Backendless.Data.of('settingsjaarpakketorganisatie').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setProperties('organisatietotaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('04c2a6614184c0f28d4e32f21d57e3ba', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND jaar=\'',(new Date((new Date())).getFullYear()),'\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a86ec7eddf8acfadb7e897bd25dc085', (await Backendless.Data.of('settingsjaarpakket').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('calcmaxtotaalbedrag').setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('56d243e2fb4e2828796696d237b26757', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c025722d2a621dd886eb0d521ecccdd2', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ea897d7b04497754b3c648ec125ba905', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('86fc7142268f6fbcc19a8574fe7243bc', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b4e43a7975f95424328dae7a54472b9', (await Backendless.Data.of('hulpvraagconsultinwpro').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoerhulpvraag ASC').setPageSize(50))));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6deb646245ca010c41c8dae7284b0698', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['email', 'email2']).setGroupBy('email').setPageSize(10))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6deb646245ca010c41c8dae7284b0698', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setGroupBy('email').setPageSize(10))));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten') {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        (function (message) { alert(message) })('Let op: dit is het vierde gesprek in de reeks van vijf. Bij het vijfde gesprek dient u het traject af te ronden. Na het vijfde gesprek wordt het dossier vervolgens door u gesloten. Alleen bij een nieuwe hulpvraag kan verlenging aangevraagd worden. Dit ter beoordeling door de coördinator.');
      } else {
        (function (message) { alert(message) })((['Op dit dossier is nog ',(getObjectProperty(___arguments.context.appData, 'resterend')),' activiteit over, wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
          (function (message) { alert(message) })((['Alle beschikbare minuten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
        } else {
          if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
            (function (message) { alert(message) })('Dit is het laatste consult, het dossier dient te worden gesloten');
          } else {
            (function (message) { alert(message) })((['Alle beschikbare activiteiten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
          }
        }
      } else {
        (function (message) { alert(message) })((['Alle beschikbare minuten op dit dossier zijn verbruikt. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' via de knop \'vraag om verlenging\' op dit dossier.\''].join('')));
      }
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.pageData, 'totaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'calcmaxtotaalbedrag'))) {
    (function (message) { alert(message) })((['U heeft het totaalbedrag aan registraties overschreden. Er kunnen geen registraties meer worden toegevoegd. Neem contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' om een verhoging van het budget voor het totaalbedrag voor dit jaar aan te vragen.'].join('')));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'registratiesorganisatietotaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'organisatietotaalbedrag'))) {
    (function (message) { alert(message) })((['Uw organisatie heeft het totaalbedrag aan registraties overschreden. Er kunnen geen registraties meer worden toegevoegd. Neem contact op met de ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))),' om een verhoging van het budget voor uw organisatie aan te vragen.'].join('')));
    await Backendless.Messaging.sendEmail((['Organisatie ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),' budget overschreden'].join('')), new Backendless.Bodyparts({ htmlmessage: (['<body>','Goedendag,','<body><br><br>','Organisatie ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),' heeft het jaar budget overschreden.','<body><br>','Deze organisatie kan vanaf nu geen registraties meer invoeren.','<body><br><br>','Met vriendelijke groet,','<body><br><br>','Lorio'].join('')) }), ensureArray('geestelijkeverzorgingrotterdam@gmail.com'), undefined);
  }
  ___arguments.context.pageData['filternietdeclarabel'] = (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f321800e4f0228994759e4216e87e0fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setProperties('financieringvws').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.get(`${Backendless.appPath}/services/dossieroverzichtpagingstartconsult/dossieroverzichtpagingstartconsult`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiestijd'),'whereClause': JSON.stringify((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))) }).send()));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.get(`${Backendless.appPath}/services/dossieroverzichtpagingstartconsult/dossieroverzichtpagingstartconsult`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiestijd'),'whereClause': JSON.stringify((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))) }).send()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/startconsultbackup/components/c7fbacd5c7a570a46009ba087ca3b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e618759de024b8c908d697decd9ab104/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a251b96154f7907704cdcee2fd6b668b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8455474a96f3f9d93f4cb676bd146aea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkbijeenkomstnpzf', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiewerkgroep', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Raad van Advies') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieraadvanadvies', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Triage/intake') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratietriage', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultpro', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult 1') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsult1', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkactiviteiten', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ontwikkeluren') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieontwikkeluren', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsgesprekken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsgesprekken', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Presentieactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiepresentieactiviteiten', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Qu69kvs' ? false : ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8445c80c81cd6b6be17775cadf48b095/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'registratienummer'))));
    if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragerprofessional', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessional', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatz', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholing', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoaching', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    }
    await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      (function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8445c80c81cd6b6be17775cadf48b095')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'registratiesaanpassen')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join('');
  } else {
    where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join('');
  }

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/72423c480a48efc297c46db6161bcab8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  ___arguments.context.appData['financieringvws'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws'));
  ___arguments.context.appData['objectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'objectId'));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult zorgvrager' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/8ed9df97f8dcaaa23a3d1a236ffd6037/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Groepsconsult' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/d83d0e9ca08d634a6281249bb9519337/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/adff3329a7ec9f65a734a8518baabee4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/51ce3b71cab2ad45dd43e402c31a879f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult professional' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/83438a46c7ceb0f8171777eb09543983/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ed3c554accf3b605e7a3fb18d43413e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'MDO/PaTz' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['dossierstatus'] = (___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['status']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/3863769ace655feb0a1c4e9eefb9b8dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing') {
    ___arguments.context.pageData['viewscholing'] = true;
    ___arguments.context.pageData['viewmoreelberaad'] = false;
    ___arguments.context.appData['questioscholingofmoreel'] = 'Scholing';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    ___arguments.context.pageData['viewmoreelberaad'] = true;
    ___arguments.context.pageData['viewscholing'] = false;
    ___arguments.context.appData['questioscholingofmoreel'] = 'Moreel beraad';
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/c3fd85b124191dbb34afca818c44e24d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Coaching on the job' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/c7d1203aff62f4bac396c06c7594c785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b9da9ad12389fb016b2ec7f14e3ae661/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d706cee8adad334fd3ab74485b2eefb7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8a165d9a227da25db24de3b338c39a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/693bca7d519a8965c4d9e36504c347bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/632359468ebe745a179807ebaa4509da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/fa2b6b0eb53a3faf102c7f8a03f18272/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossierusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'username'));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/799f82a31ce52d3b1887dd5469189f52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '0' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/13cc078f32be5deaa7a5fd7b9e26687c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '0' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6c0a8895e8f23be1407f213cb501950d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord')) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/4c684fe47b1a15a1d1dd87632a5c8a99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/52039aba582d159d9c89e54210d8006e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ac18185d6f512ed85929a6c35199b904/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Opbouw infrastructuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/b9e71c9d2ac8e61bb1b8ec1517bc2025/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Coördinatietaken' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/3fbd52bf24fde497b586f3be9e39c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/56d243e2fb4e2828796696d237b26757/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visibility = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' && (getObjectProperty(___arguments.context.pageData, 'totaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'calcmaxtotaalbedrag'))) {
    visibility = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.pageData, 'registratiesorganisatietotaalbedrag')) >= (getObjectProperty(___arguments.context.pageData, 'organisatietotaalbedrag'))) {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == '0') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == '0') {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visibility = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0 && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten') {
    visibility = true;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
    visibility = false;
  } else {
    visibility = true;
  }

  return visibility

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/eb249244b2f869968021eefa5107d2c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/8c3ff7ee03b21df9cf14af9fbe9f0103/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult professional' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nieuwehulpvraag', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/13d4a4b729b230f275dceef495c68201/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelenzorgvrager', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/833d141a647d9e8d483b8062880b4d16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Coördinatietaken' ? false : ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1b9f62b7a5c10c915ccf1144e9754afb'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossiernietquestio', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/f79d848d941c23f733eae65cc9cc4a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsultbackup/components/29e6f4bc8158f38e9771bc0525f6b248/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/cd75c91b24eac9db8845bd0f5a7c55ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'e.bron@stichtingquestio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    } else {
      await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    }
    await Backendless.Data.of('historiedossieraanpassingsverzoeken').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanpassing`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }) );
    ___arguments.context.pageData['email'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
    ___arguments.context.pageData['disablesave'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/81c3289858dcfab1de746996a3b23ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/c6efe5ce35e8452a389b54dc0564571e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/0f5d24d921631e67ac050353dae66881/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['gewerkteminuten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten'));
  ___arguments.context.appData['voorbereidingminuten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten'));
  ___arguments.context.appData['reistijdminutenspeciaal'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'reistijdminutenspeciaal'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/8d9e4339ca85ee8655878e77ee3b734d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var result, sum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    sum = (getObjectProperty(___arguments.context.appData, 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.appData, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.appData, 'reistijdminutenspeciaal'));
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
    ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  } else {
    sum = (getObjectProperty(___arguments.context.appData, 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.appData, 'gewerkteminuten'));
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
    ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('09134f7a57d2a69861ba2729051694ca'), 'pakketminutenakkoord'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/22735d2c0947bab7c295c27180d6a179/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));
  ___arguments.context.appData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'activiteit'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/44ddb4b847b981882b3c38be8d4db603/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\'',' AND GV LIKE \'PL%\''].join(''))).setProperties(['email', 'naam']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var emailadres, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailadres = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND naam=\'',(getObjectProperty(___arguments.context.pageData, 'emailnaam')),'\'AND GV LIKE \'PL%\''].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['emailadres'] = (getObjectProperty(emailadres, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsultbackup/components/003b63d93c283d0bce3614f8b641ae7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/3527d4d75eebfe3b599e7ea425d60704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var minutenactiviteiten, cc, emailaddress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plemailinstellingenperregio')))) == '1') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' consulten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' bijeenkomsten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' groepsconsulten';
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
        emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
        minutenactiviteiten = ' minuten';
      }
    } else {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' minuten';
    }
  } else {
    emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailadres'));
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' bijeenkomsten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' minuten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' groepsconsulten';
    } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
      emailaddress = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider'));
      minutenactiviteiten = ' consulten';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      minutenactiviteiten = ' minuten';
    } else {
      minutenactiviteiten = ' minuten';
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Lorio') {
    cc = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
  } else {
    cc = null;
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
    cc = (getObjectProperty(___arguments.context.pageData, 'emailprojectleider2'));
  } else {
    cc = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'emailverlenging')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailminuten')) == null) {
    (function (message) { alert(message) })('Het aantal activiteiten of minuten verlenging is niet ingevuld.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4299d5c4c3bc15d3b1a3f563a91331f7')), 'display')) == ((getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) == null)) {
    (function (message) { alert(message) })('De vraag of de verlenging is besproken is niet ingevuld.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailverlenging')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('aanvraagverlengingutrecht', Backendless.EmailEnvelope.create({ addresses: emailaddress, ccAddresses: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), cc], bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`emailminuten`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten,[`overlegverlenging`]: (getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) }), undefined);
      }
    } else {
      if (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) != 'lorioquestiogvjm') {
      } else {
        if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        } else {
          await Backendless.Messaging.sendEmailFromTemplate('aanvraagverlenging', Backendless.EmailEnvelope.create({ addresses: emailaddress, ccAddresses: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), cc], bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`emailminuten`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten }), undefined);
        }
      }
    }
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`akkoordverzoekverlenging`]: 1,[`akkoordverzoekverlengingusername`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`aantal`]: (getObjectProperty(___arguments.context.pageData, 'emailminuten')),[`minutenactiviteiten`]: minutenactiviteiten,[`overlegverlenging`]: (getObjectProperty(___arguments.context.pageData, 'overlegverlenging')) }) );
    ___arguments.context.pageData['emailverlenging'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);
  }
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Verstuur aanvraag verlenging naar ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c0d2b2b56de9d39d29f39c0f4e6df72d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/79dc760829dfd1f5b1eebec182e799a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/51c5539d4ac6444f06a3d2150977254f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6f2e358cdb328a99a94ab6835aeeefaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c708bec2b40ac4aebc495d1346fb6ab9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8114b94eedb560249258709c9b06ef62/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Postcode:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7de304217fe1dbd3bebab90883c7e58a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/61bc7bba80283a0cef1113687e588555/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e9af06693359e8b3a6bd5b99d7e46c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Postcode:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemeente:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7c73dfd1bb75400a0b435253bc72d6c6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Postcode:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/423d37f5fde57fcf35b2f1085ed2819f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/49c48998dc1f649c8a5ab5daa18d0c3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = ['Selecteer de ',(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))),' aan wie u de verlenging wilt aanvragen.'].join('');

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/16f2a27626aee567f2abc5cf02fab8e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228'), 'akkoord')) == null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7def8e6a257a021116e69099dbfac8a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('20aedf6aee1d2faa514abd46b18fc228')['akkoord']) == null ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/666d61c8344a3af96286da170de9176c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief' && (getObjectProperty(___arguments.context.pageData, 'akkoord')) == 1 && (getObjectProperty(___arguments.context.appData, 'resterend')) <= 0) {
      (function (message) { alert(message) })('Dit dossier is over het maximaal te besteden aantal minuten. Sluit dit dossier af of wanneer u meer tijd nodig heeft op dit dossier, neem dan contact op met de projectleider via de knop \'vraag om verlenging\' op dit dossier.\'');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/startconsultbackup/components/c808d09c0bc205ba29a65107bcbc16bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a27d511b65d86935cd359d6903d8ee7f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['calcmaxtotaalbedrag'] = (___arguments.context.dataModel['calcmaxtotaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/aea3cc0707f51a74f01757148392c697/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['totaalbedrag'] = (___arguments.context.dataModel['totaalbedrag']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/d8173062d2d9798339a61699826abd3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = (___arguments.context.pageData['calcmaxtotaalbedrag']) - (___arguments.context.pageData['totaalbedrag']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/5824d6b9ad042adda00ba4ff5e9da2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2d12762ad49dbeafb4cca63a6c9c62bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2ad13d2d82570db4e14b46336cd14745/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/edb3eb041b2fb4a2c1d6e37e308d9af6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['organisatietotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'organisatietotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/bafc7c2424ee498d053864181392739c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['registratiesorganisatietotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/9f8dfa5ca8cbb479af23fcab2c85c0b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = (___arguments.context.pageData['organisatietotaalbedrag']) - (___arguments.context.pageData['registratiesorganisatietotaalbedrag']);

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d43c6ced28fed7199f958b18dd6aae5d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plemailinstellingenperregio')))) == '1' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/9638aa0ecaeedee6c371a5e7f757b025/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailprojectleider'] = (getObjectProperty(___arguments.context.dataModel, 'email'));
  ___arguments.context.pageData['emailprojectleider2'] = (getObjectProperty(___arguments.context.dataModel, 'email2'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/1a2b3f430186c1e8d7a1249475976995/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/02e455861228350af0c751b4bf33b8d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e3ca2bf533e90aa177c3acb846ffb5bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6096d20b183c1505202222fb144fc19f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/cd2927aabd9f329309baf584fe1a6642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f133f4a3b64908969801b362e813d03c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/dc16b2b28ad50124f14e59aba88c99b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ee26811c166b2671fd4b30396d3b9de9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e3d3549da5a9c99a77c7d7ca26a20b76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a4142bb3245d007cbe2f33d8396c4a34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/0ffecea995c506132f19adbcd29918b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e224cc6c3f19514a0664327e1b678f3c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f1d8d3197f96941815565a8c324e9774/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c'), 'cvlkenmerk')).length > 3) {
    ;await ( async function (message){ alert(message) })('Het CvL-kenmerk bestaat uit drie getallen');
    ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c')['cvlkenmerk'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c'), 'cvlkenmerk')).slice(0, 3));
    await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('e2576d7fb4ffc32dd8a76338ff1ffb1c') );
    ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsultbackup/components/99e2e477526e1cd2a3d61ebe9df67749/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'cvlkenmerk')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ed8f37cff0b47a06ecd5b132ed6b4ff2/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'registratienummer'))));
    if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragernietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessionalnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsultnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatznietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholingnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoachingnietdecl', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
      await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      await ( async function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'visible')) == true) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      visible = false;
    } else {
      visible = true;
    }
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed8f37cff0b47a06ecd5b132ed6b4ff2')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setopjeplek')))) == '1') {
      A = 'Reistijd minuten';
      B = 'Voorbereiding in minuten';
      C = 'Aantal kilometers';
    } else {
      A = 'Reistijd minuten';
      B = 'Reistijd in minuten';
    }
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    A = 'Reistijd minuten';
    B = 'Voorbereiding in minuten';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    A = 'Voorbereiding in minuten';
    B = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Nee\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join('');

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2afbd1b88c3c80f8488a90fd8f55534d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Ja') {
    ___arguments.context.pageData['visible'] = false;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Nee') {
    ___arguments.context.pageData['visible'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'financieringvws')) == 'Gedeeltelijk') {
    ___arguments.context.pageData['visible'] = true;
  }

  return (getObjectProperty(___arguments.context.dataModel, 'financieringvws'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/95e735e2699a2c9c18eb71d17c9c064c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4c555802a26f2bc2e4a3280fb198c7b5')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/1b4b5f7d140e13834db28825100e7cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'VWS\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) != true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: true }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b4b5f7d140e13834db28825100e7cc2', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty(___arguments.context.pageData, 'visible')) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'controle')) == '1' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e71967d1c327c52bc748c52a401798d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing werkminuten',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
    await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
    await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > 30) {
      (function (message) { alert(message) })('De maximale tijd die u kunt invoeren is 30 minuten.');
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = 30;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 30 }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdconsultinwpro'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdgroepsconsult'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdmdopatz'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdscholing'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoordinatie'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht' && (getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = (getObjectProperty(___arguments.context.appData, 'maxtijdopbouwinfra'));
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Werkgroep') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdwerkgroep'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Raad van Advies') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdraadvanadvies'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')))) == 1 && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      } else {
        (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
        await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`gewerkteminuten`]: 0 }) );
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e71967d1c327c52bc748c52a401798d8')));
      }
    }
  }

  },
  /* handler:onBlur */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'gewerkteminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'gewerkteminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/startconsultbackup/components/4c1eae71097368c9ffb4682a435de1a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : false) : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : false) : true) : true) : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f4d1b9877fc28414b9fabf32e32fa2c4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'change': false }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/331b76b3b62b66f506f8e16777bfe73b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var result, sum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  result = result * 100;
  result = Math.round(result);
  result = result / 100;
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    sum = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'reistijdminutenspeciaal'));
    result = (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
  } else {
    sum = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'voorbereidingminuten')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('32ad4e779e429ce3106fd7fab4f5f36c'), 'gewerkteminuten'));
    result = (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord')) - sum;
    ___arguments.context.appData['resterend'] = result;
  }
  await do_something();

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/1333f24438161b1cb617d4d99fbfbb83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'pakketminutenakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/19ceeba44ecaa7293d38768c0236086e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1b4b5f7d140e13834db28825100e7cc2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setSortBy('registratienummer DESC').setPageSize(50))));
  await Backendless.Data.of('registraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (message) { alert(message) })('Wijziging is opgeslagen');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/0bb318cfeb09cbf3731c24ffad791c22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : true) : true) : true)))) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d758c36a29ff1b8880fffc7e56dbf872/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      visible = false;
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        visible = false;
      } else {
        visible = true;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      visible = false;
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
        visible = true;
      } else {
        visible = false;
      }
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/41be0c5de555cbc894aab63c1a8f77fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f4be3a896a76c9eac682935839d40a57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) != 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) != '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'questioscholingwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7ca6c404b24af9ac0b87b35149e74bed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = false;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Ja') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Gedeeltelijk') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = false;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = false;
        } else {
          visible = true;
        }
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/3c57d7f2fec2a6ff82120bfa89fe1645/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
        visible = false;
      } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
        visible = false;
      } else {
        visible = true;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e8bd652d38125d0ec5ed9d34b5fe49e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/5be6d03b513d3e2967a554485d5a78b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
        visible = false;
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
          visible = true;
        } else {
          visible = false;
        }
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c7467fcad2181ac41ce607e232a2143a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Zorgvrager niet aanwezig') {
          visible = true;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'consultwijze')) == 'Face-to-face') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Nee') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = false;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Ja') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'financieringvws')) == 'Gedeeltelijk') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'scholingwijze')) == 'Face-to-face') {
          visible = true;
        } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
          visible = true;
        } else {
          visible = false;
        }
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'change')) == true) {
        visible = true;
      } else {
        visible = false;
      }
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/314c00a5072ccf610296f705ff5335a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing voorbereiding',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'voorbereidingminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'voorbereidingminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
    await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
          (function (message) { alert(message) })((String('De maximale tijd die U kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
          ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
          await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
          await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
          (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
        }
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u in totaal kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2 && ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Gelderland' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Willem')) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      } else {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
        await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      }
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.appData, 'gvregistrerenzonderakkoord')) == 'true' && (getObjectProperty(___arguments.context.appData, 'akkoord')) == '0') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
        (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
        await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
        await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      }
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'resterend'))))) {
      (function (message) { alert(message) })((['De maximale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) * 1 > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))))) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdcoaching'))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('314c00a5072ccf610296f705ff5335a1')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'voorbereidingminuten')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2) {
      (function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren voor voorbereiding is ') + String(Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'gewerkteminuten')) / 2))));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['voorbereidingminuten'] = null;
      await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
      await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`voorbereidingminuten`]: 0 }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsultbackup/components/56d28f7d91e7131f7e29c20c468fde84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminuten`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdminuten',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminuten': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminuten': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminuten')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminuten')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminuten'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56d28f7d91e7131f7e29c20c468fde84')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsultbackup/components/d69b8d49960b5b5354cc26ec2985771d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var reistijdbereking;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1') {
    reistijdbereking = ___arguments.value - 20;
    if (reistijdbereking <= 0) {
      reistijdbereking = 0;
    }
  } else {
    reistijdbereking = ___arguments.value;
  }
  ___arguments.context.pageData['reistijdberekening'] = reistijdbereking;
  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminutenspeciaal`]: reistijdbereking }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdminutenspeciaal`]: reistijdbereking }) );
  await new Promise(r => setTimeout(r, 750 || 0));
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = (getObjectProperty(___arguments.context.pageData, 'reistijdberekening'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdminutenspeciaal',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminutenspeciaal': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdminutenspeciaal': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')))) == 1 && (getObjectProperty(___arguments.context.pageData, 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.pageData, 'reistijdminutenspeciaal')) * 1 > (getObjectProperty(___arguments.context.appData, 'resterend'))) {
      if (false) {
        (function (message) { alert(message) })((['De totale tijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'resterend')),' minuten. Indien u meer tijd nodig heeft, neem dan contact op met de projectleider. Hiervoor kan u de knop \'vraag om verlenging\' aanklikken op dit dossier.'].join('')));
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['gewerkteminuten'] = '';
        ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal')),' minuten.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdminutenspeciaal'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d69b8d49960b5b5354cc26ec2985771d')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsultbackup/components/93ffb69bf6bac39e90dd710629a1fccd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').save( ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f') );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ [`reistijdkm`]: ___arguments.value }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  await Backendless.Data.of('historieregistratieaanpassingen').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aanpassing reistijdkm',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`vorige waarde`]: ___arguments.prevValue,[`nieuwe waarde`]: ___arguments.value }) );

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdkm': 0 }) );
  await Backendless.Data.of('registratiestijd').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),'\''].join('')), ({ 'reistijdkm': 0 }) );
  ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) < 0) {
    (function (message) { alert(message) })('Er kan geen negatief getal ingevuld worden');
    ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
      (function (message) { alert(message) })((['De maximale reistijd die u kunt invoeren is ',(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm')),' kilometer.'].join('')));
      ___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f')['reistijdkm'] = '';
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93ffb69bf6bac39e90dd710629a1fccd')));
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/startconsultbackup/components/33850df7c3a2a302aab485ee06f5a379/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      visible = false;
    } else {
      visible = true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      visible = false;
    } else {
      visible = true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c34279419038788a98a6009f85c39e85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })(([(getObjectProperty(___arguments.context.pageData, 'activiteit')),'-',(getObjectProperty(___arguments.context.dataModel, 'change')),'-',(getObjectProperty(___arguments.context.appData, 'resterend')),'-',(getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) * 1 + (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) * 1,'-',(getObjectProperty(___arguments.context.dataModel, 'controle'))].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/3f285b566fd68b7a3236c9ccdaf376cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d9134f5f43ab99abc115565bb15b8a52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'change'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e50d16999358f0ba7eee5addb878dbbd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    visible = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvnietdeclarabel')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Questio') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      visible = true;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
      visible = true;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/fd29c86e98b42712fe229d94f22955dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/045f640745f374090d067143b3b1f94b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8eff0a4a5a243c1eff69fa357e58064d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer'))));
    Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie geopend','-dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer'))].join('')));
    await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultzorgvragerprofessional', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieprofessional', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsgroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsmdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsscholing', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailscoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailswerkgroep', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3bb649cb7834154ee82cd00bb0743e7f'), 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      (function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/b71ecfdb124f5f34684a9d1fe2e89d3c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'registratiesaanpassen')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/8638cafa0bffaf2116540035957b5b93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historielog').save( ({ [`actie`]: 'Registratie verwijdert',[`datum`]: (new Date(((new Date()).valueOf()))),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'dossier')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  await Backendless.Data.of('registraties').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),'\''].join('')) );
  await Backendless.Data.of('registratiestijd').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c555802a26f2bc2e4a3280fb198c7b5'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e735e2699a2c9c18eb71d17c9c064c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ceeba44ecaa7293d38768c0236086e', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registratiestijd').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND gebruiker <>\'vrijwilliger\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setSortBy('registratienummer DESC').setPageSize(50))));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Ja\' OR ','dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND financieringvws=\'Gedeeltelijk\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4d1b9877fc28414b9fabf32e32fa2c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', (await Backendless.Request.post(`${Backendless.appPath}/services/dossieroverzichtpaging/dossieroverzichtpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', (await Backendless.Request.post(`${Backendless.appPath}/services/countensumpaging/countensumpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registraties','whereClause': (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) })));
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/b89bda7bcec629afc5b74432b66769e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c555802a26f2bc2e4a3280fb198c7b5', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/aa7c406bc447c8dd77a1bd8ad765c153/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdwillem')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d67c7b7be29da7cf92b84c1c5d342401/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsconsult') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Utrecht') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
      visible = false;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      visible = false;
    } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coaching on the job') {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
      visible = true;
    } else {
      visible = false;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/9a74370a92b516ef2e0dca06da1de82f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.dataModel, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.dataModel, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/ce05c0e634d687d4c7ea5213352ef1e2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'registratiesgewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')),'registratiesvoorbereidingminuten': (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')),'registratiesreistijdkm': (getObjectProperty(___arguments.context.dataModel, 'reistijdkm')),'registratiesreistijdminuten': (getObjectProperty(___arguments.context.dataModel, 'reistijdminuten')),'registratiesreistijdminutenspeciaal': (getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')),'registratiesaantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'registratiestotaalbedrag': (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/1b9f050c22955ece1567666e8283b77c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.dataModel, 'dossier')),'\''].join('')), ({ 'dossieraantalconsulten': (getObjectProperty(___arguments.context.dataModel, 'aantalconsulten')),'dossiergewerkteminuten': (getObjectProperty(___arguments.context.dataModel, 'gewerkteminuten')) + (getObjectProperty(___arguments.context.dataModel, 'voorbereidingminuten')) }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/9bb4108667b9402462352152cca32f93/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvgeboortedatum')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/822eda1bf6b6b4e6adb96682411888e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/4e438f0e0e1a499912fbf2e6352bd9bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwdatumaanvraag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a632352295ba52deaec7b62eecfacdd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Ja') {
    result = 'VWS';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) != 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) == 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroomwelke'));
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/3929c1413a5c68ff6c5e02989361390f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/598393eb5de28b6cd75e3d67ab06c386/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/9c3631d196f8a55b7418137fe41331bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/77d4d81111b382e577818e22c264b769/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwdatumaanvraag'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/51e6a4ad3c416accd12811078e9fb352/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a2519b8c63194bbe3c739f278bb83075/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/24228601099f951b60cb7a6c95ebbb58/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Ja') {
    result = 'VWS';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) != 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroom')) == 'Andere financieringsstroom') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringstroomwelke'));
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b967b4c9bc01f75d4494bb2457a7842c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvregistratievragenindossierscholing')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/317534085809e628d56c2a3bf4372a32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2f66b84356f914db5a0df80ae3579aba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/404a9d86dc0804a9802980e47588915a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7e376eb574e697a3e01f9c78f47ca253/bundle.js', [], () => ({
  /* content */
  /* content */
}))

define('./pages/startconsultbackup/components/c96a203632c17cd451c5706bb3a7ec3a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b9c13196381d536a4f938668ec1544a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b2cdde63b5edf6a2243e8b12473b59fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/140308ce8be58f699c7dcb39fd8792ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing') {
    text = 'Aantal geplande scholingen: ';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad') {
    text = 'Aantal geplande moreel beraden: ';
  } else {
    text = 'Aantal geplande scholingen: ';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7a59a8b7bdd80353922138fbffcb7539/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/470e468e8286c52c451e2cb96238a6ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Coördinatietaken') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Aantal toegekende activiteiten:';
  } else {
    text = 'Aantal toegekende minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/677f4f02fa2d61260823edbec8464078/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Coördinatietaken') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing') {
    text = 'Nog te besteden activiteiten:';
  } else {
    text = 'Nog te besteden minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6c450ccc689e1e755e24686fe3944bbb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Gemiddeld aantal minuten per scholing:';
  } else {
    text = 'Gemiddeld aantal minuten per scholing (incl. voorbereidingstijd, excl. reistijd):';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2f4dbc98a80d9e45e809516bb0f1ae1a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
    text = 'Consult cliënt';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit'));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a5f248645d62ae9f71a8637f04f3e566/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Werkgroep' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Raad van Advies' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Triage/intake' ? false : true) : true) : true) : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Groepsconsult' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'MDO/PaTz' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) != 'Consult zorgvrager' ? false : true) : true) : true) : true))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/5416bc6892bc656d0b9d3964f1dfd2ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/50d16c0e8546b83e6671f35494238fc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b763dd3b599bce49eec6a2f4fa28f1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a7462e450507e8f4184d9634f62db774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/011fb349c28bcfe5ff8cb9974247e4fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/9bc57974ae4d6ef3d57ba9cfee24eb3d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/b56aeb3ec092bc630bc8fb67e60c50eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c41f55df783c60a71aeae1d5eee48f15/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/fa828d65cb27ba5d06023eba07bb083d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/07a324a600cb809380c1bc8a30d9cd45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aantekeningen_2023', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-aantekeningen geopend-','-dossier:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aantekeningen geopend',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/092c9087d26635f6c3240df168be02ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/d308f4b1af31e4919eeb26d5c245ed22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/6e85861324c53f78c165a0adbbb6135e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/0c428a2f677aad227c3ba7b8c7ff299e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
    } else {
      text = 'Geef hieronder aan hoeveel activiteiten u verwacht extra nodig te zijn op dit dossier.';
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier (reken hier de reistijd niet in mee).';
    } else {
      text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier (reken hier de reistijd niet in mee).';
    }
  } else {
    text = 'Geef hieronder aan hoeveel minuten u verwacht extra nodig te zijn op dit dossier.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/cc6829028999bf19c1e7c3723fadeba3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d2b8a463c0c02de112f88ae5b315158')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', false);
  }
  ___arguments.context.pageData['hulpvraagorigineel'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraag'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/00d8526e1ed31f5c1a516efc08452637/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }) );
  await Backendless.Messaging.sendEmailFromTemplate('hulpvraagaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@stichtingquestio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'hulpvraagorigineel': (getObjectProperty(___arguments.context.pageData, 'hulpvraagorigineel')),'hulpvraaggewijzigd': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'hulpvraagaanpassen')) }), undefined);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d2b8a463c0c02de112f88ae5b315158', false);
  (function (message) { alert(message) })('De hulpvraag is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/6d773c83385128fab51fe595c90b5e22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/4299d5c4c3bc15d3b1a3f563a91331f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6c67a0ea1b8bd069850824981ca4557b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('14c116aeee1e70c6794525f78ca32767')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/0ce413051b1b9a795427ede66daf1383/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioscholingleerdoelen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingleerdoelen')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioscholingleerdoelen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingleerdoelen')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14c116aeee1e70c6794525f78ca32767', false);
  (function (message) { alert(message) })('Het leerdoel is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/222b6047a62337873a53d94226b3343f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Scholing' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/67f49921a8e23618cdcbbba483725541/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('818e9b5f0096cc45518341dd6f92ffa9')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/1e1c491760320348eb5feed3d60476f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioconsultinwachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwachtergrondinformatie')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questioconsultinwachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioconsultinwachtergrondinformatie')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('818e9b5f0096cc45518341dd6f92ffa9', false);
  (function (message) { alert(message) })('De achtergrondinformatie is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/9d8e5a96b7f44777d2e88cdc7473d22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('edc13506624dfe2882687b8d40476adc')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/368c3683682226b9f0e6465a2711be59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschscholing': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschscholing')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschscholing': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschscholing')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('edc13506624dfe2882687b8d40476adc', false);
  (function (message) { alert(message) })('De omschrijving van de scholing is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/cbeb15974c5959a9c823c9f6d2198014/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aea93ab4064d88a8f8f82dd7b9ad6c82')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/721e3d5f43dedb4b351ec9ed02792c22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiomoreelberaadachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiomoreelberaadachtergrondinformatie')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiomoreelberaadachtergrondinformatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiomoreelberaadachtergrondinformatie')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aea93ab4064d88a8f8f82dd7b9ad6c82', false);
  (function (message) { alert(message) })('De achtergrondinformatie is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/b1c5ebe4d8a1eee95c9c23b3cfab5763/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a11a7552e0457a6cba73f1560bb3c4e')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c7090d2be9c97cc33c09a8dab84863b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschrijvinggroepsconsult': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschrijvinggroepsconsult')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'omschrijvinggroepsconsult': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'omschrijvinggroepsconsult')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a11a7552e0457a6cba73f1560bb3c4e', false);
  (function (message) { alert(message) })('De omschrijving van het groepsconsult is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/fb226a55f5a47bc332fe0a45d69be78f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/d08966ccccffc52e11ce20a968baffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1025a2f8fdc23b2b9eae1ed1539d4811')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', false);
  }
  ___arguments.context.pageData['programmaorigineel'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/870ed0c7fd62826e65414701e9636e3d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1025a2f8fdc23b2b9eae1ed1539d4811', false);
  (function (message) { alert(message) })('De programma bijeenkomst tekst is aangepast');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/13f5fc3165671a9bbca46037bf6ee606/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afa3ae9699cfe802b9057871b5953f9c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/e965416c5315bcdf809f43f85e72706b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/9524ed0b1e595292637c52cec3568afe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) == 'Nee') {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')),'wlzindicatiesoort': null }) );
    (function (message) { alert(message) })('De WLZ indicatie is aangepast');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatie')) }) );
    (function (message) { alert(message) })('De WLZ indicatie is aangepast');
    (function (message) { alert(message) })('Controleer of de Soort WLZ indicatie ingevuld is, zo niet vul deze dan in!');
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsultbackup/components/bfb21e691a9d68fa96dfac4fe4e508b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7773764d95a794c63ff8b75e02de37a2')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/284e32f9a24f12ca75bb9f5c1b526b69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'wlzindicatiesoort')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7773764d95a794c63ff8b75e02de37a2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('237cc81e69ae12c93ba808a4f0089388', true);
  (function (message) { alert(message) })('De soort WLZ indicatie is aangepast');

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('wlzindicatie').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'indicatiewlz')),'label': (getObjectProperty(item, 'indicatiewlz')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7f8362ce3c412d566a388c8ec9323fb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/79a627029737569e6669024bb1490e6f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Werkgroep' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e91a7513911a5bf8619fbf981d69a28a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Raad van Advies' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7c3e8d9a588811ea9da5e92a5139138c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/aaeb08b7c3e61c36405e041f3316ffa3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f32cb09785525b1ad6dfeb7a5c0e705b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'questioscholingofmoreel')) == 'Moreel beraad' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/7cdde004cb3adaba9e8a4af607de2ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' || (JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult professional' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/977af1a237a5895ba2d89f0b86bdb57a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz' ? true : ((JSON.parse((getObjectProperty(___arguments.context.appData, 'aw2024')))) == true && (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'MDO/PaTz' ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/28dddee5df2cb1b6cf12dacee1382ca9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'aantekeningprojectleider')) != null ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f085e72bf0bdf3446eb623ae0ca8d831/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ec295c1ef3c25d3e1ce901fb93b7fd1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/363bb46c27231ce541f9e40547e761d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/14fdf2245bac09586c95fc849bc98d62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/0603704608ae6bd2f1fc826bdb079cc7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'financieringvws')) == 'Nee' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a0e20ea2ed942ef177fab5d4324f00ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/e4842e0a21f1a06afad9934ea20ffb67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult 1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6ce9b2a4cb92e8dddb06fcca64de41e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/6b9fe1ef1e12f8cc017c646fadf45d53/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Netwerkactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/a0f5c237dde94665a1668a94ce936ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Ontwikkeluren' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/c266d3f5f74503fa73cbcd6348f57c49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/92be75553e9bd48a64836fa620f351f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult 1' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Netwerkactiviteiten' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Ontwikkeluren' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Groepsgesprekken' ? false : ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Presentieactiviteiten' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/052cf06338f2b2ebdd8a7939cdd1cd3c/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' && (getObjectProperty(___arguments.context.pageData, 'emailminuten')) > 4) {
    (function (message) { alert(message) })('Het maximaal aantal activiteiten voor een verlenging voor consulten is 4 activiteiten.');
    ___arguments.context.pageData['emailminuten'] = 4;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['emailminuten'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsultbackup/components/6d8aa8bbab795d9cdf9f6b6db4d7439f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/aeec0bc5d90b67a49eec98a2bc617022/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/7b3bd1073ca44d1a6d9e348f7315517f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8471879f28d62d39e543e162db5121a2', undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'dossier')),'\''].join('')), ({ [`registratiesgewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'gewerkteminuten')),[`registratiesvoorbereidingminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'voorbereidingminuten')),[`registratiesreistijdkm`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdkm')),[`registratiesreistijdminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminuten')),[`registratiesreistijdminutenspeciaal`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdminutenspeciaal')),[`registratiesaantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'aantalconsulten')),[`registratiestotaalbedrag`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'totaalbedrag')),[`registratiesreistijdoverijsselnr`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8471879f28d62d39e543e162db5121a2')), 'reistijdoverijsselnr')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('979b1e78e6021d38710ee3212e6ad467', undefined);
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'dossier')),'\''].join('')), ({ [`dossieraantalconsulten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'aantalconsulten')),[`dossiergewerkteminuten`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'gewerkteminuten')) + (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('979b1e78e6021d38710ee3212e6ad467')), 'voorbereidingminuten')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/35f3bab7b62438032096fcd93844383b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Zh03abn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriozhngvlieke' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('afa3ae9699cfe802b9057871b5953f9c')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('afa3ae9699cfe802b9057871b5953f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dfbe87a8b223682a042b2154a1634b6', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/bf25182d3b146022cf2378c589090041/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    }
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing-questio', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Werkgroep') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiewerkgroep', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Raad van Advies') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieraadvanadvies', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult zorgvrager') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultinw', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult professional') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultpro', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Groepsconsult') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiegroepsconsult', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO/PaTz') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdopatz', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Scholing') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiescholing', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coaching on the job') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoaching', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Opbouw infrastructuur') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieopbouwinfra', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Coördinatietaken') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiecoordinatie', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consult 1') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsult1', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Netwerkactiviteiten') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratienetwerkactiviteiten', undefined);
    } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ontwikkeluren') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieontwikkeluren', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/deb65a46e04444d6bc887a06dded5d5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/70ee133712585291e8af47627feacf38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/488e3943b4419334a6c356dcb6a62261/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult professional' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('nieuwehulpvraag', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/1b9f62b7a5c10c915ccf1144e9754afb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'blind')) == 'true' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/2d58f7f976d54b05285c3ba5c09d1d3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('aantekeningen_2023', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-aantekeningen geopend-','-dossier:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'startconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aantekeningen geopend',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/5da3c4617f0e68a5917a18899e01edc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Coördinatietaken') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Opbouw infrastructuur') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelenzorgvrager', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/12beae4e7e9e50dd3dcf6582b1856353/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/3a811dec4547dcb58358149188067402/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Coördinatietaken' ? false : ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossiernietquestio', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/4785dde5cf837195768715f15b1fd094/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoord')) == null ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) != 'Scholing' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) != 'Scholing' ? false : ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('deb65a46e04444d6bc887a06dded5d5c'), 'activiteit')) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossierconsultinwpro', undefined);
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier-questio', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/1bae19bd3c0da02d8ff34df5913b1e85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df5c5a1fd649990668cb805d743da4c6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86fc7142268f6fbcc19a8574fe7243bc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('246568c7b942d53c9e45d6d4ebac660c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/96d76a4807ae8bbc3b3c4d390577baf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
    text = 'Personen (functie/ organisatie) betrokkenen:';
  } else {
    text = 'Naam PaTz of MDO:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/3c17d1c71ec5beadfbb2763eb39b26bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Netwerkbijeenkomst NPZF' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/8f9d2ecda7a7481b4323174e7e9f85a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/4dfd47831aa794d3704dccb20f1e428c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'consultinwgender')) == 'Anders' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/1f57e176d149797518de08db6b6fdf14/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? 'Overhead' : 'Reistijd minuten')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/ce277b567da520ed72fd52a863daed5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
    text = 'Overhead:';
  } else {
    text = 'Totaal reistijd in minuten:';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/1d492069c254bbd8d1dacfd8d5457c1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Triage/intake' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsultbackup/components/1d79c1060f13d53391c56cc6f9a1f927/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/5faa1bc154366725a90d99f850ffbe7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/99826f741bd1c273343e13f76f529499/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden' && (getObjectProperty(___arguments.context.appData, 'financieringvws')) == 'Nee' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/df35c84848783608a7d9fc1766e24218/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Groepsgesprekken' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/f2d972e38f681398fde848584618b883/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Presentieactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/44e222288de88fad5b280198ffd8b0a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/86d16bed3a47670686a8b8386b260b68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsultbackup/components/800dfd2739443db8dd36bdc957e8f7a3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/3d088d98b9b882885ba868efe0d81adc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Rotterdamverzekering' }) );
  await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Rotterdamverzekering' }) );
  await Backendless.Data.of('historielog').save( ({ [`datum`]: (new Date(((new Date()).valueOf()))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`pagina`]: 'startconsult',[`actie`]: ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' ','en alle registraties op dit dossier op subsidie Rotterdamverzekering gezet'].join('') }) );
  await Backendless.Messaging.sendEmailFromTemplate('rotterdamverzekering', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }), undefined);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', false);
  (function (message) { alert(message) })('Het dossier en de eventuele registraties op dit dossier zijn op de subsidie Rotterdamverzekering gezet.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/48a48bb899c8f841b7985f0a2b03fc48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69f8cb379be9115ca91f2e715a386752', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsultbackup/components/81e8d197a08374e6f9caa481952dc04a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/a6fba3ea0973d1b7458556e103dcfd88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/ecbc1fa879b4fa34da3dea81a286469f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/eeeeda7dd7a3624a2aca33f55eb38544/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/fc69bb91203a67f15a55b94d3b5f541a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'aantekeningen')) == null) {
    (function (message) { alert(message) })('Aantekeningen moet ingevuld worden.');
  } else {
    await Backendless.Data.of('aantekeningen').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'datuminvoeraantekening': (new Date()),'aantekeningen': (getObjectProperty(___arguments.context.pageData, 'aantekeningen')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    ___arguments.context.pageData['aantekeningen'] = '';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteraantekeningen'] = (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'','AND username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da8e8774c4df1d0a10461b8776978d6f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('aantekeningprojectleider').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/3133f7b6c27a30436a37d3b742f72bff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Aantekeningen dossier ') + String(JSON.parse((___arguments.context.appData['dossier']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/2627799293631f5b120a3ab190d89e57/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['aantekeningprojectleider']) == null ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/7eca433e0a6b3b120e5f1486e4077886/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4eceec23bf48f05595a0064b8c723be', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/b1a59813012e10d767c815c611b4bcd7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.pageData['selected']) == true) {
    ___arguments.context.pageData['selectednee'] = false;
    await new Promise(r => setTimeout(r, 2000 || 0));
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9db828a14de24555a9ac9efc332acf13', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33cb07a6a1b2faa6c49d0a63779ee10c', false);
    await (async function() {
    	window.print()
    })();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4eceec23bf48f05595a0064b8c723be', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9db828a14de24555a9ac9efc332acf13', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33cb07a6a1b2faa6c49d0a63779ee10c', true);
    ___arguments.context.pageData['selected'] = false;
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen/components/c2587e043fc9071537575d1bc316d867/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if ((___arguments.context.pageData['selectednee']) == true) {
    ___arguments.context.pageData['selected'] = false;
    ;await ( async function (message){ alert(message) })('Indien er geen toestemming is verkregen van de zorgvrager dan kunnen de aantekeningen niet geprint worden.');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4eceec23bf48f05595a0064b8c723be', false);
    ___arguments.context.pageData['selectednee'] = false;
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b5316ce7993012ac5cceb5667d4b169', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('aantekeningprojectleider').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('AANTEKENINGEN DOSSIER  ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/d9bf204fc0f2ac457fe9699af16d6bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('aantekeningen').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/5ecc5ca9100b7ee189c776ecddea8e9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#89b087';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/19bfb0d80cbc61cf8e036ba2374cdc98/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/89efc196401e5c994d4813a164a97b83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/a14c80814751fb55fed93cd24c9ff12a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'aantekeningprojectleider')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/44d62bac8b48b7c17e8632ad73f5fda9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'nieuweaantekening')) == null) {
    (function (message) { alert(message) })('Aantekeningen moet ingevuld worden.');
  } else {
    await Backendless.Data.of('aantekeningen').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'datuminvoeraantekening': (new Date()),'aantekeningen': (getObjectProperty(___arguments.context.pageData, 'nieuweaantekening')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    ___arguments.context.pageData['nieuweaantekening'] = '';
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/a19afdb71d918411e8e300c3896a9fd2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'aantekeningprojectleider')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/287c331443d67e4292916bf81abe814b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e047e3a58e9fa5c07bb103b438e50b7')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/1a4cd66eea08b55a0b4658cdbb67ac99/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/f86ce658657a9444f787e36a15ea21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('aantekeningen').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e047e3a58e9fa5c07bb103b438e50b7'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e047e3a58e9fa5c07bb103b438e50b7', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('aantekeningen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('datuminvoeraantekening DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligeraantekeningen_2023/components/dd0390c3fce3b37fd83f9b2b5fefe73b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0eaaa477a99cf89cbe7aed7978bd2d0a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0eaaa477a99cf89cbe7aed7978bd2d0a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4257dffec1e79b9d2bf8cc43ec04f44c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44d62bac8b48b7c17e8632ad73f5fda9', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzinggv'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['toelichtingopredenafronding'] = null;
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['afrondingdoorverwijzing'] = null;
  if (___arguments.value == 'Doorverwijzing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec4c5c85f2b490257e97586245c98e98', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89f3157a03c4794ecb0af3c4c4af7cdd', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec4c5c85f2b490257e97586245c98e98', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89f3157a03c4794ecb0af3c4c4af7cdd', false);
  }
  if (___arguments.value == 'Doorverwijzing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', false);
  }
  if (___arguments.value == 'Doorverwijzing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb34f0317a427aa82bbf768bcce72e36', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd3c0cde9187c3d6cc768c5b89919b2', false);
  }
  if (___arguments.value == 'Anders') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5ebfa85234425d94a591c5a1bd0eb359', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c8e6bad2d1c85b82bdc1aaba76a35db', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5ebfa85234425d94a591c5a1bd0eb359', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c8e6bad2d1c85b82bdc1aaba76a35db', false);
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingreden').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingreden']),'label': (item['afrondingreden']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/5fd3c0cde9187c3d6cc768c5b89919b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('afrondingdoorverwijzing').find(Backendless.DataQueryBuilder.create().setWhereClause((String((await Backendless.UserService.getCurrentUser(false))['centraname']) + String('=\'1\''))).setSortBy('afrondingdoorverwijzing').setPageSize(100))).map(async item => {; return ({ 'value': (item['afrondingdoorverwijzing']),'label': (item['afrondingdoorverwijzing']) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/87bb9d4afcf7aab7f17dea4c44e2d015/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'vrijwilligerstatus')) == 'Actief') {
    text = String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  } else {
    text = String('Openen dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var vrijwilligerstatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('321841bc3ab3cd68f19466f3285e58f1', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalvw', 'vrijwilligerstatus']).setPageSize(100))));
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    vrijwilligerstatus = '1';
  } else {
    vrijwilligerstatus = '%';
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('daa3d6fbef97b1b7176399641f67bc7d', (await Backendless.Data.of('wasersprakevan').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',vrijwilligerstatus,'\''].join(''))).setSortBy('wasersprakevan').setPageSize(100))));
  ___arguments.context.pageData['listwasersprakevan'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/aa627e5d527a29b453dc455c923cde7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijiwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/c5baacf6e177b2edd1b9dc931fb83182/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantalvw'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantalvw'));
  ___arguments.context.pageData['vrijwilligerstatus'] = (getObjectProperty(___arguments.context.dataModel, 'vrijwilligerstatus'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/3494836a7809574b151e39c55bfff6a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['delenaantalvw']) != 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/66bbd2528517a7827fc72284b2bfc219/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22185b622141e6ba9e1672dc03422722'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('22185b622141e6ba9e1672dc03422722'), 'wasersprakevan')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22185b622141e6ba9e1672dc03422722'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).splice((((getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('22185b622141e6ba9e1672dc03422722'), 'wasersprakevan')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d04489c31c9ca5e28179f5d862abe028')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('89f3157a03c4794ecb0af3c4c4af7cdd')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzinggv')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5fd3c0cde9187c3d6cc768c5b89919b2')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9c8e6bad2d1c85b82bdc1aaba76a35db')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`vrijwilligerafrondingabc`]: String(getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')),[`vrijwilligerafrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`vrijwilligerafrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`vrijwilligerstatus`]: 'Afgesloten',[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) }) );
    await Backendless.Data.of('dossiersafgesloten').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`activiteit`]: 'Consult zorgvrager',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`afrondingabc`]: String(getObjectProperty(___arguments.context.pageData, 'listwasersprakevan')),[`afrondingreden`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingreden')),[`afrondingdoorverwijzing`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzing')),[`afrondingdoorverwijzinggv`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'afrondingdoorverwijzinggv')),[`status`]: 'Afgesloten',[`gebruiker`]: 'Vrijwilliger',[`toelichtingopredenafronding`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'toelichtingopredenafronding')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/3c339a03eded815f81bd89dc22611888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'vrijwilligerstatus': 'Actief','vrijwilligerafrondingabc': null,'vrijwilligerafrondingdoorverwijzing': null,'vrijwilligerafrondingreden': null }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/a22777ebef0bda047662fe32c0e54ce2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'vrijwilligerstatus')) == 'Actief' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/d59b45031ef3fe771dd589bffc168952/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'vrijwilligerstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerafsluitendossierconsultinwpro/components/d04489c31c9ca5e28179f5d862abe028/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteit')))) == 'Opbouw infrastructuur' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.dataModel['centraname'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/561bec1c2dcb96d10a8bd4dbdeecd0a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vw, gv, pakketminutenakkoord;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('561bec1c2dcb96d10a8bd4dbdeecd0a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a0c395a6800ec9261083a145b723c508')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea1a781744591d38c9299dc5af02dbbe')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('feca418431c3720d9b6fad4fcc87e4ae')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e389faff8e99334fba258b82f041f215')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.appData, 'toestemmingconsultinwpro')) == 'true') {
      pakketminutenakkoord = (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro'))));
    } else {
      pakketminutenakkoord = null;
    }
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('GV') !== -1) {
      gv = 1;
      vw = 0;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('VW') !== -1) {
      vw = 1;
      gv = 0;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')).indexOf('PL') !== -1) {
      vw = 0;
      gv = 0;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),[`regio`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'regio')),[`leeftijd`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')),[`consultinwgeboortejaar`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')),[`consultinwgender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gender')),[`verwijzer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwijzer')),[`doelgroep`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'doelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'hulpvraag')),[`verwachtaantalcontactmomenten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'verwachtaantalcontactmomenten')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`activiteit`]: 'Consult zorgvrager',[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`akkoord`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'toestemmingconsultinwpro')))),[`gebruiker`]: 'vrijwilliger',[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`vrijwilligerstatus`]: 'Actief',[`status`]: 'Vrijwilliger',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`pakketminuten`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossiertijdconsultinwpro')))),[`pakketminutenakkoord`]: pakketminutenakkoord,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`delenaantalgv`]: gv,[`delenaantalvw`]: vw,[`dossieraanmaker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    ___arguments.context.appData['startpagemijndossiers'] = 'consultzorgvrager';
    ___arguments.context.pageData['disablesave'] = false;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/3b2d2532dc02423bef0a4fb4956484bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, centra;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    centra = String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('vrijwilligers');
  } else {
    centra = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }

  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(centra) + String('=\'1\''))).setSortBy('verwijzer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/396219b6b0a5e5675255d4656073df56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/1c894979f8694397d8d94b1e96fc72f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    text = 'Voer de vier cijfers van de postcode van de zorgvrager in';
  } else {
    text = 'Selecteer gemeente/woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/a0c395a6800ec9261083a145b723c508/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')).length > 4) {
    (function (message) { alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')).slice(0, 4));
  }
  list = (await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND gemeentewoonplaats =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setPageSize(1)));
  if (!list.length) {
    (function (message) { alert(message) })('Deze postcode valt niet binnen het CvL ');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['gemwoon'] = '';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvpostcode')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/890811d777445414c146705efbb7c2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    text = 'Geboortejaar zorgvrager';
  } else {
    text = 'Leeftijd zorgvrager';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/ea1a781744591d38c9299dc5af02dbbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) < 5) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'leeftijd')) > 120) {
    (function (message) { alert(message) })('Ingevoerde leeftijd klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['leeftijd'] = undefined;
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/feca418431c3720d9b6fad4fcc87e4ae/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'geboortejaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['geboortejaar'] = undefined;
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['regio'] = (getObjectProperty(regio, 'value'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/29751c4f6414444b62956113556e22a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/e389faff8e99334fba258b82f041f215/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'gvgender')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossierconsultinw/components/ccea5756e95e770cfe5cdc1ac971c2e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var return2, item, status2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Willem' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) != 'Gelderland') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
      status2 = '%';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
      status2 = '%';
    } else {
      status2 = '0';
    }
    return2 = (await Promise.all((await Backendless.Data.of('doelgroep').find(Backendless.DataQueryBuilder.create().setWhereClause((['status LIKE\'',status2,'\''].join(''))).setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    return2 = (await Promise.all((await Backendless.Data.of('doelgroepwillem').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('doelgroep DESC').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'doelgroep')),[`label`]: (getObjectProperty(item, 'doelgroep')) });})));
  }

  return return2

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c16cd2c21817a99c9bc771d490c439a3', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['regio'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var regio;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d16cbd1f4edf04dbf30f4989fd0d046f')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'opbouwinfrakortetoelichting')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'zwnlopbouwinfrafrequentie')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemeentewoonplaats')) == null) {
      regio = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
    } else {
      regio = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemeentewoonplaats'));
    }
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('dossiers').save( ({ [`userobjectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'opbouwinfrakortetoelichting')),[`activiteit`]: 'Opbouw infrastructuur',[`aantalgepland`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'zwnlopbouwinfrafrequentie')),[`minutenpergepland`]: 1,[`akkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingopbouwinfra')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'zwnlopbouwinfrafrequentie')) * 1,[`kenmerk`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'kenmerk')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`status`]: 'Vrijwilliger',[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`aantekeningprojectleider`]: undefined,[`tariefperminuut`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefopbouwinfra')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`regio`]: regio,[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'gemeentewoonplaats')),[`userorganisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`vrijwilligerstatus`]: 'Actief',[`gebruiker`]: 'vrijwilliger' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'toestemmingopbouwinfra')) == 1) {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3'), 'email')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'geestelijkeverzorgingrotterdam@gmail.com', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plmeldingdossiers')))) == 1 && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      if ((getObjectProperty(___arguments.context.appData, 'toestemmingopbouwinfra')) == 'true') {
      } else {
        await Backendless.Messaging.sendEmailFromTemplate('dossier', Backendless.EmailEnvelope.create({ addresses: 'coordinator@centrum-levensvragen.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`activiteit`]: 'Opbouw infrastructuur',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
      }
    }
    ___arguments.context.pageData['disablesave'] = false;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/7c951d39d791a2ef346d2059b706a8ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/b93fdb26f52cb381f10394c2adc5bf25/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/5f89d16f9af8c30289975a5ce6bfd36d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/d16cbd1f4edf04dbf30f4989fd0d046f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
  toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',___arguments.value,'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
  ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('vrijwilligerregio').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/2cd258cb7f81c3fb85fa1047b816a60d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/5f99364ec827cddffb38241a530da3fd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var toestemmingopbouwinfra, item, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    email = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['email'] = (getObjectProperty(email, 'value'));
    toestemmingopbouwinfra = (await Promise.all((await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('toestemmingopbouwinfra').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'toestemmingopbouwinfra')) });})))[0];
    ___arguments.context.getComponentDataStoreByUid('c16cd2c21817a99c9bc771d490c439a3')['toestemmingopbouwinfra'] = (getObjectProperty(toestemmingopbouwinfra, 'value'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/1d09ae799651a265c34eea2d182874ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligercreatedossieropbouwinfra/components/e214014ce0596e1f0b1e800d9dc6b7b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`label`]: (getObjectProperty(item, 'gemeentewoonplaats')) });}))), ({ [`value`]: 'Zinvol',[`label`]: 'Zinvol' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligerdetailsregistratieconsultzorgvrager/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['tabelfilter'] = (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerdetailsregistratieconsultzorgvrager/components/b11b92625c08deeb7f18ca985a4c8163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdetailsregistratieconsultzorgvrager/components/aab6d99ad0fed101ad8785751e1a8ede/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Details registratie ') + String(JSON.parse((___arguments.context.appData['registratienummer']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerdetailsregistratieconsultzorgvrager/components/de1955cd4073cd113a685c7188cf316b/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var B, item, A, C;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de1955cd4073cd113a685c7188cf316b'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1') {
  } else {
    C = 'OV-vergoeding';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerdetailsregistratieconsultzorgvrager/components/0ec68821cbfcbcd377c31057cc6a2d51/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/2f154579192182af405271bb20bd0886/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Dossier ',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),' delen'].join('').toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/5a63aaacb926920c3a6e33bdf2ab4dde/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/bc0daadb215a4b3f99e1fc17adb97635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/9295b93e4a8f9c7be64f72515e6464e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/c60a0aae3d19219375ba4af20a68468d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var delenaantalvw, delenaantalgv;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'GV')).indexOf('GV') !== -1) {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv')) + 1;
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw'));
    await Backendless.Data.of('Dossiers').bulkUpdate( (['objectId=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))),'\''].join('')), ({ [`username`]: [(getObjectProperty(___arguments.context.appData, 'dossierusername')),';',(getObjectProperty(___arguments.context.pageData, 'delenaan'))].join(''),[`status`]: 'Actief',[`delenaantalgv`]: delenaantalgv,[`delenaantalvw`]: delenaantalvw }) );
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  } else {
    delenaantalgv = (getObjectProperty(___arguments.context.pageData, 'delenaantalgv'));
    delenaantalvw = (getObjectProperty(___arguments.context.pageData, 'delenaantalvw')) + 1;
    await Backendless.Data.of('Dossiers').bulkUpdate( (['objectId=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))),'\''].join('')), ({ [`username`]: [(getObjectProperty(___arguments.context.appData, 'dossierusername')),';',(getObjectProperty(___arguments.context.pageData, 'username'))].join(''),[`delenaantalgv`]: delenaantalgv,[`delenaantalvw`]: delenaantalvw }) );
    await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'objectId')) }));
  }
  await Backendless.Data.of('dossierdelen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'delenaannaam')) }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('83a82bb69ad8f0cd1e164c467db5fd1e', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  await Backendless.Messaging.sendEmailFromTemplate('dossierdelen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`centraname`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`naamverzender`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`emailtext`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`activiteit`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteit')))) }), undefined);
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/f0b72dbd58f5b117bdc478d11e24d9fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['Dossier ',(JSON.parse((___arguments.context.appData['dossier']))),' is nu gedeeld met ',(___arguments.context.pageData['delenaannaam'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/eb96d605a02d09ecd5ce7073a3d9c7c9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setProperties(['naam', 'organisatie', 'userobjectId']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'userobjectId')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var naam, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('dossierdelenusers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' AND userobjectId=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties(['naam', 'GV', 'organisatie', 'userobjectId', 'email', 'username']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`GV`]: (getObjectProperty(item, 'GV')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`userobjectId`]: (getObjectProperty(item, 'userobjectId')),[`email`]: (getObjectProperty(item, 'email')),[`username`]: (getObjectProperty(item, 'username')) });})))[0];
  ___arguments.context.pageData['delenaannaam'] = ([(getObjectProperty(naam, 'value')),' - ',(getObjectProperty(naam, 'organisatie'))].join(''));
  ___arguments.context.pageData['userObjectId'] = (getObjectProperty(naam, 'userobjectId'));
  ___arguments.context.pageData['GV'] = (getObjectProperty(naam, 'GV'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(naam, 'email'));
  ___arguments.context.pageData['username'] = (getObjectProperty(naam, 'username'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1b5bfd8b1633faf838550f5831c3ed3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5444ae675c8260d2b4a4ddf4a132a61d', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/0941101bb3f45c9d22cb54f9067b5481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((JSON.parse((___arguments.context.appData['dossierobjectid']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f957cf284bc6decc74db421f00cfd82d', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('83a82bb69ad8f0cd1e164c467db5fd1e', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('78f436d5bde5279c27ec017607bcee51', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantalgv', 'delenaantalvw']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerdossierdelen/components/e3d4a43f9a536ed7e174973718b98104/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['delenaantalgv'] = (___arguments.context.dataModel['delenaantalgv']);
  ___arguments.context.pageData['delenaantalvw'] = (___arguments.context.dataModel['delenaantalvw']);

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaarselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'jaar', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'jaar', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'jaar', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(vrijwilligervergoedingov) as vrijwilligervergoedingovtotaalbedrag', 'jaar']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'jaar', 'activiteit']).setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6ecdeeb178614a158f4c1990789eb7a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND jaar= \'',(getObjectProperty(___arguments.context.pageData, 'jaarselectie')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('jaar').setSortBy('created DESC').setGroupBy('jaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'jaar')),'label': (getObjectProperty(item, 'jaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerdervrijwilliger').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligerjaaroverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1') {
  } else {
    G = 'OV-vergoeding';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02'), 'vrijwilligervergoedingovtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/aa87e0ff7f899bd13e51daf13a79cf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/5455648e4a32ebef60b83d4f76632bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['tariefreistijdkm']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/08f4b99cc45946991c1af374fde242fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/ece242b6591d663f35587841822f0542/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/94a6c2499561cb7765bc14f67fe923cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/617f4ec45e7ecbf55e5c2a4eb9eb3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642'), 'reistijdminutenspeciaaltotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/c0de0145869c46bc1b4681032aea4d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('618d1598a108cc4738d5f1bdb594e2ad')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['VIEW2'] = 'false';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6f1f3a15f38822e6885d32c247cb5916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['INVOICE']) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/c8e79d6b48425e220e2aadd303e8d8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8e79d6b48425e220e2aadd303e8d8c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/90a6c1643fa86c2c0ac4e56124dacca9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('90a6c1643fa86c2c0ac4e56124dacca9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/0baa2e3d13e3c7568f3e92ec80569c62/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0baa2e3d13e3c7568f3e92ec80569c62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/c684b73d1c7297048c52c3c2636de2a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c684b73d1c7297048c52c3c2636de2a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerdervrijwilliger').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://cvl23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
      return (['https://cvl.lorio.nl/api/files/logos/',((await Backendless.UserService.getCurrentUser(false))['username']),'.jpg'].join(''))

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/866690a969ad906c8fea3d636b3f0642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/4f6bfb06195515da074e779c77ee27d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutentotaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/b954e73e22beac83e99c3c1603b12eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b954e73e22beac83e99c3c1603b12eb9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(vrijwilligervergoedingov) as vrijwilligervergoedingovtotaalbedrag', 'maand']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/679ba3d289679bd74823ec736bb49ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d42d5821823391bd10a3e02fda5fcaf'), 'vrijwilligervergoedingovtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/1d42d5821823391bd10a3e02fda5fcaf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'vrijwilligervergoedingovtotaalbedrag')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/23871a8e9acf837e18ddefbc5fc7fb85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/f6ecdeeb178614a158f4c1990789eb7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/43cd2f532abe62f470a47e121592fc0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutentotaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerjaaroverzicht/components/564e5a5e0f362875d43dd89abd2c32ed/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(vrijwilligervergoedingov)as vrijwilligervergoedingovlexbtw', 'Sum(vrijwilligervergoedingov) as vrijwilligervergoedingovtotaalbedrag', 'maand']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\''].join(''))).setProperties('maand').setSortBy('maand ASC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (item['maand']),'label': (item['maand']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerdervrijwilliger').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden, de kwitantie kan verstuurd worden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligermaandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var H, item, G, F, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1' && (JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1') {
  } else {
    H = 'OV-vergoeding';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G && (item['title']) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, C, D, E, F, G, item, H;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1' && (JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1') {
  } else {
    H = 'OV-vergoeding';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
    C = 'Korte omschrijving';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
    G = 'Omschrijving scholing';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F && (item['title']) != G);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['vrijwilligervergoedingovlexbtw']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = 0;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['vrijwilligervergoedingovtotaalbedrag']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingov']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await (async function() {
  	window.print()
  })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzicht/components/49edc219013a602f7d9e634f7dc2bb3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://cvl.lorio.nl/api/files/logos/Declaratieformulier reiskosten vrijwilligers.pdf', true, null);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4419bc6a64f94b668e282f5548feb787', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(vrijwilligervergoedingov) as vrijwilligervergoedingovtotaalbedrag', 'maand']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6ecdeeb178614a158f4c1990789eb7a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandakkoordgv').setGroupBy('maandakkoordgv').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a')['tariefperminuut']) * 60;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerdervrijwilliger').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['VIEW2'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden, de kwitantie kan verstuurd worden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligermaandoverzichtkwitantie',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var H, item, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten n.a.v. scholing';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvreistijdpostcode')))) == '1') {
  } else {
    G = 'Postcode vertrek - aankomst';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1') {
  } else {
    G = 'OV-vergoeding';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0da62fa6a06c28aab646c3bef07ac52e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c69cb4583f8ae832212e5a594b2329', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/4a540805aad767399f9bd033d9e8b875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/149e3697728ac8cec3a1d1d4e6d66e3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a540805aad767399f9bd033d9e8b875', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('149e3697728ac8cec3a1d1d4e6d66e3b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02'), 'vrijwilligervergoedingovtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/57c69cb4583f8ae832212e5a594b2329/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Opmerkingen/ leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/0da62fa6a06c28aab646c3bef07ac52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    ___arguments.context.pageData['VIEW2'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/8f42a0dc08f74f7c426ab8a81a3d7dab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/046f017ede9daa81c1f6fe95ab0fb362/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['maandselectie'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/aa87e0ff7f899bd13e51daf13a79cf5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/5455648e4a32ebef60b83d4f76632bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['tariefreistijdkm']);
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/08f4b99cc45946991c1af374fde242fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642'), 'tariefreistijdminutenspeciaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/ece242b6591d663f35587841822f0542/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4f6bfb06195515da074e779c77ee27d7'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/94a6c2499561cb7765bc14f67fe923cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('23871a8e9acf837e18ddefbc5fc7fb85')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/617f4ec45e7ecbf55e5c2a4eb9eb3c96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('866690a969ad906c8fea3d636b3f0642'), 'reistijdminutenspeciaaltotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c0de0145869c46bc1b4681032aea4d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('618d1598a108cc4738d5f1bdb594e2ad')['totaalbedrag']);
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/9865a2b31099e4f27f53a018a07f68ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/3507c848cf2d7c5d2717895276f4c126/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.dataModel['postcode']),' ',(___arguments.context.dataModel['woonplaats'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/1f1fd25eb00647d6f3f432e4b02b476e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/f66e53f320553989369e60cc43523af2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden om de factuur op te maken.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Naam rekeninghouder moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['VIEW2'] = 'false';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63cce9b3fbc17296119c964798ed33d6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6f1f3a15f38822e6885d32c247cb5916/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['INVOICE']) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/5c4d2f4b68c29f3f2e9eac7de04c2744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c8e79d6b48425e220e2aadd303e8d8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8e79d6b48425e220e2aadd303e8d8c3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/17b820e59b5a1498f9bddf1b10c59baf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('17b820e59b5a1498f9bddf1b10c59baf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/90a6c1643fa86c2c0ac4e56124dacca9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('90a6c1643fa86c2c0ac4e56124dacca9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/0baa2e3d13e3c7568f3e92ec80569c62/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0baa2e3d13e3c7568f3e92ec80569c62', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c684b73d1c7297048c52c3c2636de2a5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c684b73d1c7297048c52c3c2636de2a5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/7f327a4fbf817e41b2c8605271a8dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7f327a4fbf817e41b2c8605271a8dca8', (await Backendless.Data.of('gegevenspenvoerdervrijwilliger').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/18c832e4baccdbdbaa14163e57bdc77a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18c832e4baccdbdbaa14163e57bdc77a', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/63ffbfa847892a2344ab3be1c6d99319/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('63ffbfa847892a2344ab3be1c6d99319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((___arguments.context.appData['user']))),'\' AND maand= \'',(___arguments.context.pageData['maandselectie']),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/867babe383cad221e52f294d17d68a12/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('867babe383cad221e52f294d17d68a12', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',((await Backendless.UserService.getCurrentUser(false))['username']),'\''].join(''))).setPageSize(10))));

  },  
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/62275d5d997298924051748d6e0988a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/76e50845efcac63e3da6b68367439e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/2d0a3ae96c46886f31675df6ddff0e6d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/2651c1540796fe87edec33878cb3b90b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/81f953117e9faf94482607d85faec141/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/59caac6e2731dde6b8f924e41dc4d68a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/239d61fe632dc2550b2b846563f5dbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/b8d2f3374d2f8dd9d276d101f7e8b918/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/3f2ac10aa646845856b3a9119ffb20e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;



  return (String((await Backendless.UserService.getCurrentUser(false))['username']) + String('.jpg'))

  },  
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3f2ac10aa646845856b3a9119ffb20e6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/5b6c01780038ae78f895c8ea23644da6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/866690a969ad906c8fea3d636b3f0642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdminutenspeciaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/94d34198538b5b2345d85ee659bf294c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ca933cb7d3c90dbeeb6d5ed940453389', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6471adf583ef836135b2acfe9fffe991', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94d34198538b5b2345d85ee659bf294c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/0f6f5d12a49dcee86098c5b309eab404/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1nZxZCyIvT6gOFezqjJxr1MZ5_bqjirIK/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1sVPnaOflKO2Wi6RTdsB-v67HPiO_ixpw/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1VhcDQNd92MbBIFI_Y7BzGXwr3GQEyXIr/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6e25f52be2f2cafe8004057d295440b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('5494397c09ddb3af314db21f92f48315') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/4f6bfb06195515da074e779c77ee27d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutentotaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/b954e73e22beac83e99c3c1603b12eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b954e73e22beac83e99c3c1603b12eb9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(vrijwilligervergoedingov) as vrijwilligervergoedingovtotaalbedrag', 'maand']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/679ba3d289679bd74823ec736bb49ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d42d5821823391bd10a3e02fda5fcaf'), 'vrijwilligervergoedingovtotaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/1d42d5821823391bd10a3e02fda5fcaf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'vrijwilligervergoedingovtotaalbedrag')) == null || (getObjectProperty(___arguments.context.dataModel, 'vrijwilligervergoedingovtotaalbedrag')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/23871a8e9acf837e18ddefbc5fc7fb85/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'reistijdkm')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/99bbbd0bc1ee2f6f33be7a32a53d19b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == 'true') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'false') {
    visible = false;
  } else if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'VIEW2')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/30f7a637396f200393fd94461274576d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://cvl.lorio.nl/api/files/logos/Declaratieformulier reiskosten vrijwilligers.pdf', true, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/65bf4cd5d83b16613cecbfff4112f128/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Vink het vak hier aan indien u akkoord bent met het maandoverzicht, indien u niet akkoord bent neem dan contact op met de ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator')))))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == true) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\''].join('')), ({ 'maandakkoordgv': 1 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 1;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoordgv')) == false) {
    await Backendless.Data.of('registraties').bulkUpdate( (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\''].join('')), ({ 'maandakkoordgv': 0 }) );
    ___arguments.context.pageData['maandakkoordgv'] = 0;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/f6ecdeeb178614a158f4c1990789eb7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/43cd2f532abe62f470a47e121592fc0a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'gewminutentotaal')) == 0 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/564e5a5e0f362875d43dd89abd2c32ed/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/b3f19c2973265294fe8826f181d17ead/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/7c36a872d4e889583377d888eed30731/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/5e6dc8219256376e48cc9b9c17a715ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/c314be6d86775e94f84b561584948e0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermaandoverzichtkwitantie/components/3f89dd49d89659c4c785477ce42c88bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function oud_11_06_2026() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol') {
    ___arguments.context.pageData['conditionzorgvrager'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\' OR username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND activiteit=\'Opbouw infrastructuur\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''));
  } else {
    ___arguments.context.pageData['conditionzorgvrager'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''));
  }
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eaa9f8755c3cff7dbd1b529a11621d76', (await Backendless.Data.of('tarievenpercentra').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['conditionzorgvrager'] = (['username LIKE\'%',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'%\' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''));
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpagemijndossiers'));
  ___arguments.context.pageData['statusfilter'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/ad1dda42ca6e610a84b4617b936eb2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/93a56b644eec20a89db4265f06054542/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/17a38ab526025dedf6112fdaf18114f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossierconsultinw', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/c92b6df66c75680c5fd1069a59d24d92/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['tariefconsultinwpro'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'consultinwpro'))));
  ___arguments.context.appData['tariefreistijdkm'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'reistijdkmvrijwilliger'))));
  ___arguments.context.appData['tariefreistijdminutenspeciaal'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'reistijdminutenspeciaal'))));
  ___arguments.context.appData['tariefgroepsconsult'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'groepsconsult'))));
  ___arguments.context.appData['tariefmdopatz'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'mdopatz'))));
  ___arguments.context.appData['tariefscholing'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'scholing'))));
  ___arguments.context.appData['tariefcoaching'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coaching'))));
  ___arguments.context.appData['tariefcoordinatietaken'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'coordinatietaken'))));
  ___arguments.context.appData['tariefopbouwinfra'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9d16dc294b585c666c19252b25126dc7'), 'opbouwinfra'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/42e4711b2aace0850c0234abb0afa5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })([(JSON.stringify((___arguments.context.appData['tariefconsultinwpro']))), (JSON.stringify((___arguments.context.appData['tariefgroepsconsult']))), (JSON.stringify((___arguments.context.appData['tariefmdopatz']))), (JSON.stringify((___arguments.context.appData['tariefscholing']))), (JSON.stringify((___arguments.context.appData['tariefcoaching']))), (JSON.stringify((___arguments.context.appData['tariefopbouwinfra']))), (JSON.stringify((___arguments.context.appData['tariefreistijdkm']))), (JSON.stringify((___arguments.context.appData['tariefreistijdminutenspeciaal'])))]);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/c781714564bc650fd4622fdeee680307/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossierconsultinw', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/8445c80c81cd6b6be17775cadf48b095/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligermijndossiers',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: undefined,[`usernamedossier`]: (getObjectProperty(___arguments.selectedRecord, 'username')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.selectedRecord, 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);
  ___arguments.context.appData['startpagemijndossiers'] = 'consultzorgvrager';

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8445c80c81cd6b6be17775cadf48b095'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvgender']))) == '1') {
  } else {
    B = 'Gender';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    C = 'Gemeente/woonplaats';
  } else {
    C = 'Postcode';
  }
  if ((JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))) == 'projectleider') {
    D = 'Akkoord coördinator';
  } else {
    D = 'Akkoord projectleider';
  }
  return2 = (item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/4646ffaa85bfb2b5094768445c2582e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/799dbea9909f47271aaae9c8c7dd8b2c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossierconsultinw', undefined);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL') {
    text = 'Dossier consult zorgvrager toevoegen';
  } else {
    text = 'Dossier toevoegen';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/918c3db73b42188fc47232cc0b2cd61e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['conditionzorgvrager'] = (['username LIKE\'%',(JSON.parse((___arguments.context.appData['user']))),'%\'',' AND activiteit=\'','Consult zorgvrager','\'',' AND centra=\'',(JSON.parse((___arguments.context.appData['centraname']))),'\'',' AND vrijwilligerstatus LIKE\'',(___arguments.context.pageData['statusfilter']),'\''].join(''));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/416226bcca73172b4216955b64af1ce1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('931936f3437182456c1fbc5d19984568')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/ab1c8a8ae1f10454218bc77b7394371a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZWNL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Zinvol' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossieropbouwinfra', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/c9d85c6ad00538fa1ed157afb743d8b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossieropbouwinfra', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/5de3f941e65bc7cee7da693986451152/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligercreatedossieropbouwinfra', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijndossiers/components/f685dac65cb9c82da1bb6763c664bca4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalendergv', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/d091fa265bb91775390f99cc4aad997d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/72b7b063dcbe81460cadece1799baec4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8a5a5d24e8a4d6ded2a3e4918723e768', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\''].join(''))).setProperties(['centraname', 'naam', 'username', 'email', 'organisatie']).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/501fb8d6f63dc00cd7610922814ea438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email2`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/407cd3477c6efd89ea38e681a639c77b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f749921cc81844608a7031bf5b44d1b'), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1f749921cc81844608a7031bf5b44d1b'), 'centraname'));
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/aed3ee0638e971814ee8da0ecd29bb57/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aed3ee0638e971814ee8da0ecd29bb57', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurkwitantie': 'Kwitantie' }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/9257e8a24ad3a23e80cae41bd3eafd84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/1235bd02b69ed3fc1aef11a66a740ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/3afca7edfa87d265019c39bea6eec31f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/a39414b2d8fe3fedef0bdde64fd4640c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/27bb89730c3217e763737de8296d73fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/b76d03f6ced8e93bb87e4ecfed011299/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/88db4366bf1bcaa776e8f7b2cf6bf1dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/25d7fc4999a518f2d19cb8d486bc4d09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'selfbilling')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/2e835b3b31e93fa215155caed9078f09/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad'), 'akkoordfactuurgegevens')) == true) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username LIKE\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'akkoordfactuurgegevens': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad'), 'akkoordfactuurgegevens')) == false) {
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username LIKE\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'akkoordfactuurgegevens': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligermijngegevens/components/05f4ed846b346e466f7dc329f61471b7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('7c13254341e2b13e72197af2f17e81ad') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/a6fba3ea0973d1b7458556e103dcfd88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/ecbc1fa879b4fa34da3dea81a286469f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/eeeeda7dd7a3624a2aca33f55eb38544/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/59811a069deafe52ec66ac555b3cb781/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('Dossier ') + String(JSON.parse((___arguments.context.appData['dossier']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/fc69bb91203a67f15a55b94d3b5f541a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.pageData['nieuwehulpvraag']) == null) {
    ;await ( async function (message){ alert(message) })('Nieuwe hulpvraag moet ingevuld worden');
  } else {
    await Backendless.Data.of('hulpvraagconsultinwpro').save( ({ 'dossier': (JSON.parse((___arguments.context.appData['dossier']))),'datuminvoerhulpvraag': (new Date()),'nieuwehulpvraag': (___arguments.context.pageData['nieuwehulpvraag']) }) );
  }
  ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligernieuwehulpvraag/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9c247914f18bec11fe8d0971f28b3c99', (await Backendless.Data.of('belangcatconsult2026').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('belangrijkstecategorie').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('323ea16ceb0e60bb392566ea639e3a0b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  ___arguments.context.pageData['listcat'] = [];
  ___arguments.context.pageData['listcat2'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var vrijwilligervergoedingov, reistijdkm, reistijdminutenspeciaal, werkminuten, consultbetrokken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('561bec1c2dcb96d10a8bd4dbdeecd0a1')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccea5756e95e770cfe5cdc1ac971c2e4')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d86f87bc9fbed2ff6081a3c94cd17bd6')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d86f87bc9fbed2ff6081a3c94cd17bd6')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat2')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a3f3d7879f6948cadb88611ddd86f737')), 'display')) == true && !(getObjectProperty(___arguments.context.pageData, 'listcat')).length) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('074988f6219ebfcb22d285eca7abf887')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('349b44a8d1e70402c48aa0a50ce76668')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f4fe056e29ef32942305eed8af11f237')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')) == 'true') {
      reistijdkm = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm'))));
    } else {
      reistijdkm = 0;
    }
    if ((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')) == 'true') {
      reistijdminutenspeciaal = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal'))));
    } else {
      reistijdminutenspeciaal = 0;
    }
    if ((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingwerkminuten')) == 'true') {
      werkminuten = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultinwpro'))));
    } else {
      werkminuten = 0;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'vrijwilligervergoedingov')) == null) {
      vrijwilligervergoedingov = 0;
    } else {
      vrijwilligervergoedingov = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'vrijwilligervergoedingov')) * 10000;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Nee') {
      consultbetrokken = 'Er waren geen anderen bij het gesprek betrokken';
    } else {
      consultbetrokken = String(getObjectProperty(___arguments.context.pageData, 'listcat2'));
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Vrijwilliger',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`consultwijze`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')),[`consultthemas`]: String(getObjectProperty(___arguments.context.pageData, 'listcat')),[`consultbetrokken`]: consultbetrokken,[`consultaantbetrokken`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultaantalbetrokken')),[`quote`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'quote')),[`aantalcontactmomenten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantalcontactmomenten')),[`regelmaatbezoek`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'regelmaatbezoek')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`activiteit`]: 'Consult zorgvrager',[`reistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),[`tariefperminuut`]: werkminuten,[`tariefreistijdminutenspeciaal`]: reistijdminutenspeciaal,[`tariefreistijdkm`]: reistijdkm,[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`maand`]: [(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),[`gebruiker`]: 'vrijwilliger',[`akkoord`]: 1,[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`consultinwleeftijd`]: (getObjectProperty(___arguments.context.pageData, 'consultinwleeftijd')),[`consultinwverwijzer`]: (getObjectProperty(___arguments.context.pageData, 'consultinwverwijzer')),[`consultinwdoelgroep`]: (getObjectProperty(___arguments.context.pageData, 'consultinwdoelgroep')),[`hulpvraag`]: (getObjectProperty(___arguments.context.pageData, 'hulpvraag')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`dossieraanmaker`]: (getObjectProperty(___arguments.context.pageData, 'dossieraanmaker')),[`vrijwilligervergoedingov`]: vrijwilligervergoedingov,[`postcodesvertrekenaankomstlocatie`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodevertrekpunt')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'postcodeaankomst'))].join('') }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/561bec1c2dcb96d10a8bd4dbdeecd0a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('consultwijze').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'consultwijze')),'label': (getObjectProperty(item, 'consultwijze')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) != 'Face-to-face') {
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['vrijwilligervergoedingov'] = undefined;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/9973d93b94c27b4cc8b62d31d9eaf248/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/bc5fcfab9f5c401f8c4782a4f68cbff7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))))) {
    await ( async function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdkm'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdkm'] = '';
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bc5fcfab9f5c401f8c4782a4f68cbff7')));
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/c109550b7fd9187732f86a878fe9dc2b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/ffae893972da5bd745a7b87efa1991f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['setuitlegtijdconsultinw'])

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/451fdfa2a292226f97e5bc2c5cefd962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25af33e1861c9cb7258f0b1884bb2ef4'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('25af33e1861c9cb7258f0b1884bb2ef4'), 'belangrijkstecategorie')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('25af33e1861c9cb7258f0b1884bb2ef4'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('25af33e1861c9cb7258f0b1884bb2ef4'), 'belangrijkstecategorie')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/a1e8549b31526fe82307e2d165b935a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')) > (JSON.parse((getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))))) {
    await ( async function (message) { alert(message) })((String('De maximale tijd die u kunt invoeren is ') + String(getObjectProperty(___arguments.context.appData, 'maxtijdreistijdminutenspeciaal'))));
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['reistijdminutenspeciaal'] = '';
    await ( async function (component) { component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a1e8549b31526fe82307e2d165b935a2')));
  }

  },
  /* handler:onBlur */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/e68a55e6219dc8ca1591e6998f7d2543/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['consultinwleeftijd'] = (getObjectProperty(___arguments.context.dataModel, 'leeftijd'));
  ___arguments.context.pageData['consultinwverwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['consultinwdoelgroep'] = (getObjectProperty(___arguments.context.dataModel, 'doelgroep'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.dataModel, 'hulpvraag'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['dossieraanmaker'] = (getObjectProperty(___arguments.context.dataModel, 'dossieraanmaker'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/074988f6219ebfcb22d285eca7abf887/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/56a2bd270ba195eafb1aa7a4392f27c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/1684e32347271471c37d5451e9aa891c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/349b44a8d1e70402c48aa0a50ce76668/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodevertrekpunt']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/480ed0660328100c8aca27b168610a06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/f4fe056e29ef32942305eed8af11f237/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['gvreistijdpostcode']))) == '1' && (___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).length > 4) {
    ;await ( async function (message){ alert(message) })('Voer enkel de 4 cijfers in van de postcode.');
    ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst'] = ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['postcodeaankomst']).slice(0, 4));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/f8010bfdee0d06ef81b4dcfc3896fccb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultwijze')) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/066c6ebe0bbad55b578bb9d1194a395d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.appData['uitlegreiskostenvergoeding'])

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['consultwijze']) == 'Face-to-face' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/c34ee54d807dd079e91ffefa6ed7e5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/d86f87bc9fbed2ff6081a3c94cd17bd6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'consultbetrokken')) == 'Ja' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/5b9f4fe91cd98f49de28dbbd2f028804/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'selected')) == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listcat2')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'betrokken')));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'selected')) == false) {
    (getObjectProperty(___arguments.context.pageData, 'listcat2')).splice((((getObjectProperty(___arguments.context.pageData, 'listcat2')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'betrokken')) + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'betrokken')) == 'Familie eerste graad') {
    text = 'Familie eerste graad (partner, ouders, kinderen, schoonouders, schoonzoons, schoondochters)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'betrokken')) == 'Familie tweede graad') {
    text = 'Familie tweede graad (broers, zussen, kleinkinderen, opa\'s, oma\'s, schoonzussen, zwagers, stiefzussen, stiefbroers)';
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c1491593cca47988161e5b41d69dc64c'), 'betrokken'));
  }

  return text

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/9897fc756ba8aede9f4e48398c7a64b9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9897fc756ba8aede9f4e48398c7a64b9', (await Backendless.Data.of('consultbetrokken').find(Backendless.DataQueryBuilder.create().setWhereClause((String(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))) + String('=\'1\''))).setSortBy('nr').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/00fa53699bf73d5d0207757b39a96b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = 'Datum gesprek';
  } else {
    visible = 'Datum consult';
  }

  return visible

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/e7b323bdd9dceace2473fcac48cdebf4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/dbb70c7e42970f02ccf454cbb5e6814f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/1ffdd2bf151483ab2a4b8a4ff498ec61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieconsultinw/components/2129bf38ea35128e80627b4afe78c706/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? 'Quote of kort verhaal voor bijvoorbeeld de nieuwsbrief' : 'Quote uit het gesprek met deze zorgvrager. Dit helpt het Centrum voor Levensvragen bij social media en het jaarverslag. De quote zal altijd onherkenbaar worden gebruikt.')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f4cee651b32b076e79698b4ba0cfa81a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/ee533fa1c3112a147e0f5e98af164e83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['centraname'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/9969b846a3adda6f073a52f2b7b3b24d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var timestamp, vrijwilligervergoedingov;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('26e368d415a66a057174bb5b95754abc')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2897d66ea277dafff8128c2a915f7c66')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')) == null) {
    (function (message) { alert(message) })('Alle velden dienen ingevuld te worden');
  } else if (false) {
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'vrijwilligervergoedingov')) == null) {
      vrijwilligervergoedingov = 0;
    } else {
      vrijwilligervergoedingov = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'vrijwilligervergoedingov')) * 10000;
    }
    ___arguments.context.pageData['createddossier'] = (await Backendless.Data.of('registraties').save( ({ [`financieringvws`]: 'Nee',[`financieringstroom`]: 'Vrijwilliger',[`gebruiker`]: 'vrijwilliger',[`reistijdbtwupdate`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'reistijdbtwupdate')))),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datumconsult`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum')),[`activiteit`]: 'Opbouw infrastructuur',[`opbouwinfrakorteomschrijving`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'opbouwinfrakorteomschrijving')),[`reistijdminutenspeciaal`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminutenspeciaal')),[`tariefperminuut`]: 0,[`tariefreistijdminutenspeciaal`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdminutenspeciaal')))),[`tariefreistijdkm`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefreistijdkm')))),[`centra`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),[`username`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),[`naam`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'naam')))),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`btwinclcoaching`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclcoaching')),[`btwinclconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclconsulten')),[`btwinclgroepsconsulten`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclgroepsconsulten')),[`btwinclscholing`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclscholing')),[`btwinclmdopatz`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclmdopatz')),[`gewerkteminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'gewerkteminuten')),[`reistijdminuten`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdminuten')),[`reistijdkm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'reistijdkm')),[`vrijwilligervergoedingov`]: vrijwilligervergoedingov,[`maand`]: [(new Date((new Date(timestamp))).getMonth()) + 1,'-',(new Date((new Date(timestamp))).getFullYear())].join(''),[`emailgv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`dossieraanmaker`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossieraanmaker')))),[`akkoord`]: (getObjectProperty(___arguments.context.pageData, 'akkoord')),[`opbouwinfrakortetoelichting`]: (getObjectProperty(___arguments.context.pageData, 'opbouwinfrakortetoelichting')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`regio`]: (getObjectProperty(___arguments.context.pageData, 'regio')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`rotterdamwaarheid`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'rotterdamwaarheid')) }) ));
    await Backendless.Data.of('dossiers').addRelation((JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))), 'registraties', [(getObjectProperty(___arguments.context.pageData, 'createddossier'))]);
    await Backendless.Data.of('aantekeningen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`datuminvoeraantekening`]: (new Date()),[`aantekeningen`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'aantekeningen')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/c19c1ba7ee7a9c78e73d725ae09c4cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerstartconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/b1f2a90e984d91859fc92cfd02ee2f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/15bdb7fc3fb5706fe7e27569393ecbf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/6563509e43a1bd582e0d78859f138bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opbouwinfrakortetoelichting'] = (getObjectProperty(___arguments.context.dataModel, 'opbouwinfrakortetoelichting'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.dataModel, 'regio'));
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.dataModel, 'akkoord'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/00f3a019a3c753f3f70cd1172e0a9f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2'), 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.getComponentDataStoreByUid('a22777ebef0bda047662fe32c0e54ce2')['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/8e15471b3d6fc65ddb0edd54145e2701/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerregistratieopbouwinfra/components/f17e248d8f722f2d68766e19da6f8351/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/ad1dda42ca6e610a84b4617b936eb2a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('Vrijwilliger'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6c2750f37c639981eeb5cd973a574503', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cce134b46f41fd8fce7a788e6b4ae4c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('93f2fa59041d7cf3126aad1c93725183', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0d0859383c5de094b598dbb19f842ef8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b4e43a7975f95424328dae7a54472b9', (await Backendless.Data.of('hulpvraagconsultinwpro').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('92be75553e9bd48a64836fa620f351f4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['Sum(gewerkteminuten) as gewerkteminuten', 'Sum(voorbereidingminuten) as voorbereidingminuten', 'Sum(reistijdkm) as reistijdkm', 'Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminuten) as reistijdminuten', 'Count(dossier) as aantalconsulten']).setPageSize(50))));
  ___arguments.context.pageData['registratiesfilter'] = (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8ff23ee060e82f8437cd3cabd941288', (await Backendless.Data.of('emailprojectleider').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND regio=\'',(getObjectProperty(___arguments.context.pageData, 'regio')),'\''].join(''))).setProperties(['email', 'email2']).setGroupBy('email').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/c7fbacd5c7a570a46009ba087ca3b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((String('Dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))).toUpperCase())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/e618759de024b8c908d697decd9ab104/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/a251b96154f7907704cdcee2fd6b668b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginavrijwilliger', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/8455474a96f3f9d93f4cb676bd146aea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteit')))) == 'Consult zorgvrager') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerregistratieconsultinw', undefined);
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteit')))) == 'Opbouw infrastructuur') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerregistratieopbouwinfra', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['dossierstatus']) == 'Afgesloten' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/8445c80c81cd6b6be17775cadf48b095/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'username')) == (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
    if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteit')))) == 'Consult zorgvrager') {
      ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'registratienummer'))));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerdetailsregistratieconsultzorgvrager', undefined);
    }
    Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie geopend','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
    await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligerstartconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'username')) != (JSON.parse((getObjectProperty(___arguments.context.appData, 'user'))))) {
      (function (message) { alert(message) })('Deze registratie kunt u niet inzien, deze registratie is door een andere gebruiker gedaan.');
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var C, item, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8445c80c81cd6b6be17775cadf48b095')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'vrijwilligervergoedingov')))) == '1') {
  } else {
    C = 'OV-vergoeding';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where = ['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\'',' AND centra=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'centraname')))),'\''].join('');

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/72423c480a48efc297c46db6161bcab8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['objectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'objectId'));

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult zorgvrager' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'vrijwilligerstatus'));
  ___arguments.context.pageData['regio'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'regio'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/8ed9df97f8dcaaa23a3d1a236ffd6037/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'Groepsconsult' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/d83d0e9ca08d634a6281249bb9519337/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligermijndossiers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/adff3329a7ec9f65a734a8518baabee4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/51ce3b71cab2ad45dd43e402c31a879f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Consult professional' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/83438a46c7ceb0f8171777eb09543983/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/ed3c554accf3b605e7a3fb18d43413e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'MDO/PaTz' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/3863769ace655feb0a1c4e9eefb9b8dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'Scholing' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/c3fd85b124191dbb34afca818c44e24d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['activiteit']) == 'Coaching on the job' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/c7d1203aff62f4bac396c06c7594c785/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/b9da9ad12389fb016b2ec7f14e3ae661/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/d706cee8adad334fd3ab74485b2eefb7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('nl', undefined).format((___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922')['created'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/8a165d9a227da25db24de3b338c39a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdkm']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/693bca7d519a8965c4d9e36504c347bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['vrijwilligervergoedingreistijdminutenspeciaal']))) == '1' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/fa2b6b0eb53a3faf102c7f8a03f18272/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      ___arguments.context.appData['dossierusername'] = (___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c')['username']);

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/799f82a31ce52d3b1887dd5469189f52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c')['akkoord']) != '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/13cc078f32be5deaa7a5fd7b9e26687c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c')['akkoord']) != '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/6c0a8895e8f23be1407f213cb501950d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c')['akkoord']) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/4c684fe47b1a15a1d1dd87632a5c8a99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c')['akkoord']) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/46e177a1e1e8a66fd4f5fa335f5b1e58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('10c60983e2c1189eda589b79a0d9b401') );
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ae13b197b596611c3a8e8739f4c94b2e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((___arguments.context.appData['dossier']))),'\''].join(''))).setPageSize(50))));

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/b1d6905e00bb2f4bd2c2189c7fb5a7b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d0859383c5de094b598dbb19f842ef8', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/2413755df97a1eacda0874cdf5de0e51/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['dossierstatus']) == 'Afgesloten' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/66250716aa93b17e7f6de96fafad6d2c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['dossierstatus']) == 'Afgesloten' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/11d533dc95fbc6f7b9a8e3b3e17e9bcc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligernieuwehulpvraag', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/41cc6decea0d50d735070e6ebca64744/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerdossierdelen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/f85500f966ea2f72e5ed001c47c8689a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerafsluitendossierconsultinwpro', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/21bc22c5da6f7f5d958e6e9e153386dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d0859383c5de094b598dbb19f842ef8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('120b4fe96c08cb7dbecfffcabc7858fd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('52feb4774b69a8b6c60769c82e12b063', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/2d3941cab202aba8681cf6331845dd35/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['dossierstatus']) == 'Afgesloten' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/60ade5ec5d7db8e1bdf7972b97bb4dae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.pageData['email']) == null) {
    ;await ( async function (message){ alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: ((await Backendless.UserService.getCurrentUser(false))['email']), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': ((await Backendless.UserService.getCurrentUser(false))['naam']),'gebruiker': ((await Backendless.UserService.getCurrentUser(false))['username']),'centraname': ((await Backendless.UserService.getCurrentUser(false))['centraname']),'email': (___arguments.context.pageData['email']),'dossier': (JSON.parse((___arguments.context.appData['dossier']))),'email2': ((await Backendless.UserService.getCurrentUser(false))['email']) }), undefined);
    ___arguments.context.pageData['email'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('120b4fe96c08cb7dbecfffcabc7858fd', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/7efbad94b4b757d3b47a1be5d8956746/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('120b4fe96c08cb7dbecfffcabc7858fd', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/e08a4aa118e94be9dd6d6fec38d772bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d0859383c5de094b598dbb19f842ef8', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/321b278e123eeb23bffc00ec7dea71c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailverlenging')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('aanvraagverlenging', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailadres')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'emailverlenging')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    ___arguments.context.pageData['emailverlenging'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('52feb4774b69a8b6c60769c82e12b063', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var text;


  text = String('Verstuur aanvraag verlenging naar de ') + String(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator'])));

  return text

  },  
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/042b4c5b361e82a8df6646452aec9d37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('52feb4774b69a8b6c60769c82e12b063', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/432cd647205e0479ddceb5d447453551/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((___arguments.context.appData['centraname']))),'\'',' AND GV LIKE \'PL%\''].join(''))).setProperties(['email', 'naam']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (item['naam']),'label': (item['naam']) });})))

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var emailadres, item;


  emailadres = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(JSON.parse((___arguments.context.appData['centraname']))),'\' AND naam=\'',(___arguments.context.pageData['emailnaam']),'\'AND GV LIKE \'PL%\''].join(''))).setProperties('email').setPageSize(100))).map(async item => {; return ({ 'value': (item['email']) });})))[0];
  ___arguments.context.pageData['emailadres'] = (emailadres['value']);

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/5a78e9dd0597dff167ca1f09dbf7183c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c'), 'akkoord'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('66250716aa93b17e7f6de96fafad6d2c'), 'activiteit'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/2ec540bf1851ce12f38324f6414727a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  text = ['Selecteer de ',(JSON.parse((___arguments.context.appData['naamprojectleidercoordinator']))),' aan wie u de verlenging wilt aanvragen.'].join('');

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/6f2e358cdb328a99a94ab6835aeeefaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;


  if ((___arguments.context.appData['gvpostcode']) == 'true') {
    text = 'Postcode:';
  } else {
    text = 'Gemeente/woonplaats:';
  }

  return text

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/79dc760829dfd1f5b1eebec182e799a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvgeboortejaar']) == 'true' ? false : true)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/532a0c18826a77e18bb97abf1e3b7417/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvgeboortejaar']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/a3680b9184fca6678f51e8f319bf9b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligeraantekeningen_2023', undefined);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-aantekeningen geopend-','-dossier:',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier'))))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'vrijwilligerstartconsult',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'aantekeningen geopend',[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`registratienummer`]: undefined,[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/0e9f8f426f176a5ec9920e428d89a69a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('52feb4774b69a8b6c60769c82e12b063', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('120b4fe96c08cb7dbecfffcabc7858fd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d0859383c5de094b598dbb19f842ef8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/80951617998ee8be9037762cb2e234f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('120b4fe96c08cb7dbecfffcabc7858fd', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d0859383c5de094b598dbb19f842ef8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('52feb4774b69a8b6c60769c82e12b063', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/60d3f20f51a9b16ed8a8e21ce7bc04eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('vrijwilligerafsluitendossierconsultinwpro', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/32de2aff4648f0c95225ae02fb0b9594/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'activiteit')) == 'Opbouw infrastructuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'vrijwilligerstatus'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/vrijwilligerstartconsult/components/83cad915e62d32da8d3900786fd7226d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e5040cc7fc211ef4cf1aa7a86b29c922'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/18b903c526923bcb929f6bae37e47cab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['user'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/5fb678e18cd32d099d8414d683da32e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/65414ac31a5ba768c9d10cca0585401a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = 'true';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6aac7a5a50429c04b92b2c05c55e2aa6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Ja\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c394869d5ff3e7c278e20686c4f648c4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('71c950e80329614b1a08b835af5ce26d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fbc69b7d949306365bcabed8ce05c319', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw)as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaal', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfd475169d91218427fa0df7bb2199b3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdkm) as reistijdkm', 'Sum(reistijdkmexbtw)as reistijdkmexbtw', 'Sum(reistijdkmbtw) as reistijdkmbtw', 'Sum(reistijdkmtotaalbedrag) as reistijdkmtotaalbedrag', 'maand', 'tariefreistijdkm']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f14f8f2f8b9175332287b88fcd6df2fa', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(reistijdminutenspeciaal) as reistijdminutenspeciaal', 'Sum(reistijdminutenspeciaalexbtw)as reistijdminutenspeciaalexbtw', 'Sum(reistijdminutenspeciaalbtw) as reistijdminutenspeciaalbtw', 'Sum(reistijdminutenspeciaaltotaalbedrag) as reistijdminutenspeciaaltotaalbedrag', 'maand', 'tariefreistijdminutenspeciaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('23ec61b314233b59e8d3df3deb92371c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Consult zorgvrager\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Consult professional\'','OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Groepsconsult\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8f11dff78bb94658555cda631b48ee96', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Scholing\'',' OR username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit=\'Coaching on the job\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fdffe5223e9abeae0b17217a9584e73d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'MDO/PaTz\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('284b366eb8b312dd89c2887935817fb6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND activiteit =\'Opbouw infrastructuur\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a349402bfd6237db389129954ab1a9c9', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' '].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw)as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5167ef1aa962cf82b61e83d238c84ee6', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['naam=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties(['maandakkoord']).setGroupBy('maandakkoord').setPageSize(100))));
  ___arguments.context.pageData['conditionregistraties'] = (['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'VWS\' OR ','username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringsubsidie=\'fonds buiten VWS\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0c06d7cd18ad9e67f3cd42242bd9930e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('41ff3b7eb7814efcaa213ee25cc3e0a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04b64dc468ea8e19de7a5d02e73a2d26', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fda7052fe1d1f8b2236fda9c7b01de97', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aab997318a09409b831c17d42d0a4649', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('180e83cdeb3cd7c5c14b0b5d462804b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc95a09c6a4115e2196e44acc17dee1', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('maand').setSortBy('created DESC').setGroupBy('maand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'maand')),'label': (getObjectProperty(item, 'maand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/d3567cfef3a22826d64cd293ab53ebea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/e58c17068ea7264502724be69c67cbec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/9f5bd3a365f9c9935587f6d43dfd24ba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/dc8ecf7275a64b67ab5b3b3ba5f45d96/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6dd49426d883d95f43684f4c386c66b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/373725965042b393cfd324ac19b5a9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('f7e40ab7bbfef35544874d7961e62ee8')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cfb16df36766f049fb84ff5b7a739283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('43cd2f532abe62f470a47e121592fc0a'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/d8b1bb872c5dff295dffbe9470dbf8b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/3b263b6b6779b27d0b8841d94c279439/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6d2e7d4557683d587edea5cea406d253/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['reistijdkmtotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/dc3584664e68ca5f68ed435f8874a30b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cd31ffa6cdfa4393834cd271e02d0c97')['tariefreistijdkm']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/039cc1f3f751922c4393f28c86bb84e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['tariefreistijdminutenspeciaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/8ae4577f00f4f3f46204db07b528a8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6299737feb0d07ff602af84cb4614489/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format2() {
  euro = euro / 1000000;
  cent = Math.ceil(100 * euro);
  euro = cent / 100;
  ___arguments.context.pageData['reistijdminutenspeciaalbtw'] = euro;
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f31ecdb7b4fb54016ca9a47194d2ea6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('eacfe939dc66fe66ead969b6fc98b77b')['reistijdminutenspeciaaltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ee2d9b8afd82fe9bab5dad0238fe19a9', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  ___arguments.context.pageData['image'] = true;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5c4d2f4b68c29f3f2e9eac7de04c2744', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/34d1765edf8486f9db1c9eb9c852e375/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagv', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a16557c9f6e5ef092ca7788b99f36d25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8caa6537a19dab94c9824d3c5fec6b6d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4baa25d4acab863d6c11c03dca33d241', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6471adf583ef836135b2acfe9fffe991/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d4cee1870f2e9958b73c9a72a93f1a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', false);
  Backendless.Logging.getLogger('ISO').info(([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-details registratie en dossier geopend-','-dossier:',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'-registratienummer:',(getObjectProperty(___arguments.selectedRecord, 'registratienummer'))].join('')));
  await Backendless.Data.of('historielog').save( ({ [`pagina`]: 'maandoverzicht',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'details registratie en dossier geopend',[`dossier`]: (getObjectProperty(___arguments.selectedRecord, 'dossier')),[`registratienummer`]: (getObjectProperty(___arguments.selectedRecord, 'registratienummer')),[`usernamedossier`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  ___arguments.context.pageData['VIEW'] = 'false';
  ___arguments.context.pageData['filterdossier'] = (['dossier=\'',(getObjectProperty(___arguments.selectedRecord, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['filterregistratie'] = (['registratienummer=\'',(getObjectProperty(___arguments.selectedRecord, 'registratienummer')),'\''].join(''));
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult zorgvrager') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Groepsconsult') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'MDO/PaTz') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Scholing') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', true);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6471adf583ef836135b2acfe9fffe991'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Overzicht registraties ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/fcd9b87b7764fcaf000fcacde05649b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fcd9b87b7764fcaf000fcacde05649b6', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aac7a5a50429c04b92b2c05c55e2aa6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd475169d91218427fa0df7bb2199b3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f14f8f2f8b9175332287b88fcd6df2fa', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4419bc6a64f94b668e282f5548feb787', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23ec61b314233b59e8d3df3deb92371c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1553a0fa965f2d7dda9aafb282864a5', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fae9b1680f37e2ccac121ad481e23689', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('791fe3443ae55743bc261c3a26596128', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e927f7bb038022e57c838c961f15e4f', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19e459069aabd8b452cad35f78cfd3e8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('294a2e2b1b5ad6ff608833a1bfae780d', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29516353a52343c5f006f9c18a291e97', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb146666706e3ff6258a92aff8fe5dbd', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ___arguments.context.pageData['VIEW'] = 'true';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cd31ffa6cdfa4393834cd271e02d0c97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/eacfe939dc66fe66ead969b6fc98b77b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/21b2fff717277c969bace2331dfcf1ef/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('21b2fff717277c969bace2331dfcf1ef'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/af373dbfd4e16f635a23b6c81bb477ab/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('af373dbfd4e16f635a23b6c81bb477ab'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/b64a60a600b34cc7dca82e7cbf8e5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b64a60a600b34cc7dca82e7cbf8e5eba'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/825d3c23d667b65b9e660e2e39c58146/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('825d3c23d667b65b9e660e2e39c58146'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cc6eb1bf00341b8b1ede3afcf0933e43/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cc6eb1bf00341b8b1ede3afcf0933e43'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c07d0127556464ef5788c99ac438cc23/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A, F, E;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c07d0127556464ef5788c99ac438cc23'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/9358216581347a4ac1a8c8525f38e5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var A, B, item, return2;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9358216581347a4ac1a8c8525f38e5cd'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvgeboortejaar']))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
  }
  if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    B = 'Gemeente/woonplaats';
  } else {
    B = 'Postcode';
  }
  return2 = (item['title']) != A && (item['title']) != B;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/993b5788281f5eb1c4722aa6f8b5089e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['naam'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/1e0a81e95bbab0249fd68e34f7f1478d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['organisatie'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/01f9255fb489356ab1eef6e327ffe6d7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (JSON.parse((___arguments.context.appData['emailgv'])))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/94d80ff4a049973ed502fe45dd7c50d5/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, B, item, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('94d80ff4a049973ed502fe45dd7c50d5'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/3f91948849f33cd1995b23b14a95ed0a/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3f91948849f33cd1995b23b14a95ed0a'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/b4b5963d41d125247b73e77a302c9106/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b4b5963d41d125247b73e77a302c9106'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c895a68dd0ca08a2a0f9a33e63f15cff/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c895a68dd0ca08a2a0f9a33e63f15cff'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/afbcb213b03d0331a5c71bff7b0eaef6/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var return2, A, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('afbcb213b03d0331a5c71bff7b0eaef6'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['gvpostcode']))) == '1') {
    A = 'Gemeente/woonplaats';
  } else {
    A = 'Postcode';
  }
  return2 = (item['title']) != A;


 return return2;
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/abb297234fdba08749e7a57a1c857f83/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/dafd0b045a47f612363ef9df5f4e169b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsselbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a294d37ab2a221d23a1323676e758929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('cb828268a1efcacf668494121cf97d02')['reistijdoverijsseltotaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cb828268a1efcacf668494121cf97d02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Overijssel' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/2a3744db2d39a0f38f84e47f709197e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/558ccb4b347138b388b8b2dfc6356695/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c6e9635c891c6e3a70ea9085f57a7eea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/750930777078a42df5085041102b681e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('2dbc1ee93c7f3dd5dc38d9ba1f98a4fb')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/32ace18c06537d180831f9d3f41d9011/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/53bb7d1ffd09e90de2cf3305621eaba9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c24371ee5c657c7d9e6c0b06d451506d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('492ea75e679151f79e5e8fb3546aac47')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0c9ba9c76382ef54dc295ea49e26dd79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/ad6ba834d83f6cba2da6b15d7fc2ab74/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/281f88b92af464964dfadfa9162cb1ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f5d565a585ef73d58e1fb2291cdef67f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ea3e179fd5d68ecb763e790df22d7173'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/8f5db1aa67fcf5373083509802720339/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/19fb3f1f2737ba682c7f2ae77c1e024a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/7dde52a604e4a2d1f599d2e7123887a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('78fce14caae7720c1ad8763913cab744')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a95c06fb4598e88ee499e44267094449/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0644c44f03fceebabf8f8b72ade2d59f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/687456a8575fe93e48030c5ebcc92d12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutenbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/3983c66d42ec4ad9f1983c5785fd7dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('864f03345cfab011aaf110dd02a570da')['gewminutentotaal']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/e246f231300ee74bc938be16aa483186/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/531cde561f3da025bd595e751c27d602/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/520359e4c7f80e16756716b22c9cabd7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('32789b3b6f849fb1c23e5c82c718d45b')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/8ebe1325253434d76d134261271f94fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cb32b79aac95883c0943262e91322ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var F, item, E, D, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('cb32b79aac95883c0943262e91322ad8'))['columns']), async (item) => {
   if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1' && (JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminuten']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdkm']))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((___arguments.context.appData['setreistijdminutenspeciaal']))) == '1') {
    A = 'Reistijd in km';
    B = 'Reistijd in minuten';
  }
  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Reistijd in km';
  } else {
    D = 'Leerpunten';
    E = 'Naar waarheid ingevuld';
    F = 'Klachtenreglement besproken';
  }


 return ((item['title']) != A && (item['title']) != B && (item['title']) != C && (item['title']) != D && (item['title']) != E && (item['title']) != F);
}))

  },  
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/ff8cc9c670c162bbeb4dbea1b1f644c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/9d4cee1870f2e9958b73c9a72a93f1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6aac7a5a50429c04b92b2c05c55e2aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/bfd475169d91218427fa0df7bb2199b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f14f8f2f8b9175332287b88fcd6df2fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/4419bc6a64f94b668e282f5548feb787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/23ec61b314233b59e8d3df3deb92371c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6aac7a5a50429c04b92b2c05c55e2aa6')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/9224658f241147fae6d81af813a47afd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0c06d7cd18ad9e67f3cd42242bd9930e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6c2b3cc697da3b7aed1e0ae5dcdc47bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/8f11dff78bb94658555cda631b48ee96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6c2b3cc697da3b7aed1e0ae5dcdc47bf')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/210a4446cc8dd5f7c0c6dc8516aff91a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/41ff3b7eb7814efcaa213ee25cc3e0a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/71c950e80329614b1a08b835af5ce26d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/fdffe5223e9abeae0b17217a9584e73d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('71c950e80329614b1a08b835af5ce26d')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f6fe3b1944e975553fb1fbb9863b1d24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/04b64dc468ea8e19de7a5d02e73a2d26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/fbc69b7d949306365bcabed8ce05c319/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/284b366eb8b312dd89c2887935817fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fbc69b7d949306365bcabed8ce05c319')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/521b455fb2640a8fe6e4359106c3eead/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a349402bfd6237db389129954ab1a9c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.pageData['VIEW']) == 'false') {
    visible = false;
  } else if (!((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a349402bfd6237db389129954ab1a9c9')).length) {
    visible = false;
  } else if ((___arguments.context.pageData['VIEW']) == 'true') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/aa289e34a6c3e6a1925fb57fbee1f563/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalexbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/d739b42d4073b8177a76efbebb7ba67b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbtw']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/b7d5973296be117105521ddd0001fb54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.getComponentDataStoreByUid('42420111bee752e686170c3e610d1735')['totaalbedrag']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f761aa41091454bf728bcc1312699991/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cb789b94fd7e4c3217e86ba9f8dc2df6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'factuurdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/e32b522d24f79d2c7f56687f01dff468/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/16498df1282374434642494414e4cada/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a7ee3bdf64ee3171075c6467c56571af/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7ee3bdf64ee3171075c6467c56571af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/d01c35d25ae6a39568984d6157c553a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer'))].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'tennamevaniban')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6ab891ed58f47a7a5531f06288ae1c26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var part, euro, dotnumber, length2, rest;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/41f537e9747b0577bdee2abc25b6c635/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/619d951fd09bc4793c4c3781249aa3e4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('619d951fd09bc4793c4c3781249aa3e4', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/615f8805a5749e5f2a5d8e93a845e0a3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('615f8805a5749e5f2a5d8e93a845e0a3', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a72bdcacd71e91daa1e1243fa0c1285f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0f42b3be9ce887083b81e7712d641ecc'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0df6a9a2373468971022f78f561637c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0c6bb8d997636ba843ff17f10319aa68'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/ca2226b7963c5258aa68311661a893e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('18b599ee2d786077920712e57597f1a3'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/622c994a7c58345f82f69ac66cb39a53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('622c994a7c58345f82f69ac66cb39a53', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw=0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/245bd7a4191728768474579a4c1e1a9c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('245bd7a4191728768474579a4c1e1a9c', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'user')))),'\' AND maand= \'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND gewerkteminutenbtw<>0'].join(''))).setProperties(['Sum(gewerkteminutenexbtw) as gewerkteminutenexbtw', 'Sum(gewerkteminutenbtw)as gewerkteminutenbtw', 'Sum(gewerkteminutentotaalbedrag) as gewerkteminutentotaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/8ecaf544e2f34556c487683a5f9ddd5d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['exclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['exclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/72dbfe0bd02da9fe25324d8da3fd5439/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclgewerkteminutenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenexbtw'));
  ___arguments.context.pageData['inclgewerkteminutenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutenbtw'));
  ___arguments.context.pageData['inclgewerkteminutentotaalbedrag'] = (getObjectProperty(___arguments.context.dataModel, 'gewerkteminutentotaalbedrag'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/395efac6a9320919644299ef79f253ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/5c4c6d02601e586571913a63643f8721/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/965edb0c0c5456bdaba28cbc73d9be71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/28f4266b7c0fb07a2c779e9f8511ed0b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclgewerkteminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/6a36f1acc94d84f2d8f525729b068097/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/4908b91e4b824b319a9e06d982acb3df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'false') {
    visible = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == 'true') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4908b91e4b824b319a9e06d982acb3df', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f5ef5669df27ecb4a7f84b9f49ff8102/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/783ccd87c10238e52547e319f9c42196/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/809248d2c76e9a5d8d3103df80d1a035/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/132dc05fa9facce6542b5adb562d8e24/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/87e76f5cb99d5b25530bec34e8d15378/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/e96179628c3b44e6cc9f8551b957967d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/dbe95b43ac5af80b474f07556a088a0d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/484540e5dabdc37318ef1a05df8acae5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/080729f791fee87f1065442affbc9cfd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/df2cd44542371254347e6453639ea089/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/94bc865961a1662e0f0cfa2862496c1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c391da74d72e9391b7813122fa37401c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/468dcf71802d7b6c8e78e6579ccd3873/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['spinner'] = true;
  await new Promise(r => setTimeout(r, 5000 || 0));
  ___arguments.context.pageData['spinner'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('Voordat de factuur opgemaakt kan worden moet eerst de maand geselecteerd worden.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'false';
    ___arguments.context.pageData['START'] = 'false';
    ___arguments.context.pageData['INVOICE'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1209dcab0383fea6c9d4e1bde47c47a5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/1209dcab0383fea6c9d4e1bde47c47a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['START'] = 'true';
  ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
  ___arguments.context.pageData['VIEW'] = 'true';
  ___arguments.context.pageData['INVOICE'] = 'false';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ee42ccab5d631311c56fa9cb97f60f3', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34d1765edf8486f9db1c9eb9c852e375', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1209dcab0383fea6c9d4e1bde47c47a5', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0313aa339fc39c341d4da0722017616f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/04e5958dcafd67997f3add2fe065298a/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['SOURCE'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['image'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04e5958dcafd67997f3add2fe065298a');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/1067219e319f3c37cbeedef87a980acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0313aa339fc39c341d4da0722017616f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurnummer')).length) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'telefoon')).length) {
    (function (message) { alert(message) })('Het telefoonnummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dbe95b43ac5af80b474f07556a088a0d')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('484540e5dabdc37318ef1a05df8acae5')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'tennamevaniban')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'factuurdatum')) == null) {
    (function (message) { alert(message) })('De factuurdatum moet ingevuld worden om de factuur op te maken.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99bbbd0bc1ee2f6f33be7a32a53d19b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee2d9b8afd82fe9bab5dad0238fe19a9', true);
    ___arguments.context.pageData['INVOICE'] = 'true';
    ___arguments.context.pageData['VIEW'] = 'true';
    ___arguments.context.pageData['FACTGEGEVENS'] = 'false';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d217f619e343b2d5ae24ce39329c0f24', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5167ef1aa962cf82b61e83d238c84ee6', true);
    await new Promise(r => setTimeout(r, 3000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503ba202d726474b425ec03bb4b2ea03', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b833cbee86a640fe456be69ce8f9a3ec'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c20795538be3991ac1223d9bb0249b09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/b765eb6f0122d899a5b5cc54dfc1acbf/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b765eb6f0122d899a5b5cc54dfc1acbf', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/777912f371e2e0421302f306ce78cb89/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('777912f371e2e0421302f306ce78cb89', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/0303a567855b9ae6678e79418ce5458e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0303a567855b9ae6678e79418ce5458e', (await Backendless.Data.of('gegevenspenvoerder').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/484793826f8c07d194efef09905bc219/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('484793826f8c07d194efef09905bc219', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Ja\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/204c448c0256f419e016d44d22b77a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('204c448c0256f419e016d44d22b77a9d', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag', 'maand', 'activiteit']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/e3089d6c4e2393cdf9e5e868b1c47abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('067e543f88024b3899bae6fdd6d10c55'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/60ba84733abcbc2a857f13b68cc1f8f8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/f7db815535632651395b977afb7c5f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a3de41b9fc790b44908df7b252fa3bae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/067dd82481efb99de78c5588076a0c31/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/2a9a973bb1a8e809211d09b95eebef63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://docs.google.com/document/d/1YegezYy8wS7ywkeB_8_E9DXawv-142LO/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/9abfbf11965396eeb1596a2789d59e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.pageData['image'] = false;

  },
  /* handler:onError */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'image'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/d472e12c349893525cb97babad2bb64f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/478366811545b5a987097c16d0d17abf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'activiteit')) + String(' (fonds buiten VWS)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/ba1cbf9aa95b116b55ad2f1c0f19521e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'tariefperminuut'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/338ca7f65319001d56120b6e901c3208/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/c2b14d751e4e1343e53ba033a2dfd07b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/b3bfc9d65652b6155dad62e62a35cb2b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0144ee35d934bfa18369c4fb5e3732da'), 'gewminutentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/5571a42fac7ba4acdaeca4a2fc119547/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'activiteit')) + String(' (fonds buiten VWS)'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/a70a134cfbd71d33cf64df1eceea2bc5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'tariefperminuut')) * 60;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/36d56e995383437dc31d21085cd85991/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/cb667cb61f25fc8538a8bee9e6494f98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a2353af64039636621de515fd52e3cd4'), 'gewminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/be15fdb6b73c905a1f3bf006a23d5c97/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be15fdb6b73c905a1f3bf006a23d5c97', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND financieringvws=\'Nee\''].join(''))).setProperties(['Count(registratienummer) as aantal', 'Sum(gewerktvoorbereidingreistijdminuten) as gewminuten', 'Sum(gewerkteminutenbtw) as gewminutenbtw', 'Sum(gewerkteminutenexbtw) as gewminutenexbtw', 'Sum(gewerkteminutentotaalbedrag) as gewminutentotaalbedrag', 'maand', 'activiteit', 'tariefperminuut']).setSortBy('activiteit').setGroupBy('activiteit').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/3c4acfdae42a3b4ef30d4543906ca138/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['factuurdatum'] = (new Intl.DateTimeFormat('de', undefined).format(___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackupmaandoverzichtrotterdam2022/components/5cf7b86f419849c30fc112ce9b596fa6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == 'false') {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/db799e8b86a609c8bc1f1a6db846de38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filteractiviteit']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['teksttoestemmingdossiers'] = 'TOESTEMMING DOSSIERS';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['akkoord'] = '=\'0\'';
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  ___arguments.context.pageData['filterregio'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = (getObjectProperty(___arguments.context.pageData, 'filternaamgv'));
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/2a07c8910267501fa1bd76cf01986c99/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['akkoord'] = (getObjectProperty(___arguments.context.pageData, 'akkoord'));
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/48356f0d3cbf5241c9e77bcccdd62796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['filternaamgv']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/562481d7e395ac6433057c77c9224b88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.context.pageData['akkoord']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/250dc99c9ec6681560434e71323add7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  ___arguments.context.pageData['questioscholingbedrag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingbedrag'));
  ___arguments.context.pageData['factuurcontactpersoon'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurcontactpersoon'));
  ___arguments.context.pageData['factuurmailadres'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'factuurmailadres'));
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join(''));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['hulpvraag'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'hulpvraag'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));
  ___arguments.context.pageData['opmerkingenprojectleider'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider'));
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-dossier geopend en inzage op alle registraties in dossier-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'dossier geopend en inzage op alle registraties in dossier',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult zorgvrager') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Consult professional') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Groepsconsult') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'MDO/PaTz') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Drechtsteden') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ff944e4139f137319e96b862e535127', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Scholing') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Scholing' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2abb028ab38b59c21776517b7d68f0f5', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'questioscholingofmoreel')) == 'Moreel beraad' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76880c9fcb0c123d929ccb63054da895', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coaching on the job') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Coördinatietaken') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Opbouw infrastructuur') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Netwerkbijeenkomst NPZF') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('df4cf34cb7e742ae2ac4a6e87dd6685b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Raad van Advies') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5071b65e623a154d46ca2db7302fa68f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit')) == 'Werkgroep') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('829a1de661884cf46729c511d6fa24c4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/89a3c1bc335575694ec460c565f6ae53/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('activiteit ASC').setGroupBy('activiteit').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'activiteit')),'label': (getObjectProperty(item, 'activiteit')) });}))), ({ 'value': '%','label': 'Alle activiteiten' })))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a659efe30439c09f4b02162561665ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailvraag')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    await Backendless.Messaging.sendEmailFromTemplate('informatieverzoekdossiers', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`emailvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailvraag')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`opmerkingenprojectleider`]: [(getObjectProperty(___arguments.context.pageData, 'opmerkingenprojectleider')),' / Emailvraag: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(new Intl.DateTimeFormat('de', undefined).format(((new Date()).valueOf()))),'-',(getObjectProperty(___arguments.context.pageData, 'emailvraag')),' /'].join('') }) );
    ___arguments.context.pageData['emailvraag'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['emailvraag'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c7f4ea7390d845d20796f4cd0a465592', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef7cb91659da8a6646f3872bf144bd8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968fa5a253f2472fd8b2db2de35a2f43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa15bf4effe2b37efd2bd769686ff48d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('796ea58fd5daf3c29d13ba44d07d7d9d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a39ae2681cb81722c878ce6336d258a9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d168e33a12064424506c143745849a26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9ca50247ab4921db49efc0f7c7d9111', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bdcb4a2287b5b0aab4edfaacfd338abd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64ed27db0edcb01945d265947d45035d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fe666b5fe970f153424c421446823a4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6fb58b012d87a383c2dde50eca092d9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bf71eb57a628f7fd2e63b6d24ab52492', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a0bfe5923a26de4186f1aef6b192c534', false);
    ___arguments.context.pageData['pageoffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ee252ab2d0df5dee8398cbc3d1481d2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/78ae5cf4fdee5da4ca4b4308444bc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginaprojectleider', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/bf2163bdf337032177dd49b30a63881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	document.addEventListener("wheel", (event) => {
  	  if (document.activeElement.type === "number") {
  	    document.activeElement.blur();
  	  }
  	});

  })();
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'pakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingpakketminutenakkoord': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')),'aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/922b3b47a30de37c7e6d81694e6f8ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('922b3b47a30de37c7e6d81694e6f8ea1'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/53c9f87a4f13ba9eab442e9236c446c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', true);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6d8a83b517eaf97d37c36695a2ad62bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 1) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      }
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
      if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Consult zorgvrager') {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
      } else {
        emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
      }
    } else {
      emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is akkoord bevonden voor ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    }
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == null) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is niet akkoord bevonden.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  } else if ((getObjectProperty(___arguments.context.pageData, 'akkoordemail')) == 0) {
    emailtext = ['Dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is in behandeling.'].join('');
    ___arguments.context.pageData['emailtext'] = emailtext;
  }

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/5b46e22ef77b8ab19974d85625f44efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleider')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['opmerkingprojectleider'] = null;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/2deb2963a12d9dcd96329a2b70597dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 0) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = 1;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) == null) {
      ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier'));
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutendossier')) }) );
    } else {
      await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord')) }) );
    }
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = null;
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['pakketminutenakkoord'] = null;
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null,[`pakketminutenakkoord`]: null,[`status`]: 'Afgesloten',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'NIET AKKOORD',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: null }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    ___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454')['akkoord'] = '';
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0,[`pakketminutenakkoord`]: null,[`status`]: 'Actief',[`akkoorddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoorddatum`]: (new Date()) }) );
    await Backendless.Data.of('registraties').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
    await Backendless.Data.of('historiepltoestemmingen').save( ({ [`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`aanpassingstatusdossier`]: 'TE BEHANDELEN',[`aanpassingdatum`]: (new Date()),[`aanpassingdoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    await Backendless.Data.of('nietdeclarabel').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ [`akkoord`]: 0 }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == false) {
    label = 'te behandelen';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == true) {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#8CC63F';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord')) == null) {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2deb2963a12d9dcd96329a2b70597dfa'))['backgroundColor'] = '#FF0000';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e23755a152bae2d981ca5758f8d37c96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efd417d7a8ad28def9d729dcb26a9ef4', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(___arguments.context.appData['centraname']),'\'',' AND activiteit LIKE \'',(___arguments.context.pageData['filteractiviteit']),'\'',' AND naam LIKE \'',(___arguments.context.pageData['filternaamgv']),'\'',' AND akkoord',(___arguments.context.pageData['akkoord'])].join('')),'sortBy': 'Dossier DESC' })));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/fb2254d1d9cba6b1c47e26b4a1d53b43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/50e3d8cf1d5b5021dca38b96f68fee7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('50e3d8cf1d5b5021dca38b96f68fee7c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f637f05271be094e23498be6da470faf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fb2254d1d9cba6b1c47e26b4a1d53b43', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/4f5920c69d1b7abd2f822e09cb1d21c7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));
  await format();
  ___arguments.context.pageData['budgetconsultinwpro'] = (getObjectProperty(___arguments.context.appData, 'budgetconsultinwpro'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ac961463f293122c2af42bd2bc951f7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetgroepsconsult']);
  await format();
  ___arguments.context.pageData['budgetgroepsconsult'] = (___arguments.context.appData['budgetgroepsconsult']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/99659364a71ca96f178968d42f2fce56/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetmdopatz']);
  await format();
  ___arguments.context.pageData['budgetmdopatz'] = (___arguments.context.appData['budgetmdopatz']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/dc5277eedcf30867919eb198931ae448/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetscholing']);
  await format();
  ___arguments.context.pageData['budgetscholing'] = (___arguments.context.appData['budgetscholing']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0e03786468acfe7cce88103d5573990f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoaching']);
  await format();
  ___arguments.context.pageData['budgetcoaching'] = (___arguments.context.appData['budgetcoaching']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/66df52ab599bc4d4605fdbab2ec9357d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.appData['budgetcoordinatietaken']);
  await format();
  ___arguments.context.pageData['budgetcoordinatie'] = (___arguments.context.appData['budgetcoordinatietaken']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ec7fc435caf722a5bb5290af93f9d143/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));
  await format();
  ___arguments.context.pageData['budgetopbouwinfra'] = (getObjectProperty(___arguments.context.appData, 'budgetopbouwinfra'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/1466292dbeb6de8e0e19693b06d629d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));
  await format();
  ___arguments.context.pageData['budgettotaal'] = (getObjectProperty(___arguments.context.appData, 'budgettotaal'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/15b85667f8b2491efe59dc5be4b2dce5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('15b85667f8b2491efe59dc5be4b2dce5', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' AND jaar=2024 OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/eb2d8062b33538fdda3e8e6e12ea2316/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eb2d8062b33538fdda3e8e6e12ea2316', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Groepsconsult\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/10f2698d26baf92b10fe422640d276de/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('10f2698d26baf92b10fe422640d276de', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'MDO/PaTz\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b3d3479b95de2b9cccae603f34094285/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b3d3479b95de2b9cccae603f34094285', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Scholing\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/207573524be607a6c1c6826e874fea9a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('207573524be607a6c1c6826e874fea9a', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coaching on the job\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0074fe95f8fad94e8884fc0caf4e8ab2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0074fe95f8fad94e8884fc0caf4e8ab2', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Coördinatietaken\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/633b88654084f4d12a89e55efadf2687/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('633b88654084f4d12a89e55efadf2687', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Opbouw infrastructuur\' AND jaar=2024'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/8d85f7f484ccf25b162e45969bf6a748/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2025 AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d85f7f484ccf25b162e45969bf6a748', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND jaar=2025'].join(''))).setProperties('Sum(totaalbedrag) as totaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/50a28c68cde3fb4a8fb381542c0fe8ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a5313f4bf8347e339c4eade136811d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedgroepsconsult'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3c7a4013e296143d9d47d92be89333c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedmdopatz'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a368cbd17349f50400233d4a6487bf39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedscholing'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b512abf16d8e6da3e644f456cdac4f4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoaching'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a8ebfb35abae6b24ea78922c0074f4e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedcoordinatie'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/55baa318075a1bd8c1c404bf6a085b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['totaalbedrag']);
  await format();
  ___arguments.context.pageData['besteedopbouwinfra'] = (___arguments.context.dataModel['totaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6fa78d485af6f6f6d1bba9be0dcdac3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['besteedtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'totaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c843e2f80775b77b51a711e83afb299f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c843e2f80775b77b51a711e83afb299f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a6cc9fc7efa8bb333d4247c84d0fc52e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a6cc9fc7efa8bb333d4247c84d0fc52e', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/73f8b93f28c2d826704db521e2414073/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('73f8b93f28c2d826704db521e2414073', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d8f75cb59af9b9e3ea54684acf7a4f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8f75cb59af9b9e3ea54684acf7a4f4b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e8533b6140414d11fca7aed5ddb4968c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e8533b6140414d11fca7aed5ddb4968c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c306ec81991e8fb999c760fd70e1e44c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c306ec81991e8fb999c760fd70e1e44c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/fc7744bc17dfe7fbf4bfbfa9649dcded/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fc7744bc17dfe7fbf4bfbfa9649dcded', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6cf3f1d8f9044cace1cf17b82ccb24e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6cf3f1d8f9044cace1cf17b82ccb24e8', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterend) as resterend').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e73c1d420478f1d947391cc31e73008c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e73c1d420478f1d947391cc31e73008c', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult zorgvrager\' OR ','centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit=\'Consult professional\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/eab629dfbd7f4928c036dc22bfafbfcb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('eab629dfbd7f4928c036dc22bfafbfcb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Groepsconsult','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/47837b81b0b2c648f3b5bfe524397cdb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('47837b81b0b2c648f3b5bfe524397cdb', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','MDO/PaTz','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/13ff2e8816793b54bcdf9c5653239514/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('13ff2e8816793b54bcdf9c5653239514', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Scholing','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e99eb0486adebf5f819ae5e71c7339ed/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e99eb0486adebf5f819ae5e71c7339ed', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coaching on the job','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/151d795c1845ee060f73320e0103ef4a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('151d795c1845ee060f73320e0103ef4a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Coördinatietaken','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0c1901ca79832fe6a3882a9b866be294/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0c1901ca79832fe6a3882a9b866be294', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',((await Backendless.UserService.getCurrentUser(false))['centraname']),'\' AND activiteit=\'','Opbouw infrastructuur','\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));

  },  
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ad75e9465b8126566f99b3362a23b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND activiteit<>\'Werkgroep\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad75e9465b8126566f99b3362a23b46a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('Sum(resterendtotaalbedrag) as openstaandtotaalbedrag').setPageSize(100))));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3cfa4b18dde681a3c8df93d3e16e1708/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandconsultinwpro'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/503f431d5b5faf63e5afea1a84df2a8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandgroepsconsult'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/cd85d0d273c557fa4ba2d9a1f8168184/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandmdopatz'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/4fbd1a890f434f5e12e58719b56859bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandscholing'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0b378e9d2267f529cb94e152a47de283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoaching'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7ba49626e8b588f7bd7bbc2dd1fbfcc8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandcoordinatie'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d3a16f996d4e90bc920d0cb9665e3b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.dataModel['openstaandtotaalbedrag']);
  await format();
  ___arguments.context.pageData['openstaandopbouwinfra'] = (___arguments.context.dataModel['openstaandtotaalbedrag']);

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/bd938b46dafbf7ec3494e793c2f2b94d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));
  await format();
  ___arguments.context.pageData['openstaandtotaal'] = (getObjectProperty(___arguments.context.dataModel, 'openstaandtotaalbedrag'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/90361a85a3b8834c28a334d5bcce088e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro')) + (getObjectProperty(___arguments.context.pageData, 'openstaandconsultinwpro'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/8b81a556be61cfd1ceec1f0a745b4111/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedgroepsconsult']) + (___arguments.context.pageData['openstaandgroepsconsult']);
  euro = (___arguments.context.pageData['budgetgroepsconsult']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3d27b3d26878cef28135293953071b52/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedmdopatz']) + (___arguments.context.pageData['openstaandmdopatz']);
  euro = (___arguments.context.pageData['budgetmdopatz']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/54445c8dd2bc501296abc21dbe3bb3a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedscholing']) + (___arguments.context.pageData['openstaandscholing']);
  euro = (___arguments.context.pageData['budgetscholing']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/bbca5d3cc364099e452cc28645e416a6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, cent, part, dotnumber, length2, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoaching']) + (___arguments.context.pageData['openstaandcoaching']);
  euro = (___arguments.context.pageData['budgetcoaching']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/2e176a5989a1306939badbb848fe65ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedcoordinatie']) + (___arguments.context.pageData['openstaandcoordinatie']);
  euro = (___arguments.context.pageData['budgetcoordinatie']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/db32b9a6675a648f8b82c303f21de791/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest, sum;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (___arguments.context.pageData['besteedopbouwinfra']) + (___arguments.context.pageData['openstaandopbouwinfra']);
  euro = (___arguments.context.pageData['budgetopbouwinfra']) - sum;
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/1e06fe39d44cadac049cd2a88a8cd907/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, sum, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  sum = (getObjectProperty(___arguments.context.pageData, 'besteedtotaal')) + (getObjectProperty(___arguments.context.pageData, 'openstaandtotaal'));
  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - sum;
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/824b126c33eb3cd63dd8595ed3c68f8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setconsultinw')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0a9783d95605c6f63152a93e58d592e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setgroepsconsult']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/4284d0cd9144569f671f70dcb5a3b92e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setmdopatz']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ae2c9885141c8c8f433b60c37b959c41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setscholing']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/68d5d27230b5acf1e6e62df87da7a4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoaching']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6256ac564398545a470b969575661be7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['setcoordinatietaken']) == 'true' && (___arguments.context.appData['plbudgetdetails']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/26d57ba7dae535750ab5399e2865047b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'setopbouwinfra')) == 'true' && (getObjectProperty(___arguments.context.appData, 'plbudgetdetails')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7de3b5295b3b7842b7c72729efc7941c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND dossier LIKE\'',(getObjectProperty(___arguments.context.pageData, 'dossiernummer')),'\''].join('')) })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/34ed2b476992f0a6e4e4e8a4f1cefd28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgetconsultinwpro')) - (getObjectProperty(___arguments.context.pageData, 'besteedconsultinwpro'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f39e324f9e48ec31c74213c26592708c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetgroepsconsult']) - (___arguments.context.pageData['besteedgroepsconsult']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e8aeb0930c95050cea025b4e124fe99e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetmdopatz']) - (___arguments.context.pageData['besteedmdopatz']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d8d77a0a9a4570e3323ab3e2d502ef1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetscholing']) - (___arguments.context.pageData['besteedscholing']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/bca1322ecb7cf2a5ce4fa958bd8254d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoaching']) - (___arguments.context.pageData['besteedcoaching']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/06c2fa7579f5a972bba8aa3a5371396d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetcoordinatie']) - (___arguments.context.pageData['besteedcoordinatie']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d881eb4f0158775dcffa76c990399861/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (___arguments.context.pageData['budgetopbouwinfra']) - (___arguments.context.pageData['besteedopbouwinfra']);
  await format();

  return euro

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/667f3c48e3956ffe73efe3824738a691/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'budgettotaal')) - (getObjectProperty(___arguments.context.pageData, 'besteedtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b88a84df888397b4714e5a5370283c03/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? false : true)) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/fefd0e9ad2a7924e66310f53a0e47db4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/47a1890b9aecb8879ec9a2b83bce9204/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d09b4c992fb2125f6c5f1df747457607/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d036100e7ed9acb83ad2fe8e93bbe3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/fbf31ec6fc86aa473cc58f7db268b73e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/5b9b9ecc780658a7ee9b52c2e579c181/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7fc70af8ec0456e18ff41fa6dc39ec1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/320167587f0601545ed86ff266a9a32d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/df77d477ecff3d38b334b8cbf6838ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['gvregistratiestop']) == 'true' ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/4a7a98ac5fdd7bdf65c6e6bfca3a7e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'gvregistratiestop')) == 'true' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6eb2d97b8051741c32feea6fdd374918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3bfd812d5946761b5cbc4f527eae1af3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('dossieraanmaker ASC').setGroupBy('dossieraanmaker').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dossieraanmaker')),'label': (getObjectProperty(item, 'dossieraanmaker')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/18d87ffcd8ee58ad3f0a72030b0e275f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7c8270a1fa57cbdf245cb0e73d1c0eab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterdossieraanmaker'] = '%';
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/af9884d7dfaf872183d4658b2731815e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/190739bfbd5238033e4f1d481d0e86bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossiernummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/cc4962cf9954798318fb993dd68f8a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'plmaandcontroledossieraanmaker')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f7a1ce4c07e9b8bd8de6ef7ba8369ed6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.appData['plmaandcontroledossieraanmaker']) == 1 ? true : false)

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a57d9a4cceef2ccb176efc4d04ee3b52/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J, K;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a57d9a4cceef2ccb176efc4d04ee3b52')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvgeboortejaar')))) == '1') {
    A = 'Leeftijd';
  } else {
    A = 'Geboortejaar';
    B = 'Gender';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    C = 'CvL';
    D = 'CvL GV';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Achtergrondinformatie';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN') {
  } else {
    F = 'Status';
    G = 'Toelichting';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
    H = 'Leeftijd';
    I = 'Gender';
  } else {
    J = 'Aangenomen door';
    K = 'Geboortedatum';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/cb4f5c5f4ca2ea43781f807eb5dd1d41/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' AND activiteit LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['dossiernummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/9d777e7e69140ecd2e570cca06c3a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filterregio'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c0f5fc5f4da7dd348f8b6408b16dc22c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = String('Toegekend door ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'naamprojectleidercoordinator'))));

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/8f34ff3b740ca2953d57c21ec03c57c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'gvpostcode')))) == '1') {
    text = 'Postcode';
  } else {
    text = 'Gemeente/ woonplaats';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/19d83863a759a0f64e2959a4caade4a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/195fdfabb05549a1cdee74cbfaf24ff7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c2a4435c204f604698e9498d397d33e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/091956a3be8ae403ba7b709cbeb618ab/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async onTooltipTextAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier. Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  } else {
    text = 'Vul hier het bedrag in wat u toe wilt kennen aan dit dossier (excl. reistijd). Indien het voorgesteld aantal minuten akkoord is dan hoeft u hier niets in te vullen. Wilt u de geestelijk verzorger bij een verlenging extra minuten toekennen dan telt u het aantal minuten op bij het aantal minuten dat er al staat. ';
  }

  return text

  },  
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b4f970b1bc4b6c249c342d4cd2a812b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var text;


  if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
    text = 'CvL';
  } else {
    text = 'Regio';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/242fc97ce7f4f1894362b833b3ad9396/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b99b4cee3ed517af6505e26f83447885/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      return (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b133f6a5ef6a27276c97c0bdb227a0ae/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var D, item, C, B, A;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b133f6a5ef6a27276c97c0bdb227a0ae'))['columns']), async (item) => {
   if (((await Backendless.UserService.getCurrentUser(false))['centraname']) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
  }


 return ((item['title']) != A && (item['title']) != B);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/9dec074121e3b8fa37a6b1ed514c72a3/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var D, item, C, B, A, E;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9dec074121e3b8fa37a6b1ed514c72a3')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
  } else {
    E = 'Doelgroep';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/897a38e7ed49de0b1362726b9ac1b854/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var K, item, J, I, H, G, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('897a38e7ed49de0b1362726b9ac1b854')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    E = 'Betrokken disciplines';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
  } else {
    F = 'Omschrijving';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/76c7f946db0bb2446726879e2f62172f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var A, B, C, D, E, F, G, H, I, item, J, K, L, M;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76c7f946db0bb2446726879e2f62172f')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Utrecht') {
  } else {
    A = 'CvL';
    B = 'CvL GV';
    C = 'Aanvraag besproken?';
    D = 'Evt. extra info';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
  } else {
    E = 'Organisatie die de scholing afneemt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Limburg') {
  } else {
    F = 'Team dat geschoold wordt';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt') {
  } else {
    G = 'Bestaand of nieuw';
    H = 'Naam scholing';
    I = 'Leerdoelen';
    J = 'Doelgroep scholing';
    K = 'Organisatie van de scholing';
    L = 'Locatie scholing';
    M = 'Verwacht aantal deelnemers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G && (getObjectProperty(item, 'title')) != H && (getObjectProperty(item, 'title')) != I && (getObjectProperty(item, 'title')) != J && (getObjectProperty(item, 'title')) != K && (getObjectProperty(item, 'title')) != L && (getObjectProperty(item, 'title')) != M);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/61dd0bccaa0aeec9fc1dfabce0dc7676/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3eae46f51f4143753db9f87af6a99ef4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((JSON.parse((getObjectProperty(___arguments.context.appData, 'plcvlkenmerk')))) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ac529001aa1ec4b5af440144996fe91b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/84359169d459dd7edcd8118e4edbbdcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/23e1c5223c82007889230b7891020864/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenverlenging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0ef16d2bbb71488616967b0e30f23704/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1) {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 1;
  } else {
    ___arguments.context.pageData['akkoordverzoekverlenging'] = 0;
  }

  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/27974f7c1949fdcb25d5b18f628c3642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e51103c1efb2d4b2b057adda717d025f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier =\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'\''].join('')), ({ 'akkoordverzoekverlenging': 0 }) );
  await Backendless.Data.of('historiepltoestemmingen').save( ({ 'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dossier': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),'aanpassingstatusdossier': 'VERLENGING BEHANDELD','aanpassingdatum': (new Date()),'aanpassingdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Request.post(`${Backendless.appPath}/services/toestemmingenpaging/toestemmingenpaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers','whereClause': (['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join('')),'sortBy': 'Dossier DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/346452324cb50227117a1d326d218377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/9d335661048628c6dc319984a8ab25ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'akkoordverzoekverlenging')) == 1 ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a58e23d6ee6a8f111a1f4bbcbd8d42c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['opmerkingprojectleider'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30d86d04965ea9b4dbf5d7bf449225b9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', true);
  ___arguments.context.pageData['akkoordemail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'akkoord'));
  ___arguments.context.pageData['dossier'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'activiteit'));
  ___arguments.context.pageData['pakketminutenakkoord'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'pakketminutenakkoord'));
  ___arguments.context.pageData['emailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'emailgv'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/bce1d43de65bcfaa38771d065a9a9693/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    if ((getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Scholing' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Werkgroep' || (getObjectProperty(___arguments.context.pageData, 'activiteit')) == 'Raad van Advies') {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
    } else {
      emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' consulten.'].join('');
    }
  } else {
    emailtext = ['Uw verlengingsverzoek van dossier ',(getObjectProperty(___arguments.context.pageData, 'dossier')),' met activiteit ',(getObjectProperty(___arguments.context.pageData, 'activiteit')),' is beoordeeld. Op uw dossier staan nu ',(getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),' minuten.'].join('');
  }
  ___arguments.context.pageData['emailtextverlenging'] = emailtext;

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/08cee2ff62abd78b98b95c37da18d89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var name2, emailreactie, cc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    cc = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'plemailakkoord')) == 'true') {
    emailreactie = 'Mocht u op deze mail willen reageren, gebruik dan reply all/ allen beantwoorden.';
  } else {
    emailreactie = 'Op deze mail kan niet gereageerd worden, voor meer informatie neem contact op met de projectleider.';
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'emailgv'));
  console.log(cc);
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Overijssel') {
    name2 = 'Overijssel/Flevoland';
  } else {
    name2 = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));
  }
  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('dossierakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailgv')), ccAddresses: cc, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`tekst`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')),[`pakketminutenakkoord`]: (getObjectProperty(___arguments.context.pageData, 'pakketminutenakkoord')),[`naamprojectleider`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailreactie`]: emailreactie,[`centraname`]: name2 }), undefined);
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`akkoordmail`]: 1 }) );
  await Backendless.Data.of('verlengingsaanvragen').save( ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`aanvraag`]: (getObjectProperty(___arguments.context.pageData, 'emailtextverlenging')),[`dossier`]: (getObjectProperty(___arguments.context.pageData, 'dossier')),[`opmerkingprojectleider`]: (getObjectProperty(___arguments.context.pageData, 'opmerkingprojectleiderverlenging')) }) );
  ___arguments.context.pageData['opmerkingprojectleider'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['pageoffset'] = 0;
  ___arguments.context.pageData['disablesave'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78ae5cf4fdee5da4ca4b4308444bc22c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53c9f87a4f13ba9eab442e9236c446c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b42605d2462eaddf349498ba7eb6cc7a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6e964abb716dad44771ca67249679a5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('195fdfabb05549a1cdee74cbfaf24ff7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7292149a1aa9ee328d29a86da3e4f22f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1812bea30989f9712c6422c84bb8a6d6', false);
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging=\'',1,'\''].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  ___arguments.context.pageData['emailvraag'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e565497a76adf3d984e9b4846562a45f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Voorgestelde activiteiten/ minuten per activiteit';
  } else {
    return2 = 'Voorgestelde minuten per activiteit';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/604514d3288232ecc1af2bcecd8a1908/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    return2 = 'Totaal voorgestelde activiteiten/ minuten voor dossier';
  } else {
    return2 = 'Totaal voorgestelde minuten voor dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3b8e0bf691d3cd6cc5688fd3d516eb1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7983e62e084b4e8ea3dc92728b714f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5d449f7736f41f29bd84ba3321b55c3b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty(___arguments.context.appData, 'centraname')),'\'',' AND akkoordverzoekverlenging <> \'',1,'\'',' AND activiteit LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\'',' AND naam LIKE \'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\'',' AND regio LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterregio')),'\' AND dossieraanmaker LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdossieraanmaker')),'\' AND akkoord',(getObjectProperty(___arguments.context.pageData, 'akkoord'))].join(''))).setSortBy('Dossier DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ac7678dad6cdfabd0fb9126ef8499012/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/5a86c2b9221cca5eb54c8b8605d6bad5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'Openstaand bedrag';
  } else {
    text = 'Bedrag openstaande werkminuten';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d85606ccfb959cec3eee6841309fa496/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('dossiers').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/27a7061c7f7c6386feb8c5e86c67b2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d85606ccfb959cec3eee6841309fa496')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d85606ccfb959cec3eee6841309fa496', true);
    Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-notitie geopend-','dossier:',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier'))].join('')));
    await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'notitie geopend',[`dossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'dossier')),[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'regio')),[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')))).length == 2) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'opmerkingenprojectleider')) == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#545C5C';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('27a7061c7f7c6386feb8c5e86c67b2ab'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/30d86d04965ea9b4dbf5d7bf449225b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('pltoestemmingenaantekeningen', undefined);
  Backendless.Logging.getLogger('ISO').info((['Projectleider-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-pagina alle notities bekeken'].join('')));
  await Backendless.Data.of('historielogprojectleider').save( ({ [`pagina`]: 'pltoestemmingen',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'pagina alle notities bekeken',[`dossier`]: undefined,[`registratienummer`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`regiodossier`]: undefined,[`regiogv`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),[`regiogvpl`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogvpl')),[`GV`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'GV')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7ed79134dee951114b23d61dcc3c4f27/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Request.post(`${Backendless.appPath}/services/findObjectsWithPaging/findObjectsWithPaging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gemeentewoonplaats','whereClause': (['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join('')) })).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var regio, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regio = (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND gemeentewoonplaats=\'',(getObjectProperty(___arguments.context.pageData, 'gemwoon')),'\''].join(''))).setProperties('regio').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')) });})))[0];
  ___arguments.context.pageData['regio'] = (getObjectProperty(regio, 'value'));
  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemwoon')),'regio': (getObjectProperty(___arguments.context.pageData, 'regio')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gemeente is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
  ___arguments.context.pageData['gemwoon'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d1c984094f95e9e620c681b31e16b129/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e6843d2b0325abc67873359d806c678')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e6843d2b0325abc67873359d806c678', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/17d54ceb9ff56ade3dca42b270aeee47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d6a1354ceace3cf3f686f5c8cb75c89')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/5881104a24e257c8c0675754cd6a3514/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) < 1900) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'jaar')) >= 2016) {
    (function (message) { alert(message) })('Ingevoerde geboortejaar klopt niet.');
    ___arguments.context.pageData['jaar'] = null;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6c54fa2d064b22d4ab4167e4624b81af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'geboortedatumdag': (getObjectProperty(___arguments.context.pageData, 'geboortedatumdag')),'geboortedatummaand': (getObjectProperty(___arguments.context.pageData, 'geboortedatummaand')),'geboortedatumjaar': (getObjectProperty(___arguments.context.pageData, 'geboortedatumjaar')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  ___arguments.context.pageData['geboortedatumdag'] = null;
  ___arguments.context.pageData['geboortedatummaand'] = null;
  ___arguments.context.pageData['geboortedatumjaar'] = null;
  (function (message) { alert(message) })('Geboortedatum is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d6a1354ceace3cf3f686f5c8cb75c89', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/03683411dd557e29ae1e45c685f2d031/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c93628d0a42596bf60a182984079fe4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c93628d0a42596bf60a182984079fe4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/01a6a261fbd7021643d6f539a8d5f567/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5587bd1a0cde7f14ecf7b1e5dcc6e301')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/69e22bbde63a8931761be26eb44f712f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'consultinwgender': (getObjectProperty(___arguments.context.pageData, 'gender')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Gender is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5587bd1a0cde7f14ecf7b1e5dcc6e301', false);
  ___arguments.context.pageData['gender'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f202e9f2502e675ea47e645a13eac437/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('doelgroepquestio').find(Backendless.DataQueryBuilder.create().setProperties('doelgroep').setSortBy('nr ASC').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'doelgroep')),'label': (getObjectProperty(item, 'doelgroep')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'doelgroep': (getObjectProperty(___arguments.context.pageData, 'doelgroep')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Doelgroep is aangepast');
  ___arguments.context.pageData['doelgroep'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c219ab61f96f7b9ce0fab1abf9cf1ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('573695c51d1447d96f97e8bdf75d6527')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('573695c51d1447d96f97e8bdf75d6527', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/9cc59ee788574dede34dc9723e2679df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4f9af13a07d5245cdea7da571657705')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f2f976f8b14b6cd120d628690d45a3d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'hulpvraag': (getObjectProperty(___arguments.context.dataModel, 'hulpvraag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Hulpvraag is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c4f9af13a07d5245cdea7da571657705', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c4f9af13a07d5245cdea7da571657705/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4f9af13a07d5245cdea7da571657705', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('hulpvraag').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/14fd0741e66dfd39ab56d4d2fbaa4e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e4bec6b7206b2ff1b0577896bf985ca')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/305cb8f2e0c670ca21b412caf64aa542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'verwijzer': (getObjectProperty(___arguments.context.pageData, 'verwijzer')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Verwijzer is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e4bec6b7206b2ff1b0577896bf985ca', false);
  ___arguments.context.pageData['verwijzer'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzers').find(Backendless.DataQueryBuilder.create().setWhereClause((String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) + String('=\'1\''))).setProperties('verwijzer').setSortBy('nr ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/2a4f8f4f6666a285e5facfdfa6b4b31f/bundle.js', [], () => ({
  /* content */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var F, item, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a4f8f4f6666a285e5facfdfa6b4b31f')), 'columns')), async (item) => {
   if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1' && (JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminuten')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdkm')))) == '1') {
    A = 'Reistijd minuten';
    B = 'Reistijd in minuten';
  } else if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'setreistijdminutenspeciaal')))) == '1') {
    A = 'Aantal kilometers';
    B = 'Reistijd minuten';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    A = 'Reistijd in minuten';
    B = 'Reistijd minuten';
    C = 'Aantal kilometers';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F);
}))

  },
  /* handler:onColumnsAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/e3a50f7e5bd4485aad127b9c737467f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bc613a630b217e93e626880a470508e7')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/ebc92f328bfdb8fb9aa2f085026c2266/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questioscholingbedrag': (getObjectProperty(___arguments.context.pageData, 'questioscholingbedrag')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De eigen bijdrage is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc613a630b217e93e626880a470508e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a9c2f5452dfbe2b86e1f4733e8814297/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossierskalender', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/aacd343f68c4bb05dd63282a3be96317/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5d1a6122cb0e48cd84f19df551bd7d3d')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/57bf086975d2bbd27452000ba0ca0d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'questiogroepsconsultprogrammabijeenkomst': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d1a6122cb0e48cd84f19df551bd7d3d'), 'questiogroepsconsultprogrammabijeenkomst')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Programma is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d1a6122cb0e48cd84f19df551bd7d3d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/0f516cdc7a87a6ea4bf70da987e3dfbd/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0f516cdc7a87a6ea4bf70da987e3dfbd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questiogroepsconsultprogrammabijeenkomst').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/9da46e0784b6c92e46fa5f31c65d6f52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6bbe190c3259a97366ce030fefddbe01')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d53211de5906121a606260195aad8ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79abb5a3590c2b9ff8ce5939cc430832')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33a6cea49fff954dca096566d2b90c63', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/6255fd828bcfa9d403ef015d4008f8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatie': (getObjectProperty(___arguments.context.pageData, 'wlzindicatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz is aangepast');
  ___arguments.context.pageData['wlzindicatie'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6bbe190c3259a97366ce030fefddbe01', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/928520092141ae4e2c8634bba421e66a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'wlzindicatiesoort': (getObjectProperty(___arguments.context.pageData, 'wlzindicatiesoort')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Wlz indicatie is aangepast');
  ___arguments.context.pageData['wlzindicatiesoort'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79abb5a3590c2b9ff8ce5939cc430832', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d1ff33dff6da76fdc4e107e65544c786/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cbf77d19f4fa2292df687b656f521de')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d06bb12b3dc6fcf25c18762379a7e1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d99043cb0e2beb14692b289ca3f3a56')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f3e33b580a8a6528ea34f2d393596f23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurcontactpersoon': (getObjectProperty(___arguments.context.pageData, 'factuurcontactpersoon')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('De contactpersoon voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cbf77d19f4fa2292df687b656f521de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d06bb12b3dc6fcf25c18762379a7e1d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/458800d42e473d4a95c7bc165d45fe0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ 'factuurmailadres': (getObjectProperty(___arguments.context.pageData, 'factuurmailadres')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Het emailadres voor de factuur is aangepast');
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d99043cb0e2beb14692b289ca3f3a56', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1ff33dff6da76fdc4e107e65544c786', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3a50f7e5bd4485aad127b9c737467f2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/341f4ca6cebbded4944b69746ecc11ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/503b31d353cfd70f674baddc726ca10d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/f77f4042ef5bc25c5ea8cf7d4ea64945/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.parse((getObjectProperty(___arguments.context.appData, 'activiteiten')))) == true) {
    return2 = 'Resterende activiteiten/ minuten op dossier';
  } else {
    return2 = 'Resterende minuten op dossier';
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/98e4a0146d34b776c2aeffeb29ea81fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/32e73059454f19165d0147ca564a76ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Questio' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Rotterdam' ? true : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Sichtpunt' ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/23af9c9cb2082e68985b3473224b510a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function round() {
  value = value * 100;
  value = Math.round(value);
  value = value / 100;
}


  value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb6dc28ce7a83449c2d7c56c1f9a6454'), 'resterend'));
  await round();

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/d0949bf9f98b6f35b12427fc37a6f8bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/fefbe76de87b4fa35153a6e37dd7f8e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('chartverlengingbrabant', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/3dec7a07010c45a3396dea41a0bbdb12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/1e191665dc4e26d95b2e1b74c861967e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/88e23952ed55134c3a77d72960e3122f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/82186e3b732d07b322bc5dd6e6d7ffcd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Haaglanden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/33a6cea49fff954dca096566d2b90c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8553db664a7b49b4869ab7f3c06ff17f')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/4503288cc2c85e84af1ae5357c5b1b78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join('')), ({ [`questioconsultinwachtergrondinformatie`]: (getObjectProperty(___arguments.context.dataModel, 'questioconsultinwachtergrondinformatie')) }) );
  ___arguments.context.pageData['filtertabel'] = null;
  ___arguments.context.pageData['filtertabel'] = (['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''));
  (function (message) { alert(message) })('Achtergrondinformatie is aangepast');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8553db664a7b49b4869ab7f3c06ff17f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9cc59ee788574dede34dc9723e2679df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d1c984094f95e9e620c681b31e16b129', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c219ab61f96f7b9ce0fab1abf9cf1ec6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17d54ceb9ff56ade3dca42b270aeee47', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01a6a261fbd7021643d6f539a8d5f567', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14fd0741e66dfd39ab56d4d2fbaa4e03', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9da46e0784b6c92e46fa5f31c65d6f52', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d53211de5906121a606260195aad8ec2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/8553db664a7b49b4869ab7f3c06ff17f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8553db664a7b49b4869ab7f3c06ff17f', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(getObjectProperty(___arguments.context.pageData, 'dossier')),'\''].join(''))).setProperties('questioconsultinwachtergrondinformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/a7bbca3209812702649e08f59bdf152b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a7bbca3209812702649e08f59bdf152b', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))).setProperties('naam').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b25db17d25541ed4ad434ee940f48692/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('dossierdelen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'filtertabel'))))) == 0) {
    result = false;
  } else {
    result = true;
  }

  return result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/b6e964abb716dad44771ca67249679a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'ZHN' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/7f98d6bd268de8850d18878aa702e1bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = '(incl. openstaand bedrag)';
  } else {
    text = '(incl. openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/xbackuppltoestemmingen20250508/components/c6ac4a32b1cfbbaa721786b9818d2863/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Brabant') {
    text = 'budget 2025 min totaal besteed bedrag';
  } else {
    text = '(zonder openstaande werkminuten)';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

